layout = {};
o2.xApplication = o2.xApplication || {};
o2.widget = o2.widget || {};
o2.widget.css = o2.widget.css || {};
o2.xDesktop = o2.xDesktop || {};
o2.xDesktop.$all=true;
o2.xDesktop.Common=true;

var csskey = encodeURIComponent("../x_component_process_Work/$Main/default/css.wcss");
o2.widget.css[csskey]={
  "content":{
    "width": "100%",
    "height": "100%",
    "overflow": "auto",
    "background-color": "#FFF"
    //"position": "relative"
  },
  "formNode": {
    "min-height": "100%",
    "font-size": "14px",
    "overflow": "auto",
    "background-color": "#FFF",
    "height": "100%",
  },
  "maskNode": {
    "background-color": "#666",
    "opacity": 0.4,
    "z-index":100
  },

  "flowNode_Area": {
    "background-color": "#FFF",
    "overflow": "hidden",
    "height": "100%"
  },
  "flowNode_mobile": {
    "width": "100%",
    "height": "100%",
    "min-height": "280px",
    "opacity": 1,
    "top":"0px",
    "left": "0px",
    "overflow": "auto",
    "background": "#F5F5F5",
    "position": "absolute",
    "z-index":300
  },

  "processNode_from": {
    "width": "480px",
    "min-height": "280px",
    "height": "auto",
    "z-index":300,
    "background-color": "#FFF",
    "overflow": "hidden",
    "border": "3px solid #666",
    "border-radius": "10px",
    "box-shadow": "0px 0px 15px #666",
    "opacity": 1,
    "position": "absolute"
  },
  "processNode_Area": {
    "height": "300px",
    "width": "700px",
    "padding": "10px",
    "background-color": "#FFF",
    "overflow": "hidden"
  },
  "processNodeMobile_from": {
    "width": "480px",
    "min-height": "280px",
    "height": "auto",
    "z-index":3000,
    "background-color": "#eeeeee",
    "overflow": "hidden",
    "border": "0px",
    "border-radius": "0px",
    "box-shadow": "0px",
    "opacity": 1,
    "position": "absolute"
  },

  "processNode": {
    "width": "480px",
    "min-height": "280px",
    "height": "auto",
    "opacity": 1,
    "overflow": "hidden"
  },
  "processNodeMobile": {
    "width": "480px",
    "min-height": "280px",
    "height": "auto",
    "opacity": 1,
    "top":"0px",
    "left": "0px",
    "overflow": "hidden"
  },

  "routeSelectorTile": {
    "overflow": "hidden",
    "height": "24px",
    "line-height": "24px"
  },
  "routeSelectorArea": {
    "overflow": "hidden"
  },

  "mobileActionBarNode": {
    "font-size": "16px",
    "color": "#008BE6",
    "text-align": "center",
    "line-height": "40px",
    "height": "40px",
    "width": "100%",
    "position": "absolute",
    "background-color": "#ffffff",
    "bottom": "0px"
  },
  "mobileSaveActionNode": {
    "height": "40px"
  },
  "workListArea": {
    "width": "90%",
    "min-width": "300px",
    "max-width": "600px",
    "margin": "60px auto 0px auto",
    "overflow": "hidden"
  },
  "workListAreaTitle": {
    "height": "60px",
    "padding": "0px 10px",
    "color": "#666666",
    "font-size": "20px",
    "overflow": "hidden"
  },
  "workListContent": {
    "margin": "10px auto 0px auto",
    "overflow": "hidden"
  },
  "workItemNode": {
    "padding": "3px 10px",
    "height": "60px",
    "border-radius": "30px",
    "border": "2px solid #cccccc",
    "margin-bottom": "20px",
    "background-color": "#ffffff",
    "cursor": "pointer",
  },
  "workItemNode_over": {
    "border": "2px solid #4A90E2"
  },
  "workItemTitleNode": {
    "height": "27px",
    "line-height": "27px",
    "padding": "0px 10px",
    "color": "#333333"
  },
  "workItemInforNode": {
    "height": "27px",
    "line-height": "27px",
    "padding": "0px 10px",
    "color": "#999999",
    "font-size": "12px"
  },
  "workItemInforTitleNode": {
    "color": "#333333",
    "font-weight": "bold",
    "float": "left",
    "margin-right": "5px"
  },
  "workItemInforContentNode": {
    "float": "left",
    "margin-right": "10px"
  },
  "formNode_bg": {
    "background-color": "#f3f3f3"
  },
  "identitySelectArea": {
    "position": "absolute",
    "top": 0,
    "visibility": "visible",
    "width": "100%",
    "height": "100%",
    "background-color": "#eeeeee",
    "z-index": 10000
  },
  "identitySelectNode": {
    "background-color": "#ffffff",
    "box-shadow": "#999999 0px 0px 18px",
    "margin": "auto",
    "border-radius": "8px",
    "border": "0px solid #666666",
    "overflow": "auto",
    "height": "601.533px",
    "width": "700px"
  },
  "identitySelectNodeTitle": {
    "height": "50px",
    "line-height": "50px",
    "padding": "0 30px",
    "text-align": "left",
    "font-size": "16px",
    "color": "#333333"
  },
  "identitySelectNodeInfo": {
    "margin": "20px 0",
    "height": "40px",
    "line-height": "40px",
    "padding": "0 30px",
    "text-align": "left",
    "font-size": "14px",
    "color": "#666666"
  },
  "identitySelectNodeList": {
    "padding": "10px 30px"
  },
  "identitySelectNodeItem": {
    "width": "240px",
    "border": "1px solid rgb(230, 230, 230)",
    "border-radius": "8px",
    "background": "url(../x_component_process_TaskCenter/$ProcessStarter/default/id_bg.png) 0% 0% / cover no-repeat",
    "float": "left",
    "cursor": "pointer",
    "font-size": "12px",
    "padding": "20px 20px 10px",
    "margin": "10px 10px 20px 20px",
    "box-shadow": "rgb(230 230 230) 0px 0px 4px",
    "position": "relative"
  }

}

var csskey = encodeURIComponent("../x_component_portal_Portal/$Main/default/css.wcss");
o2.widget.css[csskey]={
    "content":{
        "width": "100%",
        "height": "100%",
        "overflow": "auto",
        "background-color": "#FFF"
    },
    "maskNode": {
        "background-color": "#666",
        "opacity": 0.4,
        "z-index":100
    },
    "processNode_from": {
        "width": "480px",
        "min-height": "280px",
        "height": "auto",
        "z-index":300,
        "background-color": "#FFF",
        "overflow": "hidden",
        "border": "3px solid #666",
        "border-radius": "10px",
        "box-shadow": "0px 0px 15px #666",
        "opacity": 0.2,
        "position": "absolute"
    },
    "processNode": {
        "width": "480px",
        "min-height": "280px",
        "height": "auto",
        "opacity": 1,
        "overflow": "hidden"
    },
    "routeSelectorTile": {
        "overflow": "hidden",
        "height": "24px",
        "line-height": "24px"
    },
    "routeSelectorArea": {
        "overflow": "hidden"
    }
}
var csskey = encodeURIComponent("../x_component_process_Xform/$Form/default/css.wcss");
o2.widget.css[csskey]={
	"container": {
		"padding": "3px",
		"overflow": "hidden",
		"-webkit-user-select": "text",
        "-moz-user-select": "text"
	},
	"textfieldNode": {
		"display": "inline-block"
	},
	"personfieldIcon": {
		"background": "url(../x_component_process_Xform/$Form/default/icon/selectperson.png) center center no-repeat",
		"width": "18px",
		"height": "18px",
		"float": "right",
		"cursor": "pointer" 
	},
	"orgfieldIcon": {
        "background": "url(../x_component_process_Xform/$Form/default/icon/selectorg.png) center center no-repeat",
        "width": "18px",
        "height": "18px",
        "float": "right"
    },
    "orgIcon": {
        "background": "url(../x_component_process_Xform/$Form/default/icon/selectperson.png) center center no-repeat",
        "width": "18px",
        "height": "18px",
        "float": "right"
    },
	"textFieldIcon": {
	    "background": "url(../x_component_process_Xform/$Form/default/icon/inputtext.png) center center no-repeat",
        "width": "18px",
        "height": "18px",
        "float": "right"
	},
	"numberIcon": {
	    "background": "url(../x_component_process_Xform/$Form/default/icon/number.png) center center no-repeat",
        "width": "18px",
        "height": "18px",
        "float": "right"
	},
    "currencyIcon": {
      "background": "url(../x_component_process_Xform/$Form/default/icon/currency.png) center center no-repeat",
      "width": "18px",
      "height": "18px",
      "float": "right"
    },
	"calendarIcon": {
		"background": "url(../x_component_process_Xform/$Form/default/icon/calendar.png) center center no-repeat",
		"width": "18px",
		"height": "18px",
		"float": "right",
		"cursor": "pointer" 
	},
	"selectIcon": {
		"background": "url(../x_component_process_Xform/$Form/default/icon/pull.png) center center no-repeat",
		"width": "18px",
		"height": "18px",
		"float": "right",
		"cursor": "pointer"
	},
    "descriptionNode": {
        "color": "#bbb",
        "cursor": "text",
        "position": "absolute",
        "top": "0px"
    },

	"buttonStyles": {
        "color" : "#777",
		"border-radius": "5px",
		"border-top": "1px solid #ccc",
		"border-left": "1px solid #ccc",
		"border-right": "1px solid #ccc",
		"border-bottom": "1px solid #ccc",
		"overflow": "hidden",
		"cursor": "pointer",
		"-webkit-user-select": "none",
		"-moz-user-select": "none",
		"position": "static",
		"top": "auto",
		"left": "auto",
		"opacity": 1,
		"height": "26px"
	},
	"datagridTitle": {
		"height": "28px",
		"cursor": "pointer",
		"line-height": "28px",
		"overflow": "hidden",
		"opacity": 1,
		"background": "#C3CEEA"
	},
	"gridLineActionCell": {
		"width": "40px"
	},
	"gridMoveActionCell": {
		"width": "5px"
	},
	"addLineAction": {
		"width": "20px",
		"height": "20px",
		"background": "url(../x_component_process_Xform/$Form/default/icon/addline.png) center center no-repeat",
		"cursor": "pointer",
		"float": "left"
	},
	"delLineAction": {
		"width": "20px",
		"height": "20px",
		"background": "url(../x_component_process_Xform/$Form/default/icon/delline.png) center center no-repeat",
		"cursor": "pointer",
		"float": "left"
	},
	"completeLineAction": {
		"width": "20px",
		"height": "20px",
		"background": "url(../x_component_process_Xform/$Form/default/icon/check.png) center center no-repeat",
		"cursor": "pointer",
		"float": "left"
	},
	"moveLineAction": {
		"width": "5px",
		"height": "20px",
		"background": "url(../x_component_process_Xform/$Form/default/icon/move.png) center center no-repeat",
		"cursor": "move",
		"float": "left"
	},
    "datatableMoveLineAction": {
      "width": "5px",
      "color": "#aaa",
      "cursor": "pointer",
      "float": "left"
    },
	"gridMoveLineDragNode": {
		"opacity": 0.7,
		"z-index": 30000,
		"background-color": "#CCC",
		position: 'absolute'
	},
	"gridMoveLineDragNodeTr": {
		//"background-color": "#f3f1ad"
		"background-color": "#e4f6e9"
	},
	"logActivityNode": {
	    "overflow": "hidden",
	    "margin": "0px",
	    "border": "1px solid #CCC",
	    "background-color": "#FFF"
	},
	"logActivityNode_record": {
	    "overflow": "hidden",
	    "margin": "0px",
	    "padding": "10px 0",
	    "border": "1px solid #CCC",
	    "background-color": "#FFF"
	},
	"logActivityNode_even": {
	    "overflow": "hidden",
        //"margin": "10px",
        "border": "1px solid #CCC",
        "background-color": "#FFF"
	},
	"logActivityTitleNode": {
	    "height": "40px",
	    "line-height": "40px",
        //"background-color": "#edf3f9",
        "background-color": "#f0f0f0",
	    "border-bottom": "1px solid #CCC",
	    "font-size": "12px",
	    "overflow": "hidden"
	},
	"logActivityTitleNode_even": {
        "height": "40px",
        "line-height": "40px",
        //"background-color": "#edf3f9",
        "background-color": "#f0f0f0",
        "border-bottom": "1px solid #CCC",
        "font-size": "12px",
        "overflow": "hidden"
	},
	"logActivityChildNode": {
	    "clear": "both",
	    "overflow": "hidden"
	},
	"logActivityChildRecordNode": {
	    "clear": "both",
    	"overflow": "hidden",
    	"background-color": "#ffffff",
    	"min-height": "30px",
    	"line-height": "30px"
	},
	"logActivityChildRecordNode_even": {
        "clear": "both",
        "overflow": "hidden",
        "background-color": "#f6f6f6",
    	"min-height": "30px",
    	"line-height": "40px"
    },
	"logActivityIconNode": {
	    "height": "40px",
	    "width": "30px",
	    "background-position": "center center",
	    "background-repeat": "no-repeat",
	    "float": "left"
	},
	"logActivityFromNode": {
        "height": "40px",
        "line-height": "40px",
        "float": "left",
        "font-size": "14px"
	},
	"logActivityArrowNode": {
        "height": "40px",
        "width": "30px",
        "background-position": "center center",
        "background-repeat": "no-repeat",
        "float": "left"
	},
	"logActivityArrivedNode": {
	    "height": "40px",
	    "line-height": "40px",
        "float": "left",
        "font-size": "14px"
	},
	"logActivityReadActionNode": {
	    "height": "40px",
        "line-height": "40px",
        "float": "left",
        "color": "#0000FF",
        "margin-left": "20px",
        "cursor": "pointer",
        "font-size": "12px"
	},
	"logActivityTimeNode": {
	    "height": "40px",
    	"line-height": "20px",
    	"margin-right": "5px",
        "float": "right"

	},
	"logTaskNode": {
	    "clear": "both",
	    "overflow": "hidden",
        "line-height": "28px",
        //"border-bottom": "1px solid #CCC",
        "font-size": "12px",
        "background": "transparent"
	},
	"logTaskNode_even": {
        "overflow": "hidden",
        "line-height": "28px",
        //"border-bottom": "1px solid #CCC",
        "font-size": "12px",
        "background": "#f6f6f6"
    },
	"logTaskIconNode": {
        "height": "28px",
        "width": "28px",
        "margin-left": "20px",
        "background-position": "center center",
        "background-repeat": "no-repeat",
        "float": "left"
    },
    "logTaskIconNode_record": {
        "height": "28px",
        "width": "28px",
        "background-position": "center center",
        "background-repeat": "no-repeat",
        "float": "left"
    },
    "logTaskTextNode": {
        "margin-right": "10px",
        "overflow": "hidden"
        //"float": "left",
        //"margin-left": "28px"
    },
    "logTaskFloatTextNode": {
        "margin-right": "10px",
        "overflow": "hidden"
//        "float": "left",
        //"margin-left": "28px"
    },
    "logReadTextNode": {
        "margin": "5px 48px 5px 48px",
        "overflow": "hidden",
        "line-height": "18px",
        "font-size": "12px"
    },
    "logMediaIcon": {
        "width": "20px",
        "height": "28px",
        "background-position": "center center",
        "margin-left": "10px",
        "background-repeat": "no-repeat",
        "float": "left",
        "cursor": "pointer"
    },
    "logMediaOpinionContent": {
        //"position": "absolute",
        "background": "#ffffff",
        "border": "1px solid #cccccc",
        //"border-radius": "6px",
        "float": "left",
        "overflow": "hidden"
    },
    "logMediaOpinionContentClose": {
        "height": "20px",
        "width": "20px",
        "float": "right",
        "background": "url(../x_component_process_Xform/$Form/default/icon/close.png) center center no-repeat",
        "cursor": "pointer"
    },
    "logMediaOpinionContentArea": {
        "overflow": "hidden"
    },

    "logTable": {
        "border-left": "1px solid #CCC",
        "border-top": "1px solid #CCC"
    },
    "logTableTr": {
        "background-color": "#edf3f9"
    },
    "logTableIconTd": {
        "width": "20px",
        "background-position": "center center",
        "background-repeat": "no-repeat",
        "border-right": "0px solid #CCC",
        "border-bottom": "1px solid #CCC"
    },
    "logTableActivityTd": {
        "border-right": "1px solid #CCC",
        "border-bottom": "1px solid #CCC"
    },
    "logTableTaskTd": {
        "border-right": "1px solid #CCC",
        "border-bottom": "1px solid #CCC",
        "background-color": "#FFF"
    },

    "logTableActivityNode": {
        "line-height": "28px",
        "font-size": "14px",
        "text-align": "center"
    },
    "logTableActivityTimeNode": {
        "line-height": "20px",
        "text-align": "center"
    },
    "logTableTask": {
        "border-left": "1px solid #CCC",
        "border-top": "1px solid #CCC",
        "font-size": "12px"
    },
    "logTableTaskTitleLine": {
        "text-align": "center",
        "font-weight": "bold",
        "background-color": "#edf3f9"
    },
    "logTableTaskTitle": {
        "line-height": "28px",
        "border-right": "1px solid #CCC",
        "border-bottom": "1px solid #CCC"
    },
    "logTableTaskLine": {
        "line-height": "28px",
        "border-right": "1px solid #CCC",
        "border-bottom": "1px solid #CCC",
        "background": "#ffffff"
    },
    "logTableTaskLine_even": {
        "line-height": "28px",
        "border-right": "1px solid #CCC",
        "border-bottom": "1px solid #CCC",
        "background": "#f6f6f6"
    },
    "logTableTaskLine_task": {
        "line-height": "28px",
        "border-right": "1px solid #CCC",
        "border-bottom": "1px solid #CCC",
        "color": "red"
    },

    "relatedlinkTable": {
      "border-top": "1px solid #CCC",
      "font-size": "12px"
    },
    "relatedlinkTableTitleLine": {
      "text-align": "center",
      "font-weight": "bold",
      "background-color": "#edf3f9"
    },
    "relatedlinkTableTitle": {
      "line-height": "28px",
      "border-bottom": "1px solid #CCC"
    },
    "relatedlinkTableCell": {
      "line-height": "28px",
      "border-bottom": "1px solid #CCC"
    },
    "relatedlinkTableCell_title": {
      "font-size": "14px"
    },
  "relatedlinkTableLine": {
    "background": "#ffffff"
  },
    "relatedlinkTableLine_over": {
      "background": "#f6f6f6"
    },
    "relatedlinkNode": {
      "clear": "both",
      "overflow": "hidden",
      "line-height": "24px",
      "padding": "5px 10px",
      //"border-bottom": "1px solid #CCC",
      "font-size": "14px",
      "background": "transparent"
    },
    "relatedlinkNode_even": {
      "overflow": "hidden",
      "line-height": "24px",
      "padding": "5px 10px",
      //"border-bottom": "1px solid #CCC",
      "font-size": "14px",
      "background": "transparent" //,"#f6f6f6"
    },
    "relatedlinkTextNode": {
      "margin-right": "10px",
      "overflow": "hidden"
      //"float": "left",
      //"margin-left": "28px"
    },

    "datagridTotalTr": {
        "height": "20px",
        "cursor": "pointer",
        "line-height": "20px",
        "overflow": "hidden",
        "background": "#e1e6f3"
    },
    "datagridTotalTr_section": {
      "height": "20px",
      "cursor": "pointer",
      "line-height": "20px",
      "overflow": "hidden",
      "background": "#fafafa"
    },
    "datagridTotalTd": {
        "font-weight": "bold"
    },

    "mobileDatagridTable": {

    },
    "gridTotalNode": {
        "overflow": "hidden",
        "margin-bottom": "10px"
    },
    "gridTotalTitleNode": {
        "height": "30px",
        "text-align": "center",
        "line-height": "30px",
        "font-size": "14px",
        "font-weight": "bold",
        "background-color": "#C3CEEA",
        "border-top": "1px solid #999",
        "border-left": "1px solid #999",
        "border-right": "1px solid #999"
    },
    "gridMobileTableNode" : {
        "overflow": "hidden"
    },
    "gridTotalTableNode": {
        "overflow": "hidden"
    },
    "gridMobileDeleteActionAreaNode": {
        "color": "#FFF",
        "text-align": "center",
        "float": "right"
    },
    "gridMobileDeleteActionNode": {
        "background": "#cd0a0a",
        "color": "#FFF",
        "text-align": "center",
        "height": "100%",
        //"line-height": "100%",
        "width": "100%",
        //"margin": "0px auto",
        "float": "right"
    },
    "gridMobileActionNode": {
        "margin-bottom": "10px",
        "height": "30px",
        "line-height": "30px",
        "border": "1px solid #CCCCCC",
        "border-radius": "5px",
        "text-align": "center"
    },
    "gridImpExpAreaNode" : {
      "display" : "block"
    },
  "gridImportActionStyles" : {
    "color" : "#777",
    "border-radius": "5px",
    "border": "1px solid #ccc",
    "cursor": "pointer",
    "height": "26px",
    "float" : "left",
    "line-height": "26px",
    "padding": "0px 5px",
    "background-color": "#efefef",
    "margin" : "5px"
  },
  "gridExportActionStyles" : {
    "color" : "#777",
    "border-radius": "5px",
    "border": "1px solid #ccc",
    "cursor": "pointer",
    "height": "26px",
    "float" : "left",
    "line-height": "26px",
    "padding": "0px 5px",
    "background-color": "#efefef",
    "margin" : "5px"
  },
    "mobileGridHelpNode": {
        "width": "30px",
        "height": "30px",
        "background": "url(../x_component_process_Xform/$Form/default/icon/help.png) center center no-repeat",
        "cursor": "pointer"
    },
    "mobileDatagridActionNode": {
//        "width": "235px",
        "text-align": "right",
        "float": "right",
        "overflow": "hidden"
    },
    "mobileDatagridDelActionNode": {
        "width": "34px",
        "margin-left": "10px",
        "height": "28px",
        "line-height": "28px",
        "color": "#666",
        "font-size": "16px",
        "padding-left": "26px",
        "padding-right": "5px",
        "border": "1px solid #CCCCCC",
        "border-radius": "3px",
        "background": "url(../x_component_process_Xform/$Form/default/icon/del.png) 5px center no-repeat",
        "float": "right",
        "cursor": "pointer"
    },
    "mobileDatagridEditActionNode": {
        "width": "34px",
        "margin-left": "10px",
        "height": "28px",
        "line-height": "28px",
        "color": "#666",
        "font-size": "16px",
        "padding-left": "26px",
        "padding-right": "5px",
        "border": "1px solid #CCCCCC",
        "border-radius": "3px",
        "background": "url(../x_component_process_Xform/$Form/default/icon/edit.png) 5px center no-repeat",
        "float": "right",
        "cursor": "pointer"
    },
    "mobileDatagridAddActionNode": {
        "width": "34px",
        "margin-left": "10px",
        "height": "28px",
        "line-height": "28px",
        "color": "#666",
        "font-size": "16px",
        "padding-left": "26px",
        "padding-right": "5px",
        "border": "1px solid #CCCCCC",
        "border-radius": "3px",
        "background": "url(../x_component_process_Xform/$Form/default/icon/add.png) 5px center no-repeat",
        "float": "right",
        "cursor": "pointer"
    },
    "mobileDatagridCancelActionNode": {
      "width": "34px",
      "margin-left": "10px",
      "height": "28px",
      "line-height": "28px",
      "color": "#666",
      "font-size": "16px",
      "padding-left": "26px",
      "padding-right": "5px",
      "border": "1px solid #CCCCCC",
      "border-radius": "3px",
      "background": "url(../x_component_process_Xform/$Form/default/icon/del.png) 5px center no-repeat",
      "float": "right",
      "cursor": "pointer",
      "display": "none"
    },
    "mobileDatagridCompleteActionNode": {
        "width": "34px",
        "margin-left": "10px",
        "height": "28px",
        "line-height": "28px",
        "color": "#666",
        "font-size": "16px",
        "padding-left": "26px",
        "padding-right": "5px",
        "border": "1px solid #CCCCCC",
        "border-radius": "3px",
        "background": "url(../x_component_process_Xform/$Form/default/icon/completed.png) 5px center no-repeat",
        "float": "right",
        "cursor": "pointer",
        "display": "none"
    },
    "mobileGridHelpContentNode": {
        "font-size": "14px",
        "color": "#999"
    },
    "officeSpacerNode": {
        "width": "100%",
        "position": "absolute",
        "display": "none",
        "opacity": "0"
    },
    "officeAreaNode": {
        "width": "100%",
        "z-index": "100"
    },
    "officeMenuNode": {
        "height": "30px",
        //"border-top": "1px solid #CCCCCC",
        //"background-color": "#F3F3F3",
        "background-color": "#2a579a"
    },
    "officeMenuItemNode": {
        "height": "22px",
        "margin-top": "3px",
        "margin-left": "5px",
        //"background-color": "#FFFFFF",
        "background": "transparent",
        "border": "0px solid #DDDDDD",
        //"border-radius": "3px",
        "color": "#ffffff",
        "cursor": "pointer",
        "padding": "0px 5px",
        "line-height": "30px",
        "font-size": "14px",
        "float": "left"
    },
    "sidebar": {
        "border": "1px solid #999999",
        "border-radius": "8px",
        "overflow": "hidden"
    },
    "opinionSelectNode": {
        "position": "absolute",
        "border": "1px solid #cccccc",
        "border-radius": "5px",
        //"box-shadow": "3px 3px 5px #999",
        "min-width": "120px",
        "max-height": "300px",
        "padding": "5px 0px",
        "background-color": "#ffffff",
        "overflow": "auto"
    },
    "opinionSelectOption": {
        "padding": "3px 10px",
        "cursor": "pointer"
    },
    "inputOpinionMediaActionArea": {
        "position": "relative",
        "height": "25px",
        "line-height": "25px",
        "top": "-34px",
        "float": "right",
        "width": "160px",
        "margin-right": "5px"
    },

    "inputOpinionHandwritingAction": {
        "float": "right",
        "border": "1px solid #6681a5",
        "border-radius": "3px",
        "cursor": "pointer",
        "padding-left": "24px",
        "padding-right": "5px",
        "margin-left": "5px",
        "cursor": "pointer",
        "background": "url(../x_component_process_Work/$Processor/default/write.png) no-repeat 5px center"
    },
    "handwritingNode": {
        "position": "absolute",
        "background": "#ffffff",
        "border": "2px solid #999",
        "border-radius": "8px",
        "box-shadow": "0px 0px 10px #666",
    },
    "handwritingActionNode": {
        "height": "30px",
        "line-height": "30px",
        "margin": "5px auto",
        "width": "70%",
        "min-width": "100px",
        "border-radius": "5px",
        "text-align": "center",
        "background-color": "#6681a5",
        "color": "#ffffff",
        "font-size": "16px",
        "cursor": "pointer"
    },

    "inputOpinionAudioRecordAction": {
        "float": "right",
        "border": "1px solid #6681a5",
        "border-radius": "3px",
        "cursor": "pointer",
        "padding-left": "24px",
        "padding-right": "5px",
        "margin-left": "5px",
        "cursor": "pointer",
        "background": "url(../x_component_process_Work/$Processor/default/audioRecord.png) no-repeat 5px center"
    },
  "selectIdeaNode": {
    "height": "130px",
    "width": "210px",
    "float": "right",
    "background-color": "#FFF",
    "overflow": "hidden",
    "border-top" : "1px solid #ccc",
    "border-right" : "1px solid #ccc"
  },
  "selectIdeaScrollNode": {
    "height": "130px",
    "margin-right": "6px",
    "overflow": "hidden"
  },
  "selectIdeaItemNode": {
    "line-height": "18px",
    "font-size": "14px",
    "cursor": "pointer",
    "background-color": "#FFF",
    "margin-top": "2px",
    "padding": "2px 2px 2px 12px",
    "background": "url(../x_component_process_Work/$Processor/process/point.png) no-repeat 3px center",
    "overflow": "hidden"
  },
  "selectIdeaItemNode_over": {
    "background-color": "#e6ecf8"
  },

    "modelNode": {
        "border-radius": "3px",
        "border": "1px solid #999999",
        "box-shadow": "0px 0px 5px #666",
        "padding": "5px",
        "background-color": "#ffffff",
        "position": "absolute"
    },
    "modelNodeTitle": {
        "height": "20px",
        "line-height": "20px",
        "font-weight": "bold",
        "color": "#666666",
        "float": "left"
    },
    "modelItemNode": {
        "height": "20px",
        "line-height": "20px",
        "font-size": "12px",
        "color": "#a31515",
        "float": "left",
        "cursor": "pointer",
        "margin-left": "10px"
    },
    "modelNodeContent": {
        "margin-left": "10px"
    },
    "attachmentPermissionNode": {
        "overflow": "hidden",
        "width": "500px",
        "padding": "0px 40px"
    },
    "attachmentPermissionNode_mobile": {
      "overflow": "hidden",
      "padding": "0px 10px"
    },
    "attachmentPermissionNamesNode": {
        "overflow": "hidden"
    },
    "attachmentPermissionNamesTitleNode": {
        "font-size": "14px",
        "color": "#666666",
        "height": "30px",
        "font-weight": "bold",
        "line-height": "30px"
    },
    "attachmentPermissionNamesAreaNode": {
        "overflow": "hidden",
        "padding": "0px",
        "color": "#0000ff",
        "margin-bottom": "20px"
    },


    "attachmentPermissionAttNode": {
        "height": "20px",
        "line-height": "20px"
    },
    "attachmentPermissionTitleNode": {
        "font-size": "14px",
        "color": "#666666",
        "min-height": "26px",
        "line-height": "26px"
    },
    "attachmentPermissionInputNode": {
        "min-height": "24px",
        "overflow": "hidden",
        "line-height": "24px",
        "border": "1px solid #3C76B7",
        "border-radius": "3px",
        "cursor": "pointer",
        "margin-bottom": "10px",
        "background-color": "#ffffff"
    },

    "attachmentOCRNode": {
        "width": "500px",
        "height": "450px",
        "padding": "20px 20px 10px 20px"
    },
    "attachmentOCRInputAreaNode": {
        "height": "242px",
        //"width": "398px",
        "border": "1px solid #999999",
        "border-radius": "5px",
        "padding": "5px",
        "background-color": "#ffffff"
    },
    "attachmentOCRInputNode": {
        "height": "230px",
        "width": "490px",
        "border": "0px",
        "font-size": "14px",
        "font-family": "'Microsoft YaHei','Microsoft YaHei','SimSun','宋体'",
        "overflow": "auto"
    },
    "attachmentOCRImageAreaNode": {
        "height": "190px",
        "margin-bottom": "10px",
        "text-align": "center"
    },
    "attachmentOCRImageNode": {
        "max-height": "190px",
        "max-height": "190px",
        "max-width": "498px",
        "margin": "auto"
    },

    "empowerAreaNode": {
        "padding": "0 30px",
        "font-size": "14px",
        "overflow": "hidden"
    },
    "empowerSelectAllItemNode" : {
        "height": "40px",
        "line-height": "40px",
        "padding-left" : "5px",
        "font-size" : "16px",
        "width": "50px",
        "margin-left" : "30px",
        "float": "left",
        "overflow": "hidden",
        "color" : "inherit",
        "cursor" : "pointer",
        "background": "url(../x_component_process_Xform/$Form/default/icon/rollback_uncheck.png) no-repeat left center"
    },
    "empowerSelectAllItemNode_over" : {
        "color" : "#3C76B7",
        "background": "url(../x_component_process_Xform/$Form/default/icon/rollback_uncheck.png) no-repeat left center"
    },
    "empowerSelectAllItemNode_selected" : {
        "color" : "#3C76B7",
        "background": "url(../x_component_process_Xform/$Form/default/icon/empower_check.png) no-repeat left center"
    },
    "empowerItemOddNode": {
        "float" : "left",
        "width" : "250px",
        "min-height": "20px",
        "margin-bottom": "10px",
        "padding": "10px",
        "cursor": "pointer",
        "background-color": "#ffffff",
        "margin-right" : "10px"
    },
    "empowerItemEvenNode": {
        "float" : "left",
        "width" : "250px",
        "min-height": "20px",
        "margin-bottom": "10px",
        "padding": "10px",
        "cursor": "pointer",
        "background-color": "#ffffff"
    },
    "empowerItemOddNode_over": {
        "background-color": "#eaf1f9"
    },
    "empowerItemEvenNode_over": {
        "background-color": "#eaf1f9"
    },
    "empowerItemOddNode_selected": {
        "background-color": "#6196d1"
    },
    "empowerItemEvenNode_selected": {
        "background-color": "#6196d1"
    },
    "empowerItemIconNode": {
        "height": "20px",
        "width": "30px",
        "float": "right",
        "overflow": "hidden",
        "background": "url(../x_component_process_Xform/$Form/default/icon/rollback_uncheck.png) no-repeat center center"
    },
    "empowerItemIconNode_selected": {
        "background": "url(../x_component_process_Xform/$Form/default/icon/rollback_check.png) no-repeat center center"
    },
    "empowerItemContentNode": {
        "min-height": "20px"
    },
    "empowerItemTitleNode": {
        "float": "left",
        "min-height": "20px",
        "margin-left": "5px",
        "line-height": "20px",
        "font-size": "14px",
        "color": "#666666"
    },
    "empowerItemTitleNode_selected":{
        "color": "#ffffff"
    },
    "empowerItemPersonNode": {
        "float": "left",
        "margin-left": "5px",
        "min-height": "20px",
        "line-height": "20px",
        "font-size": "14px",
        "color": "#0000ff"
    },
    "empowerItemPersonNode_selected": {
        "color": "#ffffff"
    },

    "rollbackItemIconNode": {
        "height": "46px",
        "width": "30px",
        "float": "right",
        "overflow": "hidden",
        "background": "url(../x_component_process_Xform/$Form/default/icon/rollback_uncheck.png) no-repeat center center"
    },
    "rollbackItemIconNode_current": {
        "background": "url(../x_component_process_Xform/$Form/default/icon/rollback_check.png) no-repeat center center"
    },
    "rollbackItemContentNode": {
        "margin-right": "30px",
        "min-height": "46px"
    },

    "rollbackAreaNode": {
        "padding": "0 30px",
        "font-size": "14px",
        "overflow": "hidden"
    },
    "rollbackItemNode": {
        "min-height": "46px",
        "margin-bottom": "10px",
        "padding": "10px",
        "cursor": "pointer",
        "background-color": "#ffffff"
    },
    "rollbackItemNode_over": {
        "background-color": "#eaf1f9"
    },
    "rollbackItemNode_current": {
        "background-color": "#6196d1"
    },

    "rollbackItemIconNode": {
        "min-height": "46px",
        "width": "30px",
        "float": "right",
        "overflow": "hidden",
        "background": "url(../x_component_process_Xform/$Form/default/icon/rollback_uncheck.png) no-repeat center center"
    },
    "rollbackItemIconNode_current": {
        "background": "url(../x_component_process_Xform/$Form/default/icon/rollback_check.png) no-repeat center center"
    },
    "rollbackItemContentNode": {
        "margin-right": "30px",
        "min-height": "46px"
    },
    "rollbackItemActivityNode": {
        "height": "26px",
        "line-height": "26px",
        "font-weight": "bold",
        "float": "left",
        "color": "#000000",
        "margin-right": "10px"
    },
    "rollbackItemActivityNode_current": {
        "color": "#ffffff",
    },
    "rollbackItemTimeNode": {
        "height": "26px",
        "line-height": "26px",
        "color": "#666666",
        "float": "left"
    },
    "rollbackItemTimeNode_current": {
        "color": "#eeeeee"
    },
    "rollbackItemTaskTitleNode": {
        "float": "left",
        "height": "20px",
        "line-height": "20px",
        "font-size": "12px",
        "color": "#0000ff",
        "font-weight": "bold"
    },
    "rollbackItemTaskTitleNode_current":{
        "color": "#ffffff"
    },
    "rollbackItemTaskBodyNode": {
      "float": "left",
      "overflow": "hidden",
      "color": "#666666"
    },
    "rollbackItemTaskBodyNode_current": {
      "color": "#eeeeee"
    },
    "rollbackItemTaskNode": {
        "float": "left",
        "margin-left": "5px",
        "min-height": "20px",
        "line-height": "20px",
        "font-size": "12px"
    },
    "rollbackItemTaskCheckNode": {
        "float": "left"
    },
    "rollbackItemTaskNode_current": {
        "color": "#eeeeee"
    },
    "officeRecoverItemNode": {
        "height": "30px",
        "line-height": "30px",
        "margin-bottom": "10px",
        "padding": "10px",
        "cursor": "pointer",
        "color": "#666666",
        "font-weight": "bold",
        "font-size": "14px",
        "background-color": "#ffffff"
    },
    "officeRecoverItemNode_over": {
        "background-color": "#eaf1f9"
    },
    "officeRecoverItemNode_current": {
        "color": "#ffffff",
        "background-color": "#6196d1"
    },
    "officeRecoverItemActionNode": {
        "height": "30px",
        "width": "50px",
        "float": "right",
        "overflow": "hidden",
        "background": "url(../x_component_process_Xform/$Form/default/icon/open.png) no-repeat center center"
    },
    "officeRecoverItemActionNode_current": {
        "background": "url(../x_component_process_Xform/$Form/default/icon/open_current.png) no-repeat center center"
    },
    "officeRecoverItemTitleNode": {
        "margin-right": "50px",
        "height": "30px"
    },
    "documentEditorNode": {
        "background": "#f1f1f1",
        "border": "1px solid #cccccc",
        "overflow": "hidden",
        "position": "relative"
    },
    "documentEditorNode_page": {
        "width": "15.6cm",
        "height": "22.5cm",
        "padding": "3.7cm 2.6cm 3.5cm 2.8cm",
        "margin": "30px auto",
        "border": "0px #D3D3D3 solid",
        "border-radius": "5px",
        "background": "#ffffff",
        "box-shadow": "0 0 10px rgba(0, 0, 0, 0.1)",
        "font-size": "16pt",
        "font-family": "'仿宋_GB2312', serif",
        "line-height": "1.02cm",
        "letter-spacing": "-0.01cm"
    },
    "html5ActionButtonDingdingMore": {
        "height": "3em",
        "float": "left",
        "margin": "0.5em 0",
        "font-size": "1em",
        "color": "#191F25",
        "text-align": "center",
        "background": "#ffffff",
        "line-height": "3em"
    },
    "html5ActionButtonDingdingNormal": {
        "height": "3em",
        "float": "left",
        "margin": "0.5em 0",
        "font-size": "1em",
        "color": "#191F25",
        "text-align": "center",
        "background": "#ffffff",
        "line-height": "3em",
        "border-radius": "5px",
        "border": "1px solid #dfdfdf"
    },
    "html5ActionButtonDingdingPrimary": {
        "height": "3em",
        "float": "left",
        "margin": "0.5em 0",
        "font-size": "1em",
        "color": "#ffffff",
        "text-align": "center",
        "background": "#3296FA",
        "line-height": "3em",
        "border-radius": "5px",
        "border": "1px solid #3296FA"
    },
    "html5ActionButtonDingdingDanger": {
        "height": "3em",
        "float": "left",
        "margin": "0.5em 0",
        "font-size": "1em",
        "color": "#ffffff",
        "text-align": "center",
        "background": "#F25643",
        "line-height": "3em",
        "border-radius": "5px",
        "border": "1px solid #F25643"
    },
    "html5ActionButtonDingdingSplit": {
        "width": "1em",
        "background-color": "#ffffff",
        "height": "3em",
        "margin": "0.5em 0",
        "float": "left"
    },
    "html5ActionButton": {
        "height": "100%",
        "float": "left",
        "font-size": "16px",
        "color": "transparent",
        "text-align": "center",
        "background": "#ffffff",
        "line-height": "50px"
    },
    "html5ActionButtonSplit": {
        "width": "1px",
        "background-color": "#dfdfdf",
        "height": "34px",
        "margin-top": "8px",
        "float": "left"
    },
    "html5ActionOtherArea": {
        "overflow": "hidden",
        "background": "#ffffff",
        "position": "absolute",
        "left": "0",
        "bottom": "50px",
        "z-index": 100,
        "padding": "0px 20px",
        "border-top": "1px solid #dfdfdf",
    },
    "html5ActionOtherButton": {
        "height": "50px",
        "font-size": "16px",
        "border-bottom": "1px solid #dfdfdf",
        "color": "#068de7",
        "text-align": "center",
        "line-height": "50px"
    },
    "html5ActionButton_over": {
        "background": "#eeeeee"
    },
    "html5ActionButton_up": {
        "background": "#ffffff"
    },
    "waitSplitPageNode": {
        "width": "260px",
        "height": "60px",
        "line-height": "60px",
        "background-color": "#333333",
        "position": "absolute",
        "font-size": "16px",
        "color": "#ffffff",
        "border-radius": "10px",
        "text-align": "center",
        "opacity": 0.9,
        "z-index": 20000,
        "border": "1px solid #333333",
        "box-shadow": "3px 3px 20px #333333"
    },
    "attachmentOrderNode":{
        "width": "700px",
        "height": "600px",
        "padding": "10px 10px 5px 10px"
    },
  "attachmentOrderNode_mobile":{
    "padding": "10px 0px 5px 0px"
  },
    "attachmentOrderInforNode": {
        "padding": "15px 20px 10px 20px",
        "min-height": "20px",
        "line-height": "20px",
        "color": "#666666"
    },
    "attachmentOrderAreaNode": {
        "padding": "10px 10px 5px 10px",
        "background-color": "#ffffff",
        "height": "530px",
        "overflow": "auto"
    },
  "attachmentOrderAreaNode_mobile": {
    "padding": "10px 0px 5px 0px",
    "background-color": "#ffffff",
    "overflow": "auto"
  },
    "attachmentOrderItemNode": {
        "min-height": "30px",
        "overflow": "auto",
        "line-height": "30px",
        "padding": "5px 0px",
        "border-bottom": "1px solid #cccccc"
    },
    "attachmentOrderItemIconNode": {
        "width": "30px",
        "height": "30px",
        "float": "left",
        "cursor": "move",
        "background": "url(../x_component_process_Xform/$Form/default/icon/attOrder.png) no-repeat center center",
        "background-size": "24px 24px"
    },
    "attachmentOrderItemTextNode": {
        "margin-left": "30px",
        "margin-right": "130px",
        "min-height": "30px",
        "padding": "0px 5px",
        "color": "#666666"
    },
  "attachmentOrderItemTextNode_mobile": {
    "margin-left": "30px",
    "margin-right": "60px",
    "min-height": "30px",
    "padding": "0px 5px",
    "color": "#666666"
  },
    "attachmentOrderItemActionNode": {
        "width": "130px",
        "height": "30px",
        "float": "right"
    },
  "attachmentOrderItemActionNode_mobile": {
    "width": "60px",
    "height": "30px",
    "float": "right"
  },
    "attachmentOrderItemActionUpNode": {
        "border": "1px solid #999999",
        "border-radius": "3px",
        "height": "20px",
        "width": "30px",
        "float": "left",
        "margin-left": "5px",
        "margin-top": "4px",
        "padding-left": "20px",
        "line-height": "20px",
        "font-size": "12px",
        "cursor": "pointer",
        "background": "url(../x_component_process_Xform/$Form/default/icon/moveup.png) no-repeat 3px center",
        "color": "#999999"
    },
     "attachmentOrderItemActionDownNode": {
         "border": "1px solid #999999",
         "border-radius": "3px",
         "height": "20px",
         "width": "30px",
         "float": "left",
         "margin-left": "5px",
         "margin-top": "4px",
         "padding-left": "20px",
         "line-height": "20px",
         "font-size": "12px",
         "cursor": "pointer",
         "background": "url(../x_component_process_Xform/$Form/default/icon/movedown.png) no-repeat 3px center",
         "color": "#999999"
     },
     "attachmentOrderFlagNode": {
        "height": "2px",
        "background-color": "#5c649c"
     },
     "el-container-aside": {
        "background-color": "#D3DCE6",
        "width": "240px"
     },
     "el-container-header": {
       "background-color": "#B3C0D1",
       "height": "60px"
     },
     "el-container-footer": {
         "background-color": "#B3C0D1",
         "height": "60px"
     },
     "goBack_activityArea": {

     },
     "goBack_activity_mobile": {
         "padding": "6px 0",
         "overflow": "hidden",
         "display": "flex",
         "width": "97%",
         "justify-content": "space-between",
         "cursor": "pointer",
         "border-bottom": "1px solid #cccccc",
         "border-radius": "10px"
       },
  "goBack_activity": {
    "padding": "6px 0",
    "overflow": "hidden",
    "height": "48px",
    "display": "flex",
    "width": "97%",
    "justify-content": "space-between",
    "cursor": "pointer",
    "border-bottom": "1px solid #cccccc",
    "border-radius": "10px"
  },
  "goBack_activity_content": {
    "overflow": "hidden",
    "width": "calc(100% - 40px)",
    "display": "flex",
    "align-items": "flex-start",
    "justify-content": "center",
    "flex-direction": "column"
  },
  "goBack_activity_way": {
    "width": "140px",
    "color": "#666666",
    "font-size": "12px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "padding-right": "20px"
  },
  "goBack_activity_way_mobile": {
    "color": "#666666",
    "font-size": "12px"
  },
  "goBack_activity_check": {
    "width": "40px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center"
  },
  "goBack_activity_name": {
    "color": "#000000",
    "font-size": "14px"
  },
  "goBack_activity_info": {
    "color": "#999999",
    "font-size": "12px"
  },
  "associatedDocumentItem":{
    "overflow": "hidden",
    "cursor": "pointer",
    "line-height": "30px",
    "min-height": "30px",
    "background": "#fff"
  },
  "associatedDocumentItem_over":{
    "background": "#eaf0f5"
},
  "associatedDocumentCmsIcon":{
    "margin-top": "3px",
    "margin-left": "4px",
    "width": "21px",
    "height": "24px",
    "background": "url(../x_component_process_Xform/$Form/default/icon/doc_cms.png) no-repeat center center",
    "background-size": "21px 24px",
    "float": "left"
  },
  "associatedDocumentWorkIcon":{
    "margin-top": "3px",
    "margin-left": "4px",
    "width": "21px",
    "height": "24px",
    "background": "url(../x_component_process_Xform/$Form/default/icon/doc_work.png) no-repeat center center",
    "background-size": "21px 24px",
    "float": "left"
  },
  "associatedDocumentText": {
    "margin-left": "32px",
    "margin-right": "30px"
  },
  "associatedDocumentDelete": {
    "margin-top": "7px",
    "margin-left": "5px",
    "width": "16px",
    "height": "16px",
    "margin-right": "5px",
    "background": "url(../x_component_process_Xform/$Form/default/icon/delete1.png) no-repeat center center",
    "background-size": "16px 16px",
    "float": "right"
  }

}

var csskey = encodeURIComponent("../o2_core/o2/widget/$Tab/mobileForm/css.wcss");
o2.widget.css[csskey]={
	"tabNodeContainer": {
        "height": "40px",
        "background": "#ffffff",
        "border-top": "0px solid #CCC",
        "border-bottom": "0px solid #CCC"
    },
	"contentNodeContainer": {
		"overflow": "hidden",
		"clear": "both"
	},
	"contentNodeArea": {
		"overflow": "hidden",
		"display": "none",
		"opacity": 0
	},
	"tabNode": {
        "position": "relative",
        "margin-left": "2px",
        "margin-right": "0px",
        "float": "left",
        "height": "40px",
        "cursor": "pointer",
        "min-width": "70px",
        "background": "#ffffff",
        "border": "0px"
    },
	"tabTextNode": {
        "color": "#666666",
        "line-height": "40px",
        "text-align": "center",
        "margin-right": "4px",
        "margin-top": "0px",
        "margin-left": "4px",
        "font-size": "14px"
    },
	"tabCloseNode": {
		"height": "24px",
		"width": "20px",
		"background": "url("+o2.session.path+"/widget/$Tab/default/close.gif) center center"
	},
	"tabNodeCurrent": {
        "position": "relative",
        "margin-top": "0px",
        "margin-left": "2px",
        "margin-right": "0px",
        "float": "left",
        "height": "40px",
        "min-width": "70px",
        "background": "#ffffff",
        "border-bottom": "2px solid #bf6364"
    },
	"tabTextNodeCurrent": {
        "color": "#fb4747",
        "line-height": "40px",
        "text-align": "center",
        "margin-right": "4px",
        "margin-left": "4px",
        "font-size": "14px"
    },

	"tabCloseNodeCurrent": {
		"height": "30px",
		"width": "20px",
		"background": "url("+o2.session.path+"/widget/$Tab/default/close.gif) center center"
	}
}
var csskey = encodeURIComponent("../o2_core/o2/widget/$Menu/tab/css.wcss");
o2.widget.css[csskey]={
	"borderNode": {
		"border": "0px solid #666",
		"background-color": "#666666",
		"padding": "1px",
		"overflow": "hidden",
		"display": "none",
		"z-index": "999",
		"opacity": 0,
		"position": "absolute",
		"float": "left",
		"min-width": (Browser.iecomp) ? "auto" : "140px",
		"border-radius": "3px",
		"box-shadow": "0px 0px 10px #333", 
		"cursor": "default"
	},
	"container": {
		"border-top": "1px solid #eeeeee",
		"border-left": "1px solid #eeeeee",
		"border-right": "1px solid #eeeeee",
		"border-bottom": "1px solid #eeeeee",
		"border-radius": "3px",
		"background-color": "#eeeeee",
		"padding": "3px",
		"overflow": "hidden",
		"cursor": "default"
	},
	"menuItem": {
		"border-radius": "3px",
		"display":"block",
		"position": "static",
		"height": "24px",
		"line-height": "24px",
		"border": "1px solid #eeeeee",
		"background-color": "#eeeeee",
		"cursor": "pointer",
		"color": "#000",
		"font-family": "Microsoft YaHei",
		"font-size": "14px"
	},

	"menuItemImgDiv": {
		"display":"block",
		"float": "left",
		"width": "0px",
		"height": "24px",
		"text-align": "center"
	},
	"menuItemImg": {
		"height": "16px",
		"width": "0px",
		"margin-top": "4px",
		"margin-left": "4px"
	},
	"menuItemSeparator": {
		"display":"block",
		"float": "left",
		"height": "24px",
		"width": "0px",
		"background-color": "#d7d7d7",
		"border-right": "0px solid #d7d7d7",
		"overflow": "hidden"
	},
	"menuItemText": {
		"display":"block",
		"position": "static",
		"height": "24px",
		"margin-left": "10px",
		"margin-right": "10px",
		"line-height": "24px",
		"font-size": "12px"
	},
	"menuLine": {
		"position": "static",
		"display":"block",
		"height": "1px",
		"overflow": "hidden",
		"margin-left": "0px",
		"margin-top": "3px",
		"margin-bottom": "3px",
		"background-color": "#CCCCCC",
		"border-bottom": "1px solid #FFFFFF"
	},
	"menuItemDisable": {
		"color": "#999"
	},

	"menuOver": {
		"border": "1px solid #999",
		//"background-color": "#b5bed6"
		"background-color": "#aec0d7"
	},
	"menuOut": {
		"border": "1px solid #eeeeee",
		"background-color": "#eeeeee"
	},
	"menuDown": {
		"border": "1px solid #000000",
		"background-color": "#c6cde0"
	},
	"menuUp": {
		"border": "1px solid #999",
		//"background-color": "#b5bed6"
		"background-color": "#aec0d7"
	},
	"toolbarButtonDownNode": {
		"display":"block",
		"float": "left",
		"padding-left": "2px",
		"padding-right": "2px",
		"padding-top": "0px",
		"height": "18px",
		"color": "#ff0000",
		"cursor": "pointer"
	},
	"menuItemSubmenuIcon":{
		"background-image": "url("+o2.session.path+"/widget/$Menu/desktopStyle/submenu.png)",
		"height": "16px",
		"width": "16px",
		"margin-top": "4px",
		"float": "right"
	}
}
o2.widget = o2.widget || {};
o2.widget.css = o2.widget.css || {};
o2.widget.Common = new Class({
	Implements: [Options, Events],
	options: {},
	initialize: function(options){
		this.setOptions(options);
	},
	_loadCss: function(reload){
        var key = encodeURIComponent(this.cssPath);
        if (!reload && o2.widget.css[key]){
            this.css = o2.widget.css[key];
        }else{
            this.cssPath = (this.cssPath.indexOf("?")!=-1) ? this.cssPath+"&v="+o2.version.v : this.cssPath+"?v="+o2.version.v;
            var r = new Request.JSON({
                url: o2.filterUrl(this.cssPath),
                secure: false,
                async: false,
                method: "get",
                noCache: false,
                onSuccess: function(responseJSON, responseText){
                    this.css = responseJSON;
                    o2.widget.css[key] = responseJSON;
                }.bind(this),
                onError: function(text, error){
                    alert(error + text);
                }
            });
            r.send();
        }
	},
	setLayoutStyle: function(node, classes, nodes){
		var styleNode = node || this.node;
		
		var elements = styleNode.getElements(".GOES");
		elements.each(function(item){
			var id = item.get("id");
			var styles = this.css[id];
			if (styles){
				item.setStyles(styles);
			}
			var idx = classes.indexOf(id);
			if (idx!=-1){
				this[nodes[idx]] = item;
			}
			item.removeProperty("id");
		}.bind(this));
	},
	setScrollBar: function(node, style, offset, callback){
		if (!style) style = "default";
		if (!offset){
			offset = {
				"V": {"x": 0, "y": 0},
				"H": {"x": 0, "y": 0}
			};
		};
		o2.require("o2.widget.ScrollBar", function(){
			var scrollBar = new o2.widget.ScrollBar(node, {
				"style": style,
				"offset": offset
			});
			if (callback) callback(scrollBar);
		});
		return false;
	}
});

o2.widget = o2.widget || {};
o2.widget.Dialog = o2.DL = new Class({
	Implements: [Options, Events],
    Extends: o2.widget.Common,
	options: {
		"style": "default",
		"title": "dialog",
		"width": "300",
		"height": "150",
		"contentWidth": null,
		"contentHeight": null,
		"top": "0",
		"left": "0",
		"fromTop": "0",
		"fromLeft": "0",
		"mark": true,

		"html": "",
		"text": "",
		"url": "",
		"content": null,
		"lp": null,

		"isMax": false,
		"isClose": false,
		"isResize": true,
		"isMove": true,
        "isTitle": true,
		
		"buttons": null,
		"buttonList": null,
        "maskNode" : null,

		"transition": null,
		"duration": 200,

        "container": null
	},
	initialize: function(options){

		this.setOptions(options);

		this.path = o2.session.path+"/widget/$Dialog/";
		this.cssPath = o2.session.path+"/widget/$Dialog/"+this.options.style+"/css.wcss";

		this._loadCss();
		
		this.reStyle();
//		this.css.to.height = this.options.height;
//		this.css.to.width = this.options.width;
//		this.css.to.top = this.options.top;
//		this.css.to.left = this.options.left;
//		this.css.to.top = this.options.top;
//		this.css.from.top = this.options.fromTop;
//		this.css.from.left = this.options.fromLeft;
		
		this.fireEvent("queryLoad");

		this.getContentUrl();
		var request = new Request.HTML({
			url: this.contentUrl,
			method: "GET",
			async: false,
			onSuccess: function(responseTree, responseElements, responseHTML, responseJavaScript){
				this.node = responseTree[0];
				this.getDialogNode();
				this.fireEvent("postLoad");
			}.bind(this),
			onFailure: function(xhr){
				alert(xhr);
			}
		});
		request.send();
	},
	getContentUrl: function(){
		this.contentUrl = o2.session.path+"/widget/$Dialog/"+this.options.style+"/dialog.html";
	},
	reStyle: function(options){
		if (options) this.setOptions(options);
		this.css.to.height = this.options.height+"px";
		this.css.to.width = this.options.width+"px";
		this.css.to.top = this.options.top+"px";
		this.css.to.left = this.options.left+"px";
		//this.css.to.top = this.options.top+"px";
		this.css.from.top = this.options.fromTop+"px";
		this.css.from.left = this.options.fromLeft+"px";

		if (this.node) this.node.set("styles", this.css.from);
	},

    getParentSelect: function(node){
        var select = "";
        var pnode = node.getParent();
        while (!select && pnode){
            select = pnode.getStyle("-webkit-user-select");
            var pnode = pnode.getParent();
        }
        return select;
    },
	getDialogNode: function(){
		this.node.set("styles", this.css.from);
		this.node.inject(this.options.container || $(document.body));
		this.node.addEvent("selectstart", function(e){
			var select = e.target.getStyle("-webkit-user-select");
            if (!select) select = this.getParentSelect(e.target);
			if (!select){
				select = "none";
			}else{
				select = select.toString().toLowerCase();
			}
			var tag = e.target.tagName.toString().toLowerCase();
			if (select!="text" && select!="auto" && ["input", "textarea"].indexOf(tag)==-1) e.preventDefault();
			
        }.bind(this));

		this.title = this.node.getElement(".MWF_dialod_title");
		this.titleCenter = this.node.getElement(".MWF_dialod_title_center");
        this.titleRefresh = this.node.getElement(".MWF_dialod_title_refresh");
		this.titleText = this.node.getElement(".MWF_dialod_title_text");
		this.titleAction = this.node.getElement(".MWF_dialod_title_action");
        this.under = this.node.getElement(".MWF_dialod_under");
		this.content = this.node.getElement(".MWF_dialod_content");
		this.bottom = this.node.getElement(".MWF_dialod_bottom");
		this.resizeNode = this.node.getElement(".MWF_dialod_bottom_resize");
		this.button = this.node.getElement(".MWF_dialod_button");

		if (!this.options.isTitle) {
            this.title.destroy();
            this.title = null;
            this.titleCenter = null;
            this.titleRefresh = null;
            this.titleText = null;
            this.titleAction = null;
        }

		if (this.title) this.title.setStyles(this.css.MWF_dialod_title);
        if (this.titleCenter) this.titleCenter.setStyles(this.css.MWF_dialod_title_center);
        if (this.titleRefresh) this.titleRefresh.setStyles(this.css.MWF_dialod_title_refresh);
        if (this.titleText) this.titleText.setStyles(this.css.MWF_dialod_title_text);
        if (this.titleAction) this.titleAction.setStyles(this.css.MWF_dialod_title_action);
        if (this.under) this.under.setStyles(this.css.MWF_dialod_under);
        if (this.content) this.content.setStyles(this.css.MWF_dialod_content);
        if (this.bottom) this.bottom.setStyles(this.css.MWF_dialod_bottom);
        if (this.resizeNode) this.resizeNode.setStyles(this.css.MWF_dialod_bottom_resize);
        if (this.button) this.button.setStyles(this.css.MWF_dialod_button);


		if (this.title) this.setTitleEvent();
        if (this.titleRefresh) this.setTitleRefreshNode();
	//	if (this.titleText) this.getTitle();
		if (this.content) this.getContent();
		if (this.titleAction) this.getAction();
		if (this.resizeNode) this.setResizeNode();
	//	if (this.button) this.getButton();

		if (this.content) this.setContentSize();
	},
    setTitleRefreshNode: function(){
        this.titleRefresh.setStyles(this.css.titleRefresh);
        this.titleRefresh.set("title", o2.LP.widget.refresh);
    },
	setTitleEvent: function(){
		var content;
		if (layout.app) content = layout.app.content;
		if (layout.desktop.currentApp) content = layout.desktop.currentApp.content;
		this.containerDrag = new Drag.Move(this.node, {
			"handle": this.title,
			"container": this.options.container || this.markNode || content,
			"snap": 5
		});

		// this.title.addEvent("mousedown", function(e){
        //     var content;
        //     if (layout.app) content = layout.app.content;
        //     if (layout.desktop.currentApp) content = layout.desktop.currentApp.content;
		// 	this.containerDrag = new Drag.Move(this.node, {
        //         "container": content
        //     });
		// 	this.containerDrag.start();
		// }.bind(this));
		// this.title.addEvent("mouseup", function(){
		// 	this.node.removeEvents("mousedown");
		// 	this.title.addEvent("mousedown", function(){
		// 		var content;
		// 		if (layout.app) content = layout.app.content;
		// 		if (layout.desktop.currentApp) content = layout.desktop.currentApp.content;
        //         this.containerDrag = new Drag.Move(this.node, {
        //             "container": content
        //         });
		// 		this.containerDrag.start();
		// 	}.bind(this));
		// }.bind(this));
	},
	setResizeNode: function(){
		//未实现................................
        if (!this.options.isResize){
            if (this.resizeNode) this.resizeNode.hide();
        }else{
            if (this.resizeNode){
                this.node.makeResizable({
                    "handle": this.resizeNode || this.bottom,
                    "limit": {x:[200, null], y:[150, null]},
                    "onDrag": function(){
                        var size = this.node.getComputedSize();
                        // this.css.to.width = size.totalWidth;
                        // this.css.to.height = size.totalHeight;
                        this.css.to.width = size.width;
                        this.css.to.height = size.height;

                        this.setContentSize(size.height, size.width);

                        this.fireEvent("resize");
                    }.bind(this),
                    "onComplete": function(){
                        this.fireEvent("resizeCompleted");
                    }.bind(this)
                });
			}
		}
	},
	getAction: function(){
		//未完成................................
		if (this.options.isClose){
			this.closeAction = new Element("div", {"styles": this.css.closeAction}).inject(this.titleAction);
            this.closeAction.addEvent("click", this.close.bind(this));
		}
	},
	getButton: function(){
		for (i in this.options.buttons){
			var button = new Element("input", {
				"type": "button",
				"value": i,
				"class": "mainColor_bg",
				"styles": this.css.button,
				"events": {
					"click": this.options.buttons[i].bind(this)
				}
			}).inject(this.button);
		}

		if (this.options.buttonList){
			this.options.buttonList.each(function(bt){
				var styles = this.css.button;
				if( bt.type === "ok" && this.css.okButton )styles = this.css.okButton;
				if( bt.type === "cancel" && this.css.cancelButton )styles = this.css.cancelButton;
				if( bt.styles )styles = bt.styles;
				var button = new Element("input", {
					"type": "button",
					"value": bt.text,
					"title": bt.title,
					"class": (bt.type!=="cancel") ? "mainColor_bg" : "",
					"styles": styles,
					"events": {
						"click": function(e){bt.action.call(this, this, e)}.bind(this)
					}
				}).inject(this.button);
			}.bind(this));
		}
	},
	getContentSize: function(height, width){
        var nodeHeight, nodeWidth;
		if (!height){
			if (this.options.contentHeight){
                nodeHeight = height = this.options.contentHeight.toFloat();
			}else{
                height = this.options.height.toFloat();
			}
		}
        if (!width){
            if (this.options.contentWidth){
                nodeWidth = width = this.options.contentWidth.toFloat();
            }else{
                width = this.options.width.toFloat();
            }
        }

        var offsetHeight = 0;
        var offsetWidth = 0;
		if (this.title){
			var h1 = this.title.getSize().y;
			var ptop1 = this.title.getStyle("padding-top").toFloat();
			var pbottom1 = this.title.getStyle("padding-bottom").toFloat();
			var mtop1 = this.title.getStyle("margin-top").toFloat();
			var mbottom1 = this.title.getStyle("margin-bottom").toFloat();
            offsetHeight += h1 + ptop1 + pbottom1 + mtop1 + mbottom1;
		}
		if (this.bottom){
			var h2 = this.bottom.getSize().y;
			var ptop2 = this.bottom.getStyle("padding-top").toFloat();
			var pbottom2 = this.bottom.getStyle("padding-bottom").toFloat();
			var mtop2 = this.bottom.getStyle("margin-top").toFloat();
			var mbottom2 = this.bottom.getStyle("margin-bottom").toFloat();

            offsetHeight += h2 + ptop2 + pbottom2 + mtop2 + mbottom2;
		}
		if (this.button){
			var h3 = this.button.getSize().y;
			var ptop3 = this.button.getStyle("padding-top").toFloat();
			var pbottom3 = this.button.getStyle("padding-bottom").toFloat();
			var mtop3 = this.button.getStyle("margin-top").toFloat();
			var mbottom3 = this.button.getStyle("margin-bottom").toFloat();

            offsetHeight += h3 + ptop3 + pbottom3 + mtop3 + mbottom3;
		}
				
		var ptop4 = this.content.getStyle("padding-top").toFloat();
		var pbottom4 = this.content.getStyle("padding-bottom").toFloat();
		var mtop4 = this.content.getStyle("margin-top").toFloat();
		var mbottom4 = this.content.getStyle("margin-bottom").toFloat();
        offsetHeight += ptop4 + pbottom4 + mtop4 + mbottom4;

        var maxHeight = 0;
        if (nodeHeight){
            nodeHeight = nodeHeight + offsetHeight+2;
        }else {
            height = height - offsetHeight;
			if( height < 0 ){
				maxHeight = (this.options.container || $(document.body)).getSize().y;
				maxHeight = maxHeight - offsetHeight - 10;
			}
        }

        //if (this.content.getParent().getStyle("overflow-x")!="hidden" ) height = height-18;
		
		var pleft = this.content.getStyle("padding-left").toFloat();
		var pright = this.content.getStyle("padding-right").toFloat();
		var mleft = this.content.getStyle("margin-left").toFloat();
		var mright = this.content.getStyle("margin-right").toFloat();
        offsetWidth = pleft+pright+mleft+mright;
		//width = width-pleft-pright-mleft-mright;
        //if (this.content.getParent().getStyle("overflow-y")!="hidden" ) width = width-18;
        if (nodeWidth){
            nodeWidth = nodeWidth+offsetWidth;
        }else{
            width = width-offsetWidth;
		}


		if (nodeHeight) {
            this.options.height = nodeHeight;
            this.options.contentHeight = null;
            this.options.fromTop = this.options.fromTop.toFloat()-offsetHeight/2;
            this.options.top = this.options.top.toFloat()-offsetHeight/2;
            this.css.to.height = nodeHeight+"px";
            this.css.to.top = this.options.top+"px";
            this.css.from.top = this.options.fromTop+"px";
        }
        if (nodeWidth){
            this.options.width = nodeWidth;
            this.options.contentWidth = null;
            this.options.fromLeft = this.options.fromLeft.toFloat()-offsetWidth/2;
            this.options.left = this.options.left.toFloat()-offsetWidth/2;
            this.css.to.width = nodeWidth+"px";
            this.css.to.left = this.options.left+"px";
            this.css.from.left = this.options.fromLeft+"px";
        }

        if (!height || height<0){
            this.content.setStyles({"overflow": "hidden", "height": "auto", "width": ""+width+"px"});
            if( maxHeight )this.content.setStyles({"max-height": maxHeight+"px"});
            height = this.content.getSize().y;
            var h = height + h1 + ptop1 + pbottom1 + mtop1 + mbottom1;
            h = h + h2 + ptop2 + pbottom2 + mtop2 + mbottom2;
            h = h + h3 + ptop3 + pbottom3 + mtop3 + mbottom3;
            h = h + ptop4 + pbottom4 + mtop4 + mbottom4;
            this.css.to.height = h;
        }

//		var ptop5 = this.node.getStyle("padding-top").toFloat();
//		var pbottom5 = this.node.getStyle("padding-bottom").toFloat();
//		height = height - ptop5 - pbottom5;
		
		return {"height": height+"px", "width": width+"px"};
	},
	setContentSize: function(height, width){
		//this.content.setStyle("height", this.getContentSize(height));
		// if (!this.options.height && !height){
         //    this.content.setStyle("height", "auto");
         //    this.content.setStyle("overflow", "hidden");
         //    this.content.setStyle("width", "auto");
		// }else{
            this.content.setStyles(this.getContentSize(height, width));
            this.content.setStyle("width", "auto");
		//}
	},
	reCenter: function(){
		var size = this.node.getSize();
		var container = $(document.body);
		if (layout.desktop.currentApp){
			container = layout.desktop.currentApp.content;
		}else{
			if (this.options.container){
				if (this.options.container.getSize().y<$(document.body).getSize().y){
					container = this.options.container;
				}
			}
		}

		// if (this.options.container){
		// 	if (this.options.container.getSize().y<$(document.body).getSize().y){
		// 		container = this.options.container;
		// 	}
		// }

        var p = o2.getCenter(size, container, container);
        if (p.y<0) p.y = 0;
        this.options.top = p.y;
        this.options.left = p.x;
        this.css.to.top = this.options.top+"px";
        this.css.to.left = this.options.left+"px";
        this.node.setStyles({
			"top": this.css.to.top,
            "left": this.css.to.left
		});
	},

	getTitle: function(){
		this.titleText.set("text", this.options.title);
	},
	getContent: function(){
		this.content.setStyles(this.css.content);
		if (this.options.content){
			this.options.content.inject(this.content);
		}else if (this.options.url){
			this.content.set("load", {"method": "get", "async": false});
			$(this.content).loadHtml(this.options.url, {"bind": {"lp": this.options.lp}});
/*
			var request = new Request.HTML({
				url: this.options.url,
				method: "GET",
				onSuccess: function(responseTree, responseElements, responseHTML, responseJavaScript){
					alert(responseHTML);
					this.content.set("html", responseHTML);
				}.bind(this),
				onFailure: function(xhr){
					alert("回退出现错误："+xhr.status+" "+xhr.statusText);
					window.close();
				}
			});*/
		}else if (this.options.html){
			this.content.set("html", this.options.html);
		}else if (this.options.text){
			this.content.set("text", this.options.text);
		}
//		this.content.addEvent("selectstart", function(e){
//			e.preventDefault();
//		});
	},
	show: function(){
		if (this.options.mark) this._markShow();
		if (!this.morph){
			this.morph = new Fx.Morph(this.node, {duration: this.options.duration, "transition": this.options.transition});
		}
		if (this.fireEvent("queryShow")){
			this.node.setStyle("display", "block");

            // this.node.setStyles(t);
            // if (this.titleText) this.getTitle();
            // if (this.button) this.getButton();
            // //	this.content.setStyle("display", "block");
            // //this.fireEvent("postShow");

			var pn = this.node.getOffsetParent() || this.node.getParent();
			var p = pn.getPosition();

			var scrollParent = this.getScrollableParent(this.node);

			var h = this.css.to.height.toInt();
			var y = this.css.to.top.toInt();
			y = y+p.y;

			var windowHeight  = window.innerHeight.toInt();
			if( layout.mobile ){
				var toolbar = $(document.body).getElement(".o2_form_mobile_actions");
				if(toolbar)windowHeight = windowHeight - toolbar.getSize().y;
			}

			var ih = windowHeight + scrollParent.getScroll().y;
			if (h+y> ih){
				y = ih-p.y-h-20;
				if (y<0) y=0;
				this.css.to.top = ""+y+"px";
			}

			this.morph.start(this.css.to).chain(function(){
				if (this.titleText) this.getTitle();
				if (this.button) this.getButton();
			//	this.content.setStyle("display", "block");
				this.fireEvent("postShow");
			}.bind(this));
		}
	},
	getScrollableParent: function (ele) {
		if( !ele || ele === document.body )return document.body;
		if( this.isScrollable(ele) ){
			return ele;
		}else{
			return this.getScrollableParent(ele.parentNode);
		}
	},
	isScrollable: function (ele) {
		var hasScrollableContent = ele.scrollHeight > ele.clientHeight;

		var overflowYStyle = window.getComputedStyle(ele).overflowY;
		var isOverflowHidden = overflowYStyle.indexOf('hidden') !== -1;

		return hasScrollableContent && !isOverflowHidden;
	},
	hide: function() {
		if (!this.morph){
			this.morph = new Fx.Morph(this.node, {duration: this.options.duration, "transition": this.options.transition});
		}
		if (this.fireEvent("queryHide")){
			if (this.titleText) this.titleText.set("text", "");
			if (this.button) this.button.set("html", "");
			
			this.morph.start(this.css.from).chain(function(){
				this._markHide();
				this.node.setStyle("display", "none");
				this.fireEvent("postHide");
			}.bind(this));
		}
	},
	close: function(){
		if (!this.morph){
			this.morph = new Fx.Morph(this.node, {duration: this.options.duration, "transition": this.options.transition});
		}
		
		if (this.fireEvent("queryClose")){
			this.morph.start(this.css.from).chain(function(){
				this._markHide();
				this.node.destroy();
				this.node = null;
				this.fireEvent("postClose");
			}.bind(this));
		}
	},
	_markShow: function(){

		if (this.options.mark){
			if (!this.markNode){
				var size = o2.getMarkSize(this.options.maskNode);
				this.markNode = new Element("div", {
					styles: this.css.mark
				}).inject(this.options.container || $(document.body));
				this.markNode.set("styles", {
					"height": size.y,
					"width": size.x
				});
			}
			this.markNode.setStyle("display", "block");
		}
	},
	
	_markHide: function(){
		if (this.markNode){
			this.markNode.setStyle("display", "none");
			this.markNode.destroy();
			this.markNode = null;
		}
		if (this.markNode_up){
			this.markNode_up.setStyle("display", "none");
			this.markNode_up.destroy();
			this.markNode_up = null;
		}
	}
});

o2.widget = o2.widget || {};
o2.widget.UUID = new Class({
	initialize: function(){
		this.id = this.createUUID();
	},
	valueOf: function() {  
		return this.id;  
	},
	toString: function() {  
		return this.id;
	},
	createUUID: function(){
		//
		// Loose interpretation of the specification DCE 1.1: Remote Procedure Call
		// described at
		// http://www.opengroup.org/onlinepubs/009629399/apdxa.htm#tagtcjh_37
		// since JavaScript doesn't allow access to internal systems, the last 48
		// bits
		// of the node section is made up using a series of random numbers (6 octets
		// long).
		//  
		var dg = new Date(1582, 10, 15, 0, 0, 0, 0);
		var dc = new Date();
		var t = dc.getTime() - dg.getTime();
		var tl = this.getIntegerBits(t, 0, 31);
		var tm = this.getIntegerBits(t, 32, 47);
		var thv = this.getIntegerBits(t, 48, 59) + '1'; // version 1, security version is 2
		var csar = this.getIntegerBits(this.rand(4095), 0, 7);
		var csl = this.getIntegerBits(this.rand(4095), 0, 7);

		// since detection of anything about the machine/browser is far to buggy,
		// include some more random numbers here
		// if NIC or an IP can be obtained reliably, that should be put in
		// here instead.
		var n = this.getIntegerBits(this.rand(8191), 0, 7)
				+ this.getIntegerBits(this.rand(8191), 8, 15)
				+ this.getIntegerBits(this.rand(8191), 0, 7)
				+ this.getIntegerBits(this.rand(8191), 8, 15)
				+ this.getIntegerBits(this.rand(8191), 0, 15); // this last number is two octets long
		return tl + tm + thv + csar + csl + n;
	},
	createTrueUUID: function(){
		//
		// Loose interpretation of the specification DCE 1.1: Remote Procedure Call
		// described at
		// http://www.opengroup.org/onlinepubs/009629399/apdxa.htm#tagtcjh_37
		// since JavaScript doesn't allow access to internal systems, the last 48
		// bits
		// of the node section is made up using a series of random numbers (6 octets
		// long).
		//  
		var dg = new Date(1582, 10, 15, 0, 0, 0, 0);
		var dc = new Date();
		var t = dc.getTime() - dg.getTime();
		var tl = this.getIntegerBits(t, 0, 31);
		var tm = this.getIntegerBits(t, 32, 47);
		var thv = this.getIntegerBits(t, 48, 59) + '1'; // version 1, security version is 2
		var csar = this.getIntegerBits(this.rand(4095), 0, 7);
		var csl = this.getIntegerBits(this.rand(4095), 0, 7);

		// since detection of anything about the machine/browser is far to buggy,
		// include some more random numbers here
		// if NIC or an IP can be obtained reliably, that should be put in
		// here instead.
		var n = this.getIntegerBits(this.rand(8191), 0, 7)
				+ this.getIntegerBits(this.rand(8191), 8, 15)
				+ this.getIntegerBits(this.rand(8191), 0, 7)
				+ this.getIntegerBits(this.rand(8191), 8, 15)
				+ this.getIntegerBits(this.rand(8191), 0, 15); // this last number is two octets long
		return tl +"-"+ tm +"-"+ thv +"-"+ csar + csl +"-"+ n;
	},
	getIntegerBits: function(val, start, end){
		var base16 = this.returnBase(val, 16);
		var quadArray = new Array();
		var quadString = '';
		var i = 0;
		for (i = 0; i < base16.length; i++) {
			quadArray.push(base16.substring(i, i + 1));
		}
		for (i = Math.floor(start / 4); i <= Math.floor(end / 4); i++) {
			if (!quadArray[i] || quadArray[i] == '')
				quadString += '0';
			else
				quadString += quadArray[i];
		}
		return quadString;
	},
	returnBase: function(number, base) {
		return (number).toString(base).toUpperCase();
	},
	rand: function(max) {
		return Math.floor(Math.random() * (max + 1));
	}
	
});

o2.widget = o2.widget || {};
o2.widget.Menu = new Class({
	Implements: [Options, Events],
    Extends: o2.widget.Common,
	options: {
		"style": "default",
		"event": "contextmenu",
		"disable": false,
		"top": -1,
		"left": -1,
        "container": null
	},
	initialize: function(target, options){
		this.setOptions(options);

		this.items = [];
		
		this.path = o2.session.path+"/widget/$Menu/";
		this.cssPath = o2.session.path+"/widget/$Menu/"+this.options.style+"/css.wcss";

		this._loadCss();

		this.target = $(target);
	//	if (this.target.onselectstart) 
		if (this.target) this.target.onselectstart = function(){return false;};
	//	if (this.target.oncontextmenu) 
		if (this.target) this.target.oncontextmenu = function(){return false;};
		
		this.pauseCount = 0;
	},
	pause: function(count){
		this.pauseCount = count;
	},
	load: function(){
		if (this.fireEvent("queryLoad")){
			this.node = new Element("div.MWFMenu");
			this.node.set("styles", this.css.container);

			if (this.options.event){
				if (this.target) this.target.addEvent(this.options.event, this.showIm.bind(this));
			}
			//this.node.inject(this.options.container || $(document.body));
			this.node.inject(this.options.container || this.target);

			this.hide = this.hideMenu.bind(this);
			this.fireEvent("postLoad");
		}
	},
	setItemWidth: function(){
		this.items.each(function(item){
			var w1 = this.node.getStyle("padding-left").toInt();
			var w2 = this.node.getStyle("padding-right").toInt();
			var w3 = this.node.getStyle("border-left-width").toInt();
			var w4 = this.node.getStyle("border-right-width").toInt();
			var w5 = item.item.getStyle("border-left-width").toInt();
			var w6 = item.item.getStyle("border-right-width").toInt();
			var w7 = item.item.getStyle("margin-left").toInt();

		//	item.item.setStyle("width", this.node.getSize().x-w1-w2-w3-w4-w5-w6-w7);
			/*
			if (item.type=="line"){
				
				item.item.setStyle("width", this.node.getSize().x-8-28);
			}else{
				item.item.setStyle("width", this.node.getSize().x-8);
			}*/
		}.bind(this));
	},
	setPosition: function(e){
		var top;
		var left;
		if (this.options.top==-1){
			top = e.page.y;
		}else{
			top = this.options.top;
		}
		if (this.options.left==-1){
			left = e.page.x;
		}else{
			left = this.options.left;
		}
		var size = this.node.getSize();

		var bodyNode = this.node.getOffsetParent();

		//var bodySize = $(document.body).getSize();
        var bodySize = bodyNode.getSize();

		if (left+size.x>bodySize.x){
			left = left-size.x-5;
			if (left<0) left = 0;
		}
		
		//var scrollTop = ($(document.body).getScroll().y.toFloat()) || 0;
        var scrollTop = (bodyNode.getScroll().y.toFloat()) || 0;
		
		if (top+size.y>bodySize.y+scrollTop){
			top = top-size.y-5;
			if (top<0) top = 0;
		}
		this.node.setStyle("top", top);
		this.node.setStyle("left", left);

		var nodeSize = this.node.getSize();
        if (!this.nodeFrame) this.createIframeNode();
        this.nodeFrame.setStyles({
			"top": top,
            "left": left,
			"width": ""+nodeSize.x+"px",
            "height": ""+nodeSize.y+"px"
		});
	},
	showIm: function(e){
		if (!this.options.disable){
			this.hide = this.hideIm.bind(this);
			if (this.fireEvent("queryShow", [e])){
				this.tmpBodyOncontextmenu = document.body.oncontextmenu;
				document.body.oncontextmenu = function(){return false;};
				if (this.pauseCount<=0){
					this.setItemWidth();
					
					this.node.setStyles({
						"display": "block",
						"opacity": this.options.opacity || 1
					});

                    if (!this.nodeFrame) this.createIframeNode();
                    this.nodeFrame.setStyles({
                        "display": "block",
                        "opacity": 0
                    });
					
					this.setPosition(e);
					
					$(document.body).removeEvent("mousedown", this.hide);
					$(document.body).addEvent("mousedown", this.hide);
					
					this.show = true;
				}else{
					this.pauseCount--;
				}
				this.fireEvent("postShow", [e]);
			}
		}
		
	},
	hideIm: function(all){
		if (this.fireEvent("queryHide")){
			$(document.body).removeEvent("mousedown", this.hide);
			this.node.set("styles", {
				"display": "none",
				"opacity": 0
			});
            if (this.nodeFrame){
                this.nodeFrame.set("styles", {
                    "display": "none",
                    "opacity": 0
                });
			}

			this.show = false;
			document.body.oncontextmenu = this.tmpBodyOncontextmenu;
			this.tmpBodyOncontextmenu = null;
			
			if (all){
                var menu = this;
                while (menu.topMenu){
                    menu = menu.topMenu;
                }
                menu.hideIm();
                //if (this.topMenu) this.topMenu.hideIm();
            } else {
                this.items.each(function(item){
                    if (item.type=="menu"){
                        item.subMenu.hideIm();
                    }
                });
            }

			this.fireEvent("postHide");
		}
	},
	createIframeNode: function(){
        if (!this.nodeFrame){
            this.nodeFrame = new Element("iframe");
            //this.nodeFrame.set("styles", this.css.container);
            this.nodeFrame.setStyles({
                "border": "0px",
                "z-index": "998",
                "margin": "0px",
                "padding": "0px",
                "position": "absolute",
                "display": "none",
                "opacity": 0
            });
        }
        //this.nodeFrame.inject(this.options.container || $(document.body));
        this.nodeFrame.inject(this.options.container || this.target);
	},
	showMenu: function(e){
		if (!this.show){
			if (this.pauseCount<=0){
				if (!this.options.disable){
					this.hide = this.hideMenu.bind(this);
					if (this.fireEvent("queryShow", [e])){
						this.tmpBodyOncontextmenu = document.body.oncontextmenu;
						document.body.oncontextmenu = function(){return false;};
						this.node.setStyle("display", "block");
                        if (!this.nodeFrame) this.createIframeNode();
                        this.nodeFrame.setStyle("display", "block");
						this.setItemWidth();
						this.setPosition(e);
						if (!this.morph){
							this.morph = new Fx.Morph(this.node, {duration: 100});
                            //this.morphFrame = new Fx.Morph(this.nodeFrame, {duration: 100});
						}

                        // this.morphFrame.start({
                        //     "opacity": this.options.opacity || 1
                        // });
						this.morph.start({
							"opacity": this.options.opacity || 1
						}).chain(function(){
							$(document).removeEvent("click", this.hide);
							$(document).addEvent("click", this.hide);
							$(document).removeEvent("mousedown", this.hide);
							$(document).addEvent("mousedown", this.hide);
							this.show = true;
							this.fireEvent("postShow");
						}.bind(this));
					}
				}
			}else{
				this.pauseCount--;
			}
		}
	},
	hideMenu: function(){
		$(document).removeEvent("click", this.hide);
		if (this.show){
			if (!this.morph){
				this.morph = new Fx.Morph(this.node, {duration: 100});
                //this.morphFrame = new Fx.Morph(this.nodeFrame, {duration: 100});
			}
			if (this.fireEvent("queryHide")){
                // this.morphFrame.start({
                //     "opacity": 0
                // });
				this.morph.start({
					"opacity": 0
				}).chain(function(){
					this.node.set("styles", {
						"display": "none"
					});
                    this.nodeFrame.set("styles", {
                        "display": "none"
                    });
					this.show = false;
					document.body.oncontextmenu = this.tmpBodyOncontextmenu;
					this.tmpBodyOncontextmenu = null;
					this.fireEvent("postHide");
				}.bind(this));
			}
		}
	},
	clearItems: function(){
		this.items.each(function(item){
			item.remove();
		});
		this.items = [];
	},
	addMenuItem: function(str, even, fun, img, disable){
		var item = new o2.widget.MenuItem(this, {
			"text": str,
			"event": even,
			"action": fun,
			"img": img,
			"disable": disable
		});
		item.load();
		this.items.push(item);
		return item;
	},
	addMenuMenu: function(str, img, menu, disable){
		var item = new o2.widget.MenuMenu(this, menu, {
			"text": str,
			"img": img,
			"disable": disable
		});
		item.load();
		this.items.push(item);
		return item;
	},
	addMenuLine: function(){
		var item = new o2.widget.MenuLine(this);
		item.load();
		this.items.push(item);
	},
	
	_loadToolbarItemNode: function(){
		var subNodes = this.node.getChildren();
		subNodes.each(function(node, idx){
			var type = node.get("MWFnodetype");
			if (type){
				if (typeOf(this[type])=="array"){
					this[type].push(node);
				}else{
					this[type] = [];
					this[type].push(node);
				}
			}
		}.bind(this));
	},


	_loadMenuItems: function(){
		this._loadToolBarSeparator(this.MWFToolBarMenuItem);
		this._loadToolBarButton(this.MWFToolBarMenuLine);
		this._loadToolBarMenu(this.MWFToolBarMenuItem);
	},
	_loadToolBarSeparator: function(nodes){
		if (nodes) {
			nodes.each(function(node, idx){
				node.set("styles", this.css.toolbarSeparator);
			}.bind(this));
		}
	},
	_loadToolBarButton: function(nodes){
		if (nodes) {
			nodes.each(function(node, idx){
				var btn =  new o2.widget.ToolbarButton(node, this);
				btn.load();
				if (btn.buttonID){
					this.items[btn.buttonID] = btn;
				}
				this.children.push(btn);
				this.childrenButton.push(btn);
			}.bind(this));
		}
	},
	_loadToolBarMenu: function(nodes){
		if (nodes) {
			nodes.each(function(node, idx){
				var btn =  new o2.widget.ToolbarMenu(node, this);
				btn.load();
				if (btn.buttonID){
					this.items[btn.buttonID] = btn;
				}
				this.children.push(btn);
				this.childrenMenu.push(btn);
			}.bind(this));
		}
	}

});

o2.widget.MenuItem = new Class({
	Implements: [Options],
	options: {
		"text": "",
		"event": "",
		"action": null,
		"img": "",
		"disable": false
	},
	initialize: function(menu, options){
		this.setOptions(options);
		this.menu = menu;
		this.type="item";
		this.createNode();
		
	},
	createNode: function(){
		this.item = new Element("div", {"styles": this.menu.css.menuItem});
		var imgDiv = new Element("div", {"styles": this.menu.css.menuItemImgDiv}).inject(this.item);
        if (this.options.img){
            if (this.options.img.substr(0,3)=="url"){
                var img = new Element("div", {"styles": this.menu.css.menuItemImg}).inject(imgDiv);
                img.setStyles({
                    "background-size": "cover",
                    "background-image": this.options.img
				});
            }else{
                var img = new Element("img", {"styles": this.menu.css.menuItemImg, "src": this.options.img}).inject(imgDiv);
            }
		}


		var separator = new Element("div", {"styles": this.menu.css.menuItemSeparator}).inject(this.item);
		this.text = new Element("div", {"styles": this.menu.css.menuItemText, "text": this.options.text}).inject(this.item);
		if (this.options.event) this.item.addEvent(this.options.event, this.doAction.bind(this));

		this.setDisable(this.options.disable);
	},
	setText: function(text){
		this.options.text = text;
		var textNode = this.item.getLast("div");
		if (textNode) textNode.set("text", text);
	},
	load: function(){
		this.item.inject(this.menu.node);
		this._addButtonEvent();
	},
	setDisable: function(flag){
		if (this.options.disable!=flag){
			this.options.disable = flag;
			if (flag){
				this.item.set("styles", this.menu.css.menuItemDisable);
				var img = this.item.getElement("img");
				if (img){
					var src = img.get("src");
					//src = src.substr(0, src.lastIndexOf("."));

					if (src.substr(0,5) != "data:"){
                        var i = src.lastIndexOf(".");
                        srcLeft = src.substr(0, i);
                        srcRight = src.substr(i, src.length-i);
                        src = srcLeft+"_gray"+srcRight;
                        //src = src.replace(i, "_gray.");
                        img.set("src", src);
                    }
				}
			}else{
				this.item.set("styles", this.menu.css.menuItem);
				var img = this.item.getElement("img");
				if (img){
					var src = img.get("src");
                    if (src.substr(0,5) != "data:"){
                        src = src.replace("_gray", "");
                        img.set("src", src);
                    }
				}
			}
		}
	},

	_addButtonEvent: function(){
		this.item.addEvent("mouseover", this._menuItemMouseOver.bind(this));
		this.item.addEvent("mouseout", this._menuItemMouseOut.bind(this));
		this.item.addEvent("mousedown", this._menuItemMouseDown.bind(this));
		this.item.addEvent("mouseup", this._menuItemMouseUp.bind(this));
		//this.item.addEvent("click", this.doAction.bind(this));
	},
	_menuItemMouseOver: function(e){
		this.menu.items.each(function(item){
			if (item!=this) if (item.type!="line")	if (!item.options.disable){item._menuItemMouseOut(e);};
		}.bind(this));
		if (!this.options.disable){this.item.set("styles", this.menu.css.menuOver); this.menu.current = this;};
	},
	_menuItemMouseOut: function(e){
		if (!this.options.disable){this.item.set("styles", this.menu.css.menuOut);};
	},
	_menuItemMouseDown: function(e){
		if (!this.options.disable){this.item.set("styles", this.menu.css.menuDown);};
		e.stopPropagation();
	},
	_menuItemMouseUp: function(e){
		if (!this.options.disable){this.item.set("styles", this.menu.css.menuUp);};
	},
	doAction: function(e){
		if (!this.options.disable){
			if (this.options.action){
				this.options.action.apply(this, [e]);
			}
			this.menu.hideIm(true);
		}
	},
	remove: function(){
		this.item.destroy();
	}
});

o2.widget.MenuLine = new Class({
	initialize: function(menu, options){
		this.type="line";
		this.menu = menu;
		this.createNode();
	},
	createNode: function(){
		this.item = new Element("div", {"styles": this.menu.css.menuLine});
	},
	load: function(){
		this.item.inject(this.menu.node);
	},
	remove: function(){
		this.item.destroy();
	},
	setDisable: function(){}
});

o2.widget.MenuMenu = new Class({
	Implements: [Options],
	Extends: o2.widget.MenuItem,

	initialize: function(menu, submenu, options){
		//this.setOptions(options);

		this.subMenu = submenu;
		this.parent(menu, options);
		this.subMenu.topMenu = this.menu;
		this.type="menu";
		
		this.createIcon();
		
		this.subMenu.setPosition = function(){
			this.setPosition();
		}.bind(this);
	},
	createIcon: function(){
		var icon = new Element("div", {"styles": this.menu.css.menuItemSubmenuIcon});
		icon.inject(this.text, "before");
		this.text.setStyle("margin-right", "16px");
	},
	_menuItemMouseOver: function(e){
		this.menu.items.each(function(item){
			if (item!=this) if (item.type!="line")	if (!item.options.disable){item._menuItemMouseOut(e);};
		}.bind(this));
		if (!this.options.disable){this.item.set("styles", this.menu.css.menuOver); this.menu.current = this;};
		this.subMenu.showIm();
	},
	_menuItemMouseOut: function(e){
		if (e.event.toElement!=this.subMenu.node && !this.subMenu.node.contains(e.event.toElement)){
			if (!this.options.disable){this.item.set("styles", this.menu.css.menuOut);};
			this.subMenu.hideIm();
		}
	},
	
	setPosition: function(e){
		var top;
		var left;
		
		var position = this.item.getPosition();
		var size = this.item.getSize();
        this.subMenu.node.setStyle("display", "block");
		var menuSize = this.subMenu.node.getSize();

		var bodyNode = this.subMenu.node.getOffsetParent();
		//var bodySize = $(document.body).getSize();
        var bodySize = bodyNode.getSize();
		
		top = position.y;
		left = (position.x.toFloat()) + (size.x.toFloat())-3;
		if ((left.toFloat()) + (menuSize.x.toFloat())>bodySize.x){
			left = (position.x.toFloat()) - (menuSize.x.toFloat())+8;
		}
		
		//var scrollTop = ($(document.body).getScroll().y.toFloat()) || 0;
        var scrollTop = (bodyNode.getScroll().y.toFloat()) || 0;

		if (top+menuSize.y>bodySize.y+scrollTop){
			top = top-menuSize.y + size.y+3;
			if (top<0) top = 0;
		}
		
		if (this.subMenu.options.offsetX) left = left + this.subMenu.options.offsetX;
		if (this.subMenu.options.offsetY) top = top + this.subMenu.options.offsetY;
			
		var zIndex = this.menu.node.getStyle("z-index");
		this.subMenu.node.setStyle("z-index", zIndex+1);
		this.subMenu.node.setStyle("top", top);
		this.subMenu.node.setStyle("left", left);
	}
	
});










o2.widget = o2.widget || {};
o2.widget.Toolbar = new Class({
	Implements: [Options, Events],
    Extends: o2.widget.Common,
	options: {
		"style": "default"
	},
	initialize: function(container, options, bindObject){
		this.setOptions(options);
		this.bindObject = bindObject;

		this.items = {};
		this.children = [];
		this.childrenButton = [];
		this.childrenMenu = [];

		this.path = o2.session.path+"/widget/$Toolbar/";
		this.cssPath = o2.session.path+"/widget/$Toolbar/"+this.options.style+"/css.wcss";
		this._loadCss();

		this.node = $(container);
		this.node.onselectstart = function (){return false;};
		this.node.oncontextmenu = function (){return false;};

	},
	load: function(){
        if (this.fireEvent("queryLoad")){
            this.node.set("styles", this.css.container);

            this._loadToolbarItemNode();
            this._loadToolbarItems();
            this.fireEvent("postLoad");
        }
    },
	_loadToolbarItemNode: function(){
		var subNodes = this.node.getChildren();
		subNodes.each(function(node, idx){
			var type = node.get("MWFnodetype");
			if (type){
				if (typeOf(this[type])=="array"){
					this[type].push(node);
				}else{
					this[type] = [];
					this[type].push(node);
				}
			}
		}.bind(this));
	},


	_loadToolbarItems: function(){
		this._loadToolBarSeparator(this.MWFToolBarSeparator);
		this._loadToolBarButton(this.MWFToolBarButton);
        this._loadToolBarOnOffButton(this.MWFToolBarOnOffButton);
		this._loadToolBarMenu(this.MWFToolBarMenu);
	},
	_loadToolBarSeparator: function(nodes){
		if (nodes) {
			nodes.each(function(node, idx){
				node.set("styles", this.css.toolbarSeparator);
			}.bind(this));
		}
	},
	_loadToolBarButton: function(nodes){
		if (nodes) {
			nodes.each(function(node, idx){
				var btn =  new o2.widget.ToolbarButton(node, this, this.options);
				btn.load();
				this.fireEvent("buttonLoad", [btn]);
				if (btn.buttonID){
					this.items[btn.buttonID] = btn;
				}
				this.children.push(btn);
				this.childrenButton.push(btn);
			}.bind(this));
		}
	},
    _loadToolBarOnOffButton: function(nodes){
        if (nodes) {
            nodes.each(function(node, idx){
                var btn =  new o2.widget.ToolbarOnOffButton(node, this, this.options);
                btn.load();
                this.fireEvent("buttonLoad", [btn]);
                if (btn.buttonID){
                    this.items[btn.buttonID] = btn;
                }
                this.children.push(btn);
                this.childrenButton.push(btn);
            }.bind(this));
        }
    },
	_loadToolBarMenu: function(nodes){
		var _self = this;
		if (nodes) {
			nodes.each(function(node, idx){
				var btn =  new o2.widget.ToolbarMenu(node, this, {
					"onAddMenuItem": function(item){
						this.fireEvent("addMenuItem", [item]);
					}.bind(this),
					"onMenuQueryShow": function(menu){
						_self.fireEvent("menuQueryShow", [this, menu]);
					},
					"onMenuPostShow": function(menu){
						_self.fireEvent("menuPostShow", [this, menu]);
					},
					"onMenuQueryHide": function(menu){
						_self.fireEvent("menuQueryHide", [this, menu]);
					},
					"onMenuPostHide": function(menu){
						_self.fireEvent("menuPostHide", [this, menu]);
					},
					"onLoad": function(menu){
						_self.fireEvent("menuLoaded", [this, menu]);
					}
				});
				btn.load();
				this.fireEvent("menuLoad", [btn]);
				if (btn.buttonID){
					this.items[btn.buttonID] = btn;
				}
				this.children.push(btn);
				this.childrenMenu.push(btn);
			}.bind(this));
		}
	}

});

o2.widget.ToolbarButton = new Class({
	Implements: [Options, Events],
	options: {
		"text": "",
		"title": "",
		"pic": "",
		"action": "",
        "actionScript": "",
		"disable": false,
		"hide": false
	},
	initialize: function(node, toolbar, options){
		this.setOptions(options);
		this.node = $(node);
		this.toolbar = toolbar;
		this.buttonID = this.node.get("MWFnodeid") || this.node.get("id");

		if (!this.node){
			this.node = new Element("div").inject(this.toolbar.node);
		}else{
			var buttonText = this.node.get("MWFButtonText");
			if (buttonText) this.options.text = buttonText;
			
			var title = this.node.get("title");
			if (title) this.options.title = title;
			
			var buttonImage = this.node.get("MWFButtonImage");
			if (buttonImage) this.options.pic = buttonImage;

			var buttonImageOver = this.node.get("MWFButtonImageOver");
			if (buttonImageOver) this.options.pic_over = buttonImageOver;

			var buttonDisable = this.node.get("MWFButtonDisable");
			if (buttonDisable) this.options.disable = true;
			
			var buttonAction = this.node.get("MWFButtonAction");
			if (buttonAction) this.options.action = buttonAction;

			var buttonHide = this.node.get("MWFHide");
			this.options.hide = !!buttonHide;

            //var buttonActionScript = this.node.get("MWFButtonActionScript");
            //if (buttonActionScript) this.options.actionScript = buttonActionScript;
		}

		this.modifiyStyle = true;
	},
	load: function(){
		this._addButtonEvent();
		this.node.title = this.options.title;
		this.node.set("styles", this.toolbar.css.button);

		if (this.options.pic) this.picNode = this._createImageNode(this.options.pic);
		if (this.options.text) this.textNode = this._createTextNode(this.options.text);

		this.setDisable(this.options.disable);
		this.setHide(this.options.hide);
	},
	hide: function(){
		this.node.hide();
		this.options.hide = true;
	},
	show: function(){
		this.node.show();
		this.options.hide = false;
	},
	setHide: function(flag){
		if (flag){
			this.hide();
		}else{
			this.show();
		}
	},
	enable: function(){
		if (this.options.disable){
			this.setDisable(false);
			this.options.disable = false;
		}
	},
	disable: function(){
		if (!this.options.disable){
			this.setDisable(true);
			this.options.disable = true;
		}
	},
	setDisable: function(flag){
		if (flag){
			if (!this.options.disable){
                this.options.disable = true;
                this.node.set("styles", this.toolbar.css.buttonDisable);
                if (this.picNode){
                    this.picNode.set("styles", this.toolbar.css.buttonImgDivDisable);
                    var img = this.picNode.getElement("img");
                    var src = img.get("src");
                    var ext = src.substr(src.lastIndexOf("."), src.length);
                    src = src.substr(0, src.lastIndexOf("."));
                    src = src+"_gray"+ext;
                    img.set("src", src);
                }
                if (this.textNode) this.textNode.set("styles", this.toolbar.css.buttonTextDivDisable);
			}
		}else{
            if (this.options.disable){
                this.options.disable = false;
                this.node.set("styles", this.toolbar.css.button);
                if (this.picNode){
                    this.picNode.set("styles", this.toolbar.css.buttonImgDiv);
                    var img = this.picNode.getElement("img");
                    var src = img.get("src");
                    src = src.replace("_gray", "");
                    img.set("src", src);
                }
                if (this.textNode) this.textNode.set("styles", this.toolbar.css.buttonTextDiv);
            }
		}
	},
	_createImageNode: function(src){
		if (src){
			var div = new Element("span", {"styles": this.toolbar.css.buttonImgDiv}).inject(this.node);
			var img = this.imgNode = new Element("img", {
				"styles": this.toolbar.css.buttonImg,
				"src": src
			}).inject(div);
			return div;
		}else{
			return null;
		}
	},
	_createTextNode: function(text){
		if (text){
			var div = new Element("span", {
				"styles": this.toolbar.css.buttonTextDiv,
				"text": text
			}).inject(this.node);
			return div;
		}else{
			return null;
		}
	},
	setText: function(text){
        this.node.getLast().set("text", text);
	},

	_addButtonEvent: function(){
		this.node.addEvent("mouseover", this._buttonMouseOver.bind(this));
		this.node.addEvent("mouseout", this._buttonMouseOut.bind(this));
		this.node.addEvent("mousedown", this._buttonMouseDown.bind(this));
		this.node.addEvent("mouseup", this._buttonMouseUp.bind(this));
		this.node.addEvent("click", this._buttonClick.bind(this));
	},
	_buttonMouseOver: function(){
		if (this.modifiyStyle) if (!this.options.disable){this.node.set("styles", this.toolbar.css.buttonOver);};
		if( this.options.pic_over )if (!this.options.disable && this.imgNode){this.imgNode.set("src", this.options.pic_over);};
	},
	_buttonMouseOut: function(){
		if (this.modifiyStyle) if (!this.options.disable){this.node.set("styles", this.toolbar.css.buttonOut);};
		if( this.options.pic_over )if (!this.options.disable && this.imgNode){this.imgNode.set("src", this.options.pic);};
	},
	_buttonMouseDown: function(){
		if (this.modifiyStyle) if (!this.options.disable){this.node.set("styles", this.toolbar.css.buttonDown);};
	},
	_buttonMouseUp: function(){
		if (this.modifiyStyle) if (!this.options.disable){this.node.set("styles", this.toolbar.css.buttonUp);};
	},
	_buttonClick: function(e){

		if (!this.options.disable){
			if (this.options.action){
				if (typeOf(this.options.action)==="string"){
                    var tmparr = this.options.action.split(":");
                    var action = tmparr.shift();
                    var bindObj = (this.toolbar.bindObject) ? this.toolbar.bindObject : window;

                    if (bindObj[action]){
                        tmparr.push(this);
                        tmparr.push(e);
                        bindObj[action].apply(bindObj,tmparr);
                    }else{
                        if (window[action]){
                            window[action].apply(this,tmparr);
                        }
                    }
				}else{
                    this.options.action();
				}
			}
		}
	}
});

o2.widget.ToolbarOnOffButton = new Class({
    Implements: [Options, Events],
    Extends: o2.widget.ToolbarButton,

	on: function(){
        if (this.status !== "on"){
            if (!this.options.disable){this.node.set("styles", this.toolbar.css.buttonDown);}
            this.modifiyStyle = false;
            this.status = "on";
            if (this.textNode) this.textNode.set("styles", this.toolbar.css.buttonTextDivDown);
		}
	},
	off: function(){
        if (this.status === "on"){
            if (!this.options.disable){this.node.set("styles", this.toolbar.css.buttonOut);}
            this.modifiyStyle = true;
            this.status = "off";
            if (this.textNode) this.textNode.set("styles", this.toolbar.css.buttonTextDiv);
        }
	},
    _buttonClick: function(e){
    	if (this.status === "on"){
            if (!this.options.disable){this.node.set("styles", this.toolbar.css.buttonOut);}
            this.modifiyStyle = true;
            this.status = "off";
            if (this.textNode) this.textNode.set("styles", this.toolbar.css.buttonTextDiv);
		}else{
            if (!this.options.disable){this.node.set("styles", this.toolbar.css.buttonDown);}
            this.modifiyStyle = false;
            this.status = "on";
            if (this.textNode) this.textNode.set("styles", this.toolbar.css.buttonTextDivDown);
		}
        if (!this.options.disable){
            if (this.options.action){
                if (typeOf(this.options.action)==="string"){
                    var tmparr = this.options.action.split(":");
                    var action = tmparr.shift();
                    var bindObj = (this.toolbar.bindObject) ? this.toolbar.bindObject : window;
                    tmparr.push(this.status);
                    tmparr.push(this);

                    if (bindObj[action]){
                        tmparr.push(this);
                        tmparr.push(e);
                        bindObj[action].apply(bindObj,tmparr);
                    }else{
                        if (window[action]){
                            window[action].apply(this,tmparr);
                        }
                    }
                }else{
                    this.options.action();
                }
            }
        }
    }
});



o2.widget.ToolbarMenu = new Class({
	Implements: [Options, Events],
	Extends: o2.widget.ToolbarButton,

	initialize: function(node, toolbar, options){
		this.parent(node, toolbar, options);
		this.modifiyStyle = true;
		this.menu = null;
        this.buttonID = this.node.get("MWFnodeid") || this.node.get("id");
	},
	setDisable: function(flag){
		if (this.menu) this.menu.options.disable = flag;
		if (flag){
			this.node.set("styles", this.toolbar.css.buttonDisable);
			if (this.picNode){
				this.picNode.set("styles", this.toolbar.css.buttonImgDivDisable);
				var img = this.picNode.getElement("img");
				var src = img.get("src");
				
				var ext = src.substr(src.lastIndexOf("."), src.length);
				src = src.substr(0, src.lastIndexOf("."));
				src = src+"_gray"+ext;
				
			//	src = src.substr(0, src.lastIndexOf("."));
			//	src = src+"_gray.gif";
				img.set("src", src);
			}
			if (this.textNode) this.textNode.set("styles", this.toolbar.css.buttonTextDivDisable);
		}else{
			this.node.set("styles", this.toolbar.css.button);
			if (this.picNode){
				this.picNode.set("styles", this.toolbar.css.buttonImgDiv);
				var img = this.picNode.getElement("img");
				var src = img.get("src");
				src = src.replace("_gray", "");
				img.set("src", src);
			}
			if (this.textNode) this.textNode.set("styles", this.toolbar.css.buttonTextDiv);
		}
	},
	load: function(){

		this._addButtonEvent();
		this.node.title = this.options.title;
		this.node.set("styles", this.toolbar.css.button);

		if (this.options.pic) this.picNode = this._createImageNode(this.options.pic);
		if (this.options.text) this.textNode = this._createTextNode(this.options.text);
		
		this._createDownNode();

		var toolbarMenu = this;
		o2.require("o2.widget.Menu", function(){
			this.menu = new o2.widget.Menu(this.node, {
				"style": this.toolbar.options.style,
				"bindObject": this.options.bindObject,
				"event": "click",
				"disable": toolbarMenu.options.disable,
				"onQueryShow": function(){
					var p = toolbarMenu.node.getPosition(toolbarMenu.node.getOffsetParent());
					var s = toolbarMenu.node.getSize();
					this.setOptions({
						"top": p.y+s.y-2,
						"left": p.x
					});
					toolbarMenu.fireEvent("menuQueryShow", [this]);
					return true;
				},
				"onPostShow": function(){
					var p = toolbarMenu.node.getPosition(toolbarMenu.node.getOffsetParent());
					var s = toolbarMenu.node.getSize();
					toolbarMenu.node.set("styles", {
						"background-color": this.node.getStyle("background-color"),
						"border-top": this.node.getStyle("border-top"),
						"border-right": this.node.getStyle("border-top"),
						"border-left": this.node.getStyle("border-top"),
						"border-bottom": "0"
					});
					toolbarMenu.modifiyStyle = false;

					toolbarMenu.tmpStyleNode = new Element("div.MWFtmpStyleNode",{
						"styles":{
							"position":"absolute",
							"top": p.y+s.y-2,
							"left": p.x+1,
							"width": s.x-2,
							"z-index": this.node.getStyle("z-index")+1,
							"background-color": this.node.getStyle("background-color"),
							"height": "1px",
							"overflow": "hidden"
						}
					}).inject(toolbarMenu.node);

					toolbarMenu.fireEvent("menuPostShow", [this]);
				},
				"onQueryHide": function(){
					toolbarMenu.fireEvent("menuQueryHide", [this]);
				},
				"onPostHide": function(){
					toolbarMenu.node.set("styles", toolbarMenu.toolbar.css.button);
					toolbarMenu.modifiyStyle = true;
					if (toolbarMenu.tmpStyleNode) toolbarMenu.tmpStyleNode.destroy();
					toolbarMenu.fireEvent("menuPostHide", [this]);
				}
			});
			this.menu.load();
			this.fireEvent("load", [this.menu]);
			this.addMenuItems();
		}.bind(this));

		this.setDisable(this.options.disable);

	},
	_createDownNode: function(){
		var spanNode = new Element("div",{
			"styles": this.toolbar.css.toolbarButtonDownNode
		}).inject(this.node);
		spanNode.set("html", "<img src=\""+o2.session.path+"/widget/$Toolbar/"+this.toolbar.options.style+"/downicon.gif"+"\" />");
		return spanNode;
	},
	addMenuItems: function(){
		var els = this.node.getChildren();
		els.each(function(node, idx){
			var type = node.get("MWFnodetype");
			if (type=="MWFToolBarMenuItem"){
				this._loadMenuItem(node);
			}
			if (type=="MWFToolBarMenuLine"){
				this._loadMenuLine(node);
			}
		}.bind(this));
	},
	_loadMenuItem: function(node){
		var toolBarMenu = this;
		var item = this.menu.addMenuItem(node.get("MWFButtonText"),"click",function(e){toolBarMenu._menuItemClick(node.get("MWFButtonAction"), e, this);}, node.get("MWFButtonImage"), node.get("MWFButtonDisable"));
		this.fireEvent("addMenuItem", [item]);
	},

	_menuItemClick: function(itemAction, e, item){
		if (itemAction){
			var tmparr = itemAction.split(":");
			var action = tmparr.shift();
			var bindObj = (this.toolbar.bindObject) ? this.toolbar.bindObject : window;
			if (bindObj[action]){
				tmparr.push(this);
                tmparr.push(e);
                tmparr.push(item);
				bindObj[action].apply(bindObj,tmparr);
				this.menu.hideMenu();
			}else{
				if (window[action]){
					window[action].apply(this,tmparr);
					this.menu.hideMenu();
				}
			}
		}
	},

	_loadMenuLine: function(){
		this.menu.addMenuLine();
	}

});

o2.xDesktop = o2.xDesktop || {};
o2.xd = o2.xDesktop;
o2.xDesktop.requireApp = function(module, clazz, callback, async){
    o2.requireApp(module, clazz, callback, async)
};
o2.xApplication = o2.xApplication || {};

MWF.xDesktop.loadConfig = function(callback){
    o2.JSON.get("res/config/config.json", function(config) {
        if (config.proxyCenterEnable){
            if (o2.typeOf(config.center)==="array"){
                config.center.forEach(function(c){
                    c.port = window.location.port;
                });
            }else{
                config.port = window.location.port;
            }
        }
        layout.config = config;
        if (layout.config.app_protocol === "auto") {
            layout.config.app_protocol = window.location.protocol;
        }
        layout.config.systemName = layout.config.systemName || layout.config.footer;
        layout.config.systemTitle = layout.config.systemTitle || layout.config.title;
        if (callback) callback();
    });
};
MWF.xDesktop.getService = function(callback) {
    MWF.xDesktop.getServiceAddress(layout.config, function(service, center){
        layout.serviceAddressList = service;
        layout.centerServer = center;
        if (callback) callback();
    });
};
MWF.xDesktop.loadService = function(callback){
    MWF.xDesktop.loadConfig(function(){
        MWF.xDesktop.getService(callback);
    });
};

MWF.xDesktop.checkLogin = function(loginFun){
    layout.authentication = new MWF.xDesktop.Authentication({
        "onLogin": loginFun
    });
    layout.authentication.isAuthenticated(function(json){
        layout.session.user = json.data;
        if (loginFun) loginFun();
    }.bind(this), function(){
        layout.authentication.loadLogin(this.node);
    });
};

MWF.xDesktop.getDefaultLayout = function(callback){
    MWF.UD.getPublicData("defaultLayout", function(json) {
        if (json) layout.defaultLayout = json;
        if (callback) callback();
    }.bind(this));
},
MWF.xDesktop.getUserLayout = function(callback){
    MWF.UD.getPublicData("forceLayout", function(json) {
        var forceStatus = null;
        if (json) forceStatus = json;
        debugger;
        MWF.UD.getDataJson("layout", function(json) {
            if (json) {
                layout.userLayout = json;
                if( !layout.userLayout.flatStyle )layout.userLayout.flatStyle = layout.config.defaultSkin;
                if( !layout.userLayout.apps )layout.userLayout.apps = {};
                if (forceStatus) layout.userLayout.apps = Object.merge(layout.userLayout.apps, forceStatus.apps);
                if (callback) callback();
            }else{
                MWF.UD.getPublicData("defaultLayout", function(json) {
                    layout.userLayout = json || {};
                    // if( !layout.userLayout.flatStyle )
                        layout.userLayout.flatStyle = layout.config.defaultSkin || 'blue';
                    if( !layout.userLayout.apps )layout.userLayout.apps = {};
                    if (forceStatus) layout.userLayout.apps = Object.merge(layout.userLayout.apps, forceStatus.apps);
                    if (callback) callback();
                }.bind(this));
            }
        }.bind(this));
    }.bind(this));
},

MWF.xDesktop.notice = function(type, where, content, target, offset, option){
    if (!where) where = { "x": "right", "y": "top" };
    if (!type) type = "ok";
    var noticeTarget = target || layout.desktop.desktopNode || document.body;

    var off = offset;
    if (!off){
        off = {
            x: 10,
            y: where.y.toString().toLowerCase()=="bottom" ? 10 : 10
        };
    }

    var options = {
        type: type,
        position: where,
        move: false,
        target: noticeTarget,
        offset: off,
        content: content
    };
    if( option && typeOf(option) === "object" ){
        options = Object.merge( options, option );
    }
    new mBox.Notice(options);
};
MWF.xDesktop.loadPortal =  function(portalId, parameters, isLoginPage){
    layout.openApplication(null, "portal.Portal", {
        "portalId": portalId,
        "parameters": parameters,
        "isLoginPage": isLoginPage,
        "onAfterModulesLoad": function(){
            var layoutNode = $("layout");
            if (layoutNode) layoutNode.setStyles({
                "position": "absolute",
                "width": "100%",
                "z-index": 100,
                "top": "0px",
                "left": "0px"
            }).fade("out");
            var appContentNode = $("appContent");
            if (appContentNode) appContentNode.setStyles({
                "position": "absolute",
                "width": "100%",
                "top": "0px",
                "opacity": 0,
                "left": "0px"
            }).fade("in");
        }
    }, null, true);
};
MWF.name = {
    "cns": function(names){
        if( typeOf(names) !== "array" )return [];
        var n = [];
        names.each(function(v){
            n.push(this.cn(v));
        }.bind(this));
        return n;
    },
    "cn": function(name){
        if (!name) return "";
        var idx = name.indexOf("@");
        return (idx!==-1) ? name.substring(0, idx) : name;
    },
    "ou": function(name){
        if (!name) return "";
        var idx = name.indexOf("@");
        var lastIdx = name.lastIndexOf("@");
        if (idx===-1){
            return name;
        }else if (lastIdx===idx){
            return "";
        }else{
            return name.substring(idx+1, lastIdx);
        }
    },
    "flag": function(name){
        if (!name) return "";
        var lastIdx = name.lastIndexOf("@");
        if (lastIdx===-1){
            return "";
        }else{
            return name.substring(lastIdx+1, name.length);
        }
    },
    "type": function(name){
        if (!name) return "";
        var lastIdx = name.lastIndexOf("@");
        if (lastIdx===-1){
            return "";
        }else{
            return name.substring(lastIdx+1, name.length);
        }
    }
};
MWF.xDesktop.confirm = function(type, e, title, text, width, height, ok, cancel, callback, mask, style){
    MWF.require("MWF.xDesktop.Dialog", function(){
        var container = layout.desktop.node || $(document.body);
        var size = container.getSize();
        var x = 0;
        var y = 0;

        if (typeOf(e)=="element"){
            var position = e.getPosition(container);
            x = position.x;
            y = position.y;
        }else{
            if (Browser.name=="firefox"){
                x = parseFloat(e.event.clientX);
                y = parseFloat(e.event.clientY);
            }else{
                x = parseFloat(e.x || e.event.x);
                y = parseFloat(e.y || e.event.y);
            }

            if (e.target){
                var position = e.target.getPosition(container);
                x = position.x;
                y = position.y;
            }
            //    }
        }

        if (x+parseFloat(width)>size.x){
            x = x-parseFloat(width);
        }
        if (x<0) x = 0;
        if (y+parseFloat(height)>size.y){
            y = y-parseFloat(height);
        }
        if (y<0) y = 0;

        var ctext = "";
        var chtml = "";
        if (typeOf(text).toLowerCase()=="object"){
            ctext = text.text;
            chtml = text.html;
        }else{
            ctext = text;
        }
        var dlg = new MWF.xDesktop.Dialog({
            "title": title,
            "style": style || "o2",
            "top": y,
            "left": x-20,
            "fromTop":y,
            "fromLeft": x-20,
            "width": width,
            "height": height,
            "text": ctext,
            "html": chtml,
            "container": MWF.xDesktop.node,
            "maskNode": mask,
            "buttonList": [
                {
                    "type": "ok",
                    "text": MWF.LP.process.button.ok,
                    "action": ok
                },
                {
                    "type": "cancel",
                    "text": MWF.LP.process.button.cancel,
                    "action": cancel
                }
            ]
        });

        switch (type.toLowerCase()){
            case "success":
                dlg.content.setStyle("background-image", "url(data:image/png;base64,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)");
                break;
            case "error":
                dlg.content.setStyle("background-image", "url(data:image/png;base64,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)");
                break;
            case "info":
                dlg.content.setStyle("background-image", "url(data:image/png;base64,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)");
                break;
            case "warn":
                dlg.content.setStyle("background-image", "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABgtJREFUeNqsWG2IlFUUft6vmdlZd539GFdTY5VMomy1oBJUSPLXkmQt5I8gCIMK+iH0K4ooEvtTRP7JX9JKWCC1mUUkIkQKSoaZH60t2pboOK37Mc6Ozsw779t57t5xx5ndnTvhC4d373nnnnPuOeee85y1Jr+G6dNcCrBB6AnbQo9tY4UFLLYstIYhMsK/IjRULOF0voATx87jp60fICPygzmFbpn+26pnzK0ilrk2+kTp5kgC6+w4YDfJxpiQJ+QAYUmoKHQLCG4K5YDsCI7fzOPgcBr7172BP0VUILrC/22MnHSbvF6KLcRap1WMmGfsRQRZ2Z8BJv7BybEs9t6/DbuFXaj2VKUx7ize6BZvbHcdvB67D5bdrD/ocwUiruiLZPFGSbziiHci4iVPpEn41MM9pPZWPBofwiOX9uDh05fwkSgf5Dln8lKNZwo+HnRsvBVbjK1eJ39RdWIxJCfhGB0HxjNTBtGQhHiuPQHEY9MG3X5EbXEESA3i4KmL2Ln5Xfwi3CINmjVM9IjnYGeTGOJ2zOx+SU5cE8Hp/DMIopvgxFejlDsFO38IC6ID6JIDRCMz7/WvA1cG8d2PJ/H2y5/gLA2a9ndVmBia2CIxpL3yJ1XG5MUzTh8S3e/B9Zo09x74xSeRS7vyfT+i3sx7KXfRCvSuz2NUltuFJmhj+btdmazMEa+NsZidfIYlsQXzE51oa2tDV1eXenNNPr/PtZ/ylybxwtEP8Ypw4pU22OXrq27NvZIh4dzCeI07lvQiHo8jFovBdV315pp8fp9rP+VTT/cCPL/jRawSTqScma4OT1+sA2vtqN4w552V03meMsKyprLblowlj2s/qC+DepJLsWpjD56T5aDOnRI908yC5jTVOVEl1THWhKhPwrVx/UNYqL0DmyU+0iyVNWooKKxjTGgmh/o6k+h5tRcbhBNTDla9JtKAV+6SZ5RBondZF9YwOkKOq5qeZ6CkUpmJMQYP9Xa0YqX8ySRxXdV9bXMBloShnLg134RvhQ3IEr2tTViqc8ZxNQwwFuCJANsqiOJ4jSHke40cTPQ2RdFZNsYmHrEaiHVEmqI/drTGO+paC5/fTWVRghTaZl1ibJvAqG6hqqygIsG+/iXCID8VFk1ck+9Z5rKoV8BYThc9yyVCE2A0nyDJKOmEoiP98GV7mNwKO7EOwfjPwL9fKL7q2CUzWTRGANiILgghjRkKfTwAyxw4cWt4pR+F4X72NAn2FIxQzg4aECMtcmISl3WzDFxi1sDH046hZ4JQ45kbgmeyFXhGUGB7i8YzhgcTvbg2jiHCKPrTJXgmE56ZgKIoH5XGn/YEz3QLnpm/GrcmTiE9dkiOOaBuU9QzN+bsMM7dNoYo/qk1OC597vEahDbDU5BtuVbBMysr8ExS45lBV74LnjHwMhFjahRndn2rUN9NhsrmOEEUX/LNbgB/F13yLBJtyTvwDNfkNyLnj8s4dv5vBbQmVdcmWuc4IYl0MjC44jz0guWb0NLSojAMoQTfXJPvGNQs6hGvnNt7GIeFkyGk4hcVGM41HCcEZIV1ix53jJ+QieDOWKi18CN2fWOo58QF/PD5ETVPZXTO3IZ8Aeea9Dj2FOt4R7WDq1L0SlVFT9bke3WMofzf/8I3fTvwlXAYomy5IChj9AxT4FyTmsBBPyyXoVpSRe9qP8LfXkNw7ZAaIfnmmnwbs++l3AspHPl4APuEw2I3pr0S1owqMsO4B97BYz3L8eaiFvR6uHsPceWFNI7s/h6f7TqgblBq1umgPCRwwOJcc3EEe3NsOXN4yYRUkRQ5vw5j4P19+FQbkha6Ud04aiZK8Y6lS2ALxwmi+GQcqxyGKDT3RCBSSkKpLM4xWXWOjGi6UXeirDKI1yXOcYIonuC5s1lQoTbKKlPZCdYUBZpSGZxhHeH11bdmVOdIrnLWNv4vhPzQ1sBnHlE8wTMxK6EiERqBEfEIYQC7L5seew1LPCurLmgZTdl6/4UwaWmWzq2IRvHNGrNGNLmYdpCvb0dBl/hJXdAKJrOF1eClsHX4XP12NM+qGFJKmnz9NgYV/wkwAMYATK0QLuhAAAAAAElFTkSuQmCC)");
                break;
            default:
            //dlg.content.setStyle("background-image", "");
        }
        dlg.show();
        if (callback) callback(dlg);
    }.bind(this));
};
MWF.xDesktop.getImageSrc = function( id ){
    if (layout.config.app_protocol=="auto"){
        layout.config.app_protocol = window.location.protocol;
    }

    var addressObj = layout.serviceAddressList["x_file_assemble_control"];
    if (addressObj){
        var address = layout.config.app_protocol+"//"+addressObj.host+((!addressObj.port || addressObj.port==80) ? "" : ":"+addressObj.port)+addressObj.context;
    }else{
        var host = layout.config.center.host || window.location.hostname;
        var port = layout.config.center.port;
        var address = layout.config.app_protocol+"//"+host+((port || port=="80") ? "" : ":"+port)+"/x_file_assemble_control";
    }
    var url = "/jaxrs/file/"+id+"/download/stream";
    return o2.filterUrl(address+url);
};
MWF.xDesktop.setImageSrc = function(){
    if( !event )return;
    var obj = event.srcElement ? event.srcElement : event.target;
    if( !obj )return;
    obj.onerror = null;
    var id = obj.get("data-id");
    if( id )obj.set("src" , MWF.xDesktop.getImageSrc(id) );
};
MWF.xDesktop.uploadImage = function( reference, referencetype, formData, file, success, failure ){
    this.action = new MWF.xDesktop.Actions.RestActions("/xDesktop/Actions/action.json", "x_file_assemble_control");
    this.action.invoke({
        "name": "uploadImage",
        "parameter": {"reference" : reference, "referencetype": referencetype},
        "data": formData,
        "file": file,
        "success": success,
        "failure": failure
    });
};
MWF.xDesktop.uploadImageByScale = function( reference, referencetype, scale, formData, file, success, failure ){
    this.action = new MWF.xDesktop.Actions.RestActions("/xDesktop/Actions/action.json", "x_file_assemble_control");
    this.action.invoke({
        "name": "uploadImageByScale",
        "parameter": {"reference" : reference, "referencetype": referencetype, "scale" : scale || 0},
        "data": formData,
        "file": file,
        "success": success,
        "failure": failure
    });
};
MWF.xDesktop.copyImage = function( reference, referencetype, attachmentId, scale, success, failure ){
    this.action = new MWF.xDesktop.Actions.RestActions("/xDesktop/Actions/action.json", "x_file_assemble_control");
    this.action.invoke({
        "name": "copyImage",
        "parameter": {"reference" : reference, "referencetype": referencetype, "attachmentId" : attachmentId, "scale":scale || 0 },
        "success": success,
        "failure": failure
    });
};
MWF.xDesktop.getPortalFileUr = function(id, app){
    var root = "x_portal_assemble_surface";
    var url = MWF.Actions.getHost(root)+"/"+root+MWF.Actions.get(root).action.actions.readFile.uri;
    url = url.replace("{flag}", id);
    url = url.replace("{applicationFlag}", app);
    return url
};
MWF.xDesktop.getProcessFileUr = function(id, app){
    var root = "x_processplatform_assemble_surface";
    var url = MWF.Actions.getHost(root)+"/"+root+MWF.Actions.get(root).action.actions.readFile.uri;
    url = url.replace("{flag}", id);
    url = url.replace("{applicationFlag}", app);
    return url
};
MWF.xDesktop.getCMSFileUr = function(id, app){
    var root = "x_cms_assemble_control";
    var url = MWF.Actions.getHost(root)+"/"+root+MWF.Actions.get(root).action.actions.readFile.uri;
    url = url.replace("{flag}", id);
    url = url.replace("{applicationFlag}", app);
    return url
};

MWF.xDesktop.getServiceAddress = function(config, callback){
    var error = function(){
        //MWF.xDesktop.notice("error", {"x": "right", "y": "top"}, "")
        var loadingNode = $("browser_loadding");
        var contentNode = $("appContent");
        ((loadingNode) ? loadingNode.getFirst() : contentNode).empty();
        var html= "<div style='width: 800px; color: #ffffff; margin: 30px auto'>" +
            "<div style='height: 40px;'>" +
            "   <div style='height: 40px; width: 40px; float: left; background: url(../x_desktop/img/error.png)'></div>" +
            "   <div style='margin-left: 50px; font-size: 20px; line-height: 40px;'>"+MWF.LP.desktop.notice.errorConnectCenter1+"</div>" +
            "</div><div style='margin-left: 0px;'>";
        if (typeOf(config.center)==="array"){
            config.center.each(function(center){
                var h = (center.host) ? center.host : window.location.hostname;
                var p = (center.port) ? ":"+center.port : "";
                var url = "http://"+h+p+"/x_program_center/jaxrs/echo";
                html+="<br><a style='margin-left: 50px; color: #e0e8d1; line-height: 30px;' href='"+url+"' target='_blank'>"+url+"</a>"
            });
        }else{
            var h = (config.center.host) ? config.center.host : window.location.hostname;
            var p = (config.center.port) ? ":"+config.center.port : "";
            var url = "http://"+h+p+"/x_program_center/jaxrs/echo";
            html+="<br><a style='margin-left: 50px; color: #e0e8d1; line-height: 30px;'href='"+url+"' target='_blank'>"+url+"</a>"
        }
        html+="</div><br><div style='margin-left: 50px; font-size: 20px'>"+MWF.LP.desktop.notice.errorConnectCenter2+"</div></div>";

        ((loadingNode) ? loadingNode.getFirst() : contentNode).set("html", html);
        if (!loadingNode && contentNode){
            contentNode.setStyle("background-color", "#666666");
        }
    };

    if (config.center){
        if (typeOf(config.center)==="object"){
            MWF.xDesktop.getServiceAddressConfigObject(config.center, callback, error);
        }else if (typeOf(config.center)==="array"){
            MWF.xDesktop.getServiceAddressConfigArray(config, callback, error);
        }
    }else{
        MWF.xDesktop.getServiceAddressConfigObject( {
            "host": window.location.hostname,
            "port": window.location.port || 80
        }, callback, error);
    }
};

MWF.xDesktop.getServiceAddressConfigArray = function(config, callback, error) {
    var requests = [];
    var centers = {};
    config.center.each(function(center){
        if (!centers[center.host+center.port]) {
            centers[center.host + center.port] = true;

            requests.push(
                MWF.xDesktop.getServiceAddressConfigObject(center, function(serviceAddressList, center){

                    requests.each(function(res){
                        if (res && res.res) if (res.res.isRunning()){res.res.cancel();}
                        if (res && res.actionWorker) res.actionWorker.terminate();
                    });
                    if (callback) callback(serviceAddressList, center);
                }.bind(this), function(){

                    if (requests.length){
                        for (var i=0; i<requests.length; i++){
                            if (requests[i].res) if (requests[i].res.isRunning()) return "";
                            if (requests[i].actionWorker && requests[i].actionWorker.terminate) return "";
                        }
                    }
                    if (error) error();
                }.bind(this))
            );
        }
    }.bind(this));
};
MWF.xDesktop.getServiceAddressConfigObject = function(center, callback, error){
    var centerConfig = center;
    if (!centerConfig) centerConfig = layout.config.center;
    var host = centerConfig.host || window.location.hostname;
    var port = centerConfig.port;
    var uri = "";

    if (layout.config.app_protocol=="auto"){
        layout.config.app_protocol = window.location.protocol;
    }

    if (!port || port=="80"){
        uri = layout.config.app_protocol+"//"+host+"/x_program_center/jaxrs/distribute/assemble/source/{source}";
    }else{
        uri = layout.config.app_protocol+"//"+host+":"+port+"/x_program_center/jaxrs/distribute/assemble/source/{source}";
    }

    var currenthost = (layout.config.applicationServer && layout.config.applicationServer.host) ? layout.config.applicationServer.host : window.location.hostname;
    //var currenthost = window.location.hostname;
    uri = uri.replace(/{source}/g, currenthost);
    //var uri = "http://"+layout.config.center+"/x_program_center/jaxrs/distribute/assemble";

    try{
        return MWF.restful("get", uri, null, {
            "onSuccess": function(json){
                //this.serviceAddressList = json.data;
                //this.centerServer = center;
                var serviceAddressList = json.data;
                if (layout.config.proxyApplicationEnable || !layout.config.center){
                    Object.keys(serviceAddressList).forEach(function(k){
                        if (k!=="x_message_assemble_communicate" || !layout.config.center) serviceAddressList[k].port = window.location.port;
                    })
                }
                if (callback) callback(serviceAddressList, center);
            }.bind(this),
            "onRequestFailure": function(xhr){
                if (error) error(xhr);
            }.bind(this),
            "onError": function(xhr){
                if (error) error(xhr);
            }.bind(this)
        });
    }catch(e){
        if (error) error();
        return null;
    }
};
MWF.xDesktop.$globalEvents = {};
MWF.xDesktop.addEvent = function(name, type, fn){
    if (!MWF.xDesktop.$globalEvents[name]) MWF.xDesktop.$globalEvents[name] = {};
    if (!MWF.xDesktop.$globalEvents[name][type]) MWF.xDesktop.$globalEvents[name][type] = [];
    MWF.xDesktop.$globalEvents[name][type].push(fn);
};

MWF.xDesktop.addEvents = function(name, o){
    if (!MWF.xDesktop.$globalEvents[name]) MWF.xDesktop.$globalEvents[name] = {};
    Object.each(o, function(fn, type){
        MWF.xDesktop.addEvent(name, type, fn);
    }.bind(this));
};

MWF.xDesktop.removeEvent = function(name, type, fn){
    if (!MWF.xDesktop.$globalEvents[name]) return true;
    if (!MWF.xDesktop.$globalEvents[name][type]) return true;
    MWF.xDesktop.$globalEvents[name][type].erase(fn);
};
MWF.xDesktop.removeEvents = function(name, type){
    if (!MWF.xDesktop.$globalEvents[name]) return true;
    if (!MWF.xDesktop.$globalEvents[name][type]) return true;
    MWF.xDesktop.$globalEvents[name][type] = [];
};

MWF.org = {
    parseOrgData: function(data, flat, simple){
        if (data.distinguishedName){
            var flag = data.distinguishedName.substr(data.distinguishedName.length-2, 2);
            switch (flag.toLowerCase()){
                case "@i":
                    return this.parseIdentityData(data, flat, simple);
                    break;
                case "@p":
                    return this.parsePersonData(data, simple);
                    break;
                case "@u":
                    return this.parseUnitData(data, simple);
                    break;
                case "@g":
                    return this.parseGroupData(data, simple);
                    break;
                case "@r":
                    return this.parseRoleData(data, simple);
                    break;
                case "@a":
                    return this.parseAttributeData(data, simple);
                    break;
                default:
                    return data;
            }
        }else{
            return data;
        }
    },
    parseIdentityData: function(data, flat, simple){
        if( simple ){
            var ndata = {
                "id": data.id,
                "name": data.name,
                "distinguishedName": data.distinguishedName,
                "unitLevelName" : data.unitLevelName,
                "person": data.person,
                "unit": data.unit,
                "unitName": data.unitName,
            };
            if( data.ignoreEmpower )ndata.ignoreEmpower = true;
            if( data.ignoredEmpower )ndata.ignoredEmpower = true;
            return ndata;
        }
        var rData = {
            "id": data.id,
            "name": data.name,
            "unique": data.unique,
            "distinguishedName": data.distinguishedName,
            // "dn": data.distinguishedName,
            "person": data.person,
            "unit": data.unit,
            "unitName": data.unitName,
            // "unitLevel": data.unitLevel,
            "unitLevelName": data.unitLevelName
        };

        if( data.personName )rData.personName = data.personName;
        if( data.personEmployee )rData.personEmployee = data.personEmployee;
        if( data.personUnique )rData.personUnique = data.personUnique;
        if( data.personDn )rData.personDn = data.personDn;

        if( data.ignoreEmpower )rData.ignoreEmpower = true;
        if( data.ignoredEmpower )rData.ignoredEmpower = true;

        if( !flat || !data.personDn || !data.personEmployee || !data.personUnique ){
            var woPerson = data.woPerson;
            if (!data.woPerson){
                //MWF.require("MWF.xDesktop.Actions.RestActions", null, false);
                //this.action = new MWF.xDesktop.Actions.RestActions("", "x_organization_assemble_control");
                //var uri = "/jaxrs/person/{flag}";
                //uri = uri.replace("{flag}", data.person);

                //this.action.invoke({"uri": uri, "success": function(json){
                //    woPerson = json.data;
                //}.bind(this), "async":false});
                MWF.Actions.get("x_organization_assemble_control").getPerson(data.person, function(json){
                    woPerson = json.data
                }, null, false);
            }
            rData.personName = woPerson.name;
            rData.personEmployee = woPerson.employee;
            rData.personUnique = woPerson.unique;
            rData.personDn = woPerson.distinguishedName;

            if (!flat){
                rData.woPerson = {
                    "id": woPerson.id,
                    "genderType": woPerson.genderType,
                    "name": woPerson.name,
                    "employee": woPerson.employee,
                    "unique": woPerson.unique,
                    "distinguishedName": woPerson.distinguishedName,
                    "dn": woPerson.distinguishedName,
                    "mail": woPerson.mail,
                    "weixin": woPerson.weixin,
                    "qq": woPerson.qq,
                    "mobile": woPerson.mobile,
                    "officePhone": woPerson.officePhone
                };
            }
        }
        return rData;
    },
    parsePersonData: function(data, simple){
        if( simple ){
            return {
                "id": data.id,
                "name": data.name,
                "employee": data.employee,
                "distinguishedName": data.distinguishedName,
            }
        }else{
            return {
                "id": data.id,
                "genderType": data.genderType,
                "name": data.name,
                "employee": data.employee,
                "unique": data.unique,
                "distinguishedName": data.distinguishedName,
                "dn": data.distinguishedName,
                "mail": data.mail,
                "weixin": data.weixin,
                "qq": data.qq,
                "mobile": data.mobile,
                "officePhone": data.officePhone
            }
        }
    },
    parseUnitData: function(data, simple){
        if( simple ){
            return {
                "id": data.id,
                "name": data.name,
                "distinguishedName": data.distinguishedName,
                "levelName": data.levelName
            }
        }else{
            return {
                "id": data.id,
                "name": data.name,
                "unique": data.unique,
                "distinguishedName": data.distinguishedName,
                "dn": data.distinguishedName,
                "typeList":data.typeList,
                "shortName": data.shortName,
                "level": data.level,
                "levelName": data.levelName
            }
        }
    },
    parseGroupData: function(data, simple){
        if( simple ){
            return {
                "id": data.id,
                "name": data.name,
                "distinguishedName": data.distinguishedName
            }
        }else{
            return {
                "id": data.id,
                "name": data.name,
                "unique": data.unique,
                "distinguishedName": data.distinguishedName,
                "dn": data.distinguishedName
            }
        }
    },
    parseRoleData: function(data, simple){
        if( simple ){
            return {
                "id": data.id,
                "name": data.name,
                "distinguishedName": data.distinguishedName
            }
        }else{
            return {
                "id": data.id,
                "name": data.name,
                "unique": data.unique,
                "distinguishedName": data.distinguishedName,
                "dn": data.distinguishedName
            }
        }
    },
    parseAttributeData: function(data, simple){
        if(simple){
            return {
                "id": data.id,
                "name": data.name,
                "distinguishedName": data.distinguishedName,
                "person": data.person,
                "attributeList": Array.clone(data.attributeList)
            }
        }else{
            return {
                "id": data.id,
                "description": data.description,
                "name": data.name,
                "unique": data.unique,
                "distinguishedName": data.distinguishedName,
                "dn": data.distinguishedName,
                "person": data.person,
                "attributeList": Array.clone(data.attributeList)
            }
        }
    }
};
//var lp = o2.session.path + "/lp/" + o2.language + ".js";
// var lp = "../x_desktop/js/base_lp_" + o2.language +((o2.session.isDebugger) ? "" : ".min")+ ".js";
// if (!o2.LP){
//     new Request({
//         "url": lp,
//         "method": "get"
//     }).send();
// }

o2.openWindow = function(url){
    var a = new Element("a", {
        "target": "_blank",
        "href": url
    });
    a.click();
    a.destroy();
}

MWF.xDesktop.Actions = MWF.xDesktop.Actions || {};
MWF.xDesktop.Actions.RestActions = new Class({
    Implements: [Events],
    initialize: function(actionPath, serviceName, root){
        this.actionPath = actionPath;
        this.serviceName = serviceName;
        this.root = root;
    },

    listApplicationAddress: function(success, failure){
        var url = this.actions.listAddress;
        url = this.actions.slotHost+url;
        var callback = new MWF.xApplication.Common.Actions.RestActions.Callback(success, failure);
        MWF.getJSON(url, callback);
    },
    getAddress: function(success, failure){
//		var name = "x_processplatform_core_designer";
//		var url = this.actions.getAddress.replace(/{id}/g, name);
//		url = this.actions.slotHost+url;
//		var callback = new MWF.process.RestActions.Callback(success, failure, function(data){
//			this.designAddress = data.data.url;
//		}.bind(this));

//		MWF.getJSON(url, callback);

        //this.address = "http://xa02.zoneland.net:8080/"+this.serviceName;
        var addressObj = layout.serviceAddressList[this.serviceName];
        if (addressObj){
            //var mapping = layout.getAppUrlMapping(layout.config.app_protocol+"//"+addressObj.host+(addressObj.port==80 ? "" : ":"+addressObj.port)+addressObj.context);
            this.address = layout.config.app_protocol+"//"+(addressObj.host || window.location.hostname)+((!addressObj.port || addressObj.port==80) ? "" : ":"+addressObj.port)+addressObj.context;
        }else{
            var host = layout.desktop.centerServer.host || window.location.hostname;
            var port = layout.desktop.centerServer.port;

            //var mapping = layout.getCenterUrlMapping(layout.config.app_protocol+"//"+host+(port=="80" ? "" : ":"+port)+"/x_program_center");
            this.address = layout.config.app_protocol+"//"+host+((!port || port=="80") ? "" : ":"+port)+"/"+this.serviceName;
        }

        //this.address = "http://hbxa01.bf.ctc.com/"+this.serviceName;
        //this.designAddress = "http://localhost:9080/x_processplatform_front_designer";
        if (success) success.apply();
        return this.address;
    },
    getActions: function(callback){

        if (!this.actions){
            var url = (this.root) ? "/"+this.root+this.actionPath : MWF.defaultPath+this.actionPath;
            MWF.getJSON(url, function(json){
                this.actions = json;
                if (callback) callback();
            }.bind(this), false, false, false);
        }else{
            if (callback) callback();
        }
    },
    invokeUri: function(option){
        if (!this.address) this.getAddress();
        var uri = this.address+option.uri;
        var async = (option.async===false) ? false : true;
        var method = option.method || "GET";
        var callback = new MWF.xDesktop.Actions.RestActions.Callback(option.success, option.failure);

        var data = (option.data) ? JSON.encode(option.data) : "";
        var credentials = true;
        if (option.withCredentials===false){
            credentials = false;
        }
        MWF.restful(method, uri, data, callback, async, credentials);
    },
    invoke: function(option){
        if (window.importScripts && window.isCompletionEnvironment) return null;
        if (!this.address) this.getAddress();
        var res = null;
        this.getActions(function(){
            //name, parameter, data, async, success, failure, withCredentials, urlEncode
            var action = this.actions[option.name];
            var method = action.method || "GET";
            var uri = action.uri;
            var progress = action.progress;

            if (option.parameter){
                Object.each(option.parameter, function(value, key){
                    var reg = new RegExp("{"+key+"}", "g");
                    if (option.urlEncode===false){
                        uri = uri.replace(reg, value);
                    }else{
                        uri = uri.replace(reg, encodeURI(value));
                    }
                });
            }
            uri = this.address+uri;

            //putToPost, deleteToGet
            if (layout.config.mock && layout.config.mock[this.serviceName]){
                var mock = layout.config.mock[this.serviceName][method.toLowerCase()];
                if (mock){
                    method = mock.to || method;
                    var append = mock.append;
                    uri = uri+((uri.substr(uri.length-1, 1)=="/") ? append : "/"+append);
                }
            }

            var async = (option.async===false) ? false : true;

            // if (!option.success) option.success = function(v){return v;}.ag();
            // if (option.success && !option.success.isAG) option.success = option.success.ag();
            //
            // if (option.failure && option.failure.failure) option.failure = option.failure.failure;
            // if (option.failure) {
            //     option.success.catch(option.failure);
            //     option.failure.owner = option.success;
            // }
            // if (!option.failure && option.success && option.success.failure){
            //     option.failure = option.success.failure;
            //     option.failure.owner = option.success;
            // }

            // if (option.failure && option.failure.failure) option.failure = option.failure.failure;
            // if (!option.failure && option.success && option.success.failure){
            //     option.failure = option.success.failure;
            //     option.failure.owner = option.success;
            // }
            // if (!option.success){
            //     option.success = function(v){return v;}.ag();
            //     if (option.failure) {
            //         option.success.catch(option.failure);
            //         option.failure.owner = option.success;
            //     }
            // }

            var callback = new MWF.xDesktop.Actions.RestActions.Callback(option.success, option.failure);
            if (action.enctype && (action.enctype.toLowerCase()=="formdata")){
                res = this.invokeFormData(method, uri, option.data, option.file, callback, async, progress);
            }else{
                //var data = (option.data) ? JSON.encode(option.data) : "";
                var data = JSON.encode(option.data);
                var credentials = true;
                if (option.withCredentials===false){
                    credentials = false;
                }
                res = MWF.restful(method, uri, data, callback, async, credentials, option.cache);
            }
        }.bind(this));
        return res;
    },
    formDataUpdateProgress: function(){

    },

    invokeFormDataWithProgress: function(xhr, method, uri, data, file, callback, async, progress){
        var messageItem = null;
        var currentDate = new Date();

        xhr.upload.addEventListener("progress", function(e){this.updateProgress(e, xhr, messageItem, currentDate);}.bind(this), false);
        xhr.upload.addEventListener("load", function(e){
            if(file){
                this.transferComplete(e, xhr, messageItem, currentDate, file);
            }
        }.bind(this), false);
        xhr.upload.addEventListener("loadstart", function(e){this.transferStart(e, xhr, messageItem);}.bind(this), false);
        xhr.upload.addEventListener("error", function(e){this.transferFailed(e, xhr, messageItem);}.bind(this), false);
        xhr.upload.addEventListener("abort", function(e){this.transferCanceled(e, xhr, messageItem);}.bind(this), false);
        xhr.upload.addEventListener("timeout", function(e){this.transferCanceled(e, xhr, messageItem);}.bind(this), false);

        xhr.addEventListener("readystatechange", function(e){this.xhrStateChange(e, xhr, messageItem, callback);}.bind(this), false);

        xhr.open(method, uri, async!==false);
        xhr.withCredentials = true;

        var token = (layout.config && layout.config.sessionStorageEnable) ? sessionStorage.getItem("o2LayoutSessionToken") : "";
        if (!token) {
            token = (layout.session && layout.session.user) ? (layout.session.token || layout.session.user.token) : "";
        }
        if (token) {
            xhr.setRequestHeader("Authorization", token);
        }

        if (file && File.prototype.isPrototypeOf(file)) messageItem = this.addFormDataMessage(file, false, xhr, progress);
        xhr.send(data);
    },
    setMessageText: function(messageItem, text){
        if (messageItem && messageItem.message){
            var progressNode = messageItem.contentNode.getFirst("div").getFirst("div");
            var progressPercentNode = progressNode.getFirst("div");
            var progressInforNode = messageItem.contentNode.getFirst("div").getLast("div");
            progressInforNode.set("text", text);
            messageItem.dateNode.set("text", (new Date()).format("db"));
        }
        //@upload message
        if (messageItem && messageItem.moduleMessage){
            if (messageItem.moduleMessage.setMessageText) messageItem.moduleMessage.setMessageText();
        }
    },
    setMessageTitle: function(messageItem, text){
        if (messageItem && messageItem.message) messageItem.subjectNode.set("text", text);
        //@upload message
        if (messageItem && messageItem.moduleMessage){
            if (messageItem.moduleMessage.setMessageTitle) messageItem.moduleMessage.setMessageTitle();
        }
    },
    clearMessageProgress: function(messageItem){
        if (messageItem && messageItem.message) {
            var progressNode = messageItem.contentNode.getFirst("div").getFirst("div");
            progressNode.destroy();
        }
        //@upload message
        if (messageItem && messageItem.moduleMessage){
            if (messageItem.moduleMessage.clearMessageProgress) messageItem.moduleMessage.clearMessageProgress();
        }
    },


    transferStart: function(e, xhr, messageItem){
        if (messageItem && messageItem.message) {
            this.setMessageText(messageItem, MWF.LP.desktop.action.sendStart);
            messageItem.status = "progress";
        }
        //@upload message
        if (messageItem && messageItem.moduleMessage){
            if (messageItem.moduleMessage.transferStart) messageItem.moduleMessage.transferStart();
        }
        this.fireEvent("loadstart");
    },
    transferFailed: function(e, xhr, messageItem){
        if (messageItem && messageItem.message) {
            this.setMessageText(messageItem, MWF.LP.desktop.action.sendError);
            this.setMessageTitle(messageItem, MWF.LP.desktop.action.sendError);
            this.clearMessageProgress(messageItem);
            messageItem.status = "failed";
        }
        //@upload message
        if (messageItem && messageItem.moduleMessage){
            if (messageItem.moduleMessage.transferFailed) messageItem.moduleMessage.transferFailed();
        }
        this.fireEvent("error");
    },
    transferCanceled: function(e, xhr, messageItem){
        if (messageItem && messageItem.message) {
            this.setMessageText(messageItem, MWF.LP.desktop.action.sendAbort);
            this.setMessageTitle(messageItem, MWF.LP.desktop.action.sendAbort);
            this.clearMessageProgress(messageItem);
            messageItem.status = "cancel";
        }
        //@upload message
        if (messageItem && messageItem.moduleMessage){
            if (messageItem.moduleMessage.transferCanceled) messageItem.moduleMessage.transferCanceled();
        }
        this.fireEvent("abort");
    },
    transferComplete: function(e, xhr, messageItem, currentDate, file){

        var sendDate = new Date();
        var ms = sendDate.getTime()-currentDate.getTime();
        var speed = (file.size)/ms;
        var u = "K/S";
        if (speed>1024){
            u = "M/S";
            speed = speed/1024;
        }
        if (speed>1024){
            u = "G/S";
            speed = speed/1024;
        }
        speed = speed.round(2);

        var timeStr = "";
        if (ms>3600000){
            var h = ms/3600000;
            var m_s = ms % 3600000;
            var m = m_s / 60000;
            var s_s = m_s % 60000;
            var s = s_s/1000;
            timeStr = ""+h.toInt()+MWF.LP.desktop.action.hour+m.toInt()+MWF.LP.desktop.action.minute+s.toInt()+MWF.LP.desktop.action.second;
        }else if (ms>60000){
            var m = ms / 60000;
            var s_s = ms % 60000;
            var s = s_s/1000;
            timeStr = ""+m.toInt()+MWF.LP.desktop.action.minute+s.toInt()+MWF.LP.desktop.action.second;
        }else{
            var s = ms/1000;
            timeStr = ""+s.toInt()+MWF.LP.desktop.action.second;
        }
        if (messageItem && messageItem.message) {
            this.setMessageText(messageItem, MWF.LP.desktop.action.uploadComplete + "  " + MWF.LP.desktop.action.speed + ": " + speed + u + "  " + MWF.LP.desktop.action.time + ": " + timeStr, MWF.LP.desktop.action.uploadComplete);
            this.setMessageTitle(messageItem, MWF.LP.desktop.action.uploadComplete);
            this.clearMessageProgress(messageItem);

            messageItem.status = "completed";
        }
        //@upload message

        if (messageItem && messageItem.moduleMessage){
            if (messageItem.moduleMessage.transferComplete) messageItem.moduleMessage.transferComplete();
        }
        //var msg = {
        //    "subject": MWF.LP.desktop.action.uploadComplete,
        //    "content": MWF.LP.desktop.action.uploadComplete+" : "+file.name
        //};
        //layout.desktop.message.addTooltip(msg);
        this.fireEvent("load");
    },
    updateProgress: function(e, xhr, messageItem, currentDate){
        var percent = 100*(e.loaded/e.total);

        var sendDate = new Date();
        var ms = sendDate.getTime()-currentDate.getTime();
        var speed = (e.loaded)/ms;
        var u = "K/S";
        if (speed>1024){
            u = "M/S";
            speed = speed/1024;
        }
        if (speed>1024){
            u = "G/S";
            speed = speed/1024;
        }
        speed = speed.round(2);

        if (messageItem && messageItem.message) {
            if (messageItem.contentNode) {
                var progressNode = messageItem.contentNode.getFirst("div").getFirst("div");
                var progressPercentNode = progressNode.getFirst("div");
                var progressInforNode = messageItem.contentNode.getFirst("div").getLast("div");
                progressPercentNode.setStyle("width", "" + percent + "%");
                progressInforNode.set("text", MWF.LP.desktop.action.sendStart + ": " + speed + u);
            }
        }
        //@upload message

        if (messageItem && messageItem.moduleMessage){
            if (messageItem.moduleMessage.updateProgress) messageItem.moduleMessage.updateProgress(percent);
        }
        this.fireEvent("progress");
    },
    xhrStateChange: function(e, xhr, messageItem, callback){
        if (xhr.readyState != 4) return;

        var status = xhr.status;
        status = (status == 1223) ? 204 : status;

        if ((status >= 200 && status < 300)){
            var json = JSON.decode(xhr.responseText);
            if (json){
                switch(json.type) {
                    case "success":
                        var dataId = "";
                        var t = typeOf(json.data);
                        if (t=="array"){
                            dataId = json.data[0].id;
                        }
                        if (t=="object"){
                            dataId = json.data.id;
                        }

                        MWF.runCallback(callback, "success", [{
                            "type": "success",
                            "id": dataId,
                            "messageId": (messageItem && messageItem.moduleMessage) ? messageItem.moduleMessage.data.id : "",
                            "data": json.data
                        }, xhr.responseText]);
                        break;
                    case "warn":
                        MWF.xDesktop.notice("info", {x: "right", y:"top"}, json.errorMessage.join("\n"));

                        var dataId = "";
                        var t = typeOf(json.data);
                        if (t=="array"){
                            dataId = json.data[0].id;
                        }
                        if (t=="object"){
                            dataId = json.data.id;
                        }
                        MWF.runCallback(callback, "success", [{
                            "type": "success",
                            "id": dataId
                        }, xhr.responseText]);
                        break;
                    case "error":
                        var messageId = (messageItem && messageItem.moduleMessage) ? messageItem.moduleMessage.data.id : "";
                        if( messageId && xhr )xhr.messageId = messageId;
                        MWF.runCallback(callback, "failure", [xhr]);
                        break;
                }
            }else{
                var messageId = (messageItem && messageItem.moduleMessage) ? messageItem.moduleMessage.data.id : "";
                if( messageId && xhr )xhr.messageId = messageId;
                MWF.runCallback(callback, "failure", [xhr]);
            }
        }else{
            var messageId = (messageItem && messageItem.moduleMessage) ? messageItem.moduleMessage.data.id : "";
            if( messageId && xhr )xhr.messageId = messageId;
            MWF.runCallback(callback, "failure", [xhr]);
        }
    },

    invokeFormDataWithoutProgress: function(xhr, method, uri, data, file, callback, async, progress){
        var messageItem = null;
        var currentDate = new Date();

        xhr.addEventListener("readystatechange", function(e){
            if (xhr.readyState == 4){
                if(file){
                    this.transferComplete(e, xhr, messageItem, currentDate, file);
                }
                this.xhrStateChange(e, xhr, messageItem, callback);
            }
        }.bind(this), false);

        xhr.open(method, uri, true);
        xhr.withCredentials = true;
        var token = (layout.config && layout.config.sessionStorageEnable) ? sessionStorage.getItem("o2LayoutSessionToken") : "";
        if (!token) {
            token = (layout.session && layout.session.user) ? (layout.session.token || layout.session.user.token) : "";
        }
        if (token) {
            xhr.setRequestHeader("Authorization", token);
        }

        messageItem = this.addFormDataMessage(file, true, xhr, progress);
        xhr.send(data);
        this.setMessageText(messageItem, MWF.LP.desktop.action.sendStart);
    },
    invokeFormDataWithForm: function(xhr, method, uri, data, file, callback, async){
        MWF.O2UploadCallback = callback;
        MWF.O2UploadCallbackFun = function(){
            if (MWF.O2UploadCallback) MWF.O2UploadCallback();
        };
        var div = data.items[0].value.el.getParent();
        div.set("styles", {
            "width": "500px",
            "height": "300px",
            "background-color": "#999999",
            "position": "absolute",
            "top": "100px",
            "left": "100px",
            "z-index": "30000",
            "display": "block"
        }).inject(document.body);

        var formNode = new Element("form", {
            "method": method,
            "action": (uri.indexOf("?")!=-1) ? uri+"&callback=MWF.O2UploadCallbackFun" : uri+"?callback=MWF.O2UploadCallbackFun",
            "enctype": "multipart/form-data",
            "target": "o2_upload_iframe"
        }).inject(div);
        var iframe = new Element("iframe", {
            "name": "o2_upload_iframe"
        }).inject(div);
        data.items.each(function(item){
            if (typeOf(item.value)=="string"){
                new Element("input", {
                    "name": item.name,
                    "value": item.value
                }).inject(formNode);
            }else{
                item.value.el.inject(formNode);
                item.value.el.set("name", item.name);
            }
        }.bind(this));
        var submitNode = new Element("input", {
            "type": "submit"
        }).inject(formNode);
        //   formNode.submit();
    },

    invokeFormData: function(method, uri, data, file, callback, async, progress){
        uri = o2.filterUrl(uri);
        var xhr = new COMMON.Browser.Request();
        if(file){
            data.append('fileName', file.name);
        }

        if (data.type==="o2_formdata"){
            this.invokeFormDataWithForm(xhr, method, uri, data, file, callback, async);
        }else{
            if (xhr.upload){
                this.invokeFormDataWithProgress(xhr, method, uri, data, file, callback, async, progress);
            }else{
                this.invokeFormDataWithoutProgress(xhr, method, uri, data, file, callback, async, progress);
            }
        }
        return xhr;
    },
    addFormDataMessage: function(file, noProgress, xhr, showMsg){

        if (layout.desktop.message){
            var contentHTML = "";
            if (noProgress){
                contentHTML = "<div style=\"height: 20px; line-height: 20px\">"+MWF.LP.desktop.action.sendReady+"</div></div>" ;
            }else{
                contentHTML = "<div style=\"overflow: hidden\"><div style=\"height: 3px; border:1px solid #999; margin: 3px 0px\">" +
                    "<div style=\"height: 3px; background-color: #acdab9; width: 0px;\"></div></div>" +
                    "<div style=\"height: 20px; line-height: 20px\">"+MWF.LP.desktop.action.sendReady+"</div></div>" ;
            }
            var msg = {
                "subject": MWF.LP.desktop.action.uploadTitle,
                //"content": MWF.LP.desktop.action.uploadTitle+" : "+file.name+"<br/>"+contentHTML
                "content": ( file.name ? (o2.txt(file.name)+"<br/>") : "" )+contentHTML
            };

            var messageItem = layout.desktop.message.addMessage(msg);

            //var _self = this;
            messageItem.close = function(callback, e){
                if (this.status=="progress"){
                    var flag = false;
                    var name = o2.txt(file.name||"");
                    name = name.length > 50 ? name.substr(0, 50)+"..." : name;
                    var text = MWF.LP.desktop.action.cancelUpload.replace(/{name}/g, (name));
                    MWF.xDesktop.confirm("wram", e, MWF.LP.desktop.action.cancelUploadTitle, text, "400", "180", function(){
                        xhr.abort();
                        //xhr.upload.timeout = 1;
                        this.close();
                        //messageItem.closeItem();
                    }, function(){
                        this.close()
                    });
                    //MWF.LP.desktop.action.sendStart
                }else{
                    messageItem.closeItem(callback, e);
                }
            };
        }

        //@upload message
        if (this.targetModule){
            var moduleMessage = this.targetModule.module.addFormDataMessage(this.targetModule.file);
            if (!messageItem) messageItem  ={};
            messageItem.moduleMessage = moduleMessage;
            this.targetModule = null;
        }

        //messageItem.addEvent("close", function(flag, e){
        //    debugger;
        //    if (this.status=="progress"){
        //        flag = false;
        //        var text = MWF.LP.desktop.action.cancelUpload.replace(/{name}/g, file.name);
        //        MWF.xDesktop.confirm("wram", e, MWF.LP.desktop.action.cancelUploadTitle, text, "300", "120", function(){
        //            xhr.abort();
        //            this.close();
        //            //messageItem.closeItem();
        //        }, function(){
        //            this.close()
        //        });
        //        //MWF.LP.desktop.action.sendStart
        //    }
        //});

        if (showMsg){
            window.setTimeout(function(){
                if (layout.desktop.message) if (!layout.desktop.message.isShow) layout.desktop.message.show();
            }.bind(this), 300);
        }

        //msg = {
        //    "subject": MWF.LP.desktop.action.uploadTitle,
        //    "content": MWF.LP.desktop.action.uploadTitle+" : "+file.name
        //};
        //var tooltipItem = layout.desktop.message.addTooltip(msg);
        return messageItem;
    },
    getAuthentication: function(success, failure){
        this.invoke({
            "name": "authentication",
            "async": true,
            "success": function(json, responseText){
                if (json.data.tokenType!="anonymous"){
                    if (success) success(json);
                }else{
                    if (failure) failure(null, responseText, json.message);
                }
            },
            "failure": failure
        });
    },
    login: function(data, success, failure){
        var name = "login";
        //    if (data.credential.toLowerCase()=="xadmin") name = "loginAdmin";
        this.invoke({
            "name": name,
            "async": true,
            "data": data,
            "success": function(json, responseText){
                //if (json.data.authentication){
                if (json.data.tokenType!="anonymous"){
                    if (success) success(json);
                }else{
                    if (failure) failure(null, responseText, json.message);
                }
            },
            "failure": failure
        });
    },
    logout: function(success, failure){
        this.invoke({
            "name": "logout",
            "async": false,
            "success": success,
            "failure": failure
        });
    }

});

MWF.xDesktop.Actions.RestActions.Callback = new Class({
    initialize: function(success, failure, appendSuccess, appendFailure){
        this.success = success;
        this.failure = failure;
        this.appendSuccess = appendSuccess;
        this.appendFailure = appendFailure;
    },

    onSuccess: function(responseJSON, responseText){
        if (responseJSON){
            switch(responseJSON.type) {
                // case "success":
                //    if (this.appendSuccess) this.appendSuccess(responseJSON);
                //    if (this.success) return this.success(responseJSON, responseText);
                //    return responseJSON;
                //     break;
                case "warn":
                    //MWF.xDesktop.notice("info", {x: "right", y:"top"}, responseJSON.errorMessage.join("\n"));
                    if (this.appendSuccess) this.appendSuccess(responseJSON);
                    if (this.success) return this.success(responseJSON);
                    return responseJSON;
                    break;
                case "error":
                    return this.doError(null, responseText, responseJSON.message);
                    return responseJSON;
                    break;
                default:
                    if (this.appendSuccess) this.appendSuccess(responseJSON);
                    if (this.success) return this.success(responseJSON, responseText);
                    return responseJSON;
                    break;
            }
        }else{
            return this.doError(null, responseText, "");
        }
    },
    onRequestFailure: function(xhr){
        return this.doError(xhr, "", "");
    },
    onFailure: function(xhr, text, error){
        return this.doError(xhr, text, error);
    },
    onError: function(text, error){
        return this.doError(null, text, error);
    },
    doError: function(xhr, text, error){
        if (this.appendFailure) this.appendFailure(xhr, text, error);
        var flag = true;
        if (this.failure && this.failure.owner){
            if (this.failure.reject || (this.failure.rejectList && this.failure.rejectList.length)){
                return this.failure(xhr, text, error);
            }
            this.failure = null;
        }else{
            if (this.failure) flag = !this.failure(xhr, text, error);
        }
        //if (!this.failure && !this.appendFailure){
        if (flag && !this.appendFailure){
            if (xhr.status!=0){
                var errorText = error;
                if (xhr){
                    var json = JSON.decode(xhr.responseText);
                    if (json){
                        errorText = json.message.trim() || "request json error";
                    }else{
                        errorText = "request json error: "+xhr.responseText;
                    }
                }
                errorText = errorText.replace(/\</g, "&lt;");
                errorText = errorText.replace(/\</g, "&gt;");
                if (layout.session && layout.session.user) MWF.xDesktop.notice("error", {x: "right", y:"top"}, errorText);
            }
            //	throw "request error: "+errorText;
        }
        return  {"xhr": xhr, "text": text, "error":error};
    }
});

MWF.xAction = MWF.xAction || {};
//MWF.require("MWF.xDesktop.Actions.RestActions", null, false);

MWF.xAction.RestActions = MWF.Actions = {
    "actions": {},
    "loadedActions": {},
    "get": function(root){
        if (this.actions[root]) return this.actions[root];

        var actions = null;
        var url = o2.session.path+"/xAction/services/"+root+".json";
        MWF.getJSON(url, function(json){actions = json;}.bind(this), false, false, false);

        if (!MWF.xAction.RestActions.Action[root] && actions.clazz) MWF.require("MWF.xAction.services."+actions.clazz, null, false);
        if (!MWF.xAction.RestActions.Action[root]) MWF.xAction.RestActions.Action[root] = new Class({Extends: MWF.xAction.RestActions.Action});

        this.actions[root] = new MWF.xAction.RestActions.Action[root](root, actions);
        return this.actions[root];
    },
    "load": function(root){
        if (this.loadedActions[root]) return this.loadedActions[root];
        var jaxrs = null;
        //var url = this.getHost(root)+"/"+root+"/describe/describe.json";
        var url = this.getHost(root)+"/"+root+"/describe/api.json";
        //var url = "../o2_core/o2/xAction/temp.json";
        try{
            MWF.getJSON(url, function(json){jaxrs = json.jaxrs;}.bind(this), false, false, false);
            if (jaxrs){
                var actionObj = {};
                jaxrs.each(function(o){
                    if (o.methods && o.methods.length){
                        var actions = {};
                        o.methods.each(function(m){
                            var o = {"uri": "/"+m.uri};
                            if (m.method) o.method = m.method;
                            if (m.enctype) o.enctype = m.enctype;
                            actions[m.name] = o;
                        }.bind(this));
                        actionObj[o.name] = new MWF.xAction.RestActions.Action(root, actions);
                        //actionObj[o.name] = new MWF.xAction.RestActions.Action(root, o.methods);
                    }
                }.bind(this));
                this.loadedActions[root] = actionObj;
                return actionObj;
            }
        }catch(e){}
        return null;
    },
    //actions: [{"action": "", "subAction": "TaskAction", "name": "list", "par": [], "body": "",  "urlEncode"： false, "cache": false}]
    async: function(actions, callback){
        var cbs = (o2.typeOf(callback)==="function") ? callback : callback.success;
        var cbf = (o2.typeOf(callback)==="function") ? null : callback.failure;
        var res = [];
        var len = actions.length;
        var jsons = new Array(len-1);

        var cb = function(){
            if (res.length===len) cbs.apply(this, jsons);
        };
        var _doError = function(xhr, text, error){
            if (xhr.status!=0){
                var errorText = error;
                if (xhr){
                    var json = JSON.decode(xhr.responseText);
                    if (json){
                        errorText = json.message.trim() || "request json error";
                    }else{
                        errorText = "request json error: "+xhr.responseText;
                    }
                }
                MWF.xDesktop.notice("error", {x: "right", y:"top"}, errorText);
            }
        };

        actions.each(function(action, i){
            var actionArgs = action.par || [];
            actionArgs.push(function(json){
                jsons[i] = json;
                res.push(true);
                cb();
            });
            actionArgs.push(function(xhr, text, error){
                res.push(false);
                if (!cbf){
                    _doError(xhr, text, error);
                }else{
                    cbf();
                }
                cb();
            });
            actionArgs.push(true);
            actionArgs.push(action.urlEncode);
            actionArgs.push(action.cache);
            action.action[action.subAction][action.name].apply(action.action[action.subAction], actionArgs);
        });
    },

    //actions: [{"action": "", "name": "list", "par": [], "body": "",  "urlEncode"： false, "cache": false}]
    invokeAsync2: function(actions, callback){

        var cbs = (o2.typeOf(callback)==="function") ? callback : callback.success;
        var cbf = (o2.typeOf(callback)==="function") ? null : callback.failure;
        var res = [];
        var len = actions.length;
        var jsons = new Array(len-1);

        var cb = function(){
            if (res.length===len) cbs.apply(this, jsons);
        };
        var _doError = function(xhr, text, error){
            if (xhr.status!=0){
                var errorText = error;
                if (xhr){
                    var json = JSON.decode(xhr.responseText);
                    if (json){
                        errorText = json.message.trim() || "request json error";
                    }else{
                        errorText = "request json error: "+xhr.responseText;
                    }
                }
                MWF.xDesktop.notice("error", {x: "right", y:"top"}, errorText);
            }
        };

        actions.each(function(action, i){
            var actionArgs = action.par || [];
            actionArgs.push(function(json){
                jsons[i] = json;
                res.push(true);
                cb();
            });
            actionArgs.push(function(xhr, text, error){
                res.push(false);
                if (!cbf){
                    _doError(xhr, text, error);
                }else{
                    cbf();
                }
                cb();
            });
            actionArgs.push(true);
            actionArgs.push(action.urlEncode);
            actionArgs.push(action.cache);
            action.action[action.name].apply(action.action, actionArgs);
        });
    },

    "getHost": function(root){
        var addressObj = layout.serviceAddressList[root];
        var address = "";
        if (addressObj){
            //var mapping = layout.getAppUrlMapping();
            address = layout.config.app_protocol+"//"+(addressObj.host || window.location.hostname)+ (( !addressObj.port || addressObj.port==80 ) ? "" : ":"+addressObj.port);
        }else{
            var host = layout.desktop.centerServer.host || window.location.hostname;
            var port = layout.desktop.centerServer.port;
            //var mapping = layout.getCenterUrlMapping();
            address = layout.config.app_protocol+"//"+host+( (!port || port=="80") ? "" : ":"+port);
        }
        return address;
    },
    "invokeAsync": function(actions, callback){
        var len = actions.length;
        var parlen = arguments.length-2;
        var res = [];
        var jsons = new Array(len-1);
        var args = arguments;

        var cbs = (o2.typeOf(callback)==="function") ? callback : callback.success;
        var cbf = (o2.typeOf(callback)==="function") ? null : callback.failure;

        var cb = function(){
            if (res.length===len) cbs.apply(this, jsons);
        };
        var _doError = function(xhr, text, error){
            if (xhr.status!=0){
                var errorText = error;
                if (xhr){
                    var json = JSON.decode(xhr.responseText);
                    if (json){
                        errorText = json.message.trim() || "request json error";
                    }else{
                        errorText = "request json error: "+xhr.responseText;
                    }
                }
                MWF.xDesktop.notice("error", {x: "right", y:"top"}, errorText);
            }
        };

        actions.each(function(action, i){
            var par = (i<parlen) ? args[i+2] : args[parlen+1];
            if (par){
                var actionArgs = (o2.typeOf(par)==="array") ? par : [par];
                actionArgs.unshift(function(xhr, text, error){
                    res.push(false);
                    if (!cbf){
                        _doError(xhr, text, error);
                    }else{
                        cbf();
                    }
                    cb();
                    return true;
                });
                //actionArgs.unshift(null);
                actionArgs.unshift(function(json){
                    jsons[i] = json;
                    res.push(true);
                    cb();
                });

                var p = action.action[action.name].apply(action.action, actionArgs);
                // p.catch(function(xhr, text, error){
                //     res.push(false);
                //     if (!cbf){
                //         _doError(xhr, text, error);
                //     }else{
                //         cbf();
                //     }
                //     cb();
                // })

            }else{
                action.action[action.name](function(){
                    jsons[i] = json;
                    res.push(true);
                    cb();
                }, function(xhr, text, error){
                    res.push(false);
                    if (!cbf){
                        _doError(xhr, text, error);
                    }else{
                        cbf();
                    }
                    cb();
                });
            }
        });
    }
};
MWF.xAction.RestActions.Action = new Class({
    initialize: function(root, actions){
        this.action = new MWF.xDesktop.Actions.RestActions("/xAction/services/"+root+".json", root, "");
        this.action.actions = actions;

        Object.each(this.action.actions, function(service, key){
            if (service.uri) if (!this[key]) this.createMethod(service, key);
        }.bind(this));
    },
    createMethod: function(service, key){
        var jaxrsUri = service.uri;
        var re = new RegExp("\{.+?\}", "g");
        var replaceWords = jaxrsUri.match(re);
        var parameters = [];
        if (replaceWords) parameters = replaceWords.map(function(s){
            return s.substring(1,s.length-1);
        });

        this[key] = this.invokeFunction(service, parameters, key);
    },
    invokeFunction: function(service, parameters, key){
        //uri的参数, data(post, put), file(formData), success, failure, async
        return function(){
            var i = parameters.length-1;
            var n = arguments.length;
            var functionArguments = arguments;
            var parameter = {};
            var success, failure, async, data, file;
            if (typeOf(functionArguments[0])==="function"){
                i=-1;
                success = (n>++i) ? functionArguments[i] : null;
                failure = (n>++i) ? functionArguments[i] : null;
                parameters.each(function(p, x){
                    parameter[p] = (n>++i) ? functionArguments[i] : null;
                });
                if (service.method && (service.method.toLowerCase()==="post" || service.method.toLowerCase()==="put")){
                    if ((!service.enctype) || service.enctype.toLowerCase()!=="formdata"){
                        data = (n>++i) ? functionArguments[i] : null;
                    }else{
                        data = (n>++i) ? functionArguments[i] : null;
                        file = (n>++i) ? functionArguments[i] : null;
                    }
                }
                async = (n>++i) ? functionArguments[i] : null;
                urlEncode = (n>++i) ? functionArguments[i] : true;
                cache = (n>++i) ? functionArguments[i] : (Browser.name != "ie");
            }else{
                parameters.each(function(p, x){
                    parameter[p] = (n>x) ? functionArguments[x] : null;
                });
                if (service.method && (service.method.toLowerCase()==="post" || service.method.toLowerCase()==="put")){
                    if ((!service.enctype) || service.enctype.toLowerCase()!=="formdata"){
                        data = (n>++i) ? functionArguments[i] : null;
                    }else{
                        data = (n>++i) ? functionArguments[i] : null;
                        file = (n>++i) ? functionArguments[i] : null;
                    }
                }
                success = (n>++i) ? functionArguments[i] : null;
                failure = (n>++i) ? functionArguments[i] : null;
                async = (n>++i) ? functionArguments[i] : null;
                urlEncode = (n>++i) ? functionArguments[i] : true;
                cache = (n>++i) ? functionArguments[i] : (Browser.name != "ie");
            }
            return this.invoke(service,{"name": key, "async": async, "data": data, "file": file, "parameter": parameter, "success": success, "failure": failure, "urlEncode": urlEncode, "cache": cache});
            //if (!cache) debugger;
            //return this.action.invoke({"name": key, "async": async, "data": data, "file": file, "parameter": parameter, "success": success, "failure": failure, "urlEncode": urlEncode, "cache": cache});
        }.bind(this);
    },
    invoke: function(service, options){
        return this.action.invoke(options);
    }
});


MWF.xDesktop = MWF.xDesktop || {};
MWF.xApplication = MWF.xApplication || {};
//MWF.xDesktop.requireApp("Organization", "Actions.RestActions", null, false);

MWF.xDesktop.Access = MWF.AC = {
    "companyList": null,
    "action": null,

    getRoleList: function(){
        if (!this.roleList){
            this.roleList = [];
            layout.desktop.session.user.roleList.each(function(role){
                this.roleList.push(role.substring(0, role.indexOf("@")).toLowerCase());
            }.bind(this));
        }
    },
    isAdministrator: function(){
        this.getRoleList();
        return (layout.desktop.session.user.name.toLowerCase() === "xadmin") || (this.roleList.indexOf("manager")!==-1) || (this.roleList.indexOf("systemmanager")!==-1);
    },
    isManager: function(){
        this.getRoleList();
        return (layout.desktop.session.user.name.toLowerCase() === "xadmin") || (this.roleList.indexOf("manager")!==-1);
    },
    isProcessManager: function(){
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("processplatformmanager")!==-1);
    },
    isPortalManager: function(){
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("portalmanager")!==-1);
    },
    isPortalCreator: function(){
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("portalmanager")!==-1) || (this.roleList.indexOf("portalcreator")!==-1);
    },
    isQueryManager: function(){
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("querymanager")!==-1);
    },
    isQueryCreator: function(){
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("querymanager")!==-1) || (this.roleList.indexOf("querycreator")!==-1);
    },
    isOrganizationManager: function(){
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("organizationmanager")!==-1);
    },
    isMessageManager: function(){
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("messagemanager")!==-1);
    },
    isServiceManager: function(){
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("servicemanager")!==-1);
    },

    isUnitManager: function(){
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("unitmanager")!==-1);
    },
    isGroupManager: function(){
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("groupmanager")!==-1);
    },
    isRoleManager: function(){
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("rolemanager")!==-1);
    },
    isPersonManager: function(){
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("personmanager")!==-1);
    },
    isSystemManager: function(){
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return (this.roleList.indexOf("systemmanager")!==-1);
    },
    isSecurityManager: function(){
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return (this.roleList.indexOf("securitymanager")!==-1);
    },
    isAuditManager: function(){
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return (this.roleList.indexOf("auditmanager")!==-1);
    },

    isGroupCreator: function(){
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return (this.roleList.indexOf("groupcreator")!==-1);
    },
    isProcessPlatformCreator: function(){
        if (this.isAdministrator()) return true;
        if (this.isProcessManager()) return true;
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return (this.roleList.indexOf("processplatformcreator")!==-1);
    },
    isPortalPlatformCreator: function(){
        if (this.isAdministrator()) return true;
        if (this.isPortalCreator()) return true;
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return (this.roleList.indexOf("portalcreator")!==-1);
    },

    isQueryPlatformCreator: function(){
        if (this.isAdministrator()) return true;
        if (this.isQueryCreator()) return true;
        if (!layout.desktop.session.user.roleList) return false;
        this.getRoleList();
        return (this.roleList.indexOf("querycreator")!==-1);
    },
    isApplicationManager: function(option){
        if (this.isAdministrator()) {
            if (option.yes) option.yes();
        }else{

        }
    },
    isCMSManager: function(){
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("cmsmanager")!==-1);
    },
    isCMSCreator: function(){
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("cmsmanager")!==-1) || (this.roleList.indexOf("cmscreator")!==-1);
    },
    isBBSManager: function(){
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("bbsmanager")!==-1) || (this.roleList.indexOf("bssmanager")!==-1);
    },
    isOKRManager: function(){
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("okrmanager")!==-1);
    },
    isCRMManager: function(){
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("crmmanager")!==-1);
    },
    isAttendanceManager: function(){
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("attendancemanager")!==-1);
    },
    isMeetingAdministrator: function(){
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("meetingmanager")!==-1);
    },
    isHotPictureManager: function(){
        this.getRoleList();
        return this.isAdministrator() || (this.roleList.indexOf("hotpicturemanager")!==-1);
    },
    isPersonEditor: function(option){
        //{list: "idlist", "yes": trueFunction, "no": falseFunction}
        if (this.isAdministrator()) return true;
        if (this.isPersonManager()) return true;
        if (option.list && option.list.length){
            if (option.list.indexOf(layout.desktop.session.user.id)!==-1) return true;
        }
        return false;
    },
    isCompanyEditor: function(option) {
        //{id: "companyId", "yes": trueFunction, "no": falseFunction}
        if (this.isAdministrator()){
            if (option.yes) option.yes();
        }else if (this.isCompanyCreator()){
            if (option.yes) option.yes();
        }else{
            this.getCompanyList(function(){
                if (option.id){
                    if (this.companyList.indexOf(option.id)!==-1){
                        if (option.yes) option.yes();
                    }else{
                        if (option.no) option.no();
                    }
                }else{
                    if (this.companyList.length>0){
                        if (option.yes) option.yes();
                    }else{
                        if (option.no) option.no();
                    }
                }
            }.bind(this));
        }
    },
    isDepartmentEditor: function(option) {
        //{id: "superCompanyId", "yes": trueFunction, "no": falseFunction}
        if (this.isAdministrator()){
            if (option.yes) option.yes();
        }else if (this.isCompanyCreator()){
            if (option.yes) option.yes();
        }else{
            this.getCompanyList(function(){
                if (option.id){
                    if (this.companyList.indexOf(option.id)!==-1){
                        if (option.yes) option.yes();
                    }else{
                        if (option.no) option.no();
                    }
                }else{
                    if (option.no) option.no();
                }
            }.bind(this));
        }
    },

    getCompanyList: function(callback){
        if (this.companyList===null){
            this.getAction();
            this.action.getCompanyAccess(function(json){
                if (json.data){
                    this.companyList = json.data;
                }else{
                    this.companyList = [];
                }
                if (callback) callback();
            }.bind(this), null, layout.desktop.session.user.id);
        }else{
            if (callback) callback();
        }
    },
    getAction: function(){
        if (!this.action) this.action = MWF.Actions.get("x_organization_assemble_control");
        //if (!this.action) this.action = new MWF.xApplication.Organization.Actions.RestActions();
    }

}

o2.require("MWF.widget.Dialog", null, false);
o2.xDesktop.Dialog = o2.DDL = new Class({
	Extends: o2.widget.Dialog,
    options : {
	    "zindex": null,
        "maxHeightPercent": "98%"
    },
//	_markShow: function(){
//
//		if (this.options.mark){
//			if (!this.markNode){
//				
//				this.markNode = new Element("div", {
//					styles: this.css.mark
//				}).inject($(document.body));
//				
//			}
////			if (this.options.markNode){
////				var size = this.options.markNode.getComputedSize();
////				var position = this.options.markNode.getPosition();
////				alert(size.totalHeight);
////				this.markNode.set("styles", {
////					"height": size.totalHeight+"px",
////					"width": size.totalWidth+"px",
////					"top": position.y,
////					"height": position.x
////				});
////
////			}else{
//				var size = MWF.getMarkSize();
//				this.markNode.set("styles", {
//					"height": size.y,
//					"width": size.x,
//					"top": "0xp",
//					"height": "0px"
//				});
////			}
//			
//			this.markNode.setStyle("display", "block");
//		}
//	},
	_markShow: function(){

		if (this.options.mark){
			if (!this.markNode){
				var size = MWF.getMarkSize(this.options.maskNode);
				var topNode = this.options.container || $(document.body);

                this.markNode = new Element("iframe", {
                    styles: this.css.mark
                }).inject(topNode);
                this.markNode.set("styles", {
                    "height": size.y,
                    "width": size.x
                });
				if (!this.markNode_up) this.markNode_up = new Element("div", { styles: this.css.mark }).inject(topNode);
                this.markNode_up.set("styles", {
                    "height": size.y,
                    "width": size.x
                });
			}
			this.markNode.setStyle("display", "block");
		}
	},
    setZindex: function(){
        if( o2.typeOf(this.options.zindex) === "number" && this.options.zindex > 0 ){
            this.css = Object.clone(this.css);
            this.css.from["z-index"] = this.options.zindex.toString();
            this.css.to["z-index"] = this.options.zindex.toString();
            this.css.mark["z-index"] = (this.options.zindex-1).toString();
        }
    },
	getDialogNode: function(){
        this.setZindex();

        this.width = this.options.width;
        this.height = this.options.height;

		this.node.set("styles", this.css.from);
		var topNode = this.options.container || $(document.body);
		this.node.inject(topNode);
//		this.node.addEvent("selectstart", function(e){
//		//	e.preventDefault();
//		});

		this.title = this.node.getElement(".MWF_dialod_title");
		this.titleCenter = this.node.getElement(".MWF_dialod_title_center");
		this.titleText = this.node.getElement(".MWF_dialod_title_text");
		this.titleAction = this.node.getElement(".MWF_dialod_title_action");
		this.content = this.node.getElement(".MWF_dialod_content");
		this.bottom = this.node.getElement(".MWF_dialod_bottom");
		this.resizeNode = this.node.getElement(".MWF_dialod_bottom_resize");
		this.button = this.node.getElement(".MWF_dialod_button");
        if( (!this.options.buttonList || this.options.buttonList.length === 0) && ( !this.options.buttons ) ){
            this.button.setStyle("display","none");
            this.buttonDisable = true;
        }else{
            this.okButton = this.node.getElement(".MWF_dialod_ok_button");
            this.cancelButton = this.node.getElement(".MWF_dialod_cancel_button");
        }
        this.backAction = this.node.getElement(".MWF_dialod_Action_back");

        if (!this.options.isTitle) {
            this.title.destroy();
            this.title = null;
            this.titleCenter = null;
            this.titleRefresh = null;
            this.titleText = null;
            this.titleAction = null;
        }

		if (this.title) this.setTitleEvent(); 
	//	if (this.titleText) this.getTitle();
		if (this.content) this.getContent();
		if (this.titleAction) this.getAction();
		if (this.resizeNode) this.setResizeNode();
	//	if (this.button) this.getButton();

		if (this.content) this.setContentSize();
        if (this.backAction)this.backAction.addEvent("click", this.close.bind(this))
	},
    getButton: function(){
        for (i in this.options.buttons){
            var button = new Element("input", {
                "type": "button",
                "value": i,
                "styles": this.css.button,
                "class": "mainColor_bg",
                "events": {
                    "click": this.options.buttons[i].bind(this)
                }
            }).inject(this.button);
        }
        if (this.options.buttonList){
            this.options.buttonList.each(function(bt){
                var styles = this.css.button;
                if( bt.type === "ok" && this.css.okButton )styles = this.css.okButton;
                if( bt.type === "cancel" && this.css.cancelButton )styles = this.css.cancelButton;
                if( bt.styles )styles = bt.styles;
                var button;
                if( bt.type === "ok" && this.okButton ){
                    button = this.okButton;
                    button.show();
                }else if( bt.type === "cancel" && this.cancelButton ){
                    button = this.cancelButton;
                    button.show();
                }else{
                    if( !bt.tag ){
                        button = new Element("input", {
                            "type": "button"
                        }).inject(this.button);
                    }else{
                        button = new Element( bt.tag, {}).inject(this.button);
                    }
                }

                if( button.get("type") === "button" ){
                    button.set({
                        "value": bt.text,
                        "title": bt.title,
                        "styles": styles,
                        "class": (bt.type!=="cancel") ? "mainColor_bg" : "",
                        "events": {
                            "click": function(e){bt.action.call(this, this, e)}.bind(this)
                        }
                    })
                }else{
                    button.set({
                        "text": bt.text,
                        "title": bt.title,
                        "styles": styles,
                        "class": (bt.type!=="cancel") ? "mainColor_bg" : "",
                        "events": {
                            "click": function(e){bt.action.call(this, this, e)}.bind(this)
                        }
                    })
                }
            }.bind(this));
        }
    },
    setTitleEvent: function(){
        var content;
        if( this.options.isMove ){
            if (layout.app) content = layout.app.content;
            if (layout.desktop.currentApp) content = layout.desktop.currentApp.content;
            this.containerDrag = new Drag.Move(this.node, {
                "handle": this.title,
                "container": this.options.positionNode || this.options.container || this.markNode || content,
                "snap": 5
            });
        }
    },
    getAction: function(){
        //未完成................................
        if (this.options.isClose){
            this.closeAction = new Element("div", {"styles": this.css.closeAction}).inject(this.titleAction);
            this.closeAction.addEvent("click", this.close.bind(this));
        }
        if (this.options.isMax){
            this.maxAction = new Element("div", {"styles": this.css.maxAction}).inject(this.titleAction);
            this.maxAction.addEvent("click", this.maxSize.bind(this));

            this.restoreAction = new Element("div", {"styles": this.css.restoreAction}).inject(this.titleAction);
            this.restoreAction.hide();
            this.restoreAction.addEvent("click", this.restoreSize.bind(this));

            if (this.title){
                this.title.addEvent("dblclick", function(){
                    this.switchMax();
                }.bind(this));
            }
        }
    },
    switchMax : function(){
        if( !this.isMax ){
            this.maxSize();
        }else{
            this.restoreSize();
        }
    },
    maxSize: function(){
        //if(!this.oldCoordinate)this.oldCoordinate = {
        //    height : this.options.height,
        //    width : this.options.width,
        //    top : this.options.top,
        //    left : this.options.left,
        //    fromTop : this.options.fromTop,
        //    fromLeft : this.options.fromLeft,
        //    contentHeight : this.options.contentHeight,
        //    contentWidth : this.options.contentWidth,
        //    maxHeightPercent : this.options.maxHeightPercent,
        //    maxHeight : this.options.maxHeight,
        //    maxWidth : this.options.maxWidth
        //};
        //if( !this.oldSize ){
        //    this.oldSize = {
        //        "width" : this.width,
        //        "height" : this.height
        //    }
        //}
        if( !this.oldNodeSize ){
            this.oldNodeSize = {
                "width" : this.nodeWidth,
                "height" : this.nodeHeight
            }
        }
        if( !this.oldContentSize ){
            this.oldContentSize = {
                "width" : this.contentWidth,
                "height" : this.contentHeight
            }
        }

        var container = $(document.body);
        if (layout.desktop.currentApp){
            container = layout.desktop.currentApp.content;
        }else if (this.options.container){
            if (this.options.container.getSize().y<$(document.body).getSize().y){
                container = this.options.container;
            }
        }
        var containerSize = container.getSize();
        this.options.width = containerSize.x;
        this.options.height = containerSize.y;

        this.setContentSize( containerSize.y, containerSize.x );
        this.node.setStyles({
            width : containerSize.x + "px",
            height : containerSize.y + "px",
            top : "0px",
            left : "0px"
        });

        this.maxAction.setStyle("display","none");
        this.restoreAction.setStyle("display","");
        this.isMax = true;
        this.fireEvent("max");
    },
    restoreSize : function(){

        this.contentHeight = this.oldContentSize.height;
        this.contentWidth = this.oldContentSize.width;

        this.nodeHeight = this.oldNodeSize.height;
        this.nodeWidth = this.oldNodeSize.width;

        this.content.setStyles( this.oldContentSize );

        this.node.setStyles( this.oldNodeSize );

        this.reCenter();

        this.maxAction.setStyle("display","");
        this.restoreAction.setStyle("display","none");
        this.isMax = false;
        this.fireEvent("restore");
    },
    reCenter: function(){
	    var size;
	    if( this.node.offsetParent === null ){ //如果是隐藏的
            size = this.node.measure(function(){
                return this.getSize();
            });
        }else{
            size = this.node.getSize();
        }

        if( this.options.positionWidth ){
            size.x = parseInt(this.options.positionWidth);
        }
        if( this.options.positionHeight ){
            size.y = parseInt(this.options.positionHeight);
        }

        var container = $(document.body);
        if( this.options.positionNode && this.options.positionNode.getSize().y<$(document.body).getSize().y ){
            container = this.options.positionNode;
        }else if (layout.desktop.currentApp){
            container = layout.desktop.currentApp.content;
        }else{
            if (this.options.container){
                if (this.options.container.getSize().y<$(document.body).getSize().y){
                    container = this.options.container;
                }
            }
        }

        var p = o2.getCenter(size, container, container);
        if (p.y< ( this.options.minTop || 0 ) ) p.y = this.options.minTop || 0;
        this.options.top = p.y;
        this.options.left = p.x;
        this.css.to.top = this.options.top+"px";
        this.css.to.left = this.options.left+"px";
        this.node.setStyles({
            "top": this.css.to.top,
            "left": this.css.to.left
        });
    },
    getOffsetY : function(node){
        return (node.getStyle("margin-top").toInt() || 0 ) +
            (node.getStyle("margin-bottom").toInt() || 0 ) +
            (node.getStyle("padding-top").toInt() || 0 ) +
            (node.getStyle("padding-bottom").toInt() || 0 )+
            (node.getStyle("border-top-width").toInt() || 0 ) +
            (node.getStyle("border-bottom-width").toInt() || 0 );
    },
    getOffsetX : function(node){
        return (node.getStyle("margin-left").toInt() || 0 ) +
            (node.getStyle("margin-right").toInt() || 0 ) +
            (node.getStyle("padding-left").toInt() || 0 ) +
            (node.getStyle("padding-right").toInt() || 0 )+
            (node.getStyle("border-left-width").toInt() || 0 ) +
            (node.getStyle("border-right-width").toInt() || 0 );
    },
    getMarginY : function(node){
        return (node.getStyle("margin-top").toInt() || 0 ) +
            (node.getStyle("margin-bottom").toInt() || 0 );
    },
    getMarginX : function(node){
        return (node.getStyle("margin-left").toInt() || 0 ) +
            (node.getStyle("margin-right").toInt() || 0 );
    },
    getContentMaxHeight: function(){
        var maxHeight = this.getMaxHeight();
        var offsetY = 0;
        if( this.title )offsetY = offsetY + this.getOffsetY( this.title ) + this.title.getSize().y;
        if( this.bottom )offsetY = offsetY + this.getOffsetY( this.bottom ) + this.bottom.getSize().y;
        if( this.button && !this.buttonDisable )offsetY = offsetY + this.getOffsetY( this.button ) + this.button.getSize().y;
        if( this.content )offsetY = offsetY + this.getMarginY( this.content );
        return maxHeight - offsetY;
    },
    setContentHeightAuto : function(){
        var maxHeight = this.getMaxHeight();

        var offsetY = 0;
        var y = 0;
        //y = y + getOffsetY( this.title ) + this.title.getSize().y; //this.titleNode.getStyle("height").toInt();
        if( this.title )offsetY = offsetY + this.getOffsetY( this.title ) + this.title.getSize().y;
        if( this.bottom )offsetY = offsetY + this.getOffsetY( this.bottom ) + this.bottom.getSize().y;
        if( this.button && !this.buttonDisable )offsetY = offsetY + this.getOffsetY( this.button ) + this.button.getSize().y;
        if( this.content ){
            offsetY = offsetY + this.getMarginY( this.content );
            y = offsetY + this.content.getSize().y;
        }else{
            y = offsetY;
        }


        if (  typeOf(maxHeight) === "number" && y > maxHeight) {
            this.options.height = maxHeight;
            this.options.contentHeight = null;
            this.options.fromTop = this.options.fromTop.toFloat() - offsetY / 2;
            this.options.top = this.options.top.toFloat() - offsetY / 2;
            this.css.to.height = maxHeight + "px";
            this.css.to.top = this.options.top + "px";
            this.css.from.top = this.options.fromTop + "px";
            this.node.setStyles({
                "height": maxHeight
            });
            this.contentHeight = maxHeight - offsetY;
            if (this.content) {
                this.content.setStyles({
                    "height" : maxHeight - offsetY,
                    "overflow-y": "auto"
                })
            }
        }else{
            this.options.height = y;
            this.options.contentHeight = null;
            this.options.fromTop = this.options.fromTop.toFloat() - offsetY / 2;
            this.options.top = this.options.top.toFloat() - offsetY / 2;
            this.css.to.height = y + "px";
            this.css.to.top = this.options.top + "px";
            this.css.from.top = this.options.fromTop + "px";
            this.node.setStyles({
                "height": y
            });
            this.contentHeight = y - offsetY;
            if (this.content) {
                this.content.setStyles({
                    "height" : y - offsetY,
                    "overflow-y": "hidden"
                })
            }
        }
    },
    getMaxHeight : function(){
        var maxHeightPercent;
        if( this.options.maxHeightPercent ){
            maxHeightPercent = this.options.maxHeightPercent;
            if( typeOf(maxHeightPercent) === "string" && maxHeightPercent.substr(maxHeightPercent.length - 1, 1) === "%" ) {
                var containerHeight = ( this.options.positionNode || this.options.container || $(document.body)).getSize().y;
                maxHeightPercent = parseInt(containerHeight * parseInt(maxHeightPercent) / 100);

                if( maxHeightPercent + (this.options.minTop || 0) > containerHeight ){
                    maxHeightPercent = containerHeight - (this.options.minTop)
                }
            }
        }

        var maxHeight;
        if( this.options.maxHeight && parseFloat( this.options.maxHeight ).toString() !== "NaN" ){
            maxHeight = parseFloat( this.options.maxHeight );
            if( typeOf(maxHeightPercent) === "number" ){
                maxHeight = Math.min( maxHeight, maxHeightPercent )
            }
        }else if( typeOf(maxHeightPercent) === "number" ){
            maxHeight = maxHeightPercent;
        }
        return maxHeight;
    },
    getNodeSize: function(){
        return {
            "height": this.nodeHeight+"px",
            "width": this.nodeWidth+"px"
        };
    },
    getContentSize: function(height, width){
        var nodeHeight, nodeWidth;
        if (!height){
            if (this.options.contentHeight){
                nodeHeight = height = this.options.contentHeight.toFloat();
                this.contentHeight = height;
            }else{
                height = this.options.height.toFloat();

                var maxHeight = this.getMaxHeight();
                if( typeOf(maxHeight) === "number" &&  maxHeight < height ){
                    height = maxHeight;
                }

                this.nodeHeight = height;
            }
        }else{
            this.nodeHeight = height;
        }
        if (!width){
            if (this.options.contentWidth){
                nodeWidth = width = this.options.contentWidth.toFloat();
                this.contentWidth = width;
            }else{
                width = this.options.width.toFloat();
                this.nodeWidth = width;
            }
        }else{
            this.nodeWidth = width;
        }

        var offsetHeight = 0;
        var offsetWidth = 0;
        if (this.title){
            var h1 = this.title.getSize().y;
            var ptop1 = this.title.getStyle("padding-top").toFloat();
            var pbottom1 = this.title.getStyle("padding-bottom").toFloat();
            var mtop1 = this.title.getStyle("margin-top").toFloat();
            var mbottom1 = this.title.getStyle("margin-bottom").toFloat();
            offsetHeight += h1 + ptop1 + pbottom1 + mtop1 + mbottom1;
        }
        if (this.bottom){
            var h2 = this.bottom.getSize().y;
            var ptop2 = this.bottom.getStyle("padding-top").toFloat();
            var pbottom2 = this.bottom.getStyle("padding-bottom").toFloat();
            var mtop2 = this.bottom.getStyle("margin-top").toFloat();
            var mbottom2 = this.bottom.getStyle("margin-bottom").toFloat();

            offsetHeight += h2 + ptop2 + pbottom2 + mtop2 + mbottom2;
        }
        if (this.button && !this.buttonDisable){
            var h3 = this.button.getSize().y;
            var ptop3 = this.button.getStyle("padding-top").toFloat();
            var pbottom3 = this.button.getStyle("padding-bottom").toFloat();
            var mtop3 = this.button.getStyle("margin-top").toFloat();
            var mbottom3 = this.button.getStyle("margin-bottom").toFloat();

            offsetHeight += h3 + ptop3 + pbottom3 + mtop3 + mbottom3;
        }

        var ptop4 = this.content.getStyle("padding-top").toFloat();
        var pbottom4 = this.content.getStyle("padding-bottom").toFloat();
        var mtop4 = this.content.getStyle("margin-top").toFloat();
        var mbottom4 = this.content.getStyle("margin-bottom").toFloat();
        offsetHeight += ptop4 + pbottom4 + mtop4 + mbottom4;

        if (nodeHeight){
            nodeHeight = nodeHeight + offsetHeight+2;
        }else {
            height = height - offsetHeight;
        }

        //if (this.content.getParent().getStyle("overflow-x")!="hidden" ) height = height-18;

        var pleft = this.content.getStyle("padding-left").toFloat();
        var pright = this.content.getStyle("padding-right").toFloat();
        var mleft = this.content.getStyle("margin-left").toFloat();
        var mright = this.content.getStyle("margin-right").toFloat();
        offsetWidth = pleft+pright+mleft+mright;
        //width = width-pleft-pright-mleft-mright;
        //if (this.content.getParent().getStyle("overflow-y")!="hidden" ) width = width-18;
        if (nodeWidth){
            nodeWidth = nodeWidth+offsetWidth;
        }else{
            width = width-offsetWidth;
        }


        if (nodeHeight) {
            this.nodeHeight = nodeHeight;
            this.options.height = nodeHeight;
            this.options.contentHeight = null;
            this.options.fromTop = this.options.fromTop.toFloat()-offsetHeight/2;
            this.options.top = this.options.top.toFloat()-offsetHeight/2;
            this.css.to.height = nodeHeight+"px";
            this.css.to.top = this.options.top+"px";
            this.css.from.top = this.options.fromTop+"px";
        }else{
            this.contentHeight = height;
        }

        if (nodeWidth){
            this.nodeWidth = nodeWidth;
            this.options.width = nodeWidth;
            this.options.contentWidth = null;
            this.options.fromLeft = this.options.fromLeft.toFloat()-offsetWidth/2;
            this.options.left = this.options.left.toFloat()-offsetWidth/2;
            this.css.to.width = nodeWidth+"px";
            this.css.to.left = this.options.left+"px";
            this.css.from.left = this.options.fromLeft+"px";
        }else{
            this.contentWidth = width;
        }

        if (!height || height<0){
            this.content.setStyles({"overflow": "hidden", "height": "auto", "width": ""+width+"px"});
            height = this.content.getSize().y;
            var h = height + h1 + ptop1 + pbottom1 + mtop1 + mbottom1;
            h = h + h2 + ptop2 + pbottom2 + mtop2 + mbottom2;
            h = h + h3 + ptop3 + pbottom3 + mtop3 + mbottom3;
            h = h + ptop4 + pbottom4 + mtop4 + mbottom4;
            this.css.to.height = h;
        }

//		var ptop5 = this.node.getStyle("padding-top").toFloat();
//		var pbottom5 = this.node.getStyle("padding-bottom").toFloat();
//		height = height - ptop5 - pbottom5;

        return {"height": height+"px", "width": width+"px"};
    },
    setContentHeight: function(height){
        var nodeHeight;
        if (!height){
            if (this.options.contentHeight){
                nodeHeight = height = this.options.contentHeight.toFloat();
                this.contentHeight = height;
            }else{
                height = this.options.height.toFloat();

                var maxHeight = this.getMaxHeight();
                if( typeOf(maxHeight) === "number" &&  maxHeight < height ){
                    height = maxHeight;
                }

                this.nodeHeight = height;
            }
        }else{
            this.nodeHeight = height;
        }

        var offsetHeight = 0;
        if (this.title){
            var h1 = this.title.getSize().y;
            //offsetHeight += h1 + this.getOffsetY(this.title);
            var ptop1 = this.title.getStyle("padding-top").toFloat();
            var pbottom1 = this.title.getStyle("padding-bottom").toFloat();
            var mtop1 = this.title.getStyle("margin-top").toFloat();
            var mbottom1 = this.title.getStyle("margin-bottom").toFloat();

            offsetHeight += h1 + ptop1 + pbottom1 + mtop1 + mbottom1;
        }
        if (this.bottom){
            var h2 = this.bottom.getSize().y;
            //offsetHeight += h2 + this.getOffsetY(this.bottom);
            var ptop2 = this.bottom.getStyle("padding-top").toFloat();
            var pbottom2 = this.bottom.getStyle("padding-bottom").toFloat();
            var mtop2 = this.bottom.getStyle("margin-top").toFloat();
            var mbottom2 = this.bottom.getStyle("margin-bottom").toFloat();

            offsetHeight += h2 + ptop2 + pbottom2 + mtop2 + mbottom2;
        }
        if (this.button && !this.buttonDisable){
            var h3 = this.button.getSize().y;
            //offsetHeight += h3 + this.getOffsetY(this.button);

            var ptop3 = this.button.getStyle("padding-top").toFloat();
            var pbottom3 = this.button.getStyle("padding-bottom").toFloat();
            var mtop3 = this.button.getStyle("margin-top").toFloat();
            var mbottom3 = this.button.getStyle("margin-bottom").toFloat();

            offsetHeight += h3 + ptop3 + pbottom3 + mtop3 + mbottom3;
        }

        //offsetHeight +=  this.getOffsetY(this.content);
        var ptop4 = this.content.getStyle("padding-top").toFloat();
        var pbottom4 = this.content.getStyle("padding-bottom").toFloat();
        var mtop4 = this.content.getStyle("margin-top").toFloat();
        var mbottom4 = this.content.getStyle("margin-bottom").toFloat();
        offsetHeight += ptop4 + pbottom4 + mtop4 + mbottom4;


        if (nodeHeight){
            nodeHeight = nodeHeight + offsetHeight+2;
        }else {
            height = height - offsetHeight;
        }

        if (nodeHeight) {
            this.nodeHeight = nodeHeight;
            this.options.height = nodeHeight;
            this.options.contentHeight = null;
            this.options.fromTop = this.options.fromTop.toFloat()-offsetHeight/2;
            this.options.top = this.options.top.toFloat()-offsetHeight/2;
            this.css.to.height = nodeHeight+"px";
            this.css.to.top = this.options.top+"px";
            this.css.from.top = this.options.fromTop+"px";
        }else{
            this.contentHeight = height;
        }
        //if (nodeWidth){
        //    this.nodeWidth = nodeWidth;
        //    this.options.width = nodeWidth;
        //    this.options.contentWidth = null;
        //    this.options.fromLeft = this.options.fromLeft.toFloat()-offsetWidth/2;
        //    this.options.left = this.options.left.toFloat()-offsetWidth/2;
        //    this.css.to.width = nodeWidth+"px";
        //    this.css.to.left = this.options.left+"px";
        //    this.css.from.left = this.options.fromLeft+"px";
        //}else{
        //    this.contentWidth = width;
        //}

        if (!height || height<0){
            this.content.setStyles({"overflow": "hidden", "height": "auto"});
            height = this.content.getSize().y;
            var h = height + h1 + ptop1 + pbottom1 + mtop1 + mbottom1;
            h = h + h2 + ptop2 + pbottom2 + mtop2 + mbottom2;
            h = h + h3 + ptop3 + pbottom3 + mtop3 + mbottom3;
            h = h + ptop4 + pbottom4 + mtop4 + mbottom4;
            this.css.to.height = h;
        }else{
            this.content.setStyles( {"height" : height} )
        }

    },
    setContentWidthAuto : function(){
        var maxWidth = this.options.maxWidth || "100%";
        if( typeOf(maxWidth) === "string" && maxWidth.substr(maxWidth.length - 1, 1) === "%" ) {
            var containerWidth = ( this.options.positionNode || this.options.container || $(document.body)).getSize().x;
            maxWidth = parseInt(containerWidth * parseInt(maxWidth) / 100);
        }

        var offsetX = 0;
        var x = 0;
        if( this.content ){
            offsetX = offsetX + this.getMarginX( this.content );
            x = offsetX + this.content.getSize().x;
        }else{
            x = offsetX;
        }


        if ( x > maxWidth) {
            this.nodeWidth = maxWidth;
            this.options.width = maxWidth;
            this.options.contentWidth = null;
            this.options.fromLeft = this.options.fromLeft.toFloat() - offsetX / 2;
            this.options.left = this.options.left.toFloat() - offsetX / 2;
            this.css.to.width = maxWidth + "px";
            this.css.to.left = this.options.left + "px";
            this.css.from.left = this.options.fromLeft + "px";
            this.node.setStyles({
                "width": maxWidth
            });

            this.contentWidth = maxWidth - this.getOffsetX(this.content);
            if (this.content) {
                this.content.setStyles({
                    "width" : this.contentWidth,
                    "overflow-x": "auto"
                })
            }
        }else{
            this.nodeWidth = x;
            this.options.width = x;
            this.options.contentHeight = null;
            this.options.fromLeft = this.options.fromLeft.toFloat() - offsetX / 2;
            this.options.left = this.options.left.toFloat() - offsetX / 2;
            this.css.to.width = x + "px";
            this.css.to.left = this.options.left + "px";
            this.css.from.left = this.options.fromLeft + "px";
            this.node.setStyles({
                "width": x
            });
            this.contentWidth = x - this.getOffsetX(this.content);
            if (this.content) {
                this.content.setStyles({
                    "width" : this.contentWidth,
                    "overflow-x": "hidden"
                })
            }
        }
    },
    setContentWidth: function(width){
        var nodeWidth;
        if (!width){
            if (this.options.contentWidth){
                nodeWidth = width = this.options.contentWidth.toFloat();
                this.contentWidth = width;
            }else{
                width = this.options.width.toFloat();
                this.nodeWidth = width;
            }
        }else{
            this.nodeWidth = width;
        }


        var offsetWidth = 0;

        //if (this.content.getParent().getStyle("overflow-x")!="hidden" ) height = height-18;

        var pleft = this.content.getStyle("padding-left").toFloat();
        var pright = this.content.getStyle("padding-right").toFloat();
        var mleft = this.content.getStyle("margin-left").toFloat();
        var mright = this.content.getStyle("margin-right").toFloat();
        offsetWidth = pleft+pright+mleft+mright;
        //width = width-pleft-pright-mleft-mright;
        //if (this.content.getParent().getStyle("overflow-y")!="hidden" ) width = width-18;
        if (nodeWidth){
            nodeWidth = nodeWidth+offsetWidth;
        }else{
            var x = width;
            width = width-offsetWidth;
        }

        if (nodeWidth){
            this.nodeWidth = nodeWidth;
            this.options.width = nodeWidth;
            this.options.contentWidth = null;
            this.css.to.left = this.options.left+"px";
            this.css.from.left = this.options.fromLeft+"px";
            this.css.to.width = nodeWidth+"px";
            this.options.fromLeft = this.options.fromLeft.toFloat()-offsetWidth/2;
            this.options.left = this.options.left.toFloat()-offsetWidth/2;
            this.node.setStyle("width", nodeWidth )
        }else{
            this.contentWidth = width;
            this.node.setStyle("width", x )
        }

        this.content.setStyles( {"width" : width} )

    },
    setContentSize: function(height, width){

        //this.content.setStyle("height", this.getContentSize(height));
        // if (!this.options.height && !height){
        //    this.content.setStyle("height", "auto");
        //    this.content.setStyle("overflow", "hidden");
        //    this.content.setStyle("width", "auto");
        // }else{
        var y = height;
        if (!y){
            if (this.options.contentHeight){
                y = this.options.contentHeight;
            }else{
                y = this.height;
            }
        }

        var x = width;
        if (!x){
            if (this.options.contentWidth){
                x = this.options.contentWidth;
            }else{
                x = this.width;
            }
        }
        if( y === "auto" || x === "auto" ){
            if( y === "auto" ){
                this.setContentHeightAuto();
            }else{
                this.setContentHeight( height );
            }
            if( x === "auto" ){
                this.setContentWidthAuto();
            }else{
                this.setContentWidth( width );
            }
        }else{
            this.content.setStyles(this.getContentSize(height, width));
            this.content.setStyle("width", "auto");
        }
    }
});
o2.DL.open = function(options){

    if (!options) options = {};
    if (!options.style) options.style = "user";
    //if (!options.transition) options.transition = Fx.Transitions.Back.easeOut;
    if (!options.duration) options.duration = 200;
    if (options.isClose!==false) options.isClose = true;

    var size;
    if ((!options.width || options.width=="auto") && !options.contentWidth){
        if (options.content){
            options.content.show();
            size = options.content.getComputedSize();
            options.contentWidth = size.totalWidth.toFloat();
        }
    }
    if ((!options.height || options.height=="auto") && !options.contentHeight){
        if (options.content){
            if (!size){
                options.content.show();
                size = options.content.getComputedSize();
            }
            options.contentHeight = size.totalHeight.toFloat()+2;
        }
    }
    if (!options.width && !options.contentWidth) options.width = 300;
    if (!options.height && !options.contentHeight) options.height = 150;

    if (!options.container && layout){
        if (layout.desktop.currentApp){
            options.container = layout.desktop.currentApp.content;
        }
    }
    var container = (options.positionNode || options.container || $(document.body));

    if( options.width !== "auto" && options.height !== "auto" ){

        //如果是百分比
        if( "string" == typeOf(options.width)  && (1 < options.width.length && "%" == options.width.substr(options.width.length - 1, 1)) ){
            options.width = parseInt( container.getSize().x * parseInt(options.width, 10) / 100, 10);
        }

        if( "string" == typeOf(options.height)  && (1 < options.height.length && "%" == options.height.substr(options.height.length - 1, 1)) ){
            options.height = parseInt( container.getSize().y * parseInt(options.height, 10) / 100, 10);
        }

        if ((options.top===undefined ) && (options.left===undefined)){
            var p = o2.getCenter({"x":(options.width || options.contentWidth), "y": (options.height || options.contentHeight+120)}, container, container);
            options.top = (p.y<0) ? 0 : p.y;
            options.left  = (p.x<0) ? 0 : p.x;
        }
        if ((options.fromTop===undefined ) && (options.fromLeft===undefined)){
            var p = o2.getCenter({"x":(options.width || options.contentWidth)*0, "y": (options.height || options.contentHeight+120)*0}, container, container);
            options.fromTop = (p.y<0) ? 0 : p.y;
            options.fromLeft  = (p.x<0) ? 0 : p.x;
        }
        if (options.offset){
            if (options.offset.y){
                options.top = options.top+options.offset.y.toInt();
                options.fromTop = options.fromTop+options.offset.y.toInt();
            }
            if (options.offset.x){
                options.left = options.left+options.offset.x.toInt();
                options.fromLeft = options.fromLeft+options.offset.x.toInt();
            }
        }
        if (options.top<0) options.top = 0;
        if (options.left<0) options.left = 0;
        if (options.fromTop<0) options.fromTop = 0;
        if (options.fromLeft<0) options.fromLeft = 0;
    }else{
        if(options.top===undefined )options.top = 0;
        if(options.left===undefined)options.left = 0;
        if(options.fromTop===undefined)options.fromTop = 0;
        if(options.fromLeft===undefined)options.fromLeft = 0;
    }


    options.mark = !(options.mask===false);

    var dlg = new o2.DDL(options);
    if( options.width === "auto" || options.height === "auto" ){
        dlg.addEvent("postShow", function(){this.reCenter()});

    }
    dlg.show();
    return dlg;
};

MWF.xDesktop = MWF.xDesktop || {};
MWF.require("MWF.widget.Menu", null, false);
MWF.xDesktop.Menu = new Class({
	Extends: MWF.widget.Menu,
	Implements: [Options, Events],
	options: {
		"style": "default",
		"event": "contextmenu",
		"disable": false,
		"top": -1,
		"left": -1,
        "container": null,
		"where": {"x": "left", "y": "bottom"}
	},
	load: function(){
		if (this.fireEvent("queryLoad")){
			this.node = new Element("div#menu");
			this.node.set("styles", this.css.container);
			
			if (this.options.event){
				if (this.target) this.target.addEvent(this.options.event, this.showIm.bind(this));
			}
			this.borderNode = new Element("div.MWFMenu", {
				"styles": this.css.borderNode
			}).inject(this.options.container || $(document.body));
			
			this.node.inject(this.borderNode);

			this.hide = this.hideMenu.bind(this);
			this.fireEvent("postLoad");
		}
	},
	showIm: function(e){
		if (!this.options.disable){
			this.hide = this.hideIm.bind(this);
			if (this.fireEvent("queryShow", [e])){
				this.tmpBodyOncontextmenu = document.body.oncontextmenu;
				document.body.oncontextmenu = function(){return false;};
				if (this.pauseCount<=0){
					this.setItemWidth();
					
					var i = MWF.xDesktop.zIndexPool ? MWF.xDesktop.zIndexPool.zIndex : 0;
					
					this.borderNode.setStyles({
						"display": "block",
						"opacity": this.options.opacity || 1,
						"z-index": i
					});
					
					this.setPosition(e);
					
					$(document.body).removeEvent("mousedown", this.hide);
					$(document.body).addEvent("mousedown", this.hide);
					
					this.show = true;
				}else{
					this.pauseCount--;
				}

				var p = this.node.getPosition(document.body);
				var size = this.node.getSize();
				var bodySize = document.body.getSize();
				if (p.y+size.y+10>bodySize.y){
					var y = bodySize.y-p.y-10;
					this.node.setStyle("height", ""+y+"px");
					this.node.addEvent("mousedown", function(e){ e.stopPropagation(); })
				}

				this.fireEvent("postShow");
			}
		}
	},
	hideIm: function(all){
		if (this.fireEvent("queryHide")){
			$(document.body).removeEvent("mousedown", this.hide);
			this.borderNode.set("styles", {
				"display": "none",
				"opacity": 0
			});
			this.show = false;
			document.body.oncontextmenu = this.tmpBodyOncontextmenu;
			this.tmpBodyOncontextmenu = null;
			
			if (all) if (this.topMenu) this.topMenu.hideIm();
			
			this.fireEvent("postHide");
		}
	},
	setPosition: function(e){
		var position = this.target.getPosition(this.target.getOffsetParent());
		var size = this.target.getSize();
        this.borderNode.show();
        var nodeSize = this.borderNode.getSize();

        var left=0, top=0;
        switch (this.options.where.x.toLowerCase()){
			case "right":
                left = position.x-nodeSize.x+size.x;
				break;
			default:
                left = position.x-0;
		}
        switch (this.options.where.y.toLowerCase()){
            case "top":
                top = position.y-nodeSize.y;
                break;
            default:
                top = position.y+size.y;
        }
		//(this.options.where)


		if (this.options.offsetY) top = top+this.options.offsetY;
		if (this.options.offsetX) left = left+this.options.offsetX;

        var bodySize = $(document.body).getSize();
        var borderSize = this.borderNode.getSize();
        if (left+borderSize.x>bodySize.x) left = bodySize.x-borderSize.x-10;
		
		this.borderNode.setStyle("top", top);
		this.borderNode.setStyle("left", left);
	}
});










MWF.xDesktop = MWF.xDesktop || {};
MWF.xApplication = MWF.xApplication || {};
MWF.require("MWF.xDesktop.Actions.RestActions", null, false);

MWF.xDesktop.UserData = MWF.UD = {
    getAction: function(){
        //this.action = new MWF.xDesktop.Actions.RestActions("/xDesktop/Actions/action.json", "x_organization_assemble_personal");
        this.action = o2.Actions.get("x_organization_assemble_personal");
    },
    getData: function(name, callback, async){
        if (!this.action) this.getAction();
        this.action.getUserData(name, function(json){
            if (callback) callback(json);
        }, null, async);
    },
    getDataJson: function(name, callback, async){
        if (!this.action) this.getAction();
        this.action.getUserData(name, function(json){
            var returnJson = null;
            if (json.data){
                try{
                    returnJson = JSON.decode(json.data);
                }catch(e){}
            }
            if (callback) callback(returnJson);
        }, null, async);
    },

    putData: function(name, data, callback, async){
        if (!this.action) this.getAction();
        this.action.putUserData(name, data, function(json){
            if (callback) callback(json);
        }, null, async)

        // this.action.invoke({"name": "putUserData", "async": async, "data": data, "parameter": {"name": name}, "success": function(json){
        //     if (callback) callback(json);
        // }.bind(this)});
    },
    deleteData: function(name, callback, async){
        if (!this.action) this.getAction();
        this.action.deleteUserData(name, function(json){
            if (callback) callback(json);
        }, null, async)

        // this.action.invoke({"name": "deleteUserData", "async": async, "parameter": {"name": name}, "success": function(json){
        //     if (callback) callback(json);
        // }.bind(this)});
    },

    getPublicData: function(name, callback, async){
        if (!this.action) this.getAction();
        this.action.getPublicUserData(name, function(json){
            var returnJson = null;
            if (json.data){
                try{
                    returnJson = JSON.decode(json.data);
                }catch(e){}
            }
            if (callback) callback(returnJson);
        }, null, async)

        // this.action.invoke({"name": "getPublicUserData", "async": async, "parameter": {"name": name}, "success": function(json){
        //     var returnJson = null;
        //     if (json.data) returnJson = JSON.decode(json.data);
        //     if (callback) callback(returnJson);
        // }.bind(this)});
    },
    putPublicData: function(name, data, callback, async){
        if (!this.action) this.getAction();

        this.action.putPublicUserData(name, data, function(json){
            if (callback){
                if (callback.success){
                    callback.success(json);
                }else{
                    callback(json);
                }
            }
        }, function(xhr, text, error){
            if (xhr.status!=0){
                var errorText = error;
                if (xhr){
                    var json = JSON.decode(xhr.responseText);
                    if (json){
                        errorText = json.message.trim() || "request json error";
                    }else{
                        errorText = "request json error: "+xhr.responseText;
                    }
                }
                MWF.xDesktop.notice("error", {x: "right", y:"top"}, errorText);
            }
            if (callback) if (callback.failure) callback.failure(xhr, text, error);
        }, async);

        // this.action.invoke({"name": "putPublicUserData", "async": async, "data": data, "parameter": {"name": name}, "success": function(json){
        //     if (callback){
        //         if (callback.success){
        //             callback.success(json);
        //         }else{
        //             callback(json);
        //         }
        //     }
        // }.bind(this), "failure": function(xhr, text, error){
        //     if (xhr.status!=0){
        //         var errorText = error;
        //         if (xhr){
        //             var json = JSON.decode(xhr.responseText);
        //             if (json){
        //                 errorText = json.message.trim() || "request json error";
        //             }else{
        //                 errorText = "request json error: "+xhr.responseText;
        //             }
        //         }
        //         MWF.xDesktop.notice("error", {x: "right", y:"top"}, errorText);
        //     }
        //     if (callback) if (callback.failure) callback.failure(xhr, text, error);
        // }});
    },
    deletePublicData: function(name, callback, async){
        if (!this.action) this.getAction();
        this.action.deletePublicUserData(name, function(json){
            if (callback) callback(json);
        }, null, async);

        // this.action.invoke({"name": "deletePublicUserData", "async": async, "parameter": {"name": name}, "success": function(json){
        //     if (callback) callback(json);
        // }.bind(this)});
    }
};

MWF.xApplication.Template = MWF.xApplication.Template || {};
//MWF.xDesktop.requireApp("Template", "lp." + MWF.language, null, false);
MWF.xApplication.Template.MPopupForm = MPopupForm = new Class({
    Extends: MWF.widget.Common,
    Implements: [Options, Events],
    options: {
        "style": "default",
        "width": 500,
        "height": 450,
        "top": null,
        "left": null,
        "bottom" : null,
        "right" : null,
        "minWidth" : 300,
        "minHeight" : 220,

        "isLimitSize": true,
        "ifFade": true,
        "hasTop": false,
        "hasTopIcon" : false,
        "hasTopContent" : false,
        "hasIcon": true,
        "hasMask" : true,
        "closeByClickMask" : false,
        "hasScroll" : true,
        "scrollType" : "",

        "title": "",
        "draggable": false,
        "resizeable" : false,
        "maxAction" : false,
        "closeAction": true,
        "okClass": "",
        "topClass": "",

        "relativeToApp" : true,
        "sizeRelateTo" : "app", //desktop
        "resultSeparator" : ",",

        "hasBottom": true,
        "hideBottomWhenReading": false,
        "closeByClickMaskWhenReading" : false,
        "buttonList" : [{ "type":"cancel", "text": "" },{ "type":"ok", "text": "" }]
    },
    initialize: function (explorer, data, options, para) {
        this.setOptions(options);
        this.explorer = explorer;
        if( para ){
            if( this.options.relativeToApp ){
                this.app = para.app || this.explorer.app;
                this.container = para.container || this.app.content;
                this.lp = para.lp || this.explorer.lp || this.app.lp;
                this.css = para.css || this.explorer.css || this.app.css;
                this.actions = para.actions || this.explorer.actions || this.app.actions || this.app.restActions;
            }else{
                this.container = para.container;
                this.lp = para.lp || this.explorer.lp;
                this.css = para.css || this.explorer.css;
                this.actions = para.actions || this.explorer.actions;
            }
        }else{
            if( this.options.relativeToApp ){
                this.app = this.explorer.app;
                this.container = this.app.content;
                this.lp = this.explorer.lp || this.app.lp;
                this.css = this.explorer.css || this.app.css;
                this.actions = this.explorer.actions || this.app.actions || this.app.restActions;
            }else{
                this.container = window.document.body;
                this.lp = this.explorer.lp;
                this.css = this.explorer.css;
                this.actions = this.explorer.actions;
            }
        }
        this.data = data || {};

        this.cssPath = "../x_component_Template/$MPopupForm/"+this.options.style+"/css.wcss";

        this.load();
    },
    load: function () {
        this._loadCss();
    },
    _loadCss: function(reload){
        var css = {};
        var key = encodeURIComponent(this.cssPath);
        if (!reload && o2.widget.css[key]){
            css = Object.clone(o2.widget.css[key]);
        }else{
            var r = new Request.JSON({
                url: o2.filterUrl(this.cssPath),
                secure: false,
                async: false,
                method: "get",
                noCache: false,
                onSuccess: function(responseJSON, responseText){
                    o2.widget.css[key] = responseJSON;
                    css = Object.clone(responseJSON);
                }.bind(this),
                onError: function(text, error){
                    alert(error + text);
                }
            });
            r.send();
       }

        var isEmptyObject = true;
        for( var key in css ){
            if(key){
                isEmptyObject = false;
                break;
            }
        }
        if( !isEmptyObject ){
            this.css = Object.merge(  css, this.css || {});
        }else if( !this.css ){
            this.css = {};
        }
    },
    reload : function( keepData ){
        if( keepData ){
            this.data = this.form.getResult(false, this.options.resultSeparator, false, false, true);
        }
        this.formTopNode = null;
        if(this.setFormNodeSizeFun && this.app && this.app.removeEvent){
            this.app.removeEvent("resize",this.setFormNodeSizeFun);
        }
        if( this.formMaskNode )this.formMaskNode.destroy();
        if( this.formAreaNode )this.formAreaNode.destroy();
        if( this.isNew ){
            this.create();
        }else if( this.isEdited ){
            this.edit();
        }else{
            this.open();
        }
    },
    open: function (e) {
        this.fireEvent("queryOpen");
        this.isNew = false;
        this.isEdited = false;
        this._open();
        this.fireEvent("postOpen");
    },
    create: function () {
        this.fireEvent("queryCreate");
        this.isNew = true;
        this._open();
        this.fireEvent("postCreate");
    },
    edit: function () {
        this.fireEvent("queryEdit");
        this.isEdited = true;
        this._open();
        this.fireEvent("postEdit");
    },
    _open: function () {
        this.fireEvent("queryLoad");
        if(this._queryLoad)this._queryLoad();

        if( this.options.hasMask ){
            this.formMaskNode = new Element("div.formMaskNode", {
                "styles": this.css.formMaskNode,
                "events": {
                    "mouseover": function (e) {
                        e.stopPropagation();
                    },
                    "mouseout": function (e) {
                        e.stopPropagation();
                    },
                    "click": function (e) {
                        e.stopPropagation();
                    },
                    "mousewheel": function (e) {
                        if (e.stopPropagation) e.stopPropagation();
                        else e.cancelBubble = true;

                        if (e.preventDefault) e.preventDefault();
                        else e.returnValue = false;
                    },
                    "DOMMouseScroll": function (e) {
                        if (e.stopPropagation) e.stopPropagation();
                        else e.cancelBubble = true;

                        if (e.preventDefault) e.preventDefault();
                        else e.returnValue = false;
                    }
                }
            }).inject( this.container || this.app.content);
        }

        this.formAreaNode = new Element("div.formAreaNode", {
            "styles": this.css.formAreaNode
        });

        this.createFormNode();

        if( this.formMaskNode ){
            this.formAreaNode.inject(this.formMaskNode , "after");
        }else{
            this.formAreaNode.inject( this.container || this.app.content );
        }
        if (this.options.ifFade){
            this.formAreaNode.fade("in");
        }else{
            this.formAreaNode.setStyle("opacity", 1);
        }


        this.setFormNodeSize();
        this.setFormNodeSizeFun = this.setFormNodeSize.bind(this);
        if( this.app && this.app.addEvent )this.app.addEvent("resize", this.setFormNodeSizeFun);

        if (this.options.draggable && this.formTopNode) {
            var size = (this.container || this.app.content).getSize();
            var nodeSize = this.formAreaNode.getSize();
            this.formAreaNode.makeDraggable({
                "handle": this.formTopNode,
                "limit": {
                    "x": [0, size.x - nodeSize.x],
                    "y": [0, size.y - nodeSize.y]
                },
                "onDrag": function(){
                    this.fireEvent("drag");
                }.bind(this),
                "onComplete": function(){
                    this.fireEvent("dragCompleted");
                }.bind(this)
            });
        }

        if( ( this.options.closeByClickMask || (!this.isNew && !this.isEdited && this.options.closeByClickMaskWhenReading) ) && this.formMaskNode ){
            this.formMaskNode.addEvent("click", function(e){
                this.close(e)
            }.bind(this));
        }

        if (this.options.resizeable){
            this.resizeNode = new Element("div.resizeNode", {
                "styles": this.css.resizeNode
            }).inject(this.formNode);
            this.formAreaNode.makeResizable({
                "handle": this.resizeNode,
                "limit": {x:[ this.options.minWidth, null], y:[this.options.minHeight, null]},
                "onDrag": function(){
                    var size = this.formAreaNode.getComputedSize();
                    this.setNodesSize( size.width, size.height );
                    this.fireEvent("resize");
                }.bind(this),
                "onComplete": function(){
                    var size = this.formAreaNode.getComputedSize();
                    this.options.width = size.width;
                    this.options.height = size.height;
                    if( this.oldCoordinate ){
                        this.oldCoordinate.width = size.width;
                        this.oldCoordinate.height = size.height;
                    }
                    this.fireEvent("resizeCompleted");
                    this.fireEvent("afterResize");
                }.bind(this)
            });
        }

        if(this._postLoad)this._postLoad();
        this.fireEvent("postLoad");

    },
    createFormNode: function () {
        var _self = this;

        this.formNode = new Element("div.formNode", {
            "styles": this.css.formNode
        }).inject(this.formAreaNode);

        if (this.options.hasTop) {
            this.createTopNode();
        }

        if (this.options.hasIcon) {
            this.formIconNode = new Element("div.formIconNode", {
                "styles": this.isNew ? this.css.formNewNode : this.css.formIconNode
            }).inject(this.formNode);
        }

        this.createContent();
        //formContentNode.set("html", html);

        if (this.options.hasBottom && (this.isNew || this.isEdited || !this.options.hideBottomWhenReading) ) {
            this.createBottomNode();
        }

        this._setCustom();

        if( this.options.hasScroll ){
            //this.setScrollBar(this.formTableContainer)
            if( this.options.scrollType == "window" ){
                this.formContentNode.setStyle("overflow","auto");
                this.formTableContainer.setStyle("overflow","visible");
            }else{
                MWF.require("MWF.widget.ScrollBar", function () {
                    new MWF.widget.ScrollBar(this.formTableContainer, {
                        "indent": false,
                        "style": "xApp_TaskList",
                        "where": "before",
                        "distance": 30,
                        "friction": 4,
                        "axis": {"x": false, "y": true},
                        "onScroll": function (y) {
                            //var scrollSize = _self.viewContainerNode.getScrollSize();
                            //var clientSize = _self.viewContainerNode.getSize();
                            //var scrollHeight = scrollSize.y - clientSize.y;
                            //if (y + 200 > scrollHeight && _self.view && _self.view.loadElementList) {
                            //    if (!_self.view.isItemsLoaded) _self.view.loadElementList();
                            //}
                        }
                    });
                }.bind(this));
            }
        }
    },
    _setCustom : function(){

    },
    createTopNode: function () {

        this.fireEvent("queryCreateTop");
        if (!this.formTopNode) {
            this.formTopNode = new Element("div.formTopNode", {
                "styles": this.css.formTopNode
            }).inject(this.formNode);
            if( this.options.topClass ){
                this.formTopNode.addClass( this.options.topClass );
            }

            if(this.options.hasTopIcon){
                this.formTopIconNode = new Element("div", {
                    "styles": this.css.formTopIconNode
                }).inject(this.formTopNode)
            }

            this.formTopTextNode = new Element("div", {
                "styles": this.css.formTopTextNode,
                "text": this.options.title
            }).inject(this.formTopNode);

            if (this.options.closeAction) {
                this.formTopCloseActionNode = new Element("div", {
                    "styles": this.css.formTopCloseActionNode,
                    "title" : MWF.xApplication.Template.LP.MPopupForm.close
                }).inject(this.formTopNode);
                this.formTopCloseActionNode.addEvent("click", function ( ev ) {
                    this.close();
                    ev.stopPropagation();
                }.bind(this))
            }

            if( this.options.maxAction ){
                this.formTopMaxActionNode = new Element("div", {
                    "styles": this.css.formTopMaxActionNode,
                    "title" : MWF.xApplication.Template.LP.MPopupForm.max
                }).inject(this.formTopNode);
                this.formTopMaxActionNode.addEvent("click", function () {
                    this.maxSize()
                }.bind(this));

                this.formTopRestoreActionNode = new Element("div", {
                    "styles": this.css.formTopRestoreActionNode,
                    "title": MWF.xApplication.Template.LP.MPopupForm.restore
                }).inject(this.formTopNode);
                this.formTopRestoreActionNode.addEvent("click", function () {
                    this.restoreSize()
                }.bind(this));

                this.formTopNode.addEvent("dblclick", function(){
                    this.switchMax();
                }.bind(this));
            }

            if(this.options.hasTopContent){
                this.formTopContentNode = new Element("div.formTopContentNode", {
                    "styles": this.css.formTopContentNode
                }).inject(this.formTopNode);

                this._createTopContent();
            }

        }

        this.fireEvent("postCreateTop");

        //if (!this.formTopNode) {
        //    this.formTopNode = new Element("div.formTopNode", {
        //        "styles": this.css.formTopNode,
        //        "text": this.options.title
        //    }).inject(this.formNode);
        //
        //    this._createTopContent();
        //
        //    if (this.options.closeAction) {
        //        this.formTopCloseActionNode = new Element("div.formTopCloseActionNode", {"styles": this.css.formTopCloseActionNode}).inject(this.formTopNode);
        //        this.formTopCloseActionNode.addEvent("click", function () {
        //            this.close()
        //        }.bind(this))
        //    }
        //}
    },
    _createTopContent: function () {

    },
    createContent: function () {
        this.formContentNode = new Element("div.formContentNode", {
            "styles": this.css.formContentNode
        }).inject(this.formNode);

        this.formTableContainer = new Element("div.formTableContainer", {
            "styles": this.css.formTableContainer
        }).inject(this.formContentNode);

        this.formTableArea = new Element("div.formTableArea", {
            "styles": this.css.formTableArea
        }).inject(this.formTableContainer);


        this._createTableContent();
    },
    _createTableContent: function () {

        var html = "<table width='100%' bordr='0' cellpadding='5' cellspacing='0' styles='formTable'>" +
                //"<tr><td colspan='2' styles='formTableHead'>申诉处理单</td></tr>" +
            "<tr><td styles='formTableTitle' lable='empName'></td>" +
            "    <td styles='formTableValue' item='empName'></td></tr>" +
            "<tr><td styles='formTableTitle' lable='departmentName'></td>" +
            "    <td styles='formTableValue' item='departmentName'></td></tr>" +
            "<tr><td styles='formTableTitle' lable='recordDateString'></td>" +
            "    <td styles='formTableValue' item='recordDateString'></td></tr>" +
            "<tr><td styles='formTableTitle' lable='status'></td>" +
            "    <td styles='formTableValue' item='status'></td></tr>" +
            "<tr><td styles='formTableTitle' lable='appealReason'></td>" +
            "    <td styles='formTableValue' item='appealReason'></td></tr>" +
            "<tr><td styles='formTableTitle' lable='appealDescription'></td>" +
            "    <td styles='formTableValue' item='appealDescription'></td></tr>" +
            "<tr><td styles='formTableTitle' lable='opinion1'></td>" +
            "    <td styles='formTableValue' item='opinion1'></td></tr>" +
            "</table>";
        this.formTableArea.set("html", html);

        MWF.xDesktop.requireApp("Template", "MForm", function () {
            this.form = new MForm(this.formTableArea, {empName: "xadmin"}, {
                isEdited: this.isEdited || this.isNew,
                itemTemplate: {
                    empName: {text: "姓名", type: "innertext"},
                    departmentName: {text: "部门", tType: "department", notEmpty: true},
                    recordDateString: {text: "日期", tType: "date"},
                    status: {text: "状态", tType: "number"},
                    appealReason: {
                        text: "下拉框",
                        type: "select",
                        selectValue: ["测试1", "测试2"]
                    },
                    appealDescription: {text: "描述", type: "textarea"},
                    opinion1: {text: "测试", type: "button", "value": "测试"}
                }
            }, this.app);
            this.form.load();
        }.bind(this), true);
    },
    createBottomNode: function () {
        this.fireEvent("queryCreateBottom");
        this.formBottomNode = new Element("div.formBottomNode", {
            "styles": this.css.formBottomNode
        }).inject(this.formNode);

        this._createBottomContent();
        this.fireEvent("postCreateBottom");
    },
    _createBottomContent: function () {

        if( !this.options.buttonList ){
            this._createCancelActionNode();
            this._createOkActionNode();
        }else{
            debugger;
            this.options.buttonList.each(function (button) {
                if(button.type === "cancel"){
                    this._createCancelActionNode( button.text || "" );
                }else if( button.type === "ok" ){
                    this._createOkActionNode( button.text || "" );
                }else{

                }
            }.bind(this))
        }
    },
    _createCancelActionNode: function(text){
        this.cancelActionNode = new Element("div.formCancelActionNode", {
            "styles": this.css.formCancelActionNode,
            "text": text || this.lp.cancel
        }).inject(this.formBottomNode);
        this.cancelActionNode.addEvent("click", function (e) {
            this.cancel(e);
        }.bind(this));
    },
    _createOkActionNode: function(text){
        if (this.isNew || this.isEdited) {
            this.okActionNode = new Element("div.formOkActionNode", {
                "styles": this.css.formOkActionNode,
                "text": text || this.lp.ok
            }).inject(this.formBottomNode);

            if( this.options.okClass ){
                this.okActionNode.addClass( this.options.okClass );
            }

            this.okActionNode.addEvent("click", function (e) {
                this.ok(e);
            }.bind(this));
        }
    },
    cancel: function (e) {
        this.fireEvent("queryCancel");
        this.close();
        this.fireEvent("postCancel");
    },
    close: function (e) {
        this.fireEvent("queryClose");
        this._close();
        //if( this.form ){
        //    this.form.destroy();
        //}
        if(this.setFormNodeSizeFun && this.app && this.app.removeEvent ){
            this.app.removeEvent("resize",this.setFormNodeSizeFun);
        }
        if( this.formMaskNode )this.formMaskNode.destroy();
        if( this.formAreaNode )this.formAreaNode.destroy();
        this.fireEvent("postClose");
        delete this;
    },
    _close: function(){

    },
    ok: function (e) {
        this.fireEvent("queryOk");
        var data = this.form.getResult(true, this.options.resultSeparator, true, false, true);
        if (data) {
            this._ok(data, function (json) {
                if (json.type == "error") {
                    if( this.app && this.app.notice )this.app.notice(json.message, "error");
                } else {
                    if( this.formMaskNode )this.formMaskNode.destroy();
                    if( this.formAreaNode )this.formAreaNode.destroy();
                    if (this.explorer && this.explorer.view)this.explorer.view.reload();
                    if( this.app && this.app.notice)this.app.notice(this.isNew ? this.lp.createSuccess : this.lp.updateSuccess, "success");
                    this.fireEvent("postOk");
                }
            }.bind(this))
        }
    },
    _ok: function (data, callback) {
        //this.app.restActions.saveDocument( this.data.id, data, function(json){
        //    if( callback )callback(json);
        //}.bind(this), function( errorObj ){
        //    var error = JSON.parse( errorObj.responseText );
        //    this.app.notice( error.message, error );
        //}.bind(this));
    },
    switchMax : function(){
        if( !this.isMax ){
            this.maxSize();
        }else{
            this.restoreSize();
        }
    },
    maxSize: function(){
        if(!this.oldCoordinate)this.oldCoordinate = {
            width : this.options.width,
            height : this.options.height,
            top : this.options.top,
            left : this.options.left,
            bottom : this.options.bottom,
            right : this.options.right
        };
        this.options.width = "100%";
        this.options.height = "100%";
        this.options.top = null;
        this.options.left = null;
        this.options.bottom = null;
        this.options.right = null;
        this.setFormNodeSize();
        this.formTopMaxActionNode.setStyle("display","none");
        this.formTopRestoreActionNode.setStyle("display","");
        this.isMax = true;
        this.fireEvent("max");
        this.fireEvent("afterResize");
    },
    restoreSize : function(){
        if( this.oldCoordinate){
            this.options.width = this.oldCoordinate.width;
            this.options.height = this.oldCoordinate.height;
            this.options.top = this.oldCoordinate.top;
            this.options.left = this.oldCoordinate.left;
            this.options.bottom = this.oldCoordinate.bottom;
            this.options.right = this.oldCoordinate.right;
        }
        this.setFormNodeSize();
        this.formTopMaxActionNode.setStyle("display","");
        this.formTopRestoreActionNode.setStyle("display","none");
        this.isMax = false;
        this.fireEvent("restore");
        this.fireEvent("afterResize");
    },
    resetHeight: function( height, offset ){
        var h;
        if( height === "auto" ){
            var tableHeight = this.formTableArea.getSize().y;
            var tableContainerOffsetY = this.getOffsetY( this.formTableContainer );
            var formContentOffsetY = this.getOffsetY( this.formContentNode );
            var formTopHeight = this.formTopNode ? ( this.formTopNode.getSize().y + this.getOffsetY(this.formTopNode) ) : 0;
            var formBottomHeight = this.formBottomNode ? ( this.formBottomNode.getSize().y + this.getOffsetY(this.formBottomNode) ) : 0;
            h = tableHeight + tableContainerOffsetY + formContentOffsetY + formTopHeight + formBottomHeight + (offset || 0);
        }else{
            h = height + (offset || 0);
        }
        this.options.height = h;
        if( this.isMax )return;
        var s = this.lastStyle || {};
        this.setFormNodeSize(null, h, s.top, s.left );
        this.fireEvent("afterResize");
    },
    setSize: function(width, height){
        if( width )this.options.width = width;
        if( height )this.options.height = height;
        this.setFormNodeSize(width, height);
        this.fireEvent("afterResize");
    },
    setFormNodeSize: function (width, height, top, left, bottom, right) {

        this._beforeFormNodeSize();

        if (!width)width = this.options.width ? this.options.width : "50%";
        if (!height)height = this.options.height ? this.options.height : "50%";
        if (!top && top != 0 ) top = this.options.top; // ? this.options.top : 0;
        if (!left && left != 0) left = this.options.left; // ? this.options.left : 0;
        if (!bottom && bottom != 0) bottom = this.options.bottom; // ? this.options.bottom : 0;
        if (!right && right != 0) right = this.options.right; // ? this.options.right : 0;

        width = width.toString();
        height = height.toString();

        var allSize = ( this.container || this.app.content).getSize();
        var limitWidth = allSize.x; //window.screen.width
        var limitHeight = allSize.y; //window.screen.height

        if (this.options.isLimitSize){
            if( "%" != width.substr(width.length - 1, 1) ){
                if( allSize.x < parseInt(width) )width = allSize.x;
            }
            if( "%" != height.substr(height.length - 1, 1) ){
                if( allSize.y < parseInt(height) )height = allSize.y;
            }
        }

        //if( width != "auto" ){
            "string" == typeof width && (1 < width.length && "%" == width.substr(width.length - 1, 1)) && (width = parseInt(limitWidth * parseInt(width, 10) / 100, 10));
            this.options.minWidth > width && (width = this.options.minWidth);
        //}
        //if( height != "auto" ){
            "string" == typeof height && (1 < height.length && "%" == height.substr(height.length - 1, 1)) && (height = parseInt(limitHeight * parseInt(height, 10) / 100, 10));
            this.options.minHeight > height && (height = this.options.minHeight);
        //}

        var styles = {
            "width": "" + width + "px",
            "height": "" + height + "px"
        };

        if( top != null ){
            styles.top = "" + top + "px";
            styles.bottom = "auto";
        }else if( bottom != null ){
            styles.top = "auto";
            styles.bottom = "" + bottom + "px";
        }else{
            styles.top = "" + parseInt((limitHeight - height) / 2, 10) + "px";
            styles.bottom = "auto";
        }

        if( left != null ){
            styles.left = "" + left + "px";
            styles.right = "auto";
        }else if( right != null ){
            styles.left = "auto";
            styles.right = "" + right + "px";
        }else{
            styles.left = "" + parseInt((limitWidth - width) / 2, 10) + "px";
            styles.right = "auto";
        }

        this.lastStyle = styles;

        if( this.formAreaNode )this.formAreaNode.setStyles(styles);

        this._setFormNodeSize(styles);

        this.setNodesSize( width, height );
    },
    _beforeFormNodeSize : function(){

    },
    _setFormNodeSize: function( styles ){

    },
    setNodesSize: function(width, height){
        //if( height == "auto" )return;
        this.options.minWidth > width && (width = this.options.minWidth);
        this.options.minHeight > height && (height = this.options.minHeight);

        this.formNode.setStyles({
            "width": "" + width + "px",
            "height": "" + height + "px"
        });

        var iconSize = this.formIconNode ? this.formIconNode.getSize() : {x: 0, y: 0};
        var topSize = this.formTopNode ? this.formTopNode.getSize() : {x: 0, y: 0};
        var bottomSize = this.formBottomNode ? this.formBottomNode.getSize() : {x: 0, y: 0};

        var contentHeight = height - iconSize.y - topSize.y - bottomSize.y;
        var marginTop = parseFloat(this.formContentNode.getStyle( "margin-top" )) || 0;
        var marginBottom = parseFloat(this.formContentNode.getStyle( "margin-bottom" )) || 0;
        var formContentHeight = contentHeight - marginTop - marginBottom;
        this.formContentNode.setStyles({
            "height": "" + formContentHeight + "px"
        });

        var paddingTop = parseFloat( this.formContentNode.getStyle( "padding-top" )) || 0;
        var paddingBottom = parseFloat( this.formContentNode.getStyle( "padding-bottom" )) || 0;
        marginTop = parseFloat( this.formTableContainer.getStyle( "margin-top" )) || 0;
        marginBottom = parseFloat( this.formTableContainer.getStyle( "margin-bottom" )) || 0;
        var tablePaddingTop = parseFloat( this.formTableContainer.getStyle( "padding-top" )) || 0;
        var tablePaddingTBottom = parseFloat( this.formTableContainer.getStyle( "padding-bottom" )) || 0;
        var formTableHeight = contentHeight - marginTop - marginBottom - paddingTop - paddingBottom - tablePaddingTop - tablePaddingTBottom;

        if( this.options.scrollType == "window" ){
            formTableHeight = formTableHeight - 10;
        }

        this.formTableContainer.setStyles({
            "height": "" + formTableHeight + "px"
        });
        this._setNodesSize( width, height, formContentHeight, formTableHeight );
        this.fireEvent("resizeForm");
    },
    _setNodesSize : function(width, height, formContentHeight, formTableHeight ){

    },
    getOffsetY : function(node){
        return (node.getStyle("margin-top").toInt() || 0 ) +
            (node.getStyle("margin-bottom").toInt() || 0 ) +
            (node.getStyle("padding-top").toInt() || 0 ) +
            (node.getStyle("padding-bottom").toInt() || 0 )+
            (node.getStyle("border-top-width").toInt() || 0 ) +
            (node.getStyle("border-bottom-width").toInt() || 0 );
    },
    getOffsetX : function(node){
        return (node.getStyle("margin-left").toInt() || 0 ) +
            (node.getStyle("margin-right").toInt() || 0 ) +
            (node.getStyle("padding-left").toInt() || 0 ) +
            (node.getStyle("padding-right").toInt() || 0 )+
            (node.getStyle("border-left-width").toInt() || 0 ) +
            (node.getStyle("border-right-width").toInt() || 0 );
    }
});

MWF.xDesktop = MWF.xDesktop || {};
MWF.xApplication = MWF.xApplication || {};
MWF.xDesktop.requireApp("Template", "MPopupForm", null, false);
MWF.require("MWF.xDesktop.UserData", null, false);

MWF.xDesktop.Authentication = new Class({
    Extends: MWF.widget.Common,
    Implements: [Options, Events],
    options: {
        "style": "default",
        // "width": "650",
        // "height": "480"
        "width": "420",
        "height": "640",
        "popupStyle_password": "o2platformSignupFlat",
        "popupStyle_signup": "o2platformSignup"
    },
    initialize: function (options, app, node) {
        this.setOptions(options);
        this.node = node;
        this.path = MWF.defaultPath + "/xDesktop/$Authentication/";

        // var css = null;
        // MWF.UD.getPublicData("loginStyleList", function (json) {
        //     if (json && json.enabledId) {
        //         MWF.UD.getPublicData(json.enabledId, function (json) {
        //             if (json && json.data) {
        //                 css = json.data;
        //             }
        //         }.bind(this), false);
        //     }
        // }.bind(this), false);

        // if (!css) {
            this.cssPath = MWF.defaultPath + "/xDesktop/$Authentication/" + this.options.style + "/css.wcss";
            this._loadCss();
        // } else {
        //     this.css = css;
        // }

        this.lp = MWF.LP.authentication;
        this.app = app || {};
    },
    isAuthenticated: function (success, failure) {
        MWF.Actions.get("x_organization_assemble_authentication").getAuthentication(success, failure);
    },

    loadLogin: function (node) {
        o2.Actions.load("x_organization_assemble_authentication").EchoAction.get(function () {
            if (node) this.loginNode = node;
            if (!node && this.loginNode) node = this.loginNode;
            if (layout.config.loginPage && layout.config.loginPage.enable && layout.config.loginPage.portal) {
                MWF.xDesktop.loadPortal(layout.config.loginPage.portal, this.options.loginParameter, true);
                this.fireEvent("openLogin");
            } else {
                this.popupOptions = {
                    "draggable": false,
                    "closeAction": false,
                    "hasMask": false,
                    "relativeToApp": false
                };
                this.popupPara = {
                    container: node
                };
                this.postLogin = function (json) {
                    layout.desktop.session.user = json.data;
                    layout.session.user = json.data;
                    layout.session.token = layout.session.user.token;
                    var user = layout.desktop.session.user;
                    if (!user.identityList) user.identityList = [];
                    if (user.roleList) {
                        var userRoleName = [];
                        user.roleList.each(function (role) {
                            userRoleName.push(role.substring(0, role.indexOf("@")));
                        });
                        user.roleList = user.roleList.concat(userRoleName);
                    }
                    var roleLCList = (user.roleList || []).map(function (role) {
                        return role.toLowerCase();
                    }.bind(this));
                    if (roleLCList.isIntersect(["systemmanager", "securitymanager", "auditmanager"])) {
                        window.location = "../x_desktop/app.html?app=ThreeMember";
                    } else {
                        window.location.reload();
                    }
                }.bind(this);
                this.openLoginForm(this.popupOptions);
                this.fireEvent("openLogin");
            }
        }.bind(this), function (xhr) {
            var message;
            if (xhr) {
                try {
                    var responseJSON = JSON.parse(xhr.responseText);
                    message = responseJSON.message; //message为错误提示文本
                } catch (e) {
                }
            }
            if (!message) message = MWF.LP.authentication.accessError;
            new Element("div", {
                "style": "font-size:16px;font-weight:bold;",
                "text": message
            }).inject(node);
        }.bind(this));
    },
    safeLogout: function(){
        o2.Actions.get("x_organization_assemble_authentication").safeLogout(function () {
            if (this.socket) {
                this.socket.close();
                this.socket = null;
            }
            if (layout.session && layout.session.user) layout.session.user.token = "";
            if (sessionStorage) sessionStorage.removeItem("o2LayoutSessionToken");
            window.location.reload();
        }.bind(this));
    },
    logout: function ( callback ) {
        MWF.Actions.get("x_organization_assemble_authentication").logout(function () {
            if (this.socket) {
                this.socket.close();
                this.socket = null;
            }
            if (layout.session && layout.session.user) layout.session.user.token = "";
            if (sessionStorage) sessionStorage.removeItem("o2LayoutSessionToken");
            if( callback ){
                callback();
            }else{
                window.location.reload();
            }
        }.bind(this));
    },
    openLoginForm: function (options, callback) {
        var opt = Object.merge(this.popupOptions || {}, options || {}, {
            onPostOk: function (json) {
                if (callback) callback(json);
                if (this.postLogin) this.postLogin(json);
                this.fireEvent("postOk", json)
            }.bind(this)
        });
        opt.width = this.options.width;
        opt.height = this.options.height;
        var form = new MWF.xDesktop.Authentication.LoginForm(this, {}, opt, this.popupPara);
        form.create();
    },
    openSignUpForm: function (options, callback) {
        var opt = Object.merge(this.popupOptions || {}, options || {}, {
            onPostOk: function (json) {
                if (callback) callback(json);
                this.fireEvent("postOk", json)
            }.bind(this)
        });
        delete opt.width;
        delete opt.height;
        if (this.options.popupStyle_signup) opt.popupStyle = this.options.popupStyle_signup;
        var form = new MWF.xDesktop.Authentication.SignUpForm(this, {}, opt, this.popupPara);
        form.create();
    },
    openResetPasswordForm: function (options, callback) {
        var opt = Object.merge(this.popupOptions || {}, options || {}, {
            onPostOk: function (json) {
                if (callback) callback(json);
                this.fireEvent("postOk", json)
            }.bind(this)
        });
        if (this.options.popupStyle_password) opt.popupStyle = this.options.popupStyle_password;
        // delete opt.width;
        // delete opt.height;
        var form = new MWF.xDesktop.Authentication.ResetPasswordForm(this, {}, opt, this.popupPara);
        form.create();
    },
    openChangePasswordForm: function (options, callback) {
        //options 里应该包括 userName
        var opt = Object.merge(this.popupOptions || {}, options || {}, {
            onPostOk: function (json) {
                if (callback) callback(json);
                this.fireEvent("postOk", json)
            }.bind(this)
        });
        // if (this.options.popupStyle_password) opt.popupStyle = this.options.popupStyle_password;
        var form = new MWF.xDesktop.Authentication.ChangePasswordForm(this, {}, opt, this.popupPara);
        form.create();
    }

});

MWF.xDesktop.Authentication.LoginForm = new Class({
    Extends: MPopupForm,
    Implements: [Options, Events],
    options: {
        "style": "default",
        "popupStyle": "o2platform",
        "width": "650",
        "height": "480",
        "hasTop": true,
        "hasIcon": false,
        "hasTopIcon": true,
        "hasTopContent": true,
        "hasBottom": false,
        "hasScroll": false,
        "hasMark": false,
        "title": "",
        "draggable": true,
        "closeAction": true
    },
    load: function () {
        this.setOptions({
            "title": (layout.config && (layout.config.systemTitle || layout.config.title)) ? (layout.config.title || layout.config.systemTitle) : MWF.LP.authentication.LoginFormTitle
        });
        this._loadCss();
    },
    //Camera Login
    _createTopContent: function () {
        this.actions = MWF.Actions.get("x_organization_assemble_authentication");

        this.faceLogin = false;
        // this.actions.getLoginMode(function (json) {
        //     this.faceLogin = json.data.faceLogin;
        // }.bind(this), null, false);
        //
        // if (this.faceLogin) {
        //     if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        //         COMMON.AjaxModule.loadDom("../o2_lib/adapter/adapter.js", function () {
        //             if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        //                 //暂时隐藏此功能
        //                 this.cameraLoginIcon = new Element("div", { "styles": this.explorer.css.cameraLoginIcon }).inject(this.formTopContentNode);
        //                 this.cameraLoginIcon.addEvent("click", function () {
        //                     if (!this.isCameraLogin) {
        //                         this.cameraLogin();
        //                         this.isCameraLogin = true;
        //                     } else {
        //                         this.closeCamera();
        //                         this.isCameraLogin = false;
        //                     }
        //                 }.bind(this));
        //             }
        //         }.bind(this));
        //     }
        // }
    },
    closeCamera: function () {
        if (this.cameraLoginVideoNode) {
            if (this.video) this.video.destroy();
            if (this.canvas) this.canvas.destroy();
            if (this.cameraLoginVideoNode) this.cameraLoginVideoNode.destroy();
            this.video = null;
            this.canvas = null;
            this.cameraLoginVideoNode = null;
        }
        this.cameraLoginIcon.setStyles(this.explorer.css.cameraLoginIcon);
    },
    cameraLoginInit: function () {
        this.cameraLoginConfig = {
            "maxStep": 2,
            "step": 0,
            "count": 0,
            "max": 2,
            "errorCount": 0,
            "errorMax": 3,
            "user": "",
            "tokens": []
        };
    },
    cameraLoginReset: function (resetError) {
        this.cameraLoginConfig.count = 0;
        this.cameraLoginConfig.user = "";
        if (resetError) this.cameraLoginConfig.errorCount = 0;
    },
    cameraLogin: function () {
        this.cameraLoginInit();
        this.cameraLoginIcon.setStyles(this.explorer.css.closeCameraLoginIcon);
        this.createCameraLoginNode();
        this.startCameraLogin();
    },
    createCameraLoginNode: function () {
        this.cameraLoginVideoNode = new Element("div", { "styles": this.explorer.css.cameraLoginVideoNode }).inject(this.container);
        var size = this.formNode.getSize();
        var topSize = this.formTopNode.getSize();
        var h = size.y - topSize.y;
        this.cameraLoginVideoNode.setStyles({
            "width": "" + size.x + "px",
            "height": "" + h + "px"
        });
        this.cameraLoginVideoNode.position({
            "relativeTo": this.formContentNode,
            "position": "upperLeft",
            "edge": "upperLeft"
        });
    },
    startCameraLogin: function () {
        this.cameraLoginVideoAreaNode = new Element("div").inject(this.cameraLoginVideoNode);
        this.cameraLoginVideoInfoNode = new Element("div", { "styles": this.explorer.css.cameraLoginVideoInfoNode }).inject(this.cameraLoginVideoNode);
        this.cameraLoginVideoInfoNode.set("text", MWF.LP.desktop.login.camera_logining);
        var size = this.cameraLoginVideoNode.getSize();
        var infoSize = this.cameraLoginVideoInfoNode.getSize();
        var h = size.y - infoSize.y;
        this.cameraLoginVideoAreaNode.setStyle("height", "" + h + "px");

        this.cameraLoginVideoAreaNode.set("html", "<video autoplay></video>");
        this.video = this.cameraLoginVideoAreaNode.getFirst().setStyles({
            "background-color": "#000000",
            "width": "" + size.x + "px",
            "height": "" + h + "px"
        });
        this.videoStart();
    },
    videoStart: function () {
        this.video.addEventListener("canplay", function () {
            window.setTimeout(function () {
                this.startCameraAuthentication();
            }.bind(this), 500);
        }.bind(this));

        navigator.mediaDevices.getUserMedia({
            audio: false,
            video: true
        }).then(function (stream) {
            this.video.srcObject = stream;
        }.bind(this))["catch"](function (error) {
            console.log('navigator.getUserMedia error: ', error);
            this.closeCamera();
        }.bind(this));
    },
    getFormData: function () {
        if (!this.canvas) {
            this.canvas = new Element("canvas", { "styles": { "display": "none" } }).inject(this.cameraLoginVideoNode);
            this.canvas.width = this.video.videoWidth;
            this.canvas.height = this.video.videoHeight;
        }
        this.canvas.getContext('2d').drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);

        var blob = this.toBlob(this.canvas.toDataURL());
        var formData = new FormData();
        formData.append('file', blob);

        this.canvas.destroy();
        return { "data": formData, "size": blob.size };
    },
    //检测出身份
    checkUserFace: function (formData) {

        var faceset = window.location.host;
        faceset = faceset.replace(/\./g, "_");
        this.faceAction.search(faceset, formData.data, { "name": "pic", "size": formData.size }, function (json) {
            if (json.data.results && json.data.results.length) {
                var hold = json.data.thresholds["1e-5"];
                if (json.data.results[0].confidence > hold) {
                    var token = json.data.faces[0].face_token;
                    var user = json.data.results[0].user_id;
                    if ((!this.cameraLoginConfig.user) || (this.cameraLoginConfig.user === user)) {
                        this.cameraLoginConfig.count++;
                        this.cameraLoginConfig.user = user;
                        this.cameraLoginConfig.tokens.push(token);
                        this.cameraLoginConfig.step++;
                        this.cameraLoginConfig.errorCount = 0;
                        this.cameraLoginVideoInfoNode.set("text", MWF.LP.desktop.login["camera_logining_" + this.cameraLoginConfig.step]);
                    } else {
                        this.cameraLoginReset();
                        this.cameraLoginConfig.errorCount++;
                    }
                } else {
                    this.cameraLoginReset();
                    this.cameraLoginConfig.errorCount++;
                }
            } else {
                this.cameraLoginReset();
                this.cameraLoginConfig.errorCount++;
            }
            this.checkCameraLogin();
        }.bind(this), function () {
            window.setTimeout(function () { this.startCameraAuthentication(); }.bind(this), 500);
        }.bind(this));
    },
    checkUserAlive: function (formData, attr, method) {
        this.faceAction.detectattr(attr, formData.data, { "name": "pic", "size": formData.size }, function (json) {
            if (json.data.faces && json.data.faces.length) {
                if (this[method](json.data.faces[0].attributes)) {
                    this.cameraLoginConfig.step++;
                    this.cameraLoginConfig.errorCount = 0;
                    this.cameraLoginVideoInfoNode.set("text", MWF.LP.desktop.login["camera_logining_" + this.cameraLoginConfig.step]);
                } else {
                    //可能是照片
                    this.cameraLoginConfig.errorCount++;
                }
            } else {
                this.cameraLoginConfig.errorCount++;
            }
            this.checkCameraLogin();
        }.bind(this), function () {
            this.cameraLoginConfig.errorCount++;
            this.checkCameraLogin();
        }.bind(this));
    },
    //检测微笑
    checkUserSmile: function (attr) {
        return attr.smile.value > attr.smile.threshold;
    },
    //检测抬头
    checkUserPitch: function (attr) {
        return attr.headpose.pitch_angle < -10;
    },
    startCameraAuthentication: function () {
        if (this.video) {
            var formData = this.getFormData();
            if (!this.faceAction) this.faceAction = MWF.Actions.get("x_faceset_control");

            if (this.cameraLoginConfig.step === 0) {
                this.checkUserFace(formData);
            }
            if (this.cameraLoginConfig.step === 1) {
                this.checkUserAlive(formData, "smiling", "checkUserSmile");
            }
            if (this.cameraLoginConfig.step === 2) {
                this.checkUserAlive(formData, "headpose", "checkUserPitch");
            }
        }
    },

    toBlob: function (base64) {
        var bytes;
        if (base64.substr(0, 10) === 'data:image') {
            bytes = window.atob(base64.split(',')[1]);
        } else {
            bytes = window.atob(base64);
        }
        var ab = new ArrayBuffer(bytes.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < bytes.length; i++) {
            ia[i] = bytes.charCodeAt(i);
        }
        return new Blob([ab], { type: "image/png" });
    },
    getDIF: function (arr) {
        var max = Math.max.apply(this, arr);
        var min = Math.min.apply(this, arr);
        return max - min;
    },
    checkCameraLogin: function () {

        if (this.cameraLoginConfig.errorCount > this.cameraLoginConfig.errorMax) {
            this.cameraLoginVideoInfoNode.set("text", MWF.LP.desktop.login.camera_loginError);
        } else {
            if (this.cameraLoginConfig.step >= this.cameraLoginConfig.maxStep) {
                var text = MWF.LP.desktop.login.camera_loginSuccess.replace("{name}", this.cameraLoginConfig.user);
                this.cameraLoginVideoInfoNode.set("text", text);
                this.cameraLoginSuccess();
            } else {
                window.setTimeout(function () { this.startCameraAuthentication(); }.bind(this), 100);
            }
        }
    },

    cameraLoginSuccess: function () {
        COMMON.AjaxModule.loadDom(["../o2_lib/CryptoJS/tripledes.js", "../o2_lib/CryptoJS/mode-ecb.js"], function () {
            //COMMON.AjaxModule.loadDom(, function(){

            var addressObj = layout.serviceAddressList["x_organization_assemble_authentication"];
            var url = layout.config.app_protocol + "//" + (addressObj.host || window.location.hostname)+ (addressObj.port === 80 ? "" : ":" + addressObj.port) + addressObj.context;

            var code = this.crypDES();
            var json = { "client": "face", "token": code };
            var _self = this;
            var res = new Request.JSON({
                "method": "POST",
                "url": o2.filterUrl(url + "/jaxrs/sso"),
                "data": JSON.stringify(json),
                secure: false,
                emulation: false,
                noCache: true,
                withCredentials: true,
                "headers": {
                    "Content-Type": "application/json; charset=utf-8"
                },
                onSuccess: function (responseJSON) {
                    _self._close();
                    _self.closeCamera();
                    if (_self.formMaskNode) _self.formMaskNode.destroy();
                    _self.formAreaNode.destroy();
                    var xToken = this.getHeader(o2.tokenName);
                    if (layout.config && layout.config.sessionStorageEnable) sessionStorage.setItem("o2LayoutSessionToken", xToken);
                    if (_self.explorer && _self.explorer.view) _self.explorer.view.reload();
                    if (_self.app) _self.app.notice(_self.lp.loginSuccess, "success");
                    _self.fireEvent("postOk", responseJSON);
                },
                onError: function () {
                    this.cameraLoginVideoInfoNode.set("text", MWF.LP.desktop.login.camera_loginError2);
                }.bind(this)
            });
            res.send();

            //}.bind(this));
        }.bind(this));
    },

    crypDES: function () {
        var key = "xplatform";
        var userId = this.cameraLoginConfig.user;
        var d = (new Date()).getTime();

        var keyHex = CryptoJS.enc.Utf8.parse(key);

        var xtoken = CryptoJS.DES.encrypt(userId + "#" + d, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        var str = xtoken.ciphertext.toString(CryptoJS.enc.Base64);
        str = str.replace(/=/g, "");
        str = str.replace(/\+/g, "-");
        str = str.replace(/\//g, "_");
        return str;
    },

    _createTableContent: function () {
        if( this.formTopTextNode && this.formTopCloseActionNode ){
            this.formTopCloseActionNode.inject( this.formTopTextNode, "before" )
        }

        this.loginType = "captcha";
        this.codeLogin = false;
        this.bindLogin = false;
        this.captchaLogin = true;
        this.actions.getLoginMode(function (json) {
            this.codeLogin = json.data.codeLogin;
            this.bindLogin = json.data.bindLogin;
            this.captchaLogin = json.data.captchaLogin;
        }.bind(this), null, false);

        MWF.Actions.get("x_organization_assemble_personal").getRegisterMode(function (json) {
            this.signUpMode = json.data.value;
        }.bind(this), null, false);

        if (this.bindLogin) {
            this.bindLoginTipPic = new Element("div.bindLoginTipPic", { styles: this.css.bindLoginTipPic }).inject(this.formContentNode, "top");
            this.bindLoginAction = new Element("div.bindLoginAction", { styles: this.css.bindLoginAction }).inject(this.formContentNode, "top");
            this.bindLoginAction.addEvent("click", function () {
                this.showBindCodeLogin();
            }.bind(this));

            this.backtoPasswordLoginTipPic = new Element("div.backtoPasswordLoginTipPic", { styles: this.css.backtoPasswordLoginTipPic }).inject(this.formContentNode, "top");
            this.backtoPasswordLoginAction = new Element("div.backtoPasswordLoginAction", { styles: this.css.backtoPasswordLoginAction }).inject(this.formContentNode, "top");
            this.backtoPasswordLoginAction.addEvent("click", function () {
                this.backtoPasswordLogin();
            }.bind(this));
        }

        var html =
            "<table width='100%' bordr='0' cellpadding='0' cellspacing='0' styles='formTable'>" +
            "<tr><div><div item='passwordAction'>";
        if (this.codeLogin) {
            html += "</div><div styles='titleSep'></div><div item='codeAction'></div></tr>";
        }
        html += "</table>";

        html += "<table width='100%' bordr='0' cellpadding='0' cellspacing='0' styles='formTable'>" +
            "<tr item='credentialTr'><td styles='formTableValueTop20' item='credential'></td></tr>" +
            "<tr item='passwordTr'><td styles='formTableValueTop20' item='password'></td></tr>";
        if (this.captchaLogin) {
            html += "<tr item='captchaTr'><td styles='formTableValueTop20'>" +
                "<div item='captchaAnswer' style='float:left;'></div><div item='captchaPic' style='float:left;padding-left:5px'></div><div item='changeCaptchaAction' style='float:left;'></div>" +
                "</td></tr>";
        }
        if (this.codeLogin) {
            html += "<tr item='codeTr' style='display: none'><td styles='formTableValueTop20'>" +
                "   <div item='codeAnswer' style='float:left;'></div>" +
                "   <div item='verificationAction' style='float:left;'></div>" +
                "   <div item='resendVerificationAction' style='float:left;display:none;'></div>" +
                "</td></tr>";
        }
        html += "<tr><td styles='formTableValueTop20' item='loginAction'></td></tr>" +
            "</table>" +
            "<table width='100%' bordr='0' cellpadding='0' cellspacing='0' styles='formTable'>";
        if (this.signUpMode && this.signUpMode !== "disable") {
            html += "<tr><td><div item='signUpAction'></div><div item='forgetPassword'></div></td></tr>";
        } else {
            html += "<tr><td><div styles='signUpAction'></div><div item='forgetPassword'></div></td></tr>";
        }
        html += "<tr><td  styles='formTableValue' item='errorArea'></td></tr>" +
            "<tr><td  styles='formTableValue' item='oauthArea'></td></tr>" +
            "</table>";

        this.formTableArea.set("html", html);
        new Element("div", {
            "styles": this.css.formFooter,
            // "styles": {
            //     "text-align": "center",
            //     "height": "40px",
            //     "line-height": "40px"
            // },
            "text": layout.config.footer || layout.config.systemName
        }).inject(this.formTableArea, "after");


        if (this.captchaLogin) this.setCaptchaPic();
        this.errorArea = this.formTableArea.getElement("[item=errorArea]");

        this.oauthArea = this.formTableArea.getElement("[item=oauthArea]");

        MWF.xDesktop.requireApp("Template", "MForm", function () {
            this.form = new MForm(this.formTableArea, this.data, {
                style: this.options.popupStyle,
                verifyType: "single",	//batch一起校验，或alert弹出
                isEdited: this.isEdited || this.isNew,
                itemTemplate: {
                    credential: {
                        text: this.lp.userName,
                        defaultValue: this.lp.userName,
                        className: "inputUser",
                        notEmpty: true,
                        defaultValueAsEmpty: true,
                        emptyTip: this.lp.inputYourUserName,
                        event: {
                            focus: function (it) {
                                if (this.lp.userName === it.getValue()) it.setValue("");
                                if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive);
                            }.bind(this),
                            blur: function (it) {
                                if ("" === it.getValue()) it.setValue(this.lp.userName);
                                if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputUser);
                            }.bind(this),
                            keyup: function (it, ev) {
                                if (ev.event.keyCode === 13) this.ok();
                            }.bind(this)
                        },
                        onEmpty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this),
                        onUnempty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputUser);
                        }.bind(this)
                    },
                    password: {
                        text: this.lp.password,
                        type: "password",
                        defaultValue: "password",
                        className: "inputPassword",
                        notEmpty: true,
                        defaultValueAsEmpty: true,
                        emptyTip: this.lp.inputYourPassword,
                        event: {
                            focus: function (it) {
                                if ("password" === it.getValue()) it.setValue("");
                                if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive);
                            }.bind(this),
                            blur: function (it) {
                                if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputPassword);
                            }.bind(this),
                            keyup: function (it, ev) {
                                if (ev.event.keyCode === 13) this.ok();
                            }.bind(this)
                        },
                        onEmpty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this),
                        onUnempty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputPassword);
                        }.bind(this)
                    },
                    captchaAnswer: {
                        tType: "number",
                        text: this.lp.verificationCode,
                        defaultValue: this.lp.verificationCode,
                        className: "inputVerificationCode",
                        notEmpty: true,
                        defaultValueAsEmpty: true,
                        emptyTip: this.lp.inputPicVerificationCode,
                        event: {
                            focus: function (it) {
                                if (this.lp.verificationCode === it.getValue()) it.setValue("");
                                if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive);
                            }.bind(this),
                            blur: function (it) {
                                if ("" === it.getValue()) it.setValue(this.lp.verificationCode);
                                if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputVerificationCode);
                            }.bind(this),
                            keyup: function (it, ev) {
                                if (ev.event.keyCode === 13) this.ok();
                            }.bind(this)
                        },
                        onEmpty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this),
                        onUnempty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputVerificationCode);
                        }.bind(this)
                    },
                    changeCaptchaAction: {
                        value: this.lp.changeVerification,
                        type: "innerText",
                        className: "verificationChange",
                        event: {
                            click: function () {
                                this.setCaptchaPic();
                            }.bind(this)
                        }
                    },
                    codeAnswer: {
                        text: this.lp.verificationCode,
                        defaultValue: this.lp.inputVerificationCode,
                        className: "inputVerificationCode2",
                        notEmpty: true,
                        defaultValueAsEmpty: true,
                        emptyTip: this.lp.inputVerificationCode,
                        event: {
                            focus: function (it) {
                                if (this.lp.inputVerificationCode === it.getValue()) it.setValue("");
                                if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive);
                            }.bind(this),
                            blur: function (it) {
                                if ("" === it.getValue()) it.setValue(this.lp.inputVerificationCode);
                                if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputVerificationCode2);
                            }.bind(this),
                            keyup: function (it, ev) {
                                if (ev.event.keyCode === 13) this.ok();
                            }.bind(this)
                        },
                        onEmpty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this),
                        onUnempty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputVerificationCode2);
                        }.bind(this)
                    },
                    verificationAction: {
                        value: this.lp.sendVerification,
                        type: "button",
                        className: "inputSendVerification",
                        event: {
                            click: function () {
                                this.sendVerificationAction();
                            }.bind(this)
                        }
                    },
                    resendVerificationAction: {
                        value: this.lp.resendVerification,
                        type: "button",
                        className: "inputResendVerification"
                    },
                    loginAction: {
                        value: this.lp.loginAction,
                        type: "button",
                        className: "inputLogin",
                        event: {
                            click: function () {
                                this.ok();
                            }.bind(this)
                        }
                    },
                    passwordAction: {
                        value: this.lp.passwordLogin,
                        type: "innerText",
                        className: "titleNode_active",
                        event: {
                            click: function () {
                                if (this.codeLogin) this.showPasswordLogin();
                            }.bind(this)
                        }
                    },
                    codeAction: {
                        value: this.lp.codeLogin,
                        type: "innerText",
                        className: "titleNode_normal",
                        event: {
                            click: function () {
                                this.showCodeLogin();
                            }.bind(this)
                        }
                    },
                    signUpAction: {
                        value: this.lp.signUp,
                        type: "innerText",
                        className: "signUpAction",
                        event: {
                            click: function () {
                                this.gotoSignup();
                            }.bind(this)
                        }
                    },
                    forgetPassword: {
                        value: this.lp.forgetPassword,
                        type: "innerText",
                        className: "forgetPassword",
                        event: {
                            click: function () {
                                this.gotoResetPassword();
                            }.bind(this)
                        }
                    }
                }
            }, this.app, this.css);
            this.form.load();
        }.bind(this), true);

        if (this.bindLogin) {
            this.bindLoginContainer = new Element("div", {
                styles: this.css.bindLoginContainer
            }).inject(this.formContentNode);

            var html2 = "<div item='bindLoginTitle' styles='bindTitleNode'></div>" +
                "<div styles='bindBodyArea'>" +
                "<div item='bindPicArea' styles='bindPicArea'></div>" +
                "<div styles='bindSepArea'></div>" +
                "<div styles='bindExampleArea'></div>" +
                "</div>" +
                "<div styles='bindTipArea'>" +
                "   <div styles='bindTipIconArea'></div>" +
                "   <div styles='bindTipTextArea'>" +
                "       " + this.lp.userAppCameraHtml +
                "       <div>"+this.lp.loginToPage +"</div>" +
                "</div>" +
                "<div styles='bindErrorArea'></div>";

            this.bindLoginContainer.set("html", html2);

            this.isShowEnable = true;
            this.bindBodyArea = this.bindLoginContainer.getElement("[styles='bindBodyArea']");
            this.bindLoginContainer.addEvent("mousemove", function (ev) {
                if (this.bindBodyArea.isOutside(ev)) {
                    this.hideExampleArea(ev);
                } else {
                    this.showExampleArea(ev);
                }
            }.bind(this));

            this.bindPicArea = this.bindLoginContainer.getElement("[item='bindPicArea']");
            this.setBindPic();
            this.bindExampleArea = this.bindLoginContainer.getElement("[styles='bindExampleArea']");
            this.bindSepArea = this.bindLoginContainer.getElement("[styles='bindSepArea']");
            var link = this.bindLoginContainer.getElement("[styles='bindTipLinkArea']");
            link.addEvent("click", function () {
                if( layout.config.appUrl ){
                    window.open(layout.config.appUrl, "_blank");
                }else{
                    window.open(this.lp.o2downloadLink, "_blank");
                }
            }.bind(this));
            this.bindErrorArea = this.bindLoginContainer.getElement("[styles='bindErrorArea']");

            MWF.xDesktop.requireApp("Template", "MForm", function () {
                this.bindform = new MForm(this.bindLoginContainer, {}, {
                    style: "o2platform",
                    verifyType: "single",	//batch一起校验，或alert弹出
                    isEdited: this.isEdited || this.isNew,
                    itemTemplate: {
                        bindLoginTitle: { value: this.lp.bingLoginTitle, type: "innerText" }
                    }
                }, this.app, this.css);
                this.bindform.load();
            }.bind(this), true);
        }

        this.loadOauthContent()

    },
    _beforeFormNodeSize: function () {
        if (!this.isPlusOauthSize && this.oauthListNode) {
            this.options.height = parseInt(this.options.height) + this.oauthArea.getSize().y;
            this.isPlusOauthSize = true;
        }
        if (this.oauthListNode || (!this.captchaLogin && !this.bindLogin)) { //留高度给二维码
            this.options.height = this.options.height - 60;
        }
        if (this.oauthListNode && this.captchaLogin) {
            this.options.height = this.options.height + 60;
        }
    },
    loadOauthContent: function () {
        this.actions.listOauthServer(function (json) {
            this.oauthList = json.data || [];
            if (this.oauthList.length > 0) {
                if (!this.oauthArea.getChildren().length) {
                    this.oauthListNode = new Element("div", { styles: this.css.oauthListNode }).inject(this.oauthArea);
                }
                this.oauthList.each(function (d) {
                    if (d.displayName === "@O2企业微信") {
                        d.qywx = true;
                    } else if (d.displayName === "@O2钉钉") {
                        d.dingding = true;
                    }
                    this.loadOauthItem(d);
                }.bind(this));
            }
        }.bind(this), null, false);

    },
    loadOauthItem: function (data) {
        var url = data.icon.indexOf("http") == 0 ? data.icon : ("data:image/png;base64," + data.icon);

        var itemNode = new Element("div", {
            styles: this.css.oauthItemNode,
            events: {
                click: function () {
                    var url = "../x_desktop/oauth.html?oauth=" + encodeURIComponent(this.name);
                    if (this.qywx) {
                        url += "&qywx=" + this.qywx;
                    }
                    if (this.dingding) {
                        url += "&dingding=" + this.dingding;
                    }
                    window.location = url;
                }.bind(data)
            }
        }).inject(this.oauthListNode);
        var iconNode = new Element("img", {
            styles: this.css.oauthItemIconNode,
            src: url
        }).inject(itemNode);
        var textNode = new Element("div", {
            styles: this.css.oauthItemTextNode,
            text: data.name
        }).inject(itemNode);
    },
    showExampleArea: function () {
        if (this.isHiddingExample || this.isShowingExample) return;
        if (!this.isShowEnable) return;
        this.isShowingExample = true;
        var left = this.bindBodyArea.getPosition(this.bindBodyArea.getParent()).x;
        var hideLeft = ((this.bindBodyArea.getParent().getSize().x) - 400) / 2;
        this.intervalId = setInterval(function () {
            if (left > hideLeft) {
                this.bindBodyArea.setStyle("margin-left", (left - 5) + "px");
                left = left - 5;
            } else {
                clearInterval(this.intervalId);
                this.bindBodyArea.setStyle("width", "400px");
                this.bindSepArea.setStyle("display", "");
                this.bindExampleArea.setStyle("display", "");
                this.isHidEnable = true;
                this.isShowEnable = false;
                this.isShowingExample = false;
            }
        }.bind(this), 10)
    },
    hideExampleArea: function () {
        if (this.isShowingExample || this.isHiddingExample) return;
        if (!this.isHidEnable) return;
        this.isHiddingExample = true;
        var left = this.bindBodyArea.getPosition(this.bindBodyArea.getParent()).x;
        this.bindSepArea.setStyle("display", "none");
        this.bindExampleArea.setStyle("display", "none");
        var hideLeft = ((this.bindBodyArea.getParent().getSize().x) - 200) / 2;
        this.intervalId2 = setInterval(function () {
            if (left < hideLeft) {
                this.bindBodyArea.setStyle("margin-left", (left + 5) + "px");
                left = left + 5;
            } else {
                clearInterval(this.intervalId2);
                this.bindBodyArea.setStyle("width", "204px");
                this.isHidEnable = false;
                this.isShowEnable = true;
                this.isHiddingExample = false;
            }
        }.bind(this), 10)
    },
    showPasswordLogin: function () {
        this.errorArea.empty();
        this.loginType = "captcha";
        this.form.getItem("passwordAction").setStyles(this.css.titleNode_active);
        this.form.getItem("codeAction").setStyles(this.css.titleNode_normal);
        this.formTableArea.getElement("[item='passwordTr']").setStyle("display", "");
        var captchaTr = this.formTableArea.getElement("[item='captchaTr']");
        if (captchaTr) captchaTr.setStyle("display", "");
        this.formTableArea.getElement("[item='codeTr']").setStyle("display", "none");
    },
    showCodeLogin: function () {
        this.errorArea.empty();
        this.loginType = "code";
        this.form.getItem("passwordAction").setStyles(this.css.titleNode_normal);
        this.form.getItem("codeAction").setStyles(this.css.titleNode_active);
        this.formTableArea.getElement("[item='passwordTr']").setStyle("display", "none");
        var captchaTr = this.formTableArea.getElement("[item='captchaTr']");
        if (captchaTr) captchaTr.setStyle("display", "none");
        this.formTableArea.getElement("[item='codeTr']").setStyle("display", "");

    },
    showBindCodeLogin: function () {
        this.errorArea.empty();
        this.formTableContainer.setStyle("display", "none");
        this.bindLoginContainer.setStyle("display", "");
        this.bindLoginTipPic.setStyle("display", "none");
        this.bindLoginAction.setStyle("display", "none");
        this.backtoPasswordLoginTipPic.setStyle("display", "");
        this.backtoPasswordLoginAction.setStyle("display", "");
        this.checkBindStatus();
    },
    backtoPasswordLogin: function () {
        this.errorArea.empty();
        if (this.bindStatusInterval) clearInterval(this.bindStatusInterval);
        this.formTableContainer.setStyle("display", "");
        this.bindLoginContainer.setStyle("display", "none");
        this.bindLoginTipPic.setStyle("display", "");
        this.bindLoginAction.setStyle("display", "");
        this.backtoPasswordLoginTipPic.setStyle("display", "none");
        this.backtoPasswordLoginAction.setStyle("display", "none");
    },
    setBindPic: function () {
        this.bindPicArea.empty();
        this.actions.getLoginBind(function (json) {
            this.bindMeta = json.data.meta;
            new Element("img", {
                src: "data:image/png;base64," + json.data.image
            }).inject(this.bindPicArea);
        }.bind(this))
    },
    setCaptchaPic: function () {
        if (!this.captchaLogin) return;
        var captchaPic = this.formTableArea.getElement("[item='captchaPic']");
        captchaPic.empty();
        this.actions.getLoginCaptcha(120, 50, function (json) {
            this.captcha = json.data.id;
            new Element("img", {
                src: "data:image/png;base64," + json.data.image,
                styles: this.css.verificationImage
            }).inject(captchaPic);
        }.bind(this), null, true, null, false)
    },
    sendVerificationAction: function () {
        var flag = true;
        var credentialItem = this.form.getItem("credential");
        var credential = credentialItem.getValue();
        if (!credential || credential.trim() === "") {
            credentialItem.setWarning(this.lp.inputYourUserName, "empty");
            return;
        } else {
            // this.actions.checkCredential(credential, function (json) {
            //     if (!json.data.value) {
            //         flag = false;
            //         credentialItem.setWarning(this.lp.userNotExist, "invalid");
            //     }
            // }.bind(this), function (errorObj) {
            //     flag = false;
            //     var error = JSON.parse(errorObj.responseText);
            //     credentialItem.setWarning(error.message, "invalid");
            // }.bind(this), false)
        }
        if (!flag) {
            return;
        } else {
            credentialItem.clearWarning("invalid");
        }
        this.actions.createCredentialCode(credential, function (json) {
        }, function (errorObj) {
            var error = JSON.parse(errorObj.responseText);
            var codeAnswerItem = this.form.getItem("codeAnswer");
            if(codeAnswerItem){
                codeAnswerItem.clearWarning("empty");
            }
            this.setWarning(error.message);
            flag = false
        }.bind(this));
        if (!flag) {
            return;
        } else {
            this.errorArea.empty();
        }
        this.form.getItem("verificationAction").container.setStyle("display", "none");
        this.setResendVerification();
    },
    setResendVerification: function () {
        var resendItem = this.form.getItem("resendVerificationAction");
        resendItem.container.setStyle("display", "");
        this.resendElement = resendItem.getElements()[0];
        this.resendElement.set("text", this.lp.resendVerification + "(60)");

        var i = 60;
        this.timer = setInterval(function () {
            if (i > 0) {
                this.resendElement.set("text", this.lp.resendVerification + "(" + --i + ")")
            } else {
                this.form.getItem("verificationAction").container.setStyle("display", "");
                resendItem.container.setStyle("display", "none");
                clearInterval(this.timer)
            }
        }.bind(this), 1000)
    },
    gotoSignup: function () {
        this.explorer.openSignUpForm();
        //this.explorer.openResetPasswordForm();
        this.close();
    },
    gotoResetPassword: function () {
        this.explorer.openResetPasswordForm();
        this.close();
    },
    gotoChangePassword : function( options ){ //密码过期
        this.explorer.openChangePasswordForm( options, function(){
            this.explorer.loadLogin();
        }.bind(this));
        this.close();
    },
    checkBindStatus: function () {
        this.bindStatusInterval = setInterval(function () {
            this.actions.checkBindStatus(this.bindMeta, function (json) {
                if (json.data) {
                    if (json.data.name && json.data.name !== "anonymous") {
                        this.fireEvent("queryOk");
                        this._close();
                        if (this.formMaskNode) this.formMaskNode.destroy();
                        this.formAreaNode.destroy();
                        if (this.explorer && this.explorer.view) this.explorer.view.reload();
                        if (this.app) this.app.notice(this.lp.loginSuccess, "success");
                        this.fireEvent("postOk", json);
                    }
                }
            }.bind(this), function (errorObj) {
                var error = JSON.parse( errorObj.responseText );
                if (this.app) {
                    this.app.notice(error.message, "error");
                }else{
                    this.setBindWarning( error.message );
                }
            }.bind(this))
        }.bind(this), 3000);

    },
    _close: function () {
        if (this.bindStatusInterval) clearInterval(this.bindStatusInterval);
        if (this.timer) clearInterval(this.timer);
    },
    ok: function () {
        this.fireEvent("queryOk");
        this.errorArea.empty();
        var captchaItem = null;
        var codeItem = null;
        if (this.loginType === "captcha") {
            this.form.getItem("password").options.notEmpty = true;

            if (this.captchaLogin) {
                captchaItem = this.form.getItem("captchaAnswer");
                if (captchaItem) captchaItem.options.notEmpty = true;
            }

            codeItem = this.form.getItem("codeAnswer");
            if (codeItem) codeItem.options.notEmpty = false;
        } else if (this.loginType === "code") {
            this.form.getItem("password").options.notEmpty = false;
            if (this.captchaLogin) {
                captchaItem = this.form.getItem("captchaAnswer");
                if (captchaItem) captchaItem.options.notEmpty = false;
            }
            codeItem = this.form.getItem("codeAnswer");
            if (codeItem) codeItem.options.notEmpty = true;
        }
        var data = this.form.getResult(true, ",", true, false, true);
        if (data) {
            this._ok(data, function (json) {
                if (json.type === "error") {
                    if (this.app) this.app.notice(json.message, "error");
                } else if( json.data.passwordExpired ){ //密码过期
                    var userName = json.data.distinguishedName;
                    this.explorer.logout( function(){ //注销再到密码修改页
                        this.gotoChangePassword({
                            userName : userName
                        });
                    }.bind(this))
                } else {
                    this._close();
                    if (this.formMaskNode) this.formMaskNode.destroy();
                    this.formAreaNode.destroy();
                    if (this.explorer && this.explorer.view) this.explorer.view.reload();
                    if (this.app) this.app.notice(this.lp.loginSuccess, "success");
                    this.fireEvent("postOk", json);
                }
            }.bind(this));
        }
    },
    setWarning: function (text) {
        this.errorArea.empty();
        new Element("div", {
            "text": text,
            "styles": this.css.warningMessageNode
        }).inject(this.errorArea);
    },
    setBindWarning: function (text) {
        if( this.bindErrorArea ){
            this.bindErrorArea.empty();
            new Element("div", {
                "text": text,
                "styles": this.css.warningMessageNode
            }).inject(this.bindErrorArea);
        }
    },
    _ok: function (data, callback) {
        var d = null;
        if (this.loginType === "captcha") {
            d = {
                credential: data.credential,
                password: data.password
            };
            if (this.captchaLogin) {
                d.captchaAnswer = data.captchaAnswer;
                d.captcha = this.captcha;
            }
            this.actions.loginByCaptcha(d, function (json) {
                if (callback) callback(json);
                //this.fireEvent("postOk")
            }.bind(this), function (errorObj) {
                var error = JSON.parse(errorObj.responseText);
                this.setWarning(error.message);
                this.setCaptchaPic();
                if (this.form.getItem("captchaAnswer")) this.form.getItem("captchaAnswer").setValue("");
            }.bind(this));
        } else if (this.loginType === "code") {
            d = {
                credential: data.credential,
                codeAnswer: data.codeAnswer
            };
            this.actions.loginByCode(d, function (json) {
                if (callback) callback(json);
                //this.fireEvent("postOk")
            }.bind(this), function (errorObj) {
                var error = JSON.parse(errorObj.responseText);
                this.setWarning(error.message);
            }.bind(this));
        }
    }
});

MWF.xDesktop.Authentication.SignUpForm = new Class({
    Extends: MPopupForm,
    Implements: [Options, Events],
    options: {
        "style": "default",
        "popupStyle": "o2platformSignup",
        "width": "910",
        "height": "740",
        "hasTop": true,
        "hasIcon": false,
        "hasTopIcon": true,
        "hasTopContent": true,
        "hasBottom": false,
        "title": "",
        "draggable": true,
        "closeAction": true
    },
    load: function () {
        if (!this.options.title) this.setOptions({
            "title": MWF.LP.authentication.SignUpFormTitle
        });
        this._loadCss();
    },
    _createTableContent: function () {
        if( this.formTopTextNode && this.formTopCloseActionNode ){
            this.formTopCloseActionNode.inject( this.formTopTextNode, "before" )
        }

        var self = this;

        this.actions = MWF.Actions.get("x_organization_assemble_personal");

        var signUpMode = "code";
        this.actions.getRegisterMode(function (json) {
            signUpMode = json.data.value;
        }.bind(this), null, false);

        this.formTopNode.setStyle("height","50px");
        this.formTableContainer.setStyles({
            "width": "890px",
            "margin-top": "40px"
        });

        var html = "<table width='100%' bordr='0' cellpadding='5' cellspacing='0' styles='formTable'>" +
            "<tr><td styles='formTableTitle' lable='name' width='200'></td>" +
            "   <td styles='formTableValue' item='name' width='350'></td>" +
            "   <td styles='formTableValue' item='nameTip'></td></tr>" +
            "<tr><td styles='formTableTitle' lable='password'></td>" +
            "   <td styles='formTableValue' item='password'></td>" +
            "   <td styles='formTableValue'><div item='passwordStrengthArea'></div></div><div item='passwordTip'></div></td></tr>" +
            "<tr><td styles='formTableTitle' lable='confirmPassword'></td>" +
            "   <td styles='formTableValue' item='confirmPassword'></td>" +
            "   <td styles='formTableValue' item='confirmPasswordTip'></td></tr>" +
            "<tr><td styles='formTableTitle' lable='genderType'></td>" +
            "   <td styles='formTableValue' item='genderType'></td>" +
            "   <td styles='formTableValue' item='genderTypeTip'></td></tr>" +
            "<tr><td styles='formTableTitle' lable='mail'></td>" +
            "   <td styles='formTableValue' item='mail'></td>" +
            "   <td styles='formTableValue' item='mailTip'></td></tr>" +
            "<tr><td styles='formTableTitle' lable='mobile'></td>" +
            "   <td styles='formTableValue' item='mobile'></td>" +
            "   <td styles='formTableValue' item='mobileTip'></td></tr>";
        if (signUpMode === "code") {
            html += "<tr><td styles='formTableTitle' lable='codeAnswer'></td>" +
                "   <td styles='formTableValue'><div item='codeAnswer' style='float:left;'></div><div item='verificationAction' style='float:left;'></div><div item='resendVerificationAction' style='float:left;display:none;'></div></td>" +
                "   <td styles='formTableValue' item='verificationCodeTip'></td></tr>";
        } else {
            html += "<tr><td styles='formTableTitle' lable='captchaAnswer'></td>" +
                "   <td styles='formTableValue'><div item='captchaAnswer' style='float:left;'></div><div item='captchaPic' style='float:left;'></div><div item='changeCaptchaAction' style='float:left;'></div></td>" +
                "   <td styles='formTableValue' item='captchaAnswerTip'></td></tr>";
        }
        html += "<tr><td styles='formTableTitle'></td>" +
            "   <td styles='formTableValue' item='signUpAction'></td>" +
            "   <td styles='formTableValue' item='signUpTip'></td></tr>" +
            "<tr><td></td>" +
            "   <td><div item='hasAccountArea'></div><div item='gotoLoginAction'></div></td>" +
            "   <td></td></tr>" +
            "</table>";
        this.formTableArea.set("html", html);

        if (signUpMode === "captcha") {
            this.setCaptchaPic();
        }
        //this.createPasswordStrengthNode();

        MWF.xDesktop.requireApp("Template", "MForm", function () {
            this.form = new MForm(this.formTableArea, this.data, {
                style: this.options.popupStyle,
                verifyType: "batchSingle",	//batch一起校验，或alert弹出
                isEdited: this.isEdited || this.isNew,
                onPostLoad: function () {
                    var form = this.form;
                    var table = this.formTableArea;
                    form.getItem("name").tipNode = table.getElement("[item='nameTip']");
                    form.getItem("password").tipNode = table.getElement("[item='passwordTip']");
                    form.getItem("confirmPassword").tipNode = table.getElement("[item='confirmPasswordTip']");
                    form.getItem("mail").tipNode = table.getElement("[item='mailTip']");
                    form.getItem("genderType").tipNode = table.getElement("[item='genderTypeTip']");
                    form.getItem("mobile").tipNode = table.getElement("[item='mobileTip']");
                    this.tipNode = table.getElement("[item='signUpTip']");
                    var captchaAnswer = form.getItem("captchaAnswer");
                    if (captchaAnswer) {
                        form.getItem("captchaAnswer").tipNode = table.getElement("[item='captchaAnswerTip']");
                    }
                    var codeAnswer = form.getItem("codeAnswer");
                    if (codeAnswer) {
                        form.getItem("codeAnswer").tipNode = table.getElement("[item='verificationCodeTip']");
                    }
                }.bind(this),
                itemTemplate: {
                    name: {
                        text: this.lp.userName, defaultValue: this.lp.userName, className: "inputUser",
                        notEmpty: true, defaultValueAsEmpty: true, emptyTip: this.lp.inputYourUserName,
                        validRule: { isInvalid: function (value, it) { return this.checkUserName(value, it); }.bind(this) },
                        validMessage: { isInvalid: this.lp.userExist },
                        event: {
                            focus: function (it) { if (this.lp.userName === it.getValue()) it.setValue(""); if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive); }.bind(this),
                            keyup: function (it, ev) { if (ev.event.keyCode === 13) { this.ok() } }.bind(this),
                            blur: function (it) {
                                if (it.verify(true)) {
                                    if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputUser);
                                }
                            }.bind(this)
                        }, onEmpty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this), onUnempty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputUser);
                        }.bind(this)
                    },
                    password: {
                        text: this.lp.password, type: "password", className: "inputPassword",
                        notEmpty: true, defaultValueAsEmpty: true, emptyTip: this.lp.inputYourPassword,
                        validRule: {
                            passwordIsWeak: function (value, it) {
                                return !this.getPasswordRule(it.getValue());
                            }.bind(this)
                        },
                        validMessage: {
                            passwordIsWeak: function () {
                                return self.getPasswordRule(this.getValue());
                            }
                        }, //this.lp.passwordIsSimple
                        event: {
                            focus: function (it) { if ("password" === it.getValue()) it.setValue(""); if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive); }.bind(this),
                            //keyup : function(it){ this.pwStrength(it.getValue()) }.bind(this),
                            blur: function (it) { it.verify(true) }.bind(this)
                        }, onEmpty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this), onUnempty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputPassword);
                        }.bind(this)
                    },
                    confirmPassword: {
                        text: this.lp.confirmPassword, type: "password", className: "inputComfirmPassword",
                        notEmpty: true, defaultValueAsEmpty: true, emptyTip: this.lp.inputComfirmPassword,
                        validRule: {
                            passwordNotEqual: function (value, it) {
                                if (it.getValue() === this.form.getItem("password").getValue()) return true;
                            }.bind(this)
                        },
                        validMessage: { passwordNotEqual: this.lp.passwordNotEqual },
                        event: {
                            focus: function (it) { if ("password" === it.getValue()) it.setValue(""); if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive); }.bind(this),
                            keyup: function (it, ev) { if (ev.event.keyCode === 13) { this.ok() } }.bind(this),
                            blur: function (it) {
                                if (it.verify(true)) {
                                    if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputComfirmPassword);
                                }
                            }.bind(this)
                        }, onEmpty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this), onUnempty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputComfirmPassword);
                        }.bind(this)
                    },
                    mail: {
                        text: this.lp.mail, defaultValue: this.lp.inputYourMail, className: "inputMail",
                        notEmpty: false, defaultValueAsEmpty: true, emptyTip: this.lp.inputYourMail,
                        validRule: { isFormatInvalid: function (value, it) {
                            if( (!value || value===this.lp.inputYourMail) ||
                                /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test( value ) ){
                                it.tipNode.empty();
                                it.warningStatus = false;
                                return true;
                            }else{
                                it.warningStatus = true;
                                return false;
                            }
                        }.bind(this) },
                        validMessage: { isFormatInvalid: this.lp.mailFormatError },
                        event: { //validRule: { email: false },
                            focus: function (it) {
                                if (this.lp.inputYourMail === it.getValue()) it.setValue("");
                                if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive);
                            }.bind(this),
                            blur: function (it) {
                                it.verify(true);
                                if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputMail);
                            }.bind(this),
                            keyup: function (it, ev) { if (ev.event.keyCode === 13) { this.ok() } }.bind(this)
                        }, onEmpty: function (it) {
                            // it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this), onUnempty: function (it) {
                            // it.getElements()[0].setStyles(this.css.inputMail);
                        }.bind(this)
                    },
                    genderType: {
                        text: this.lp.genderType, className: "inputGenderType", type: "select", selectValue: this.lp.genderTypeValue.split(","), selectText: this.lp.genderTypeText.split(","),
                        notEmpty: true, emptyTip: this.lp.selectGenderType, event: {
                            focus: function (it) { if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive); }.bind(this),
                            blur: function (it) { it.verify(true); if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputGenderType); }.bind(this),
                            keyup: function (it, ev) { if (ev.event.keyCode === 13) { this.ok() } }.bind(this)
                        }, onEmpty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this), onUnempty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputGenderType);
                        }.bind(this)
                    },
                    mobile: {
                        text: this.lp.mobile, defaultValue: this.lp.inputYourMobile, className: "inputMobile", tType: "number",
                        notEmpty: true, defaultValueAsEmpty: true, emptyTip: this.lp.inputYourMobile,
                        validRule: { isInvalid: function (value, it) { return this.checkMobile(value, it); }.bind(this) },
                        validMessage: { isInvalid: this.lp.mobileIsRegisted },
                        event: {
                            focus: function (it) { if (this.lp.inputYourMobile === it.getValue()) it.setValue(""); if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive); }.bind(this),
                            keyup: function (it, ev) { if (ev.event.keyCode === 13) { this.ok() } }.bind(this),
                            blur: function (it) {
                                if (it.verify(true)) {
                                    if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputMobile);
                                }
                            }.bind(this)
                        }, onEmpty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this), onUnempty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputMobile);
                        }.bind(this)
                    },
                    captchaAnswer: {
                        tType: "number", text: this.lp.verificationCode, defaultValue: this.lp.verificationCode, className: "inputVerificationCode",
                        notEmpty: true, defaultValueAsEmpty: true, emptyTip: this.lp.inputPicVerificationCode, event: {
                            focus: function (it) { if (this.lp.verificationCode === it.getValue()) it.setValue(""); if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive); }.bind(this),
                            blur: function (it) { it.verify(true); if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputVerificationCode); }.bind(this),
                            keyup: function (it, ev) { if (ev.event.keyCode === 13) { this.ok() } }.bind(this)
                        }, onEmpty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this), onUnempty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputVerificationCode);
                        }.bind(this)
                    },
                    changeCaptchaAction: {
                        value: this.lp.changeVerification, type: "innerText", className: "verificationChange", event: {
                            click: function () {
                                this.setCaptchaPic();
                            }.bind(this)
                        }
                    },
                    codeAnswer: {
                        text: this.lp.verificationCode, defaultValue: this.lp.inputVerificationCode, className: "inputVerificationCode2",
                        notEmpty: true, defaultValueAsEmpty: true, emptyTip: this.lp.inputVerificationCode, event: {
                            focus: function (it) { if (this.lp.inputVerificationCode === it.getValue()) it.setValue(""); if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive); }.bind(this),
                            blur: function (it) { it.verify(true); if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputVerificationCode2); }.bind(this),
                            keyup: function (it, ev) { if (ev.event.keyCode === 13) { this.ok() } }.bind(this)
                        }, onEmpty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this), onUnempty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputVerificationCode2);
                        }.bind(this)
                    },
                    verificationAction: {
                        value: this.lp.sendVerification, type: "button", className: "inputSendVerification", event: {
                            click: function () { this.sendVerificationAction() }.bind(this)
                        }
                    },
                    resendVerificationAction: { value: this.lp.resendVerification, type: "button", className: "inputResendVerification" },
                    signUpAction: {
                        value: this.lp.signUp, type: "button", className: "inputSignUp", event: {
                            click: function () { this.ok() }.bind(this)
                        }
                    },
                    hasAccountArea: { value: this.lp.hasAccount, type: "innerText", className: "hasCountArea" },
                    gotoLoginAction: {
                        value: this.lp.gotoLogin, type: "innerText", className: "gotoLoginAction", event: {
                            click: function () { this.gotoLogin() }.bind(this)
                        }
                    }
                }
            }, this.app, this.css);
            this.form.load();
        }.bind(this), true);
    },
    checkMobile: function (mobile, it) {
        var flag = true;
        this.actions.checkRegisterMobile(mobile, function () {
            flag = true
        }.bind(this), function (errorObj) {
            if (errorObj.status === 404) {
                it.options.validMessage.isInvalid = this.lp.pageNotFound;
                flag = false;
            } else {
                var error = JSON.parse(errorObj.responseText);
                it.options.validMessage.isInvalid = error.message;
                flag = false;
            }
        }.bind(this), false);
        return flag;
    },
    checkUserName: function (userName, it) {
        var flag = true;
        this.actions.checkRegisterName(userName, function () {
            flag = true
        }.bind(this), function (errorObj) {
            if (errorObj.status === 404) {
                it.options.validMessage.isInvalid = this.lp.pageNotFound;
                flag = false
            } else {
                var error = JSON.parse(errorObj.responseText);
                it.options.validMessage.isInvalid = error.message;
                flag = false
            }
        }.bind(this), false);
        return flag;
    },
    setCaptchaPic: function () {
        var captchaPic = this.formTableArea.getElement("[item='captchaPic']");
        captchaPic.empty();
        this.actions.getRegisterCaptcha(120, 50, function (json) {
            this.captcha = json.data.id;
            new Element("img", {
                src: "data:image/png;base64," + json.data.image,
                styles: this.css.verificationImage
            }).inject(captchaPic);
        }.bind(this))
    },
    sendVerificationAction: function () {
        var flag = true;
        var it = this.form.getItem("mobile");
        if (it.verify(true)) {
            it.clearWarning();
            it.getElements()[0].setStyles(this.css.inputMobile);
        } else {
            return;
        }
        this.actions.createRegisterCode(it.getValue(), function (json) {

        }, function (errorObj) {
            var codeIt = this.form.getItem("codeAnswer");
            var error = JSON.parse(errorObj.responseText);
            if (errorObj.status === 404) {
                codeIt.setWarning(error.message, this.lp.pageNotFound);
                flag = false;
            } else {
                codeIt.setWarning(error.message, "invalid");
                flag = false;
            }
        }.bind(this), false);

        if (!flag) return false;
        this.form.getItem("verificationAction").container.setStyle("display", "none");
        this.setResendVerification();
    },
    setResendVerification: function () {
        var resendItem = this.form.getItem("resendVerificationAction");
        resendItem.container.setStyle("display", "");
        this.resendElement = resendItem.getElements()[0];
        this.resendElement.set("text", this.lp.resendVerification + "(60)");

        var i = 60;
        this.timer = setInterval(function () {
            if (i > 0) {
                this.resendElement.set("text", this.lp.resendVerification + "(" + --i + ")")
            } else {
                this.form.getItem("verificationAction").container.setStyle("display", "");
                resendItem.container.setStyle("display", "none");
                clearInterval(this.timer)
            }
        }.bind(this), 1000)
    },
    getPasswordRule: function (password) {
        var str = "";
        this.actions.checkRegisterPassword(password, function (json) {
            str = json.data.value || "";
        }.bind(this), null, false);
        return str;
    },
    //createPasswordStrengthNode : function(){
    //    var passwordStrengthArea = this.formTableArea.getElement("[item='passwordStrengthArea']");
    //
    //    var lowNode = new Element( "div", {styles : this.css.passwordStrengthNode }).inject( passwordStrengthArea );
    //    this.lowColorNode = new Element( "div", {styles : this.css.passwordStrengthColor }).inject( lowNode );
    //    this.lowTextNode = new Element( "div", {styles : this.css.passwordStrengthText, text : this.lp.weak }).inject( lowNode );
    //
    //    var middleNode = new Element( "div" , {styles : this.css.passwordStrengthNode }).inject( passwordStrengthArea );
    //    this.middleColorNode = new Element( "div", {styles : this.css.passwordStrengthColor }).inject( middleNode );
    //    this.middleTextNode = new Element( "div", {styles : this.css.passwordStrengthText, text : this.lp.middle }).inject( middleNode );
    //
    //    var highNode = new Element("div", {styles : this.css.passwordStrengthNode }).inject( passwordStrengthArea );
    //    this.highColorNode = new Element( "div", {styles : this.css.passwordStrengthColor }).inject( highNode );
    //    this.highTextNode = new Element( "div", {styles : this.css.passwordStrengthText, text : this.lp.high }).inject( highNode );
    //},
    //getPasswordLevel: function( password ){
    //    // Level（级别）
    //    //  •0-3 : [easy]
    //    //  •4-6 : [midium]
    //    //  •7-9 : [strong]
    //    //  •10-12 : [very strong]
    //    //  •>12 : [extremely strong]
    //    var level = 0;
    //    this.actions.checkRegisterPassword( password, function( json ){
    //        level = json.data.value;
    //    }.bind(this), null, false );
    //    return level;
    //},
    //pwStrength: function(pwd){
    //    this.lowColorNode.setStyles( this.css.passwordStrengthColor );
    //    this.lowTextNode.setStyles( this.css.passwordStrengthText );
    //    this.middleColorNode.setStyles( this.css.passwordStrengthColor );
    //    this.middleTextNode.setStyles( this.css.passwordStrengthText );
    //    this.highColorNode.setStyles( this.css.passwordStrengthColor );
    //    this.highTextNode.setStyles( this.css.passwordStrengthText );
    //    if (!pwd){
    //    }else{
    //        //var level = this.checkStrong(pwd);
    //        var level = this.getPasswordLevel(pwd);
    //        switch(level) {
    //            case 0:
    //            case 1:
    //            case 2:
    //            case 3:
    //                this.lowColorNode.setStyles( this.css.passwordStrengthColor_low );
    //                this.lowTextNode.setStyles( this.css.passwordStrengthText_current );
    //                break;
    //            case 4:
    //            case 5:
    //            case 6:
    //                this.middleColorNode.setStyles( this.css.passwordStrengthColor_middle );
    //                this.middleTextNode.setStyles( this.css.passwordStrengthText_current );
    //                break;
    //            default:
    //                this.highColorNode.setStyles( this.css.passwordStrengthColor_high );
    //                this.highTextNode.setStyles( this.css.passwordStrengthText_current );
    //        }
    //    }
    //},
    gotoLogin: function () {
        this.explorer.openLoginForm({}, function () { window.location.reload(); });
        this.close();
    },
    setWarning: function (text) {
        this.tipNode.empty();
        new Element("div", {
            "text": text,
            "styles": this.css.warningMessageNode
        }).inject(this.tipNode);
    },
    setNotice: function (text) {
        this.tipNode.empty();
        new Element("div", {
            "text": text,
            "styles": this.css.noticeMessageNode
        }).inject(this.tipNode);
    },
    ok: function () {
        this.tipNode.empty();
        this.fireEvent("queryOk");
        var data = this.form.getResult(true, ",", true, false, true);
        if (data) {
            this._ok(data, function (json) {
                if (json.type === "error") {
                    if (this.app) this.app.notice(json.message, "error");
                } else {
                    if (this.formMaskNode) this.formMaskNode.destroy();
                    this.formAreaNode.destroy();
                    this.setNotice(this.lp.registeSuccess);
                    if (this.app) this.app.notice(this.lp.registeSuccess, "success");
                    this.fireEvent("postOk", json);
                    this.gotoLogin();
                }
            }.bind(this))
        }
    },
    _ok: function (data, callback) {
        data.captcha = this.captcha;
        this.actions.register(data, function (json) {
            if (callback) callback(json);
        }.bind(this), function (errorObj) {
            if (errorObj.status === 404) {
                this.setWarning(this.lp.pageNotFound);
            } else {
                var error = JSON.parse(errorObj.responseText);
                this.setWarning(error.message);
            }
        }.bind(this));
    }
});

//忘记密码
MWF.xDesktop.Authentication.ResetPasswordForm = new Class({
    Extends: MPopupForm,
    Implements: [Options, Events],
    options: {
        "style": "default",
        "popupStyle": "o2platformSignup",
        "width": "710",
        "height": "450",
        "hasTop": true,
        "hasIcon": false,
        "hasTopIcon": true,
        "hasTopContent": true,
        "hasBottom": false,
        "title": "",
        "draggable": true,
        "closeAction": true
    },
    load: function () {
        if (!this.options.title) this.setOptions({
            "title": MWF.LP.authentication.ResetPasswordFormTitle
        });
        this._loadCss();
    },
    _createTopContent: function () {

        this.actions = MWF.Actions.get("x_organization_assemble_personal");

        this.actions.getRegisterMode(function (json) {
            this.signUpMode = json.data.value;
        }.bind(this), null, false);
        if (this.signUpMode && this.signUpMode !== "disable") {
            this.gotoSignupNode = new Element("div", {
                styles: this.css.formTopContentCustomNode,
                text: this.lp.signUp
            }).inject(this.formTopContentNode);
            this.gotoSignupNode.addEvent("click", function () { this.gotoSignup() }.bind(this));

            new Element("div", { styles: this.css.formTopContentSepNode }).inject(this.formTopContentNode);
        }

        this.gotoLoginNode = new Element("div", {
            styles: this.css.formTopContentCustomNode,
            text: this.lp.loginAction
        }).inject(this.formTopContentNode);
        this.gotoLoginNode.addEvent("click", function () { this.gotoLogin() }.bind(this));
    },
    _createTableContent: function () {

        if( this.formTopTextNode && this.formTopCloseActionNode ){
            this.formTopCloseActionNode.inject( this.formTopTextNode, "before" )
        }

        this.formTableContainer.setStyles(this.css.formTableContainer2);
        this.loadSteps();
        this.loadStepForm_1();
        this.loadStepForm_2();
        this.loadStepForm_3();

    },
    reset: function () {
        this.formTableArea.empty();
        this._createTableContent();
    },
    loadSteps: function () {
        var stepsContainer = new Element("div", { styles: this.css.stepsContainer }).inject(this.formTableArea);
        this.step_1 = new Element("div", {
            styles: this.css.step_1_active,
            text: this.lp.shotMessageCheck
        }).inject(stepsContainer);
        this.stepLink_1 = new Element("div", { styles: this.css.stepLink_1 }).inject(this.step_1);

        this.step_2 = new Element("div", {
            styles: this.css.step_2,
            text: this.lp.setMewPassword
        }).inject(stepsContainer);
        this.stepLink_2 = new Element("div", { styles: this.css.stepLink_2 }).inject(this.step_2);

        this.step_3 = new Element("div", {
            styles: this.css.step_3,
            text: this.lp.completed
        }).inject(stepsContainer);

    },
    loadStepForm_1: function () {
        var html = "<table width='100%' bordr='0' cellpadding='5' cellspacing='0' styles='formTable'>" +
            "<tr><td styles='formTableTitle' lable='name' width='80'></td>" +
            "   <td styles='formTableValue' item='name' width='350'></td></tr>" +
            "<tr><td styles='formTableTitle' lable='codeAnswer'></td>" +
            "   <td styles='formTableValue'>" +
            "       <div item='codeAnswer' style='float:left;'></div>" +
            "       <div item='verificationAction' style='float:left;'></div>" +
            "       <div item='resendVerificationAction' style='float:left;display:none;'></div></td>" +
            "   </tr>" +
            "<tr><td styles='formTableTitle'></td>" +
            "   <td styles='formTableValue' item='nextStep'></td></tr>" +
            "</table>";
        this.stepNode_1 = new Element("div", { html: html, styles: { display: "" } }).inject(this.formTableArea);
        MWF.xDesktop.requireApp("Template", "MForm", function () {
            this.stepForm_1 = new MForm(this.stepNode_1, {}, {
                style: this.options.popupStyle,
                verifyType: "single",	//batch一起校验，或alert弹出
                isEdited: this.isEdited || this.isNew,
                itemTemplate: {
                    name: {
                        text: this.lp.userName, defaultValue: this.lp.userName, className: "inputUser",
                        notEmpty: true, defaultValueAsEmpty: true, emptyTip: this.lp.inputYourUserName,
                        // validRule: { isInvalid: function (value, it) { return this.checkUserName(value, it); }.bind(this) },
                        // validMessage: { isInvalid: this.lp.userNotExist },
                        event: {
                            focus: function (it) { if (this.lp.userName === it.getValue()) it.setValue(""); if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive); }.bind(this),
                            blur: function (it) { if (it.getValue() === "") it.setValue(this.lp.userName); if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputUser); }.bind(this),
                            keyup: function (it, ev) { if (ev.event.keyCode === 13) { this.gotoStep(2) } }.bind(this)
                        }, onEmpty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this), onUnempty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputUser);
                        }.bind(this)
                    },
                    codeAnswer: {
                        text: this.lp.verificationCode, defaultValue: this.lp.inputVerificationCode, className: "inputVerificationCode2",
                        notEmpty: true, defaultValueAsEmpty: true, emptyTip: this.lp.inputVerificationCode, event: {
                            focus: function (it) { if (this.lp.inputVerificationCode === it.getValue()) it.setValue(""); if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive); }.bind(this),
                            blur: function (it) {
                                if (it.getValue() === "") it.setValue(this.lp.inputVerificationCode);
                                if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputVerificationCode2);
                            }.bind(this),
                            keyup: function (it, ev) { if (ev.event.keyCode === 13) { this.gotoStep(2) } }.bind(this)
                        }, onEmpty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this), onUnempty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputVerificationCode2);
                        }.bind(this)
                    },
                    verificationAction: {
                        value: this.lp.sendVerification, type: "button", className: "inputSendVerification", event: {
                            click: function () { this.sendVerificationAction() }.bind(this)
                        }
                    },
                    resendVerificationAction: { value: this.lp.resendVerification, type: "button", className: "inputResendVerification" },
                    nextStep: {
                        value: this.lp.nextStep, type: "button", className: "inputSignUp", event: {
                            click: function () { this.gotoStep(2) }.bind(this)
                        }
                    }
                }
            }, this.app, this.css);
            this.stepForm_1.load();
        }.bind(this), true);
    },
    loadStepForm_2: function () {
        var self = this;

        html = "<table width='100%' bordr='0' cellpadding='5' cellspacing='0' styles='formTable'>" +
            "<tr><td styles='formTableTitle' lable='password' width='80'></td>" +
            "   <td styles='formTableValue' item='password' width='350'></td>" +
            "   <td styles='formTableValue'><div item='passwordStrengthArea'></div></td></tr>" +
            "<tr><td styles='formTableTitle' lable='confirmPassword'></td>" +
            "   <td styles='formTableValue' item='confirmPassword'></td>" +
            "   <td styles='formTableValue'></td></tr>" +
            "<tr><td styles='formTableTitle'></td>" +
            "   <td styles='formTableValue' item='nextStep'></td>" +
            "   <td styles='formTableValue'></td></tr>" +
            "</table>";
        this.stepNode_2 = new Element("div", {
            html: html,
            styles: { "display": "none" }
        }).inject(this.formTableArea);
        MWF.xDesktop.requireApp("Template", "MForm", function () {
            this.stepForm_2 = new MForm(this.stepNode_2, {}, {
                style: this.options.popupStyle,
                verifyType: "single",	//batch一起校验，或alert弹出
                isEdited: this.isEdited || this.isNew,
                itemTemplate: {
                    password: {
                        text: this.lp.setNewPassword, type: "password", className: "inputPassword",
                        notEmpty: true, defaultValueAsEmpty: true, emptyTip: this.lp.inputYourPassword,
                        attr: { "placeholder": this.lp.inputYourPassword },
                        validRule: {
                            passwordIsWeak: function (value, it) {
                                return !this.getPasswordRule(it.getValue());
                            }.bind(this)
                        },
                        validMessage: {
                            passwordIsWeak: function () {
                                return self.getPasswordRule(this.getValue());
                            }
                        },
                        event: {
                            focus: function (it) { if ("password" === it.getValue()) it.setValue(""); if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive); }.bind(this),
                            blur: function (it) { it.verify(true); }.bind(this)
                            //if( !it.warningStatus )it.getElements()[0].setStyles( this.css.inputPassword );
                            //keyup : function(it){ this.pwStrength(it.getValue()) }.bind(this)
                        }, onEmpty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this), onUnempty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputPassword);
                        }.bind(this)
                    },
                    confirmPassword: {
                        text: this.lp.confirmNewPassword, type: "password", className: "inputComfirmPassword",
                        notEmpty: true, defaultValueAsEmpty: true, emptyTip: this.lp.inputComfirmPassword,
                        attr: { "placeholder": this.lp.inputComfirmPassword },
                        validRule: {
                            passwordNotEqual: function (value, it) {
                                if (it.getValue() === this.stepForm_2.getItem("password").getValue()) return true;
                            }.bind(this)
                        },
                        validMessage: { passwordNotEqual: this.lp.passwordNotEqual },
                        event: {
                            focus: function (it) { if ("password" === it.getValue()) it.setValue(""); if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive); }.bind(this),
                            blur: function (it) { if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputComfirmPassword); }.bind(this),
                            keyup: function (it, ev) { if (ev.event.keyCode === 13) { this.gotoStep(3) } }.bind(this)
                        }, onEmpty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this), onUnempty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputComfirmPassword);
                        }.bind(this)
                    },
                    nextStep: {
                        value: this.lp.nextStep, type: "button", className: "inputSignUp", event: {
                            click: function () { this.gotoStep(3) }.bind(this)
                        }
                    }
                }
            }, this.app, this.css);
            this.stepForm_2.load();
        }.bind(this), true);

        //this.createPasswordStrengthNode();
    },
    loadStepForm_3: function () {
        this.stepNode_3 = new Element("div", {
            styles: this.css.stepFormResult
        }).inject(this.formTableArea);
    },
    createSetForm_3: function (isSuccess, text) {
        var area = null;
        var action = null;
        if (isSuccess) {
            this.stepNode_3.setStyles(this.css.stepFormResult);
            this.stepNode_3.setStyle("display", "");
            new Element("div", {
                styles: this.css.resetPasswordSuccess,
                text: this.lp.resetPasswordSuccess
            }).inject(this.stepNode_3);
            area = new Element("div", {
                styles: this.css.resetPasswordResultArea
            }).inject(this.stepNode_3);
            new Element("div", {
                styles: this.css.resetPasswordResultWord,
                text: this.lp.resetPasswordSuccessWord
            }).inject(area);
            action = new Element("div", {
                styles: this.css.resetPasswordResultAction,
                text: this.lp.gotoLogin
            }).inject(area);
            action.addEvent("click", function () { this.gotoLogin() }.bind(this));
        } else {
            this.stepNode_3.setStyles(this.css.stepFormResult_fail);
            this.stepNode_3.setStyle("display", "");
            new Element("div", {
                styles: this.css.resetPasswordFail,
                text: text + this.lp.resetPasswordFail
            }).inject(this.stepNode_3);
            area = new Element("div", {
                styles: this.css.resetPasswordResultArea
            }).inject(this.stepNode_3);
            new Element("div", {
                styles: this.css.resetPasswordResultWord,
                text: this.lp.resetPasswordFailWord
            }).inject(area);
            action = new Element("div", {
                styles: this.css.resetPasswordResultAction,
                text: this.lp.backtoModify
            }).inject(area);
            action.addEvent("click", function () { this.reset() }.bind(this));
        }
    },
    gotoStep: function (step) {
        var form = this["stepForm_" + (step - 1)];
        form.clearWarning();
        var data = form.getResult(true, ",", true, false, true);
        if (!data) {
            return;
        }
        var i;
        for (i = 1; i <= step; i++) {
            this["step_" + i].setStyles(this.css["step_" + i + "_active"]);
            if (i !== step && this["stepLink_" + i]) {
                this["stepLink_" + i].setStyles(this.css["stepLink_" + i + "_active"]);
            }
        }
        for (i = step + 1; i <= 3; i++) {
            this["step_" + i].setStyles(this.css["step_" + i]);
            if (i !== 3) {
                this["stepLink_" + i].setStyles(this.css["stepLink_" + i]);
            }
        }
        for (i = 1; i <= 3; i++) {
            if (i === step) {
                this["stepNode_" + i].setStyle("display", "");
            } else {
                this["stepNode_" + i].setStyle("display", "none");
            }
        }

        if (step === 3) {
            var d = {
                credential: this.stepForm_1.getItem("name").getValue(),
                codeAnswer: this.stepForm_1.getItem("codeAnswer").getValue(),
                password: this.stepForm_2.getItem("password").getValue()
            };
            this.actions.resetPassword(d, function () {
                this.createSetForm_3(true)
            }.bind(this), function (errorObj) {
                var error = JSON.parse(errorObj.responseText);
                //this.app.notice( error.message );
                this.createSetForm_3(false, error.message)
            }.bind(this), false);
        }
    },
    checkMobile: function (mobile) {
        var flag = true;
        this.actions.checkRegisterMobile(mobile, function () {
            flag = true
        }.bind(this), function () {
            flag = false;
        }.bind(this), false);
        return flag;
    },
    checkUserName: function (userName, it) {
        var flag = false;
        this.actions.checkCredentialOnResetPassword(userName, function (json) {
            if (json.data) {
                flag = json.data.value;
            }
        }.bind(this), function (errorObj) {
            if (errorObj.status === 404) {
                it.options.validMessage.isInvalid = this.lp.pageNotFound;
                flag = false
            } else {
                var error = JSON.parse(errorObj.responseText);
                it.options.validMessage.isInvalid = error.message;
                flag = false
            }
        }.bind(this), false);
        return flag;
    },
    sendVerificationAction: function () {
        var flag = true;
        var it = this.stepForm_1.getItem("name");
        this.stepForm_1.clearWarning();
        if (it.verify(true)) {
        } else {
            return;
        }
        this.actions.createCodeOnResetPassword(it.getValue(), function (json) {

        }, function (errorObj) {
            var error = JSON.parse(errorObj.responseText);
            it.setWarning(error.message, "invalid");
            flag = false
        }.bind(this), false);

        if (!flag) return false;
        this.stepForm_1.getItem("verificationAction").container.setStyle("display", "none");
        this.setResendVerification();
    },
    setResendVerification: function () {
        var resendItem = this.stepForm_1.getItem("resendVerificationAction");
        resendItem.container.setStyle("display", "");
        this.resendElement = resendItem.getElements()[0];
        this.resendElement.set("text", this.lp.resendVerification + "(60)");

        var i = 60;
        this.timer = setInterval(function () {
            if (i > 0) {
                this.resendElement.set("text", this.lp.resendVerification + "(" + --i + ")")
            } else {
                this.stepForm_1.getItem("verificationAction").container.setStyle("display", "");
                resendItem.container.setStyle("display", "none");
                clearInterval(this.timer)
            }
        }.bind(this), 1000)
    },
    getPasswordRule: function (password) {
        var str = "";
        this.actions.checkRegisterPassword(password, function (json) {
            str = json.data.value || "";
        }.bind(this), null, false);
        return str;
    },
    //createPasswordStrengthNode : function(){
    //    var passwordStrengthArea = this.formTableArea.getElement("[item='passwordStrengthArea']");
    //
    //    var lowNode = new Element( "div", {styles : this.css.passwordStrengthNode }).inject( passwordStrengthArea );
    //    this.lowColorNode = new Element( "div", {styles : this.css.passwordStrengthColor }).inject( lowNode );
    //    this.lowTextNode = new Element( "div", {styles : this.css.passwordStrengthText, text : this.lp.weak }).inject( lowNode );
    //
    //    var middleNode = new Element( "div" , {styles : this.css.passwordStrengthNode }).inject( passwordStrengthArea );
    //    this.middleColorNode = new Element( "div", {styles : this.css.passwordStrengthColor }).inject( middleNode );
    //    this.middleTextNode = new Element( "div", {styles : this.css.passwordStrengthText, text : this.lp.middle }).inject( middleNode );
    //
    //    var highNode = new Element("div", {styles : this.css.passwordStrengthNode }).inject( passwordStrengthArea );
    //    this.highColorNode = new Element( "div", {styles : this.css.passwordStrengthColor }).inject( highNode );
    //    this.highTextNode = new Element( "div", {styles : this.css.passwordStrengthText, text : this.lp.high }).inject( highNode );
    //},
    //getPasswordLevel: function( password ){
    //    /*Level（级别）
    //     •0-3 : [easy]
    //     •4-6 : [midium]
    //     •7-9 : [strong]
    //     •10-12 : [very strong]
    //     •>12 : [extremely strong]
    //     */
    //    var level = 0;
    //    this.actions.checkRegisterPassword( password, function( json ){
    //        level = json.data.value;
    //    }.bind(this), null, false );
    //    return level;
    //},
    //pwStrength: function(pwd){
    //    this.lowColorNode.setStyles( this.css.passwordStrengthColor );
    //    this.lowTextNode.setStyles( this.css.passwordStrengthText );
    //    this.middleColorNode.setStyles( this.css.passwordStrengthColor );
    //    this.middleTextNode.setStyles( this.css.passwordStrengthText );
    //    this.highColorNode.setStyles( this.css.passwordStrengthColor );
    //    this.highTextNode.setStyles( this.css.passwordStrengthText );
    //    if (!pwd){
    //    }else{
    //        //var level = this.checkStrong(pwd);
    //        var level = this.getPasswordLevel(pwd);
    //        switch(level) {
    //            case 0:
    //            case 1:
    //            case 2:
    //            case 3:
    //                this.lowColorNode.setStyles( this.css.passwordStrengthColor_low );
    //                this.lowTextNode.setStyles( this.css.passwordStrengthText_current );
    //                break;
    //            case 4:
    //            case 5:
    //            case 6:
    //                this.middleColorNode.setStyles( this.css.passwordStrengthColor_middle );
    //                this.middleTextNode.setStyles( this.css.passwordStrengthText_current );
    //                break;
    //            default:
    //                this.highColorNode.setStyles( this.css.passwordStrengthColor_high );
    //                this.highTextNode.setStyles( this.css.passwordStrengthText_current );
    //        }
    //    }
    //},
    gotoLogin: function () {
        this.explorer.openLoginForm({}, function () { window.location.reload(); });
        this.close();
    },
    gotoSignup: function () {
        this.explorer.openSignUpForm();
        this.close();
    }
});

//密码过期
MWF.xDesktop.Authentication.ChangePasswordForm = new Class({
    Extends: MPopupForm,
    Implements: [Options, Events],
    options: {
        "style": "default",
        "popupStyle": "o2platform",
        "width": "650",
        "height": "480",
        "hasTop": true,
        "hasIcon": false,
        "hasTopIcon": true,
        "hasTopContent": true,
        "hasBottom": false,
        "hasScroll": false,
        "hasMark": false,
        "title": "",
        "draggable": true,
        "closeAction": true,
        "userName" : ""
    },
    load: function () {
        if (!this.options.title) this.setOptions({
            "title": MWF.LP.authentication.ChangePasswordFormTitle
        });
        this._loadCss();
    },
    _createTableContent: function () {
        var self = this;

        if( this.formTopTextNode && this.formTopCloseActionNode ){
            this.formTopCloseActionNode.inject( this.formTopTextNode, "before" )
        }

        this.actions = MWF.Actions.get("x_organization_assemble_personal");

        var html = "<table width='100%' bordr='0' cellpadding='0' cellspacing='0' styles='formTable'>" +
            "<tr><td styles='formTableValueTop20' item='password'></td></tr>" +
            "<tr><td styles='formTableValueTop20' item='newPassword'></td>" +
            "<tr><td styles='formTableValue'><div item='passwordTip'></div></td></tr>" +
            "<tr><td styles='formTableValueTop20' item='confirmPassword'></td>" +
            "<tr><td styles='formTableValueTop20' item='submitAction'></td></tr>" +
            "<tr><td><div item='forgetPassword'></div><div item='gotoLoginAction'></div></td></tr>"+
            "<tr><td  styles='formTableValue' item='errorArea'></td></tr>" +
            "</table>";

        this.formTableArea.set("html", html);

        this.errorArea = this.formTableArea.getElement("[item=errorArea]");

        MWF.xDesktop.requireApp("Template", "MForm", function () {
            this.form = new MForm(this.formTableArea, this.data, {
                style: this.options.popupStyle,
                verifyType: "single",	//batch一起校验，或alert弹出
                isEdited: this.isEdited || this.isNew,
                onPostLoad: function () {
                    var form = this.form;
                    form.getItem("password").tipNode = this.errorArea;
                    form.getItem("newPassword").tipNode = this.errorArea;
                    form.getItem("confirmPassword").tipNode = this.errorArea;
                }.bind(this),
                itemTemplate: {
                    password: {
                        text: this.lp.oldPassword,
                        type: "password",
                        className: "inputPassword",
                        notEmpty: true,
                        defaultValueAsEmpty: true,
                        emptyTip: this.lp.inputYourOldPassword,
                        attr: {"placeholder": this.lp.oldPassword},
                        event: {
                            focus: function (it) {
                                if ("password" === it.getValue()) it.setValue("");
                                if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive);
                            }.bind(this),
                            blur: function (it) {
                                // it.verify(true);
                                if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputPassword);
                            }.bind(this),
                            keyup: function (it, ev) {
                                if (ev.event.keyCode === 13) this.ok();
                            }.bind(this)
                        },
                        onEmpty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this),
                        onUnempty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputPassword);
                        }.bind(this)
                    },
                    newPassword: {
                        text: this.lp.newPassword,
                        type: "password",
                        className: "inputPassword",
                        notEmpty: true,
                        defaultValueAsEmpty: true,
                        emptyTip: this.lp.inputYourNewPassword,
                        attr: {"placeholder": this.lp.newPassword},
                        validRule: {
                            passwordIsWeak: function (value, it) {
                                return !this.getPasswordRule(it.getValue());
                            }.bind(this)
                        },
                        validMessage: {
                            passwordIsWeak: function () {
                                return self.getPasswordRule(this.getValue());
                            }
                        },
                        event: {
                            focus: function (it) {
                                if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive);
                            }.bind(this),
                            blur: function (it) {
                                // it.verify(true);
                            }.bind(this),
                            keyup: function (it, ev) {
                                if (ev.event.keyCode === 13)this.ok();
                            }.bind(this)
                        },
                        onEmpty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this),
                         onUnempty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputPassword);
                        }.bind(this)
                    },
                    confirmPassword: {
                        text: this.lp.confirmNewPassword,
                        type: "password",
                        className: "inputComfirmPassword",
                        notEmpty: true,
                        defaultValueAsEmpty: true,
                         emptyTip: this.lp.inputComfirmPassword,
                        attr: {"placeholder": this.lp.confirmPassword},
                        validRule: {
                            passwordNotEqual: function (value, it) {
                                if (it.getValue() === this.form.getItem("newPassword").getValue()) return true;
                            }.bind(this)
                        },
                        validMessage: {passwordNotEqual: this.lp.passwordNotEqual},
                        event: {
                            focus: function (it) {
                                if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputActive);
                            }.bind(this),
                            blur: function (it) {
                                // it.verify(true);
                                if (!it.warningStatus) it.getElements()[0].setStyles(this.css.inputComfirmPassword);
                            }.bind(this),
                            keyup: function (it, ev) {
                                if (ev.event.keyCode === 13)this.ok();
                            }.bind(this)
                        },
                        onEmpty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputEmpty);
                        }.bind(this),
                         onUnempty: function (it) {
                            it.getElements()[0].setStyles(this.css.inputComfirmPassword);
                        }.bind(this)
                    },

                    forgetPassword: {
                        value: this.lp.forgetPassword,
                        type: "innerText",
                        className: "forgetPassword",
                        event: {
                            click: function () {
                                this.gotoResetPassword();
                            }.bind(this)
                        }
                    },
                    gotoLoginAction: {
                        value: this.lp.loginAction,
                        type: "innerText",
                        className: "signUpAction",
                        event: {
                            click: function () { this.gotoLogin() }.bind(this)
                        }
                    },
                    passwordTip: {
                        type: "innerText",
                        className: "forgetPassword",
                        defaultValue: layout.config.passwordRegexHint || ""
                    },
                    submitAction: {
                        value: this.lp.submitAction,
                        type: "button",
                        className: "inputLogin",
                        event: {
                            click: function () {
                                this.ok();
                            }.bind(this)
                        }
                    }
                }
            }, this.app, this.css);
            this.form.load();
        }.bind(this), true);

    },
    gotoLogin: function () {
        this.explorer.openLoginForm({}, function () { window.location.reload(); });
        this.close();
    },
    getPasswordRule: function (password) {
        var str = "";
        this.actions.checkRegisterPassword(password, function (json) {
            str = json.data.value || "";
        }.bind(this), null, false);
        return str;
    },
    gotoResetPassword: function () {
        this.explorer.openResetPasswordForm();
        this.close();
    },
    ok: function () {
        this.fireEvent("queryOk");
        this.errorArea.empty();
        var data = this.form.getResult(true, ",", true, false, true);
        if (data) {
            this._ok(data, function (json) {
                if (json.type === "error") {
                    if (this.app) this.app.notice(json.message, "error");
                } else {

                    this._close();
                    if (this.formMaskNode) this.formMaskNode.destroy();
                    this.formAreaNode.destroy();
                    if (this.explorer && this.explorer.view) this.explorer.view.reload();
                    if (this.app) this.app.notice(this.lp.changePasswordSuccess, "success");
                    this.fireEvent("postOk", json);
                }
            }.bind(this));
        }
    },
    setWarning: function (text) {
        this.errorArea.empty();
        new Element("div", {
            "text": text,
            "styles": this.css.warningMessageNode
        }).inject(this.errorArea);
    },
    _ok: function (data, callback) {
        var d = {
            userName : this.options.userName,
            oldPassword : data.password,
            newPassword : data.newPassword,
            confirmPassword : data.confirmPassword,
            isEncrypted : "n" //是否启用加密,默认不加密,启用(y)。注意:使用加密先要在服务器运行 create encrypt key"
        }
        // o2.Actions.load("x_organization_assemble_personal").PasswordAction.changePassword( d, function (json) {
        o2.Actions.load("x_organization_assemble_personal").ResetAction.setPasswordAnonymous( d, function (json) {
            if (callback) callback(json);
            //this.fireEvent("postOk")
        }.bind(this), function (errorObj) {
            var error = JSON.parse(errorObj.responseText);
            this.setWarning(error.message);
        }.bind(this) )
    }
});

MWF.require("MWF.widget.Dialog", null, false);
MWF.xDesktop.Window = new Class({
	Extends: MWF.widget.Dialog,
	Implements: [Options, Events],
	options: {
		"style": "default",
		"title": "window",
		"width": "800",
		"height": "600",
		"top": "10",
		"left": "10",
		"fromTop": "0",
		"fromLeft": "0",
		"mark": false,

		"html": "",
		"text": "",
		"url": "",
		"content": null,

		"isMax": true,
		"isClose": true,
		"isResize": true,
		"isMove": true,
		
		"buttons": null,
		"buttonList": null
	},
	initialize: function(app, options){

		var position = layout.desktop.desktopNode.getPosition();
	//	var size = layout.desktop.desktopNode.getSize();
		
		this.options.top = parseFloat(this.options.top)+position.y;
		this.options.fromTop = parseFloat(this.options.fromTop)+position.y;
		
		this.app = app;
		this.parent(options);
		this.isHide = false;
		this.isMax = false;
	},
    // _loadCss: function(){
     //    if (this.app.windowCss){
	// 		this.css = this.app.windowCss;
     //    }else{
     //        var key = encodeURIComponent(this.cssPath);
     //        if (!reload && MWF.widget.css[key]){
     //            this.css = MWF.widget.css[key];
     //        }else{
     //            this.cssPath = (this.cssPath.indexOf("?")!=-1) ? this.cssPath+"&v="+COMMON.version : this.cssPath+"?v="+COMMON.version;
     //            var r = new Request.JSON({
     //                url: this.cssPath,
     //                secure: false,
     //                async: false,
     //                method: "get",
     //                noCache: false,
     //                onSuccess: function(responseJSON, responseText){
     //                    this.css = responseJSON;
     //                    MWF.widget.css[key] = responseJSON;
     //                }.bind(this),
     //                onError: function(text, error){
     //                    alert(error + text);
     //                }
     //            });
     //        }
     //    }
	// },
	changeStyle: function(){
        var obj = this.getNodeStyleStatus();
        this.cssPath = MWF.defaultPath+"/widget/$Dialog/"+this.options.style+"/css.wcss";
        this._loadCss();

        this.getContentUrl();
        var request = new Request.HTML({
            url: this.contentUrl,
            method: "GET",
            async: false,
            onSuccess: function(responseTree){
                var node = responseTree[0];
                var title = node.getElement(".MWF_dialod_title");
                var titleCenter = node.getElement(".MWF_dialod_title_center");
                var titleRefresh = node.getElement(".MWF_dialod_title_refresh");
                var titleText = node.getElement(".MWF_dialod_title_text");
                var titleAction = node.getElement(".MWF_dialod_title_action");
                var under = node.getElement(".MWF_dialod_under");
                var content = node.getElement(".MWF_dialod_content");
                var bottom = node.getElement(".MWF_dialod_bottom");
                var resizeNode = node.getElement(".MWF_dialod_bottom_resize");
                var button = node.getElement(".MWF_dialod_button");

                if (this.title && title){
                	this.title.clearStyles();
                	this.title.set("style", title.get("style"));
				}
                if (this.titleCenter && titleCenter){
                    this.titleCenter.clearStyles();
                    this.titleCenter.set("style", titleCenter.get("style"));
                }
                if (this.titleRefresh && titleRefresh){
                    this.titleRefresh.clearStyles();
                    this.titleRefresh.set("style", titleRefresh.get("style"));
                }
                if (this.titleText && titleText){
                    this.titleText.clearStyles();
                    this.titleText.set("style", titleText.get("style"));
                }
                if (this.titleAction && titleAction){
                    this.titleAction.clearStyles();
                    this.titleAction.set("style", titleAction.get("style"));
                }
                if (this.under && under){
                    this.under.clearStyles();
                    this.under.set("style", under.get("style"));
                }
                if (this.content && content){
                    this.content.clearStyles();
                    this.content.set("style", content.get("style"));
                }
                if (this.bottom && bottom){
                    this.bottom.clearStyles();
                    this.bottom.set("style", bottom.get("style"));
                }
                if (this.resizeNode && resizeNode){
                    this.resizeNode.clearStyles();
                    this.resizeNode.set("style", resizeNode.get("style"));
                }
                if (this.button && button){
                    this.button.clearStyles();
                    this.button.set("style", button.get("style"));
                }


                this.setNodeStyleStatus(obj);

                this.node.setStyles(this.css.to);
                this.spacer.setStyles(this.css.spacerTo);

                if (this.closeActionNode) this.closeActionNode.setStyles(this.css.closeActionNode);
                if (this.maxActionNode) this.maxActionNode.setStyles(this.css.maxActionNode);
                if (this.minActionNode) this.minActionNode.setStyles(this.css.minActionNode);
                if (this.restoreActionNode) this.restoreActionNode.setStyles(this.css.restoreActionNode);

                if (this.app == this.app.desktop.currentApp){
                    this.node.setStyles(this.css.current);
                    this.spacer.setStyles(this.css.spacerCurrent);
                }else{
                    this.node.setStyles(this.css.uncurrent);
                    this.spacer.setStyles(this.css.spacerUncurrent);
                }

                this.setContentSize();


            }.bind(this)
        });
        request.send();



	},
	setNodeStyleStatus: function(obj){
		this.css.to.height = obj.nodeTo.height;
		this.css.to.width = obj.nodeTo.width;
		this.css.to.top = obj.nodeTo.top;
		this.css.to.left = obj.nodeTo.left;
		this.css.to["z-index"] = obj.nodeTo["z-index"];
		
		this.css.from.top = obj.nodeFrom.top;
		this.css.from.left = obj.nodeFrom.left;
		this.css.from["z-index"] = obj.nodeFrom["z-index"];
		
		this.css.spacerTo.height = obj.spacerTo.height;
		this.css.spacerTo.width = obj.spacerTo.width;
		this.css.spacerTo.top = obj.spacerTo.top;
		this.css.spacerTo.left = obj.spacerTo.left;
		this.css.spacerTo["z-index"] = obj.spacerTo["z-index"];
		
		this.css.spacerFrom.top = obj.spacerFrom.top;
		this.css.spacerFrom.left = obj.spacerFrom.left;
		this.css.spacerFrom["z-index"] = obj.spacerFrom["z-index"];
	},
	
	getNodeStyleStatus: function(){
		return {
			"nodeTo": {
				"height": this.css.to.height,
				"width": this.css.to.width,
				"top": this.css.to.top,
				"left": this.css.to.left,
				"z-index": this.css.to["z-index"]
			},
			"nodeFrom": {
				"top": this.css.from.top,
				"left": this.css.from.left,
				"z-index": this.css.from["z-index"]
			},
			"spacerTo": {
				"height": this.css.spacerTo.height,
				"width": this.css.spacerTo.width,
				"top": this.css.spacerTo.top,
				"left": this.css.spacerTo.left,
				"z-index": this.css.spacerTo["z-index"]
			},
			"spacerFrom": {
				"top": this.css.spacerFrom.top,
				"left": this.css.spacerFrom.left,
				"z-index": this.css.spacerFrom["z-index"]
			}
		};
	},
	reStyle: function(options){
		if (options) this.setOptions(options);
		
		var index = null;
		if (MWF.xDesktop.zIndexPool) index = MWF.xDesktop.zIndexPool.applyZindex();

		this.css.to.height = this.options.height+"px";
		this.css.to.width = this.options.width+"px";
		this.css.to.top = this.options.top+"px";
		this.css.to.left = this.options.left+"px";
	//	this.css.to.top = this.options.top+"px";
		this.css.from.top = this.options.fromTop+"px";
		this.css.from.left = this.options.fromLeft+"px";
		if (index){
			this.css.from["z-index"] = index+1;
			this.css.to["z-index"] = index+1;
		}
		if (this.node) this.node.set("styles", this.css.from);
		
		this.css.spacerTo.height = this.options.height+"px";
		this.css.spacerTo.width = this.options.width+"px";
		this.css.spacerTo.top = this.options.top+"px";
		this.css.spacerTo.left = this.options.left+"px";
	//	this.css.spacerTo.top = this.options.top+"px";
		this.css.spacerFrom.top = this.options.fromTop+"px";
		this.css.spacerFrom.left = this.options.fromLeft+"px";
		if (index){
			this.css.spacerFrom["z-index"] = index;
			this.css.spacerTo["z-index"] = index;
		}
		if (this.spacer) this.spacer.set("styles", this.css.spacerFrom);
	},
	
	setCurrent: function(){
		if (MWF.xDesktop.zIndexPool){
			var index = this.node.getStyle("z-index").toFloat()+1;
			if (index < MWF.xDesktop.zIndexPool.zIndex){
				var newIndex = MWF.xDesktop.zIndexPool.applyZindex();
				
				this.css.spacerTo["z-index"] = newIndex;
				this.css.spacerFrom["z-index"] = newIndex;
				
//				if(this.spacerMorph){
//					if (this.spacerMorph.isRunning()){
//						this.spacerMorph.chain(function(){
//							if (this.spacer) this.spacer.setStyle("z-index", newIndex);
//						}.bind(this));
//					}else{
						if (this.spacer) this.spacer.setStyle("z-index", newIndex);
//					}
//				}

				this.css.to["z-index"] = newIndex+1;
				this.css.from["z-index"] = newIndex+1;
				
//				if(this.morph){
//					if (this.morph.isRunning()){
//						this.morph.chain(function(){
//							this.node.setStyle("z-index", newIndex+1);
//						}.bind(this));
//					}else{
						this.node.setStyle("z-index", newIndex+1);
//					}
//				}
			}
		}
		this.node.setStyles(this.css.current);
		if (this.spacer) this.spacer.setStyles(this.css.spacerCurrent);
	},
	setUncurrent: function(){
		this.node.setStyles(this.css.uncurrent);
		if (this.spacer) this.spacer.setStyles(this.css.spacerUncurrent);
	},
	setTitleEvent: function(){
		this.node.addEvent("mousedown", function(){
			this.app.setCurrent();
		}.bind(this));

        this.containerDrag = new Drag(this.title, {
            "handle": this.title,
            "onStart": function(el, e){
                this.containerDrag.stop();
                var div = this.node.clone(false).inject($(document.body));
                var size = this.node.getSize();
                div.setStyles({
                    "opacity": 0.7,
                    "border": "2px dashed #999",
                    "z-index": this.node.getStyle("z-index"),
                    "width": size.x,
                    "height": size.y,
                    "background-color": "#CCC",
                    "position": "absolute"
                });
                div.position({
                    relativeTo: this.node,
                    position: 'upperLeft',
                    edge: 'upperLeft'
                });

                var drag = new Drag.Move(div, {
                    "onStart": function(){
                        //this.node.setStyle("display", "none");
                        this.node.fade("out");
                        this.spacer.fade("out");
                    }.bind(this),
                    "onDrop": function(dragging, inObj, e){
                        
                        this.node.fade("in");
                        this.spacer.fade(this.css.spacerTo.opacity);
                        this.node.position({
                            relativeTo: dragging,
                            position: 'upperLeft',
                            edge: 'upperLeft'
                        });
                        var p = this.node.getPosition();
                        this.spacer.setStyles({
                            "top": p.y,
                            "left": p.x
                        });
                        this.css.spacerTo.left = p.x;
                        this.css.spacerTo.top = p.y;
                        this.css.to.left = p.x;
                        this.css.to.top = p.y;
                        dragging.destroy();
                        this.fireEvent("moveDrop", [e]);
                    }.bind(this),
                    "onCancel": function(dragging){
                        dragging.destroy();
                        drag = null;
                    }
                });
                drag.start(e);
            }.bind(this)
        });



        //this.title.addEvent("mousedown", function(e){
        //}.bind(this));

        //this.containerDrag = new Drag.Move(this.node, {
        //    "limit": {"x": [null, null], "y": [0, null]},
        //    "handle": this.title,
        //    "onDrag": function(){
        //        var p = this.node.getPosition();
        //        if (this.spacer){
        //            this.spacer.setStyles({
        //                "top": p.y,
        //                "left": p.x
        //            });
        //            this.css.spacerTo.left = p.x;
        //            this.css.spacerTo.top = p.y;
        //        };
        //        this.css.to.left = p.x;
        //        this.css.to.top = p.y;
        //    }.bind(this)
        //});
		
		if (this.options.isResize){
			this.node.makeResizable({
				"handle": this.resizeNode || this.bottom,
				"limit": {x:[200, null], y:[200, null]},
				"onDrag": function(){
					var size = this.node.getComputedSize();
					
					if (this.spacer){
						this.spacer.setStyles({
							"width": size.width,
							"height": size.height
						});
						this.css.spacerTo.width = size.width;
						this.css.spacerTo.height = size.height;
					}
					this.css.to.width = size.width;
					this.css.to.height = size.height;
	
					this.setContentSize(size.height, size.width);
					
					this.fireEvent("resize");
				}.bind(this),
                "onComplete": function(){
                    this.fireEvent("resizeCompleted");
                }.bind(this)
			});
		}
	},
	getContentUrl: function(){
		if (layout.desktop.windowCss){
            this.contentUrl = MWF.defaultPath+"/xDesktop/$Window/desktop_default/dialog.html";
		}else{
            this.contentUrl = MWF.defaultPath+"/xDesktop/$Window/"+this.options.style+"/dialog.html";
		}

	},
	
	_loadCss: function(){
        if (this.app.desktop.windowCss){
            this.css = this.app.desktop.windowCss;
        }else{
            this.path = MWF.defaultPath+"/xDesktop/$Window/";
            this.cssPath = MWF.defaultPath+"/xDesktop/$Window/"+this.options.style+"/css.wcss";

            var r = new Request.JSON({
                url: this.cssPath,
                secure: false,
                async: false,
                method: "get",
                noCache: true,
                onSuccess: function(responseJSON, responseText){
                    this.css = responseJSON;
                }.bind(this),
                onError: function(text, error){
                    alert(text);
                }
            });
            r.send();
        }
	},
	getSpacer: function(){
		if (!this.spacer){
			this.spacer = new Element("div", {
				styles: this.css.spacerFrom
			}).inject(this.options.container || $(document.body));
		}
	},
    showNoAnimation: function(max, hide){
        if (max){
            this.showMaxIm();
        }else if (hide){
            this.showIm();
            this.hideIm();
        }else{
            this.showIm();
        }
    },
    showMaxIm: function(callback){
        this.querySetMaxStyle();
        this.getSpacer();
        this.spacer.setStyle("display", "block");
        this.node.setStyle("display", "block");

        var size = this.getMaxSize();

        var spacerTo = Object.clone(this.css.spacerTo);
        var to = Object.clone(this.css.to);
        var contentTo = {};

        spacerTo.top = size.position.y;
        spacerTo.left = size.position.x;
        spacerTo.width = size.spacer.x;
        spacerTo.height = size.spacer.y;

        to.top = size.position.y;
        to.left = size.position.x;
        to.width = size.node.x;
        to.height = size.node.y;

        contentTo = size.contentSize;

        if (this.fireEvent("queryShow")){
            this.fireEvent("queryMax");
            this.node.setStyles(to);
            this.spacer.setStyles(spacerTo);
            this.content.setStyles(contentTo);

            if (this.titleText) this.getTitle();
            this.isMax = true;
            this.isHide = false;
            if (this.containerDrag) this.containerDrag.detach();

            this.postSetMaxStyle();

            if (callback) callback();
            this.fireEvent("postShow");
            this.fireEvent("postMax");
            if (this.maxActionNode) this.maxActionNode.setStyles(this.css.restoreActionNode);
        }
    },
    showIm: function(){
        if (this.options.mark) this._markShow();
        this.getSpacer();
        this.spacer.setStyle("display", "block");
        this.node.setStyle("display", "block");
        var contentSize = this.getContentSize(this.css.to.height.toFloat(), this.css.to.width.toFloat());

        if (this.fireEvent("queryShow")){

            this.spacer.setStyles(this.css.spacerTo);
            if (this.app.desktop.currentApp!=this.app) this.spacer.setStyles(this.css.spacerUncurrent);
            this.content.setStyles(contentSize);
            this.node.setStyles(this.css.to);

            if (this.titleText) this.getTitle();
            this.isHide = false;
            if (this.containerDrag) this.containerDrag.attach();
            this.fireEvent("postShow");
        }
    },
	show: function(){
		if (this.options.mark) this._markShow();
		if (!this.morph){
			this.morph = new Fx.Morph(this.node, {duration: 100, link: "chain"});
		}
		this.morph.setOptions({duration: 50});

		this.getSpacer();
		if (!this.spacerMorph){
			this.spacerMorph = new Fx.Morph(this.spacer, {duration: 100, link: "chain"});
		}
		this.spacerMorph.setOptions({duration: 50});
		
		if (!this.contentMorph){
			this.contentMorph = new Fx.Morph(this.content, {duration: 50, link: "chain"});
		}
		this.contentMorph.setOptions({duration: 50});
		
		this.spacer.setStyle("display", "block");
		this.node.setStyle("display", "block");
		
		var contentSize = this.getContentSize(this.css.to.height.toFloat(), this.css.to.width.toFloat());

		if (this.fireEvent("queryShow")){
			var nodeFinish = false;
			var spacerFinish = false;
			var contentFinish = false;
			
			this.spacerMorph.start(this.css.spacerTo).chain(function(){
				if (this.app.desktop.currentApp!=this.app) this.spacer.setStyles(this.css.spacerUncurrent);
				spacerFinish = true;
				firePost();
			}.bind(this));

			this.contentMorph.start(contentSize).chain(function(){
				contentFinish = true;
				firePost();
			}.bind(this));

			this.morph.start(this.css.to).chain(function(){
				nodeFinish = true;
				firePost();
			}.bind(this));
			
			var firePost = function(){
				if (nodeFinish && spacerFinish && contentFinish){
					if (this.titleText) this.getTitle();
					this.isHide = false;
					if (this.containerDrag) this.containerDrag.attach();
					this.fireEvent("postShow");

//					if (this.isMax){
//						this.isMax = false;
//						this.app.maxSize();
//					}
				} 
			}.bind(this);
		}
	},
	restore: function(callback){
		this.querySetRestoreStyle();
		if (this.options.mark) this._markShow();
		if (!this.morph){
			this.morph = new Fx.Morph(this.node, {duration: 100, link: "chain"});
		}
		this.morph.setOptions({duration: 50});
		this.getSpacer();
		if (!this.spacerMorph){
			this.spacerMorph = new Fx.Morph(this.spacer, {duration: 100, link: "chain"});
		}
		this.spacerMorph.setOptions({duration: 50});
		
		if (!this.contentMorph){
			this.contentMorph = new Fx.Morph(this.content, {duration: 50, link: "chain"});
		}
		this.contentMorph.setOptions({duration: 50});
		this.spacer.setStyle("display", "block");
		this.node.setStyle("display", "block");
		
		var contentSize = this.getContentSize(this.css.to.height.toFloat(), this.css.to.width.toFloat());
		
		if (this.fireEvent("queryRestore")){
			var nodeFinish = false;
			var spacerFinish = false;
			var contentFinish = false;
			
			this.spacerMorph.start(this.css.spacerTo).chain(function(){
				if (this.app.desktop.currentApp!=this.app) this.spacer.setStyles(this.css.spacerUncurrent);
				spacerFinish = true;
				firePost();
			}.bind(this));
			this.contentMorph.start(contentSize).chain(function(){
				contentFinish = true;
				firePost();
			}.bind(this));

			this.morph.start(this.css.to).chain(function(){
				if (this.app.desktop.currentApp!=this.app) this.node.setStyles(this.css.uncurrent);
				nodeFinish = true;
				firePost();
			}.bind(this));
			
			var firePost = function(){
				if (nodeFinish && spacerFinish && contentFinish){
					if (this.titleText) this.getTitle();
					this.isHide = false;
					this.isMax = false;
					if (this.containerDrag) this.containerDrag.attach();
                    this.postSetRestoreStyle();
					if (callback) callback();
					this.fireEvent("resize");
					this.fireEvent("postRestore");
				}
			}.bind(this);
			if (this.maxActionNode) this.maxActionNode.setStyles(this.css.maxActionNode);
		}
	},

    querySetRestoreStyle: function(){
        if (this.css.windowTitleRestore) this.title.setStyles(this.css.windowTitleRestore);
        if (this.css.titleRefresh) this.titleRefresh.setStyles(this.css.titleRefresh);
        if (this.css.windowTitleTextRestore) this.titleText.setStyles(this.css.windowTitleTextRestore);
        if (this.css.windowTitleActionRestore) this.titleAction.setStyles(this.css.windowTitleActionRestore);

        if (this.closeActionNode){
            if (this.css.closeActionNode) this.closeActionNode.setStyles(this.css.closeActionNode);
        }
        if (this.maxActionNode){
            if (this.css.maxActionNode) this.maxActionNode.setStyles(this.css.maxActionNode);
        }
        if (this.minActionNode){
            if (this.css.minActionNode) this.minActionNode.setStyles(this.css.minActionNode);
        }
    },
    postSetRestoreStyle: function(){
        if (this.css.windowNodeRestore) this.node.setStyles(this.css.windowNodeRestore);
    },
	restoreIm: function(callback){
        this.querySetRestoreStyle();
		this.getSpacer();
	
		this.spacer.setStyle("display", "block");
		this.node.setStyle("display", "block");
		var contentSize = this.getContentSize(this.css.to.height.toFloat(), this.css.to.width.toFloat());
		
		if (this.fireEvent("queryRestore")){
			this.node.setStyles(this.css.to);
			this.spacer.setStyles(this.css.spacerTo);
			this.content.setStyles(contentSize);
			
			if (this.titleText) this.getTitle();
			this.isHide = false;
			this.isMax = false;
			if (this.containerDrag) this.containerDrag.attach();
			this.postSetRestoreStyle();
			if (callback) callback();
			this.fireEvent("resize");
			this.fireEvent("postRestore");

			if (this.maxActionNode) this.maxActionNode.setStyles(this.css.maxActionNode);
		}
	},
    hideIm: function(x, y, callback) {
        this.getSpacer();
        if (x){
            this.css.from.left = x;
            this.css.spacerFrom.left = x;
        }
        if (y){
            this.css.from.top = y;
            this.css.spacerFrom.top = y;
        }

        if (this.fireEvent("queryHide")){
            if (this.titleText) this.titleText.set("text", "");
            if (this.button) this.button.set("html", "");

            this.spacer.setStyles(this.css.spacerFrom);

            this.node.setStyles(this.css.from);

            this._markHide();
            this.isHide = true;
            this.node.setStyle("display", "none");
            this.spacer.setStyle("display", "none");
            if (callback) callback();
            this.fireEvent("postHide");
        }
    },
	hide: function(x, y, callback) {
		if (!this.morph){
			this.morph = new Fx.Morph(this.node, {duration: 100, link: "chain"});
		}
		this.morph.setOptions({duration: 100});
		
		this.getSpacer();
		if (!this.spacerMorph){
			this.spacerMorph = new Fx.Morph(this.spacer, {duration: 100, link: "chain"});
		}
		this.spacerMorph.setOptions({duration: 100});
		
		if (x){
			this.css.from.left = x;
			this.css.spacerFrom.left = x;
		} 
		if (y){
			this.css.from.top = y;
			this.css.spacerFrom.top = y;
		} 
		
		if (this.fireEvent("queryHide")){
			if (this.titleText) this.titleText.set("text", "");
			if (this.button) this.button.set("html", "");
					
			var nodeFinish = false;
			var spacerFinish = false;
			
			this.spacerMorph.start(this.css.spacerFrom).chain(function(){
				spacerFinish = true;
				firePost();
			}.bind(this));

			this.morph.start(this.css.from).chain(function(){
				nodeFinish = true;
				firePost();
			}.bind(this));
			
			var firePost = function(){
				if (nodeFinish && spacerFinish){
					this._markHide();
					this.isHide = true;
					this.node.setStyle("display", "none");
					this.spacer.setStyle("display", "none");
					if (callback) callback();
					this.fireEvent("postHide");
				}
			}.bind(this);
		}
	},
	_hideIm: function(){
		this.node.setStyle("display", "none");
		this.spacer.setStyle("display", "none");
	},
	_showIm: function(){
		this.node.setStyle("display", "block");
		this.spacer.setStyle("display", "block");
	},
	_fadeOut: function(){
		this.node.fade("out");
		this.spacer.fade("out");
	},
	_fadeIn: function(){
		this.node.fade("in");
		this.spacer.fade("in");
	},
	
	close: function(callback){
		if (!this.morph){
			this.morph = new Fx.Morph(this.node, {duration: 100, link: "chain"});
		}
		this.morph.setOptions({duration: 100});
		this.getSpacer();
		if (!this.spacerMorph){
			this.spacerMorph = new Fx.Morph(this.spacer, {duration: 100, link: "chain"});
		}
		this.spacerMorph.setOptions({duration: 100});
		
		if (this.fireEvent("queryClose")){
			//this.spacerMorph.start(this.css.spacerFrom).chain(function(){
			//	this.spacer.destroy();
			//	this.spacer = null;
			//}.bind(this));
            //
			//this.morph.start(this.css.from).chain(function(){
			//	this._markHide();
			//	this.node.destroy();
			//	this.node = null;
			//	if (callback) callback();
			//	this.fireEvent("postClose");
			//}.bind(this));

            this.spacer.destroy();
            this.spacer = null;

            this._markHide();
            this.node.destroy();
            this.node = null;
            if (callback) callback();
            this.fireEvent("postClose");
			o2.release(this);
		}
	},
	getAction: function(){
		this.titleAction.setStyles(this.css.titleAction);
		var _self = this;
		this.closeActionNode = new Element("div", {
			"styles": this.css.closeActionNode,
			"events": {
				"mouseover": function(e){this.setStyles(_self.css.titleActionOver);e.stopPropagation();},
				"mouseout": function(e){this.setStyles(_self.css.titleActionOut);e.stopPropagation();},
				"mousedown": function(e){this.setStyles(_self.css.titleActionDown);e.stopPropagation();},
				"mouseup": function(e){this.setStyles(_self.css.titleActionOver);e.stopPropagation();},
				"click": function(e){
					this.app.close();
                    e.stopPropagation();
				}.bind(this)
			}
		}).inject(this.titleAction);
		
		if (this.options.isMax!=false){
			this.maxActionNode = new Element("div", {
				"styles": this.css.maxActionNode,
				"events": {
					"mouseover": function(){this.setStyles(_self.css.titleActionOver);},
					"mouseout": function(){this.setStyles(_self.css.titleActionOut);},
					"mousedown": function(){this.setStyles(_self.css.titleActionDown);},
					"mouseup": function(){this.setStyles(_self.css.titleActionOver);},
					"click": function(){
						this.app.maxOrRestoreSize();
					}.bind(this)
				}
			}).inject(this.titleAction);
		}
		if (this.options.isResize){
            this.title.addEvent("dblclick", this.app.maxOrRestoreSize.bind(this.app));
		}
		
		this.minActionNode = new Element("div", {
			"styles": this.css.minActionNode,
			"events": {
				"mouseover": function(){this.setStyles(_self.css.titleActionOver);},
				"mouseout": function(){this.setStyles(_self.css.titleActionOut);},
				"mousedown": function(){this.setStyles(_self.css.titleActionDown);},
				"mouseup": function(){this.setStyles(_self.css.titleActionOver);},
				"click": function(){
					this.app.minSize();
				}.bind(this)
			}
		}).inject(this.titleAction);

        if (this.options.isRefresh!=false){
            this.titleRefresh.addEvents({
                "mouseover": function(){this.setStyles(_self.css.titleActionOver);},
                "mouseout": function(){this.setStyles(_self.css.titleActionOut);},
                "mousedown": function(){this.setStyles(_self.css.titleActionDown);},
                "mouseup": function(){this.setStyles(_self.css.titleActionOver);},
                "click": function(e){
                    this.app.refresh();
                }.bind(this),
                "dblclick": function(e){
                    e.stopPropagation();
                }.bind(this)
            });
        }
	},
	maxOrRestoreSize: function(callback){
		if (this.isMax){
			this.restoreSize(callback);
		}else{
			this.maxSize(callback);
		}
	},
	restoreSize: function(callback){
		this.restore(callback);
	},
	maxSize: function(callback){
        this.querySetMaxStyle();

		if (!this.morph){
			this.morph = new Fx.Morph(this.node, {duration: 50, link: "chain"});
		}
		this.morph.setOptions({duration: 50});
		
		this.getSpacer();
		if (!this.spacerMorph){
			this.spacerMorph = new Fx.Morph(this.spacer, {duration: 50, link: "chain"});
		}
		this.spacerMorph.setOptions({duration: 50});
		
		if (!this.contentMorph){
			this.contentMorph = new Fx.Morph(this.content, {duration: 50, link: "chain"});
		}
		this.contentMorph.setOptions({duration: 50});
		
		this.spacer.setStyle("display", "block");
		this.node.setStyle("display", "block");
		
		var size = this.getMaxSize();
		
		var spacerTo = Object.clone(this.css.spacerTo);
		var to = Object.clone(this.css.to);
		var contentTo = {};
		
		spacerTo.top = size.position.y;
		spacerTo.left = size.position.x;
		spacerTo.width = size.spacer.x;
		spacerTo.height = size.spacer.y;
		
		to.top = size.position.y;
		to.left = size.position.x;
		to.width = size.node.x;
		to.height = size.node.y;

		contentTo = size.contentSize;

		if (this.fireEvent("queryMax")){
			var nodeFinish = false;
			var spacerFinish = false;
			var contentFinish = false;
			
			this.spacerMorph.start(spacerTo).chain(function(){
				if (this.app.desktop.currentApp!=this.app) this.spacer.setStyles(this.css.spacerUncurrent);
				spacerFinish = true;
				firePost();
			}.bind(this));
			this.contentMorph.start(contentTo).chain(function(){
				contentFinish = true;
				firePost();
			}.bind(this));

			this.morph.start(to).chain(function(){
				if (this.app.desktop.currentApp!=this.app) this.node.setStyles(this.css.uncurrent);
				nodeFinish = true;
				firePost();
			}.bind(this));
			
			var firePost = function(){
				if (nodeFinish && spacerFinish && contentFinish){
					if (this.titleText) this.getTitle();
					this.isMax = true;
					this.isHide = false;
					if (this.containerDrag) this.containerDrag.detach();

                    this.postSetMaxStyle();

					if (callback) callback();
					this.fireEvent("resize");
					this.fireEvent("postMax");
				}
			}.bind(this);
			
			if (this.maxActionNode) this.maxActionNode.setStyles(this.css.restoreActionNode);
		}
	},
    querySetMaxStyle: function(){
	    if (this.css.windowTitleMax) this.title.setStyles(this.css.windowTitleMax);
        if (this.css.windowTitleRefreshMax) this.titleRefresh.setStyles(this.css.windowTitleRefreshMax);
        if (this.css.windowTitleTextMax) this.titleText.setStyles(this.css.windowTitleTextMax);
        if (this.css.windowTitleActionMax) this.titleAction.setStyles(this.css.windowTitleActionMax);

        if (this.closeActionNode){
            if (this.css.windowActionNodeMax) this.closeActionNode.setStyles(this.css.windowActionNodeMax);
        }
        if (this.maxActionNode){
            if (this.css.windowActionNodeMax) this.maxActionNode.setStyles(this.css.windowActionNodeMax);
        }
        if (this.minActionNode){
            if (this.css.windowActionNodeMax) this.minActionNode.setStyles(this.css.windowActionNodeMax);
        }
	},
    postSetMaxStyle: function(){
        if (this.css.windowNodeMax) this.node.setStyles(this.css.windowNodeMax);
    },
	maxSizeIm: function(callback){
        this.querySetMaxStyle();

		this.getSpacer();
		this.spacer.setStyle("display", "block");
		this.node.setStyle("display", "block");
		
		var size = this.getMaxSize();
		
		var spacerTo = Object.clone(this.css.spacerTo);
		var to = Object.clone(this.css.to);
		var contentTo = {};
		
		spacerTo.top = size.position.y;
		spacerTo.left = size.position.x;
		spacerTo.width = size.spacer.x;
		spacerTo.height = size.spacer.y;
		
		to.top = size.position.y;
		to.left = size.position.x;
		to.width = size.node.x;
		to.height = size.node.y;
		
		contentTo = size.contentSize;

		if (this.fireEvent("queryMax")){
			this.node.setStyles(to);
			this.spacer.setStyles(spacerTo);
			this.content.setStyles(contentTo);
			
			if (this.titleText) this.getTitle();
			this.isMax = true;
			this.isHide = false;
			if (this.containerDrag) this.containerDrag.detach();

            this.postSetMaxStyle();

			if (callback) callback();
			this.fireEvent("resize");
			this.fireEvent("postMax");

			if (this.maxActionNode) this.maxActionNode.setStyles(this.css.restoreActionNode);
		}
	},
	getMaxSize: function(){
		var size = layout.desktop.desktopNode.getSize();
		var position = layout.desktop.desktopNode.getPosition();
		
		var pt = this.spacer.getStyle("padding-top").toFloat();
		var pb = this.spacer.getStyle("padding-bottom").toFloat();
		var pl = this.spacer.getStyle("padding-left").toFloat();
		var pr = this.spacer.getStyle("padding-right").toFloat();
		spacerHeight = size.y-pt-pb;
		spacerWidth = size.x-pl-pr;
		
		pt = this.node.getStyle("padding-top").toFloat();
		pb = this.node.getStyle("padding-bottom").toFloat();
		pl = this.node.getStyle("padding-left").toFloat();
		pr = this.node.getStyle("padding-right").toFloat();
		nodeHeight = size.y-pt-pb;
		nodeWidth = size.x-pl-pr;
		
		var contentSize = this.getContentSize(nodeHeight, nodeWidth);
		
		return {"node": {"x": nodeWidth, "y": nodeHeight}, "spacer": {"x": spacerWidth, "y": spacerHeight}, "position": {"x": position.x, "y": position.y}, "contentSize": contentSize};
	}
});
MWF.xDesktop.WindowTransparent = new Class({
    Implements: [Options, Events],
    options: {
        "style": "default"
    },
    initialize: function(app, options){
        this.setOptions(options);
        var position = layout.desktop.desktopNode.getPosition();
        this.app = app;

        this.fireEvent("queryLoad");
        this.isMax = false;
        this.isHide = false;
        this.css = {
            "to": {"width": "0", "height": "0", "left": "0", "top": "0"}
        };

        var index = null;
        if (MWF.xDesktop.zIndexPool) index = MWF.xDesktop.zIndexPool.applyZindex();
        this.node = new Element("div", {
            "styles":{
                "width": "0px",
                "height": "0px",
                "top": "0px",
                "left": "0px",
                "position": "absolute",
                "z-index": (index)? index : 100
            }
        }).inject(this.options.container || $(document.body));
        this.content = new Element("div", {
            "styles": {"width": "100%", "height": "100%"}
        }).inject(this.node);
        this.fireEvent("postLoad");
    },
    show: function(){
        this.fireEvent("queryShow");
        this.node.setStyle("display", "block");
        this.isHide = false;
        this.fireEvent("postShow");
    },
    hide: function(){
        this.fireEvent("queryHide");
        this.node.setStyle("display", "none");
        this.isHide = true;
        this.fireEvent("postHide");
    },
    restore: function(callback) {
        this.fireEvent("queryRestore");
        this.node.setStyle("display", "block");
        this.isHide = false;
        this.fireEvent("postRestore");
        if (callback) callback();
    },
    restoreSize: function(callback){
        this.restore(callback);
    },
    close: function(callback){
        this.fireEvent("queryClose");
        this.node.destroy();
        this.node = null;
        this.content = null;
        delete this;
        if (callback) callback();
        this.fireEvent("postClose");
    },
    maxOrRestoreSize: function(callback){
        if (this.isMax){
            this.restoreSize(callback);
        }else{
            this.maxSize(callback);
        }
    },
    maxSize: function(callback){
        this.fireEvent("queryMax");
        this.node.setStyle("display", "block");
        this.isHide = false;
        this.fireEvent("resize");
        this.fireEvent("postMax");
        if (callback) callback();
    },
    restoreIm: function(){
        this.restore();
    },
    maxSizeIm: function(){
        this.maxSize();
    },
    setCurrent: function(){
        if (MWF.xDesktop.zIndexPool){
            var index = this.node.getStyle("z-index").toFloat()+1;
            if (index < MWF.xDesktop.zIndexPool.zIndex){
                var newIndex = MWF.xDesktop.zIndexPool.applyZindex();
                this.node.setStyle("z-index", newIndex);
            }
        }
    },
    _fadeOut: function(){
        this.node.fade("out");
        if (this.spacer) this.spacer.fade("out");
    },
    _fadeIn: function(){
        this.node.fade("in");
        if (this.spacer) this.spacer.fade("in");
    },
    setUncurrent: function(){},
    reStyle: function(){},
    changeStyle: function(){}
});
MWF.xApplication.Common = MWF.xApplication.Common || {
	options: {
		"multitask": false,	//允许多窗口运行
		"executable": true	//可执行
	}
};
MWF.require("MWF.xDesktop.Window", null, false);

(function () {
	var removeOn = function (string) {
		return string.replace(/^on([A-Z])/, function (full, first) {
			return first.toLowerCase();
		});
	};
	Events.implement({
		"fireEvent": function (type, args, delay) {
			if (this.options && this.options.name && MWF.xDesktop && MWF.xDesktop.$globalEvents) {
				if (MWF.xDesktop.$globalEvents[this.options.name]) {
					var evs = MWF.xDesktop.$globalEvents[this.options.name][type];
					if (evs) {
						evs.each(function (fn) {
							if (delay) fn.delay(delay, this, args);
							else fn.apply(this, args);
						}, this);
					}
				}
			}

			type = removeOn(type);
			var events = this.$events[type];
			if (!events) return this;
			args = Array.convert(args);
			events.each(function (fn) {
				if (delay) fn.delay(delay, this, args);
				else fn.apply(this, args);
			}, this);
			return this;
		}
	});
})();

MWF.xApplication.Common.Main = new Class({
	Extends: MWF.widget.Common,
	Implements: [Options, Events],

	options: {
		"desktopReload": true,
		"style": "default",
		"name": "Common",
		"icon": "", //图标
		"title": "", //标题
		"event": null,
		"width": "800",
		"height": "600",
		"isResize": true,
		"isMax": true,
		"setCurrent": true,
		"isRefresh": false,
		"isWindowRefresh": true,
		"embededParent": ""
	},
	initialize: function (desktop, options) {
		this.setOptions(options);
		this.desktop = desktop;

		this.path = "../x_component_" + this.options.name.replace(/\./g, "_") + "/$Main/";
		this.options.icon = this.path + this.options.style + "/" + this.options.icon;

		this.cssPath = this.path + this.options.style + "/css.wcss";
		if (this.options.mvcStyle) this.stylePath = this.path + this.options.style + "/" + this.options.mvcStyle;
		if (!this.options.mvcStyle) this._loadCss();

		if( this.options.embededParent && o2.typeOf(this.options.embededParent)==="element" ){
			this.embeded = true;
		}
	},
	fireAppEvent: function (when) {
		this.fireEvent(when);
		if (this[("on-" + when).camelCase()]) this[("on-" + when).camelCase()]();
		//		if (this[("on-"+when).camelCase()+"Events"){
		//			this[("on-"+when).camelCase()+"Events".each(function(event){
		//				event.apply(this);
		//			}.bind(this));
		//		}
	},
	loadNoAnimation: function (isCurrent, max, hide) {
		this.fireAppEvent("queryLoad");
		if( this.embeded ){
			this.loadEmbeded();
		}else if (!this.inBrowser) {
			if (layout.viewMode==="Homepage"){
				this.loadWindowFlat(isCurrent);
			}else{
				this.loadWindow(isCurrent, false, max, hide);
			}
		} else {
			this.loadInBrowser(isCurrent);
		}
	},
	load: function (isCurrent, content) {
		this.fireAppEvent("queryLoad");
		if( this.embeded ){
			this.loadEmbeded();
		}else if (!this.inBrowser) {
			if (layout.viewMode==="Default"){
				this.loadWindowFlat(isCurrent);
			}else{
				this.loadWindow(isCurrent);
			}
		} else {
			this.loadInBrowser(content);
		}
	},
	loadApplication: function (callback) {
		if (callback) callback();
	},
	loadWindow: function (isCurrent, animation, max, hide) {
		this.fireAppEvent("queryLoadWindow");
		var options = {
			"style": "desktop_" + this.desktop.options.style,
			"title": this.options.title,
			"isResize": this.options.isResize,
			"isMax": this.options.isMax,
			"isRefresh": this.options.isWindowRefresh,
			"container": this.desktop.node,
			"onPostShow": function () {
				if (isCurrent) this.setCurrent();
				this.fireAppEvent("postLoadWindow");
				this.fireAppEvent("queryLoadApplication");
				//load css
				if (this.options.title) this.setTitle(this.options.title);
				if (this.stylePath) {
					(this.window.node || this.content).loadCss(this.stylePath, this.loadWindowApplication.bind(this));
				}else{
					this.loadWindowApplication();
				}
			}.bind(this),
			"onResize": function () {
				this.window.options.title = this.options.title;
				this.window.getTitle();
				this.fireAppEvent("resize");
			}.bind(this),
			"onResizeCompleted": function () {
				this.fireAppEvent("resizeCompleted");
			}.bind(this),
			"onMoveDrop": function (e) {
				if (Browser.name == "firefox") {
					if (e.event.clientX < 0 || e.event.clientY < 0) this.openInNewBrowser();
				} else {
					if (e.event.x < 0 || e.event.y < 0) this.openInNewBrowser();
				}

			}.bind(this)
		};

		if (this.options.event) {
			options.fromTop = this.options.event.page.y;
			options.fromLeft = this.options.event.page.x;
		}
		options.width = this.options.width || options.width;
		options.height = this.options.height || options.height;

		this.window = new MWF.xDesktop.Window(this, options);
		this.fireAppEvent("loadWindow");
		//this.maxSize();
		this.content = this.window.content;
		if (animation === false) {
			this.window.showNoAnimation(max, hide);
		} else {
			this.window.show();
		}
	},
	loadWindowApplication: function(){
		this.setContentEvent();
		this.content.addClass("appContent");
		this.loadApplication(function () {
			this.fireAppEvent("postLoadApplication");
		}.bind(this));
		this.fireAppEvent("postLoad");
	},

	loadWindowFlat: function (isCurrent) {
		this.window = {
			"app": this,
			"isHide": false,
			"isMax": true,
			"maxSize": function () { },
			"restore": function () { },
			"setCurrent": function () {
				//this.content.show();
				this.window.node.removeClass("layout_component_node_hide");
				this.window.node.addClass("layout_component_node_show");
				//this.window.node.fade("in");
			}.bind(this),
			"setUncurrent": function () {
				//this.content.hide();
				this.window.node.addClass("layout_component_node_hide");
				this.window.node.removeClass("layout_component_node_show");
				//this.window.node.fade("out");
			}.bind(this),
			"hide": function () { },
			"maxOrRestoreSize": function () { },
			"restoreSize": function () { },
			"close": function (callback) {
				this.content.destroy();
				if (callback) callback();
			}.bind(this)
		};

        // var component = this;
        // var OaComponent = class  extends HTMLDivElement {
        //     constructor() {
        //         super();
        //         var shadow = this.attachShadow({mode: 'open'});
        //
        //         // var shadow = layout.desktop.contentNode.attachShadow({mode: 'open'});
        //         // component.window.node = shadow;
        //         component.window.content = new Element("div.layout_component_content");
        //         component.content = component.window.content;
        //         shadow.appendChild(component.content);
        //     }
        // };
        // debugger;
        // var id = this.options.name.toLowerCase();
        // //var id = o2.uuid().substring(0,5).toLowerCase();
        // customElements.define('oa-component-'+id, OaComponent);
        // var node = document.createElement("oa-component"+id);
        // node.className="layout_component_node";
        // this.window.node = node;
        // layout.desktop.contentNode.appendChild(node);
        // component.content = new Element("div.layout_component_content").inject(node);

        // this.window.node = new Element("oa-component.layout_component_node").inject(layout.desktop.contentNode);


        // var shadow = layout.desktop.contentNode.attachShadow({mode: 'open'});
        // this.window.node = shadow;
        // this.window.content = new Element("div.layout_component_content");
        // this.content = this.window.content;
        // shadow.appendChild(this.content);

        this.window.node = this.windowNode || new Element("div.layout_component_node").inject(layout.desktop.contentNode);
		this.window.content = new Element("div.layout_component_content").inject(this.window.node);
		this.content = this.window.content;

		//this.window.setUncurrent();

		this.resizeFun = function(){
			this.fireAppEvent("resize");
		}.bind(this);

		layout.desktop.addEvent("resize", this.resizeFun);

		// window.addEventListener("beforeunload", function (e) {
		// 	this.fireAppEvent("queryClose");
		// }.bind(this));
		// window.addEventListener("pagehide", function (e) {
		// 	this.fireAppEvent("queryClose");
		// }.bind(this));

		if (isCurrent){
			this.setCurrent();
		}else{
			this.setUncurrent();
		}
		this.fireAppEvent("postLoadWindow");
		this.fireAppEvent("queryLoadApplication");

		//load css
		if (this.options.title) this.setTitle(this.options.title);
		if (this.stylePath) {
			(this.window.node || this.content).loadCss(this.stylePath, this.loadWindowApplication.bind(this));
		}else{
			this.loadWindowApplication();
		}
	},

	loadInBrowser: function (content) {
		this.window = {
			"isHide": false,
			"isMax": true,
			"maxSize": function () { },
			"restore": function () { },
			"setCurrent": function () {},
			"setUncurrent": function () {},
			"hide": function () { },
			"maxOrRestoreSize": function () { },
			"restoreSize": function () { },
			"close": function () { }
		};
		this.window.titleText = $(document.head).getElement("title");
		try {
			this.window.titleText.set("text", this.options.title);
		} catch (e) { }

		if (content && o2.typeOf(content)==="element") this.window.content = content;
		if (!this.window.content) this.window.content = $("appContent") || $("layout");
		if (!this.window.content) {
			this.window.content = new Element("div", {"styles": {"width": 0, "height": 0}}).inject(document.body);
		}
		this.content = this.window.content;
		//this.content.setStyles({"height": "100%", "overflow": "hidden"});

		window.addEvent("resize", function () {
			this.fireAppEvent("resize");
		}.bind(this));
		// $(document.body).addEvent("resize", function(){
		// 	debugger;
		//     this.fireAppEvent("resize");
		// }.bind(this));
		window.addEventListener("beforeunload", function (e) {
			this.fireAppEvent("queryClose");
		}.bind(this));

		if(layout.mobile){
			window.addEventListener("pagehide", function (e) {
				this.fireAppEvent("queryClose");
			}.bind(this));
		}

		// window.onbeforeunload = function(e){
		//     this.fireAppEvent("queryClose");
		// }.bind(this);

		this.fireAppEvent("postLoadWindow");
		this.fireAppEvent("queryLoadApplication");
		this.setContentEvent();

		if (this.options.title) this.setTitle(this.options.title);
		if (this.stylePath) o2.loadCss(this.stylePath);
		this.content.addClass("appContent");
		this.loadApplication(function () {
			this.fireAppEvent("postLoadApplication");
		}.bind(this));

		//this.content.setStyle("height", document.body.getSize().y);

		this.fireAppEvent("postLoad");
	},

	setEventTarget: function( eventTarget ){
		if( !this.embeded )return;

		if (this.eventTarget){
			if( this.resizeFun )this.eventTarget.removeEvent("resize", this.resizeFun );
			this.resizeFun = null;

			if( this.queryLoadFun )this.eventTarget.removeEvent("resize", this.queryLoadFun );
			this.queryLoadFun = null;

			if( this.postLoadFun )this.eventTarget.removeEvent("resize", this.postLoadFun );
			this.postLoadFun = null;
		}

		if(eventTarget) this.eventTarget = eventTarget;

		if (this.eventTarget){
			this.resizeFun = function () {
				debugger;
				this.fireAppEvent("resize");
			}.bind(this);
			this.eventTarget.addEvent("resize", this.resizeFun);

			this.queryLoadFun = function () {
				this.fireAppEvent && this.fireAppEvent("queryClose");
			}.bind(this);
			this.eventTarget.addEvent("queryClose", this.queryLoadFun);

			this.postLoadFun = function () {
				if (this.resizeFun) this.eventTarget.removeEvent("resize", this.resizeFun);
				this.fireAppEvent && this.fireAppEvent("postClose");
			}.bind(this);
			this.eventTarget.addEvent("postClose", this.postLoadFun);
		}
	},
	loadEmbeded: function(){
		if( !this.options.embededParent )return;

		this.window = {
			"isHide": false,
			"isMax": true,
			"maxSize": function(){},
			"restore": function(){},
			"setCurrent": function(){},
			"setUncurrent": function () {},
			"hide": function(){},
			"maxOrRestoreSize": function(){},
			"restoreSize": function(){},
			"close": function(){},
			"titleText" : {
				set : function(){}
			}
		};
		this.window.content = this.options.embededParent;
		this.content = this.window.content;

		// if( this.eventTarget && o2.typeOf( this.eventTarget.addEvent ) === "function" ){
		// 	this.setEventTarget();
		// }

		this.fireAppEvent("postLoadWindow");
		this.fireAppEvent("queryLoadApplication");
		this.setContentEvent();

		//if (this.options.title) this.setTitle(this.options.title);
		if (this.stylePath){
			(this.window.node || this.content).loadCss(this.stylePath, function () {
				this.loadApplication(function(){
					this.fireAppEvent("postLoadApplication");
				}.bind(this));
				this.fireAppEvent("postLoad");
			}.bind(this));
		}else{
			this.loadApplication(function(){
				this.fireAppEvent("postLoadApplication");
			}.bind(this));
			this.fireAppEvent("postLoad");
		}
	},

	openInNewBrowser: function (noClose) {
		this.desktop.openBrowserApp = this.options.name;
		this.desktop.openBrowserStatus = (this.recordStatus) ? this.recordStatus() : null;
		var status = (this.desktop.openBrowserStatus) ? JSON.encode(this.desktop.openBrowserStatus) : "";

		var url = "../x_desktop/app.html?app=" + this.options.name + "&status=" + status;
		window.open(o2.filterUrl(url), "_blank");
		if (!this.inBrowser) if (!noClose) this.close();
	},
	openInNewWindow: function () {
		this.desktop.openBrowserApp = this.options.name;
		this.desktop.openBrowserStatus = (this.recordStatus) ? this.recordStatus() : null;
		window.open(o2.filterUrl("../x_desktop/app.html"), "_blank");
		if (!this.inBrowser) this.close();
	},
	setContentEvent: function () {
		//		this.content.addEvents({
		//			"resize": function(){
		//				if (this.onResize) this.onResize();
		//			}.bind(this)
		//		});
	},
	setCurrent: function () {
        if (this.desktop.currentApp == this) return true;
        if (this.desktop.currentApp) {
            this.desktop.currentApp.setUncurrent();
        }

        this.window.setCurrent();

        if (this.taskitem) this.taskitem.selected();
        this.desktop.currentApp = this;

        this.desktop.appCurrentList.erase(this);
        this.desktop.appCurrentList.push(this);

        if (this.window.isHide) {
            if (this.window.isMax) {
                this.window.maxSize(function () { this.fireAppEvent("current"); }.bind(this));
            } else {
                this.window.restore(function () { this.fireAppEvent("current"); }.bind(this));
            }
        } else {
            this.fireAppEvent("current");
        }
	},
	setUncurrent: function () {
		if (this.desktop.currentApp == this) {
			this.window.setUncurrent();
			if (this.taskitem) this.taskitem.unSelected();
			this.desktop.currentApp = null;
			this.fireAppEvent("uncurrent");
		}else{
			this.window.setUncurrent();
			if (this.taskitem) this.taskitem.unSelected();
		}
	},
	minSize: function () {
		this.fireAppEvent("queryMinSize");
		var p = this.taskitem.node.getPosition();
		this.setUncurrent();
		this.window.hide(p.x, p.y, function () {
			this.fireAppEvent("postMinSize");
		}.bind(this));
	},
	_minSize: function () {

		var p = this.taskitem.node.getPosition();
		this.setUncurrent();
		this.window.hide(p.x, p.y);
	},
	maxOrRestoreSize: function () {
		var max = true;
		if (this.window.isMax) max = false;
		this.fireAppEvent((max) ? "queryMaxSize" : "queryRestoreSize");

		this.window.maxOrRestoreSize(function () {
			this.fireAppEvent((max) ? "postMaxSize" : "postRestoreSize");
		}.bind(this));
	},
	maxSize: function (callback) {
		if (!this.window.isMax) {
			this.fireAppEvent("queryMaxSize");
			this.window.maxSize(function () {
				this.fireAppEvent("postMaxSize");
				if (callback) callback();
			}.bind(this));
		} else {
			if (callback) callback();
		}
	},
	_maxSize: function (callback) {
		this.window.maxSize();
	},
	restoreSize: function (callback) {
		this.fireAppEvent("queryRestoreSize");
		this.window.restoreSize(function () {
			this.fireAppEvent("postRestoreSize");
			if (callback) callback();
		}.bind(this));
	},
	_restoreSize: function (callback) {
		this.window.restoreSize();
	},
	refresh: function () {
		this.desktop.refreshApp(this);
	},
	close: function (hasTaskitem) {
		if (this.inBrowser) {
			window.open("", "_self").close();
			window.close();
		} else if( this.embeded ){

			this.window = null;
			this.fireAppEvent("queryClose");
			if (this.resizeFun && this.eventTarget) this.eventTarget.removeEvent("resize", this.resizeFun);
			this.fireAppEvent("postClose");
			o2.release(this);

		} else {
			this.fireAppEvent("queryClose");

			this.setUncurrent();
			this.window.close(function () {
				if (!hasTaskitem) this.taskitem.destroy();
				this.window = null;
				this.taskitem = null;
				if (this.resizeFun) layout.desktop.removeEvent("resize", this.resizeFun);
				this.desktop.closeApp(this, hasTaskitem);
				this.fireAppEvent("postClose");

				o2.release(this);
			}.bind(this));
		}
	},
	setTitle: function (str) {
		try {
			if (this.taskitem) {
				this.taskitem.textNode.set("text", str);
				this.taskitem.node.set("title", str + ((this.appId) ? "-" + this.appId : ""));
				this.taskitem.setTaskitemSize();
			}
			this.options.title = str;
			this.window.titleText.set("text", str);
		} catch (e) { }

	},
	loading: function(){
		// if (this.taskitem){
		// 	if (this.taskitem.refreshNode) this.taskitem.refreshNode.addClass("icon_taskLoading");
		// }
		// this.loadingNode = new Element("div", {
		// 	"styles": {
		// 		"height": "100%",
		// 		"width": "100%",
		// 		"overflow": "auto",
		// 		"position": "absolute",
		// 		"top": "0px",
		// 		"left": "0px",
		// 		"background-repeat": "no-repeat",
		// 		"background-position": "center"
		// 	}
		// }).inject(this.content);
		// this.loadingNode.addClass("icon_loading");
	},
	unLoading: function(){
		// if (this.taskitem){
		// 	if (this.taskitem.refreshNode) this.taskitem.refreshNode.removeClass("icon_taskLoading");
		// }
		// if (this.loadingNode) this.loadingNode.destroy();
	},


	//application事件
	onQueryLoad: function () { },
	onQueryLoadWindow: function () { },
	onLoadWindow: function () { },
	onPostLoadWindow: function () { },
	onQueryLoadApplication: function () { },
	onPostLoadApplication: function () { },
	onPostLoad: function () { },
	onResize: function () { },
	onQueryClose: function () { },
	onPostClose: function () { },
	onQueryMinSize: function () { },
	onPostMinSize: function () { },
	onQueryMaxSize: function () { },
	onPostMaxSize: function () { },
	onQueryRestoreSize: function () { },
	onPostRestoreSize: function () { },

	dialog: function (options) {
		MWF.require("MWF.xDesktop.Dialog", function () {
			options.markNode = this.content;
			var dlg = new MWF.xDesktop.Dialog(options);
			dlg.show();
		}.bind(this));
	},
	notice: function (content, type, target, where, offset) {
		if (window.mBox){
			if (!where) where = { "x": "right", "y": "top" };
			if (!target) target = this.content;
			if (!target) target = this.window.content;
			if (!type) type = "ok";
			var noticeTarget = target || layout.layout.contentNode;
			// 移动端如果向下滚动了就看不到了
			if (layout.mobile) {
				noticeTarget = $(document.body);
			}
			
			var off = offset;
			if (!off) {
				off = {
					x: 10,
					y: where.y.toString().toLowerCase() == "bottom" ? 10 : 10
				};
			}
			new mBox.Notice({
				type: type,
				position: where,
				move: false,
				target: noticeTarget,
				delayClose: (type == "error") ? 10000 : 5000,
				offset: off,
				content: content
			});
		}
	},
	confirm: function (type, e, title, text, width, height, ok, cancel, callback, mask, style) {
		MWF.require("MWF.xDesktop.Dialog", function () {
			var content = layout.mobile ? $(document.body) : this.content || $(document.body);
			var size = content.getSize();
			var x = 0;
			var y = 0;

			if (layout.mobile) {
				if (parseFloat(width) > size.x) {
					width = size.x - 40;
					x = 40;
				} else {
					x = (size.x - parseFloat(width)) / 2;
				}
				if (parseFloat(height) > size.y) {
					y = 0;
				} else {
					y = (size.y - parseFloat(height)) / 2;
				}
			} else {
				if (typeOf(e) == "element") {
					var position = e.getPosition(content);
					x = position.x;
					y = position.y;
				} else {
					if (Browser.name == "firefox") {
						x = parseFloat(e.event ? (e.event.clientX || e.event.x) : e.clientX);
						y = parseFloat(e.event ? (e.event.clientY || e.event.y) : e.clientY);
					} else {
						x = parseFloat(e.x || e.event.x);
						y = parseFloat(e.y || e.event.y);
					}

					if (e.target) {
						var position = e.target.getPosition(content);
						x = position.x;
						y = position.y;
					}
				}
				if (x + parseFloat(width) > size.x) {
					x = x - parseFloat(width);
				}
				if (x < 0) x = 0;
				if (y + parseFloat(height) > size.y) {
					y = y - parseFloat(height);
				}
				if (y < 0) y = 0;
				// 鼠标位置往左偏移
				x = x - 20;
			}


			var ctext = "";
			var chtml = "";
			if (typeOf(text).toLowerCase() == "object") {
				ctext = text.text;
				chtml = text.html;
			} else {
				ctext = text;
			}

			// var tmp = new Element("div", {"overflow": "hidden","padding": "10px", "padding-left": "60px", "width": ""+width+"px"}).inject(document.body);
			// if (chtml) tmp.set("html", chtml);
			// if (ctext) tmp.set("text", ctext);
			// height = tmp.getSize().y;
			// tmp.destroy();

			var dlg = new MWF.xDesktop.Dialog({
				"title": title,
				"style": style || "o2",
				"top": y,
				"left": x,
				"fromTop": y,
				"fromLeft": x,
				"width": width,
				"height": height,
				"text": ctext,
				"html": chtml,
				"container": content,
				"mark": (mask) ? true : false,
				"maskNode": mask || content,
				"buttonList": [
					{
						"type": "ok",
						"text": MWF.LP.process.button.ok,
						"action": ok
					},
					{
						"type": "cancel",
						"text": MWF.LP.process.button.cancel,
						"action": cancel
					}
				]
			});

			switch (type.toLowerCase()) {
				case "success":
					dlg.content.setStyle("background-image", "url(data:image/png;base64,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)");
					break;
				case "error":
					dlg.content.setStyle("background-image", "url(data:image/png;base64,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)");
					break;
				case "info":
					dlg.content.setStyle("background-image", "url(data:image/png;base64,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)");
					break;
				case "warn":
					dlg.content.setStyle("background-image", "url(data:image/png;base64,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)");
					break;
				default:
				//dlg.content.setStyle("background-image", "");
			}
			dlg.show();
			if (callback) callback(dlg);
		}.bind(this));
	},
	dlg: function (type, e, title, text, width, height, actions, mask, style) {
		MWF.require("MWF.xDesktop.Dialog", function () {
			var size = this.content.getSize();
			var p = (e) ? MWF.getEPointer(e) : MWF.getCenter({ "x": width, "y": height }, this.content, this.content);
			var x = p.x || 0;
			var y = p.y || 0;

			if (x + parseFloat(width) > size.x) {
				x = x - parseFloat(width);
			}
			if (x < 0) x = 0;
			if (y + parseFloat(height) > size.y) {
				y = y - parseFloat(height);
			}
			if (y < 0) y = 0;

			var ctext = "";
			var chtml = "";
			if (typeOf(text).toLowerCase() === "object") {
				ctext = text.text;
				chtml = text.html;
			} else {
				ctext = text;
			}

			var dlg = new MWF.xDesktop.Dialog({
				"title": title,
				"style": style || "o2",
				"top": y,
				"left": x - 20,
				"fromTop": y,
				"fromLeft": x - 20,
				"width": width,
				"height": height,
				"text": ctext,
				"html": chtml,
				"container": this.content,
				"mark": (mask) ? true : false,
				"maskNode": mask || this.content,
				"buttonList": actions
			});

			switch (type.toLowerCase()) {
				case "success":
					dlg.content.setStyle("background-image", "url(data:image/png;base64,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)");
					break;
				case "error":
					dlg.content.setStyle("background-image", "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABsVJREFUeNqkWFtsFGUU/nZn2r21IqX3llp6AQmkWDVGAgIlGI0EeMAHffAFa998MCQaE8JDxZCgSHzQKIm3qPHFGC7GW0xqkIgIKhhEwFJaKSDQUtplu73s7vidmX/q32F2uw2TnOzMv2fO+f5z/8fci7yvWAZYRXo4CCwLAM1cq+HvXRYwQrrM/7rTwB+TwC/dwKG3uU75mVxCO7T7wExgKHiBATzJ2411wMoy3pSQ5gg6UiFpgpQgDZNukK6TLgBHuf7lAPD5q8DfXMpQl5U3mA4P4ztAO3+2tADLCQSV+VsR/5L+If0G/EqgH78EvKtwT1lqr0en6SfoLaCe1niB7nj+CQIuV+uZWYApV8RNPPAVcP/rQMtF4I03gbNcpjdvt5KxQXs4SKKflxBI54PAs20EElNvZTQJucjLFyUtpZwioJVurFtMD/4MXBXWDUqnL5jHHYt0PgQ8da/4UFMwThpTz0HF7wfEj0/kSKwVAwsZU5U1wKkTwOBBj7GD08xE17QSSJPanVCKlCSNkM5s2mT/JtV6epZ8InclsH4R9TjYRKWPZQixnch2POJsZNpOb5HOb9yIi5s3I5XJIHb2rL2LoBZL+fBZKhOZaS3LgPgh4HcnYZ34scFI+goQxsj8iA+QHipItrejrKwMiaVLMZJIIEpFAaUkH76AFrEVfLxEzzEej/0FXFOGc8CQ8bmFTOE6DciEUnCBCsapoLGxETU1NYhGo7i+YAHiSlFauWMmvqAGKOzcVzDlh2mdo2o/loCJkeEVRnldSMsGUdCrKaiqqkJxcTEikQgKCgpsRbJzk4oukm8iB1+CfEUKkLtZub/CZOsFvht0Qi1lrAfW0WwvN3gyI7J1K+7ZswfNzc0oLS1FKBRCMBiEaZoIh8OOovp6jI6NYXLLFjQ1NdlAxCKGYaCwsBAlJSWoJ08lwQZTKaSPHJmSL9YZZWZx438eZ8yLMwwWtWeYaqvv9oBJ8UWDyovWrUMgEPi/ZPPeBWT/rlhhx0h1dbUNRABPpSrvBVhixw4kd+26rRyMOq3jCl31kzya0vSiKgW91/DOnbZJ53V22iAsy5pSIopra2vtNflP3KIDcTcwuH074pQT8JEvelkMF4kjpBuY0n1Dbjj7XDcpSCCU+gCKxWK+77hABghkOAsQuUIOivmq3xrSm2qMLJZxrwEKlGJQ5QGUC8gVBSSYQ67hoCidAiPzSCCHZSxVlXopeHhiAk30v8RBtivFQO3etg1Du3fbbihQKe0L3MmqmGrYwaAMRuPKMl6aVCkeJ11jRvSuWYO+vj4kk0lf4bIu/wuf8MfV+5NZ5I87RhhVuAKmTGhsbHPCWSwiwoYoOMQ60tDQgPLycjvNfWOA6/J/Op3GefJzsMLcAwfs6PSz0JhTXAfcBDNlVCS0xaYHSEql3jCBRLSC5k3faV1XZZnwySWABmUqJKCo8oUOaNTZbL9SlzE4Niwh8lURLf/TyoQzAZFgdcmvDklhjKsKXKAqsF5rZEztAboOAz+KA4xHmeo0+tNFqky7VMkKfJ+nAnuV2rtn1pS0td32n16B67kpRjZuqQrs6pB5mW37s5OswoLNaOTUdRfQRjPWGhrqOF80aYVSTwXWgfQQSL8URiqa6wGkV+B+ZuAlTwUWF/VxyPoUeD/uTH5x4xhjiNapoHXWhj3l+ubhw0hTkbtz3SXdBNJHIJgFn+Vx0Tlg37eOi+RAkTTk+MDueY1WWc64qQ5oZpSXhpSiedrOz1HBBVWZZ8Pn0phzcjj9DfBBvz1r4aYkrz3PvEhZq9lIyfgY3RXwzrY3lKKytWtxhgp6fHaaL5+AoU8stulPvgB+UFZJuPOMPaF/D5wgoGq6q9XMosianER3FiD58iWcDNr/GvCegwtDbjeywShAGQ5Y3aYzZC00PELsDkxFmOGokosv6cy/XV8DHyr3XFfL1rSBnL/WNqKUcw3rQWWhD6A7oaSTPV1dwEecX07CmX1v6W3Re4iz5IAl5xqCiTIMW0zJ5DsAkXKOLxbHy/1iEQ3IiHdYmAbGdZccsBhDXXKcoMAyWqjCynJwywVCqjgbz2kJVokR5RoXyKRkctYTpQ5Iepica+Q4QesMU0GUoCozPjGS0QZ5t9uzJ51ioO6T9FVZc1XFiLgm5X6ROJjvJ5EOZ4iXwaeIs2Elz1WreExtlVFRJjQZjGQekTFAuq80PRazbp6JTtOyxy87FX9EkYCY8H6v6fDMNzNdagayQYXVZ5mIei7UmrHrnQlFSZXJY9qnECuXIjMPMJZ2lHIPj6aaGg0FNOD5CJHWjtl5f0n5T4ABAFHaXG6UVjGNAAAAAElFTkSuQmCC)");
					break;
				case "info":
					dlg.content.setStyle("background-image", "url(data:image/png;base64,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)");
					break;
				case "warn":
					dlg.content.setStyle("background-image", "url(data:image/png;base64,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)");
					break;
				default:
			}
			dlg.show();
		}.bind(this));
	},
	alert: function (type, e, title, text, width, height, callback) {
		MWF.require("MWF.widget.Dialog", function () {
			var size = $(document.body).getSize();
			var x = 0, y = 0;
			if (e === "center") {
				if( layout.mobile ){
					x = (size.x - parseFloat(width)) / 2;
					y = (size.y - parseFloat(height)) / 2;
				}else{
                    var p = o2.getCenterPosition(this.content, width, height);
                    x = p.x;
                    y = p.y;
				}
			} else {
				x = parseFloat(e.event.x);
				y = parseFloat(e.event.y);
				if (Browser.name == "firefox") {
					x = parseFloat(e.event.clientX);
					y = parseFloat(e.event.clientY);
				}
				x = x - parseFloat(width) / 2;
				y = y - parseFloat(height) / 2;
			}

			if (x + parseFloat(width) > size.x) {
				x = x - parseFloat(width);
			}
			if (x < 0) x = 0;

			if (y + parseFloat(height) > size.y) {
				y = y - parseFloat(height);
			}
			if (y < 0) y = 0;


			var ctext = "";
			var chtml = "";
			if (typeOf(text).toLowerCase() == "object") {
				ctext = text.text;
				chtml = text.html;
			} else {
				ctext = text;
			}

			var dlg = new MWF.DL({
				"title": title,
				"style": "o2",
				"top": y,
				"left": x,
				"fromTop": y,
				"fromLeft": x,
				"width": width,
				"height": height,
				"text": ctext,
				"html": chtml,
				"maskNode": layout.mobile ? $(document.body) : this.content,
				"container": layout.mobile ? $(document.body) : this.content,
				"buttonList": [
					{
						"text": MWF.LP.process.button.ok,
						"action": function () {
							if( typeOf(callback) === "function" )callback();
							this.close();
						}
					}
				]
			});

			switch (type.toLowerCase()) {
				case "success":
					dlg.content.setStyle("background-image", "url(data:image/png;base64,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)");
					break;
				case "error":
					dlg.content.setStyle("background-image", "url(data:image/png;base64,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)");
					break;
				case "info":
					dlg.content.setStyle("background-image", "url(data:image/png;base64,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)");
					break;
				case "warn":
					dlg.content.setStyle("background-image", "url(data:image/png;base64,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)");
					break;
				default:
			}
			dlg.content.setStyle("overflow","auto");
			dlg.show();
		}.bind(this));
	}
});

MWF.xApplication.portal = MWF.xApplication.portal || {};
MWF.xApplication.portal.Portal = MWF.xApplication.portal.Portal || {};
MWF.xApplication.portal.Portal.options = Object.clone(o2.xApplication.Common.options);

MWF.xApplication.portal.Portal.options.multitask = true;
MWF.xApplication.portal.Portal.Main = new Class({
    Extends: MWF.xApplication.Common.Main,
    Implements: [Options, Events],

    options: {
        "style": "default",
        "name": "portal.Portal",
        "icon": "icon.png",
        "width": "1200",
        "height": "800",
        "title": "",
        "portalId": "",
        "pageId": "",
        "widgetId" : "",
        "isControl": false,
        "taskObject": null,
        "parameters": "",
        "isLoginPage": false,
        "readonly": false
    },
    onQueryLoad: function(){
        if (!this.options.title && !layout.mobile) this.setOptions({"title": MWF.xApplication.portal.Portal.LP.title});
        this.lp = MWF.xApplication.portal.Portal.LP;
        if (this.status){
            this.options.portalId = this.status.portalId;
            this.options.pageId = this.status.pageId;
            this.options.widgetId = this.status.widgetId;
            this.options.parameters = this.status.parameters;
        }
    },
    loadApplication: function(callback){
        this.node = new Element("div", {"styles": this.css.content}).inject(this.content);

        //MWF.require("MWF.widget.Mask", function(){
        //this.mask = new MWF.widget.Mask({"style": "desktop"});

        this.formNode = new Element("div", {"styles": {"min-height": "100%", "font-size": "14px"}}).inject(this.node);
        this.action = MWF.Actions.get("x_portal_assemble_surface");

        //MWF.xDesktop.requireApp("portal.Portal", "Actions.RestActions", function(){
        //    this.action = new MWF.xApplication.portal.Portal.Actions.RestActions();
        if (!this.options.isRefresh){
            this.maxSize(function(){
                //this.mask.loadNode(this.content);
                this.loadPortal(this.options.parameters, callback);
            }.bind(this));
        }else {
            //this.mask.loadNode(this.content);
            this.loadPortal(this.options.parameters, callback);
        }
        //if (callback) callback();
        //}.bind(this));

        //}.bind(this));
    },
    //reload: function(data){
    //    if (this.form){
    //        this.formNode.empty();
    //        MWF.release(this.form);
    //        this.form = null;
    //    }
    //    //this.parseData(data);
    //    this.openPortal();
    //},
    toPortal: function(portal, page, par, nohis){
        this.options.portalId = portal;
        this.options.pageId = page;
        if (!nohis) this.doHistory(page,this.options.portalId);

        if (this.appForm) this.appForm.fireEvent("beforeClose");
        Object.keys(this.$events).each(function(k){
            this.removeEvents(k);
        }.bind(this));

        MWF.release(this.appForm);
        this.appForm = null;
        this.formNode.empty();

        this.portal = null;
        this.loadPortal(par);
    },
    doHistory: function(name, portal){
        if (this.inBrowser){
            var stateObj = { "page": name, "id": portal || this.options.portalId };
            history.pushState(stateObj, "page");
        }
    },
    toPage: function(name, par, nohis){
        if (!nohis) this.doHistory(name, this.portal.id);
        var pageJson = null;
        var loadModuleFlag = false;
        var check = function(){
            if (!!pageJson && loadModuleFlag){
                this.pageJson = pageJson;
                layout.sessionPromise.finally(function(){
                    // this.pageInfor = pageJson.data;
                    // this.setTitle(this.portal.name+"-"+pageJson.data.name);
                    // var page = (pageJson.data.data) ? JSON.decode(MWF.decodeJsonString(pageJson.data.data)): null;

                    var pageName = pageJson.data.page ? pageJson.data.page.name : pageJson.data.name;
                    //this.setTitle((this.portal && this.portal.name) ? this.portal.name+"-"+pageName : pageName);
                    this.setTitle(pageName);
                    var page;
                    if (pageJson.data.page){
                        this.pageDataText = (pageJson.data.page.data) ? MWF.decodeJsonString(pageJson.data.page.data): "";
                        page = (this.pageDataText) ? JSON.decode(this.pageDataText): null;
                        this.relatedFormMap = pageJson.data.relatedWidgetMap;
                        this.relatedScriptMap = pageJson.data.relatedScriptMap;
                        delete pageJson.data.page.data;
                        this.pageInfor = pageJson.data.page;
                    }else{
                        this.pageDataText = (pageJson.data.data) ? MWF.decodeJsonString(pageJson.data.data): "";
                        page = (this.pageDataText) ? JSON.decode(this.pageDataText): null;
                        delete pageJson.data.data;
                        this.pageInfor = pageJson.data;
                    }

                    if (page){
                        this.options.pageId = pageJson.data.id;

                        if (this.appForm) this.appForm.fireEvent("beforeClose");
                        Object.keys(this.$events).each(function(k){
                            this.removeEvents(k);
                        }.bind(this));

                        MWF.release(this.appForm);
                        this.appForm = null;
                        this.formNode.empty();
                        this.page = page;
                        this.openPortal(par);
                    }
                }.bind(this));
            }
        }.bind(this);

        if (name){
            var m = (layout.mobile) ? "getPageByNameMobileV2" : "getPageByNameV2";
            this.action[m](name, this.portal.id, function(json){
                pageJson = json;
                check();
            }.bind(this));
            var cl = "$all";
            MWF.xDesktop.requireApp("process.Xform", cl, function(){
                loadModuleFlag = true;
                check();
            });

        }else{
            if (this.options.pageId){
                var m = (layout.mobile) ? "getPageByNameMobileV2" : "getPageByNameV2";
                this.action[m](this.options.pageId, this.portal.id, function(json){
                    pageJson = json;
                    check();
                }.bind(this));

                MWF.xDesktop.requireApp("process.Xform", "$all", function(){
                    loadModuleFlag = true;
                    check();
                });
            }
        }
    },
    loadPortal: function(par, callback){
        if (this.options.pageId || this.options.widgetId){
            this.loadPortalPage(par, callback);
            this.getPageData();
        }else{
            this.getPageData(function(json){
                this.options.pageId = this.portal.firstPage;
                this.loadPortalPage(par, callback);
            }.bind(this));
        }
    },
    openPage: function(pageJson, par, callback){
        var pageName = pageJson.data.page ? pageJson.data.page.name : pageJson.data.name;
        //this.setTitle((this.portal && this.portal.name) ? this.portal.name+"-"+pageName : pageName);
        this.setTitle(pageName);
        if (pageJson.data.page){
            this.pageDataText = (pageJson.data.page.data) ? MWF.decodeJsonString(pageJson.data.page.data): "";
            this.page = (this.pageDataText) ? JSON.decode(this.pageDataText): null;
            this.relatedFormMap = pageJson.data.relatedWidgetMap;
            this.relatedScriptMap = pageJson.data.relatedScriptMap;
            delete pageJson.data.page.data;
            this.pageInfor = pageJson.data.page;
        }else{
            this.pageDataText = (pageJson.data.data) ? MWF.decodeJsonString(pageJson.data.data): "";
            this.page = (this.pageDataText) ? JSON.decode(this.pageDataText): null;
            delete pageJson.data.data;
            this.pageInfor = pageJson.data;
        }
        this.openPortal(par, callback);
    },
    loadPortalPage: function(par, callback){
        var pageJson = null;
        var loadModuleFlag = false;
        var check = function(){
            if (!!pageJson && loadModuleFlag){
                this.pageJson = pageJson;
                // if (layout.session && layout.session.user ){
                //     this.openPage(pageJson, par, callback);
                // }else if( layout.sessionPromise ){
                    layout.sessionPromise.then(function () {
                        this.openPage(pageJson, par, callback);
                    }.bind(this), function () {
                        if( this.options.isLoginPage ){
                            this.openPage(pageJson, par, callback);
                        }
                    }.bind(this));
                // }
            }
        }.bind(this);

        var m;
        if( this.options.widgetId ){
            m = (layout.mobile) ? "getWidgetByNameMobile" : "getWidgetByName";
        }else{
            m = (layout.mobile) ? "getPageByNameMobileV2" : "getPageByNameV2";
        }
        this.action[m]( this.options.widgetId || this.options.pageId, this.options.portalId, function(json){
            pageJson = json;
            check();
        }.bind(this));
        MWF.xDesktop.requireApp("process.Xform", "$all", function(){
            loadModuleFlag = true;
            check();
        });
    },

    getPageData: function(callback){
        if (this.portal){
            if (callback) callback(this.portal);
            return ;
        }
        this.action.getApplication(this.options.portalId, function(json){
            this.portal = json.data;
            if (this.pageJson){
                var pageName = this.pageJson.data.page ? this.pageJson.data.page.name : this.pageJson.data.name;
                //if(!layout.mobile)this.setTitle(this.portal.name+"-"+pageName);
            }

            if (this.portal.icon){
                if (this.taskitem){
                    this.taskitem.iconNode.setStyles({
                        "background-image": "url(data:image/png;base64,"+this.portal.icon+")",
                        "background-size": "24px 24px"
                    });
                }
            }
            if (callback) callback(json)
        }.bind(this));
    },

    openPortal: function(par, callback){
        debugger;
        if (this.page){
            //MWF.xDesktop.requireApp("process.Xform", "Form", function(){
                this.appForm = new MWF.APPForm(this.formNode, this.page, {
                    "macro": "PageContext",
                    "parameters": par
                });
                this.appForm.businessData = {
                    "control": {
                        "allowSave": true
                    },
                    "pageInfor": this.pageInfor,
                    "data": {}
                };


                this.appForm.workAction = this.action;
                this.appForm.app = this;
                this.appForm.formDataText = this.pageDataText;

                this.appForm.load();

                if (callback) callback();
                if (this.mask) this.mask.hide();
            //}.bind(this));
        }
    },
    recordStatus: function(){
        return {"portalId": this.options.portalId, "pageId": this.options.pageId, "parameters" : this.options.parameters};
    },
    onPostClose: function(){
        if (this.appForm){
            this.appForm.modules.each(function(module){
                MWF.release(module);
            });
            MWF.release(this.appForm);
        }
    }

});

MWF.xApplication.Selector = MWF.xApplication.Selector || {};
//MWF.xDesktop.requireApp("Selector", "lp."+MWF.language, null, false);
//MWF.xDesktop.requireApp("Selector", "Actions.RestActions", null, false);
o2.xApplication.Selector.package = MWF.O2Selector = new Class({
    Implements: [Options],
    options: {
        "count": 0,
        "type": "person",
        "title": "",
        "groups": [],
        "roles": [],
        "units": [],
        "unitType": "",
        "values": [],
        "exclude" : [],
        "categoryType": "unit",
        "dutyUnitLevelBy" : "duty"
    },
    initialize: function(container, options, delayLoad){
        if( !MWF.xApplication.Selector.LP ){
            MWF.xDesktop.requireApp("Selector", "lp."+MWF.language, null, false);
        }
        //MWF.xDesktop.requireApp("Selector", "Actions.RestActions", null, false);
        this.loading = true;
        if (!options.title) options.title = MWF.xApplication.Selector.LP.multiSelectTitle;
        this.setOptions(options);
        this.container = container;

        if( this.options.types && typeOf(this.options.types) === "array" && this.options.types.length > 0 ){
            MWF.xDesktop.requireApp("Selector", "MultipleSelector", function() {
                var opts = Object.clone( this.options );
                for (var option in options){
                    if (typeOf(options[option]) === 'function' && (/^on[A-Z]/).test(option)){
                        opts[option] = options[option];
                    }
                }
                this.selector = new MWF.xApplication.Selector.MultipleSelector(this.container, opts );
                if( delayLoad !== true )this.selector.load();
                this.loading = false;
            }.bind(this));
        }else{
            var type = typeOf(this.options.type) === "string" ? this.options.type.capitalize() : this.options.type;
            if (type){
                if ((type.toLowerCase()==="unit") && (this.options.unitType)){
                    MWF.xDesktop.requireApp("Selector", "UnitWithType", function(){
                        this.selector = new MWF.xApplication.Selector.UnitWithType(this.container, options);
                        if( delayLoad !== true )this.selector.load();
                        this.loading = false;
                    }.bind(this));
                }else if ((type.toLowerCase()==="identity") && ((this.options.dutys) && this.options.dutys.length) && this.options.categoryType.toLowerCase()==="duty"){
                    MWF.xDesktop.requireApp("Selector", "IdentityWidthDuty", function(){
                        this.selector = new MWF.xApplication.Selector.IdentityWidthDuty(this.container, options);
                        if( delayLoad !== true )this.selector.load();
                        this.loading = false;
                    }.bind(this));
                }else if ((type.toLowerCase()==="identity") && ((this.options.dutys) && this.options.dutys.length) ){ //&& this.options.categoryType.toLowerCase()==="unit"
                    MWF.xDesktop.requireApp("Selector", "IdentityWidthDutyCategoryByUnit", function(){
                        this.selector = new MWF.xApplication.Selector.IdentityWidthDutyCategoryByUnit(this.container, options);
                        if( delayLoad !== true )this.selector.load();
                        this.loading = false;
                    }.bind(this));
                }else if ((type.toLowerCase()==="identity") && (this.options.unitType) ){ //&& this.options.categoryType.toLowerCase()==="unit"
                    MWF.xDesktop.requireApp("Selector", "IdentityWithType", function(){
                        this.selector = new MWF.xApplication.Selector.IdentityWithType(this.container, options);
                        if( delayLoad !== true )this.selector.load();
                        this.loading = false;
                    }.bind(this));
                }else{
                    MWF.xDesktop.requireApp("Selector", type, function(){
                        this.selector = new MWF.xApplication.Selector[type](this.container, options);
                        if( delayLoad !== true )this.selector.load();
                        this.loading = false;
                    }.bind(this));
                }
            }
        }
    }
});

MWF.O2SelectorFilter = new Class({
    Implements: [Options],
    options: {
        "count": 0,
        "type": "person",
        "title": "Select Person",
        "groups": [],
        "roles": [],
        "units": [],
        "unitType": "",
        "values": []
    },
    initialize: function(value, options){
        //MWF.xDesktop.requireApp("Selector", "Actions.RestActions", null, false);
        this.setOptions(options);
        this.value = value;
        //var type = this.options.type.capitalize();

        if( this.options.types && typeOf(this.options.types) === "array" && this.options.types.length > 0 ){
            MWF.xDesktop.requireApp("Selector", "MultipleSelector", function() {
                this.selectFilter = new MWF.xApplication.Selector.MultipleSelector.Filter(this.container, this.options );
            }.bind(this), false);
        }else{
            var type = typeOf(this.options.type) === "string" ? this.options.type.capitalize() : this.options.type;
            if (type){
                if ((type.toLowerCase()==="unit") && (this.options.unitType)){
                    MWF.xDesktop.requireApp("Selector", "UnitWithType", function(){
                        this.selector = new MWF.xApplication.Selector.UnitWithType.Filter(this.container, options);
                        this.selector.load();
                    }.bind(this));
                }else if ((type.toLowerCase()==="identity") && ((this.options.dutys) && this.options.dutys.length) && this.options.categoryType.toLowerCase()==="duty"){
                    MWF.xDesktop.requireApp("Selector", "IdentityWidthDuty", function(){
                        this.selectFilter = new MWF.xApplication.Selector.IdentityWidthDuty.Filter(this.value, options);
                    }.bind(this), false);
                }else if ((type.toLowerCase()==="identity") && ((this.options.dutys) && this.options.dutys.length) ){ //&& this.options.categoryType.toLowerCase()==="unit"
                    MWF.xDesktop.requireApp("Selector", "IdentityWidthDutyCategoryByUnit", function(){
                        this.selectFilter = new MWF.xApplication.Selector.IdentityWidthDutyCategoryByUnit.Filter(this.value, options);
                    }.bind(this));
                }else{
                    MWF.xDesktop.requireApp("Selector", type, function(){
                        this.selectFilter = new MWF.xApplication.Selector[type].Filter(this.value, options);
                    }.bind(this), false);
                }
            }
        }

        //if (type){
        //    if ((type.toLowerCase()==="unit") && (this.options.unitType)){
        //        MWF.xDesktop.requireApp("Selector", "UnitWithType", function(){
        //            this.selector = new MWF.xApplication.Selector.UnitWithType.Filter(this.container, options);
        //            this.selector.load();
        //        }.bind(this));
        //    }else if ((type.toLowerCase()==="identity") && ((this.options.dutys) && this.options.dutys.length)){
        //        MWF.xDesktop.requireApp("Selector", "IdentityWidthDuty", function(){
        //            this.selectFilter = new MWF.xApplication.Selector.IdentityWidthDuty.Filter(this.value, options);
        //        }.bind(this), false);
        //    }else{
        //        MWF.xDesktop.requireApp("Selector", type, function(){
        //            this.selectFilter = new MWF.xApplication.Selector[type].Filter(this.value, options);
        //        }.bind(this), false);
        //     }
        //}else{
        //    MWF.xDesktop.requireApp("Selector", "MultipleSelector", function() {
        //        this.selectFilter = new MWF.xApplication.Selector.MultipleSelector.Filter(this.container, this.options );
        //    }.bind(this), false);
        //}

    },
    filter: function(value, callback){
        return this.selectFilter.filter(value, callback);
    }
});

(function(){
    var _createEl = function(data, node){
        var dname;
        if (typeOf(data)==="string"){
            data = {"id": data};
            dname = data.id;
        }else{
            dname = data.distinguishedName || data.name || data.id
        }
        var len = dname.length;
        var flag = dname.substring(len-1,len);
        switch (flag){
            case "U":
                new o2.widget.O2Unit(data, node, {"style": "xform"});
                break;
            case "I":
                new o2.widget.O2Identity(data, node, {"style": "xform"});
                break;
            case "G":
                new o2.widget.O2Group(data, node, {"style": "xform"});
                break;
            case "P":
                new o2.widget.O2Person(data, node, {"style": "xform"});
                break;
            case "R":
                new o2.widget.O2Role(data, node, {"style": "xform"});
                break;
        }
    };

    //Element.implement({
    //    setSelectPerson : function(container, options){
    //        if (options.types) options.type = "";
    //        options.onComplete = function(items){
    //
    //            debugger;
    //
    //            o2.require("o2.widget.O2Identity", function(){
    //                options.values = [];
    //                this.empty();
    //                items.each(function(item){
    //                    options.values.push(item.data);
    //                    _createEl(item.data, this);
    //                    if (options.selectItem) options.selectItem(item);
    //                }.bind(this));
    //                this.store("data-value", options.values);
    //            }.bind(this));
    //        }.bind(this);
    //
    //        if (options.values){
    //            options.values.each(function(v){
    //                this.store("data-value", options.values);
    //                _createEl(v, this);
    //            }.bind(this));
    //        }
    //        this.addEvent("click", function(){
    //            var i = this.getZIndex();
    //            options.zIndex = i+1;
    //            new MWF.O2Selector(container, options);
    //        }.bind(this));
    //    }
    //});

    Element.prototype.setSelectPerson = function(container, options){
        if (options.types) options.type = "";
        options.onComplete = function(items){
            o2.require("o2.widget.O2Identity", function(){
                options.values = [];
                this.empty();
                items.each(function(item){
                    options.values.push(item.data);
                    _createEl(item.data, this);
                    if (options.selectItem) options.selectItem(item);
                }.bind(this));
                this.store("data-value", options.values);
            }.bind(this));
        }.bind(this);

        if (options.values){
            options.values.each(function(v){
                this.store("data-value", options.values);
                _createEl(v, this);
            }.bind(this));
        }
        this.addEvent("click", function(){
            var i = this.getZIndex();
            options.zIndex = i+1;
            new MWF.O2Selector(container, options);
            //var selector = new MWF.O2Selector(container, options);
            //this.store("data-selector", selector)
        }.bind(this));
    };
})();

MWF.xApplication.Selector = MWF.xApplication.Selector || {};
//MWF.xDesktop.requireApp("Selector", "lp."+MWF.language, null, false);
//MWF.xDesktop.requireApp("Selector", "Actions.RestActions", null, false);
MWF.xApplication.Selector.Person = new Class({
    Extends: MWF.widget.Common,
    Implements: [Options, Events],

    options: {
        "style": "default",
        "count": 0,
        "title": "",
        "groups": [],
        "roles": [],
        "values": [],
        "exclude" : [],
        "zIndex": 1000,
        "expand": true,
        "embedded" : false, //是否嵌入在其他容器中
        "selectAllEnable" : false, //是否允许全选
        "selectAllRange" : "direct", //全选直属人员 还是 所有下级人员
        "selectAllActiveNestSub": true, //全选时，是否展开子级级以后的层次

        "level1Indent" : 10, //第一级的缩进
        "indent" : 10, //后续的缩进

        "hasLetter" : true, //字母
        "hasTop" : false, //可选、已选的标题

        "hasShuttle" : false, //穿梭按钮
        "searchbarInTopNode" : true, //搜索框在标题上还是另起一行
        "hasSelectedSearchbar" : false, //已选是不是有搜索框
        "noSelectedContainer" : false, //是否隐藏右侧已选区域
        "contentUrl" : "", //和默认的页面布局不一样的话，可以传入页面布局HTML URL
        "injectToBody" : false, //当传入HTML URL的时候是否插入到document.body, false的时候插入到this.container
        "selectSingleItem" : false, //当只有一个候选项的时候，是否默认选中
        "hiddenEmptyCategory" : false,

        "flatCategory" : false, //扁平化展现分类,
        "selectType" : "person",

        "isCheckStatus" : false,
        "showSelectedCount" : false,

        "itemHeight" : 29,
        "identityItemWidth" : 0, //选项宽度，如果不为0，设置为float:left,

        "storeRange" : "full", //数据是否保存为精简，可选值：full,simple

        "showEmptyText" : true
    },
    setInitTitle: function(){
        this.setOptions({"title": MWF.xApplication.Selector.LP.selectPerson});
    },
    initialize: function(container, options){
        this.active = true;

        this.setOptions(options);
        if (!this.options.title) this.setInitTitle();

        this.path = "../x_component_Selector/$Selector/";
        this.cssPath = "../x_component_Selector/$Selector/"+this.options.style+"/css.wcss";
        this._loadCss(true);

        this.container = $(container);

        if( ["flow"].contains(this.options.style)  ){
            this.options.contentUrl = this.path + this.options.style + "/"+( this.options.embedded ? "selector_embedded":"selector" )+".html";
            this.options.level1Indent = 10;
            this.options.indent = 20;
        }

        Object.defineProperties(this, {
            "orgAction": {"get": function(){return o2.Actions.get("x_organization_assemble_control");}},
            "processAction": {"get": function(){return o2.Actions.get("x_processplatform_assemble_surface");}},
            "designerAction": {"get": function(){return o2.Actions.get("x_processplatform_assemble_designer");}},
            "portalAction": {"get": function(){return o2.Actions.get("x_portal_assemble_surface");}},
            "portalDesignerAction": {"get": function(){return o2.Actions.get("x_portal_assemble_designer");}},
            "cmsAction": {"get": function(){return o2.Actions.get("x_cms_assemble_control");}},
            "queryAction": {"get": function(){return o2.Actions.get("x_query_assemble_designer");}}
        });

        // this.orgAction = MWF.Actions.get("x_organization_assemble_control");
        // //this.org2Action = MWF.Actions.get("x_organization_assemble_express");
        // this.processAction = MWF.Actions.get("x_processplatform_assemble_surface");
        // this.designerAction = MWF.Actions.get("x_processplatform_assemble_designer");
        // this.portalAction = MWF.Actions.get("x_portal_assemble_surface");
        // this.portalDesignerAction = MWF.Actions.get("x_portal_assemble_designer");
        // this.cmsAction = MWF.Actions.get("x_cms_assemble_control");
        // this.queryAction = MWF.Actions.get("x_query_assemble_designer");

        //this.action = new MWF.xApplication.Selector.Actions.RestActions();

        this.lastPeople = "";
        this.pageCount = "13";

        this.selectedItems = []; //所有已选项

        this.items = []; //所有选择项

        this.subCategorys = []; //直接的分类
        this.subItems = []; //直接的选择项

        this.subCategoryMap = {};
        this.subCategoryMapWithDuty = {};

        if( !this.options.values ){
            this.options.values = [];
        }

        this.tooltips = [];

        this.availableStatusTypes = ["identity","custom"];

        this._init();
    },
    _init : function(){
        this.selectType = "person";
        this.className = "Person";
    },
    load: function(){
        debugger;
        this.fireEvent("queryLoad",[this]);
        if( this.options.contentUrl ){
            this.loadWithUrl()
        }else{
            if (layout.mobile){
                this.loadMobile();
            }else{
                this.loadPc();
            }
            this.fireEvent("load");
        }
    },
    loadMobile: function(){
        this.overrideSelectedItems();

        this.maskRelativeNode = $(document.body);
        this.maskRelativeNode.mask({
            "destroyOnHide": true,
            "style": this.css.maskNode
        });

        this.node = new Element("div", {"styles": this.css.containerNodeMobile});
        this.node.setStyle("z-index", this.options.zIndex.toInt()+1);
        this.node.setStyle("height", ( $(document.body).getSize().y ) + "px");
        this.titleNode = new Element("div", {
            "styles": this.css.titleNodeMobile
        }).inject(this.node);

        this.titleCancelActionNode = new Element("div", {
            "styles": this.css.titleCancelActionNodeMobile,
            "text": MWF.SelectorLP.back
        }).inject(this.titleNode);
        this.titleOkActionNode = new Element("div", {
            "styles": this.css.titleOkActionNodeMobile,
            "text": MWF.SelectorLP.ok
        }).inject(this.titleNode);

        this.titleTextNode = new Element("div", {
            "styles": this.css.titleTextNodeMobile,
            "text": this.options.title
        }).inject(this.titleNode);

        this.contentNode = new Element("div", {
            "styles": this.css.contentNode
        }).inject(this.node);

        var size = $(document.body).getSize();
        var height = size.y-40;
        //var height = size.y;
        this.contentNode.setStyle("height", ""+height+"px");

        this.node.inject($(document.body));
        this.node.setStyles({
            "top": "0px",
            "left": "0px"
        });

        this.loadContent();

        this.setEvent();
    },
    overrideSelectedItems: function(){
       var  _self = this;

        var oldPush = this.selectedItems.push;
        this.selectedItems.push = function(){
            oldPush.apply(this, arguments);
            _self.setSelectedCount();
        };

        var oldErase = this.selectedItems.erase;
        this.selectedItems.erase = function(){
            oldErase.apply(this, arguments);
            _self.setSelectedCount();
        };

        var oldConcat = this.selectedItems.concat;
        this.selectedItems.concat = function(){
            oldConcat.apply(this, arguments);
            _self.setSelectedCount();
        };
    },
    setSelectedCount: function(){
        var quantifier = MWF.SelectorLP.quantifier[ this.selectType ] || "";
        if(this.selectedCountTextNode)this.selectedCountTextNode.set("text", quantifier + ":"+ this.selectedItems.length );
        if(this.selectedTitleCountNode){
            if( this.inMulitple ){
                this.selectedTitleCountNode.set("text", quantifier + ":" + this.selectedItems.length );
            }else{
                this.selectedTitleCountNode.set("text", "("+ quantifier + ":" + this.selectedItems.length +")");
            }
        }
    },
    loadSelectedCountNode: function(){
        if( this.inMulitple )return;
        this.selectedCountNode = new Element("div.selectedCountNode", {
            "styles": this.css.selectedCountNodeMobile,
            "events":{
                "click": function () {
                    this.css.selectedMaskNodeMobile["z-index"] = this.options.zIndex + 2;
                    this.selectedMaskNode = new Element("div", {
                        "styles": this.css.selectedMaskNodeMobile,
                        "events":{
                            "click": function () {
                                this.selectedWrapNode.hide();
                                this.selectedMaskNode.destroy();
                            }.bind(this)
                        }
                    }).inject( this.node );
                    this.selectedWrapNode.show().inject( this.node );
                }.bind(this)
            }
        }).inject(this.selectNode);

        this.selectedCountLabelNode = new Element("div", {
            "styles": this.css.selectedCountLabelNodeMobile,
            "text": MWF.SelectorLP.selected2
        }).inject( this.selectedCountNode );
        this.selectedCountTextNode = new Element("div", {
            "styles": this.css.selectedCountTextNodeMobile,
            "text": (MWF.SelectorLP.quantifier[ this.selectType ] || "") + ":0"
        }).inject( this.selectedCountNode );
    },
    setMaskResize: function(){
        var size = this.container.getSize();
        this.mask.resize();
        this.maskInterval = window.setInterval(function(){
            var resize = this.container.getSize();
            if ((size.x!==resize.x) || (size.y!==resize.y)){
                this.mask.position();
                this.mask.resize();
                size.x = resize.x;
                size.y = resize.y;
            }
        }.bind(this), 66);
    },
    loadPc: function(){
        if( this.options.embedded ){
            this.node = new Element("div", {
                "styles": this.css.containerNode_embedded, //(this.options.count.toInt()===1) ? this.css.containerNodeSingle_embedded : this.css.containerNode_embedded,
                "events": {
                    "click": function(e){e.stopPropagation();},
                    "mousedown": function(e){e.stopPropagation();},
                    "mouseover": function(e){e.stopPropagation();},
                    "mouseout": function(e){e.stopPropagation();},
                    "keydown": function(e){e.stopPropagation();}
                }
            });

            this.contentNode = new Element("div", {
                "styles": this.css.contentNode_embedded ? this.css.contentNode_embedded : this.css.contentNode
            }).inject(this.node);

            this.loadContent();

            if( this.options.width || this.options.height ){
                this.setSize()
            }

            this.node.inject(this.container);
        } else {
            this.css.maskNode["z-index"] = this.options.zIndex;
            var position = this.container.getPosition(this.container.getOffsetParent());
            this.mask = new Mask(this.container, {
                "destroyOnHide": true,
                "style": this.css.maskNode,
                "useIframeShim": true,
                "iframeShimOptions": {"browsers": true},
                "inject": {"where":"bottom"},
                "onShow": function () {
                    this.shim.shim.setStyles({
                        "opacity": 0,
                        "top": "" + position.y + "px",
                        "left": "" + position.x + "px"
                    });
                }
                //
                // "destroyOnHide": true,
                // "style": this.css.maskNode,
                // "useIframeShim": true,
                // "iframeShimOptions": {"browsers": true},
                // "onShow": function(){
                //     this.shim.shim.setStyles({
                //         "opacity": 0,
                //         "top": ""+position.y+"px",
                //         "left": ""+position.x+"px"
                //     });
                // }
            });
            this.mask.show();
            this.setMaskResize();

            //  this.container.setStyle("z-index", this.options.zIndex);
            this.node = new Element("div", {
                "styles": this.options.noSelectedContainer ? this.css.containerNodeSingle : this.css.containerNode, //(this.options.count.toInt()===1)
                "events": {
                    "click": function(e){e.stopPropagation();},
                    "mousedown": function(e){e.stopPropagation();},
                    "mouseover": function(e){e.stopPropagation();},
                    "mouseout": function(e){e.stopPropagation();},
                    "keydown": function(e){e.stopPropagation();}
                }
            });
            this.node.setStyle("z-index", this.options.zIndex.toInt()+1);
            this.titleNode = new Element("div.titleNode", {
                "styles": this.css.titleNode
            }).inject(this.node);

            this.titleActionNode = new Element("div", {
                "styles": this.css.titleActionNode
            }).inject(this.titleNode);
            this.titleTextNode = new Element("div", {
                "styles": this.css.titleTextNode,
                "text": this.options.title
            }).inject(this.titleNode);

            this.contentNode = new Element("div", {
                "styles": this.css.contentNode
            }).inject(this.node);

            this.loadContent();

            this.actionNode = new Element("div", {
                "styles": this.css.actionNode
            }).inject(this.node);
            //if (this.options.count.toInt() === 1) this.actionNode.setStyle("text-align", "center");
            this.loadAction();

            this.node.inject(this.container);

            this.node.position({
                relativeTo: this.container,
                position: "center",
                edge: "center"
            });

            var size = this.container.getSize();
            var nodeSize = this.node.getSize();
            this.node.makeDraggable({
                "handle": this.titleNode,
                "limit": {
                    "x": [0, size.x - nodeSize.x],
                    "y": [0, size.y - nodeSize.y]
                }
            });

            if( this.options.width || this.options.height ){
                this.setSize()
            }

            this.setEvent();

        }
    },

    loadWithUrl : function(){
        if( this.options.style === "flow" ){
            debugger;
            var node = new Element("div");
            node.loadHtml( this.options.contentUrl, {
                "bind": { "lp": MWF.xApplication.Selector.LP, "options": this.options },
                "module": this
            },function () {
                this.node = node.getFirst();
                this.node.loadCss("../x_component_Selector/$Selector/flow/style.css");
                this.loadContentWithHTML();
                this.fireEvent("load");
            }.bind(this));
        }else{
            var request = new Request.HTML({
                url: this.options.contentUrl,
                method: "GET",
                async: false,
                onSuccess: function(responseTree, responseElements, responseHTML, responseJavaScript){
                    this.node = responseTree[0];
                    this.loadContentWithHTML();
                    this.fireEvent("load");
                }.bind(this),
                onFailure: function(xhr){
                    alert(xhr);
                }
            });
            request.send();
        }
    },
    loadContentWithHTML : function(){
        debugger;
        var container = this.options.injectToBody ? $(document.body) : this.container;
        if( !this.options.embedded ){
            this.maskRelativeNode = container;
            this.css.maskNode["z-index"] = this.options.zIndex;
            this.maskRelativeNode.mask({
                "destroyOnHide": true,
                "style": this.css.maskNode
            });
        }

        if( !this.options.embedded ) {
            this.node.setStyles( layout.mobile ? this.css.containerNodeMobile : this.css.containerNode );
            this.node.setStyle("z-index", this.options.zIndex.toInt() + 1);
        }
        if( layout.mobile ){
            this.node.setStyle("height", ( container.getSize().y ) + "px");
        }

        this.titleNode = this.node.getElement(".MWF_selector_titleNode");
        this.titleTextNode = this.node.getElement(".MWF_selector_titleTextNode");
        this.titleCancelActionNode = this.node.getElement(".MWF_selector_titleCancelActionNode");
        this.titleOkActionNode = this.node.getElement(".MWF_selector_titleOkActionNode");

        this.titleActionNode = this.node.getElement(".MWF_selector_titleActionNode");

        this.contentNode = this.node.getElement(".MWF_selector_contentNode");

        this.selectNode = this.node.getElement(".MWF_selector_selectNode");
        this.selectTopNode = this.node.getElement(".MWF_selector_selectTopNode");
        this.selectTopTextNode = this.node.getElement(".MWF_selector_selectTopTextNode");
        this.searchInputDiv = this.node.getElement(".MWF_selector_searchInputDiv");
        this.searchInput = this.node.getElement(".MWF_selector_searchInput");
        this.searchCancelAction = this.node.getElement(".MWF_selector_searchCancelAction");
        this.letterActionNode = this.node.getElement(".MWF_selector_letterActionNode");

        this.flatCategoryScrollNode = this.node.getElement(".MWF_selector_flatCategoryScrollNode");
        this.flatCategoryNode = this.node.getElement(".MWF_selector_flatCategoryNode");
        if( this.options.flatCategory && this.flatCategoryScrollNode ){
            this.isFlatCategory = true;
            this.flatSubCategoryNodeList = [];
        }

        this.letterAreaNode = this.node.getElement(".MWF_selector_letterAreaNode");

        this.itemAreaScrollNode = this.node.getElement(".MWF_selector_itemAreaScrollNode");
        this.itemAreaNode = this.node.getElement(".MWF_selector_itemAreaNode");

        this.itemSearchAreaScrollNode = this.node.getElement(".MWF_selector_itemSearchAreaScrollNode");
        this.itemSearchAreaNode = this.node.getElement(".MWF_selector_itemSearchAreaNode");

        this.selectedContainerNode = this.node.getElement(".MWF_selector_selectedContainerNode");

        this.selectedTopNode = this.node.getElement(".MWF_selector_selectedTopNode");
        this.selectedTopTextNode = this.node.getElement(".MWF_selector_selectedTopTextNode");
        this.emptySelectedNode = this.node.getElement(".MWF_selector_emptySelectedNode");

        this.selectedScrollNode = this.node.getElement(".MWF_selector_selectedScrollNode");
        this.selectedNode = this.node.getElement(".MWF_selector_selectedNode");
        this.selectedItemSearchAreaNode = this.node.getElement(".MWF_selector_selectedItemSearchAreaNode");

        this.actionNode = this.node.getElement(".MWF_selector_actionNode");
        this.okActionNode = this.node.getElement(".MWF_selector_okActionNode");
        this.cancelActionNode = this.node.getElement(".MWF_selector_cancelActionNode");

        if (this.titleNode) this.titleNode.setStyles( layout.mobile ? this.css.titleNodeMobile : this.css.titleNode );
        if (this.titleTextNode){
            this.titleTextNode.setStyles(layout.mobile ? this.css.titleTextNodeMobile : this.css.titleTextNode);
            if(this.options.title)this.titleTextNode.set("text", this.options.title);
        }
        if (this.titleActionNode)this.titleActionNode.setStyles(this.css.titleActionNode);
        if (this.titleCancelActionNode) this.titleCancelActionNode.setStyles(this.css.titleCancelActionNodeMobile);
        if (this.titleOkActionNode) this.titleOkActionNode.setStyles(this.css.titleOkActionNodeMobile);
        if (this.contentNode) this.contentNode.setStyles(this.css.contentNode);

        if (this.selectNode) this.selectNode.setStyles( layout.mobile ? this.css.selectNodeMobile : this.css.selectNode);
        if (this.selectTopNode)this.selectTopNode.setStyles(this.css.selectTopNode);
        if (this.selectTopTextNode)this.selectTopTextNode.setStyles(this.css.selectTopTextNode);
        if (this.searchInputDiv) this.searchInputDiv.setStyles(this.css.searchInputDiv);
        if (this.searchInput) this.searchInput.setStyles( (this.options.count.toInt()===1 || this.options.noSelectedContainer) ? this.css.searchInputSingle : this.css.searchInput );
        if (this.searchCancelAction) this.searchCancelAction.setStyles(this.css.searchCancelAction);
        if (this.letterActionNode) this.letterActionNode.setStyles(this.css.letterActionNode);
        if (this.letterAreaNode) this.letterAreaNode.setStyles(this.css.letterAreaNode);
        if (this.itemAreaScrollNode) this.itemAreaScrollNode.setStyles(this.css.itemAreaScrollNode);
        if (this.itemAreaNode) this.itemAreaNode.setStyles(this.css.itemAreaNode);

        if (this.itemSearchAreaScrollNode) this.itemSearchAreaScrollNode.setStyles(this.css.itemSearchAreaScrollNode);
        if (this.itemSearchAreaNode) this.itemSearchAreaNode.setStyles(this.css.itemAreaNode);

        if (this.selectedContainerNode)this.selectedContainerNode.setStyles(this.css.selectedContainerNode);
        if (this.selectedTopNode)this.selectedTopNode.setStyles(this.css.selectedTopNode);
        if (this.selectedTopTextNode)this.selectedTopTextNode.setStyles(this.css.selectedTopTextNode);
        if (this.emptySelectedNode)this.emptySelectedNode.setStyles(this.css.selectedTopActionNode);

        if (this.selectedScrollNode) this.selectedScrollNode.setStyles(this.css.selectedScrollNode);
        if (this.selectedNode) this.selectedNode.setStyles(this.css.selectedNode);
        if (this.selectedItemSearchAreaNode) this.selectedItemSearchAreaNode.setStyles(this.css.itemAreaNode);

        if (this.actionNode) this.actionNode.setStyles(this.css.actionNode);
        if (this.okActionNode) {
            this.okActionNode.setStyles(this.css.okActionNode);
            this.okActionNode.set("text", MWF.SelectorLP.ok);
        }
        if (this.cancelActionNode) {
            this.cancelActionNode.setStyles(this.css.cancelActionNode);
            this.cancelActionNode.set("text", MWF.SelectorLP.cancel);
        }

        this.node.inject( container );

        this.loadContent();
        if( this.actionNode ){
            this.loadAction();
        }

        if( !this.options.embedded ){
            if( layout.mobile ){
                this.node.setStyles({
                    "top": "0px",
                    "left": "0px"
                });
            }else{
                if( this.options.width || this.options.height ){
                    this.setSize()
                }
                this.node.position({
                    relativeTo: this.container,
                    position: "center",
                    edge: "center"
                });

                var size = this.container.getSize();
                var nodeSize = this.node.getSize();
                this.node.makeDraggable({
                    "handle": this.titleNode,
                    "limit": {
                        "x": [0, size.x - nodeSize.x],
                        "y": [0, size.y - nodeSize.y]
                    }
                });
            }
        }else{
            if( this.options.width || this.options.height ){
                this.setSize()
            }
        }

        this.setEvent();
    },
    switchLetterArea: function(){
        var showing = this.letterAreaNode.offsetParent;
        this.letterAreaNode.setStyle("display", showing ? "none" : "" );

        this.letterActionNode.setStyles( showing ? this.css.letterActionNode : this.css.letterActionNode_active )
        if( showing ){
            this.letterActionNode.removeClass("MWF_selector_letterActionNode_active");
            if( this.options.mainColorEnable )this.letterActionNode.removeClass("mainColor_color");
        }else{
            this.letterActionNode.addClass("MWF_selector_letterActionNode_active");
            if( this.options.mainColorEnable )this.letterActionNode.addClass("mainColor_color");
        }

        if( this.letterAreaNode.offsetParent )this.loadLetters();

        var height = this.selectNode.getSize().y - this.getOffsetY( this.selectNode );

        if( this.searchInput ){
            height = height - this.getOffsetY( this.searchInputDiv ) - ( this.searchInputDiv.getStyle("height").toInt() || 0 )
        }

        if( !showing ){
            height = height - this.getOffsetY( this.letterAreaNode ) - ( this.letterAreaNode.getStyle("height").toInt() || 0 );
        }

        this.itemAreaScrollNode.setStyle("height", ""+height+"px");

        if( this.itemSearchAreaScrollNode ){
            this.itemSearchAreaScrollNode.setStyle("height", ""+height+"px");
        }
    },
    getUnitIdentityCount : function(){

    },
    getUnitSelecteIndentityCount : function( unitLevelName ){ //根据组织获取已选身份数
        var count;
        this.selectedItems.each( function (item) {
            if( item.data.unitLevelName.indexOf( unitLevelName ) === 0 )count++;
        }.bind(this));
        return count;
    },
    getGroupNestCount : function(){
        // o2.Actions.load("x_organization_assemble_express").
    },
    getGroupSelecteIndentityCount : function( groupName ){ //根据组织获取已选身份数
        var count;
        this.selectedItems.each( function (item) {
            if( item.data.unitLevelName.indexOf( unitLevelName ) === 0 )count++;
        }.bind(this));
        return count;
    },
    setEvent: function(){
        if (this.titleActionNode){
            this.titleActionNode.addEvent("click", function(){
                this.fireEvent("cancel", this);
                this.close();
            }.bind(this));
        }
        if (this.titleCancelActionNode){
            this.titleCancelActionNode.addEvent("click", function(){
                this.fireEvent("cancel", this);
                this.close();
            }.bind(this));
        }
        if (this.titleOkActionNode){
            this.titleOkActionNode.addEvent("click", function(){
                this.fireEvent("complete", [this.selectedItems]);
                if( this.options.closeOnclickOk !== false )this.close();
            }.bind(this));
        }
    },
    close: function(){
        this.fireEvent("close");
        this.clearTooltip();
        this.node.destroy();
        //if (this.mask) this.mask.hide();
        if( !this.options.embedded ){
            (this.maskRelativeNode || this.container).unmask();
        }
        if (this.maskInterval){
            window.clearInterval(this.maskInterval);
            this.maskInterval = null;
        }
        this.active = false;
        MWF.release(this);
        delete this;
    },
    clearTooltip: function(){
        if( this.tooltips && this.tooltips.length ){
            this.tooltips.each(function (tooltip) {
                if(tooltip.destroy)tooltip.destroy();
            }.bind(this));
            this.tooltips = [];
        }
    },
    loadAction: function(){
        if( !this.okActionNode ){
            this.okActionNode = new Element("button", {
                "styles": this.css.okActionNode,
                "text": MWF.SelectorLP.ok
            }).inject(this.actionNode);
        }
        if( !this.cancelActionNode ){
            this.cancelActionNode = new Element("button", {
                "styles": this.css.cancelActionNode,
                "text": MWF.SelectorLP.cancel
            }).inject(this.actionNode);
        }
        this.okActionNode.addEvent("click", function(){
            this.fireEvent("complete", [this.selectedItems]);
            if( this.options.closeOnclickOk !== false )this.close();
        }.bind(this));
        this.cancelActionNode.addEvent("click", function(){this.fireEvent("cancel", this); this.close();}.bind(this));
    },
    loadContent: function( contentNode, isHTML ){

        this.selectedItemsMap = {};

        this.fireEvent("queryLoadContent",[this]);

        if( contentNode )this.contentNode = contentNode;
        if( this.options.contentUrl || isHTML ){
            if( layout.mobile ){
                this.loadSelectedNodeHTMLMobile();
                this.loadSelectNodeHTMLMobile(contentNode);
            }else{
                this.loadSelectNodeHTML(contentNode);
                this.loadSelectedNodeHTML();
            }
        }else{
            if (layout.mobile){
                this.loadSelectedNodeMobile();
                this.loadSelectNodeMobile();
                this.setSelectedItem();
            }else{
                this.loadSelectNode();
                if( this.options.hasShuttle ){
                    this.loadShuttleNode();
                }
                //if (this.options.count.toInt()!==1) this.loadSelectedNode();
                this.loadSelectedNode();
            }
        }
        this.fireEvent("postLoadContent", [this]);
    },
    getOffsetX : function(node){
        return (node.getStyle("margin-left").toInt() || 0 )+
            (node.getStyle("margin-right").toInt() || 0 ) +
            (node.getStyle("padding-left").toInt() || 0 ) +
            (node.getStyle("padding-right").toInt() || 0 ) +
            (node.getStyle("border-left-width").toInt() || 0 ) +
            (node.getStyle("border-right-width").toInt() || 0 );
    },
    getOffsetY : function(node){
        return (node.getStyle("margin-top").toInt() || 0 ) +
            (node.getStyle("margin-bottom").toInt() || 0 ) +
            (node.getStyle("padding-top").toInt() || 0 ) +
            (node.getStyle("padding-bottom").toInt() || 0 )+
            (node.getStyle("border-top-width").toInt() || 0 ) +
            (node.getStyle("border-bottom-width").toInt() || 0 );
    },
    loadSelectNodeHTML: function(contentNode){
        var size;
        var height;
        debugger;
        if( contentNode ){
            size = contentNode.getSize();
            height = size.y;
            if( height === 0 ){
                height = contentNode.getStyle("height").toInt();
            }
        }else{
            size = this.node.getSize();

            // var zoom = this.node.getStyle("zoom").toInt() || 0;
            // if( zoom ){
            //     size.x = size.x * 100 / zoom;
            //     size.y = size.y * 100 / zoom;
            // }

            height = size.y-this.getOffsetY( this.contentNode );
            if( this.titleNode ){
                height = height - this.getOffsetY( this.titleNode ) - ( this.titleNode.getStyle("height").toInt() || 0 )
            }
            if( this.actionNode ){
                height = height - this.getOffsetY( this.actionNode ) - ( this.actionNode.getStyle("height").toInt() || 0 )
            }

            this.contentNode.setStyle("height", ""+height+"px");
        }

        height = height - this.getOffsetY( this.selectNode );
        this.selectNode.setStyle("height", ""+height+"px");

        this.selectedContainerNode.setStyle("height", ""+height+"px");
        var selectedTopHeight = 0;
        if( this.selectedTopNode )selectedTopHeight = this.getOffsetY( this.selectedTopNode ) + ( this.selectedTopNode.getStyle("height").toInt() || 0 )
        this.selectedScrollNode.setStyle("height", ""+( height - selectedTopHeight )+"px");


        if( this.searchInput ){
            this.initSearchInput();
            height = height - this.getOffsetY( this.searchInputDiv ) - ( this.searchInputDiv.getStyle("height").toInt() || 0 )
        }

        if( this.options.hasLetter && this.letterAreaNode){
            if( this.letterAreaNode.offsetParent ){
                this.loadLetters();
                height = height - this.getOffsetY( this.letterAreaNode ) - ( this.letterAreaNode.getStyle("height").toInt() || 0 );
            }
        }

        this.itemAreaScrollNode.setStyle("height", ""+height+"px");
        this.itemAreaScrollNode.setStyle("overflow", "auto");

        if(this.itemSearchAreaScrollNode){
            this.itemSearchAreaScrollNode.setStyles({
                "display": "none",
                "height": ""+height+"px",
                "overflow" : "auto"
            });
        }
        this.itemSearchAreaNode.setStyle("display", "none");

        this.initLoadSelectItems();
        this.checkLoadSelectItems();
    },
    loadSelectedNodeHTML: function(){

        if( this.emptySelectedNode ){
            this.emptySelectedNode.addEvent("click", function () {
                this.emptySelectedItems()
            }.bind(this))
        }

        this.setSelectedItem();

        //if(this.selectedScrollNode)this.selectedScrollNode.setStyle("display", "none");
    },

    loadSelectNodeHTMLMobile: function(contentNode){
        var size;
        var height;
        if( contentNode ){
            size = contentNode.getSize();
            height = size.y;
            if( height === 0 ){
                height = contentNode.getStyle("height").toInt();
            }
        }else{
            var container = this.options.injectToBody ? $(document.body) : this.container;
            //var containerSize = this.container.getSize();
            //var bodySize = $(document.body).getSize();
            size = container.getSize();
            if(size.y === 0){
                size.y = $(document.body).getSize().y
            }

            //size = {
            //    "x" : Math.min( containerSize.x, bodySize.x ),
            //    "y" : Math.min( containerSize.y, bodySize.y )
            //};
            if(this.node){
                var zoom = this.node.getStyle("zoom").toInt();
                zoom = zoom ? (zoom * 100) : 0;
                if( zoom ){
                    size.x = size.x * 100 / zoom;
                    size.y = size.y * 100 / zoom;
                }
                this.node.setStyles({
                    "width" : size.x+"px",
                    "height" : size.y+"px"
                })
            }
            height = size.y-this.getOffsetY( this.contentNode );
            if( this.titleNode ){
                height = height - this.getOffsetY( this.titleNode ) - ( this.titleNode.getStyle("height").toInt() || 0 )
            }
            if( this.actionNode ){
                height = height - this.getOffsetY( this.actionNode ) - ( this.actionNode.getStyle("height").toInt() || 0 )
            }

            this.contentNode.setStyle("height", ""+height+"px");
        }


        var isFormWithAction = window.location.href.toLowerCase().indexOf("workmobilewithaction.html") > -1;

        this.selectNode.setStyle("height", ""+height+"px");


        if( this.searchInput ){
            this.initSearchInput();
            height = height - this.getOffsetY( this.searchInputDiv ) - ( this.searchInputDiv.getStyle("height").toInt() || 0 )
        }

        if( this.options.hasLetter && this.letterAreaNode ){
            var width = size.x - 18;
            this.letterAreaNode.setStyle("width", "" + width + "px");
            this.loadLetters();
            height = height - this.getOffsetY( this.letterAreaNode ) - ( this.letterAreaNode.getStyle("height").toInt() || 0 )
        }

        this.itemAreaScrollNode.setStyle("height", ""+height+"px");
        this.itemAreaScrollNode.setStyle("overflow", "auto");

        if(this.itemSearchAreaScrollNode){
            this.itemSearchAreaScrollNode.setStyles({
                "display": "none",
                "height": ""+height+"px",
                "overflow" : "auto"
            });
        }
        this.itemSearchAreaNode.setStyle("display", "none");

        this.initLoadSelectItems();
        this.checkLoadSelectItems();
    },


    loadSelectNodeMobile: function(){
        this.selectNode = new Element("div.selectNode", {
            "styles": this.css.selectNodeMobile
        }).inject(this.contentNode);

        var containerSize = this.container.getSize();
        var bodySize = $(document.body).getSize();

        var size = {
            "x" : Math.min( containerSize.x, bodySize.x ),
            "y" : Math.min( containerSize.y, bodySize.y )
        };

        var height;
        if( !this.inMulitple ){
            var isFormWithAction = window.location.href.toLowerCase().indexOf("workmobilewithaction.html") > -1;

            var formActionY = 0;
            if( isFormWithAction ){
                // var formActions = document.getElement(".o2_form_mobile_actions");
                // if(formActions)formActionY = formActions.getSize().y - this.getOffsetY(formActions);
            }

            height = size.y - formActionY - this.titleNode.getSize().y - this.getOffsetY(this.titleNode);
            this.selectNode.setStyle("height", ""+height+"px");
        }


        this.searchInputDiv = new Element("div.searchInputDiv", {
            "styles": this.css.searchInputDiv
        }).inject(this.selectNode);
        this.searchInput = new Element("input.searchInput", {
            "styles": (this.options.count.toInt()===1 || this.options.noSelectedContainer) ? this.css.searchInputSingle : this.css.searchInput,
            "type": "text"
        }).inject(this.searchInputDiv);
        var width = size.x-20-18;
        this.searchInput.setStyle("width", ""+width+"px");
        this.searchInput.setStyle("height", "20px");
        this.initSearchInput();

        if( this.options.hasLetter ) {
            this.letterAreaNode = new Element("div", {
                "styles": this.css.letterAreaMobileNode
            }).inject(this.selectNode);
            width = size.x - 18;
            this.letterAreaNode.setStyle("width", "" + width + "px");
            this.loadLetters();
        }

        this.itemAreaScrollNode = new Element("div.itemAreaScrollNode", {
            "styles": this.css.itemAreaScrollNode
        }).inject(this.selectNode);

        this.loadSelectedCountNode();

        if( !this.inMulitple ) {
            var y = this.getOffsetY(this.itemAreaScrollNode);
            if (this.searchInputDiv) y = y + this.searchInputDiv.getSize().y + this.getOffsetY(this.searchInputDiv);
            if (this.letterAreaNode) y = y + this.letterAreaNode.getSize().y + this.getOffsetY(this.letterAreaNode);
            if (this.selectedCountNode) y = y + this.selectedCountNode.getSize().y + this.getOffsetY(this.selectedCountNode);

            height = height - y;

            this.itemAreaScrollNode.setStyle("height", "" + height + "px");

            if( this.itemSearchAreaScrollNode ){
                this.itemSearchAreaScrollNode.setStyle("height", "" + height + "px");
            }
        }
        this.itemAreaScrollNode.setStyle("overflow", "auto");

        this.itemAreaNode = new Element("div.itemAreaNode", {
            "styles": this.css.itemAreaNode
        }).inject(this.itemAreaScrollNode);
        this.itemSearchAreaNode = new Element("div.itemSearchAreaNode", {
            "styles": this.css.itemAreaNode
        }).inject(this.itemAreaScrollNode);
        this.itemSearchAreaNode.setStyle("display", "none");



        //MWF.require("MWF.widget.ScrollBar", function(){
        //    var _self = this;
        //    new MWF.widget.ScrollBar(this.itemAreaScrollNode, {
        //        "style":"xApp_Organization_Explorer",
        //        "where": "before",
        //        "distance": 30,
        //        "friction": 4,
        //        "axis": {"x": false, "y": true},
        //        "onScroll": function(y){
        //            _self._scrollEvent(y);
        //        }
        //    });
        //}.bind(this));
        this.initLoadSelectItems();
        this.checkLoadSelectItems();
    },
    loadSelectedNodeHTMLMobile: function(){

        this.setSelectedItem();

        //MWF.require("MWF.widget.ScrollBar", function(){
        //    var _self = this;
        //    new MWF.widget.ScrollBar(this.selectedScrollNode, {
        //        "style":"xApp_Organization_Explorer", "where": "before", "distance": 100, "friction": 4,"axis": {"x": false, "y": true}
        //    });
        //}.bind(this));
        if(this.selectedScrollNode)this.selectedScrollNode.setStyle("display", "none");
    },

    checkLoadSelectItems: function(){
        if (!this.options.groups.length && !this.options.roles.length){
            this.loadSelectItems();
        }else{
            this.loadSelectItemsByCondition();
        }
    },

    loadShuttleNode : function(){
        if(this.shuttleNode)return;

        this.shuttleNode = new Element("div.shuttleNode", {
            "styles": this.css.shuttleNode
        }).inject(this.contentNode);

        this.shuttleInnerNode = new Element("div.shuttleInnerNode", {
            "styles": this.css.shuttleInnerNode
        }).inject(this.shuttleNode);

        this.goRightNode = new Element("div.goRightNode", {
            "styles": this.css.goRightNode
        }).inject(this.shuttleInnerNode);

        this.goLeftNode = new Element("div.goLeftNode", {
            "styles": this.css.goLeftNode
        }).inject(this.shuttleInnerNode);

    },

    loadSelectNode: function(){
        this.selectNode = new Element("div.selectNode", {
            "styles": this.css.selectNode //(this.options.count.toInt()===1) ? this.css.selectNodeSingle : this.css.selectNode
        }).inject(this.contentNode);

        if( this.options.hasTop ){ //if( this.options.embedded && this.options.count.toInt()!==1 ){
            this.selectTopNode = new Element("div.selectTopNode",{
                "styles" : this.css.selectTopNode
            }).inject( this.selectNode );
            this.selectTopTextNode = new Element("div",{
                "text" : MWF.SelectorLP.waitingSelect,
                "styles" : this.css.selectTopTextNode
            }).inject( this.selectTopNode );
        }

        if( this.options.searchbarInTopNode ){
            this.searchInputDiv = new Element("div", {
                "styles": this.css.searchInputDiv
            }).inject( this.selectTopNode || this.selectNode);
        }else{
            this.searchInputDiv = new Element("div.searchInputDiv", {
                "styles": this.css.searchInputDiv
            }).inject( this.selectNode);
        }
        this.searchInput = new Element("input", {
            "styles": this.css.searchInput, //(this.options.count.toInt()===1) ? this.css.searchInputSingle : this.css.searchInput,
            "placeholder" : MWF.SelectorLP.searchDescription,
            "type": "text"
        }).inject(this.searchInputDiv);

        if( this.css.searchCancelAction ){
            this.searchCancelAction = new Element("div.searchCancelAction", {
                "styles": this.css.searchCancelAction
            }).inject( this.searchInputDiv);
        }
        this.initSearchInput();

        if( this.options.hasLetter ){
            this.letterAreaNode = new Element("div", {
                "styles": this.css.letterAreaNode
            }).inject(this.selectNode);
            this.loadLetters();
        }

        this.itemAreaScrollNode = new Element("div", {
            "styles": this.css.itemAreaScrollNode
        }).inject(this.selectNode);

        this.itemAreaNode = new Element("div", {
            "styles": this.css.itemAreaNode
        }).inject(this.itemAreaScrollNode);
        this.itemSearchAreaNode = new Element("div", {
            "styles": this.css.itemAreaNode
        }).inject(this.itemAreaScrollNode);
        this.itemSearchAreaNode.setStyle("display", "none");

        this.loadSelectNodeScroll();
        this.initLoadSelectItems();
        this.checkLoadSelectItems();
    },
    loadSelectNodeScroll: function(){
        var overflowY = this.itemAreaScrollNode.getStyle("overflow-y");
        if( typeOf(overflowY)==="string" && (overflowY.toLowerCase() === "auto" || overflowY.toLowerCase() === "scroll") )return;
        MWF.require("MWF.widget.ScrollBar", function(){
            var _self = this;
            new MWF.widget.ScrollBar(this.itemAreaScrollNode, {
                "style":"xApp_Organization_Explorer",
                "where": "before",
                "distance": 30,
                "friction": 4,
                "axis": {"x": false, "y": true},
                "onScroll": function(y){
                    _self._scrollEvent(y);
                }
            });
        }.bind(this));
    },
    initSearchInput: function(){
        this.searchInput.addEvents({
            "keydown": function(e){
                var iTimerID = this.searchInput.retrieve("searchTimer", null);
                if (iTimerID){
                    window.clearTimeout(iTimerID);
                    this.searchInput.eliminate("searchTimer");
                }

                iTimerID = window.setTimeout(function(){
                    this.search();
                }.bind(this), 800);

                this.searchInput.store("searchTimer", iTimerID);
                if(this.searchCancelAction)this.searchCancelAction.show();
            }.bind(this),
            "change": function(e){
                var key = this.searchInput.get("value");
                if (!key) this.initSearchArea(false);
                if(this.searchCancelAction)this.searchCancelAction[ key ? "show" : "hide" ]();
            }.bind(this),
            "blur": function(){
                var key = this.searchInput.get("value");
                if (!key) this.initSearchArea(false);
                if(this.searchCancelAction)this.searchCancelAction[ key ? "show" : "hide" ]();
            }.bind(this)
        });

        if( this.letterActionNode ){
            this.letterActionNode.addEvent("click", function () {
                this.switchLetterArea()
            }.bind(this))
        }

        if( this.searchCancelAction && this.searchInput ){
            this.searchCancelAction.addEvent("click", function () {
                this.searchInput.set("value", "");
                this.searchInput.focus();
                this.initSearchArea(false);
                this.searchCancelAction.hide();
            }.bind(this))
        }

    },

    initSearchArea: function(flag){
        this.searchItems = [];
        if (flag){
            this.itemSearchAreaNode.empty();
            this.itemAreaNode.setStyle("display", "none");
            if( this.itemSearchAreaNode.getParent() !== this.itemAreaScrollNode ){
                this.itemAreaScrollNode.setStyle("display", "none");
            }
            if(this.flatCategoryScrollNode){
                this.flatCategoryScrollNode.setStyle("display", "none");
            }
            if( this.itemSearchAreaScrollNode )this.itemSearchAreaScrollNode.setStyle("display", "block");
            this.itemSearchAreaNode.setStyle("display", "block");
        }else{
            this.itemAreaScrollNode.setStyle("display", "block");
            this.itemAreaNode.setStyle("display", "block");
            if(this.flatCategoryScrollNode && this.flatSubCategoryNodeList && this.flatSubCategoryNodeList.length > 1 ){
                this.flatCategoryScrollNode.setStyle("display", "block");
            }
            if( this.itemSearchAreaScrollNode )this.itemSearchAreaScrollNode.setStyle("display", "none");
            this.itemSearchAreaNode.setStyle("display", "none");
        }
    },

    search: function(){
        if (!this.options.groups.length && !this.options.roles.length && !this.options.forceSearchInItem ){
            var key = this.searchInput.get("value");
            if (key){
                this._listItemByKey(function(json){
                    this.initSearchArea(true);
                    json.data.each(function(data){
                        if( !this.isExcluded( data ) ) {
                            var itemSearch = this._newItemSearch(data, this, this.itemSearchAreaNode);
                            this.searchItems.push( itemSearch );
                        }
                        //this._newItem(data, this, this.itemSearchAreaNode);
                    }.bind(this));
                }.bind(this), null, key);
            }else{
                this.initSearchArea(false);
            }
        }else{
            var key = this.searchInput.get("value");
            if (key){
                this.initSearchArea(true);
                this.searchInItems(key);
            }else{
                this.initSearchArea(false);
            }
        }
    },
    searchInItems: function(key){

        var createdId = [];
        this.createItemsSearchData(function(){
            var word = key.toLowerCase();

            this.itemsSearchData.each(function(obj){
                var text = obj.text+"#"+obj.pinyin+"#"+obj.firstPY;
                var id = obj.data.distinguishedName || obj.data.id || obj.data.name || obj.data.text;
                if (text.indexOf(word)!==-1){
                    if (createdId.indexOf( id )===-1){
                        this._newItem(obj.data, this, this.itemSearchAreaNode);
                        createdId.push( id );
                    }
                }
            }.bind(this));

            //delete createdId;
        }.bind(this));
        return createdId;
    },
    createItemsSearchData: function(callback){
        if (!this.itemsSearchData){
            this.itemsSearchData = [];
            MWF.require("MWF.widget.PinYin", function(){
                var initIds = [];
                this.items.each(function(item){
                    var id = item.data.distinguishedName || item.data.id || item.data.name || item.data.text;
                    if (initIds.indexOf( id )==-1){
                        var text = item._getShowName().toLowerCase();
                        var pinyin = text.toPY().toLowerCase();
                        var firstPY = text.toPYFirst().toLowerCase();
                        this.itemsSearchData.push({
                            "text": text,
                            "pinyin": pinyin,
                            "firstPY": firstPY,
                            "data": item.data
                        });
                        initIds.push( id );
                    }
                }.bind(this));
                delete initIds;
                if (callback) callback();
            }.bind(this));
        }else{
            if (callback) callback();
        }
    },


    initSelectedSearchInput: function(){
        this.selectedSearchInput.addEvents({
            "keydown": function(e){
                var iTimerID = this.selectedSearchInput.retrieve("searchTimer", null);
                if (iTimerID){
                    window.clearTimeout(iTimerID);
                    this.selectedSearchInput.eliminate("searchTimer");
                }

                iTimerID = window.setTimeout(function(){
                    this.selectedSearch();
                }.bind(this), 800);

                this.selectedSearchInput.store("searchTimer", iTimerID);
                if(this.selectedSearchCancelAction)this.selectedSearchCancelAction.show();
            }.bind(this),
            "change": function(e){
                var key = this.selectedSearchInput.get("value");
                if (!key) this.selectedSearch();
                if(this.selectedSearchCancelAction)this.selectedSearchCancelAction[ key ? "show" : "hide" ]();
            }.bind(this),
            "blur": function(){
                var key = this.selectedSearchInput.get("value");
                if (!key) this.selectedSearch();
                if(this.selectedSearchCancelAction)this.selectedSearchCancelAction[ key ? "show" : "hide" ]();
            }.bind(this)
        });

        if( this.selectedSearchCancelAction && this.selectedSearchInput ){
            this.selectedSearchCancelAction.addEvent("click", function () {
                this.selectedSearchInput.set("value", "");
                this.selectedSearchInput.focus();
                this.selectedSearch();
                this.selectedSearchCancelAction.hide();
            }.bind(this))
        }
    },

    selectedSearch: function(){
        var key = this.selectedSearchInput.get("value");
        if (key){
            this.selectedSearchInItems(key);
        }else{
            this.showAllSelectedItem()
        }
    },
    selectedSearchInItems: function(key){
        var word = key.toLowerCase();
        MWF.require("MWF.widget.PinYin", function() {
            this.selectedItems.each(function (item) {
                if (!item.searchedText) {
                    var text = item._getShowName().toLowerCase();
                    var pinyin = text.toPY().toLowerCase();
                    var firstPY = text.toPYFirst().toLowerCase();
                    item.searchedText = text + "#" + pinyin + "#" + firstPY
                }
                if (item.searchedText.indexOf(word) !== -1) {
                    item.node.show()
                } else {
                    item.node.hide()
                }
            }.bind(this));
        }.bind(this), null, false);
    },
    showAllSelectedItem: function(){
        this.selectedItems.each(function(item){
            item.node.show()
        })
    },

    loadSelectedNode: function( callback ){
        if( this.selectedContainerNode )return;
        this.selectedContainerNode = new Element("div", {
            "styles": this.css.selectedContainerNode
        }).inject(this.contentNode);

        if( this.options.noSelectedContainer ){
            this.selectedContainerNode.hide();
        }

        //if( this.options.embedded && this.options.count.toInt()!==1 ){
        if( this.options.hasTop ){
            this.selectedTopNode = new Element("div",{
                "styles" : this.css.selectedTopNode
            }).inject( this.selectedContainerNode );
            this.selectedTopTextNode = new Element("div",{
                "text" : MWF.SelectorLP.selected,
                "styles" : this.css.selectedTopTextNode
            }).inject( this.selectedTopNode );

            this.emptySelectedNode = new Element("div",{
                "text" : MWF.SelectorLP.empty,
                "styles" : this.css.selectedTopActionNode,
                "events" : {
                    "click" : function(){
                        this.emptySelectedItems()
                    }.bind(this)
                }
            }).inject( this.selectedTopNode );
        }

        if( this.options.hasSelectedSearchbar ){
            if( this.options.searchbarInTopNode ){
                this.selectedSearchInputDiv = new Element("div", {
                    "styles": this.css.searchInputDiv
                }).inject( this.selectedTopNode || this.selectedContainerNode);
            }else{
                this.selectedSearchInputDiv = new Element("div.selectedSearchInputDiv", {
                    "styles": this.css.searchInputDiv
                }).inject( this.selectedContainerNode);
            }
            this.selectedSearchInput = new Element("input", {
                "styles": this.css.searchInput, //(this.options.count.toInt()===1) ? this.css.searchInputSingle : this.css.searchInput,
                "placeholder" : MWF.SelectorLP.searchDescription,
                "type": "text"
            }).inject(this.selectedSearchInputDiv);

            if( this.css.searchCancelAction ){
                this.selectedSearchCancelAction = new Element("div.selectedSearchCancelAction", {
                    "styles": this.css.searchCancelAction
                }).inject( this.selectedSearchInputDiv);
            }
            this.initSelectedSearchInput();
        }

        this.selectedScrollNode = new Element("div.selectedScrollNode", {
            "styles": this.css.selectedScrollNode
        }).inject(this.selectedContainerNode);

        this.selectedNode = new Element("div.selectedNode", {
            "styles": this.css.selectedNode
        }).inject(this.selectedScrollNode);

        if( this.options.hasSelectedSearchbar ){
            this.selectedItemSearchAreaNode = new Element("div.selectedItemSearchAreaNode", {
                "styles": this.css.itemAreaNode
            }).inject(this.selectedScrollNode);
            this.selectedItemSearchAreaNode.setStyle("display", "none");
        }

        this.setSelectedItem();

        this.loadSelectedNodeScroll();

        if(callback)callback();
    },
    emptySelectedItems : function(){
        while (this.selectedItems.length){
            this.selectedItems[0].clickItem();
        }
    },
    loadSelectedNodeScroll: function(){
        var overflowY = this.selectedScrollNode.getStyle("overflow-y");
        if( typeOf(overflowY)==="string" && (overflowY.toLowerCase() === "auto" || overflowY.toLowerCase() === "scroll") )return;
        MWF.require("MWF.widget.ScrollBar", function(){
            var _self = this;
            new MWF.widget.ScrollBar(this.selectedScrollNode, {
                "style":"xApp_Organization_Explorer", "where": "before", "distance": 100, "friction": 4,"axis": {"x": false, "y": true}
            });
        }.bind(this));
    },

    loadSelectedNodeMobile: function(){
        if( this.inMulitple )return;
        this.css.selectedWrapNodeMobile["z-index"] = this.options.zIndex + 2;
        this.selectedWrapNode = new Element("div.selectedWrapNode", {
            "styles": this.css.selectedWrapNodeMobile
        }).inject(this.contentNode);

        this.selectedTitleNode = new Element("div.selectedTitleNodeMobile", {
            "styles": this.css.selectedTitleNodeMobile
        }).inject(this.selectedWrapNode);
        this.selectedTitleLabelNode = new Element("span", {
            "style": "font-weight:bold; padding-right:5px;",
            "text": MWF.SelectorLP.selected2
        }).inject(this.selectedTitleNode);
        this.selectedTitleCountNode = new Element("span", {
            "text": "(0)"
        }).inject(this.selectedTitleNode);

        this.selectedScrollNode = new Element("div.selectedScrollNode", {
            "styles": this.css.selectedScrollNodeMobile
        }).inject(this.selectedWrapNode);


        this.selectedNode = new Element("div.selectedNode", {
            "styles": this.css.selectedNodeMobile
        }).inject(this.selectedScrollNode);

        // MWF.require("MWF.widget.ScrollBar", function(){
        //     var _self = this;
        //     new MWF.widget.ScrollBar(this.selectedScrollNode, {
        //         "style":"xApp_Organization_Explorer", "where": "before", "distance": 100, "friction": 4,"axis": {"x": false, "y": true}
        //     });
        // }.bind(this));
        this.selectedWrapNode.setStyle("display", "none");
    },

    setSelectedItem: function(){
        if (this.options.values.length){
            this.options.values.each(function(v, i){
                if (typeOf(v)==="object"){
                    v.isFromValues = true;
                    var selecteditem = this._newItemSelected(v, this, null);
                    this.selectedItems.push(selecteditem);
                    if(this.addToSelectedItemsMap)this.addToSelectedItemsMap(v, selecteditem);
                }else if( typeOf(v)==="string" ){
                    var fun = function(json){
                        if( !json || !json.data )return;
                        this.options.values[i] = json.data;
                        json.data.isFromValues = true;
                        var selecteditem = this._newItemSelected(json.data, this, null);
                        this.selectedItems.push(selecteditem);
                        if(this.addToSelectedItemsMap)this.addToSelectedItemsMap(json.data, selecteditem);
                    }.bind(this);
                    if( this.options.resultType === "person" && this.selectType === "identity" && v.split("@").getLast().toLowerCase() === "p" ){
                        this.orgAction.getPerson(function(json){
                            fun(json);
                        }.bind(this), null, v, false);
                    }else{
                        this._getItem(fun, null, v, false);
                    }
                }
                // this._getItem(function(json){
                // 	this.selectedItems.push(this._newItemSelected(json.data, this, null));
                // }.bind(this), null, v, false);
            }.bind(this));
        }
    },

    setValues: function( values ){
        this.emptySelectedItems();
        this.options.values = values;
        this.setSelectedItem();
    },

    loadLetters: function(){
        if( this.lettersLoaded )return;
        this.lettersLoaded = true;

        var _self = this;
        var letters = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];

        var letterNodeCss = this.css.letterNode;
        var letterNodeCss_over = this.css.letterNode_over;
        if (layout.mobile){
            letterNodeCss = this.css.letterNode_mobile || letterNodeCss;
            letterNodeCss_over = this.css.letterNode_mobile_over || letterNodeCss_over;
            var size = this.container.getSize();
            // var w = (layout.mobile) ? (size.x-18)/13 : (size.x-20-4-18)/13;
            var w = (layout.mobile) ? (size.x - this.getOffsetX(this.container) - this.getOffsetX(this.letterAreaNode) - 10 )/13 : (size.x-20-4-18)/13;
            //letterNode.setStyle("width", ""+w+"px");
            letterNodeCss.width = ""+w+"px";
            letterNodeCss_over.width = ""+w+"px";
        }else if( this.options.style === "flow" ){
            var width = ( this.letterAreaNode.getSize().x - this.getOffsetX(this.letterAreaNode) - 10 ) / 13;
            letterNodeCss.width = ""+width+"px";
            letterNodeCss_over.width = ""+width+"px";
        }

        letters.each(function(l){
            var letterNode = new Element("div", {
                "styles": letterNodeCss,
                "text": l
            }).inject(this.letterAreaNode);

            if (layout.mobile){
                letterNode.addEvents({
                    "click": function(){
                        _self.listPersonByPinyin(this);
                        if(_self.searchCancelAction)_self.searchCancelAction.show();
                    }
                });
            }else{
                letterNode.addEvents({
                    "mouseover": function(e){
                        e.target.setStyles(letterNodeCss_over);
                        var showNode = new Element("div", {
                            "styles": this.css.letterShowNode,
                            "text": e.target.get("text")
                        }).inject(this.selectNode);
                        showNode.position({
                            relativeTo: this.itemAreaScrollNode,
                            position: "center",
                            edge: "center"
                        });
                        e.target.store("showNode", showNode);
                    }.bind(this),
                    "mouseout": function(e){
                        var showNode = e.target.retrieve("showNode");
                        showNode.destroy();
                        e.target.setStyles(letterNodeCss);
                    }.bind(this),
                    "click": function(){
                        _self.listPersonByPinyin(this);
                        if(_self.searchCancelAction)_self.searchCancelAction.show();
                    }
                });
            }

        }.bind(this));
    },

    listPersonByPinyin: function(node){
        this.searchInput.focus();
        var pinyin = this.searchInput.get("value");
        pinyin = pinyin+node.get("text");
        this.searchInput.set("value", pinyin);

        if (!this.options.groups.length && !this.options.roles.length){
            if (pinyin){
                this._listItemByPinyin(function(json){
                    this.initSearchArea(true);
                    json.data.each(function(data){
                        // var flag = true;
                        // if (this.options.departments){
                        //     if (this.options.departments.length){
                        //         if (this.options.departments.indexOf(data.departmentName)==-1) flag = false;
                        //     }
                        // }
                        // if (this.options.companys){
                        //     if (this.options.companys.length){
                        //         if (this.options.companys.indexOf(data.company)==-1) flag = false;
                        //     }
                        // }
                        if( !this.isExcluded( data ) ) {
                            this._newItemSearch(data, this, this.itemSearchAreaNode);
                        }
                        //this._newItem(data, this, this.itemSearchAreaNode);
                        //this._newItem(data, this, this.itemSearchAreaNode);
                    }.bind(this));
                }.bind(this), null, pinyin.toLowerCase());
            }
        }else{
            if (pinyin){
                this.initSearchArea(true);
                this.searchInItems(pinyin);
            }else{
                this.initSearchArea(false);
            }
        }
    },
    initLoadSelectItems: function(){
        this.loaddingItems = false;
        this.isItemLoaded = false;
        this.loadItemsQueue = 0;
        this.initSearchArea(false);
    },
    //loadSelectItems: function(addToNext){
    //    if (!this.isItemLoaded){
    //        if (!this.loaddingItems){
    //            this.loaddingItems = true;
    //            var count = 20;
    //            this._listItemNext(this.getLastLoadedItemId(), count, function(json){
    //                if (json.data.length){
    //                    json.data.each(function(data){
    //                        var item = this._newItem(data, this, this.itemAreaNode);
    //                        this.items.push(item);
    //                    }.bind(this));
    //                    this.loaddingItems = false;
    //
    //                    if (json.data.length<count){
    //                        this.isItemLoaded = true;
    //                    }else{
    //                        if (this.loadItemsQueue>0){
    //                            this.loadItemsQueue--;
    //                            this.loadSelectItems();
    //                        }
    //                    }
    //                }else{
    //                    this.isItemLoaded = true;
    //                    this.loaddingItems = false;
    //                }
    //            }.bind(this));
    //        }else{
    //            if (addToNext) this.loadItemsQueue++;
    //        }
    //    }
    //},
    loadSelectItems: function(addToNext, lastExcludeCount ){
        //lastExcludeCount 参数：表示本次加载是为了补足上次load的时候被排除的数量
        if (!this.isItemLoaded){
            if (!this.loaddingItems){
                this.loaddingItems = true;
                var count = 20;
                this._listItemNext(this.getLastLoadedItemId(), count, function(json){
                    if (json.data.length){
                        var excludedCount = 0;
                        json.data.each(function(data, i){
                            if( this.isExcluded( data ) ){
                                excludedCount++;
                                if( i+1 === count )this.tailExcludeItemId = data.distinguishedName
                            }else{
                                var item = this._newItem(data, this, this.itemAreaNode);
                                this.items.push(item);
                                if( i+1 === count )this.tailExcludeItemId = null;
                            }
                        }.bind(this));
                        this.loaddingItems = false;

                        if( lastExcludeCount ){ //如果是因为上次load的时候被排除而加载的
                            if( count - lastExcludeCount - excludedCount < 0 ){ //如果本次load的数量还不够补足排除的数量，需要再次load
                                excludedCount = lastExcludeCount + excludedCount - count; //把不足的数量作为再次load的参数
                                this.loadItemsQueue++
                            }
                        }else if( excludedCount > 0  ){ //把排除的数量作为再次load的参数
                            this.loadItemsQueue++
                        }
                        if (json.data.length<count){
                            this.isItemLoaded = true;
                        }else{
                            if (this.loadItemsQueue>0){
                                this.loadItemsQueue--;
                                this.loadSelectItems( addToNext, excludedCount );
                            }
                        }
                    }else{
                        this.isItemLoaded = true;
                        this.loaddingItems = false;
                    }
                    if( this.afterLoadSelectItem )this.afterLoadSelectItem();
                }.bind(this));
            }else{
                if (addToNext) this.loadItemsQueue++;
            }
        }
    },
    getLastLoadedItemId: function(){
        if( this.tailExcludeItemId )return this.tailExcludeItemId;
        return (this.items.length) ? this.items[this.items.length-1].data.distinguishedName : "(0)";
    },

    //loadSelectItemsByCondition: function(){
    //    this.options.groups.each(function(group){
    //
    //        this.orgAction.listGroupByKey(function(json){
    //            if (json.data.length){
    //                var groupData = json.data[0];
    //                var category = this._newItemCategory("ItemGroupCategory", groupData, this, this.itemAreaNode);
    //                this._getChildrenItemIds(groupData).each(function(id){
    //                    this._getItem(function(json){
    //                        var item = this._newItem(json.data, this, category.children);
    //                        this.items.push(item);
    //                    }.bind(this), null, id);
    //                }.bind(this));
    //            }
    //        }.bind(this), null, group);
    //    }.bind(this));
    //
    //    this.options.roles.each(function(role){
    //        this.orgAction.listRoleByKey(function(json){
    //            if (json.data.length){
    //                var roleData = json.data[0];
    //                var category = this._newItemCategory("ItemRoleCategory", roleData, this, this.itemAreaNode);
    //                this._getChildrenItemIds(roleData).each(function(id){
    //                    this._getItem(function(json){
    //                        var item = this._newItem(json.data, this, category.children);
    //                        this.items.push(item);
    //                    }.bind(this), null, id)
    //                }.bind(this));
    //            }
    //        }.bind(this), null, role);
    //    }.bind(this));
    //},
    loadSelectItemsByCondition: function(){
        this.options.groups.each(function(group){
            this.orgAction.listGroupByKey(function(json){
                if (json.data.length){
                    var groupData = json.data[0];
                    var category = this._newItemCategory("ItemGroupCategory", groupData, this, this.itemAreaNode);
                    this.subCategorys.push(category);
                    this._getChildrenItemIds(groupData).each(function(id){
                        this._getItem(function(json){
                            if( !this.isExcluded( json.data ) ) {
                                var item = this._newItem(json.data, this, category.children);
                                this.items.push(item);
                            }
                        }.bind(this), null, id);
                    }.bind(this));
                }
            }.bind(this), null, group);
        }.bind(this));

        this.options.roles.each(function(role){
            this.orgAction.listRoleByKey(function(json){
                if (json.data.length){
                    var roleData = json.data[0];
                    var category = this._newItemCategory("ItemRoleCategory", roleData, this, this.itemAreaNode);
                    this.subCategorys.push(category);
                    this._getChildrenItemIds(roleData).each(function(id){
                        this._getItem(function(json){
                            if( !this.isExcluded( json.data ) ) {
                                var item = this._newItem(json.data, this, category.children);
                                this.items.push(item);
                            }
                        }.bind(this), null, id)
                    }.bind(this));
                }
            }.bind(this), null, role);
        }.bind(this));
    },
    isInValues: function(d){
        if( this.options.values.length === 0 )return false;
        if( !this.valueFlagMap ){
            this.valueFlagMap = {};
            this.options.values.each( function( e ){
                if( !e )return;
                this.valueFlagMap[ typeOf( e ) === "string" ? e : ( e.distinguishedName || e.unique || e.employee || e.levelName || e.id) ] = true;
            }.bind(this));
        }
        var map = this.valueFlagMap;
        return ( d.distinguishedName && map[ d.distinguishedName ] ) ||
            ( d.unique && map[ d.unique ] ) ||
            ( d.employee && map[ d.employee ] ) ||
            ( d.levelName && map[ d.levelName ] ) ||
            ( d.id && map[ d.id ] );
    },
    isExcluded : function( d ){
        if( this.options.exclude.length === 0 )return false;
        if( !this.excludeFlagMap ){
            this.excludeFlagMap = {};
            this.options.exclude.each( function( e ){
                if( !e )return;
                this.excludeFlagMap[ typeOf( e ) === "string" ? e : ( e.distinguishedName || e.unique || e.employee || e.levelName || e.id ) ] = true;
            }.bind(this));
        }
        var map = this.excludeFlagMap;
        return ( d.distinguishedName && map[ d.distinguishedName ] ) ||
            ( d.id && map[ d.id ] ) ||
            ( d.unique && map[ d.unique ] ) ||
            ( d.employee && map[ d.employee ] ) ||
            ( d.levelName && map[ d.levelName ] );
    },
    _getChildrenItemIds: function(data){
        return data.personList;
    },
    _newItemCategory: function(type, data, selector, item){
        return new MWF.xApplication.Selector.Person[type](data, selector, item)
    },

    _listItemByKey: function(callback, failure, key){
        this.orgAction.listPersonByKey(function(json){
            if (callback) callback.apply(this, [json]);
        }.bind(this), failure, key);
    },
    _getItem: function(callback, failure, id, async){

        this.orgAction.getPerson(function(json){
            if (callback) callback.apply(this, [json]);
        }.bind(this), failure, ((typeOf(id)==="string") ? id : id.distinguishedName), async);
    },
    _newItemSelected: function(data, selector, item, selectedNode){
        return new MWF.xApplication.Selector.Person.ItemSelected(data, selector, item, selectedNode)
    },
    _listItemByPinyin: function(callback, failure, key){
        this.orgAction.listPersonByPinyin(function(json){
            if (callback) callback.apply(this, [json]);
        }.bind(this), failure, key);
    },
    _newItem: function(data, selector, container){
        return new MWF.xApplication.Selector.Person.Item(data, selector, container);
    },
    _newItemSearch: function(data, selector, container){
        return this._newItem(data, selector, container);
    },
    _listItemNext: function(last, count, callback){
        this.orgAction.listPersonNext(last, count, function(json){
            if (callback) callback.apply(this, [json]);
        }.bind(this));
    },
    _scrollEvent: function(y){
        if (!this.options.groups.length && !this.options.roles.length){
            var scrollSize = this.itemAreaScrollNode.getScrollSize();
            var clientSize = this.itemAreaScrollNode.getSize();
            var scrollHeight = scrollSize.y-clientSize.y;
            if (y+30>scrollHeight) {
                if (!this.isItemLoaded) this.loadSelectItems();
            }
        }
    },
    afterLoadSelectItem : function(){
        if( this.items.length === 0 && this.subItems.length === 0 && this.subCategorys.length === 0 ){
            this.noSelectableItemTextDiv = new Element("div", {
                text : MWF.SelectorLP.noSelectableItemText,
                styles : this.css.noSelectableItemText
            }).inject( this.itemAreaNode );
        }

        if( this.options.selectSingleItem ){
            this.selectSingleItem()
        }
        this.fireEvent("afterLoadSelectItem", [this]);
    },
    selectSingleItem: function(){
        if( !this.options.contentUrl && !layout.mobile){
            if( this.options.hasShuttle && !this.shuttleNode ){
                this.loadShuttleNode();
            }
            if( !this.selectedContainerNode ) {
                this.loadSelectedNode(function () {
                    this._selectSingleItem();
                }.bind(this));
            }else{
                this._selectSingleItem();
            }
        }else{
            this._selectSingleItem();
        }
    },
    _selectSingleItem : function(){
        var _self = this;
        var checkItem = function () {
            if(this.items.length === 1 || this.subItems.length === 1 ){
                if( this.items.length === 1 && this.subItems.length === 0 ){
                    if( !this.items[0].isSelected )this.items[0].clickItem();
                    this.fireEvent("afterSelectSingleItem",[this, this.items[0]]);
                }else if( this.items.length === 0 && this.subItems.length === 1 ){
                    if( !this.items[0].isSelected )this.subItems[0].clickItem();
                    this.fireEvent("afterSelectSingleItem",[this, this.items[0]])
                }else if( this.items.length === 1 && this.subItems.length === 1 ){
                    if( this.items[0] === this.subItems[0] ){
                        if( !this.items[0].isSelected )this.items[0].clickItem();
                        this.fireEvent("afterSelectSingleItem",[this, this.items[0]])
                    }else{
                        _self.fireEvent("afterCheckSelectSingleItem",[_self])
                    }
                }else{
                    _self.fireEvent("afterCheckSelectSingleItem",[_self])
                }
            }else{
                _self.fireEvent("afterCheckSelectSingleItem",[_self])
            }
        }.bind(this);

        var checkCategoryItem = function (category) {
            if( !category.subCategorys || category.subCategorys.length === 0 ){
                if( category.subItems && category.subItems.length === 1 ){
                    isSingleItem = true;
                    if( !category.subItems[0].isSelected )category.subItems[0].clickItem();
                    _self.fireEvent("afterSelectSingleItem",[_self, category.subItems[0]])
                }else{
                    _self.fireEvent("afterCheckSelectSingleItem",[_self])
                }
            }else if(category.subCategorys.length === 1){
                if( category.subItems && category.subItems.length > 0 ){
                    _self.fireEvent("afterCheckSelectSingleItem",[_self])
                }else if( !category.subCategorys[0]._hasChild || !category.subCategorys[0]._hasChild() ){ //category.subCategorys[0].isItem &&
                    isSingleItem = true;
                    if( !category.subItems[0].isSelected )category.subItems[0].clickItem();
                    _self.fireEvent("afterSelectSingleItem",[_self, category.subItems[0]])
                }else{
                    checkCategory( category.subCategorys[0] )
                }
            }else{
                var list = [];
                for( var i=0; i<category.subCategorys.length; i++ ){
                    if( category.subCategorys[i]._hasChild && category.subCategorys[i]._hasChild()  ){
                        list.push( category.subCategorys[i] );
                    }
                }
                if( list.length === 1 ){
                    if( !category.subItems || category.subItems.length === 0 ){
                        checkCategory( list[0] );
                    }
                }
                if( list.length === 0 ){
                    if( category.subItems && category.subItems.length === 1 ){
                        isSingleItem = true;
                        if( !category.subItems[0].isSelected )category.subItems[0].clickItem();
                        _self.fireEvent("afterSelectSingleItem",[_self, category.subItems[0]])
                    }else{
                        _self.fireEvent("afterCheckSelectSingleItem",[_self])
                    }
                }else{
                    _self.fireEvent("afterCheckSelectSingleItem",[_self])
                }
            }
        };


        var checkCategory = function ( category ) {
            if( category.loaded ){
                checkCategoryItem( category )
            }else if( category.loading ){
                window.setTimeout( function () {
                    checkCategory( category )
                }, 100 )
            }
        };

        if( this.subCategorys.length === 1 && this.subItems.length === 0) {
            checkCategory( this.subCategorys[0] );
        }else if( this.subCategorys.length === 0 ){
            checkItem();
        }else{
            _self.fireEvent("afterCheckSelectSingleItem",[_self])
        }
    },
    setSize : function(){

        if( !this.options.width && !this.options.height )return;

        var getOffsetX = function(node){
            return (node.getStyle("margin-left").toInt() || 0 )+
                (node.getStyle("margin-right").toInt() || 0 ) +
                (node.getStyle("padding-left").toInt() || 0 ) +
                (node.getStyle("padding-right").toInt() || 0 ) +
                (node.getStyle("border-left-width").toInt() || 0 ) +
                (node.getStyle("border-right-width").toInt() || 0 );
        };

        var getOffsetY = function(node){
            return (node.getStyle("margin-top").toInt() || 0 ) +
                (node.getStyle("margin-bottom").toInt() || 0 ) +
                (node.getStyle("padding-top").toInt() || 0 ) +
                (node.getStyle("padding-bottom").toInt() || 0 )+
                (node.getStyle("border-top-width").toInt() || 0 ) +
                (node.getStyle("border-bottom-width").toInt() || 0 );
        };


        if( this.options.width && this.options.width === "auto" ){
            //if (this.options.count.toInt() !== 1){
            if( this.node )this.node.setStyle("width", "auto");

            this.selectNode.setStyles({
                "width": "50%",
                "float" : "left"
            });
            //this.searchInput.setStyle("width", "99%");
            if(this.letterAreaNode ){
                this.letterAreaNode.setStyle("width", "auto");
            }

            this.selectedContainerNode.setStyle("width", "auto");
            var overflowY = this.selectedScrollNode.getStyle("overflow-y");
            if( typeOf(overflowY)==="string" && (overflowY.toLowerCase() === "auto" || overflowY.toLowerCase() === "scroll") ){
                this.selectedScrollNode.setStyle("width", "auto");
            }else{
                this.selectedScrollNode.setStyle("margin-right", "8px");
            }
            //}else{
            //    this.node.setStyle("width", "auto");
            //    this.selectNode.setStyle("width", "auto");
            //}

        }else if( this.options.width && typeOf( this.options.width.toInt() ) === "number" ){
            var nodeWidth;
            if( this.node ){
                nodeWidth = this.options.width.toInt() - getOffsetX(this.node);
                this.node.setStyle("width", nodeWidth);
            }else{
                nodeWidth = this.options.width.toInt();
            }

            nodeWidth = nodeWidth - getOffsetX( this.contentNode );

            if( this.shuttleNode ){
                nodeWidth = nodeWidth - getOffsetX(this.shuttleNode) - this.shuttleNode.getStyle("width").toInt();
            }

            //if (this.options.count.toInt() !== 1){
            var width = nodeWidth - getOffsetX(this.selectNode) - getOffsetX(this.selectedContainerNode);

            var halfWidth = this.options.noSelectedContainer ? width : ( Math.floor(width / 2) - 2);

            this.selectNode.setStyle("width", halfWidth);
            //this.searchInput.setStyle("width", halfWidth - 6);
            if(this.letterAreaNode ){
                this.letterAreaNode.setStyle("width", halfWidth - 19);
            }

            this.selectedContainerNode.setStyle("width", halfWidth);

            var overflowY = this.selectedScrollNode.getStyle("overflow-y");
            if( typeOf(overflowY)==="string" && (overflowY.toLowerCase() === "auto" || overflowY.toLowerCase() === "scroll") ){
                this.selectedScrollNode.setStyle("width", halfWidth);
            }else{
                this.selectedScrollNode.setStyle("width", halfWidth - 8);
            }
            //}else{
            //    var width = nodeWidth - getOffsetX(this.selectNode);
            //    this.selectNode.setStyle("width", width);
            //}
        }

        if( this.options.height && typeOf( this.options.height.toInt() ) === "number" ){
            var nodeHeight;
            if( this.node ){
                nodeHeight = this.options.height.toInt() - getOffsetY(this.node);
                this.node.setStyle("height", nodeHeight);
            }else{
                nodeHeight = this.options.height.toInt();
            }

            nodeHeight = nodeHeight - getOffsetY( this.contentNode ) - 1;
            if( this.titleNode ){
                nodeHeight = nodeHeight - getOffsetY( this.titleNode ) - this.titleNode.getStyle("height").toInt();
            }

            if( this.actionNode ){
                nodeHeight = nodeHeight - getOffsetY( this.actionNode ) - this.actionNode.getStyle("height").toInt();
            }

            this.contentNode.setStyle("height", nodeHeight);

            var selectNodeHeight = nodeHeight - getOffsetY(this.selectNode);
            this.selectNode.setStyle("height", selectNodeHeight);

            if( this.shuttleNode ){
                this.shuttleNode.setStyle("height", selectNodeHeight);
                var shuttleInnerHieght = getOffsetY( this.shuttleInnerNode ) + this.shuttleInnerNode.getStyle("height").toInt();
                this.shuttleInnerNode.setStyle("margin-top", (selectNodeHeight-shuttleInnerHieght)/2 +"px" )
            }

            var itemAreaScrollNodeHeight = selectNodeHeight - getOffsetY( this.searchInputDiv ) - this.searchInputDiv.getStyle("height").toInt();
            if( !this.options.searchbarInTopNode && this.selectTopNode ){
                itemAreaScrollNodeHeight = itemAreaScrollNodeHeight - getOffsetY( this.selectTopNode ) - this.selectTopNode.getStyle("height").toInt();
            }
            if(this.letterAreaNode && this.letterAreaNode.offsetParent){
                itemAreaScrollNodeHeight = itemAreaScrollNodeHeight - getOffsetY( this.letterAreaNode ) - this.letterAreaNode.getStyle("height").toInt();
            }
            itemAreaScrollNodeHeight = itemAreaScrollNodeHeight - getOffsetY( this.itemAreaScrollNode );
            this.itemAreaScrollNode.setStyle("height", itemAreaScrollNodeHeight);

            if( this.itemSearchAreaScrollNode ){
                this.itemSearchAreaScrollNode.setStyle("height", itemAreaScrollNodeHeight);
            }

            var selectedContainerNodeHeight = nodeHeight - getOffsetY(this.selectedContainerNode);
            this.selectedContainerNode.setStyle("height", selectedContainerNodeHeight);

            var selectedScrollNodeHeight = selectedContainerNodeHeight;
            if( this.selectedTopNode ) {
                selectedScrollNodeHeight = selectedScrollNodeHeight - getOffsetY(this.selectedTopNode) - this.selectedTopNode.getStyle("height").toInt();
            }
            if( !this.options.searchbarInTopNode && this.selectedSearchInputDiv ){
                selectedScrollNodeHeight = selectedScrollNodeHeight - getOffsetY( this.selectedSearchInputDiv ) - this.selectedSearchInputDiv.getStyle("height").toInt();
            }
            this.selectedScrollNode.setStyle("height", selectedScrollNodeHeight);
        }
        this.fireEvent("setSize",[this])
    },


    addFlatCategoryItem : function( categoryItemNode, hasChildrenItem, itemNodeContainer, isCreateSubCategoryListNode ){
        if(!this.flatSubCategoryNodeList)this.flatSubCategoryNodeList = [];
        if( hasChildrenItem )this.flatSubCategoryNodeList.push( categoryItemNode );
        if( !this.isFlatCategoryLoaded && this.flatSubCategoryNodeList.length > 1  ){
            this.flatCategoryScrollNode.show();
            this.flatCategoryScrollNode.setStyles( this.css.flatCategoryScrollNode );

            var height = this.itemAreaScrollNode.getStyle("height").toInt();
            this.flatCategoryScrollNode.setStyle("height", ""+height+"px");

            this.flatCategoryNode.setStyles( this.css.flatCategoryNode );
            this.isFlatCategoryLoaded = true;
            this.itemAreaScrollNode.setStyles( this.css.itemAreaScrollNode_flatCategory );
            //alert(this.flatSubCategoryNodeList[0].outerHTML)
        }
        if( hasChildrenItem )categoryItemNode.inject( itemNodeContainer || this.flatCategoryNode );
        var subCategoryListNode;
        if( isCreateSubCategoryListNode ){
            subCategoryListNode = new Element("div.subCategoryListNode").inject( itemNodeContainer || this.flatCategoryNode );
        }
        //this.setFlatCategorySequence(categoryItemNode, itemNodeContainer, subCategoryListNode);

        if( hasChildrenItem ){
            //if( this.checkClickFlatCategoryItem(categoryItemNode, itemNodeContainer) ){
            //    categoryItemNode.click();
            //}
            if( !this.currentCategoryItemNode ){
                categoryItemNode.click();
                this.currentCategoryItemNode = categoryItemNode
            }else{
                //var date = new Date();
                var first = this.flatCategoryNode.getElement(".flatCategoryItemNode");
                //if(first)console.log(first.get("title"));
                //console.log(new Date() - date );
                //console.log("      " );
                if( first ){
                    var dn1 = first.retrieve("dn");
                    var dn2 = this.currentCategoryItemNode.retrieve("dn");
                    if( dn1 && dn2 ){
                        if( dn1 != dn2 ){
                            categoryItemNode.click();
                            this.currentCategoryItemNode = categoryItemNode
                        }
                    }else{
                        var title1 = first.get("title");
                        var title2 = this.currentCategoryItemNode.get("title");
                        if( title1 && title1 ){
                            if( title1 != title2 ){
                                categoryItemNode.click();
                                this.currentCategoryItemNode = categoryItemNode
                            }
                        }else{
                            var text1 = first.get("text");
                            var text2 = this.currentCategoryItemNode.get("text");
                            if( text1 != text2 ){
                                categoryItemNode.click();
                                this.currentCategoryItemNode = categoryItemNode
                            }
                        }
                    }
                }
            }
        }

        return subCategoryListNode;
    },
    isCheckStatusOrCount: function(){
        if( this.isCheckStatusFlag )return this.isCheckStatusFlag === "y";
        if( this.availableStatusTypes.contains(this.selectType) &&
                ( this.options.count.toInt() !== 1)  && (this.options.resultType !== "person") &&
                ( this.options.showSelectedCount || this.options.isCheckStatus ) ){

            if( this.selectType === "unit" ){
                if( this.options.expandSubEnable ){
                    this.isCheckStatusFlag = "y";
                    return true;
                }else{
                    this.isCheckStatusFlag = "n";
                    return false;
                }
            }else{
                this.isCheckStatusFlag = "y";
                return true;
            }
        }else{
            this.isCheckStatusFlag = "n";
            return false;
        }
    },
    checkCountAndStatus: function(){
        if( this.subCategorys && this.subCategorys.length ){
            this.subCategorys.each(function (category) {
                if(category.checkCountAndStatus)category.checkCountAndStatus(true);
            })
        }
    },
    addSelectedCount: function( itemOrItemSelected, count ){

    }
    //checkClickFlatCategoryItem : function(categoryItemNode, itemNodeContainer){
    //    if( !this.flatCategorySeqObj_current ){
    //        this.flatCategorySeqObj_current = categoryItemNode.retrieve("seq");
    //        //console.log(this.flatCategorySeqObj_current)
    //        return true;
    //    }
    //    var seq_cur = this.flatCategorySeqObj_current;
    //    var seq = categoryItemNode ? categoryItemNode.retrieve("seq") : [];
    //    for( var i=0; i<seq.length; i++ ){
    //        if( seq_cur[i] && seq[i] < seq_cur[i] ){
    //            //console.log(seq)
    //            this.flatCategorySeqObj_current = seq;
    //            return true;
    //        }else if( !seq_cur[i] || seq[i] > seq_cur[i] ){
    //            return false;
    //        }
    //    }
    //    return false;
    //},
    //setFlatCategorySequence: function(categoryItemNode, itemNodeContainer, subCategoryListNode){
    //    if( !this.flatCategorySeqObj )this.flatCategorySeqObj = {};
    //    var parentSeq = itemNodeContainer ? itemNodeContainer.retrieve("seq") : [];
    //    var seq = Array.clone( parentSeq );
    //    if( this.flatCategorySeqObj[ parentSeq.length ] ){
    //        seq.push( this.flatCategorySeqObj[ parentSeq.length ] + 1 );
    //        this.flatCategorySeqObj[parentSeq.length] = this.flatCategorySeqObj[parentSeq.length]+1;
    //
    //        categoryItemNode.store( "seq", seq );
    //        categoryItemNode.set( "seq", seq );
    //
    //        if(subCategoryListNode){
    //            seq = Array.clone( seq );
    //            seq[ seq.length - 1 ] = seq[ seq.length - 1 ]+1;
    //            this.flatCategorySeqObj[parentSeq.length] = this.flatCategorySeqObj[parentSeq.length]+1;
    //            subCategoryListNode.store("seq", seq );
    //            subCategoryListNode.set( "seq", seq );
    //        }
    //    }else{
    //        seq.push( 1 );
    //        this.flatCategorySeqObj[ parentSeq.length ] = 1;
    //        categoryItemNode.store( "seq", seq );
    //        categoryItemNode.set( "seq", seq );
    //
    //        if(subCategoryListNode) {
    //            seq = Array.clone(seq);
    //            seq[seq.length - 1] = seq[seq.length - 1]+1;
    //            this.flatCategorySeqObj[parentSeq.length] = this.flatCategorySeqObj[parentSeq.length]+1;
    //            subCategoryListNode.store("seq", seq);
    //            subCategoryListNode.set("seq", seq);
    //        }
    //    }
    //}
});

MWF.xApplication.Selector.Person.Item = new Class({
    initialize: function(data, selector, container, level, category, delay){
        this.clazz = "Item";
        this.data = data;
        this.selector = selector;
        this.container = container;
        this.isSelected = false;
        this.level = (level) ? level.toInt() : 1;
        this.category = category;
        this.subItems = [];
        this.subCategorys = [];
        this.subCategoryMap = {};
        this.subCategoryMapWithDuty = {};
        // if(!delay)this.load();
        if(delay){
            this.placeholderNode = new Element("div").inject(this.container);
        }else{
            this.load();
        }
    },
    _getShowName: function(){
        return this.data.name + ( this.data.employee ? ("("+this.data.employee+")") : "" );
    },
    _getTtiteText: function(){
        return this.data.name + ( this.data.employee ? ("("+this.data.employee+")") : "" );
    },
    _setIcon: function(){
        var style = this.selector.options.style;
        this.iconNode.setStyle("background-image", "url("+"../x_component_Selector/$Selector/"+style+"/icon/personicon.png)");
    },
    load: function(){
        if( this.clazz === "Item" ){
            this.selector.fireEvent("queryLoadItem",[this]);
        }else if( this.clazz === "ItemSelected" ){
            this.selector.fireEvent("queryLoadItemSelected",[this]);
        }

        if( !this.node ){
            this.node = new Element("div", {
                "styles": this.selector.css.selectorItem
            });
            if(this.placeholderNode){
                this.node.inject( this.placeholderNode, "before");
                this.placeholderNode.destroy();
                this.placeholderNode = null;
            }else{
                this.node.inject(this.container);
            }
        }

        this.levelNode = new Element("div", {
            "styles": this.selector.css.selectorItemLevelNode
        }).inject(this.node);


        if( this.selector.selectType !== "identity" || this.selector.options.identityItemWidth === 0 ) {
            var indent = this.selector.options.level1Indent + (this.level - 1) * this.selector.options.indent;
            this.levelNode.setStyle("width", "" + indent + "px");
        }

        this.iconNode = new Element("div", {
            "styles": this.selector.css.selectorItemIconNode
        }).inject(this.node);
        this._setIcon();

        this.actionNode = new Element("div", {
            "styles": this.selector.css.selectorItemActionNode
        }).inject(this.node);
        if( ( this.selector.options.count.toInt() === 1 || this.selector.options.noSelectedContainer ) && this.selector.css.selectorItemActionNode_single  ){
            this.actionNode.setStyles( this.selector.css.selectorItemActionNode_single );
        }

        this.textNode = new Element("div", {
            "styles": this.selector.css.selectorItemTextNode,
            "text": this._getShowName(),
            "title": this._getTtiteText()
        }).inject(this.node);
        this.textNode.store("indent", indent);
        var m = this.textNode.getStyle("margin-left").toFloat()+indent;
        this.textNode.setStyle("margin-left", ""+m+"px");

        if( this.selector.options.identityItemWidth && this.selector.selectType === "identity"){
            this.node.setStyles({
                "float" : "left",
                "min-width" : this.selector.options.identityItemWidth + "px"
            })
        }

        if(this.postLoad)this.postLoad();

        this.loadSubItem();

        this.setEvent();

        this.check();

        if( this.clazz === "Item" ) {
            this.selector.fireEvent("postLoadItem", [this]);
        }else if( this.clazz === "ItemSelected" ){
            this.selector.fireEvent("postLoadItemSelected",[this]);
        }
    },
    loadSubItem: function(){},
    disable : function(){
      this.node.hide();
      this.disabled = true;
    },
    enable : function(){
        this.node.show();
        this.disabled = false;
    },
    check: function(){
        //if (this.selector.options.count.toInt()===1){
        //    this.checkSelectedSingle();
        //}else{
        this.checkSelected();
        //}
    },
    checkSelectedSingle: function(){
        var selectedItem = this.selector.options.values.filter(function(item, index){
            if (typeOf(item)==="object") return this.data.distinguishedName === item.distinguishedName;
            if (typeOf(item)==="string") return this.data.distinguishedName === item;
            return false;
        }.bind(this));
        if (selectedItem.length){
            this.selectedSingle();
        }
    },
    checkSelected: function(){
        var selectedItem = this.selector.selectedItems.filter(function(item, index){
            return item.data.distinguishedName === this.data.distinguishedName;
        }.bind(this));
        if (selectedItem.length){
            selectedItem[0].addItem(this);
            this.selectedItem = selectedItem[0];
            this.setSelected();
        }
    },
    checkTextNodeIndent : function( textNode, styles ){
        var indent = textNode.retrieve("indent");
        if( indent && styles && styles["margin-left"] ){
            var m = styles["margin-left"].toFloat()+indent;
            textNode.setStyle("margin-left", ""+m+"px");
        }
    },
    setSelected: function(){
        this.isSelected = true;
        if(this.node) {
            this.node.setStyles(this.selector.css.selectorItem_selected);

            this.textNode.setStyles(this.selector.css.selectorItemTextNode_selected);
            this.checkTextNodeIndent(this.textNode, this.selector.css.selectorItemTextNode_selected);

            this.actionNode.setStyles(this.selector.css.selectorItemActionNode_selected);
            if( this.selector.options.style === "flow" ){
                this.actionNode.addClass("o2icon-checkbox");
                if( this.selector.options.mainColorEnable )this.actionNode.addClass("mainColor_color");
            }
            if ((this.selector.options.count.toInt() === 1 || this.selector.options.noSelectedContainer) && this.selector.css.selectorItemActionNode_single_selected) {
                this.actionNode.setStyles(this.selector.css.selectorItemActionNode_single_selected);
            }
        }
        // if( this.category ){
        //     this.category.checkSelectAll();
        // }
    },
    setEvent: function(){
        this.node.addEvents({
            "mouseover": function(){
                this.overItem();
            }.bind(this),
            "mouseout": function(){
                this.outItem();
            }.bind(this),
            "click": function(){
                this.clickItem( null, true );
            }.bind(this)
        });
    },
    clickItem: function( callback, checkValid ){
        // if ( layout.mobile && this.selector.options.count.toInt()===1){
        //     this.selectedSingle( checkValid );
        // }else{
            if (this.isSelected){
                this.unSelected( checkValid);
            }else{
                this.selected( checkValid );
            }
        // }
    },
    overItem: function(){
        if (!this.isSelected ){
            this.node.setStyles(this.selector.css.selectorItem_over);
        }else if( this.selector.css.selectorItem_over_force ){
            this.node.setStyles(this.selector.css.selectorItem_over_force);
        }
        if (!this.isSelected){
            this.actionNode.setStyles(this.selector.css.selectorItemActionNode_over);
            if( ( this.selector.options.count.toInt() === 1 || this.selector.options.noSelectedContainer ) && this.selector.css.selectorItemActionNode_single_over  ){
                this.actionNode.setStyles( this.selector.css.selectorItemActionNode_single_over );
            }
        }else if( this.selector.css.selectorItemActionNode_over_force ){
            this.node.setStyles(this.selector.css.selectorItemActionNode_over_force);
        }
    },
    outItem: function(){
        if (!this.isSelected){
            this.node.setStyles(this.selector.css.selectorItem);
        }else if( this.selector.css.selectorItem_over_force ){
            this.node.setStyles(this.selector.css.selectorItem_selected);
        }
        if (!this.isSelected){
            this.actionNode.setStyles(this.selector.css.selectorItemActionNode);
            if( this.selector.options.style === "flow" ){
                this.actionNode.removeClass("o2icon-checkbox");
                if( this.selector.options.mainColorEnable )this.actionNode.removeClass("mainColor_color");
            }
            if( ( this.selector.options.count.toInt() === 1 || this.selector.options.noSelectedContainer ) && this.selector.css.selectorItemActionNode_single  ){
                this.actionNode.setStyles( this.selector.css.selectorItemActionNode_single );
            }
        }else if( this.selector.css.selectorItemActionNode_over_force ){
            this.actionNode.setStyles(this.selector.css.selectorItemActionNode_selected);
            if( this.selector.options.style === "flow" ){
                this.actionNode.addClass("o2icon-checkbox");
                if( this.selector.options.mainColorEnable )this.actionNode.addClass("mainColor_color");
            }
            if( ( this.selector.options.count.toInt() === 1 || this.selector.options.noSelectedContainer ) && this.selector.css.selectorItemActionNode_single_selected  ){
                this.actionNode.setStyles( this.selector.css.selectorItemActionNode_single_selected );
            }
        }
    },
    selectedSingle: function( checkValid ){
        if (!this.isSelected){
            if (this.selector.currentItem) this.selector.currentItem.unSelectedSingle();
            this.selector.emptySelectedItems();
            this.getData(function(){
                this.selector.currentItem = this;
                this.isSelected = true;

                this.selector.selectedItems.push(this);
                if(this.selector.addToSelectedItemsMap)this.selector.addToSelectedItemsMap(this.data, this);

                this.node.setStyles(this.selector.css.selectorItem_selected);

                this.textNode.setStyles(this.selector.css.selectorItemTextNode_selected);
                this.checkTextNodeIndent( this.textNode, this.selector.css.selectorItemTextNode_selected );

                this.actionNode.setStyles(this.selector.css.selectorItemActionNode_selected);
                if( this.selector.options.style === "flow" ){
                    this.actionNode.addClass("o2icon-checkbox");
                    if( this.selector.options.mainColorEnable )this.actionNode.addClass("mainColor_color");
                }
                if( ( this.selector.options.count.toInt() === 1 || this.selector.options.noSelectedContainer ) && this.selector.css.selectorItemActionNode_single_selected  ){
                    this.actionNode.setStyles( this.selector.css.selectorItemActionNode_single_selected );
                }

                this.selector.fireEvent("selectItem",[this]);
                if( checkValid )this.selector.fireEvent("valid", [this.selector, this]);

            }.bind(this));
        }else {
            this.selector.emptySelectedItems();
            this.unSelectedSingle( checkValid );
        }
    },
    getData: function(callback){
        if (callback) callback();
    },
    unSelectedSingle: function(checkValid){
        this.selector.currentItem = null;
        this.isSelected = false;
        this.selector.selectedItems.erase(this);
        if(this.selector.deleteFromSelectedItemsMap)this.selector.deleteFromSelectedItemsMap(this.data);
        this.node.setStyles(this.selector.css.selectorItem);

        this.textNode.setStyles(this.selector.css.selectorItemTextNode);
        this.checkTextNodeIndent( this.textNode, this.selector.css.selectorItemTextNode );

        this.actionNode.setStyles(this.selector.css.selectorItemActionNode);
        if( ( this.selector.options.count.toInt() === 1 || this.selector.options.noSelectedContainer ) && this.selector.css.selectorItemActionNode_single  ){
            this.actionNode.setStyles( this.selector.css.selectorItemActionNode_single );
        }
        this.selector.fireEvent("unselectItem",[this]);
        if( checkValid )this.selector.fireEvent("valid", [this.selector, this]);
    },
    selected: function( checkValid, callback, selectedNode, bySelectAll ){
        var count = this.selector.options.maxCount || this.selector.options.count;
        count = count.toInt();
        if (!count) count = 0;
        if( count == 1 && this.selector.emptySelectedItems){
            this.selector.emptySelectedItems();
        }
        if ((count===0) || (this.selector.selectedItems.length+1)<=count) {
            this.isSelected = true;
            if( this.node ){
                this.node.setStyles(this.selector.css.selectorItem_selected);

                this.textNode.setStyles(this.selector.css.selectorItemTextNode_selected);
                this.checkTextNodeIndent( this.textNode, this.selector.css.selectorItemTextNode_selected );

                this.actionNode.setStyles(this.selector.css.selectorItemActionNode_selected);
                if( this.selector.options.style === "flow" ){
                    this.actionNode.addClass("o2icon-checkbox");
                    if( this.selector.options.mainColorEnable )this.actionNode.addClass("mainColor_color");
                }
                if( ( this.selector.options.count.toInt() === 1 || this.selector.options.noSelectedContainer ) && this.selector.css.selectorItemActionNode_single_selected  ){
                    this.actionNode.setStyles( this.selector.css.selectorItemActionNode_single_selected );
                }
            }
            this.selectedItem = this.selector._newItemSelected(this.data, this.selector, this, selectedNode);
            // this.selectedItem.check();
            this.selector.selectedItems.push(this.selectedItem);
            if(this.selector.addToSelectedItemsMap)this.selector.addToSelectedItemsMap(this.data, this.selectedItem);

            // if( this.category ){
            //     this.category.checkSelectAll();
            // }

            this.selector.fireEvent("selectItem",[this]);
            if( checkValid )this.selector.fireEvent("valid", [this.selector, this]);
            if(callback)callback();
        }else{
            MWF.xDesktop.notice("error", {x: "right", y:"top"}, MWF.SelectorLP.selectItemMaxText.replace("{count}", count) , this.node);
        }
    },
    unSelected: function( checkValid, callback ){
        var isSelected = this.isSelected;
        this.isSelected = false;
        if( this.node ){
            this.node.setStyles(this.selector.css.selectorItem);

            this.textNode.setStyles(this.selector.css.selectorItemTextNode);
            this.checkTextNodeIndent( this.textNode, this.selector.css.selectorItemTextNode );

            this.actionNode.setStyles(this.selector.css.selectorItemActionNode);
            if( this.selector.options.style === "flow" ){
                this.actionNode.removeClass("o2icon-checkbox");
                if( this.selector.options.mainColorEnable )this.actionNode.removeClass("mainColor_color");
            }
            if( ( this.selector.options.count.toInt() === 1 || this.selector.options.noSelectedContainer ) && this.selector.css.selectorItemActionNode_single  ){
                this.actionNode.setStyles( this.selector.css.selectorItemActionNode_single );
            }
        }

        if( this.category && this.selector.options.selectAllRange !== "all" ){
            this.category.checkUnselectAll();
        }

        if( this.selector.searchItems && this.selector.searchItems.length ){
            this.selector.searchItems.each( function(itemSearch){
                var sd = itemSearch.data;
                var d = this.data;
                if(
                    ( sd.distinguishedName && (sd.distinguishedName === d.distinguishedName) ) ||
                    ( sd.id && (sd.id === d.id) ) ||
                    ( sd.unique && (sd.unique === d.unique) ) ||
                    ( sd.employee && (sd.employee === d.employee) ) ||
                    ( sd.levelName && (sd.levelName === d.levelName) )
                ){
                    itemSearch.isSelected = false;
                    itemSearch.node.setStyles(this.selector.css.selectorItem);

                    itemSearch.textNode.setStyles(this.selector.css.selectorItemTextNode);
                    this.checkTextNodeIndent( itemSearch.textNode, this.selector.css.selectorItemTextNode );

                    itemSearch.actionNode.setStyles(this.selector.css.selectorItemActionNode);
                    if( this.selector.options.style === "flow" ){
                        this.actionNode.removeClass("o2icon-checkbox");
                        if( this.selector.options.mainColorEnable )this.actionNode.removeClass("mainColor_color");
                    }
                    if( ( this.selector.options.count.toInt() === 1 || this.selector.options.noSelectedContainer ) && this.selector.css.selectorItemActionNode_single  ){
                        itemSearch.actionNode.setStyles( this.selector.css.selectorItemActionNode_single );
                    }
                }
            }.bind(this))
        }


        var countItems = [];
        if (this.selectedItem){
            this.selector.selectedItems.erase(this.selectedItem);
            if(this.selector.deleteFromSelectedItemsMap)this.selector.deleteFromSelectedItemsMap(this.selectedItem.data);

            if( this.selector.isCheckStatusOrCount()){
                this.selectedItem.items.each(function(item){
                    if( item.isSelected || ( item === this && isSelected ) ){
                        countItems.push(item);
                    }
                }.bind(this));
            }else if( this.selector.options.selectAllRange === "all" ){
                this.selectedItem.items.each(function(item) {
                    if (item.isSelected || (item === this && isSelected)) {
                        if (item.category && item.category._addSelectAllSelectedCount) item.category._addSelectAllSelectedCount(-1, true);
                    }
                }.bind(this))
           }

            this.selectedItem.items.each(function(item){

                if (item != this){
                    item.isSelected = false;
                    item.node.setStyles(this.selector.css.selectorItem);

                    item.textNode.setStyles(this.selector.css.selectorItemTextNode);
                    this.checkTextNodeIndent( item.textNode, this.selector.css.selectorItemTextNode );

                    item.actionNode.setStyles(this.selector.css.selectorItemActionNode);
                    if( this.selector.options.style === "flow" ){
                        this.actionNode.removeClass("o2icon-checkbox");
                        if( this.selector.options.mainColorEnable )this.actionNode.removeClass("mainColor_color");
                    }
                    if( ( this.selector.options.count.toInt() === 1 || this.selector.options.noSelectedContainer ) && this.selector.css.selectorItemActionNode_single  ){
                        item.actionNode.setStyles( this.selector.css.selectorItemActionNode_single );
                    }
                }
            }.bind(this));

            this.selectedItem.destroy();
            this.selectedItem = null;
        }

        if( this.selector.isCheckStatusOrCount()){
            this.selector.addSelectedCount( this, -1, countItems );
        }

        this.selector.fireEvent("unselectItem",[this]);
        if( checkValid )this.selector.fireEvent("valid", [this.selector, this]);
        if(callback)callback();
    },
    postLoad : function(){},
    getParentCategoryByLevel : function( level ){
        var category = this.category;
        do{
            if( category.level === level ){
                return category;
            }else{
                category = category.category;
            }
        }while( category )
    }
});

MWF.xApplication.Selector.Person.ItemSelected = new Class({
    Extends: MWF.xApplication.Selector.Person.Item,
    initialize: function(data, selector, item, selectedNode, delay){
        this.data = data;
        this.selector = selector;
        this.container = selectedNode || this.selector.selectedNode;
        this.isSelected = false;
        this.clazz = "ItemSelected";
        this.items = [];
        if (item) this.items.push(item);

        this.level = this.selector.options.style === "flow" ? 1 : 0;

        this.node = new Element("div", {
            "styles": this.selector.css.selectorItem
        }).inject(this.container);
        this.node.setStyle("display","none");

        if(this.data.isFromValues){
            this.isFromValues = true;
            this.data.isFromValues = false;
        }

        this.getData(function(){
            this.node.setStyle("display","");
            if(!delay){
                this.load();
            }else{
                this.check();
            }
        }.bind(this));
    },
    postLoad : function(){
        if( this.selector.css.selectorSelectedItemTextNode ){
            this.textNode.setStyles(this.selector.css.selectorSelectedItemTextNode);
        }
        if( layout.mobile && !this.selector.contentUrl ){
            this.actionNode.set("text", MWF.SelectorLP.remove );
            if( this.selector.css.selectedItemActionNodeMobile ){
                this.actionNode.setStyles( this.selector.css.selectedItemActionNodeMobile );
            }
            if( this.selector.css.selectorItemMobile ){
                this.node.setStyles( this.selector.css.selectorItemMobile );
            }
        }else if( this.selector.css.selectorSelectedItemActionNode ){
            this.actionNode.setStyles( this.selector.css.selectorSelectedItemActionNode );
            if( ( this.selector.options.count.toInt() === 1 || this.selector.options.noSelectedContainer ) && this.selector.css.selectorSelectedItemActionNode_single  ){
                this.actionNode.setStyles( this.selector.css.selectorSelectedItemActionNode_single );
            }
        }
    },
    getData: function(callback){
        if (callback) callback();
    },
    clickItem: function( callback, checkValid ){
        if( this.tooltip ){
            if( this.selector.tooltips )this.selector.tooltips.erase(this.tooltip);
            this.tooltip.destroy();
            this.tooltip = null;
        }
        if (this.items.length){
            var items = [], map = {};
            this.items.each(function(item){
                if( item.data.distinguishedName || item.data.unique ){
                    if( (!item.data.distinguishedName || !map[item.data.distinguishedName]) && ( !item.data.unique || !map[item.data.unique])){
                        items.push(item);
                        map[item.data.distinguishedName] = true;
                        map[item.data.unique] = true;
                    }
                }else{
                    items.push(item);
                }
            });
            items.each(function(item){
                item.unSelected( checkValid );
            });
            if( checkValid )this.selector.fireEvent("valid", [this.selector, this])
        }else{
            //this.item.selectedItem = null;
            //this.item.isSelected = false;

            if( this.selector.isCheckStatusOrCount()){
                this.selector.addSelectedCount( this, -1, [] );
            }

            this.destroy();
            this.selector.selectedItems.erase(this);
            if(this.selector.deleteFromSelectedItemsMap)this.selector.deleteFromSelectedItemsMap(this.data);
            if( checkValid )this.selector.fireEvent("valid", [this.selector, this])
        }
    },
    //overItem: function(){
    //    if (!this.isSelected){
    //        this.node.setStyles(this.selector.css.selectorItem_over);
    //        this.actionNode.setStyles(this.selector.css.selectorItemActionNode_selected_over);
    //    }
    //},
    overItem: function(){
        if( layout.mobile )return;
        if (!this.isSelected ){
            if( this.selector.css.selectorItem_selected_over ){
                this.node.setStyles(this.selector.css.selectorItem_selected_over);
            }else{
                this.node.setStyles(this.selector.css.selectorItem_over);
            }
            this.actionNode.setStyles(this.selector.css.selectorItemActionNode_selected_over);
            if( ( this.selector.options.count.toInt() === 1 || this.selector.options.noSelectedContainer ) && this.selector.css.selectorItemActionNode_single_selected_over  ){
                this.actionNode.setStyles( this.selector.css.selectorItemActionNode_single_selected_over );
            }
        }
    },
    outItem: function(){
        if( layout.mobile )return;
        if (!this.isSelected){
            var styles = this.selector.css.selectorSelectedItem || this.selector.css.selectorItem;
            this.node.setStyles(styles);
        }else if( this.selector.css.selectorItem_over_force ){
            this.node.setStyles(this.selector.css.selectorItem_selected);
        }
        if (!this.isSelected){
            var styles = this.selector.css.selectorSelectedItemActionNode || this.selector.css.selectorItemActionNode;
            this.actionNode.setStyles(styles);
            if( this.selector.options.style === "flow" ){
                this.actionNode.removeClass("o2icon-checkbox");
                if( this.selector.options.mainColorEnable )this.actionNode.removeClass("mainColor_color");
            }
            if( ( this.selector.options.count.toInt() === 1 || this.selector.options.noSelectedContainer ) &&
                ( this.selector.css.selectorSelectedItemActionNode_single || this.selector.css.selectorItemActionNode_single )  ){
                this.actionNode.setStyles( this.selector.css.selectorSelectedItemActionNode_single || this.selector.css.selectorItemActionNode_single );
            }
        }else if( this.selector.css.selectorItemActionNode_over_force ){
            this.actionNode.setStyles(this.selector.css.selectorItemActionNode_selected);
            if( this.selector.options.style === "flow" ){
                this.actionNode.addClass("o2icon-checkbox");
                if( this.selector.options.mainColorEnable )this.actionNode.addClass("mainColor_color");
            }
            if( ( this.selector.options.count.toInt() === 1 || this.selector.options.noSelectedContainer ) && this.selector.css.selectorItemActionNode_single_selected  ){
                this.actionNode.setStyles( this.selector.css.selectorItemActionNode_single_selected );
            }
        }
    },
    addItem: function(item){
        if (this.items.indexOf(item)===-1) this.items.push(item);
    },
    check: function(){
        if (this.selector.items.length){
            var items = this.selector.items.filter(function(item, index){
                return item.data.distinguishedName === this.data.distinguishedName;
            }.bind(this));
            this.items = items;
            if (items.length){
                items.each(function(item){
                    item.selectedItem = this;
                    item.setSelected();
                    // if( this.selector.options.showSelectedCount ){
                    //     if(item.category)item.category._addSelectedCount( 1, true );
                    // }
                }.bind(this));
            }
        }
        if( this.afterCheck )this.afterCheck();
    },
    destroy: function(){
        if(this.node){
            // var parent = this.node.getParent(".categorySelectedNode");
            // if( parent && !this.node.getPrevious() && !this.node.getNext() ){ //parent.getChildren().length <= 1
            //     parent.destroy();
            // }else{
                this.node.destroy();
            // }
        }
        delete this;
    }
});

MWF.xApplication.Selector.Person.ItemCategory = new Class({
    Extends: MWF.xApplication.Selector.Person.Item,
    initialize: function(data, selector, container, level, parentCategory, delay, notActive){
        this.data = data;
        this.selector = selector;
        this.container = container;
        this.isSelected = false;
        this.level = (level) ? level.toInt() : 1;
        this.category = parentCategory;
        this.subItems = [];
        this.subCategorys = [];
        this.subCategoryMap = {};
        this.subCategoryMapWithDuty = {};
        this.notActive = notActive;
        if(!delay)this.load();
    },
    load : function(){
        if( this.selector.isFlatCategory ){
            this.loadForFlat();
        }else if( !this.notActive ){
            this.loadForNormal();
        }else{
            this.createNode();
            // this.node.hide();
            this.children = new Element("div.children", {
                "styles": this.selector.css.selectorItemCategoryChildrenNode
            }).inject(this.node, "after");
            // this.children.hide();
        }
    },
    active: function(){
        this.notActive = false;
        this.node.show();
        this.children.show();
        this.loadForNormal();
    },
    loadForFlat : function(){
        this.selector.fireEvent("queryLoadCategory",[this]);

        //this.createNode();
        this.node = new Element("div.flatCategoryItemNode", {
            "styles": this.selector.css.flatCategoryItemNode,
            "title" : this._getTtiteText()
        });
        this.node.store( "category", this );
        this.node.store( "dn", this.data.distinguishedName );

        this.textNode = new Element("div", {
            "styles": this.selector.css.flatCategoryItemTextNode,
            "text": this._getShowName()
        }).inject(this.node);

        //var level = this.level;
        //var category = this;
        //while( category.category ){
        //    level =  category.category + "_" + level;
        //    category = category.category;
        //}


        this.children = new Element("div", {
            "styles": this.selector.css.selectorItemCategoryChildrenNode
        }).inject(this.selector.itemAreaNode); //this.container
        //if (!this.selector.options.expand)
        this.children.setStyle("display", "none");

        if( this.selector.options.selectAllEnable && this.selector.options.count.toInt()!==1 ){
            var selectAllWrap = new Element("div",{
                styles : this.selector.css.flatCategory_selectAllWrap
            }).inject(this.children);
            this.selectAllNode = new Element("div", {
                "styles": this.selector.css.flatCategory_selectAll,
                "text" : MWF.SelectorLP.selectAll
            }).inject(selectAllWrap);
            this.selectAllNode.addEvent( "click", function(ev){
                if( this.isSelectedAll ){
                    this.selector.options.selectAllRange === "all" ? this.unselectAllNested(ev, null, true ) : this.unselectAll(ev, null, true);
                    this.selector.fireEvent("unselectCatgory",[this]);
                    this.selector.fireEvent("unselectCatgeory",[this]);
                }else{
                    this.selector.options.selectAllRange === "all" ? this.selectAllNested(ev, true) : this.selectAll(ev, true);
                    this.selector.fireEvent("selectCatgory",[this]);
                    this.selector.fireEvent("selectCatgeory",[this]);
                }
                ev.stopPropagation();
            }.bind(this));
        }

        // var subIdList = this.selector._getChildrenItemIds(this.data);
        // if (subIdList){
        //     var count = subIdList.length;
        //     this.childrenHeight = count*this.selector.options.itemHeight;
        //     this.children.setStyle("height", ""+this.childrenHeight+"px");
        // }
        //if (!this._hasChild()){
        //    this.textNode.setStyle("color", "#333");
        //}

        if( this.selectAllNode ){
            if( this.selector.options.selectAllRange === "direct" && !this._hasChildItem() ){
                this.selectAllNode.setStyle("display", "none");
            }
        }

        this.node.addEvents({
            //"mouseover": function(){
            //    if (!this.isSelected )this.node.setStyles(this.selector.css.flatCategoryItemNode_over );
            //}.bind(this),
            //"mouseout": function(){
            //    if (!this.isSelected )this.node.setStyles(this.selector.css.flatCategoryItemNode );
            //}.bind(this),
            "click": function(){
                if( this.selector.currentFlatCategory === this )return;
                if( this.selector.currentFlatCategory ){
                    this.selector.currentFlatCategory.clickFlatCategoryItem(null, true); //取消原来选择的
                }
                this.selector.currentFlatCategory = this;
                this.clickFlatCategoryItem();
            }.bind(this)
        });
        //this.setEvent();

        var isCreateSubCategoryListNode = this._hasChildCategory ?  this._hasChildCategory() : true;
        var nodeContainer;
        if( this.nodeContainer ){
            nodeContainer = this.nodeContainer;
        }else{
            nodeContainer = (this.category &&  this.category.subCategoryListNode) ? this.category.subCategoryListNode : null;
        }
        this.subCategoryListNode = this.selector.addFlatCategoryItem( this.node, this._hasChildItem(), nodeContainer,  isCreateSubCategoryListNode );

        this.check();

        if( this.loadCategoryChildren )this.loadCategoryChildren();

        //this.afterLoad();
        this.selector.fireEvent("postLoadCategory",[this]);
    },
    loadForNormal : function(){
        this.selector.fireEvent("queryLoadCategory",[this]);
        if(!this.node)this.createNode();
        this.levelNode = new Element("div", {
            "styles": this.selector.css.selectorItemLevelNode
        }).inject(this.node);

        if(this.selector.selectType !== "identity" || this.selector.options.identityItemWidth === 0 ){
            var indent = this.selector.options.level1Indent + (this.level - 1) * this.selector.options.indent;
            this.levelNode.setStyle("width", "" + indent + "px");
        }else{
            this.node.setStyle("clear","both");
        }

        this.iconNode = new Element("div", {
            "styles": this.selector.css.selectorItemCategoryIconNode || this.selector.css.selectorItemIconNode
        }).inject(this.node);
        this._setIcon();

        this.actionNode = new Element("div", {
            "styles": (this.selector.options.expand) ? this.selector.css.selectorItemCategoryActionNode_expand : this.selector.css.selectorItemCategoryActionNode_collapse
        }).inject(this.node);
        if( this.selector.options.style === "flow" )this.actionNode.inject( this.iconNode, "before" );

        if( this.selector.options.selectAllEnable && this.selector.options.count.toInt()!==1 ){
            var selectAllNodeStyles = this.selector.css.selectorItemCategoryActionNode_selectAll;
            if( this.isSelectedAll ){
                if( this.selector.isFlatCategory ){
                    selectAllNodeStyles = this.selector.css.flatCategory_selectAll_selected;
                }else if( this.selector.css.selectorItemCategoryActionNode_selectAll_selected ){
                    selectAllNodeStyles = this.selector.css.selectorItemCategoryActionNode_selectAll_selected;
                }
            }
            this.selectAllNode = new Element("div", {
                "styles": selectAllNodeStyles,
                "title" : MWF.SelectorLP.selectChildren
            }).inject(this.node);
            this.selectAllNode.addEvent( "click", function(ev){
                if( this.isSelectedAll ){
                    // this.unselectAll(ev);
                    this.selector.options.selectAllRange === "all" ? this.unselectAllNested(ev, null, true ) : this.unselectAll(ev, null, true);
                    this.selector.fireEvent("unselectCatgory",[this]);
                    this.selector.fireEvent("unselectCategory",[this]);
                }else{
                    // this.selectAll(ev);
                    if( this.selector.options.selectAllRange === "all" ){
                        var node = new Element("div.categorySelectedNode").inject( this.selector.selectedNode );
                        this.selectAllNested(ev, true, node );
                    }else{
                        this.selectAll(ev, true)
                    }
                    this.selector.fireEvent("selectCatgory",[this]);
                    this.selector.fireEvent("selectCategory",[this]);
                }
                ev.stopPropagation();
            }.bind(this));
            if( this.selector.css.selectorItemCategoryActionNode_selectAll_over ){
                this.selectAllNode.addEvents( {
                    "mouseover" : function(ev){
                        if( !this.isSelectedAll && !this.isSelectedSome )this.selectAllNode.setStyles( this.selector.css.selectorItemCategoryActionNode_selectAll_over );
                        //ev.stopPropagation();
                    }.bind(this),
                    "mouseout" : function(ev){
                        if( !this.isSelectedAll && !this.isSelectedSome )this.selectAllNode.setStyles( this.selector.css.selectorItemCategoryActionNode_selectAll );
                        //ev.stopPropagation();
                    }.bind(this)
                })
            }
        }

        this.textNode = new Element("div", {
            "styles": this.selector.css.selectorItemCategoryTextNode,
            "text": this._getShowName()
        }).inject(this.node);
        var m = this.textNode.getStyle("margin-left").toFloat()+indent;
        this.textNode.setStyle("margin-left", ""+m+"px");

        if( this.selector.options.showSelectedCount && this.selector.availableStatusTypes.contains(this.selector.selectType) ){
            this.selectedCountNode = new Element("span").inject(this.textNode);
        }

        if(!this.children)this.children = new Element("div.children", {
            "styles": this.selector.css.selectorItemCategoryChildrenNode
        }).inject(this.node, "after");
        if (!this.selector.options.expand) this.children.setStyle("display", "none");

        if( this.selector.options.expandEmptyCategory && !this._hasChildItem() ){ //点击允许展开空分类
            this.children.hide();
            this.actionNode.setStyles(this.selector.css.selectorItemCategoryActionNode_collapse);
            this.isExpand = false;
        }else{
            var subIdList = this.selector._getChildrenItemIds(this.data);
            if (subIdList){
                var count = subIdList.length;
                this.childrenHeight = count*this.selector.options.itemHeight;
                this.children.setStyle("height", ""+this.childrenHeight+"px");
            }

            if(this.selector.options.identityItemWidth && this.selector.selectType === "identity"){
                var indent = this.level === 0 ? this.selector.options.level1Indent : this.selector.options.indent;
                this.children.setStyles({
                    "padding-left": "" + indent + "px",
                    "overflow" : "hidden"
                });
            }

            if ( !this._hasChild()){
                if( this.selector.options.hiddenEmptyCategory ){
                    this.node.hide()
                }else{
                    if( this.selector.options.style === "flow" ){
                        this.node.setStyles({
                            "opacity": "0.5",
                            "cursor": "default"
                        });
                    }else{
                        this.actionNode.setStyle("background", "transparent");
                        this.textNode.setStyle("color", "#777");
                    }
                }
            }

            if( this.selectAllNode ){
                if( this.selector.options.selectAllRange === "direct" && !this._hasChildItem() ){
                    this.selectAllNode.setStyle("display", "none");
                }
            }
        }

        this.setEvent();

        this.check();

        this.afterLoad();
        this.selector.fireEvent("postLoadCategory",[this]);
    },
    createNode: function(){
        this.node = new Element("div", {
            "styles": this.selector.css.selectorItemCategory,
            "title" : this._getTtiteText()
        }).inject(this.container);
    },
    setEvent: function(){
        this.node.addEvents({
            "mouseover": function(){
                this.overItem();
            }.bind(this),
            "mouseout": function(){
                this.outItem();
            }.bind(this),
            "click": function(){
                this.clickItem();
            }.bind(this)
        });
    },
    unselectAll : function(ev, exclude, checkValid ){
        var fun = function(){
            var excludeList = exclude || [];
            if( exclude && typeOf(exclude) !== "array"  )excludeList = [exclude];
            ( this.subItems || [] ).each( function(item){
                if(item.isSelected && !excludeList.contains(item) ){
                    item.unSelected( checkValid );
                }
            }.bind(this));

            if( this.selectAllNode ){
                if( this.selector.isFlatCategory ){
                    this.selectAllNode.setStyles( this.selector.css.flatCategory_selectAll );
                }else if(this.selector.css.selectorItemCategoryActionNode_selectAll){
                    this.selectAllNode.setStyles( this.selector.css.selectorItemCategoryActionNode_selectAll );
                }
            }
            this.isSelectedAll = false;
        }.bind(this);

        if( this.loaded ){
            fun();
        }else{
            this.clickItem( function(){
                fun();
            }.bind(this))
        }
    },
    unselectAllNested : function( ev, exclude, checkValid ){
        this.unselectAll(ev, exclude, checkValid);
        if( this.subCategorys && this.subCategorys.length ){
            this.subCategorys.each( function( category ){
                category.unselectAllNested( ev, exclude, checkValid )
            })
        }
    },
    selectAllNested : function( ev, checkValid, selectedNode, notActive ){
        var node;
        if(selectedNode)node = new Element("div.categorySelectedNode").inject( selectedNode );

        this.selectAll(ev, checkValid, node, function () {
            if( this.subCategorys && this.subCategorys.length ){
                this.subCategorys.each( function( category ){
                    if(selectedNode)var node = new Element("div.categorySelectedNode").inject( selectedNode );
                    category.selectAllNested(ev, checkValid, node, notActive)
                })
            }
        }.bind(this), notActive);
    },
    selectAll: function(ev, checkValid, selectedNode, callback, notActive){
        if( this.loaded || this.selector.isFlatCategory ){
            this._selectAll( ev, checkValid, selectedNode, notActive );
            if(callback)callback();
        }else{
            this.clickItem( function(){
                this._selectAll( ev, checkValid, selectedNode, notActive );
                if(callback)callback();
                //this.children.setStyles({
                //    "display": "none",
                //    "height": "0px"
                //});
                //this.actionNode.setStyles(this.selector.css.selectorItemCategoryActionNode_collapse);
            }.bind(this), notActive);
        }
    },
    _selectAll : function( ev, checkValid, selectedNode, notActive ){
        if( this.selector.options.selectAllRange === "direct" && ( !this.subItems || !this.subItems.length ) )return;
        var count = this.selector.options.maxCount || this.selector.options.count;
        if (!count) count = 0;
        var selectedSubItemCount = 0;
        this.subItems.each( function(item){
            if(item.isSelected)selectedSubItemCount++
        }.bind(this));
        if ((count.toInt()===0) || (this.selector.selectedItems.length+(this.subItems.length-selectedSubItemCount))<=count){
            var checkedCount = 0;

            var doSelectAll = function () {
                this.subItems.each( function(item){
                    if(!item.isSelected && !item.disabled )item.selected( false, function () {
                        checkedCount++;
                        if( this.subItems.length === checkedCount ){
                            if( checkValid )this.selector.fireEvent("valid", [this.selector, this]);
                        }
                    }.bind(this), selectedNode);
                }.bind(this));

                if( this.selectAllNode ){
                    if( this.selector.isFlatCategory ){
                        this.selectAllNode.setStyles( this.selector.css.flatCategory_selectAll_selected );
                    }else if(this.selector.css.selectorItemCategoryActionNode_selectAll_selected){

                        var styles = this.selector.css.selectorItemCategoryActionNode_selectAll_selected;

                        if( this.selector.options.isCheckStatus && this.selector.availableStatusTypes.contains(this.selector.selectType) ){
                            if( this._getSelectedCount() < this._getTotalCount() ){
                                styles = this.selector.css.selectorItemCategoryActionNode_selectsome_selected;
                            }
                        }
                        this.selectAllNode.setStyles( styles );
                    }
                }
                this.isSelectedAll = true;
            }.bind(this);

            if( this._beforeSelectAll ){
                this._beforeSelectAll( doSelectAll );
            }else{
                doSelectAll();
            }

        }else{
            MWF.xDesktop.notice("error", {x: "right", y:"top"}, MWF.SelectorLP.selectItemMaxText.replace("{count}", count), this.node);
        }
    },
    checkSelectAll : function(){
        if( this.isSelectedAll )return;
        if( !this.selectAllNode )return;
        if( !this.subItems )return;
        var isAllItemSelected = true;
        for( var i=0; i< this.subItems.length; i++ ){
            if( !this.subItems[i].isSelected ){
                isAllItemSelected = false;
                break;
            }
        }
        if( isAllItemSelected ){
            if( this.selector.isFlatCategory ){
                this.selectAllNode.setStyles( this.selector.css.flatCategory_selectAll_selected );
            }else if( this.selector.css.selectorItemCategoryActionNode_selectAll_selected ){
                this.selectAllNode.setStyles( this.selector.css.selectorItemCategoryActionNode_selectAll_selected );
            }
            this.isSelectedAll = true;
        }
    },
    checkUnselectAll : function(){
        if( !this.isSelectedAll )return;
        if( !this.selectAllNode )return;
        if( !this.subItems )return;
        var hasSelectedItem = false;
        for( var i=0; i< this.subItems.length; i++ ){
            if( this.subItems[i].isSelected ){
                hasSelectedItem = true;
                break;
            }
        }
        if( !hasSelectedItem ){
            if( this.selector.isFlatCategory ){
                this.selectAllNode.setStyles( this.selector.css.flatCategory_selectAll );
            }else if( this.selector.css.selectorItemCategoryActionNode_selectAll ){
                this.selectAllNode.setStyles( this.selector.css.selectorItemCategoryActionNode_selectAll );
            }
            this.isSelectedAll = false;
        }
    },
    afterLoad: function(){
        if (this.level===1) this.clickItem();
    },
    clickFlatCategoryItem : function( callback, hidden ){
        if (this._hasChildItem()){
            var display = this.children.getStyle("display");
            if( hidden ){
                this.children.setStyles({ "display": "none" });
                this.node.setStyles( this.selector.css.flatCategoryItemNode );
                this.isExpand = false;
            }else if (display === "none"){
                this.children.setStyles({
                    "display": "block",
                    "height": "auto"
                });
                this.node.setStyles( this.selector.css.flatCategoryItemNode_selected );
                this.isExpand = true;
            }else{
                this.children.setStyles({
                    "display": "none"
                });
                this.node.setStyles( this.selector.css.flatCategoryItemNode );
                this.isExpand = false;
            }
            if(callback)callback()
        }
    },
    clickItem: function( callback ){
        if (this._hasChild() || this.selector.options.expandEmptyCategory ){
            if (!this.fx){
                this.fx = new Fx.Tween(this.children, {
                    "duration": 200
//                "transition": Fx.Transitions.Cubic.easeIn
                });
            }
            if (!this.fx.isRunning()){
                var display = this.children.getStyle("display");
                if (display === "none"){
                    this.children.setStyles({
                        "display": "block",
                        "height": "0px"
                    });
                    this.fx.start("height", "0px", ""+this.childrenHeight+"px");
                    this.actionNode.setStyles(this.selector.css.selectorItemCategoryActionNode_expand);
                    this.isExpand = true;
                    this.selector.fireEvent("expand", [this] );
                }else{
                    if (!this.childrenHeight) this.childrenHeight = this.children.getStyle("height").toFloat();
                    this.fx.start("height", ""+this.childrenHeight+"px", "0px").chain(function(){
                        this.children.setStyles({
                            "display": "none",
                            "height": "0px"
                        });
                    }.bind(this));
                    this.actionNode.setStyles(this.selector.css.selectorItemCategoryActionNode_collapse);
                    this.isExpand = false;
                    this.selector.fireEvent("collapse", [this] );
                }
            }
            if(callback)callback()
        }
    },
    activeSub: function(){
        if(this.subItems) {
            this.subItems.each(function (item) {
                item.load()
            });
        }
        if(this.subCategorys)this.subCategorys.each(function(category){
            if(category.notActive)category.active();
        });
        this.subNotActive = false;
    },
    overItem: function(){
        //if (!this.isSelected){
        //    this.node.setStyles(this.selector.css.selectorItem_over);
        //    this.actionNode.setStyles(this.selector.css.selectorItemActionNode_over);
        //}
        if( this.selector.css.selectorItemCategory_over ){
            this.node.setStyles(this.selector.css.selectorItemCategory_over);
        }
        var display = this.children.getStyle("display");
        if( display === "none" ){
            if( this._hasChild() && this.selector.css.selectorItemCategoryActionNode_collapse_over ){
                this.actionNode.setStyles( this.selector.css.selectorItemCategoryActionNode_collapse_over )
            }
        }else{
            if( this._hasChild() && this.selector.css.selectorItemCategoryActionNode_expand_over ){
                this.actionNode.setStyles( this.selector.css.selectorItemCategoryActionNode_expand_over )
            }
        }

    },
    outItem: function(){
        //if (!this.isSelected){
        //    this.node.setStyles(this.selector.css.selectorItem);
        //    this.actionNode.setStyles(this.selector.css.selectorItemActionNode);
        //}
        if( this.selector.css.selectorItemCategory_over ){
            this.node.setStyles(this.selector.css.selectorItemCategory);
        }
        var display = this.children.getStyle("display");
        if( display === "none" ){
            if( this._hasChild() && this.selector.css.selectorItemCategoryActionNode_collapse_over ){
                this.actionNode.setStyles( this.selector.css.selectorItemCategoryActionNode_collapse )
            }
        }else{
            if( this._hasChild() && this.selector.css.selectorItemCategoryActionNode_expand_over ){
                this.actionNode.setStyles( this.selector.css.selectorItemCategoryActionNode_expand )
            }
        }
    },
    _hasChild: function(){
        var subIdList = this.selector._getChildrenItemIds(this.data);
        if (subIdList) if (subIdList.length) return true;
        return false;
    },
    _hasChildCategory: function(){
        return null;
    },
    _hasChildItem: function(){
        return this._hasChild();
    },
    _getTtiteText: function(){
        if( this.data.levelName ){
            return this.data.name+"("+ this.data.levelName +")";
        }else{
            return this.data.name;
        }
    },
    checkCountAndStatus: function( nestedSub ){
        var count = this._getSelectedCount();
        this._checkCountAndStatus(count);
        if( nestedSub && this.subCategorys && this.subCategorys.length){
            this.subCategorys.each(function(category){
                if( category.checkCountAndStatus )category.checkCountAndStatus(nestedSub);
            }.bind(this))
        }
    },
    _checkCountAndStatus: function( count ){
        if( this.selector.isCheckStatusOrCount() ){
            if(this.selectedCountNode){
                if( this.selector.options.showSelectedCount && this.selector.options.showAllCount ){
                    var totalCount = this._getTotalCount();
                    if(count || totalCount)this.selectedCountNode.set("text", (count||0)+"/"+ (totalCount||0));
                }else if(this.selector.options.showSelectedCount){
                    this.selectedCountNode.set("text", count ? "(" + count + ")" : "" );
                }else if(this.selector.options.showAllCount){
                    var totalCount = this._getTotalCount();
                    this.selectedCountNode.set("text", totalCount ? "(" + totalCount + ")" : "" );
                }
            }
            if( this.selector.options.isCheckStatus && this.selectAllNode ){
                var total = this._getTotalCount();
                if( total ){
                    var styles;
                    if( count >= total ){
                        styles = this.selector.css.selectorItemCategoryActionNode_selectAll_selected;
                        this.isSelectedSome = false;
                        this.isSelectedAll = true;
                    }else if( count > 0 ){
                        styles = this.selector.css.selectorItemCategoryActionNode_selectsome_selected;
                        this.isSelectedSome = true;
                        this.isSelectedAll = false;
                    }else{
                        styles = this.selector.css.selectorItemCategoryActionNode_selectAll;
                        this.isSelectedSome = false;
                        this.isSelectedAll = false;
                    }
                    this.selectAllNode.setStyles( styles );
                }
            }
        }else if( count === 0 && this.selector.options.selectAllRange === "all" && this.selectAllNode ){
            styles = this.selector.css.selectorItemCategoryActionNode_selectAll;
            this.isSelectedSome = false;
            this.isSelectedAll = false;
            this.selectAllNode.setStyles( styles );
        }

        // if( !this.selectedCountNode1 ){
        //     this.selectedCountNode1 = new Element("span").inject(this.textNode);
        // }
        // this.selectedCountNode1.set("text",count);
    }
})

MWF.xApplication.Selector.Person.ItemGroupCategory = new Class({
    Extends: MWF.xApplication.Selector.Person.ItemCategory,
    _getShowName: function(){
        return this.data.name;
    },
    _setIcon: function(){
        var style = this.selector.options.style;
        this.iconNode.setStyle("background-image", "url("+"../x_component_Selector/$Selector/"+style+"/icon/groupicon.png)");
    }
});

MWF.xApplication.Selector.Person.ItemRoleCategory = new Class({
    Extends: MWF.xApplication.Selector.Person.ItemCategory,
    _getShowName: function(){
        return this.data.name;
    },
    _setIcon: function(){
        var style = this.selector.options.style;
        this.iconNode.setStyle("background-image", "url("+"../x_component_Selector/$Selector/"+style+"/icon/roleicon.png)");
    }
});

MWF.xApplication.Selector.Person.Filter = new Class({
    Implements: [Options, Events],
    options: {
        "style": "default",
        "groups": [],
        "roles": []
    },
    initialize: function(value, options){
        this.setOptions(options);
        this.value = value;
        this.orgAction = MWF.Actions.get("x_organization_assemble_control");
    },
    filter: function(value, callback){
        this.value = value;
        var key = this.value;

        if (this.options.groups.length || this.options.roles.length) key = {"key": key, "groupList": this.options.groupList, "roleList": this.options.roleList};
        this.orgAction.listPersonByKey(function(json){
            data = json.data;
            if (callback) callback(data)
        }.bind(this), null, key);
    }
});

MWF.xApplication.Selector = MWF.xApplication.Selector || {};
MWF.xDesktop.requireApp("Selector", "Person", null, false);
MWF.xApplication.Selector.Identity = new Class({
    Extends: MWF.xApplication.Selector.Person,
    options: {
        "style": "default",
        "count": 0,
        "title": "",
        "units": [],
        "values": [],
        "dutys": [],
        "zIndex": 1000,
        "expand": false,
        "noUnit" : false,
        "include" : [], //增加的可选项
        "exclude" : [], //排除的可选项
        "resultType" : "", //可以设置成个人，那么结果返回个人
        "expandSubEnable" : true, //是否允许展开下一层,
        "selectAllEnable" : true,  //分类是否允许全选下一层
    },
    setInitTitle: function(){
        this.setOptions({"title": MWF.xApplication.Selector.LP.selectIdentity});
    },
    _init : function(){
        this.selectType = "identity";
        this.className = "Identity";
    },
    loadSelectItems : function(){
        this.itemsMap = {};
        // this.selectedItemsMap = {}; //所有已选项按dn或id

        if( this.options.disabled ){
            this.afterLoadSelectItem();
            return;
        }

        this._loadSelectItems();

        if( this.isCheckStatusOrCount() ) {
            this.loadingCount = "wait";
            this.loadCount();
        }
    },
    _loadSelectItems: function(addToNext){
        var afterLoadSelectItemFun = this.afterLoadSelectItem.bind(this);
        if( this.options.resultType === "person" ){
            if( this.titleTextNode ){
                this.titleTextNode.set("text", MWF.xApplication.Selector.LP.selectPerson );
            }else{
                this.options.title = MWF.xApplication.Selector.LP.selectPerson;
            }
        }
        if(this.options.noUnit){
            this.loadInclude(afterLoadSelectItemFun);
        }else if (this.options.units.length){
            var loadUnitSuccess = function () {
                this.unitLoaded = true;
                if( this.includeLoaded ){
                    afterLoadSelectItemFun();
                }
            }.bind(this);
            var loadUnitFailure = loadUnitSuccess;

            this.loadInclude( function () {
                this.includeLoaded = true;
                if( this.unitLoaded ){
                    afterLoadSelectItemFun();
                }
            }.bind(this));

            var unitList = [];
            for( var i=0 ; i<this.options.units.length; i++ ){
                var unit = this.options.units[i];
                if( typeOf( unit ) === "string" ){
                    unitList.push(unit);
                }else if( typeOf(unit)==="object"){
                    unitList.push( unit.distinguishedName || unit.unique || unit.levelName || unit.id);
                }
            }

            o2.Actions.load("x_organization_assemble_express").UnitAction.listObject( {"unitList" : unitList} , function (json) {
                if (json.data.length){
                    json.data.each( function(data){
                        var category = this._newItemCategory("ItemUnitCategory", data, this, this.itemAreaNode );
                        this.subCategorys.push(category);
                        this.subCategoryMap[data.levelName] = category;
                    }.bind(this));
                }
                loadUnitSuccess();
            }.bind(this), loadUnitFailure );

        }else{

            var load = function ( topUnit ) {
                topUnit.each(function(data){
                    if( !this.isExcluded( data ) ){
                        var category = this._newItemCategory("ItemUnitCategory", data, this, this.itemAreaNode);
                        this.subCategorys.push( category );
                        this.subCategoryMap[data.levelName] = category;
                    }
                }.bind(this));

                // this.unitLoaded = true;
                // if( this.includeLoaded ){
                afterLoadSelectItemFun();
                // }
            }.bind(this);

            if( this.topUnitObj ){
                load( this.topUnitObj );
            }else{
                this.orgAction.listTopUnit(function(json){
                    load( json.data );
                }.bind(this));
            }
        }
    },
    loadInclude: function(afterLoadFun) {
        if (!this.includeObject){
            this.includeObject = new MWF.xApplication.Selector.Identity.Include(this, this.itemAreaNode, {
                "include": this.options.include, //增加的可选项
                "resultType": this.options.resultType, //可以设置成个人，那么结果返回个人
                "expandSubEnable": this.options.expandSubEnable, //是否允许展开下一层
                "onAfterLoad" : afterLoadFun
            });
        }
        this.includeObject.load();
    },

    checkLoadSelectItems: function(){
        if (!this.options.units.length){
            this.loadSelectItems();
        }else{
            this.loadSelectItems();
        }
    },

    _scrollEvent: function(y){
        return true;
    },
    _getChildrenItemIds: function(){
        return null;
    },
    _newItemCategory: function(type, data, selector, item, level, category, delay, notActive){
        return new MWF.xApplication.Selector.Identity[type](data, selector, item, level, category, delay, notActive)
    },

    _listItem : function( filterType, callback, failure, key ){
        if( this.options.noUnit ){
            this.includeObject.listByFilter( filterType,  key, function( array ){
                var json = {"data" : array} ;
                if (callback) callback.apply(this, [json]);
            }.bind(this))
        }else{
            var action = filterType === "key" ? "listIdentityByKey" : "listIdentityByPinyin";
            if ( this.options.units.length ){
                key = this.getLikeKey( key, this.options.units );
                this.orgAction[action](function(json){ //搜若units内的组织
                    this.includeObject.listByFilter( filterType, key, function( array ){
                        json.data = array.concat( json.data || [] );
                        if (callback) callback.apply(this, [json]);
                    }.bind(this));
                }.bind(this), failure, key);
            }else{  //搜索所有人
                this.orgAction[action](function(json){
                    if (callback) callback.apply(this, [json]);
                }.bind(this), failure, key);
            }
        }
    },

    _listItemByKey: function(callback, failure, key){
        this._listItem( "key", callback, failure, key );
    },

    _getItem: function(callback, failure, id, async){
        this.orgAction.getIdentity(function(json){
            if (callback) callback.apply(this, [json]);
        }.bind(this), failure, ((typeOf(id)==="string") ? id : id.distinguishedName), async);
    },
    _newItemSelected: function(data, selector, item, selectedNode, delay){
        return new MWF.xApplication.Selector.Identity.ItemSelected(data, selector, item, selectedNode, delay)
    },
    _listItemByPinyin: function(callback, failure, key){
        this._listItem( "pinyin", callback, failure, key );
    },
    _newItem: function(data, selector, container, level, category, delay){
        return new MWF.xApplication.Selector.Identity.Item(data, selector, container, level, category, delay);
    },
    _newItemSearch: function(data, selector, container, level){
        return new MWF.xApplication.Selector.Identity.SearchItem(data, selector, container, level);
    },
    getLikeKey : function( key, unitObjects ){
        var unitObjects = unitObjects || [];
        var units = [];
        unitObjects.each(function(u){
            if (typeOf(u)==="string"){
                units.push(u);
            }
            if (typeOf(u)==="object"){
                units.push(u.distinguishedName);
            }
        });
        var keyObj = { "key": key, "unitList": units };

        if( !this.dutyDnList ){
            var dutyDnList = [];
            var dutyNameList = [];
            ( this.options.dutys || [] ).each(function(d){
                if (typeOf(d)==="string"){
                    var ds = d.split("@");
                    if( ds[ ds.length - 1].toUpperCase() === "UD" ){
                        dutyDnList.push( d )
                    }else{
                        dutyNameList.push( d );
                    }
                }
                if (typeOf(d)==="object"){
                    if( d.distinguishedName ){
                        dutyDnList.push(d.distinguishedName);
                    }else if( d.name ){
                        dutyNameList.push(d.name);
                    }
                }
            });
            if( dutyNameList.length ){
                o2.Actions.get("x_organization_assemble_express").listDutyWithName( { nameList : dutyNameList }, function(json){
                    if( json.data && json.data.unitDutyList ){
                        dutyDnList = dutyDnList.concat( json.data.unitDutyList )
                    }
                }.bind(this), null, false);
            }
            this.dutyDnList = dutyDnList;
        }
        if( this.dutyDnList.length )keyObj.unitDutyList = this.dutyDnList;

        return units.length ? keyObj : key;
    },

    loadCount: function(){

        var unitList = [];
        var groupList = [];

        var parseInclude = function () {
            if (this.options.include.length > 0) {
                this.options.include.each(function (d) {
                    var dn = typeOf(d) === "string" ? d : d.distinguishedName;
                    var flag = dn.split("@").getLast().toLowerCase();
                    if (flag === "u") {
                        unitList.push(dn);
                    } else if (flag === "g") {
                        groupList.push(dn)
                    }
                })
            }
        }.bind(this);

        var check = function () {
            this.loadingCount = "ready";
            this.checkCountAndStatus();
            this.loadingCount = "done";
        }.bind(this);

        if (this.options.noUnit) {
            parseInclude();
            this._loadUnitAndGroupCount(unitList, groupList, check);
        } else if (this.options.units.length) {
            parseInclude();
            this.options.units.each(function (u) {
                unitList.push(typeOf(u) === "string" ? u : (u.distinguishedName || u.unique || u.levelName || u.id))
            }.bind(this));
            this._loadUnitAndGroupCount(unitList, groupList, check);
        } else {
            this.orgAction.listTopUnit(function (json) {
                this.topUnitObj = json.data;
                this.topUnitObj.each(function (u) {
                    unitList.push(u.distinguishedName)
                }.bind(this));
                this._loadUnitAndGroupCount(unitList, groupList, check);
            }.bind(this))
        }
    },
    _loadUnitAndGroupCount: function(unitList, groupList, callback){

        if( !this.groupLevelNameListMap )this.groupLevelNameListMap = {};
        if( !this.groupAllLevelNameListMap )this.groupAllLevelNameListMap = {};

        this.hasGroupCategory = groupList && groupList.length > 0;

        var unitLoaded, groupLoaded, selectedIdentityLoaded, excludeIdentityLoaded;
        var unitTree, groupTree;
        this.unitExcludedIdentityCount = {};
        this.groupExcludedIdentityCount = {};
        this.unitSelectedIdentityCount = {};
        this.groupSelectedIdentityCount = {};

        var caculate = function () {
            if (unitLoaded && groupLoaded && selectedIdentityLoaded && excludeIdentityLoaded) {
                this.caculateNestedSubCount(unitTree, groupTree, function () {

                    if(callback)callback();

                }.bind(this))

            }
        }.bind(this);

        this.getIdentityCountMap(this.options.values, groupList && groupList.length > 0, function (result) {
            this.unitSelectedIdentityCount = result.unitMap;
            this.groupSelectedIdentityCount = result.groupMap;
            selectedIdentityLoaded = true;
            caculate();
        }.bind(this));

        this.getIdentityCountMap(this.options.exclude, groupList && groupList.length > 0, function (result) {
            this.unitExcludedIdentityCount = result.unitMap;
            this.groupExcludedIdentityCount = result.groupMap;
            excludeIdentityLoaded = true;
            caculate();
        }.bind(this));

        if (unitList && unitList.length > 0) {
            o2.Actions.load("x_organization_assemble_express").UnitAction.listWithUnitTree({"unitList": unitList}, function (json) {
                unitTree = json.data;
                unitLoaded = true;
                caculate();
            }.bind(this))
        } else {
            unitLoaded = true;
            caculate();
        }

        if (groupList && groupList.length > 0) {
            o2.Actions.load("x_organization_assemble_express").GroupAction.listWithGroupTree({"groupList": groupList}, function (json) {
                groupTree = json.data;
                groupLoaded = true;
                caculate();
            }.bind(this))
        } else {
            groupLoaded = true;
            caculate();
        }
    },
    getIdentityCountMap : function( identityList, byGroup, callback ){
        var result = {
            unitMap : {},
            groupMap : {}
        };
        if( byGroup ){
            this.listIdentityObjectWithGroup( identityList, function ( identityObjectList, groupLevelNameList ) {
                identityObjectList.each(function (id) {
                    if (id && id.unitLevelName) {
                        result.unitMap[id.unitLevelName] = (result.unitMap[id.unitLevelName] || 0) + 1;
                    }
                }.bind(this));
                groupLevelNameList.each(function(g){
                    result.groupMap[g] = (result.groupMap[g] || 0) + 1;
                })
                if( callback )callback( result );
            })
        }else{
            this.listIndentityObjectWithoutGroup( identityList, function ( identityObjectList ) {
                identityObjectList.each(function (id) {
                    if (id && id.unitLevelName) {
                        result.unitMap[id.unitLevelName] = (result.unitMap[id.unitLevelName] || 0) + 1;
                    }
                }.bind(this));
                if( callback )callback( result );
            })
        }
    },
    listIndentityObjectWithoutGroup : function( identityList, callback ){
        var list = [];
        identityList.each( function (d) {
            if( typeOf( d ) === "object"){
                if( !d.unitLevelName || !d.distinguishedName )list.push( d.distinguishedName || d.unique || d.id  )
            }else{
                list.push( d )
            }
        });
        if( list.length > 0 ){
            o2.Actions.load("x_organization_assemble_express").IdentityAction.listObject({ identityList : list }, function (json) {
                var map = {};
                json.data.each( function (d) { map[ d.matchKey ] =  d; });
                var identityObjectList = [];
                identityList.each( function (d) {
                    var key = typeOf( d ) === "object" ? ( d.distinguishedName || d.unique || d.id ) : d;
                    identityObjectList.push( map[key] ? map[key] : d );
                });
                if( callback )callback( identityObjectList );
            }.bind(this))
        }else{
            if( callback )callback( identityList );
        }
    },

    listIdentityObjectWithGroup: function(identityList, callback){
        if( identityList.length === 0 ){
            if( callback )callback( [], [] );
            return;
        }
        var list = identityList.map( function (d) {
            return typeOf( d ) === "object" ? (d.distinguishedName || d.unique || d.id ) : d;
        });
        o2.Actions.load("x_organization_assemble_express").IdentityAction.listObject({
            identityList : list, referenceFlag: true, recursiveFlag: true
        }, function (json) {
            var groupLevelNameList = [];
            json.data.each(function (d) {
                d.woGroupList.each(function (group) {
                    if(group.identityList.contains(d.id)){
                        groupLevelNameList = groupLevelNameList.concat(this.caculateGroupLevelName(group, false));
                    }
                }.bind(this));
            }.bind(this));
            if (callback) callback(json.data, groupLevelNameList);
        }.bind(this))
    },
    caculateNestedSubCount: function(unitTree, groupTree, callback){
        if( !this.allUnitObject )this.allUnitObject = {};
        if( !this.allGroupObject )this.allGroupObject = {};
        if( !this.allGroupObjectByDn )this.allGroupObjectByDn = {};
        if( !this.allGrounUnitObject )this.allGrounUnitObject = {};

        if( groupTree && groupTree.length ){
            groupTree.each( function ( tree ) {
                this.caculateGroupNestedCount( tree );
            }.bind(this) );
        }

        if( unitTree && unitTree.length ){
            unitTree.each( function ( tree ) {
                if( !this.allUnitObject[ tree.levelName ] ){
                    this.caculateUnitNestedCount( tree );
                }
            }.bind(this) );
        }

        if( this.allGroupObject ){
            for( var k in this.allGroupObject ){
                var obj = this.allGroupObject[k];
                this.allGroupObjectByDn[ obj.distinguishedName ] = obj;
            }
        }

        if(callback)callback();
    },
    caculateGroupNestedCount : function( tree, parentLevelName ){
        if( this.isExcluded( tree ) )return;
        var groupLevelName = parentLevelName ? ( parentLevelName + "/" + tree.distinguishedName.split("@")[0] ) : tree.distinguishedName.split("@")[0];

        if(!this.allGrounUnitObject[groupLevelName]){
            this.allGrounUnitObject[groupLevelName] = tree;
            tree.groupUnitLevelName = groupLevelName;
        }

        if(!this.allGroupObject[ groupLevelName ]){
            this.allGroupObject[ groupLevelName ] = tree;
        }else{
            return;
        }

        // tree.subDirectIdentityCount
        var count = tree.subDirectIdentityCount;
        if( this.groupExcludedIdentityCount && this.groupExcludedIdentityCount[ groupLevelName ] ){
            count = (count || 0) - this.groupExcludedIdentityCount[ groupLevelName ];
        }

        var selectedCount = 0;
        if( this.groupSelectedIdentityCount && this.groupSelectedIdentityCount[ groupLevelName ] ){
            selectedCount = this.groupSelectedIdentityCount[ groupLevelName ];
        }

        var nameList = groupLevelName.split("/");
        var names = [];
        nameList.each( function (n) {
            names.push( n );
            var levelName = names.join("/");
            var groupObject = this.allGroupObject[levelName];
            if( groupObject ){
                groupObject.subNestedIdentityCount = (groupObject.subNestedIdentityCount || 0) + count;
                groupObject.selectedNestedIdentityCount = (groupObject.selectedNestedIdentityCount || 0) + selectedCount;
            }
        }.bind(this));

        tree.subGroups.each( function (group) {
            this.caculateGroupNestedCount( group, groupLevelName );
        }.bind(this));

        tree.subUnits.each( function (unit) {
            var flag = this.allUnitObject[ unit.levelName ];
            this.caculateUnitNestedCount( unit, groupLevelName, !!flag )
        }.bind(this))

    },

    caculateUnitNestedCount : function ( tree, groupLevelName, flag ) {
        if( this.isExcluded( tree ) )return;
        var count;
        var selectedCount;

        if(!groupLevelName)groupLevelName="";

        if(!this.allGrounUnitObject[groupLevelName+"/"+tree.levelName]){
            this.allGrounUnitObject[groupLevelName+"/"+tree.levelName] = tree;
            tree.groupUnitLevelName = groupLevelName+"/"+tree.levelName;
        }

        if(!this.allUnitObject[ tree.levelName ]){
            this.allUnitObject[ tree.levelName ] = tree;
            count = tree.subDirectIdentityCount;
            if( this.unitExcludedIdentityCount && this.unitExcludedIdentityCount[ tree.levelName ] ){
                count = (count || 0) - this.unitExcludedIdentityCount[ tree.levelName ];
            }

            selectedCount = 0;
            if( this.unitSelectedIdentityCount && this.unitSelectedIdentityCount[ tree.levelName ] ){
                selectedCount = this.unitSelectedIdentityCount[ tree.levelName ];
            }
        }else if( !flag ){
            return;
        }else{
            count = this.allUnitObject[ tree.levelName ].subNestedIdentityCount || 0;
            selectedCount = this.allUnitObject[ tree.levelName ].selectedNestedIdentityCount || 0;
        }

        if( groupLevelName ){
            var groupNameList = groupLevelName.split("/");
            var groupNames = [];
            groupNameList.each( function (n) {
                groupNames.push( n );
                var levelName = groupNames.join("/");
                var groupObject = this.allGroupObject[levelName];
                if( groupObject ){
                    groupObject.subNestedIdentityCount = (groupObject.subNestedIdentityCount || 0) + count;
                    groupObject.selectedNestedIdentityCount = (groupObject.selectedNestedIdentityCount || 0) + selectedCount;
                }
            }.bind(this));
        }

        if( !flag ){
            var nameList = tree.levelName.split("/");
            var names = [];
            nameList.each( function (n) {
                names.push( n );
                var levelName = names.join("/");
                var unitObject = this.allUnitObject[levelName];
                if( unitObject ){
                    unitObject.subNestedIdentityCount = (unitObject.subNestedIdentityCount || 0) + count;
                    unitObject.selectedNestedIdentityCount = (unitObject.selectedNestedIdentityCount || 0) + selectedCount;
                }
            }.bind(this));

            tree.subUnits.each( function (unit) {
                this.caculateUnitNestedCount( unit, groupLevelName )
            }.bind(this))
        }
    },

    getIdentityParentLevelNameList: function(itemData, callback){
        if( this.hasGroupCategory ){
            if( !itemData.parentLevelNameList ){
                o2.Actions.load("x_organization_assemble_express").IdentityAction.listObject({
                    identityList : [itemData.distinguishedName], referenceFlag: true, recursiveFlag:true
                }, function (json) {
                    json.data.each( function (d) {
                        var list = [];
                        var listWithIdentity = []; //身份直接所在群组

                        d.woGroupList.each(function (group) {
                            var gList = this.caculateGroupLevelName(group);
                            list = list.concat( gList );
                            if(group.identityList.contains(d.id))listWithIdentity = listWithIdentity.concat(gList);
                        }.bind(this));

                        var resultList = [itemData.unitLevelName];
                        if( this.allGrounUnitObject ){
                            list.each(function(lName){
                                if( this.allGrounUnitObject[ lName +"/"+ itemData.unitLevelName ] ){
                                    resultList.push(lName +"/"+ itemData.unitLevelName);
                                    if( listWithIdentity.contains(lName) )resultList.push(lName);
                                }else if( this.allGrounUnitObject[ lName ] ){
                                    resultList.push(lName);
                                }
                            }.bind(this));
                        }else{  //数量树没有加载完成的时候 ？？？可能有问题
                            list.each(function(lName){
                                var level1Name = lName.split("/")[0];
                                if( this.subCategoryMap[ level1Name ] ){
                                    resultList.push(lName +"/"+ itemData.unitLevelName);
                                    resultList.push(lName );
                                }
                            }.bind(this));
                        }
                        itemData.parentLevelNameList = resultList;
                        if( callback )callback(resultList);
                    }.bind(this))
                }.bind(this))
            }else{
                if( callback )callback(itemData.parentLevelNameList);
            }
        }else{
            if( callback )callback([itemData.unitLevelName]);
        }
    },
    //通过身份信息获取的group
    caculateGroupLevelName: function(g, flag){
        var levelNameMap = flag ? this.groupAllLevelNameListMap : this.groupLevelNameListMap;
        if( levelNameMap[g.distinguishedName] ){
            return levelNameMap[g.distinguishedName];
        }

        var levelNameList = [g.name];
        var map = {};
        map[g.id] = g;
        g.woSupGroupList.each(function(group){ map[group.id] = group; });

        var nest = function( supGroupName, groupList ){
            groupList.each(function(subGroupId){
                if( map[subGroupId] ){
                    var groupLevelName = supGroupName+"/"+map[subGroupId].name;
                    if(flag || map[subGroupId].name === g.name )levelNameList.push( groupLevelName );
                    nest(groupLevelName, map[subGroupId].groupList || []);
                }
            })
        };

        g.woSupGroupList.each(function(group){
            if(flag)levelNameList.push(group.name);
            nest( group.name, group.groupList )
        });

        levelNameList = levelNameList.unique();
        levelNameMap[g.distinguishedName] = levelNameList;
        return levelNameList;
    },
    addSelectedCount: function( itemOrItemSelected, count ){
        this._addSelectedCount(itemOrItemSelected, count);
    },
    _addSelectedCount: function( itemOrItemSelected, count ){
        var itemData = itemOrItemSelected.data;
        this.getIdentityParentLevelNameList(itemData, function (parentLevelNameList) {
            parentLevelNameList.each(function(parentLevelName){
                if(!parentLevelName)return;
                var list = parentLevelName.split("/");
                var nameList = [];
                var subCategoryMapList = [this.subCategoryMap];
                for (var j = 0; j < list.length; j++) {
                    nameList.push(list[j]);
                    var name = nameList.join("/");
                    var maplist = [];
                    subCategoryMapList.each(function(subCategoryMap){
                        if ( subCategoryMap[name] ) {
                            var category = subCategoryMap[name];
                            category._addSelectedCount(count);
                            maplist.push( category.subCategoryMap ) ;
                        }
                    });
                    subCategoryMapList = subCategoryMapList.concat(maplist);

                    if( this.loadingCount === "done" ){
                        var obj = this.allUnitObject[name];
                        if (obj) {
                            obj.selectedNestedIdentityCount = obj.selectedNestedIdentityCount + count;
                        }
                    }
                }
            }.bind(this));
        }.bind(this))
    },
    addToItemMap: function (data, item) {
        if(!this.itemsMap)return;
        if(data.distinguishedName){
            if(!this.itemsMap[data.distinguishedName]){
                this.itemsMap[data.distinguishedName] = [item];
            }else{
                this.itemsMap[data.distinguishedName].push(item);
            }
        }
    },
    addToSelectedItemsMap: function(data, selectedItem){
        if(!this.selectedItemsMap)this.selectedItemsMap = {};
        if( data.distinguishedName ){
            this.selectedItemsMap[data.distinguishedName] = selectedItem;
        }
    },
    deleteFromSelectedItemsMap: function(data){
        if(!this.selectedItemsMap)this.selectedItemsMap = {};
        if( data.distinguishedName && this.selectedItemsMap[data.distinguishedName] ){
            delete this.selectedItemsMap[data.distinguishedName];
        }
    },

});


MWF.xApplication.Selector.Identity.Item = new Class({
    Extends: MWF.xApplication.Selector.Person.Item,
    _getShowName: function(){
        return this.data.name;
    },
    _getTtiteText: function(){
        return this.data.name+((this.data.unitLevelName) ? "("+this.data.unitLevelName+")" : "");
    },
    _setIcon: function(){
        var style = this.selector.options.style;
        this.iconNode.setStyle("background-image", "url("+"../x_component_Selector/$Selector/"+style+"/icon/personicon.png)");
    },
    getData: function(callback, isWait){
        if( this.selector.options.resultType === "person" ){
            var isPerson = false;
            if( this.data && this.data.distinguishedName ){
                var dn = this.data.distinguishedName;
                if( dn.substr(dn.length-1, 1).toLowerCase() === "p" )isPerson = true;
            }
            if( isPerson ) {
                if (callback) callback();
            }else if( this.data.woPerson ){
                this.data = this.data.woPerson;
                if (callback) callback();
            }else if( this.data.person ){
                this.selector.orgAction.getPerson(function(json){
                    this.data = json.data;
                    if (callback) callback();
                }.bind(this), null, this.data.person)
            }else{
                if (callback) callback();
            }
        }else{
            if( this.selector.options.ignorePerson || this.selector.options.storeRange === "simple" ){
                if(callback)callback();
                return;
            }
            if (!isWait && callback) callback();
            if (!this.data.woPerson && (!this.data.personDn || !this.data.personEmployee || !this.data.personUnique)){
                this.selector.orgAction.getPerson(function(json){
                    this.data.woPerson = json.data;
                    if (isWait && callback) callback();
                }.bind(this), null, this.data.person)
            }else{
                if (isWait && callback) callback();
            }
        }
    },
    checkSelectedSingle: function(){
        var isPerson = this.selector.options.resultType === "person";
        var selectedItem = this.selector.options.values.filter(function(item, index){
            if( isPerson ){
                if (typeOf(item)==="object") return (item.id && item.id === this.data.person) ||
                    ( item.person && item.person === this.data.id ) ||
                    ( this.data.distinguishedName && this.data.distinguishedName === item.distinguishedName);
                return false;
            }else{
                if (typeOf(item)==="object") return this.data.distinguishedName === item.distinguishedName;
                if (typeOf(item)==="string") return this.data.distinguishedName === item;
                return false;
            }
        }.bind(this));
        if (selectedItem.length){
            this.selectedSingle();
        }
    },
    checkSelected: function(){
        var isPerson = this.selector.options.resultType === "person";
        var selectedItem;
        if(isPerson || !this.selector.selectedItemsMap){
            selectedItem = this.selector.selectedItems.filter(function(item, index){
                if( isPerson ){
                    return ( item.data.id && item.data.id === this.data.person ) ||
                        ( item.data.person && item.data.person === this.data.id ) ||
                        ( item.data.distinguishedName && item.data.distinguishedName === this.data.distinguishedName );
                }else{
                    return item.data.distinguishedName === this.data.distinguishedName;
                }
            }.bind(this));
        }else{
            var sItem = this.selector.selectedItemsMap[this.data.distinguishedName];
            selectedItem = sItem ? [sItem] : [];
        }

        if (selectedItem.length){
            //selectedItem[0].item = this;
            selectedItem[0].addItem(this);
            this.selectedItem = selectedItem[0];
            this.setSelected();

            if( this.selector.options.selectAllRange === "all" && !this.selector.isCheckStatusOrCount() ){
                if(this.category && this.category._addSelectAllSelectedCount )this.category._addSelectAllSelectedCount( 1, true );
            }
        }
    }
});
MWF.xApplication.Selector.Identity.SearchItem = new Class({
    Extends: MWF.xApplication.Selector.Identity.Item,
    _getShowName: function(){
        return this.data.name+((this.data.unitLevelName) ? "("+this.data.unitLevelName+")" : "");
    }
});

MWF.xApplication.Selector.Identity.ItemSelected = new Class({
    Extends: MWF.xApplication.Selector.Person.ItemSelected,
    getData: function(callback, isWait){
        if( this.selector.options.resultType === "person" ){
            var isPerson = false;
            if( this.data && this.data.distinguishedName ){
                var dn = this.data.distinguishedName;
                if( dn.substr(dn.length-1, 1).toLowerCase() === "p" )isPerson = true;
            }
            if( isPerson ){
                if (callback) callback();
            }else if( this.data.woPerson ){
                this.data = this.data.woPerson;
                if (callback) callback();
            }else if( this.data.person ){
                this.selector.orgAction.getPerson(function(json){
                    this.data = json.data;
                    if (callback) callback();
                }.bind(this), null, this.data.person )
            }else{
                if (callback) callback();
            }
        }else if (!this.data.woPerson && (!this.data.personDn || !this.data.personEmployee || !this.data.personUnique) ){
            if( this.selector.options.ignorePerson || this.selector.options.storeRange === "simple" ){
                if(callback)callback();
                return;
            }
            if (!isWait && callback) callback();
            if (this.data.person){
                this.selector.orgAction.getPerson(function(json){
                    this.data.woPerson = json.data;
                    if (isWait && callback) callback();
                }.bind(this), function(xhr, text, error){
                    var errorText = error;
                    if (xhr){
                        var json = JSON.decode(xhr.responseText);
                        if (json){
                            errorText = json.message.trim() || "request json error";
                        }else{
                            errorText = "request json error: "+xhr.responseText;
                        }
                    }
                    MWF.xDesktop.notice("error", {x: "right", y:"top"}, errorText);
                    if (isWait && callback) callback();
                }.bind(this), this.data.person)
            }else{
                MWF.xDesktop.notice("error", {x: "right", y:"top"}, MWF.SelectorLP.noPerson.replace(/{name}/g, this.data.name));
                if (isWait && callback) callback();
            }
        }else{
            if (callback) callback();
        }

    },
    _getShowName: function(){
        return this.data.name+((this.data.unitLevelName) ? "("+this.data.unitLevelName+")" : "");
    },
    _getTtiteText: function(){
        return this.data.name+((this.data.unitLevelName) ? "("+this.data.unitLevelName+")" : "");
    },
    _setIcon: function(){
        var style = this.selector.options.style;
        this.iconNode.setStyle("background-image", "url("+"../x_component_Selector/$Selector/"+style+"/icon/personicon.png)");
    },
    check: function(){
        var items;
        if (this.selector.items.length){
            var isPerson = this.selector.options.resultType === "person";
            if( this.selector.itemsMap ){
                items = this.selector.itemsMap[this.data.distinguishedName];
            }
            if( !items ){
                items = this.selector.items.filter(function(item, index){
                    if( isPerson ){
                        return (item.data.person && item.data.person === this.data.id) ||
                            ( item.data.id && item.data.id === this.data.person) ||
                            ( item.data.distinguishedName && item.data.distinguishedName === this.data.distinguishedName );
                    }else{
                        return item.data.distinguishedName === this.data.distinguishedName;
                    }
                }.bind(this));
            }
            this.items = items;
            if (items.length){
                items.each(function(item){
                    item.selectedItem = this;
                    item.setSelected();

                    if( this.selector.options.selectAllRange === "all" && !this.selector.isCheckStatusOrCount() ){
                        if(item.category && item.category._addSelectAllSelectedCount )item.category._addSelectAllSelectedCount( 1, true );
                    }

                }.bind(this));
            }
        }

        if( !this.isFromValues ){
            if( this.selector.isCheckStatusOrCount() ){
                this.selector.addSelectedCount(this, 1, items||[]);
            }
        }

        if( this.afterCheck )this.afterCheck();
    }
});

MWF.xApplication.Selector.Identity.ItemCategory = new Class({
    Extends: MWF.xApplication.Selector.Person.ItemCategory,
    createNode: function(){
        this.node = new Element("div", {
            "styles": this.selector.css.selectorItemCategory_department,
            "title" : this._getTtiteText()
        }).inject(this.container);
    },
    _addSelectAllSelectedCount : function( count, nested ){
        var c = ( this._getSelectAllSelectedCount() || 0 ) + count;
        this.selectedCount = c;
        this._checkCountAndStatus( c );
        if( nested && this.category && this.category._addSelectAllSelectedCount ){
            this.category._addSelectAllSelectedCount(count, nested);
        }
    },
    _getSelectAllSelectedCount: function(){
        if( typeOf(this.selectedCount) === "number" ){
            return this.selectedCount;
        }else{
            return 0;
        }
    },

    _addSelectedCount : function( count, nested ){ //增加数字并向上回溯
        if( this.selector.loadingCount === "done" ){
            var c = ( this._getSelectedCount() || 0 ) + count;
            this.selectedCount = c;
            this._checkCountAndStatus( c );
        }else{
            this.selectedCount_wait = (this.selectedCount_wait || 0) + count;
        }
        if( nested && this.category && this.category._addSelectedCount ){
            this.category._addSelectedCount(count, nested);
        }
    },
    _getShowName: function(){
        // if( this._getTotalCount && this._getSelectedCount ){
        //     return "" + this._getTotalCount() + "-" + this._getSelectedCount() + "-" + this.data.name ;
        // }else{
        return this.data.name;
        // }
    },
    _getTotalCount : function(){
        if( !this.selector.allUnitObject )return 0;
        var unit =  this.selector.allUnitObject[this.data.levelName];
        var count = unit ? unit.subNestedIdentityCount : 0;
        return count;
    },
    _getSelectedCount : function(){
        if( typeOf(this.selectedCount) === "number" )return this.selectedCount;
        if( !this.selector.allUnitObject )return 0;
        var unit =  this.selector.allUnitObject[this.data.levelName];
        var count = unit ? unit.selectedNestedIdentityCount : 0;
        this.selectedCount = count + (this.selectedCount_wait || 0);
        this.selectedCount_wait = 0;
        return this.selectedCount;
    },
    _setIcon: function(){
        var style = this.selector.options.style;
        this.iconNode.setStyle("background-image", "url("+"../x_component_Selector/$Selector/"+style+"/icon/companyicon.png)");
    },
    _beforeSelectAll : function( _selectAllFun ){
        if( this.selector.options.ignorePerson || ( this.selector.options.storeRange === "simple" && this.selector.options.resultType !== "person") ){
            _selectAllFun();
            return;
        }
        //批量获取个人
        var object = {};
        if( this.selector.options.resultType === "person" ){
            this.subItems.each( function(item){
                var isPerson = false;
                if( item.data && item.data.distinguishedName ){
                    var dn = item.data.distinguishedName;
                    if( dn.substr(dn.length-1, 1).toLowerCase() === "p" )isPerson = true;
                }
                if( !isPerson && !item.data.woPerson && item.data.person ){
                    object[ item.data.person ] = item;
                }
            }.bind(this))
        }else{
            this.subItems.each( function (item) {
                if (!item.data.woPerson && item.data.person ){
                    object[ item.data.person ] = item;
                }
            }.bind(this))
        }
        var keys = Object.keys( object );
        if( keys.length > 0 ){
            o2.Actions.load("x_organization_assemble_express").PersonAction.listObject({"personList":keys}, function (json) {
                json.data.each( function ( p ){
                    if(object[ p.id ])object[ p.id ].data.woPerson = p;
                }.bind(this));
                _selectAllFun();
            })
        }else{
            _selectAllFun();
        }
    },
    clickItem: function( callback, notActive ){
        if (this._hasChild() && !this.loading){
            var firstLoaded = !this.loaded;
            this.loading = true;
            this.loadSub(function(){
                this.loading = false;
                if( !notActive ){
                    if( firstLoaded ){
                        if( !this.selector.isFlatCategory ){
                            if( this.subNotActive )this.activeSub();
                            this.children.setStyles({"display": "block", "height": "auto"});
                            this.actionNode.setStyles(this.selector.css.selectorItemCategoryActionNode_expand);
                            this.isExpand = true;
                        }
                        this.selector.fireEvent("expand", [this] );
                        // this.checkSelectAll();
                    }else{
                        var display = this.children.getStyle("display");
                        if (display === "none"){
                            if( this.subNotActive )this.activeSub();
                            this.children.setStyles({"display": "block", "height": "auto"});
                            this.actionNode.setStyles(this.selector.css.selectorItemCategoryActionNode_expand);
                            this.isExpand = true;
                            this.selector.fireEvent("expand", [this] );
                        }else{
                            this.children.setStyles({"display": "none", "height": "0px"});
                            this.actionNode.setStyles(this.selector.css.selectorItemCategoryActionNode_collapse);
                            this.isExpand = false;
                            this.selector.fireEvent("collapse", [this] );
                        }
                    }
                }
                if(callback)callback();
            }.bind(this), notActive);
        }
    },
    loadSub: function(callback, notActive){
        this._loadSub( function( firstLoad ) {
            if(callback)callback();
        }.bind(this), notActive)
    },
    _loadSub: function(callback, notActive){
        if(notActive)this.subNotActive = true;
        if (!this.loaded){
            var loadSubUnit = function () {
                if( this.selector.options.expandSubEnable && !this.categoryLoaded ){
                    o2.Actions.load("x_organization_assemble_express").UnitAction.listWithUnitSubDirectObject({
                            unitList: [this.data.distinguishedName],
                            countSubDirectUnit: true,
                            countSubDirectIdentity: true
                        },
                        function(json){
                            json.data.each(function(subData){
                                if( !this.selector.isExcluded( subData ) ) {
                                    if( subData && this.data.parentLevelName)subData.parentLevelName = this.data.parentLevelName +"/" + subData.name;
                                    var category = this.selector._newItemCategory("ItemUnitCategory", subData, this.selector, this.children, this.level + 1, this, false, notActive);
                                    this.subCategorys.push( category );
                                    this.subCategoryMap[subData.parentLevelName || subData.levelName] = category;
                                }
                            }.bind(this));
                            this.loaded = true;
                            if (callback) callback( true );
                        }.bind(this)
                    );
                }else{
                    this.loaded = true;
                    if (callback) callback( true );
                }
            }.bind(this);

            if( !this.itemLoaded ){
                this.selector.orgAction.listIdentityWithUnit(function(idJson){
                    idJson.data.each(function(idSubData){
                        if( !this.selector.isExcluded( idSubData ) ) {
                            var item = this.selector._newItem(idSubData, this.selector, this.children, this.level + 1, this, notActive);
                            this.selector.items.push(item);
                            if(this.selector.addToItemMap)this.selector.addToItemMap(idSubData,item);
                            if(this.subItems)this.subItems.push( item );
                        }
                    }.bind(this));
                    loadSubUnit();
                }.bind(this), null, this.data.distinguishedName);
            }else{
                loadSubUnit();
            }

            // }
        }else{
            if (callback) callback( );
        }
    },
    _hasChild: function(){
        var uCount = (this.data.subDirectUnitCount) ? this.data.subDirectUnitCount : 0;
        var iCount = (this.data.subDirectIdentityCount) ? this.data.subDirectIdentityCount : 0;
        return uCount + iCount;
    },
    _hasChildCategory: function(){
        return (this.data.subDirectUnitCount) ? this.data.subDirectUnitCount : 0;
    },
    _hasChildItem: function(){
        return (this.data.subDirectIdentityCount) ? this.data.subDirectIdentityCount : 0;
    },
    afterLoad: function(){
        if (this.level===1) this.clickItem();
        if( this.selector.isCheckStatusOrCount() ) {
            if (this.selector.loadingCount === "done"){
                this.checkCountAndStatus();
            }
        }
    },

    //for flat category start
    clickFlatCategoryItem: function( callback, hidden ){
        if (this._hasChildItem()){
            var firstLoaded = !this.itemLoaded;
            this.loadItemChildren(function(){
                if( hidden ){
                    //alert("hidden")
                    this.children.setStyles({"display": "none", "height": "0px"});
                    this.node.setStyles( this.selector.css.flatCategoryItemNode );
                    this.isExpand = false;
                }else if( firstLoaded ){
                    this.children.setStyles({"display": "block", "height": "auto"});
                    this.node.setStyles( this.selector.css.flatCategoryItemNode_selected );
                    this.isExpand = true;
                }else{
                    var display = this.children.getStyle("display");
                    if (display === "none"){
                        this.children.setStyles({"display": "block", "height": "auto"});
                        this.node.setStyles( this.selector.css.flatCategoryItemNode_selected );
                        this.isExpand = true;
                    }else{
                        this.children.setStyles({"display": "none", "height": "0px"});
                        this.node.setStyles( this.selector.css.flatCategoryItemNode );
                        this.isExpand = false;
                    }
                }
                if(callback)callback();
            }.bind(this));
        }
    },
    loadCategoryChildren: function(callback){
        if (!this.categoryLoaded){
            if( this.selector.options.expandSubEnable ){
                o2.Actions.load("x_organization_assemble_express").UnitAction.listWithUnitSubDirectObject({
                        unitList: [this.data.distinguishedName],
                        countSubDirectUnit: true,
                        countSubDirectIdentity: true
                    },
                    function(json){
                        json.data.each(function(subData){
                            if( !this.selector.isExcluded( subData ) ) {
                                if( subData && this.data.parentLevelName)subData.parentLevelName = this.data.parentLevelName +"/" + subData.name;
                                var category = this.selector._newItemCategory("ItemUnitCategory", subData, this.selector, this.children, this.level + 1, this);
                                this.subCategorys.push( category );
                                this.subCategoryMap[subData.parentLevelName || subData.levelName] = category;
                            }
                        }.bind(this));
                        this.categoryLoaded = true;
                        if (callback) callback();
                    }.bind(this)
                );
                // this.selector.orgAction.listSubUnitDirect(function(json){
                //     json.data.each(function(subData){
                //         if( !this.selector.isExcluded( subData ) ) {
                //             if( subData && this.data.parentLevelName)subData.parentLevelName = this.data.parentLevelName +"/" + subData.name;
                //             var category = this.selector._newItemCategory("ItemUnitCategory", subData, this.selector, this.children, this.level + 1, this);
                //             this.subCategorys.push( category );
                //             this.subCategoryMap[subData.parentLevelName || subData.levelName] = category;
                //         }
                //     }.bind(this));
                //     this.categoryLoaded = true;
                //     if (callback) callback();
                // }.bind(this), null, this.data.distinguishedName);
            }else{
                if (callback) callback();
            }
        }else{
            if (callback) callback( );
        }
    },
    loadItemChildren: function(callback){
        if (!this.itemLoaded){
            // if (this.selector.options.dutys && this.selector.options.dutys.length){
            //     var ids = [];
            //     var object = {};
            //     this.selector.options.dutys.each(function(duty){
            //         this.selector.orgAction.listIdentityWidthUnitWithDutyName(this.data.distinguishedName, duty, function(json){
            //             if (json.data && json.data.length){
            //                 ids = ids.concat(json.data);
            //             }
            //         }.bind(this), null, false);
            //
            //         ids.each(function(idSubData){
            //             if( !this.selector.isExcluded( idSubData ) && !object[ idSubData.id || idSubData.distinguishedName ]) {
            //                 var item = this.selector._newItem(idSubData, this.selector, this.children, this.level + 1, this);
            //                 this.selector.items.push(item);
            //                 if(this.subItems)this.subItems.push( item );
            //                 object[ idSubData.id || idSubData.distinguishedName ] = true;
            //             }
            //             this.itemLoaded = true;
            //         }.bind(this));
            //     }.bind(this));
            //     if (callback) callback();
            // }else{
            this.selector.orgAction.listIdentityWithUnit(function(idJson){
                idJson.data.each(function(idSubData){
                    if( !this.selector.isExcluded( idSubData ) ) {
                        var item = this.selector._newItem(idSubData, this.selector, this.children, this.level + 1, this);
                        this.selector.items.push(item);
                        if(this.selector.addToItemMap)this.selector.addToItemMap(idSubData,item);
                        if(this.subItems)this.subItems.push( item );
                    }
                    this.itemLoaded = true;
                }.bind(this));
                if (callback) callback();
            }.bind(this), null, this.data.distinguishedName);
            // }
        }else{
            if (callback) callback( );
        }
    }
    //for flat category end
});

MWF.xApplication.Selector.Identity.ItemUnitCategory = new Class({
    Extends: MWF.xApplication.Selector.Identity.ItemCategory
});

MWF.xApplication.Selector.Identity.ItemGroupCategory = new Class({
    Extends: MWF.xApplication.Selector.Identity.ItemCategory,
    createNode: function(){
        this.node = new Element("div", {
            "styles": this.selector.css.selectorItemCategory
        }).inject(this.container);
    },
    _setIcon: function(){
        var style = this.selector.options.style;
        this.iconNode.setStyle("background-image", "url("+"../x_component_Selector/$Selector/"+style+"/icon/groupicon.png)");
    },
    _getTotalCount : function(){
        if( !this.selector.allGroupObjectByDn )return 0;
        var group = this.selector.allGroupObjectByDn[this.data.distinguishedName];
        var count = group ? group.subNestedIdentityCount : 0;
        return count;
    },
    _getSelectedCount : function(){
        if( typeOf(this.selectedCount) === "number" )return this.selectedCount;
        if( !this.selector.allGroupObjectByDn )return 0;
        var group = this.selector.allGroupObjectByDn[this.data.distinguishedName];
        var count = group ? group.selectedNestedIdentityCount : 0;
        this.selectedCount = count;
        return count;
    },

    loadSub: function(callback){
        if (!this.loaded){
            var personContainer, identityContainer, groupContainer, unitContainer;
            if( this.data.personList )personContainer = new Element("div").inject( this.children );
            if( this.data.identityList )identityContainer = new Element("div").inject( this.children );
            if( this.data.groupList )groupContainer = new Element("div").inject( this.children );
            if( this.data.unitList )unitContainer = new Element("div").inject( this.children );

            var personLoadedCount = 0;
            var identityLoadedCount = 0;
            var unitLoadedCount = 0;
            var groupLoadedCount = 0;

            var checkCallback = function( type, count ){
                var addCount = count || 1;
                if( !this.selector.options.expandSubEnable ){
                    if( type === "person" )personLoadedCount += addCount;
                    if( type === "identity" )identityLoadedCount += addCount;
                    if(
                        (!this.data.personList || this.data.personList.length === 0 || this.data.personList.length == personLoadedCount) &&
                        (!this.data.identityList || this.data.identityList.length === 0 || this.data.identityList.length == identityLoadedCount)
                    ){
                        this.loaded = true;
                        if (callback) callback();
                    }
                }else{
                    if( type === "person" )personLoadedCount += addCount;
                    if( type === "identity" )identityLoadedCount += addCount;
                    if( type === "unit" )unitLoadedCount += addCount;
                    if( type === "group" )groupLoadedCount += addCount;
                    if( ( !this.data.personList || this.data.personList.length === 0 || this.data.personList.length == personLoadedCount ) &&
                        ( !this.data.identityList || this.data.identityList.length === 0 || this.data.identityList.length == identityLoadedCount )&&
                        ( !this.data.unitList || this.data.unitList.length === 0 || this.data.unitList.length == unitLoadedCount ) &&
                        ( !this.data.groupList || this.data.groupList.length === 0 || this.data.groupList.length == groupLoadedCount ) ){
                        this.loaded = true;
                        if (callback) callback();
                    }
                }
            }.bind(this);

            checkCallback();

            if( this.data.identityList && this.data.identityList.length > 0 ){
                if( this.selector.options.resultType === "person" ) {
                    //根据身份id批量获取人员对象
                    o2.Actions.load("x_organization_assemble_express").PersonAction.listWithIdentityObject({
                        identityList : this.data.identityList
                    }, function (json) {
                        this.selector.includeObject.loadPersonItem( json, identityContainer, this.level + 1, this);
                        checkCallback("identity", this.data.identityList.length )
                    }.bind(this), function () {
                        checkCallback("identity", this.data.identityList.length )
                    }.bind(this))
                }else{
                    //根据身份id批量获取身份对象
                    o2.Actions.load("x_organization_assemble_express").IdentityAction.listObject({
                        identityList : this.data.identityList
                    }, function (json) {
                        this.selector.includeObject.loadIdentityItem( json, identityContainer, this.level + 1, this);
                        checkCallback("identity", this.data.identityList.length )
                    }.bind(this), function () {
                        checkCallback("identity", this.data.identityList.length )
                    }.bind(this))
                }
            }

            if( this.data.personList && this.data.personList.length > 0 ){
                if( this.selector.options.resultType === "person" ) {
                    //根据人员d批量获取人员对象
                    o2.Actions.load("x_organization_assemble_express").PersonAction.listObject({
                        personList : this.data.personList
                    }, function (json) {
                        this.selector.includeObject.loadPersonItem( json, personContainer, this.level + 1, this);
                        checkCallback("person", this.data.personList.length )
                    }.bind(this), function () {
                        checkCallback("person", this.data.personList.length )
                    }.bind(this))
                }else{
                    //根据人员id批量获取身份对象
                    o2.Actions.load("x_organization_assemble_express").IdentityAction.listWithPersonObject({
                        personList : this.data.personList
                    }, function (json) {
                        this.selector.includeObject.loadIdentityItem( json, personContainer, this.level + 1, this);
                        checkCallback("person", this.data.personList.length )
                    }.bind(this), function () {
                        checkCallback("person", this.data.personList.length )
                    }.bind(this))
                }
            }

            // ( this.data.personList || [] ).each( function(p){
            //     if( this.selector.options.resultType === "person" ){
            //         this.selector.orgAction.getPerson(function (json) {
            //             this.selector.includeObject.loadPersonItem(json, this.children, this.level + 1, this );
            //             checkCallback("person");
            //         }.bind(this), function(){ checkCallback("person") }, p );
            //     }else{
            //         this.selector.orgAction.listIdentityByPerson(function(json){
            //             this.selector.includeObject.loadIdentityItem(json, this.children, this.level + 1, this);
            //             checkCallback("person")
            //         }.bind(this), function(){ checkCallback("person") }, p );
            //     }
            // }.bind(this));

            //list 服务不能获取下级数量
            // if( this.selector.options.expandSubEnable ){
            //     o2.Actions.load("x_organization_assemble_express").UnitAction.listObject({
            //         unitList : this.data.unitList
            //     }, function (json) {
            //         this.selector.includeObject.loadUnitItem( json, this.children, this.level + 1, this);
            //         checkCallback("unit", this.data.unitList.length )
            //     }.bind(this), function () {
            //         checkCallback("unit", this.data.unitList.length )
            //     }.bind(this))
            //
            //
            //     o2.Actions.load("x_organization_assemble_express").GroupAction.listObject({
            //         groupList : this.data.groupList
            //     }, function (json) {
            //         this.selector.includeObject.loadGroupItem(json, this.children, this.level + 1, this);
            //         checkCallback("group", this.data.groupList.length )
            //     }.bind(this), function () {
            //         checkCallback("group", this.data.groupList.length )
            //     }.bind(this))
            // }


            if( this.selector.options.expandSubEnable ){
                ( this.data.unitList || [] ).each( function(u){
                    this.selector.orgAction.getUnit(function (json) {
                        if( json.data && this.data.parentLevelName)json.data.parentLevelName = this.data.parentLevelName +"/" + json.data.levelName;
                        this.selector.includeObject.loadUnitItem(json, unitContainer, this.level + 1, this);
                        checkCallback("unit");
                    }.bind(this), function(){ checkCallback("unit") }, u );
                }.bind(this));

                ( this.data.groupList || [] ).each( function(g){
                    this.selector.orgAction.getGroup(function (json) {
                        if( json.data && this.data.parentLevelName)json.data.parentLevelName = this.data.parentLevelName +"/" + json.data.name;
                        this.selector.includeObject.loadGroupItem(json, groupContainer, this.level + 1, this);
                        checkCallback("group");
                    }.bind(this), function(){ checkCallback("group") }, g );
                }.bind(this));
            }
        }else{
            if (callback) callback( );
        }
    },
    loadCategoryChildren: function(callback){
        if (!this.categoryLoaded){

            var groupContainer, unitContainer;
            if( this.data.groupList )groupContainer = new Element("div").inject( this.children );
            if( this.data.unitList )unitContainer = new Element("div").inject( this.children );

            var unitLoadedCount = 0;
            var groupLoadedCount = 0;

            var checkCallback = function( type, count ){
                var addCount = count || 1;
                if( !this.selector.options.expandSubEnable ){
                    this.categoryLoaded = true;
                }else{
                    if( type === "unit" )unitLoadedCount += addCount;
                    if( type === "group" )groupLoadedCount += addCount;
                    if( ( !this.data.unitList || this.data.unitList.length === 0 || this.data.unitList.length == unitLoadedCount ) &&
                        ( !this.data.groupList || this.data.groupList.length === 0 || this.data.groupList.length == groupLoadedCount ) ){
                        this.categoryLoaded = true;
                        if (callback) callback();
                    }
                }
            }.bind(this);

            checkCallback();

            //list 服务不能获取下级数量
            // if( this.selector.options.expandSubEnable ){
            //     o2.Actions.load("x_organization_assemble_express").UnitAction.listObject({
            //         unitList : this.data.unitList
            //     }, function (json) {
            //         this.selector.includeObject.loadUnitItem( json, this.children, this.level + 1, this);
            //         checkCallback("unit", this.data.unitList.length )
            //     }.bind(this), function () {
            //         checkCallback("unit", this.data.unitList.length )
            //     }.bind(this))
            //
            //
            //     o2.Actions.load("x_organization_assemble_express").GroupAction.listObject({
            //         groupList : this.data.groupList
            //     }, function (json) {
            //         this.selector.includeObject.loadGroupItem(json, this.children, this.level + 1, this);
            //         checkCallback("group", this.data.groupList.length )
            //     }.bind(this), function () {
            //         checkCallback("group", this.data.groupList.length )
            //     }.bind(this))
            // }

            if( this.selector.options.expandSubEnable ){
                ( this.data.unitList || [] ).each( function(u){
                    this.selector.orgAction.getUnit(function (json) {
                        if( json.data && this.data.parentLevelName)json.data.parentLevelName = this.data.parentLevelName +"/" + json.data.levelName;
                        this.selector.includeObject.loadUnitItem(json, unitContainer, this.level + 1, this);
                        checkCallback("unit");
                    }.bind(this), function(){ checkCallback("unit") }, u );
                }.bind(this));

                ( this.data.groupList || [] ).each( function(g){
                    this.selector.orgAction.getGroup(function (json) {
                        if( json.data && this.data.parentLevelName)json.data.parentLevelName = this.data.parentLevelName +"/" + json.data.name;
                        this.selector.includeObject.loadGroupItem(json, groupContainer, this.level + 1, this);
                        checkCallback("group");
                    }.bind(this), function(){ checkCallback("group") }, g );
                }.bind(this));
            }
        }else{
            if (callback) callback( );
        }
    },
    loadItemChildren: function(callback){
        if (!this.itemLoaded){

            var personContainer, identityContainer;
            if( this.data.personList )personContainer = new Element("div").inject( this.children );
            if( this.data.identityList )identityContainer = new Element("div").inject( this.children );

            var personLoadedCount = 0;
            var identityLoadedCount = 0;

            var checkCallback = function( type, count ){
                var addCount = count || 1;
                if( type === "person" )personLoadedCount += addCount;
                if( type === "identity" )identityLoadedCount += addCount;
                if(
                    (!this.data.personList || this.data.personList.length === 0 || this.data.personList.length == personLoadedCount) &&
                    (!this.data.identityList || this.data.identityList.length === 0 || this.data.identityList.length == identityLoadedCount)
                ){
                    this.itemLoaded = true;
                    if (callback) callback();
                }
            }.bind(this);

            checkCallback();

            if( this.data.identityList && this.data.identityList.length > 0 ){
                if( this.selector.options.resultType === "person" ) {
                    //根据身份id批量获取人员对象
                    o2.Actions.load("x_organization_assemble_express").PersonAction.listWithIdentityObject({
                        identityList : this.data.identityList
                    }, function (json) {
                        this.selector.includeObject.loadPersonItem( json, identityContainer, this.level + 1, this);
                        checkCallback("identity", this.data.identityList.length )
                    }.bind(this), function () {
                        checkCallback("identity", this.data.identityList.length )
                    }.bind(this))
                }else{
                    //根据身份id批量获取身份对象
                    o2.Actions.load("x_organization_assemble_express").IdentityAction.listObject({
                        identityList : this.data.identityList
                    }, function (json) {
                        this.selector.includeObject.loadIdentityItem( json, identityContainer, this.level + 1, this);
                        checkCallback("identity", this.data.identityList.length )
                    }.bind(this), function () {
                        checkCallback("identity", this.data.identityList.length )
                    }.bind(this))
                }
            }

            if( this.data.personList && this.data.personList.length > 0 ){
                if( this.selector.options.resultType === "person" ) {
                    //根据人员d批量获取人员对象
                    o2.Actions.load("x_organization_assemble_express").PersonAction.listObject({
                        personList : this.data.personList
                    }, function (json) {
                        this.selector.includeObject.loadPersonItem( json, personContainer, this.level + 1, this);
                        checkCallback("person", this.data.personList.length )
                    }.bind(this), function () {
                        checkCallback("person", this.data.personList.length )
                    }.bind(this))
                }else{
                    //根据人员id批量获取身份对象
                    o2.Actions.load("x_organization_assemble_express").IdentityAction.listWithPersonObject({
                        personList : this.data.personList
                    }, function (json) {
                        this.selector.includeObject.loadIdentityItem( json, personContainer, this.level + 1, this);
                        checkCallback("person", this.data.personList.length )
                    }.bind(this), function () {
                        checkCallback("person", this.data.personList.length )
                    }.bind(this))
                }
            }

            // ( this.data.personList || [] ).each( function(p){
            //     if( this.selector.options.resultType === "person" ){
            //         this.selector.orgAction.getPerson(function (json) {
            //             this.selector.includeObject.loadPersonItem(json, this.children, this.level + 1, this );
            //             checkCallback("person");
            //         }.bind(this), function(){ checkCallback("person") }, p );
            //     }else{
            //         this.selector.orgAction.listIdentityByPerson(function(json){
            //             this.selector.includeObject.loadIdentityItem(json, this.children, this.level + 1, this);
            //             checkCallback("person")
            //         }.bind(this), function(){ checkCallback("person") }, p );
            //     }
            // }.bind(this));
        }else{
            if (callback) callback( );
        }
    },
    _hasChild: function(){
        var uCount = (this.data.unitList) ? this.data.unitList.length : 0;
        var gCount = (this.data.groupList) ? this.data.groupList.length : 0;
        var pCount = (this.data.personList) ? this.data.personList.length : 0;
        var iCount = (this.data.identityList) ? this.data.identityList.length : 0;
        return uCount + gCount + pCount + iCount;
    },
    _hasChildCategory: function(){
        var uCount = (this.data.unitList) ? this.data.unitList.length : 0;
        var gCount = (this.data.groupList) ? this.data.groupList.length : 0;
        return uCount + gCount;
    },
    _hasChildItem: function(){
        var pCount = (this.data.personList) ? this.data.personList.length : 0;
        var iCount = (this.data.identityList) ? this.data.identityList.length : 0;
        return pCount + iCount;
    }
});

MWF.xApplication.Selector.Identity.ItemRoleCategory = new Class({
    Extends: MWF.xApplication.Selector.Person.ItemCategory,
    _getShowName: function(){
        return this.data.name;
    },
    _setIcon: function(){
        var style = this.selector.options.style;
        this.iconNode.setStyle("background-image", "url("+"../x_component_Selector/$Selector/"+style+"/icon/roleicon.png)");
    }
});

MWF.xApplication.Selector.Identity.Include = new Class({
    Implements: [Options, Events],
    options: {
        "include" : [], //增加的可选项
        "resultType" : "", //可以设置成个人，那么结果返回个人
        "expandSubEnable" : true //是否允许展开下一层
    },
    initialize: function(selector, itemAreaNode, options){
        this.setOptions(options);
        this.selector = selector;
        this.itemAreaNode = $(itemAreaNode);
        this.orgAction = MWF.Actions.get("x_organization_assemble_control");
    },
    load : function( callback ){
        if( !this.options.include || this.options.include.length === 0 ){
            this.fireEvent("afterLoad");
            if(callback)callback();
            return;
        }


        var count = 0;
        var checkCallback = function () {
            count++;
            if( count === this.options.include.length ){
                this.fireEvent("afterLoad");
                if(callback)callback();
            }
        }.bind(this);

        this.includeAreaNode = new Element( "div.includeAreaNode").inject( this.itemAreaNode, "top" );

        if( this.selector.isFlatCategory ){
            this.flatCategoryAreaNode = new Element( "div.includeFlatCategoryAreaNode").inject( this.selector.flatCategoryNode, "top" );
        }

        //this.includeIdentityAreaNode = new Element( "div").inject( this.includeAreaNode );
        //this.includePersonAreaNode = new Element( "div").inject( this.includeAreaNode );
        //this.includeUnitAreaNode = new Element( "div").inject( this.includeAreaNode );
        //this.includeGroupAreaNode = new Element( "div").inject( this.includeAreaNode );

        this.options.include.each( function( d ){
            var container = new Element("div").inject( this.includeAreaNode );

            var flatCategoryContainer;
            if( this.flatCategoryAreaNode ){
                flatCategoryContainer = new Element("div").inject( this.flatCategoryAreaNode );
            }


            if (typeOf(d)==="string"){
                var arr = d.split("@");
                var flag = arr[ arr.length - 1].toLowerCase();
                if( flag === "u" ){
                    this.orgAction.listUnitByKey(function(json){
                        this.loadUnitItem(json, container, null, null, flatCategoryContainer);
                        checkCallback();
                    }.bind(this), checkCallback, d);
                }else if( flag === "i" ) {
                    this.orgAction.listIdentityByKey(function (json) {
                        this.loadIdentityItem(json, container, null, null, true );
                        checkCallback();
                    }.bind(this), checkCallback, d);
                }else if( flag === "g" ){
                    this.orgAction.listGroupByKey(function(json){
                        json.data.each(function(d){ d.parentLevelName = d.name; });
                        this.loadGroupItem( json , container, null, null, flatCategoryContainer);
                        checkCallback();
                    }.bind(this), checkCallback, d);
                }else if( flag === "p" ){
                    if( this.options.resultType === "person" ){
                        this.orgAction.getPerson(function (json){
                            this.loadPersonItem( json , container, null, null, true);
                            checkCallback();
                        }.bind(this), checkCallback, d);
                    }else{
                        // if( this.selector.options.onlyMajorIdentity ){
                        //     o2.Actions.load("x_organization_assemble_express").IdentityAction.listMajorWithPersonObject({"personList":[d]}, function (json) {
                        //         this.loadIdentityItem(json, container , null, null, true);
                        //         checkCallback();
                        //     }.bind(this), checkCallback)
                        // }else{
                        this.orgAction.listIdentityByPerson(function(json){
                            var obj;
                            if(json.data.length > 1 && this.selector.options.onlyMajorIdentity){
                                for(var i=0; i<json.data.length; i++){
                                    if( json.data[i].major ){
                                        obj = {"data": [json.data[i]]};
                                        break;
                                    }
                                }
                                if(!obj)obj = {"data": [json.data[0]]};
                            }
                            this.loadIdentityItem(obj || json, container , null, null, true);
                            checkCallback();
                        }.bind(this), checkCallback, d);
                        // }
                    }
                }else{
                    if( this.options.resultType === "person" ){
                        this.orgAction.listPersonByKey(function (json) {
                            this.loadPersonItem( json , container, null, null, true);
                            checkCallback();
                        }.bind(this), checkCallback, d);
                    }else{
                        this.orgAction.listIdentityByKey(function(json){
                            this.loadIdentityItem(json, container, null, null, true);
                            checkCallback();
                        }.bind(this), checkCallback, d);
                    }
                }
            }else{
                var arr = d.distinguishedName.split("@");
                var flag = arr[ arr.length - 1].toLowerCase();
                if( flag === "u" ) {
                    this.orgAction.getUnit(function (json) {
                        this.loadUnitItem(json, container, null, null, flatCategoryContainer);
                        checkCallback();
                    }.bind(this), checkCallback, d.distinguishedName);
                }else if( flag === "i" ){
                    this.orgAction.getIdentity(function (json) {
                        this.loadIdentityItem(json, container, null, null, true);
                        checkCallback();
                    }.bind(this), checkCallback, d.distinguishedName);
                }else if( flag === "g" ){
                    this.orgAction.getGroup(function(json){
                        json.data.each(function(d){ d.parentLevelName = d.name; });
                        this.loadGroupItem( json , container, null, null, flatCategoryContainer);
                        checkCallback();
                    }.bind(this), checkCallback, d.distinguishedName, null, null, true);
                }else if( flag === "p" ){
                    if( this.options.resultType === "person" ){
                        this.orgAction.getPerson(function (json) {
                            this.loadPersonItem(json, container, null, null, true);
                            checkCallback();
                        }.bind(this), checkCallback, d.distinguishedName);
                    }else{
                        this.orgAction.listIdentityByPerson(function(json){
                            this.loadIdentityItem(json, container, null, null, true);
                            checkCallback();
                        }.bind(this), checkCallback, d.distinguishedName);
                    }
                }else{
                    if( this.options.resultType === "person" ){
                        this.orgAction.getPerson(function (json) {
                            this.loadPersonItem(json, container, null, null, true);
                            checkCallback();
                        }.bind(this), checkCallback, d.distinguishedName);
                    }else{
                        this.orgAction.getIdentity(function (json) {
                            this.loadIdentityItem(json, container, null, null, true);
                            checkCallback();
                        }.bind(this), checkCallback, d.distinguishedName);
                    }
                }
                //var category = this._newItemCategory("ItemCategory", unit, this, this.itemAreaNode);
            }
        }.bind(this))
    },
    loadPersonItem : function( json, container, level, category, isIncludedPerson ){
        if( !json.data )return;
        var array = typeOf( json.data ) === "array" ? json.data : [json.data];
        array.each(function(data){
            if( !this.selector.isExcluded( data ) ) {

                if(!this.includePerson)this.includePerson = [];
                if(isIncludedPerson)this.includePerson.push( data.distinguishedName );

                if(!this.includePersonObject)this.includePersonObject = [];
                if(isIncludedPerson)this.includePersonObject.push( data );

                var item = this.selector._newItem(data, this.selector, container || this.includeAreaNode, level || 1, category);
                this.selector.items.push(item);
                if(this.selector.addToItemMap)this.selector.addToItemMap(data,item);
                if( category && category.subItems ){
                    category.subItems.push( item );
                }else if(this.selector.subItems){
                    this.selector.subItems.push( item )
                }
            }
        }.bind(this));
    },
    loadIdentityItem : function( json, container, level, category, isIncludedIdentity ){
        if( !json.data )return;
        var array = typeOf( json.data ) === "array" ? json.data : [json.data];
        array.each(function(data){
            if( !this.selector.isExcluded( data ) ) {

                if(!this.includeIdentity)this.includeIdentity = [];
                if(isIncludedIdentity)this.includeIdentity.push( data.distinguishedName );

                if(!this.includeIdentityObject)this.includeIdentityObject = [];
                if(isIncludedIdentity)this.includeIdentityObject.push( data );

                var item = this.selector._newItem(data, this.selector, container || this.includeAreaNode, level || 1, category);
                this.selector.items.push(item);
                if(this.selector.addToItemMap)this.selector.addToItemMap(data,item);
                if( category && category.subItems ){
                    category.subItems.push( item );
                }else if(this.selector.subItems){
                    this.selector.subItems.push( item )
                }
            }
        }.bind(this));
    },
    loadUnitItem : function( json, container, level, parentCategory, flatCategoryContainer ){
        if( !json.data )return;
        var array = typeOf( json.data ) === "array" ? json.data : [json.data];
        array.each(function(data){
            if( !this.selector.isExcluded( data ) ) {
                if(!this.includeUnit)this.includeUnit = [];
                this.includeUnit.push( data.distinguishedName );
                var category;
                if( flatCategoryContainer ){
                    category = this.selector._newItemCategory("ItemUnitCategory", data, this.selector,
                        container || this.includeAreaNode, level, parentCategory, true);
                    category.nodeContainer = flatCategoryContainer;
                    category.load();
                }else{
                    category = this.selector._newItemCategory("ItemUnitCategory", data, this.selector,
                        container || this.includeAreaNode, level, parentCategory);
                }
                if( parentCategory && parentCategory.subCategorys ){
                    parentCategory.subCategorys.push( category );
                    if(parentCategory.subCategoryMap)parentCategory.subCategoryMap[data.parentLevelName || data.levelName] = category;
                }else if(this.selector.subCategorys){
                    this.selector.subCategorys.push( category );
                    this.selector.subCategoryMap[data.parentLevelName || data.levelName] = category;
                }
            }
        }.bind(this));
    },
    loadGroupItem : function( json, container, level, parentCategory, flatCategoryContainer ){
        if( !json.data )return;
        var array = typeOf( json.data ) === "array" ? json.data : [json.data];
        array.each(function(data){
            if( !this.selector.isExcluded( data ) ) {
                if(!this.includeGroup)this.includeGroup = [];
                this.includeGroup.push( data.distinguishedName );
                var category;
                if( flatCategoryContainer ){
                    category = this.selector._newItemCategory("ItemGroupCategory", data, this.selector, container || this.includeAreaNode, level, parentCategory, true);
                    category.nodeContainer = flatCategoryContainer;
                    category.load();
                }else{
                    category = this.selector._newItemCategory("ItemGroupCategory", data, this.selector, container || this.includeAreaNode, level, parentCategory)
                }
                if( parentCategory && parentCategory.subCategorys ){
                    parentCategory.subCategorys.push( category );
                    if(parentCategory.subCategoryMap)parentCategory.subCategoryMap[data.parentLevelName || data.name] = category;
                }else if(this.selector.subCategorys){
                    this.selector.subCategorys.push( category );
                    this.selector.subCategoryMap[data.parentLevelName || data.name] = category;
                }
            }
        }.bind(this));
    },

    listByFilter : function( type, key, callback ){
        var arr1 = this.listByFilterPerson(key) || [];
        this.listByFilterUnitAndGroup( type, key, function(arr2){
            this.listByFilterGroup( type, key, function(arr3){
                if (callback) callback( arr1.concat( arr2 || [] ).concat( arr3 || [] ) );
            }.bind(this))
        }.bind(this))
    },
    listByFilterPerson : function( key ){
        var identitys = [];
        var persons = [];
        var keyString = typeOf( key )==="string" ? key.toLowerCase() : key.key.toLowerCase();
        if( this.includeIdentityObject && this.includeIdentityObject.length ){
            identitys = this.includeIdentityObject.filter( function(id) {
                return ( id.pinyin || "" ).indexOf(keyString) > -1 || (id.pinyinInitial || "").indexOf(keyString) > -1 || (id.distinguishedName || "").indexOf(keyString) > -1;
            })
        }
        if( this.includePersonObject && this.includePersonObject.length ){
            persons = this.includePersonObject.filter( function(id) {
                return ( id.pinyin || "" ).indexOf(keyString) > -1 || (id.pinyinInitial || "").indexOf(keyString) > -1 || (id.distinguishedName || "").indexOf(keyString) > -1;
            })
        }
        return identitys.concat( persons);
    },
    listByFilterGroup : function( type, key, callback ){
        //根据关键字获取群组内的人员，再转成身份
        var keyString = typeOf( key )==="string" ? key.toLowerCase() : key.key.toLowerCase();
        if( this.includeGroup && this.includeGroup.length ){
            var keyObject = { "key" : keyString, "groupList" : this.includeGroup };
            this.orgAction[ type === "pinyin" ? "listPersonByPinyin" : "listPersonByKey" ](function(json){
                if( this.options.resultType === "person" ){
                    if (callback) callback( json.data );
                }else{
                    var personList = (json.data || []).map( function(d){
                        return d.id
                    });
                    o2.Actions.get("x_organization_assemble_express").listIdentityWithPerson( { "personList" : personList }, function(js){
                        if (callback) callback(js.data);
                    }.bind(this), function(){
                        if (callback) callback();
                    }.bind(this))
                }
            }.bind(this), function(){
                if (callback) callback();
            }.bind(this), keyObject);
        }else{
            if (callback) callback();
        }
    },
    listByFilterUnitAndGroup : function( type, key, callback ){
        //根据关键字获取组织和群组内的身份
        var keyString = typeOf( key )==="string" ? key.toLowerCase() : key.key.toLowerCase();

        if ( (this.includeUnit && this.includeUnit.length) || (this.includeGroup && this.includeGroup.length) ){
            key = this.getUnitFilterKey( keyString, this.includeUnit, this.includeGroup );

            this.orgAction.listIdentityByKey(function(json){
                if (callback) callback(json.data);
            }.bind(this), function(){
                if (callback) callback();
            }, key);
        }else{
            if (callback) callback();
        }
    },
    getUnitFilterKey : function( key, unitObject, groupObject ){
        var unitObjects = unitObject || [];
        var units = [];
        unitObjects.each(function(u){
            if (typeOf(u)==="string"){
                units.push(u);
            }
            if (typeOf(u)==="object"){
                units.push(u.distinguishedName);
            }
        });

        var groupObjects = groupObject || [];
        var groups = [];
        groupObjects.each(function(g){
            if (typeOf(g)==="string"){
                groups.push(g);
            }
            if (typeOf(g)==="object"){
                groups.push(g.distinguishedName);
            }
        });
        if( !units.length && !groups.length ){
            return key;
        }else{
            var result = { "key": key };
            if( units.length )result.unitList = units;
            if( groups.length )result.groupList = groups;
            return result;
        }
        // return units.length ? {"key": key, "unitList": units, "groupList" : groups} : key;
    }
});

MWF.xApplication.Selector.Identity.Filter = new Class({
    Implements: [Options, Events],
    options: {
        "style": "default",
        "units": [],
        "resultType" : "" //可以设置成个人，那么结果返回个人
    },
    initialize: function(value, options){
        this.setOptions(options);
        this.value = value;
        this.orgAction = MWF.Actions.get("x_organization_assemble_control");
    },
    filter: function(value, callback){
        this.value = value;
        var key = this.value;
        if (this.options.units.length){
            var units = [];
            this.options.units.each(function(u){
                if (typeOf(u)==="string"){
                    units.push(u);
                }
                if (typeOf(u)==="object"){
                    units.push(u.distinguishedName);
                }
            });
            key = {"key": this.value, "unitList": units};
        }
        var data = null;
        this.orgAction.listIdentityByKey(function(json){
            data = json.data;
            if (callback) callback(data)
        }.bind(this), null, key);
    }
});

MWF.xApplication.Selector = MWF.xApplication.Selector || {};
MWF.xDesktop.requireApp("Selector", "Identity", null, false);
MWF.xApplication.Selector.Unit = new Class({
    Extends: MWF.xApplication.Selector.Identity,
    options: {
        "style": "default",
        "count": 0,
        "units": [],
        //"unitTypes": [],
        "values": [],
        "zIndex": 1000,
        "expand": true,
        "exclude" : [],
        "expandSubEnable" : true, //是否允许展开下一层
        "selectAllEnable" : true, //分类是否允许全选下一层
        "selectType" : "unit"
    },
    setInitTitle: function(){
        this.setOptions({"title": MWF.xApplication.Selector.LP.selectUnit});
    },
    _init : function(){
        this.selectType = "unit";
        this.className = "Unit";
    },
    loadSelectItems: function(addToNext){

        if( this.options.disabled ){
            this.afterLoadSelectItem();
            return;
        }

        this._loadSelectItems();
    },
    _loadSelectItems: function(){

        var afterLoadSelectItemFun = this.afterLoadSelectItem.bind(this);

        if (this.options.units.length){
            this.expandSubEnable = this.options.expandSubEnable || this.options.forceShowSubEnable || this.options.firstLevelSelectable;

            var unitList = [];
            for( var i=0 ; i<this.options.units.length; i++ ){
                var unit = this.options.units[i];
                if( typeOf( unit ) === "string" ){
                    unitList.push(unit);
                }else if( typeOf(unit)==="object"){
                    unitList.push(unit.distinguishedName || unit.unique || unit.levelName || unit.id);
                }
            }

            if( this.isCheckStatusOrCount() ) {
                this.loadingCount = "wait";
                this.loadCount( unitList );
            }

            o2.Actions.load("x_organization_assemble_express").UnitAction.listObject( {"unitList" : unitList} , function (json) {
                debugger;
                if (json.data.length){
                    json.data.each( function(data){
                        var item;
                        if( this.options.expandSubEnable ) {
                            if( this.options.firstLevelSelectable ){
                                item = this._newItem(data, this, this.itemAreaNode );
                                this.items.push( item );
                                this.subItems.push(item);
                            }else{
                                if (data.subDirectUnitCount){
                                    var category = this._newItemCategory("ItemCategory", data, this, this.itemAreaNode );
                                    this.subCategorys.push(category);
                                    this.subCategoryMap[data.levelName] = category;
                                }
                            }
                        }else{
                            item = this._newItem(data, this, this.itemAreaNode );
                            this.items.push( item );
                            this.subItems.push(item);
                        }
                    }.bind(this));
                }
                afterLoadSelectItemFun();
            }.bind(this), afterLoadSelectItemFun );
        }else{
            this.expandSubEnable = this.options.expandSubEnable || this.options.forceShowSubEnable;

            this.orgAction.listTopUnit(function(json){
                // if( this.isCheckStatusOrCount() ) {
                //     this.loadingCount = "wait";
                //
                //     unitList = json.data.filter(function (data) {
                //         return !this.isExcluded( data );
                //     }).map(function(data){
                //         return unit.id ||  unit.distinguishedName || unit.unique || unit.levelName
                //     }.bind(this)).clean();
                //
                //     this.loadCount( unitList );
                // }
                json.data.each(function(data){
                    if( !this.isExcluded( data ) ) {
                        var unit = this._newItem(data, this, this.itemAreaNode, 1);
                        this.items.push( unit );
                        this.subItems.push(unit);
                    }

                }.bind(this));
                afterLoadSelectItemFun();
            }.bind(this));
        }
    },

    _scrollEvent: function(y){
        return true;
    },
    _getChildrenItemIds: function(){
        return null;
    },
    _newItemCategory: function(type, data, selector, item, level, category, delay){
        return new MWF.xApplication.Selector.Unit[type](data, selector, item, level, category, delay)
    },

    _listItemByKey: function(callback, failure, key){
        if( this.options.expandSubEnable ){
            if (this.options.units.length){
                var units = [];
                this.options.units.each(function(u){
                    if (typeOf(u)==="string"){
                        units.push(u);
                    }
                    if (typeOf(u)==="object"){
                        units.push(u.distinguishedName);
                    }
                });
                key = {"key": key, "unitList": units};
            }
            this.orgAction.listUnitByKey(function(json){
                if (callback) callback.apply(this, [json]);
            }.bind(this), failure, key);
        }else{
            if (key){
                this.initSearchArea(true);
                this.searchInItems(key);
            }else{
                this.initSearchArea(false);
            }
        }
    },
    _getItem: function(callback, failure, id, async){
        this.orgAction.getUnit(function(json){
            if (callback) callback.apply(this, [json]);
        }.bind(this), failure, ((typeOf(id)==="string") ? id : id.distinguishedName), async);
    },

    _newItemSelected: function(data, selector, item, selectedNode){
        return new MWF.xApplication.Selector.Unit.ItemSelected(data, selector, item, selectedNode)
    },
    _listItemByPinyin: function(callback, failure, key){
        if (this.options.units.length){
            var units = [];
            this.options.units.each(function(u){
                if (typeOf(u)==="string"){
                    units.push(u);
                }
                if (typeOf(u)==="object"){
                    units.push(u.distinguishedName);
                }
            });
            key = {"key": key, "unitList": units};
        }
        this.orgAction.listUnitByPinyininitial(function(json){
            if (callback) callback.apply(this, [json]);
        }.bind(this), failure, key);
    },
    _newItem: function(data, selector, container, level, category, delay){
        return new MWF.xApplication.Selector.Unit.Item(data, selector, container, level, category, delay);
    },
    _newItemSearch: function(data, selector, container, level){
        return new MWF.xApplication.Selector.Unit.SearchItem(data, selector, container, level);
    },
    loadCount: function( unitList ){

        var check = function () {
            this.loadingCount = "ready";
            this.checkCountAndStatus();
            this.loadingCount = "done";
        }.bind(this);

        var unitLoaded, selectedUnitLoaded, excludeUnitLoaded;
        var unitTree;
        this.unitExcludedCount = {};
        this.unitSelectedCount = {};

        debugger;

        var caculate = function () {
            if (unitLoaded && selectedUnitLoaded && excludeUnitLoaded) {

                if( !this.allUnitObject )this.allUnitObject = {};

                if( unitTree && unitTree.length ){
                    unitTree.each( function ( tree ) {
                        if( !this.allUnitObject[ tree.levelName ] ){
                            this.caculateNestedSubCount(tree)
                        }
                    }.bind(this) );
                    check();
                }

            }
        }.bind(this);

        this.getUnitCountMap(this.options.values, function (map) {
            this.unitSelectedCount = map;
            selectedUnitLoaded = true;
            caculate();
        }.bind(this));

        this.getUnitCountMap(this.options.exclude, function (map) {
            this.unitExcludedCount = map;
            excludeUnitLoaded = true;
            caculate();
        }.bind(this));

        o2.Actions.load("x_organization_assemble_express").UnitAction.listWithUnitTree({"unitList": unitList}, function (json) {
            unitTree = json.data;
            unitLoaded = true;
            caculate();
        }.bind(this))
    },
    getUnitCountMap : function( identityList, callback ){
        var result = {};
        this.listUnitObject( identityList, function ( identityObjectList ) {
            identityObjectList.each(function (id) {
                if (id && id.levelName) {
                    result[id.levelName] = (result[id.levelName] || 0) + 1;
                }
            }.bind(this));
            if( callback )callback( result );
        })
    },
    listUnitObject : function( unitList, callback ){
        var list = [];
        unitList.each( function (d) {
            if( typeOf( d ) === "object"){
                if( !d.levelName || !d.distinguishedName )list.push( d.distinguishedName || d.unique || d.id )
            }else{
                list.push( d )
            }
        });
        if( list.length > 0 ){
            o2.Actions.load("x_organization_assemble_express").UnitAction.listObject({ unitList : list }, function (json) {
                var map = {};
                json.data.each( function (d) { map[ d.matchKey ] =  d; });
                var unitObjectList = [];
                unitList.each( function (d) {
                    var key = typeOf( d ) === "object" ? ( d.distinguishedName || d.unique || d.id ) : d;
                    unitObjectList.push( map[key] ? map[key] : d );
                });
                if( callback )callback( unitList );
            }.bind(this))
        }else{
            if( callback )callback( unitList );
        }
    },
    caculateNestedSubCount : function ( tree ) {
        if( this.isExcluded( tree ) )return;
        var count;
        var selectedCount;

        if(!this.allUnitObject[ tree.levelName ]){
            this.allUnitObject[ tree.levelName ] = tree;
            count = tree.subDirectUnitCount;
            if( this.unitExcludedCount && this.unitExcludedCount[ tree.levelName ] ){
                count = (count || 0) - this.unitExcludedCount[ tree.levelName ];
            }

            selectedCount = 0;
            if( this.unitSelectedCount && this.unitSelectedCount[ tree.levelName ] ){
                selectedCount = this.unitSelectedCount[ tree.levelName ];
            }
        }else{
            count = this.allUnitObject[ tree.levelName ].subNestedUnitCount || 0;
            selectedCount = this.allUnitObject[ tree.levelName ].selectedNestedUnitCount || 0;
        }

        var nameList = tree.levelName.split("/");
        var names = [];
        nameList.each( function (n) {
            names.push( n );
            var levelName = names.join("/");
            var unitObject = this.allUnitObject[levelName];
            if( unitObject ){
                unitObject.subNestedUnitCount = (unitObject.subNestedUnitCount || 0) + count;
                unitObject.selectedNestedUnitCount = (unitObject.selectedNestedUnitCount || 0) + selectedCount;
            }
        }.bind(this));

        tree.subUnits.each( function (unit) {
            this.caculateNestedSubCount( unit )
        }.bind(this))

    },
    _addSelectedCount: function( itemOrItemSelected, count ){
        var itemData = itemOrItemSelected.data;
        [itemOrItemSelected.data.levelName].each(function(levelName){
            if(!levelName)return;
            var list = levelName.split("/");
            var nameList = [];
            var subCategoryMapList = [this.subCategoryMap];
            for (var j = 0; j < list.length; j++) {
                nameList.push(list[j]);
                var name = nameList.join("/");
                var maplist = [];
                subCategoryMapList.each(function(subCategoryMap){
                    if ( subCategoryMap[name] ) {
                        var category = subCategoryMap[name];
                        category._addSelectedCount(count);
                        maplist.push( category.subCategoryMap ) ;
                    }
                });
                subCategoryMapList = subCategoryMapList.concat(maplist);

                if( this.loadingCount === "done" ){
                    var obj = this.allUnitObject[name];
                    if (obj) {
                        obj.selectedNestedUnitCount = obj.selectedNestedUnitCount + count;
                    }
                }
            }
        }.bind(this));
    }
});

MWF.xApplication.Selector.Unit.Item = new Class({
    Extends: MWF.xApplication.Selector.Identity.Item,
    load : function(){
        if( this.selector.isFlatCategory ){
            if( !this.justItem && this.selector.options.expandSubEnable && this.data.subDirectUnitCount ){
                this.loadCategoryForFlatCategory();
            }else if(!this.ignoreItem){
                this.loadForNormal(true);
            }
        }else{
            this.loadForNormal();
        }

    },

    loadForNormal : function( isNotLoadSubItem, container ){
        this.selector.fireEvent("queryLoadItem",[this]);

        if( !this.node )this.node = new Element("div", {
            "styles": this.selector.css.selectorItem
        }).inject(container || this.container);

        this.levelNode = new Element("div", {
            "styles": this.selector.css.selectorItemLevelNode
        }).inject(this.node);
        var indent = this.selector.options.level1Indent + (this.level-1)*this.selector.options.indent;

        if(this.selector.options.style === "flow"){
            if (this.level === 1) {
                indent = 26;
            } else {
                indent = 26 + ( this.level - 1 ) * this.selector.options.indent;
            }
        }

        this.levelNode.setStyle("width", ""+indent+"px");

        this.iconNode = new Element("div", {
            "styles": this.selector.css.selectorItemIconNode
        }).inject(this.node);
        this._setIcon();

        this.actionNode = new Element("div", {
            "styles": this.selector.css.selectorItemActionNode
        }).inject(this.node);
        if( ( this.selector.options.count.toInt() === 1 || this.selector.options.noSelectedContainer ) && this.selector.css.selectorItemActionNode_single  ){
            this.actionNode.setStyles( this.selector.css.selectorItemActionNode_single );
        }

        this.textNode = new Element("div", {
            "styles": this.selector.css.selectorItemTextNode,
            "text": this._getShowName(),
            "title": this._getTtiteText()
        }).inject(this.node);
        this.textNode.store("indent", indent);
        var m = this.textNode.getStyle("margin-left").toFloat()+indent;
        this.textNode.setStyle("margin-left", ""+m+"px");

        if(this.postLoad)this.postLoad();

        if(!isNotLoadSubItem)this.loadSubItem();

        this.setEvent();

        this.check();

        if(this.afterLoad)this.afterLoad();

        this.selector.fireEvent("postLoadItem",[this]);
    },
    _getShowName: function(){
        return (this.isShowLevelName && this.data.levelName) ? this.data.levelName : this.data.name;
    },
    _getTtiteText: function(){
        return this.data.levelName || this.data.name;
    },
    _setIcon: function(){
        var style = this.selector.options.style;
        this.iconNode.setStyle("background-image", "url("+"../x_component_Selector/$Selector/"+style+"/icon/departmenticon.png)");
    },
    loadSubItem: function(){
        if( !this.selector.options.expandSubEnable )return;
        this.isExpand = (this.selector.options.expand);
        if ( this._hasChild() || this.selector.options.expandEmptyCategory ){
            if (this.selector.options.expand){
                if( typeOf(this.selector.options.defaultExpandLevel) === "number" ){
                    if (this.level <= this.selector.options.defaultExpandLevel && this._hasChild() ){
                        this.levelNode.setStyles(this.selector.css.selectorItemLevelNode_expand);
                        this.loadSubItems();
                    }else{
                        this.isExpand = false;
                        this.levelNode.setStyles(this.selector.css.selectorItemLevelNode_collapse);
                    }
                }else if (this.level===1 && this._hasChild() ){
                    this.levelNode.setStyles(this.selector.css.selectorItemLevelNode_expand);
                    this.loadSubItems();
                }else{
                    this.isExpand = false;
                    this.levelNode.setStyles(this.selector.css.selectorItemLevelNode_collapse);
                }
            }else{
                this.levelNode.setStyles(this.selector.css.selectorItemLevelNode_collapse);
            }
            this.levelNode.addEvent("click", function(e){
                if (this.isExpand){
                    this.selector.fireEvent("collapse", [this] );
                    this.children.setStyle("display", "none");
                    this.levelNode.setStyles(this.selector.css.selectorItemLevelNode_collapse);
                    this.isExpand = false;
                }else{
                    this.selector.fireEvent("expand", [this] );
                    this.loadSubItems();
                    this.levelNode.setStyles(this.selector.css.selectorItemLevelNode_expand);
                    this.isExpand = true;
                }
                e.stopPropagation();
            }.bind(this));

            if( this.selector.css.selectorItemLevelNode_expand_over && this.selector.css.selectorItemLevelNode_collapse_over ){
                this.levelNode.addEvents({
                    mouseover : function(e){
                        var styles = this.isExpand ? this.selector.css.selectorItemLevelNode_expand_over : this.selector.css.selectorItemLevelNode_collapse_over;
                        this.levelNode.setStyles(styles);
                    }.bind(this),
                    mouseout : function(e){
                        var styles = this.isExpand ? this.selector.css.selectorItemLevelNode_expand : this.selector.css.selectorItemLevelNode_collapse;
                        this.levelNode.setStyles(styles);
                    }.bind(this)
                })
            }

            if( !this.selectAllNode && this.selector.options.count.toInt() !== 1 &&
                ( this.selector.options.style!=="blue_flat" && this.selector.options.style!=="blue_flat_mobile")){
                this.selectAllNode = new Element("div", {
                    "styles": this.selector.css.selectorItemCategoryActionNode_selectAll,
                    "title" : MWF.SelectorLP.selectChildren
                }).inject(
                    this.selector.options.style === "flow" ? this.iconNode : this.textNode,
                    "before"
                );
                this.selectAllNode.addEvent( "click", function(ev){
                    if( this.isSelectedAll ){
                        // this.unselectAll(ev);
                        this.selector.options.selectAllRange === "all" ? this.unselectAllNested(ev, null, true) : this.unselectAll(ev, null, true);
                        this.selector.fireEvent("unselectCatgory",[this]);
                        this.selector.fireEvent("unselectCategory",[this])
                    }else{
                        // this.selectAll(ev);
                        if( this.selector.options.selectAllRange === "all" ){
                            var node = new Element("div.categorySelectedNode").inject( this.selector.selectedNode );
                            this.selectAllNested(ev, true, node)
                        }else{
                            this.selectAll(ev ,true)
                        }
                        this.selector.fireEvent("selectCatgory",[this]);
                        this.selector.fireEvent("selectCategory",[this])
                    }
                    ev.stopPropagation();
                }.bind(this));
                if( this.selector.css.selectorItemCategoryActionNode_selectAll_over ){
                    this.selectAllNode.addEvents( {
                        "mouseover" : function(ev){
                            if( !this.isSelectedAll )this.selectAllNode.setStyles( this.selector.css.selectorItemCategoryActionNode_selectAll_over );
                            //ev.stopPropagation();
                        }.bind(this),
                        "mouseout" : function(ev){
                            if( !this.isSelectedAll )this.selectAllNode.setStyles( this.selector.css.selectorItemCategoryActionNode_selectAll );
                            //ev.stopPropagation();
                        }.bind(this)
                    })
                }
            }
        }else if( !this.selectAllNode && this.selector.options.count.toInt() !== 1 && this.selector.options.style === "flow" ){
            new Element("div", {
                "styles": this.selector.css.selectorItemCategoryActionNode_empty
            }).inject(
                this.selector.options.style === "flow" ? this.iconNode : this.textNode,
                "before"
            );
        }

        //this.actionNode.setStyles((this.selector.options.expand) ? this.selector.css.selectorItemCategoryActionNode_expand : this.selector.css.selectorItemCategoryActionNode_collapse);
    },
    unselectAll : function(ev, exclude, checkValid){
        //( this.subItems || [] ).each( function(item){
        //    if(item.isSelected)item.unSelected();
        //}.bind(this));
        var excludeList = exclude || [];
        if( exclude && typeOf(exclude) !== "array"  )excludeList = [exclude];
        ( this.subItems || [] ).each( function(item){
            if(item.isSelected && !excludeList.contains(item) ){
                item.unSelected( checkValid );
            }
        }.bind(this));

        if( this.selectAllNode ){
            if( this.selector.isFlatCategory ){
                this.selectAllNode.setStyles( this.selector.css.flatCategory_selectAll );
            }else if(this.selector.css.selectorItemCategoryActionNode_selectAll){
                this.selectAllNode.setStyles( this.selector.css.selectorItemCategoryActionNode_selectAll );
            }
        }
        this.isSelectedAll = false;
    },
    unselectAllNested : function( ev, exclude, checkValid ){
        this.unselectAll(ev, exclude, checkValid );
        if( this.subCategorys && this.subCategorys.length ){
            this.subCategorys.each( function( category ){
                if(category.unselectAllNested)category.unselectAllNested( ev, exclude, checkValid )
            })
        }
        if( this.subItems && this.subItems.length ){
            this.subItems.each( function( item ){
                if(item.unselectAllNested)item.unselectAllNested( ev, exclude, checkValid )
            })
        }
    },
    selectAllNested : function(ev, checkValid, selectedNode){
        var node;
        if( selectedNode )node = new Element("div.categorySelectedNode").inject( selectedNode );
        this.selectAll(ev, checkValid, node, function () {
            if( this.subCategorys && this.subCategorys.length ){
                this.subCategorys.each( function( category ){
                    if(selectedNode)var node = new Element("div.categorySelectedNode").inject( selectedNode );
                    if(category.selectAllNested)category.selectAllNested(ev, checkValid, node)
                })
            }
            if( this.subItems && this.subItems.length ){
                this.subItems.each( function( item ){
                    if(selectedNode)var node = new Element("div.categorySelectedNode").inject( selectedNode );
                    if(item.selectAllNested)item.selectAllNested(ev, checkValid, node)
                })
            }
        }.bind(this));
    },
    selectAll: function(ev, checkValid, selectedNode, callback){
        if( this.loaded || this.selector.isFlatCategory ){
            this._selectAll( ev, checkValid, selectedNode );
            if(callback)callback();
        }else{
            this.loadSubItems(function(){
                this._selectAll( ev, checkValid, selectedNode );
                if(callback)callback();
            }.bind(this));
            this.levelNode.setStyles(this.selector.css.selectorItemLevelNode_expand);
            this.isExpand = true;
        }
    },
    _selectAll : function( ev, checkValid, selectedNode ){
        if( !this.subItems || !this.subItems.length )return;
        var count = this.selector.options.maxCount || this.selector.options.count;
        if (!count) count = 0;
        var selectedSubItemCount = 0;

        this.subItems.each( function(item){
            if(item.isSelected)selectedSubItemCount++
        }.bind(this));

        if ((count.toInt()===0) || (this.selector.selectedItems.length+(this.subItems.length-selectedSubItemCount))<=count){

            var doSelectAll = function () {
                var checkedCount = 0;
                this.subItems.each( function(item){
                    if(!item.isSelected && !item.disabled )item.selected(false, function () {
                        checkedCount++;
                        if( this.subItems.length === checkedCount ){
                            if( checkValid )this.selector.fireEvent("valid", [this.selector, this]);
                        }
                    }.bind(this), selectedNode);
                }.bind(this));

                if( this.selectAllNode ){
                    if( this.selector.isFlatCategory ){
                        this.selectAllNode.setStyles( this.selector.css.flatCategory_selectAll_selected );
                    }else if(this.selector.css.selectorItemCategoryActionNode_selectAll_selected){
                        this.selectAllNode.setStyles( this.selector.css.selectorItemCategoryActionNode_selectAll_selected );
                    }
                }

                this.isSelectedAll = true;
            }.bind(this);

            if( this._beforeSelectAll ){
                this._beforeSelectAll( doSelectAll );
            }else{
                doSelectAll();
            }

        }else{
            MWF.xDesktop.notice("error", {x: "right", y:"top"}, MWF.SelectorLP.selectItemMaxText.replace("{count}", count), this.node);
        }
    },
    checkSelectAll : function(){
        if( this.isSelectedAll )return;
        if( !this.selectAllNode )return;
        if( !this.subItems )return;
        var isAllItemSelected = true;
        for( var i=0; i< this.subItems.length; i++ ){
            if( !this.subItems[i].isSelected ){
                isAllItemSelected = false;
                break;
            }
        }
        if( isAllItemSelected ){
            if( this.selector.isFlatCategory ){
                this.selectAllNode.setStyles( this.selector.css.flatCategory_selectAll_selected );
            }else if( this.selector.css.selectorItemCategoryActionNode_selectAll_selected ){
                this.selectAllNode.setStyles( this.selector.css.selectorItemCategoryActionNode_selectAll_selected );
            }
            this.isSelectedAll = true;
        }
    },
    checkUnselectAll : function(){
        if( !this.isSelectedAll )return;
        if( !this.selectAllNode )return;
        if( ! this.subItems )return;
        var hasSelectedItem = false;
        for( var i=0; i< this.subItems.length; i++ ){
            if( this.subItems[i].isSelected ){
                hasSelectedItem = true;
                break;
            }
        }
        if( !hasSelectedItem ){
            if( this.selector.isFlatCategory ){
                this.selectAllNode.setStyles( this.selector.css.flatCategory_selectAll );
            }else if( this.selector.css.selectorItemCategoryActionNode_selectAll ){
                this.selectAllNode.setStyles( this.selector.css.selectorItemCategoryActionNode_selectAll );
            }
            this.isSelectedAll = false;
        }
    },
    loadSubItems: function( callback ){
        if (!this.loaded && !this.loading){
            this.loading = true;
            if (!this.children){
                this.children = new Element("div", {
                    "styles": this.selector.css.selectorItemCategoryChildrenNode
                }).inject(this.node, "after");
            }
            this.children.setStyle("display", "block");
            //    if (!this.selector.options.expand) this.children.setStyle("display", "none");

            this.selector.orgAction.listSubUnitDirect(function(subJson){
                subJson.data.each(function(subData){
                    if( !this.selector.isExcluded( subData ) ) {
                        var category = this.selector._newItem(subData, this.selector, this.children, this.level + 1, this);
                        this.selector.items.push( category );
                        if( !this.subItems )this.subItems = [];
                        this.subItems.push( category );
                    }
                }.bind(this));
                this.loaded = true;
                this.loading = false;
                if(callback)callback();
            }.bind(this), null, this.data.distinguishedName);
        }else{
            this.children.setStyle("display", "block");
        }
    },
    getData: function(callback){
        if (callback) callback();
    },
    postLoad : function(){
        if( this.selector.options.style === "blue_flat" ) {
            if (this.level === 1) {
                var indent = 26;
                this.levelNode.setStyle("width", "" + indent + "px");
            } else {
                var indent = 26 + ( this.level - 1 ) * this.selector.options.indent;
                this.levelNode.setStyle("width", "" + indent + "px");
            }
        }
    },


    loadCategoryForFlatCategory : function(){
        this.selector.fireEvent("queryLoadCategory",[this]);

        if( !this.flatCategoryItemNode ){
            this.flatCategoryItemNode = new Element("div.flatCategoryItemNode", {
                "styles": this.selector.css.flatCategoryItemNode,
                "title" : this._getTtiteText()
            });
            this.flatCategoryItemNode.store( "category", this );
            this.flatCategoryItemNode.store( "dn", this.data.distinguishedName );

            this.flatCategoryItemTextNode = new Element("div", {
                "styles": this.selector.css.flatCategoryItemTextNode,
                "text": this._getShowName(),
                "title": this._getTtiteText()
            }).inject(this.flatCategoryItemNode);

        }

        this.children = new Element("div", {
            "styles": this.selector.css.selectorItemCategoryChildrenNode
        }).inject(this.selector.itemAreaNode);
        this.children.setStyle("display", "none");

        if( this.level === 1 ){
            this.loadForNormal(true, this.children);
        }

        if( !this.selectAllNode && this.selector.options.count.toInt() !== 1 ){
            var selectAllWrap = new Element("div",{
                styles : this.selector.css.flatCategory_selectAllWrap
            }).inject(this.children);
            this.selectAllNode = new Element("div", {
                "styles": this.selector.css.flatCategory_selectAll,
                "text" : MWF.SelectorLP.selectAll
            }).inject(selectAllWrap);
            this.selectAllNode.addEvent( "click", function(ev){
                if( this.isSelectedAll ){
                    this.unselectAll(ev);
                    this.selector.fireEvent("unselectCatgory",[this]);
                    this.selector.fireEvent("unselectCategory",[this])
                }else{
                    this.selectAll(ev);
                    this.selector.fireEvent("selectCatgory",[this]);
                    this.selector.fireEvent("selectCategory",[this]);
                }
                ev.stopPropagation();
            }.bind(this));
        }

        //this.loadForNormal(true, this.children);


        this.flatCategoryItemNode.addEvents({
            //"mouseover": function(){
            //    if (!this.isSelected )this.node.setStyles(this.selector.css.flatCategoryItemNode_over );
            //}.bind(this),
            //"mouseout": function(){
            //    if (!this.isSelected )this.node.setStyles(this.selector.css.flatCategoryItemNode );
            //}.bind(this),
            "click": function(){
                if( this.selector.currentFlatCategory === this )return;
                if( this.selector.currentFlatCategory ){
                    this.selector.currentFlatCategory.clickFlatCategoryItem(null, true); //取消原来选择的
                }
                this.selector.currentFlatCategory = this;
                this.clickFlatCategoryItem();
            }.bind(this)
        });
        //this.setEvent();

        var isCreateSubCategoryListNode = this.data.subDirectUnitCount ?  this.data.subDirectUnitCount : true;
        var nodeContainer;
        if( this.nodeContainer ){
            nodeContainer = this.nodeContainer;
        }else{
            nodeContainer = (this.category &&  this.category.subCategoryListNode) ? this.category.subCategoryListNode : null;
        }
        this.subCategoryListNode = this.selector.addFlatCategoryItem( this.flatCategoryItemNode, this.data.subDirectUnitCount, nodeContainer,  isCreateSubCategoryListNode );

        //this.check();

        if( this.loadCategoryChildren )this.loadCategoryChildren();

        //if(this.postLoad)this.postLoad();

        //this.setEvent();

        //this.check();

        this.selector.fireEvent("postLoadCategory",[this]);
    },
    clickFlatCategoryItem : function( callback, hidden ){
        //if (this._hasChildItem()){
        var firstLoaded = !this.itemLoaded;
        this.loadItemChildren(function(){
            if( hidden ){
                this.children.setStyles({ "display": "none" });
                this.flatCategoryItemNode.setStyles(this.selector.css.flatCategoryItemNode);
                this.isExpand = false;
            }else if( firstLoaded ){
                this.children.setStyles({"display": "block"});
                this.flatCategoryItemNode.setStyles( this.selector.css.flatCategoryItemNode_selected );
                this.isExpand = true;
            }else {
                var display = this.children.getStyle("display");
                if (display === "none") {
                    this.children.setStyles({ "display": "block" });
                    this.flatCategoryItemNode.setStyles(this.selector.css.flatCategoryItemNode_selected);
                    this.isExpand = true;
                } else {
                    this.children.setStyles({ "display": "none" });
                    this.flatCategoryItemNode.setStyles(this.selector.css.flatCategoryItemNode);
                    this.isExpand = false;
                }
            }
            if(callback)callback()
        }.bind(this));
        //}
    },
    loadCategoryChildren : function( callback ){
        if (!this.categoryLoaded){
            this.selector.orgAction.listSubUnitDirect(function(subJson){
                subJson.data.each(function(subData){
                    if( !this.selector.isExcluded( subData ) ) {
                        if( subData.subDirectUnitCount ){
                            var category = this.selector._newItem(subData, this.selector, this.children, this.level + 1, this);
                            //if( !this.subItems )this.subItems = [];
                            //this.subItems.push( category );
                        }
                    }
                }.bind(this));
                this.categoryLoaded = true;
                if(callback)callback();
            }.bind(this), null, this.data.distinguishedName);
        }else{
            if(callback)callback();
        }
    },
    loadItemChildren : function( callback ){
        if (!this.itemLoaded){
            this.selector.orgAction.listSubUnitDirect(function(subJson){
                subJson.data.each(function(subData){
                    if( !this.selector.isExcluded( subData ) ) {
                        //if( !subData.subDirectUnitCount ){
                        var category = this.selector._newItem(subData, this.selector, this.children, this.level + 1, this, true);
                        category.justItem = true;
                        category.load();
                        this.selector.items.push( category );
                        if( !this.subItems )this.subItems = [];
                        this.subItems.push( category );
                        //}
                    }
                }.bind(this));
                this.itemLoaded = true;
                if(callback)callback();
            }.bind(this), null, this.data.distinguishedName);
        }else{
            if(callback)callback();
        }
    },
    _hasChild : function () {
        return this.data.subDirectUnitCount;
    }
});

MWF.xApplication.Selector.Unit.SearchItem = new Class({
    Extends: MWF.xApplication.Selector.Unit.Item,
    load : function(){
        this.loadForNormal(true);
    },
    _getShowName: function(){
        // return this.data.levelName || this.data.name;
        return this.data.name+((this.data.levelName) ? "("+this.data.levelName+")" : "");
    },
    loadSubItems: function( callback ){
        //只是为了在isFlatCategory模式下，加载全称用的，否则用继承的就可以
        if (!this.loaded && !this.loading){
            this.loading = true;
            if (!this.children){
                this.children = new Element("div", {
                    "styles": this.selector.css.selectorItemCategoryChildrenNode
                }).inject(this.node, "after");
            }
            this.children.setStyle("display", "block");
            //    if (!this.selector.options.expand) this.children.setStyle("display", "none");

            this.selector.orgAction.listSubUnitDirect(function(subJson){
                subJson.data.each(function(subData){
                    if( !this.selector.isExcluded( subData ) ) {
                        var category;
                        if( this.selector.isFlatCategory ){
                            category = this.selector._newItem(subData, this.selector, this.children, this.level + 1, this, true);
                            category.isShowLevelName = true;
                            category.load();
                        }else{
                            category = this.selector._newItem(subData, this.selector, this.children, this.level + 1, this);
                        }
                        this.selector.items.push( category );
                        if( !this.subItems )this.subItems = [];
                        this.subItems.push( category );
                    }
                }.bind(this));
                this.loaded = true;
                this.loading = false;
                if(callback)callback();
            }.bind(this), null, this.data.distinguishedName);
        }else{
            this.children.setStyle("display", "block");
        }
    }
});

MWF.xApplication.Selector.Unit.ItemSelected = new Class({
    Extends: MWF.xApplication.Selector.Identity.ItemSelected,
    getData: function(callback){
        if (callback) callback();
    },
    _getTtiteText: function(){
        return this.data.levelName || this.data.name;
    },
    _getShowName: function(){
        return this.data.name+((this.data.levelName) ? "("+this.data.levelName+")" : "");
    },
    _setIcon: function(){
        var style = this.selector.options.style;
        this.iconNode.setStyle("background-image", "url("+"../x_component_Selector/$Selector/"+style+"/icon/departmenticon.png)");
    }
});

MWF.xApplication.Selector.Unit.ItemCategory = new Class({
    Extends: MWF.xApplication.Selector.Identity.ItemCategory,

    _getTotalCount : function(){
        if( !this.selector.allUnitObject )return 0;
        var unit =  this.selector.allUnitObject[this.data.levelName];
        var count = unit ? unit.subNestedUnitCount : 0;
        return count;
    },
    _getSelectedCount : function(){
        if( typeOf(this.selectedCount) === "number" )return this.selectedCount;
        if( !this.selector.allUnitObject )return 0;
        var unit =  this.selector.allUnitObject[this.data.levelName];
        var count = unit ? unit.selectedNestedUnitCount : 0;
        this.selectedCount = count + (this.selectedCount_wait || 0);
        this.selectedCount_wait = 0;
        return this.selectedCount;
    },

    loadSub: function(callback){
        if (!this.loaded){
            this.selector.orgAction.listSubUnitDirect(function(subJson){
                subJson.data.each(function(subData){
                    if( !this.selector.isExcluded( subData ) ) {
                        var category = this.selector._newItem(subData, this.selector, this.children, this.level+1, this);
                        category.isItem = true;
                        category.isCategory = true;
                        this.selector.items.push( category );
                        if(this.subItems)this.subItems.push( category );
                        this.subCategorys.push( category );
                        this.subCategoryMap[subData.levelName] = category;
                    }
                    //var category = this.selector._newItemCategory("ItemCategory", subData, this.selector, this.children, this.level+1);
                }.bind(this));

                this.loaded = true;
                if (callback) callback();

            }.bind(this), null, this.data.distinguishedName);
        }else{
            if (callback) callback();
        }
    },
    _hasChild: function(){
        var uCount = (this.data.subDirectUnitCount) ? this.data.subDirectUnitCount : 0;
        //var iCount = (this.data.subDirectIdentityCount) ? this.data.subDirectIdentityCount : 0;
        return uCount;
    },
    _hasChildCategory: function(){
        var uCount = (this.data.subDirectUnitCount) ? this.data.subDirectUnitCount : 0;
        return uCount;
    },
    _hasChildItem: function(){
        var uCount = (this.data.subDirectUnitCount) ? this.data.subDirectUnitCount : 0;
        return uCount;
    },


    //for flat category start
    loadCategoryChildren: function(callback){
        if (!this.categoryLoaded){
            this.selector.orgAction.listSubUnitDirect(function(subJson){
                subJson.data.each(function(subData){
                    if( !this.selector.isExcluded( subData ) ) {
                        var category = this.selector._newItem(subData, this.selector, this.children, this.level+1, this, true);
                        category.ignoreItem = true;
                        category.load();
                        //if(this.subItems)this.subItems.push( category );
                        this.subCategorys.push( category );
                        this.subCategoryMap[subData.levelName] = category;
                    }
                    //var category = this.selector._newItemCategory("ItemCategory", subData, this.selector, this.children, this.level+1);
                }.bind(this));

                this.categoryLoaded = true;
                if (callback) callback();

            }.bind(this), null, this.data.distinguishedName);
        }else{
            if (callback) callback( );
        }
    },
    loadItemChildren: function(callback){
        if (!this.itemLoaded){
            this.selector.orgAction.listSubUnitDirect(function(subJson){
                subJson.data.each(function(subData){
                    if( !this.selector.isExcluded( subData ) ) {
                        var category = this.selector._newItem(subData, this.selector, this.children, this.level+1, this, true);
                        category.justItem = true;
                        category.load();
                        this.selector.items.push( category );
                        if(this.subItems)this.subItems.push( category );
                        //this.subCategorys.push( category );
                    }
                    //var category = this.selector._newItemCategory("ItemCategory", subData, this.selector, this.children, this.level+1);
                }.bind(this));

                this.itemLoaded = true;
                if (callback) callback();

            }.bind(this), null, this.data.distinguishedName);
        }else{
            if (callback) callback( );
        }
    }

});

MWF.xApplication.Selector.Unit.Filter = new Class({
    Implements: [Options, Events],
    options: {
        "style": "default",
        "units": []
    },
    initialize: function(value, options){
        this.setOptions(options);
        this.value = value;
        this.orgAction = MWF.Actions.get("x_organization_assemble_control");
    },
    filter: function(value, callback){
        this.value = value;
        var key = this.value;


        if (this.options.units.length){
            var units = [];
            this.options.units.each(function(u){
                if (typeOf(u)==="string"){
                    units.push(u);
                }
                if (typeOf(u)==="object"){
                    units.push(u.distinguishedName);
                }
            });
            key = {"key": key, "unitList": units};
        }
        this.orgAction.listUnitByKey(function(json){
            data = json.data;
            if (callback) callback(data)
        }.bind(this), null, key);
    }
});

MWF.xApplication.Selector = MWF.xApplication.Selector || {};
MWF.xDesktop.requireApp("Selector", "Identity", null, false);
MWF.xApplication.Selector.IdentityWidthDuty = new Class({
    Extends: MWF.xApplication.Selector.Identity,
    options: {
        "style": "default",
        "count": 0,
        "title": "",
        "dutys": [],
        "units": [],
        "values": [],
        "zIndex": 1000,
        "expand": false,
        "noUnit" : false,
        "include" : [], //增加的可选项
        "resultType" : "", //可以设置成个人，那么结果返回个人
        "expandSubEnable": true,
        "selectAllEnable" : true, //分类是否允许全选下一层
        "exclude" : [],
        "selectType" : "identity"
    },
    setInitTitle: function(){
        this.setOptions({"title": MWF.xApplication.Selector.LP.selectIdentity});
    },
    _init : function(){
        this.selectType = "identity";
        this.className = "IdentityWidthDuty"
    },
    loadSelectItems: function(addToNext){
        this.loadingCountDuty = "wait";
        this.allUnitObjectWithDuty = {};
        var afterLoadSelectItemFun = this.afterLoadSelectItem.bind(this);
        if( this.options.disabled ){
            this.afterLoadSelectItem();
            return;
        }

        if( this.options.resultType === "person" ){
            if( this.titleTextNode ){
                this.titleTextNode.set("text", MWF.xApplication.Selector.LP.selectPerson );
            }else{
                this.options.title = MWF.xApplication.Selector.LP.selectPerson;
            }
        }
        if (this.options.dutys.length){
            var dutyLoaded = 0;

            var loadDutySuccess = function () {
                dutyLoaded++;
                if( dutyLoaded === this.options.dutys.length ){
                    this.dutyLoaded = true;
                    if( this.includeLoaded ){
                        afterLoadSelectItemFun();
                    }
                }
            }.bind(this);

            this.loadInclude( function () {
                this.includeLoaded = true;
                if( this.dutyLoaded ){
                    afterLoadSelectItemFun();
                }
            }.bind(this));

            var loadDuty = function () {
                if( this.isCheckStatusOrCount() ){
                    this.loadingCountDuty = "ready";
                    this.checkLoadingCount();
                }
                this.options.dutys.each(function(duty){
                    var data = {"name": duty, "id":duty};
                    var category = this._newItemCategory("ItemCategory",data, this, this.itemAreaNode);
                    this.subCategorys.push(category);
                    this.allUnitObjectWithDuty[data.name] = category;
                    loadDutySuccess();
                }.bind(this));
            }.bind(this);

            if( this.options.units.length === 0 ){
                loadDuty();
            }else{
                var unitList = [];
                this.options.units.each(function(u) {
                    var unitName = typeOf(u) === "string" ? u : (u.distinguishedName || u.unique || u.levelName || u.id);
                    if (unitName)unitList.push( unitName )
                });

                debugger;

                if( !this.options.expandSubEnable ){
                    this.allUnitNames = unitList;
                    loadDuty();
                }else{
                    var unitObjectList = [];
                    var loadNestedUnit = function(){
                        MWF.Actions.get("x_organization_assemble_express").listUnitSubNested({"unitList": unitList }, function(json1){
                            var unitNames = [];
                            //排序
                            if( this.options.units.length === 1 ){
                                // unitNames = unitList.concat( json1.data );
                                unitNames = Array.clone(unitList);
                                for( var i=0; i<json1.data.length; i++ ){
                                    if( !unitNames.contains(json1.data[i].distinguishedName) ){
                                        unitNames.push( json1.data[i].distinguishedName );
                                    }
                                }
                            }else{
                                unitObjectList.each( function ( u ) {
                                    unitNames.push( u.distinguishedName || u.unique || u.levelName || u.id );
                                    for( var i=0; i<json1.data.length; i++ ){
                                        if( json1.data[i].levelName.indexOf(u.levelName) > -1 ){
                                            unitNames.push( json1.data[i].distinguishedName );
                                        }
                                    }
                                })
                            }
                            this.allUnitNames = unitNames;
                            loadDuty();
                        }.bind(this), null);
                    }.bind(this);


                    var flag = false; //需要获取层次名用于排序
                    if( this.options.units.length === 1 ){
                        loadNestedUnit();
                    }else{
                        this.options.units.each(function(u) {
                            if (typeOf(u) === "string" ) {
                                u.indexOf("/") === -1 ? (flag = true) : unitObjectList.push( { levelName : u } );
                            } else {
                                u.levelName ? unitObjectList.push( u ) : (flag = true);
                            }
                        });
                        if( flag ){ //需要获取层次名来排序
                            o2.Actions.load("x_organization_assemble_express").UnitAction.listObject( {
                                unitList: unitList
                            }, function (json) {
                                unitObjectList = json.data || [];
                                loadNestedUnit();
                            }.bind(this) )
                        }else{
                            loadNestedUnit();
                        }
                    }
                }
            }
        }

        if( this.isCheckStatusOrCount() ) {
            this.loadingCountInclude = "wait";
            this.loadIncludeCount();
        }
    },

    search: function(){
        var key = this.searchInput.get("value");
        if (key){
            this.initSearchArea(true);
            var createdId = this.searchInItems(key) || [];
            if( this.options.include && this.options.include.length ){
                this.includeObject.listByFilter( "key", key, function( array ){
                    array.each( function(d){
                        if( !createdId.contains( d.distinguishedName ) ){
                            if( !this.isExcluded( d ) ) {
                                this._newItem( d, this, this.itemSearchAreaNode);
                            }
                        }
                    }.bind(this))
                }.bind(this))
            }
        }else{
            this.initSearchArea(false);
        }
    },
    listPersonByPinyin: function(node){
        this.searchInput.focus();
        var pinyin = this.searchInput.get("value");
        pinyin = pinyin+node.get("text");
        this.searchInput.set("value", pinyin);
        this.search();
    },

    checkLoadSelectItems: function(){
        if (!this.options.units.length){
            this.loadSelectItems();
        }else{
            this.loadSelectItems();
        }
    },

    _scrollEvent: function(y){
        return true;
    },
    _getChildrenItemIds: function(){
        return null;
    },
    _newItemCategory: function(type, data, selector, item, level, category, delay){
        return new MWF.xApplication.Selector.IdentityWidthDuty[type](data, selector, item, level, category, delay)
    },

    _listItemByKey: function(callback, failure, key){
        if (this.options.units.length) key = {"key": key, "unitList": this.options.units};
        this.orgAction.listIdentityByKey(function(json){
            if (callback) callback.apply(this, [json]);
        }.bind(this), failure, key);
    },
    _getItem: function(callback, failure, id, async){
        this.orgAction.getIdentity(function(json){
            if (callback) callback.apply(this, [json]);
        }.bind(this), failure, ((typeOf(id)==="string") ? id : id.distinguishedName), async);
    },
    _newItemSelected: function(data, selector, item, selectedNode){
        return new MWF.xApplication.Selector.IdentityWidthDuty.ItemSelected(data, selector, item, selectedNode)
    },
    _listItemByPinyin: function(callback, failure, key){
        if (this.options.units.length) key = {"key": key, "unitList": this.options.units};
        this.orgAction.listIdentityByPinyin(function(json){
            if (callback) callback.apply(this, [json]);
        }.bind(this), failure, key);
    },
    _newItem: function(data, selector, container, level, category, delay){
        return new MWF.xApplication.Selector.IdentityWidthDuty.Item(data, selector, container, level, category, delay);
    },
    _newItemSearch: function(data, selector, container, level){
        return new MWF.xApplication.Selector.IdentityWidthDuty.SearchItem(data, selector, container, level);
    },
    uniqueIdentityList: function(list){
        var items = [], map = {};
        (list||[]).each(function(d) {
            if (d.distinguishedName || d.unique) {
                if ((!d.distinguishedName || !map[d.distinguishedName]) && (!d.unique || !map[d.unique])) {
                    items.push(d);
                    map[d.distinguishedName] = true;
                    map[d.unique] = true;
                }
            } else {
                items.push(d);
            }
        })
        return items;
    },
    loadIncludeCount: function(){

        var unitList = [];
        var groupList = [];

        if (this.options.include.length > 0) {
            this.options.include.each(function (d) {
                var dn = typeOf(d) === "string" ? d : d.distinguishedName;
                var flag = dn.split("@").getLast().toLowerCase();
                if (flag === "u") {
                    unitList.push(dn);
                } else if (flag === "g") {
                    groupList.push(dn)
                }
            })
        }

        if(unitList.length || groupList.length){
            this._loadUnitAndGroupCount(unitList, groupList, function () {
                this.loadingCountInclude = "ready";
                this.checkLoadingCount();
            }.bind(this));
        }else{
            this.loadingCountInclude = "ignore";
            this.checkLoadingCount();
        }
    },
    checkLoadingCount: function(){
        if(this.loadingCountDuty === "ready" && this.loadingCountInclude === "ready"){
            this.checkCountAndStatus();
            this.loadingCount = "done";
        }else if(this.loadingCountDuty === "ready" && this.loadingCountInclude === "ignore"){
            this.loadingCount = "done";
        }
    },
    addSelectedCount: function( itemOrItemSelected, count, items ){
        if( this.loadingCountInclude === "ignore" ){
            this._addSelectedCountWithDuty(itemOrItemSelected, count, items);
        }else{
            this._addSelectedCountWithDuty(itemOrItemSelected, count, items);
            this._addSelectedCount(itemOrItemSelected, count);
        }

    },
    _addSelectedCountWithDuty: function( itemOrItemSelected, count, items ){
        var itemData = itemOrItemSelected.data;
        debugger;
        items.each(function(item){
            if(item.category && item.category._addSelectedCount && item.category.className === "ItemCategory"){
                item.category._addSelectedCount( count );
            }
        }.bind(this));
    },
    //_listItemNext: function(last, count, callback){
    //    this.action.listRoleNext(last, count, function(json){
    //        if (callback) callback.apply(this, [json]);
    //    }.bind(this));
    //}
});
MWF.xApplication.Selector.IdentityWidthDuty.Item = new Class({
    Extends: MWF.xApplication.Selector.Identity.Item,
    _getShowName: function(){
        return this.data.name;
    },
    _getTtiteText: function(){
        return this.data.name+((this.data.unitLevelName) ? "("+this.data.unitLevelName+")" : "");
    },
    _setIcon: function(){
        var style = this.selector.options.style;
        this.iconNode.setStyle("background-image", "url("+"../x_component_Selector/$Selector/"+style+"/icon/personicon.png)");
    }
});
MWF.xApplication.Selector.IdentityWidthDuty.SearchItem = new Class({
    Extends: MWF.xApplication.Selector.Identity.Item,
    _getShowName: function(){
        return this.data.name+((this.data.unitLevelName) ? "("+this.data.unitLevelName+")" : "");
    }
});

MWF.xApplication.Selector.IdentityWidthDuty.ItemSelected = new Class({
    Extends: MWF.xApplication.Selector.Identity.ItemSelected,
    _getShowName: function(){
        return this.data.name+((this.data.unitLevelName) ? "("+this.data.unitLevelName+")" : "");
    },
    _getTtiteText: function(){
        return this.data.name+((this.data.unitLevelName) ? "("+this.data.unitLevelName+")" : "");
    },
    _setIcon: function(){
        var style = this.selector.options.style;
        this.iconNode.setStyle("background-image", "url("+"../x_component_Selector/$Selector/"+style+"/icon/personicon.png)");
    }
});

MWF.xApplication.Selector.IdentityWidthDuty.ItemCategory = new Class({
    Extends: MWF.xApplication.Selector.Identity.ItemCategory,
    createNode: function(){
        this.className = "ItemCategory";
        this.node = new Element("div", {
            "styles": this.selector.css.selectorItemCategory_department,
            "title" : this._getTtiteText()
        }).inject(this.container);
    },
    _getShowName: function(){
        return this.data.name;
    },
    _setIcon: function(){
        var style = this.selector.options.style;
        this.iconNode.setStyle("background-image", "url("+"../x_component_Selector/$Selector/"+style+"/icon/companyicon.png)");
    },
    _addSelectAllSelectedCount: function(){
        var count = this._getSelectedCount();
        this._checkCountAndStatus(count);
    },

    _addSelectedCount : function(){
        if( this.selector.loadingCount === "done" ){
            var count = this._getSelectedCount();
            this._checkCountAndStatus(count);
        }
    },
    _getTotalCount : function(){
        return this.subItems.length;
    },
    _getSelectedCount : function(){
        var list = this.subItems.filter( function (item) { return item.isSelected; });
        return list.length;
    },
    loadSub : function(callback){
        this._loadSub( function( firstLoad ) {
            if(firstLoad){
                if( this.selector.isCheckStatusOrCount() ){
                    // var count = this._getSelectedCount();
                    // this.checkCountAndStatus(count);
                    if( this.selector.loadingCount === "done" ){
                        this.checkCountAndStatus();
                    }
                }
            }
            if(callback)callback();
        }.bind(this))
    },
    _loadSub: function(callback){
        if (!this.loaded  && !this.loadingsub){
            this.loadingsub = true;

            if (this.selector.options.units.length){
                var data = {
                    "name":this.data.name,
                    "unit":"",
                    "unitList" : this.selector.allUnitNames
                };

                MWF.Actions.get("x_organization_assemble_express").getDuty(data, function(json){
                    var list = this.selector.uniqueIdentityList(json.data);
                    list.each(function(idSubData){
                        if( !this.selector.isExcluded( idSubData ) ) {
                            var item = this.selector._newItem(idSubData, this.selector, this.children, this.level + 1, this);
                            this.selector.items.push(item);
                            if(this.subItems)this.subItems.push( item );
                        }
                    }.bind(this));

                    if (!this.loaded) {
                        this.loaded = true;
                        this.loadingsub = false;
                        this.itemLoaded = true;
                        if (callback) callback( true );
                    }

                }.bind(this), null, false);

                // if (this.selector.options.units.length){
                //     var action = MWF.Actions.get("x_organization_assemble_express");
                //     var data = {"name":this.data.name, "unit":""};
                //     var count = this.selector.options.units.length;
                //     var i = 0;
                //
                //     if (this.selector.options.expandSubEnable) {
                //         this.selector.options.units.each(function(u){
                //             var unitName = "";
                //             if (typeOf(u)==="string"){
                //                 unitName = u;
                //             }else{
                //                 unitName = u.distinguishedName || u.unique || u.id || u.levelName
                //             }
                //             if (unitName){
                //                 var unitNames;
                //                 action.listUnitNameSubNested({"unitList": [unitName]}, function(json){
                //                     unitNames = json.data.unitList;
                //                 }.bind(this), null, false);
                //
                //                 unitNames.push(unitName);
                //                 if (unitNames && unitNames.length){
                //                     data.unitList = unitNames;
                //                     action.getDuty(data, function(json){
                //                         json.data.each(function(idSubData){
                //                             if( !this.selector.isExcluded( idSubData ) ) {
                //                                 var item = this.selector._newItem(idSubData, this.selector, this.children, this.level + 1, this);
                //                                 this.selector.items.push(item);
                //                                 if(this.subItems)this.subItems.push( item );
                //                             }
                //                         }.bind(this));
                //                     }.bind(this), null, false);
                //                 }
                //             }
                //
                //             i++;
                //             if (i>=count){
                //                 if (!this.loaded) {
                //                     this.loaded = true;
                //                     this.loadingsub = false;
                //                     this.itemLoaded = true;
                //                     if (callback) callback();
                //                 }
                //             }
                //         }.bind(this));
                //     }else{
                //         this.selector.options.units.each(function(u){
                //             if (typeOf(u)==="string"){
                //                 data.unit = u;
                //             }else{
                //                 data.unit = u.distinguishedName || u.unique || u.id || u.levelName
                //             }
                //             action.getDuty(data, function(json){
                //                 json.data.each(function(idSubData){
                //                     if( !this.selector.isExcluded( idSubData ) ) {
                //                         var item = this.selector._newItem(idSubData, this.selector, this.children, this.level + 1, this);
                //                         this.selector.items.push(item);
                //                         if(this.subItems)this.subItems.push( item );
                //                     }
                //                 }.bind(this));
                //                 i++;
                //                 if (i>=count){
                //                     if (!this.loaded) {
                //                         this.loaded = true;
                //                         this.loadingsub = false;
                //                         this.itemLoaded = true;
                //                         if (callback) callback();
                //                     }
                //                 }
                //             }.bind(this));
                //         }.bind(this));
                //     }

            }else{
                this.selector.orgAction.listIdentityWithDuty(function(json){
                    var list = this.selector.uniqueIdentityList(json.data);
                    list.each(function(idSubData){
                        if( !this.selector.isExcluded( idSubData ) ) {
                            var item = this.selector._newItem(idSubData, this.selector, this.children, this.level + 1, this);
                            this.selector.items.push(item);
                            if(this.subItems)this.subItems.push( item );
                        }
                    }.bind(this));
                    this.loaded = true;
                    this.loadingsub = false;
                    if (callback) callback( true );
                }.bind(this), null, this.data.name);
            }
        }else{
            if (callback) callback( );
        }
    },
    loadCategoryChildren: function(callback){
        this.loadSub(callback);
        this.categoryLoaded = true;
        //if (callback) callback();
    },
    loadItemChildren: function(callback){
        this.loadSub(callback);
    },
    _hasChild: function(){
        return true;
    },
    _hasChildCategory: function(){
        return true;
    },
    _hasChildItem: function(){
        return true;
    }

});

MWF.xApplication.Selector.IdentityWidthDuty.ItemUnitCategory = new Class({
    Extends: MWF.xApplication.Selector.Identity.ItemUnitCategory,
    loadSub: function(callback){
        if (!this.loaded){
            this.selector.orgAction.listIdentityWithUnit(function(idJson){
                if( !this.itemLoaded ){
                    var list = this.selector.uniqueIdentityList(idJson.data);
                    list.each(function(idSubData){
                        if( !this.selector.isExcluded( idSubData ) ) {
                            var item = this.selector._newItem(idSubData, this.selector, this.children, this.level + 1, this);
                            this.selector.items.push(item);
                            if(this.subItems)this.subItems.push( item );
                        }
                    }.bind(this));
                    this.itemLoaded = true;
                }

                if( !this.selector.options.expandSubEnable ){
                    this.loaded = true;
                    if (callback) callback();
                }

                if( this.selector.options.expandSubEnable ){
                    this.selector.orgAction.listSubUnitDirect(function(json){
                        json.data.each(function(subData){
                            if( !this.selector.isExcluded( subData ) ) {
                                if( subData && this.data.parentLevelName)subData.parentLevelName = this.data.parentLevelName +"/" + subData.name;
                                var category = this.selector._newItemCategory("ItemUnitCategory", subData, this.selector, this.children, this.level + 1, this);
                                this.subCategorys.push( category );
                                this.subCategoryMap[subData.parentLevelName || subData.levelName] = category;
                            }
                        }.bind(this));
                        this.loaded = true;
                        if (callback) callback();
                    }.bind(this), null, this.data.distinguishedName);
                }
            }.bind(this), null, this.data.distinguishedName);
        }else{
            if (callback) callback( );
        }
    },
    loadCategoryChildren: function(callback){
        if (!this.categoryLoaded){
            this.loadSub(callback);
            this.categoryLoaded = true;
            this.itemLoaded = true;
            //if( this.selector.options.expandSubEnable ){
            //    this.selector.orgAction.listSubUnitDirect(function(json){
            //        json.data.each(function(subData){
            //            if( !this.selector.isExcluded( subData ) ) {
            //                var category = this.selector._newItemCategory("ItemUnitCategory", subData, this.selector, this.children, this.level + 1, this);
            //                this.subCategorys.push( category );
            //            }
            //        }.bind(this));
            //        this.categoryLoaded = true;
            //        if (callback) callback();
            //    }.bind(this), null, this.data.distinguishedName);
            //}else{
            //    if (callback) callback();
            //}
        }else{
            if (callback) callback( );
        }
    },
    loadItemChildren: function(callback){
        if (!this.itemLoaded){
            this.selector.orgAction.listIdentityWithUnit(function(idJson){
                var list = this.selector.uniqueIdentityList(idJson.data);
                list.each(function(idSubData){
                    if( !this.selector.isExcluded( idSubData ) ) {
                        var item = this.selector._newItem(idSubData, this.selector, this.children, this.level + 1, this);
                        this.selector.items.push(item);
                        if(this.subItems)this.subItems.push( item );
                    }
                }.bind(this));
                if (callback) callback();
            }.bind(this), null, this.data.distinguishedName);
            this.itemLoaded = true;
        }else{
            if (callback) callback( );
        }
    }
});

MWF.xApplication.Selector.IdentityWidthDuty.ItemGroupCategory = new Class({
    Extends: MWF.xApplication.Selector.Identity.ItemGroupCategory
});

MWF.xApplication.Selector.IdentityWidthDuty.Filter = new Class({
    Implements: [Options, Events],
    options: {
        "style": "default",
        "units": [],
        "dutys": []
    },
    initialize: function(value, options){
        this.setOptions(options);
        this.value = value;
        this.orgAction = MWF.Actions.get("x_organization_assemble_control");
    },
    getList: function(callback){
        if (false && this.list){
            if (callback) callback();
        }else{
            this.list = [];

            MWF.require("MWF.widget.PinYin", function(){
                this.options.dutys.each(function(duty){
                    if (this.options.units.length){
                        var action = MWF.Actions.get("x_organization_assemble_express");
                        var data = {"name":duty, "unit":""};
                        this.options.units.each(function(u){
                            if (typeOf(u)==="string"){
                                data.unit = u;
                            }else{
                                data.unit = u.distinguishedName || u.unique || u.levelName || u.id
                            }
                            action.getDuty(data, function(json){
                                json.data.each(function(d){
                                    d.pinyin = d.name.toPY().toLowerCase();
                                    d.firstPY = d.name.toPYFirst().toLowerCase();
                                    this.list.push(d);
                                }.bind(this));
                            }.bind(this), null, false);
                        }.bind(this));
                    }else{
                        this.orgAction.listIdentityWithDuty(function(json){
                            json.data.each(function(d){
                                d.pinyin = d.name.toPY().toLowerCase();
                                d.firstPY = d.name.toPYFirst().toLowerCase();
                                this.list.push(d);
                            }.bind(this));
                        }.bind(this), null, duty, false);
                    }
                }.bind(this));
                if (callback) callback();

            }.bind(this));
        }
    },
    filter: function(value, callback){
        this.value = value;
        this.getList(function(){
            var data = this.list.filter(function(d){
                var text = d.name+"#"+d.pinyin+"#"+d.firstPY;
                return (text.indexOf(this.value)!=-1);
            }.bind(this));
            if (callback) callback(data);
        }.bind(this));
    }
});

MWF.xApplication.Selector = MWF.xApplication.Selector || {};
MWF.xDesktop.requireApp("Selector", "IdentityWidthDuty", null, false);
MWF.xApplication.Selector.IdentityWidthDutyCategoryByUnit = new Class({
    Extends: MWF.xApplication.Selector.IdentityWidthDuty,
    options: {
        "style": "default",
        "count": 0,
        "title": "",
        "dutys": [],
        "units": [],
        "values": [],
        "zIndex": 1000,
        "expand": false,
        "noUnit": false,
        "include": [], //增加的可选项
        "resultType": "", //可以设置成个人，那么结果返回个人
        "expandSubEnable": true,
        "selectAllEnable": true, //分类是否允许全选下一层
        "exclude": [],
        "dutyUnitLevelBy": "duty", //组织层级是按身份所在群组还是职务,
        "identitySortBy" : "identityNumber", //身份排序按身份排序号，还是传入的duty
        "selectType": "identity"
    },
    setInitTitle: function(){
        this.setOptions({"title": MWF.xApplication.Selector.LP.selectIdentity});
    },
    _init: function () {
        this.selectType = "identity";
        this.className = "IdentityWidthDutyCategoryByUnit";
    },
    getUnitUniqueFormDn : function(dn){
        if(!dn)return "";
        var arr = dn.split("@");
        if( arr.length === 3 )return arr[1];
        return dn;
    },
    loadSelectItems: function (addToNext) {
        //根据组织分类展现职务
        if (this.options.resultType === "person") {
            if (this.titleTextNode) {
                this.titleTextNode.set("text", MWF.xApplication.Selector.LP.selectPerson);
            } else {
                this.options.title = MWF.xApplication.Selector.LP.selectPerson;
            }
        }
        if (this.options.disabled) {
            this.afterLoadSelectItem();
            return;
        }

        if (this.options.dutys.length) {
            this.loadInclude(function () {
                this.includeLoaded = true;
                if (this.dutyLoaded) {
                    this.afterLoadSelectItem();
                }
            }.bind(this));

            var units = [];
            var unitUniques = [];
            for (var i = 0; i < this.options.units.length; i++) {
                var unit = this.options.units[i];
                if (typeOf(unit) === "string") {
                    units.push(unit);
                    unitUniques.push( this.getUnitUniqueFormDn(unit) );
                } else {
                    units.push(unit.distinguishedName || unit.unique || unit.levelName || unit.id );
                    unitUniques.push( unit.distinguishedName ? this.getUnitUniqueFormDn(unit.distinguishedName) : (unit.unique || unit.levelName || unit.id) );
                }
            }
            this.unitStringList = units;
            this.unitUniqueList = unitUniques;

            this.loadingCountDuty = "wait";

            o2.Actions.load("x_organization_assemble_express").UnitDutyAction.listIdentityWithUnitWithNameObject({
                nameList: this.options.dutys,
                unitList: units,
                recursiveUnit : !!this.options.expandSubEnable
            }, function (json) {
                this.allIdentityData = json.data;

                this.setUnitLevelNameMap(); //如果需要检查状态，创建身份-所在组织层次名对应关系
                // this.setUnitLevelNameMapInValues(); //如果需要检查状态，创建已选值身份-所在组织层次名对应关系

                this._loadSelectItems(json.data)
            }.bind(this))
        }else{
            this.afterLoadSelectItem();
        }

        if( this.isCheckStatusOrCount() ) {
            this.loadingCountInclude = "wait";
            this.loadIncludeCount();
        }
    },
    _loadSelectItems: function (identityList) {
        //this.listAllIdentityInUnitObject( identityList );
        this.listNestedUnitByIdentity(identityList, function (unitTree) {
            this.dataTree = unitTree;
            this.uniqueIdentity(unitTree);
            this.loadingCountDuty = "ready";
            this.checkLoadingCount();
            if (this.options.dutyUnitLevelBy === "duty") {
                this.level1Container = [];
                if (this.options.units && this.options.units.length) {
                    this.options.units.each( function (unit ,i) {
                        var div = new Element("div").inject(this.itemAreaNode);
                        this.level1Container.push(div);
                    }.bind(this))
                }
                this._loadSelectItemsByDutyUnit(unitTree);
            } else {
                this._loadSelectItemsByIdentityUnit(unitTree);
            }

            this.dutyLoaded = true;
            if (this.includeLoaded) {
                this.afterLoadSelectItem();
            }
        }.bind(this));
    },
    _loadSelectItemsByIdentityUnit: function (unitTree) {
        if (!unitTree.unitList) return;
        this.sortUnit(unitTree.unitList);
        for (var i = 0; i < unitTree.unitList.length; i++) {
            var unit = unitTree.unitList[i];
            // if( !this.isExcluded( unit ) ) {
            var category = this._newItemCategory("ItemCategory", unit, this, this.itemAreaNode);
            this.subCategorys.push(category);

            var key = this.options.dutyUnitLevelBy === "duty" ? "matchUnitLevelName" : "unitLevelName";
            this.subCategoryMapWithDuty[unit.matchLevelName || unit.levelName] = category;
            // }
        }
    },
    sortUnit: function (unitList) {
        if (this.options.dutyUnitLevelBy === "duty") {
            if (this.options.units) {
                unitList.sort(function (a, b) {
                    var idxA = this.getIndexFromUnitOption(a);
                    var idxB = this.getIndexFromUnitOption(b);
                    if( a.orderNumber === 0 )a.orderNumber = -1;
                    if( b.orderNumber === 0 )b.orderNumber = -1;
                    idxA = idxA === -1 ? 9999999 + (a.orderNumber || 9999999) : idxA;
                    idxB = idxB === -1 ? 9999999 + (b.orderNumber || 9999999) : idxB;
                    return idxA - idxB;
                }.bind(this))
            } else {
                unitList.sort(function (a, b) {
                    if( a.orderNumber === 0 )a.orderNumber = -1;
                    if( b.orderNumber === 0 )b.orderNumber = -1;
                    return (a.orderNumber || 9999999) - (b.orderNumber || 9999999);
                }.bind(this))
            }
        } else {
            unitList.sort(function (a, b) {
                if( a.orderNumber === 0 )a.orderNumber = -1;
                if( b.orderNumber === 0 )b.orderNumber = -1;
                return (a.orderNumber || 9999999) - (b.orderNumber || 9999999);
            }.bind(this))
        }
    },
    _loadSelectItemsByDutyUnit: function (unitTree) {
        if (!unitTree.unitList) return;
        // this.sortUnit( unitTree.unitList );
        for (var i = 0; i < unitTree.unitList.length; i++) {
            var unit = unitTree.unitList[i];
            if (this.isUnitContain(unit)) {
                // if( !this.isExcluded( unit ) ) {
                var container = this.itemAreaNode;
                if (this.level1Container && this.level1Container.length) {
                    var index = this.getIndexFromUnitOption(unit);
                    if (index > -1 && (this.level1Container.length > index) && this.level1Container[index]) container = this.level1Container[index];
                }
                var category = this._newItemCategory("ItemCategory", unit, this, container);
                this.subCategorys.push(category);
                this.subCategoryMapWithDuty[unit.matchLevelName || unit.levelName] = category;
                // }
            } else {
                this._loadSelectItemsByDutyUnit(unit);
            }
        }
    },
    getIndexFromUnitOption: function (unit) {
        if (!this.unitStringList || !this.unitStringList.length) return -1;
        var idx = -1;
        if (idx == -1 && unit.distinguishedName) idx = this.unitStringList.indexOf(unit.distinguishedName);
        if (idx == -1 && unit.id) idx = this.unitStringList.indexOf(unit.id);
        if (idx == -1 && unit.unique) idx = this.unitStringList.indexOf(unit.unique);
        if (idx == -1 && unit.levelName) idx = this.unitStringList.indexOf(unit.levelName);
        if (idx == -1 && unit.unique ) idx = this.unitUniqueList.indexOf(unit.unique);
        if (idx == -1 && !unit.unique && unit.distinguishedName ) idx = this.unitUniqueList.indexOf(unit.distinguishedName.split("@")[1]||"");
        return idx
    },
    isUnitContain: function (d) {
        if (this.options.units.length === 0) return true;
        if (!this.unitFlagMap) {
            this.unitFlagMap = {};
            this.options.units.each(function (e) {
                if (!e) return;
                this.unitFlagMap[typeOf(e) === "string" ? e : (e.distinguishedName || e.unique || e.employee || e.levelName || e.id)] = true;
            }.bind(this));
        }
        if (!this.unitUniqueMap) {
            this.unitUniqueMap = {};
            this.unitUniqueList.each(function (e) {
                if (!e) return;
                this.unitUniqueMap[e] = true;
            }.bind(this));
        }
        var map = this.unitFlagMap;
        var uniqueMap = this.unitUniqueMap;
        var flag = (d.distinguishedName && map[d.distinguishedName]) ||
            (d.levelName && map[d.levelName]) ||
            (d.id && map[d.id]) ||
            (d.unique && map[d.unique]) ||
            (d.unique && uniqueMap[d.unique]);
        if( !flag && !d.unique && d.distinguishedName ){
            var arr = d.distinguishedName.split("@");
            if( arr.length === 3 && arr[1] && uniqueMap[arr[1]] ){
                flag = true;
            }
        }
        return flag;
    },
    listAllUnitObject: function (identityList, callback) {
        var key = this.options.dutyUnitLevelBy === "duty" ? "matchUnitLevelName" : "unitLevelName";
        var unitArray = [];
        for (var i = 0; i < identityList.length; i++) {
            var levelNames = identityList[i][key];
            //if( !levelNames && key === "matchUnitLevelName" )levelNames = identityList[i].unitLevelName;
            var unitLevelNameList = levelNames.split("/");
            var nameList = [];
            for (var j = 0; j < unitLevelNameList.length; j++) {
                nameList.push(unitLevelNameList[j]);
                var name = nameList.join("/");
                if (!unitArray.contains(name)) {
                    unitArray.push(name);
                }
            }
        }
        // o2.Actions.load("x_organization_assemble_express").UnitAction.listObject({
        o2.Actions.load("x_organization_assemble_express").UnitAction.listWithLevelNameObject({
            unitList: unitArray
        }, function (json) {
            this.allUnitObjectWithDuty = {};
            json.data.each(function (u) {
                if(u && u.levelName)this.allUnitObjectWithDuty[u.levelName] = u;
            }.bind(this));
            if (callback) callback();
        }.bind(this))
    },
    listNestedUnitByIdentity: function (identityList, callback) {
        this.listAllUnitObject(identityList, function () {
            this._listNestedUnitByIdentity(identityList, callback);
        }.bind(this));
    },
    _listNestedUnitByIdentity: function (identityList, callback) {
        debugger;
        //identityList = Array.unique(identityList);
        var key = this.options.dutyUnitLevelBy === "duty" ? "matchUnitLevelName" : "unitLevelName";
        //根据unitLevelName整合成组织树
        var unitTree = {};
        for (var i = 0; i < identityList.length; i++) {
            var flag = true;
            if (this.isExcluded(identityList[i])) continue;

            var levelNames = identityList[i][key];
            //if( !levelNames && key === "matchUnitLevelName" )levelNames = identityList[i].unitLevelName;
            var unitLevelNameList = levelNames.split("/");
            var nameList = [];
            var tree = unitTree;
            for (var j = 0; j < unitLevelNameList.length; j++) {
                nameList.push(unitLevelNameList[j]);
                var name = nameList.join("/");

                if (this.isExcluded(this.allUnitObjectWithDuty[name] || {})) {
                    flag = false;
                    break;
                }

                if (!tree.unitList) tree.unitList = [];
                var found = false;
                for (var k = 0; k < tree.unitList.length; k++) {
                    if (tree.unitList[k].levelName == name) {
                        tree = tree.unitList[k];
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    // var obj = {};
                    var obj = this.allUnitObjectWithDuty[name] || {};
                    obj.matchLevelName = name;
                    tree.unitList.push(obj);
                    tree = obj;
                }
                // if( !tree.distinguishedName ){
                //     tree = Object.merge( tree, this.allUnitObjectWithDuty[name] );
                // }
                if (!tree.identityList) tree.identityList = [];

            }
            if (flag) tree.identityList.push(identityList[i]);
        }
        if(callback)callback(unitTree);
    },
    uniqueIdentity: function (tree) {

        var map = {};
        var indexMap = {};

        var isExist = function (d, index) {
            if ((d.distinguishedName && map[d.distinguishedName]) ||
                (d.levelName && map[d.levelName]) ||
                (d.id && map[d.id]) ||
                (d.unique && map[d.unique])) {
                return true;
            } else {
                var key = typeOf(d) === "string" ? d : (d.distinguishedName || d.unique || d.employee || d.levelName || d.id);
                map[key] = true;
                indexMap[key] = index+1;
                return false;
            }
        };

        var getIndex = function (d){
            var index = ((d.distinguishedName && indexMap[d.distinguishedName]) ||
                (d.levelName && indexMap[d.levelName]) ||
                (d.id && indexMap[d.id]) ||
                (d.unique && indexMap[d.unique]));
            if( !index )index = 0;
            return index-1;
        };

        var identityList = [];
        if (tree.identityList) {
            for (var i = 0; i < tree.identityList.length; i++) {
                if (!isExist(tree.identityList[i], i)){
                    identityList.push(tree.identityList[i]);
                }else if( this.options.identitySortBy !== "identityNumber" ){
                    var index = getIndex(tree.identityList[i]);
                    if( index > -1 ){
                        var identity = tree.identityList[index];
                        if( !identity.otherMatchUnitDutyList ){
                            identity.otherMatchUnitDutyList = []
                        }
                        identity.otherMatchUnitDutyList.push({
                            matchUnitDutyNumber : tree.identityList[i].matchUnitDutyNumber,
                            matchUnitDutyName : tree.identityList[i].matchUnitDutyName
                        })
                    }

                }
            }
        }
        tree.identityList = identityList;

        if (this.isCheckStatusOrCount()) {
            var names = (tree.matchLevelName || tree.levelName || "").split("/");
            var nameList = [];

            var selectedCount = 0;
            tree.identityList.each(function (id) {
                if( this.isInValues(id) )selectedCount++;
            }.bind(this));

            for (var i = 0; i < names.length; i++) {
                nameList.push(names[i]);
                var name = nameList.join("/");
                var obj = this.allUnitObjectWithDuty[name];
                if (obj) {
                    obj.subNestedIdentityCount = (obj.subNestedIdentityCount || 0) + identityList.length;
                    obj.selectedNestedIdentityCount = (obj.selectedNestedIdentityCount || 0) + selectedCount;
                }
            }
        }

        if (tree.unitList) {
            for (var i = 0; i < tree.unitList.length; i++) {
                this.uniqueIdentity(tree.unitList[i]);
            }
        }
    },
    createItemsSearchData: function(callback){
        if (!this.itemsSearchData){
            this.itemsSearchData = [];
            MWF.require("MWF.widget.PinYin", function(){
                var initIds = [];

                var _self = this;
                function checkIdentity(data) {
                    var id = data.distinguishedName || data.name || data.id || data.text;
                    if (initIds.indexOf( id )==-1){
                        var text = data.name || "";
                        if( !text && data.distinguishedName ){
                            var dn = data.distinguishedName.split("@");
                            text = dn[0];
                        }
                        var pinyin = text.toPY().toLowerCase();
                        var firstPY = text.toPYFirst().toLowerCase();
                        _self.itemsSearchData.push({
                            "text": text,
                            "pinyin": pinyin,
                            "firstPY": firstPY,
                            "data": data
                        });
                        initIds.push( id );
                    }
                }

                function checkUnit(unit) {
                    if(unit.identityList && unit.identityList.length){
                        unit.identityList.each( function (identity) {
                            checkIdentity(identity);
                        })
                    }
                    if(unit.unitList && unit.unitList.length){
                        unit.unitList.each( function (unit) {
                            checkUnit(unit);
                        })
                    }
                }

                this.dataTree.unitList.each(function(unit){
                    checkUnit(unit);
                }.bind(this));
                delete initIds;
                if (callback) callback();
            }.bind(this));
        }else{
            if (callback) callback();
        }
    },
    //listNestedUnitByIdentity : function( identityList ){
    //    debugger;
    //    this.unitArray = [];
    //    var key = this.options.dutyUnitLevelBy === "duty" ? "matchUnitLevelName" : "unitLevelName";
    //    //根据unitLevelName整合成组织树
    //    var unitTree = {};
    //    for( var i=0; i<identityList.length; i++ ){
    //        var levelNames = identityList[i][key];
    //        //if( !levelNames && key === "matchUnitLevelName" )levelNames = identityList[i].unitLevelName;
    //        var unitLevelNameList = levelNames.split("/");
    //        var nameList = [];
    //        var tree = unitTree;
    //        for( var j=0; j<unitLevelNameList.length; j++ ){
    //            nameList.push( unitLevelNameList[j] );
    //            var name = nameList.join("/");
    //            if( !tree[ name ] ){
    //                tree[ name ] = {
    //                    name : unitLevelNameList[j],
    //                    levelName : name,
    //                    identityList : []
    //                };
    //                this.unitArray.push( name );
    //            }
    //            tree =  tree[name];
    //        }
    //        tree.identityList.push( identityList[i] );
    //    }
    //    return unitTree;
    //},
    _scrollEvent: function (y) {
        return true;
    },
    _getChildrenItemIds: function () {
        return null;
    },
    _newItemCategory: function (type, data, selector, item, level, category, delay) {
        return new MWF.xApplication.Selector.IdentityWidthDutyCategoryByUnit[type](data, selector, item, level, category, delay)
    },

    _listItemByKey: function (callback, failure, key) {
        if (this.options.units.length) key = {"key": key, "unitList": this.options.units};
        this.orgAction.listIdentityByKey(function (json) {
            if (callback) callback.apply(this, [json]);
        }.bind(this), failure, key);
    },
    _getItem: function (callback, failure, id, async) {
        if (typeOf(id) === "string") {
            this.orgAction.getIdentity(function (json) {
                if (callback) callback.apply(this, [json]);
            }.bind(this), failure, ((typeOf(id) === "string") ? id : id.distinguishedName), async);
        } else {
            if (callback) callback.apply(this, [id]);
        }
        //this.orgAction.getIdentity(function(json){
        //    if (callback) callback.apply(this, [json]);
        //}.bind(this), failure, ((typeOf(id)==="string") ? id : id.distinguishedName), async);
    },
    _newItemSelected: function (data, selector, item, selectedNode) {
        return new MWF.xApplication.Selector.IdentityWidthDutyCategoryByUnit.ItemSelected(data, selector, item, selectedNode)
    },
    _listItemByPinyin: function (callback, failure, key) {
        if (this.options.units.length) key = {"key": key, "unitList": this.options.units};
        this.orgAction.listIdentityByPinyin(function (json) {
            if (callback) callback.apply(this, [json]);
        }.bind(this), failure, key);
    },
    _newItem: function (data, selector, container, level, category, delay) {
        return new MWF.xApplication.Selector.IdentityWidthDutyCategoryByUnit.Item(data, selector, container, level, category, delay);
    },
    _newItemSearch: function (data, selector, container, level) {
        return new MWF.xApplication.Selector.IdentityWidthDutyCategoryByUnit.SearchItem(data, selector, container, level);
    },
    setUnitLevelNameMap: function(){
        var map = this.unitLevelNameMap = {};
        if (this.isCheckStatusOrCount() && this.allIdentityData.length > 0) {
            var key = this.options.dutyUnitLevelBy === "duty" ? "matchUnitLevelName" : "unitLevelName";
            this.allIdentityData.each(function(id) {
                if (!map[id.distinguishedName]) {
                    map[id.distinguishedName] = [id[key]];
                }else if( !map[id.distinguishedName].contains(id[key]) ){
                    map[id.distinguishedName].push(id[key]);
                }
            })
        }
    },
    getUnitLevelNameFormMap: function(id){
        return (this.unitLevelNameMap && this.unitLevelNameMap[id.distinguishedName]) || [];
    },
    addSelectedCount: function( itemOrItemSelected, count ){
        if( this.loadingCountInclude === "ignore" ){
            this._addSelectedCountWithDuty(itemOrItemSelected, count);
        }else{
            this._addSelectedCountWithDuty(itemOrItemSelected, count);
            this._addSelectedCount(itemOrItemSelected, count);
        }

    },
    _addSelectedCountWithDuty: function( itemOrItemSelected, count ){
        var itemData = itemOrItemSelected.data;
        var unitlevelNameList = this.getUnitLevelNameFormMap(itemData);
        unitlevelNameList.each(function (levelName) {
            var subCategoryMap = this.subCategoryMapWithDuty;
            var list = levelName.split("/");
            var nameList = [];
            for (var j = 0; j < list.length; j++) {
                nameList.push(list[j]);
                var name = nameList.join("/");
                if ( subCategoryMap[name] ) {
                    var category = subCategoryMap[name];
                    category._addSelectedCount(count);
                    subCategoryMap = category.subCategoryMapWithDuty;
                }

                var obj = this.allUnitObjectWithDuty[name];
                if (obj) {
                    obj.selectedNestedIdentityCount = obj.selectedNestedIdentityCount + count;
                }
            }
        }.bind(this));
    },


    // setUnitLevelNameMapInValues: function(){ //取消选择的时候用
    //     var map = this.unitLevelNameMapInValues = {};
    //     if (this.isCheckStatusOrCount() && this.options.values.length > 0) {
    //         var vMap = {};
    //         this.options.values.each( function( e ){
    //             if( !e )return;
    //             vMap[ typeOf( e ) === "string" ? e : ( e.distinguishedName || e.unique || e.levelName) ] = true;
    //         }.bind(this));
    //
    //         var key = this.options.dutyUnitLevelBy === "duty" ? "matchUnitLevelName" : "unitLevelName";
    //         this.allIdentityData.each(function(id) {
    //             if (vMap[id.distinguishedName]) {
    //                 if (!map[id.distinguishedName]) {
    //                     map[id.distinguishedName] = [id[key]];
    //                 }else if( !map[id.distinguishedName].contains(id[key]) ){
    //                     map[id.distinguishedName].push(id[key]);
    //                 }
    //             }else if (vMap[id.unique]) {
    //                 if (!map[id.unique]) {
    //                     map[id.unique] = [id[key]];
    //                 }else if( !map[id.unique].contains(id[key]) ){
    //                     map[id.unique].push(id[key]);
    //                 }
    //             }else if (vMap[id.levelName]) {
    //                 if (!map[id.levelName]) {
    //                     map[id.levelName] = [id[key]];
    //                 }else if( !map[id.levelName].contains(id[key]) ){
    //                     map[id.levelName].push(id[key]);
    //                 }
    //             }
    //         })
    //     }
    // },
    // getUnitLevelNameFormValueMap: function(id){
    //     var map = this.unitLevelNameMapInValues;
    //     var list = [];
    //     if( map[id.distinguishedName] )list = list.concat(map[id.distinguishedName]);
    //     if( map[id.unique] )list = list.concat(map[id.unique]);
    //     if( map[id.levelName] )list = list.concat(map[id.levelName]);
    //     return list;
    // },
    // checkCountAndStatusByUnselectItem: function( itemData ){
    //     debugger;
    //     var unitlevelNameList = this.getUnitLevelNameFormValueMap(itemData);
    //     unitlevelNameList.each(function (levelName) {
    //         var subCategoryMap = this.subCategoryMap;
    //         var list = levelName.split("/");
    //         var nameList = [];
    //         for (var j = 0; j < list.length; j++) {
    //             nameList.push(list[j]);
    //             var name = nameList.join("/");
    //             if ( subCategoryMap[name] ) {
    //                 var category = subCategoryMap[name];
    //                 category._addSelectedCount(-1);
    //                 subCategoryMap = category.subCategoryMap;
    //             }
    //
    //             var obj = this.allUnitObjectWithDuty[name];
    //             if (obj) {
    //                 obj.selectedNestedIdentityCount = obj.selectedNestedIdentityCount - 1;
    //             }
    //         }
    //     }.bind(this));
    // }
    //_listItemNext: function(last, count, callback){
    //    this.action.listRoleNext(last, count, function(json){
    //        if (callback) callback.apply(this, [json]);
    //    }.bind(this));
    //}
});
MWF.xApplication.Selector.IdentityWidthDutyCategoryByUnit.Item = new Class({
    Extends: MWF.xApplication.Selector.IdentityWidthDuty.Item
});
MWF.xApplication.Selector.IdentityWidthDutyCategoryByUnit.SearchItem = new Class({
    Extends: MWF.xApplication.Selector.IdentityWidthDuty.SearchItem
});

MWF.xApplication.Selector.IdentityWidthDutyCategoryByUnit.ItemSelected = new Class({
    Extends: MWF.xApplication.Selector.IdentityWidthDuty.ItemSelected
});

MWF.xApplication.Selector.IdentityWidthDutyCategoryByUnit.ItemCategory = new Class({
    Extends: MWF.xApplication.Selector.IdentityWidthDuty.ItemCategory,
    _getShowName: function () {
        return this.data.name;
    },
    _addSelectAllSelectedCount: function (count, nested) {
        debugger;
        var c = (this._getSelectAllSelectedCount() || 0) + count;
        this.selectedCount = c;
        this._checkCountAndStatus(c);

        if (nested && this.category && this.category._addSelectAllSelectedCount) {
            this.category._addSelectAllSelectedCount(count, nested);
        }
    },
    _getSelectAllSelectedCount: function () {
        debugger;
        if (typeOf(this.selectedCount) === "number") {
            return this.selectedCount;
        } else {
            return 0;
        }
    },


    _addSelectedCount: function (count, nested) {
        if( this.selector.loadingCount === "done" ){
            var c = (this._getSelectedCount() || 0) + count;
            this.selectedCount = c;
            this._checkCountAndStatus(c);
        }else{
            this.selectedCount_wait = (this.selectedCount_wait || 0) + count;
        }

        if (nested && this.category && this.category._addSelectedCount) {
            this.category._addSelectedCount(count, nested);
        }
    },
    _getTotalCount: function () {
        return this.data.subNestedIdentityCount;
    },
    _getSelectedCount : function(){
        if( typeOf(this.selectedCount) === "number" )return this.selectedCount;
        if( !this.selector.allUnitObjectWithDuty )return 0;
        var levelName = this.data.matchLevelName || this.data.levelName;
        var unit =  this.selector.allUnitObjectWithDuty[levelName];
        var count = unit ? unit.selectedNestedIdentityCount : 0;
        this.selectedCount = count + (this.selectedCount_wait || 0);
        this.selectedCount_wait = 0;
        return this.selectedCount;
    },
    isExisted: function (d) {
        if (!d) return true;
        if (!this.createdItemObject) this.createdItemObject = {};
        var map = this.createdItemObject;
        if ((d.distinguishedName && map[d.distinguishedName]) ||
            (d.levelName && map[d.levelName]) ||
            (d.id && map[d.id]) ||
            (d.unique && map[d.unique])) {
            return true;
        } else {
            //if( typeOf( d ) === "string" ){
            //    this.createdItemObject[ d ] = true;
            //}else{
            //    if( d.distinguishedName )this.createdItemObject[ d.distinguishedName ] = true;
            //    if( d.id )this.createdItemObject[ d.id ] = true;
            //    if( d.unique )this.createdItemObject[ d.unique ] = true;
            //    if( d.employee )this.createdItemObject[ d.employee ] = true;
            //    if( d.levelName )this.createdItemObject[ d.levelName ] = true;
            //}
            this.createdItemObject[typeOf(d) === "string" ? d : (d.distinguishedName || d.unique || d.employee || d.levelName || d.id)] = true;
            return false;
        }
    },
    sortIdentityList : function(){
        if( this.selector.options.identitySortBy === "identityNumber" ){
            this.data.identityList.sort(function (a, b) {
                //this.selector.getUnitOrderNumber( a.unitLevelName )
                if( a.orderNumber === 0 )a.orderNumber = -1;
                if( b.orderNumber === 0 )b.orderNumber = -1;
                return (a.orderNumber || 9999999) - (b.orderNumber || 9999999);
            });
        }else{
            var getOrderNumber = function (d) {
                var orderNumber = "999";
                if( d.matchUnitDutyName ){
                    var idx = this.selector.options.dutys.indexOf( d.matchUnitDutyName );
                    if( idx > -1 )orderNumber = idx.toString();
                }
                if( typeOf(d.matchUnitDutyNumber) === "number" ){
                    orderNumber += d.matchUnitDutyNumber.toString();
                }else{
                    orderNumber += "9999";
                }
                return orderNumber.toInt();
            }.bind(this);

            var getOrder = function (d) {
                if( d.otherMatchUnitDutyList && d.otherMatchUnitDutyList.length ){
                    var array = [getOrderNumber(d)];
                    d.otherMatchUnitDutyList.each(function (duty) {
                        array.push( getOrderNumber(duty) );
                    });
                    return array.min();
                }else{
                    return getOrderNumber(d);
                }
            }.bind(this);

            this.data.identityList.sort(function (a, b) {
                return getOrder(a) - getOrder(b);
            });
        }
    },
    loadSub: function (callback) {
        this._loadSub(function (firstLoad) {
            if (firstLoad && this.selector.isCheckStatusOrCount()) {

                if (this.selector.loadingCount === "done"){
                    this.checkCountAndStatus();
                }

            }
            if (callback) callback();
        }.bind(this))
    },
    _loadSub: function (callback) {
        if (!this.loaded) {
            if (!this.itemLoaded) {
                if (this.data.identityList && this.data.identityList.length > 0) {

                    this.sortIdentityList();

                    this.data.identityList.each(function (identity) {
                        // if( !this.selector.isExcluded( identity ) ) {
                        //     if( !this.isExisted( identity ) ){
                        var item = this.selector._newItem(identity, this.selector, this.children, this.level + 1, this);
                        this.selector.items.push(item);
                        if (this.subItems) this.subItems.push(item);
                        // }
                        // }
                    }.bind(this))
                }
                this.itemLoaded = true;
            }

            if( !this.categoryLoaded ){
                if (this.data.unitList && this.data.unitList.length) {
                    this.data.unitList.sort(function (a, b) {
                        if( a.orderNumber === 0 )a.orderNumber = -1;
                        if( b.orderNumber === 0 )b.orderNumber = -1;
                        return (a.orderNumber || 9999999) - (b.orderNumber || 9999999);
                    });
                    this.data.unitList.each(function (subData) {
                        // if( !this.selector.isExcluded( subData ) ) {
                        var category = this.selector._newItemCategory("ItemCategory", subData, this.selector, this.children, this.level + 1, this);
                        this.subCategorys.push(category);
                        this.subCategoryMapWithDuty[subData.matchLevelName || subData.levelName] = category;
                        // category.loadSub()
                        // }
                    }.bind(this));
                }
                this.categoryLoaded = true;
            }

            this.loaded = true;

            if (callback) callback(true);
        } else {
            if (callback) callback();
        }
    },
    loadCategoryChildren: function (callback) {
        if (!this.categoryLoaded) {
            this.loadSub();

            this.categoryLoaded = true;
            this.itemLoaded = true;
            if (callback) callback();
        } else {
            if (callback) callback();
        }
    },
    loadItemChildren: function (callback) {
        if (!this.itemLoaded) {
            if (this.data.identityList && this.data.identityList.length > 0) {
                // this.data.identityList.sort(function (a, b) {
                //     if( a.orderNumber === 0 )a.orderNumber = -1;
                //     if( b.orderNumber === 0 )b.orderNumber = -1;
                //     return (a.orderNumber || 9999999) - (b.orderNumber || 9999999);
                // });

                this.sortIdentityList();

                this.data.identityList.each(function (identity) {
                    // if( !this.selector.isExcluded( identity ) ) {
                    //     if( !this.isExisted( identity ) ){
                    var item = this.selector._newItem(identity, this.selector, this.children, this.level + 1, this);
                    this.selector.items.push(item);
                    if (this.subItems) this.subItems.push(item);
                    // }
                    // }
                }.bind(this))
            }
            this.itemLoaded = true;
            if (callback) callback();
        } else {
            if (callback) callback();
        }
    },
    _hasChild: function () {
        return (this.data.unitList && this.data.unitList.length > 0) ||
            (this.data.identityList && this.data.identityList.length > 0);
    },
    _hasChildCategory: function () {
        return (this.data.unitList && this.data.unitList.length > 0);
    },
    _hasChildItem: function () {
        return this.data.identityList && this.data.identityList.length > 0;
    }

});

MWF.xApplication.Selector.IdentityWidthDutyCategoryByUnit.ItemUnitCategory = new Class({
    Extends: MWF.xApplication.Selector.IdentityWidthDuty.ItemUnitCategory
});

MWF.xApplication.Selector.IdentityWidthDutyCategoryByUnit.ItemGroupCategory = new Class({
    Extends: MWF.xApplication.Selector.IdentityWidthDuty.ItemGroupCategory
});

MWF.xApplication.Selector.IdentityWidthDutyCategoryByUnit.Filter = new Class({
    Extends: MWF.xApplication.Selector.IdentityWidthDuty.Filter
});

MWF.xApplication.Selector = MWF.xApplication.Selector || {};
MWF.xDesktop.requireApp("Selector", "Unit", null, false);
MWF.xApplication.Selector.UnitWithType = new Class({
	Extends: MWF.xApplication.Selector.Unit,
    options: {
        "style": "default",
        "count": 0,
        "units": [],
        "unitType": "",
        "values": [],
        "zIndex": 1000,
        "expand": true,
        "exclude" : [],
        "selectType" : "unit",
        "expandSubEnable" : true, //是否允许展开下一层
        "selectAllEnable" : true //分类是否允许全选下一层
    },
    setInitTitle: function(){
        this.setOptions({"title": MWF.xApplication.Selector.LP.selectUnit});
    },
    _init : function(){
        this.selectType = "unit";
        this.className = "UnitWithType";
    },
    loadSelectItems: function(addToNext){

        if( this.options.disabled ){
            this.afterLoadSelectItem();
            return;
        }

        this._loadSelectItems();
    },
    _loadSelectItems: function(){
        var afterLoadSelectItemFun = this.afterLoadSelectItem.bind(this);

        var data = {};
        data.type = this.options.unitType;
        data.unitList = [];
        this.options.units.each(function(unit){
            if (typeOf(unit)==="string"){
                data.unitList.push(unit);
            }else{
                data.unitList.push(unit.distinguishedName);
            }
        }.bind(this));

        if( this.isCheckStatusOrCount() ) {
            this.loadingCount = "wait";
            this.loadCount( data.unitList );
        }

        //data.unitList = this.options.units;
        this.orgAction.listUnitByType(function(json){
            if (json.data.length){
                json.data.each(function(data){
                    if( !this.isExcluded( data ) ) {
                        if ( !this.options.expandSubEnable || (!this.options.unitType) || data.typeList.indexOf(this.options.unitType)!==-1){
                            var unit = this._newItem(data, this, this.itemAreaNode, 1);
                            this.items.push(unit);
                            this.subItems.push(unit);
                        }else{
                            if (data.woSubDirectUnitList.length){
                                var category = this._newItemCategory("ItemCategory", data, this, this.itemAreaNode);
                                this.subCategorys.push(category);
                                this.subCategoryMap[data.levelName] = category;
                            }
                        }
                    }
                }.bind(this));
            }
            afterLoadSelectItemFun();
        }.bind(this), afterLoadSelectItemFun, data);
    },

    _scrollEvent: function(y){
        return true;
    },
    _getChildrenItemIds: function(){
        return null;
    },
    _newItemCategory: function(type, data, selector, item, level, category, delay){
        return new MWF.xApplication.Selector.UnitWithType[type](data, selector, item, level, category, delay)
    },

    _listItemByKey: function(callback, failure, key){
        if( this.options.expandSubEnable ){
            key = {"key": key};
            if (this.options.units.length){
                var units = [];
                this.options.units.each(function(u){
                    if (typeOf(u)==="string"){
                        units.push(u);
                    }
                    if (typeOf(u)==="object"){
                        units.push(u.distinguishedName);
                    }
                });
                key.unitList = units;
            }
            if (this.options.unitType) key.type = this.options.unitType;
            this.orgAction.listUnitByKey(function(json){
                if (callback) callback.apply(this, [json]);
            }.bind(this), failure, key);
        }else{
            if (key){
                this.initSearchArea(true);
                this.searchInItems(key);
            }else{
                this.initSearchArea(false);
            }
        }
    },
    _getItem: function(callback, failure, id, async){
        this.orgAction.getUnit(function(json){
            if (callback) callback.apply(this, [json]);
        }.bind(this), failure, ((typeOf(id)==="string") ? id : id.distinguishedName), async);
    },

    _newItemSelected: function(data, selector, item, selectedNode){
        return new MWF.xApplication.Selector.UnitWithType.ItemSelected(data, selector, item, selectedNode)
    },
    _listItemByPinyin: function(callback, failure, key){
        key = {"key": key};
        if (this.options.units.length){
            var units = [];
            this.options.units.each(function(u){
                if (typeOf(u)==="string"){
                    units.push(u);
                }
                if (typeOf(u)==="object"){
                    units.push(u.distinguishedName);
                }
            });
            key.unitList = units;
        }
        if (this.options.unitType) key.type = this.options.unitType;
        this.orgAction.listUnitByPinyininitial(function(json){
            if (callback) callback.apply(this, [json]);
        }.bind(this), failure, key);
    },
    _newItem: function(data, selector, container, level, category, delay){
        return new MWF.xApplication.Selector.UnitWithType.Item(data, selector, container, level, category, delay);
    },
    _newItemSearch: function(data, selector, container, level){
        return new MWF.xApplication.Selector.UnitWithType.SearchItem(data, selector, container, level);
    }
});
MWF.xApplication.Selector.UnitWithType.Item = new Class({
	Extends: MWF.xApplication.Selector.Unit.Item,
    _getShowName: function(){
        return (this.isShowLevelName && this.data.levelName) ? this.data.levelName : this.data.name;
    },
    _getTtiteText: function(){
        return this.data.levelName || this.data.name;
    },
    _setIcon: function(){
        var style = this.selector.options.style;
        this.iconNode.setStyle("background-image", "url("+"../x_component_Selector/$Selector/"+style+"/icon/departmenticon.png)");
    },
    loadSubItem: function(){
        if( !this.selector.options.expandSubEnable )return;
        this.isExpand = (this.selector.options.expand);
        if (this.data.woSubDirectUnitList && this.data.woSubDirectUnitList.length){
            if (this.selector.options.expand){
                if (this.level===1){
                    this.levelNode.setStyles(this.selector.css.selectorItemLevelNode_expand);
                    this.loadSubItems();
                }else{
                    this.isExpand = false;
                    this.levelNode.setStyles(this.selector.css.selectorItemLevelNode_collapse);
                }
            }else{
                this.levelNode.setStyles(this.selector.css.selectorItemLevelNode_collapse);
            }
            this.levelNode.addEvent("click", function(e){
                if (this.isExpand){
                    this.selector.fireEvent("collapse", [this] );
                    this.children.setStyle("display", "none");
                    this.levelNode.setStyles(this.selector.css.selectorItemLevelNode_collapse);
                    this.isExpand = false;
                }else{
                    this.selector.fireEvent("expand", [this] );
                    this.loadSubItems();
                    this.levelNode.setStyles(this.selector.css.selectorItemLevelNode_expand);
                    this.isExpand = true;
                }
                e.stopPropagation();
            }.bind(this));

            if( !this.selectAllNode && !this.selector.isFlatCategory ){
                this.selectAllNode = new Element("div", {
                    "styles": this.selector.css.selectorItemCategoryActionNode_selectAll,
                    "title" : MWF.SelectorLP.selectChildren
                }).inject(this.textNode, "before");
                //this.selectAllNode.addEvent( "click", function(ev){
                //    this.selectAll(ev);
                //    ev.stopPropagation();
                //}.bind(this))
                this.selectAllNode.addEvent( "click", function(ev) {
                    if (this.isSelectedAll) {
                        // this.unselectAll(ev);
                        this.selector.options.selectAllRange === "all" ? this.unselectAllNested(ev, null, true) : this.unselectAll(ev, null, true);
                        this.selector.fireEvent("unselectCatgory", [this]);
                        this.selector.fireEvent("unselectCategory", [this])
                    } else {
                        // this.selectAll(ev);
                        this.selector.options.selectAllRange === "all" ? this.selectAllNested(ev, true) : this.selectAll(ev, true);
                        this.selector.fireEvent("selectCatgory", [this]);
                        this.selector.fireEvent("selectCategory", [this])
                    }
                    ev.stopPropagation();
                });
            }
        }
    },
    loadSubItems: function(callback){
        if (!this.loaded && !this.loading){
            this.loading = true;
            if (!this.children){
                this.children = new Element("div", {
                    "styles": this.selector.css.selectorItemCategoryChildrenNode
                }).inject(this.node, "after");
            }
            this.children.setStyle("display", "block");
            ( this.data.woSubDirectUnitList || [] ).each(function(subData){
                if( !this.selector.isExcluded( subData ) ) {
                    if ((!this.selector.options.unitType) || subData.typeList.indexOf(this.selector.options.unitType) !== -1) {
                        var unit = this.selector._newItem(subData, this.selector, this.children, this.level + 1, this);
                        this.selector.items.push( unit );
                        if( !this.subItems )this.subItems = [];
                        this.subItems.push( unit );
                    } else {
                        if (subData.woSubDirectUnitList.length){ // ? 原来是data.woSubDirectUnitList.length 2020-3-1
                            var category = this.selector._newItemCategory("ItemCategory", subData, this.selector, this.children, this.level+1, this);
                            this.subCategorys.push( category );
                            this.subCategoryMap[subData.levelName] = category;
                        }
                    }
                }
                if(callback)callback()
            }.bind(this));
            this.loaded = true;
            this.loading = false;
        }else{
            this.children.setStyle("display", "block");
        }
    },
    postLoad : function(){
    },

    //for flat category start
    loadCategoryChildren : function( callback ){
        if (!this.categoryLoaded){
            this.data.woSubDirectUnitList.each(function(subData){
                if( !this.selector.isExcluded( subData ) ) {
                    if ((!this.selector.options.unitType) || subData.typeList.indexOf(this.selector.options.unitType) !== -1) {
                    } else {
                        if (subData.woSubDirectUnitList.length){
                            var category = this.selector._newItemCategory("ItemCategory", subData, this.selector, this.children, this.level+1, this);
                            this.subCategorys.push( category );
                            this.subCategoryMap[subData.levelName] = category;
                        }
                    }
                }
                if(callback)callback()
            }.bind(this));
            this.categoryLoaded = true;
        }else{
            //if(callback)callback();
        }
    },
    loadItemChildren : function( callback ){
        if (!this.itemLoaded){
            if (!this.children){
                this.children = new Element("div", {
                    "styles": this.selector.css.selectorItemCategoryChildrenNode
                }).inject(this.selector.itemAreaNode);
            }
            this.children.setStyle("display", "block");
            this.data.woSubDirectUnitList.each(function(subData){
                if( !this.selector.isExcluded( subData ) ) {
                    if ((!this.selector.options.unitType) || subData.typeList.indexOf(this.selector.options.unitType) !== -1) {
                        var unit = this.selector._newItem(subData, this.selector, this.children, this.level + 1, this, true);
                        unit.justItem = true;
                        unit.load();
                        this.selector.items.push( unit );
                        if( !this.subItems )this.subItems = [];
                        this.subItems.push( unit );
                    }
                }
                if(callback)callback()
            }.bind(this));
            this.itemLoaded = true;
        }else{
            this.children.setStyle("display", "block");
            //if(callback)callback();
        }
    }
    //for flat category end
});

MWF.xApplication.Selector.UnitWithType.SearchItem = new Class({
    //Extends: MWF.xApplication.Selector.Unit.Item,
    Extends: MWF.xApplication.Selector.UnitWithType.Item,
    load : function(){
        this.loadForNormal(true);
    },
    _getShowName: function(){
        // return this.data.levelName || this.data.name;
        return this.data.name+((this.data.levelName) ? "("+this.data.levelName+")" : "");
    },
    loadSubItems: function( callback ){
    }
});

MWF.xApplication.Selector.UnitWithType.ItemSelected = new Class({
	Extends: MWF.xApplication.Selector.Unit.ItemSelected,
    // _getShowName: function(){
    //     return this.data.levelName || this.data.name;
    // },
    _getTtiteText: function(){
        return this.data.levelName || this.data.name;
    },
    _getShowName: function(){
        return this.data.name+((this.data.levelName) ? "("+this.data.levelName+")" : "");
    },
    _setIcon: function(){
        var style = this.selector.options.style;
        this.iconNode.setStyle("background-image", "url("+"../x_component_Selector/$Selector/"+style+"/icon/departmenticon.png)");
    }
});

MWF.xApplication.Selector.UnitWithType.ItemCategory = new Class({
    Extends: MWF.xApplication.Selector.Unit.ItemCategory,

    loadSub: function(callback){
        if (!this.loaded){
            this.data.woSubDirectUnitList.each(function(subData){
                if( !this.selector.isExcluded( subData ) ) {
                    if ((!this.selector.options.unitType) || subData.typeList.indexOf(this.selector.options.unitType)!==-1){
                        var unit = this.selector._newItem(subData, this.selector, this.children, this.level+1, this);
                        this.selector.items.push( unit );
                        if(this.subItems)this.subItems.push( unit );
                    }else{
                        if (subData.woSubDirectUnitList.length){
                            var category = this.selector._newItemCategory("ItemCategory", subData, this.selector, this.children, this.level+1, this);
                            this.subCategorys.push(category);
                            this.subCategoryMap[subData.levelName] = category;
                        }
                    }
                }
                if( !this.subItems || !this.subItems.length ){
                    if( this.selectAllNode ){
                        this.selectAllNode.destroy();
                    }
                }
            }.bind(this));
            this.loaded = true;
            if (callback) callback();
        }else{
            if (callback) callback();
        }
    },
    afterLoad: function(){
        if( this.actionNode )this.actionNode.setStyles(this.selector.css.selectorItemCategoryActionNode_collapse);
        if( this.children )this.children.setStyle("display", "none");
        if (this.level===1) this.clickItem();
        var flag = false;
        this.data.woSubDirectUnitList.each(function(subData) {
            if (!this.selector.isExcluded(subData)) {
                if ((!this.selector.options.unitType) || subData.typeList.indexOf(this.selector.options.unitType) !== -1) {
                    flag = true;
                }
            }
            if (!flag && this.selectAllNode)this.selectAllNode.destroy();
        }.bind(this));
    },
    _hasChild: function(){
        return this.data.woSubDirectUnitList.length;
    },
    _hasChildCategory: function(){
        return this.data.woSubDirectUnitList.length;
    },
    _hasChildItem: function(){
        if( typeOf(this.isHasChildItem) === "boolean" )return this.isHasChildItem;
        this.isHasChildItem = false;
        var unitList = this.data.woSubDirectUnitList || [];
        for( var i=0; i<unitList.length; i++){
            if ((!this.selector.options.unitType) || unitList[i].typeList.indexOf(this.selector.options.unitType) !== -1) {
                this.isHasChildItem = true;
                break;
            }
        }
        return this.isHasChildItem;
    },

    //for flat category start
    loadCategoryChildren: function(callback){
        if (!this.categoryLoaded){
            this.data.woSubDirectUnitList.each(function(subData){
                if( !this.selector.isExcluded( subData ) ) {
                    if ((!this.selector.options.unitType) || subData.typeList.indexOf(this.selector.options.unitType)!==-1){
                    }else{
                        if (subData.woSubDirectUnitList.length){
                            var category = this.selector._newItemCategory("ItemCategory", subData, this.selector, this.children, this.level+1, this);
                            this.subCategorys.push(category);
                            this.subCategoryMap[subData.levelName] = category;
                        }
                    }
                }
            }.bind(this));
            this.categoryLoaded = true;
            if (callback) callback();
        }else{
            if (callback) callback( );
        }
    },
    loadItemChildren: function(callback){
        if (!this.itemLoaded){
            this.data.woSubDirectUnitList.each(function(subData){
                if( !this.selector.isExcluded( subData ) ) {
                    if ((!this.selector.options.unitType) || subData.typeList.indexOf(this.selector.options.unitType)!==-1){
                        var unit = this.selector._newItem(subData, this.selector, this.children, this.level+1, this);
                        this.selector.items.push( unit );
                        if(this.subItems)this.subItems.push( unit );
                    }
                }
                if( !this.subItems || !this.subItems.length ){
                    if( this.selectAllNode ){
                        this.selectAllNode.destroy();
                    }
                }
            }.bind(this));
            this.itemLoaded = true;
            if (callback) callback();
        }else{
            if (callback) callback( );
        }
    }
});

MWF.xApplication.Selector.UnitWithType.Filter = new Class({
    Implements: [Options, Events],
    options: {
        "style": "default",
        "units": []
    },
    initialize: function(value, options){
        this.setOptions(options);
        this.value = value;
        this.orgAction = MWF.Actions.get("x_organization_assemble_control");
    },
    filter: function(value, callback){
        this.value = value;
        var key = this.value;
        key = {"key": key};

        if (this.options.units.length){
            var units = [];
            this.options.units.each(function(u){
                if (typeOf(u)==="string"){
                    units.push(u);
                }
                if (typeOf(u)==="object"){
                    units.push(u.distinguishedName);
                }
            });
            key.unitList = units;
        }
        if (this.options.unitType) key.type = this.options.unitType;
        this.orgAction.listUnitByKey(function(json){
            data = json.data;
            if (callback) callback(data)
        }.bind(this), failure, key);

    }
});

MWF.xScript = MWF.xScript || {};
MWF.xScript.Actions = MWF.xScript.Actions || {};
MWF.require("MWF.xDesktop.Actions.RestActions", null, false);
var invoke = function(serviceName){
    return function(data, success, failure, async, parameter){
        return this.action.invoke({"name": serviceName, "parameter": parameter, "data": data, "async": async, "success": success,"failure": failure});
    }
};

MWF.xScript.Actions.UnitActions = new Class({
	initialize: function(){
        this.actionPath = "/xScript/Actions/unitAction.json";
		this.action = new MWF.xDesktop.Actions.RestActions(this.actionPath, "x_organization_assemble_express");
    },
    //群组--------
    listGroup: invoke("listGroup"),
    listSubGroupDirect: invoke("listSubGroupDirect"),
    listSubGroupNested: invoke("listSubGroupNested"),
    listSupGroupDirect: invoke("listSupGroupDirect"),
    listSupGroupNested: invoke("listSupGroupNested"),
    listGroupWithPerson: invoke("listGroupWithPerson"),
    listGroupWithIdentity: invoke("listGroupWithIdentity"),
    groupHasRole: invoke("groupHasRole"),

    //角色--------
    listRole: invoke("listRole"),
    listRoleWithPerson: invoke("listRoleWithPerson"),

    //人员--------
    personHasRole: invoke("personHasRole"),
    getPerson: invoke("getPerson"),
    listPerson: invoke("listPerson"),
    listPersonSubDirect: invoke("listPersonSubDirect"),
    listPersonSubNested: invoke("listPersonSubested"),
    listPersonSupDirect: invoke("listPersonSupDirect"),
    listPersonSupNested: invoke("listPersonSupNested"),
    listPersonWithGroup: invoke("listPersonWithGroup"),
    listPersonWithRole: invoke("listPersonWithRole"),
    listPersonWithIdentity: invoke("listPersonWithIdentity"),
    listPersonWithUnitDirect: invoke("listPersonWithUnitDirect"),
    listPersonWithUnitNested: invoke("listPersonWithUnitNested"),
    listPersonAllAttribute: invoke("listPersonAllAttribute"),
    listPersonWithAttributeValue: invoke("listPersonWithAttributeValue"),
    listPersonWithAttribute: invoke("listPersonWithAttribute"),

    //人员属性-------
    appendPersonAttribute: invoke("appendPersonAttribute"),
    setPersonAttribute: invoke("setPersonAttribute"),
    getPersonAttribute: invoke("getPersonAttribute"),
    listPersonAttributeName: invoke("listPersonAttributeName"),

    //身份----------
    listIdentity: invoke("listIdentity"),
    listIdentityWithPerson: invoke("listIdentityWithPerson"),
    listIdentityWithUnitDirect: invoke("listIdentityWithUnitDirect"),
    listIdentityWithUnitNested: invoke("listIdentityWithUnitNested"),

    //组织----------
    listUnit: invoke("listUnit"),
    listUnitSubDirect: invoke("listUnitSubDirect"),
    listUnitSubNested: invoke("listUnitSubNested"),
    listUnitSupDirect: invoke("listUnitSupDirect"),
    listUnitSupNested: invoke("listUnitSupNested"),
    getUnitWithIdentityAndLevel: invoke("getUnitWithIdentityAndLevel"),
    getUnitWithIdentityAndType: invoke("getUnitWithIdentityAndType"),
    listUnitSupNestedWithIdentity: invoke("listUnitSupNestedWithIdentity"),
    listUnitWithIdentity: invoke("listUnitWithIdentity"),
    listUnitWithPerson: invoke("listUnitWithPerson"),
    listUnitSupNestedWithPerson: invoke("listUnitSupNestedWithPerson"),
    listUnitWithAttribute: invoke("listUnitWithAttribute"),
    listUnitWithDuty: invoke("listUnitWithDuty"),

    //组织职务-------
    getDuty: invoke("getDuty"),
    listDutyNameWithIdentity: invoke("listDutyNameWithIdentity"),
    listDutyNameWithUnit: invoke("listDutyNameWithUnit"),
    listUnitAllDuty: invoke("listUnitAllDuty"),

    //组织属性-------
    appendUnitAttribute: invoke("appendUnitAttribute"),
    setUnitAttribute: invoke("setUnitAttribute"),
    getUnitAttribute: invoke("getUnitAttribute"),
    listUnitAttributeName: invoke("listUnitAttributeName"),
    listUnitAllAttribute: invoke("listUnitAllAttribute")
});

MWF.xScript = MWF.xScript || {};
MWF.xScript.Actions = MWF.xScript.Actions || {};
MWF.require("MWF.xDesktop.Actions.RestActions", null, false);
MWF.xScript.Actions.ScriptActions = new Class({
	initialize: function(){
		this.action = new MWF.xDesktop.Actions.RestActions("", "x_processplatform_assemble_surface");
        this.action.getActions = function(callback){
            this.actions = {
                //"getScriptByName": {"uri": "/jaxrs/script/{name}/application/{applicationId}","method": "POST"},
                "getScriptByName": {"uri": "/jaxrs/script/{name}/application/{applicationId}/imported"}
            };
            if (callback) callback();
        }
    },
    getScriptByName: function(application, name, included, success, failure, async){
        this.action.invoke({"name": "getScriptByName", "async": async, "parameter": {"applicationId": application, "name": name},	"success": success,	"failure": failure});
    },
    getScript: function(id, success, failure, async){
        this.action.invoke({"name": "getScript","async": async, "parameter": {"id": id},	"success": success,	"failure": failure});
    }

    //getScriptTextDepend: function(id, text, included, success, failure){
    //    if (included.indexOf(id)==-1){
    //        this.getScript(id, function(json){
    //            included.push(json.data.name);
    //            included.push(json.data.id);
    //
    //            text = json.data.text+"\n"+text;
    //            if (json.data.dependScriptList.length){
    //                var count = json.data.dependScriptList.length;
    //                var current = 0;
    //
    //                json.data.dependScriptList.each(function(id){
    //                    this.getScriptTextDepend
    //                }.bind(this))
    //            }
    //
    //        }, failure);
    //    }
    //},
    //
    //getScriptTextByName: function(application, name, success, included, failure, async){
    //    var text = "";
    //    if (included.indexOf(name)==-1){
    //        this.getScriptByName(application, name, function(json){
    //            included.push(json.data.name);
    //            included.push(json.data.id);
    //            if (json.data.dependScriptList.length){
    //                json.data.dependScriptList.each(function(id){
    //
    //                }.bind(this))
    //            }
    //
    //
    //        }.bind(this));
    //    }else{
    //
    //    }
    //}

});
MWF.xScript = MWF.xScript || {};
MWF.xScript.Actions = MWF.xScript.Actions || {};
MWF.require("MWF.xDesktop.Actions.RestActions", null, false);
MWF.xScript.Actions.CMSScriptActions = new Class({
	initialize: function(){
		this.action = new MWF.xDesktop.Actions.RestActions("", "x_cms_assemble_control");
        this.action.getActions = function(callback){
            this.actions = {
                //"getScriptByName": {"uri": "/jaxrs/script/{uniqueName}/app/{appId}","method": "POST"},
                "getScriptByName": {"uri": "/jaxrs/script/{uniqueName}/app/{appId}/imported"}
            };
            if (callback) callback();
        }
    },
    getScriptByName: function(appId, uniqueName, included, success, failure, async){
        this.action.invoke({"name": "getScriptByName", "async": async, "parameter": {"appId": appId, "uniqueName": uniqueName},	"success": success,	"failure": failure});
    },
    getScript: function(id, success, failure, async){
        this.action.invoke({"name": "getScript","async": async, "parameter": {"id": id},	"success": success,	"failure": failure});
    },

    //getScriptTextDepend: function(id, text, included, success, failure){
    //    if (included.indexOf(id)==-1){
    //        this.getScript(id, function(json){
    //            included.push(json.data.name);
    //            included.push(json.data.id);
    //
    //            text = json.data.text+"\n"+text;
    //            if (json.data.dependScriptList.length){
    //                var count = json.data.dependScriptList.length;
    //                var current = 0;
    //
    //                json.data.dependScriptList.each(function(id){
    //                    this.getScriptTextDepend
    //                }.bind(this))
    //            }
    //
    //        }, failure);
    //    }
    //},
    //
    //getScriptTextByName: function(application, name, success, included, failure, async){
    //    var text = "";
    //    if (included.indexOf(name)==-1){
    //        this.getScriptByName(application, name, function(json){
    //            included.push(json.data.name);
    //            included.push(json.data.id);
    //            if (json.data.dependScriptList.length){
    //                json.data.dependScriptList.each(function(id){
    //
    //                }.bind(this))
    //            }
    //
    //
    //        }.bind(this));
    //    }else{
    //
    //    }
    //}

});
MWF.xScript = MWF.xScript || {};
MWF.xScript.Actions = MWF.xScript.Actions || {};
MWF.require("MWF.xDesktop.Actions.RestActions", null, false);
MWF.xScript.Actions.PortalScriptActions = new Class({
	initialize: function(){
		this.action = new MWF.xDesktop.Actions.RestActions("", "x_portal_assemble_surface");
        this.action.getActions = function(callback){
            this.actions = {
                //"getScriptByName": {"uri": "/jaxrs/script/portal/{portal}/name/{name}","method": "POST"},
                "getScriptByName": {"uri": "/jaxrs/script/portal/{portal}/name/{name}/imported"}

            };
            if (callback) callback();
        }
    },
    getScriptByName: function(application, name, included, success, failure, async){
        this.action.invoke({"name": "getScriptByName", "async": async, "parameter": {"portal": application, "name": name},	"success": success,	"failure": failure});
    },
    getScript: function(id, success, failure, async){
        this.action.invoke({"name": "getScript","async": async, "parameter": {"id": id},	"success": success,	"failure": failure});
    }

    //getScriptTextDepend: function(id, text, included, success, failure){
    //    if (included.indexOf(id)==-1){
    //        this.getScript(id, function(json){
    //            included.push(json.data.name);
    //            included.push(json.data.id);
    //
    //            text = json.data.text+"\n"+text;
    //            if (json.data.dependScriptList.length){
    //                var count = json.data.dependScriptList.length;
    //                var current = 0;
    //
    //                json.data.dependScriptList.each(function(id){
    //                    this.getScriptTextDepend
    //                }.bind(this))
    //            }
    //
    //        }, failure);
    //    }
    //},
    //
    //getScriptTextByName: function(application, name, success, included, failure, async){
    //    var text = "";
    //    if (included.indexOf(name)==-1){
    //        this.getScriptByName(application, name, function(json){
    //            included.push(json.data.name);
    //            included.push(json.data.id);
    //            if (json.data.dependScriptList.length){
    //                json.data.dependScriptList.each(function(id){
    //
    //                }.bind(this))
    //            }
    //
    //
    //        }.bind(this));
    //    }else{
    //
    //    }
    //}

});
if (!MWF.xScript || !MWF.xScript.PageEnvironment) {
    MWF.xScript = MWF.xScript || {};
    MWF.xScript.PageEnvironment = function (ev) {
        var _data = ev.data;
        var _form = ev.form;
        var _forms = ev.forms;

        this.appType = "portal";

        this.library = COMMON;
        //this.library.version = "4.0";

        //data
        var getJSONData = function (jData) {
            return new MWF.xScript.JSONData(jData, function (data, key, _self) {
                var p = {
                    "getKey": function () {
                        return key;
                    }, "getParent": function () {
                        return _self;
                    }
                };
                while (p && !_forms[p.getKey()]) p = p.getParent();
                var k = (p) ? p.getKey() : "";
                if (k) if (_forms[k]) if (_forms[k].resetData) _forms[k].resetData();
                //if (p) if (p.getKey()) if (_forms[p.getKey()]) _forms[p.getKey()].resetData();
            });
        };
        this.setData = function (data) {
            this.data = getJSONData(data);
            this.data.save = function (callback) {
                var formData = {
                    "data": data,
                    "sectionList": _form.getSectionList()
                };
                form.workAction.saveData(function (json) {
                    if (callback) callback();
                }.bind(this), null, work.id, jData);
            }
        };
        this.setData(_data);

        //workContext
        this.workContext = {
            "getTask": function () {
                return ev.task;
            },
            "getWork": function () {
                return ev.work || ev.workCompleted;
            },
            "getActivity": function () {
                return ev.activity;
            },
            "getTaskList": function () {
                return ev.taskList;
            },
            "getControl": function () {
                return ev.control;
            },
            "getWorkLogList": function () {
                return ev.workLogList;
            },
            "getAttachmentList": function () {
                return ev.attachmentList;
            },
            "getRouteList": function () {
                return (ev.task) ? ev.task.routeNameList : null;
            },
            "getInquiredRouteList": function () {
                return null;
            },
            "setTitle": function (title) {
                //if (!this.workAction){
                //    MWF.require("MWF.xScript.Actions.WorkActions", null, false);
                //    this.workAction = new MWF.xScript.Actions.WorkActions();
                //}
                //this.workAction.setTitle(ev.work.id, {"title": title});
            }
        };
        var _redefineWorkProperties = function (work) {
            if (work) {
                work.creatorPersonDn = work.creatorPerson;
                work.creatorUnitDn = work.creatorUnit;
                work.creatorUnitDnList = work.creatorUnitList;
                work.creatorIdentityDn = work.creatorIdentity;
                var o = {
                    "creatorPerson": {
                        "get": function () {
                            return this.creatorPersonDn.substring(0, this.creatorPersonDn.indexOf("@"));
                        }
                    },
                    "creatorUnit": {
                        "get": function () {
                            return this.creatorUnitDn.substring(0, this.creatorUnitDn.indexOf("@"));
                        }
                    },
                    "creatorDepartment": {
                        "get": function () {
                            return this.creatorUnitDn.substring(0, this.creatorUnitDn.indexOf("@"));
                        }
                    },
                    "creatorIdentity": {
                        "get": function () {
                            return this.creatorIdentityDn.substring(0, this.creatorIdentityDn.indexOf("@"));
                        }
                    },
                    "creatorUnitList": {
                        "get": function () {
                            var v = [];
                            this.creatorUnitDnList.each(function (dn) {
                                v.push(dn.substring(0, dn.indexOf("@")))
                            });
                            return v;
                        }
                    },
                    "creatorCompany": {
                        "get": function () {
                            return this.creatorUnitList[0]
                        }
                    }
                };
                MWF.defineProperties(work, o);
            }
            return work;
        };
        var _redefineTaskProperties = function (task) {
            if (task) {
                task.personDn = task.person;
                task.unitDn = task.unit;
                task.unitDnList = task.unitList;
                task.identityDn = task.identity;
                var o = {
                    "person": {
                        "get": function () {
                            return this.personDn.substring(0, this.personDn.indexOf("@"));
                        }
                    },
                    "unit": {
                        "get": function () {
                            return this.unitDn.substring(0, this.unitDn.indexOf("@"));
                        }
                    },
                    "department": {
                        "get": function () {
                            return this.unitDn.substring(0, this.unitDn.indexOf("@"));
                        }
                    },
                    "identity": {
                        "get": function () {
                            return this.identityDn.substring(0, this.identityDn.indexOf("@"));
                        }
                    },
                    "unitList": {
                        "get": function () {
                            var v = [];
                            this.unitDnList.each(function (dn) {
                                v.push(dn.substring(0, dn.indexOf("@")))
                            });
                            return v;
                        }
                    },
                    "company": {
                        "get": function () {
                            return this.unitList[0];
                        }
                    }
                };
                MWF.defineProperties(task, o);
            }
            return task;
        };
        _redefineWorkProperties(this.workContext.getWork());
        _redefineTaskProperties(_redefineWorkProperties(this.workContext.getTask()));

        //dict
        this.Dict = MWF.xScript.createDict(_form.json.application, "portal");
        //org
        var orgActions = null;
        var getOrgActions = function () {
            if (!orgActions) {
                MWF.require("MWF.xScript.Actions.UnitActions", null, false);
                orgActions = new MWF.xScript.Actions.UnitActions();
            }
        };
        var getNameFlag = function (name) {
            var t = typeOf(name);
            if (t === "array") {
                var v = [];
                name.each(function (id) {
                    v.push((typeOf(id) === "object") ? (id.distinguishedName || id.id || id.unique || id.name) : id);
                });
                return v;
            } else {
                return [(t === "object") ? (name.distinguishedName || name.id || name.unique || name.name) : name];
            }
        };
        this.org = {
            //群组***************
            //获取群组--返回群组的对象数组
            getGroup: function (name, async) {
                getOrgActions();
                var data = {"groupList": getNameFlag(name)};

                var v = null;

                var cb = function (json) {
                    v = json.data;
                    v = (v && v.length === 1) ? v[0] : v
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listGroup(data, cb, null, !!async);
                return (!!async) ? promise : v;

                // var v = null;
                // orgActions.listGroup(data, function(json){v = json.data;}, null, false);
                // return (v && v.length===1) ? v[0] : v;
            },
            //查询下级群组--返回群组的对象数组
            //nested  布尔  true嵌套下级；false直接下级；默认false；
            listSubGroup: function (name, nested, async) {
                getOrgActions();
                var data = {"groupList": getNameFlag(name)};

                var v = null;
                // var cb = ((async && o2.typeOf(async)=="function") ? (async.isAG ? async : async.ag()) : null) || function(json){
                //     v = json.data;
                //     return v;
                // }.ag().catch(function(json){ return json; });
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise;
                if (nested) {
                    promise = orgActions.listSubGroupNested(data, cb, null, !!async);
                } else {
                    promise = orgActions.listSubGroupDirect(data, cb, null, !!async);
                }
                return (!!async) ? promise : v;

                // var v = null;
                // if (nested){
                //     orgActions.listSubGroupNested(data, function(json){v = json.data;}, null, false);
                // }else{
                //     orgActions.listSubGroupDirect(data, function(json){v = json.data;}, null, false);
                // }
                // return v;
            },
            //查询上级群组--返回群组的对象数组
            //nested  布尔  true嵌套上级；false直接上级；默认false；
            listSupGroup: function (name, nested, async) {
                getOrgActions();
                var data = {"groupList": getNameFlag(name)};

                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise
                if (nested) {
                    var promise = orgActions.listSupGroupNested(data, cb, null, !!async);
                } else {
                    var promise = orgActions.listSupGroupDirect(data, cb, null, !!async);
                }
                return (!!async) ? promise : v;
                // var v = null;
                // if (nested){
                //     orgActions.listSupGroupNested(data, function(json){v = json.data;}, null, false);
                // }else{
                //     orgActions.listSupGroupDirect(data, function(json){v = json.data;}, null, false);
                // }
                // return v;
            },
            //人员所在群组（嵌套）--返回群组的对象数组
            listGroupWithPerson: function (name, async) {
                getOrgActions();
                var data = {"personList": getNameFlag(name)};

                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listGroupWithPerson(data, cb, null, !!async);
                return (!!async) ? promise : v;
                // var v = null;
                // orgActions.listGroupWithPerson(data, function(json){v = json.data;}, null, false);
                // return v;
            },
            //身份所在群组（嵌套）--返回群组的对象数组
            listGroupWithIdentity:function(identity, async){
                getOrgActions();
                var data = {"identityList": getNameFlag(identity)};

                var v = null;
                var cb = function(json){
                    v = json.data;
                    if (async && o2.typeOf(async)=="function") return async(v);
                    return v;
                };

                var promise = orgActions.listGroupWithIdentity(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //群组是否拥有角色--返回true, false
            groupHasRole: function (name, role, async) {
                getOrgActions();
                nameFlag = (typeOf(name) === "object") ? (name.distinguishedName || name.id || name.unique || name.name) : name;
                var data = {"group": nameFlag, "roleList": getNameFlag(role)};

                var v = false;
                var cb = function (json) {
                    v = json.data.value;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.groupHasRole(data, cb, null, !!async);
                return (!!async) ? promise : v;

                // var v = false;
                // orgActions.groupHasRole(data, function(json){v = json.data.value;}, null, false);
                // return v;
            },

            //角色***************
            //获取角色--返回角色的对象数组
            getRole: function (name, async) {
                getOrgActions();
                var data = {"roleList": getNameFlag(name)};

                var v = null;
                var cb = function (json) {
                    v = json.data;
                    v = (v && v.length === 1) ? v[0] : v;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listRole(data, cb, null, !!async);
                return (!!async) ? promise : v;

                // var v = null;
                // orgActions.listRole(data, function(json){v = json.data;}, null, false);
                // return (v && v.length===1) ? v[0] : v;
            },
            //人员所有角色（嵌套）--返回角色的对象数组
            listRoleWithPerson: function (name, async) {
                getOrgActions();
                var data = {"personList": getNameFlag(name)};

                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listRoleWithPerson(data, cb, null, !!async);
                return (!!async) ? promise : v;
                // var v = null;
                // orgActions.listRoleWithPerson(data, function(json){v = json.data;}, null, false);
                // return v;
            },

            //人员***************
            //人员是否拥有角色--返回true, false
            personHasRole: function (name, role, async) {
                getOrgActions();
                nameFlag = (typeOf(name) === "object") ? (name.distinguishedName || name.id || name.unique || name.name) : name;
                var data = {"person": nameFlag, "roleList": getNameFlag(role)};

                var v = false;
                var cb = function (json) {
                    v = json.data.value;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.personHasRole(data, cb, null, !!async);
                return (!!async) ? promise : v;

                // var v = false;
                // orgActions.personHasRole(data, function(json){v = json.data.value;}, null, false);
                // return v;
            },
            //获取人员,附带身份,身份所在的组织,个人所在群组,个人拥有角色.
            getPersonData: function(name, async){
                getOrgActions();
                var v = null;
                var cb = function(json){
                    v = json.data;
                    if (async && o2.typeOf(async)=="function") return async(v);
                    return v;
                };
                var promise = orgActions.getPerson(null, cb, null, !!async, {"flag": name});
                return (!!async) ? promise : v;
            },
            //获取人员--返回人员的对象数组
            getPerson: function (name, async, findCN) {
                getOrgActions();
                var data = {"personList": getNameFlag(name)};
                if( o2.typeOf(findCN) === "boolean"){
                    data.useNameFind = findCN;
                }
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    v = (v && v.length === 1) ? v[0] : v;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listPerson(data, cb, null, !!async);
                return (!!async) ? promise : v;
                // var v = null;
                // orgActions.listPerson(data, function(json){v = json.data;}, null, false);
                // return (v && v.length===1) ? v[0] : v;
            },
            //查询下级人员--返回人员的对象数组
            //nested  布尔  true嵌套下级；false直接下级；默认false；
            listSubPerson: function (name, nested, async) {
                getOrgActions();
                var data = {"personList": getNameFlag(name)};

                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise;
                if (nested) {
                    promise = orgActions.listPersonSubNested(data, cb, null, !!async);
                } else {
                    promise = orgActions.listPersonSubDirect(data, cb, null, !!async);
                }
                return (!!async) ? promise : v;
            },
            //查询上级人员--返回人员的对象数组
            //nested  布尔  true嵌套上级；false直接上级；默认false；
            listSupPerson: function (name, nested, async) {
                getOrgActions();
                var data = {"personList": getNameFlag(name)};
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise;
                if (nested) {
                    promise = orgActions.listPersonSupNested(data, cb, null, !!async);
                } else {
                    promise = orgActions.listPersonSupDirect(data, cb, null, !!async);
                }
                return (!!async) ? promise : v;
            },
            //获取群组的所有人员--返回人员的对象数组
            listPersonWithGroup: function (name, async) {
                getOrgActions();
                var data = {"groupList": getNameFlag(name)};

                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listPersonWithGroup(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //获取角色的所有人员--返回人员的对象数组
            listPersonWithRole: function (name, async) {
                getOrgActions();
                var data = {"roleList": getNameFlag(name)};
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise
                promise = orgActions.listPersonWithRole(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //获取身份的所有人员--返回人员的对象数组
            listPersonWithIdentity: function (name, async) {
                getOrgActions();
                var data = {"identityList": getNameFlag(name)};
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listPersonWithIdentity(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //获取身份的所有人员--返回人员的对象数组或人员对象
            getPersonWithIdentity: function (name, async) {
                getOrgActions();
                var data = {"identityList": getNameFlag(name)};
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    v = (v && v.length === 1) ? v[0] : v;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listPersonWithIdentity(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //查询组织成员的人员--返回人员的对象数组
            //nested  布尔  true嵌套的所有成员；false直接成员；默认false；
            listPersonWithUnit: function (name, nested, async) {
                getOrgActions();
                var data = {"unitList": getNameFlag(name)};
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise;
                if (nested) {
                    promise = orgActions.listPersonWithUnitNested(data, cb, null, !!async);
                } else {
                    promise = orgActions.listPersonWithUnitDirect(data, cb, null, !!async);
                }
                return (!!async) ? promise : v;
            },
            //根据属性查询人员--返回人员的对象数组
            //name  string 属性名
            //value  string 属性值
            listPersonWithAttribute: function (name, value, async) {
                getOrgActions();
                var data = {"name": name, "attribute": value};
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listPersonWithAttribute(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //根据属性查询人员--返回人员的全称数组
            //name  string 属性名
            //value  string 属性值
            listPersonNameWithAttribute: function (name, value, async) {
                getOrgActions();
                var data = {"name": name, "attribute": value};
                var v = null;
                var cb = function (json) {
                    v = json.data.personList;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listPersonWithAttributeValue(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },

            //人员属性************
            //添加人员属性值(在属性中添加values值，如果没有此属性，则创建一个)
            appendPersonAttribute: function (person, attr, values, success, failure, async) {
                getOrgActions();
                var personFlag = (typeOf(person) === "object") ? (person.distinguishedName || person.id || person.unique || person.name) : person;
                var data = {"attributeList": values, "name": attr, "person": personFlag};

                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };
                var promise = orgActions.appendPersonAttribute(data, cb, null, !!async);
                return (!!async) ? promise : v;

                // var cb = function(json){
                //     if (success) return success(json);
                // }.ag().catch(function(xhr, text, error){
                //     if (failure) return failure(xhr, text, error);
                // });
                //
                // orgActions.appendPersonAttribute(data, cb, null, !!async);
            },
            //设置人员属性值(将属性值修改为values，如果没有此属性，则创建一个)
            setPersonAttribute: function (person, attr, values, success, failure, async) {
                getOrgActions();
                var personFlag = (typeOf(person) === "object") ? (person.distinguishedName || person.id || person.unique || person.name) : person;
                var data = {"attributeList": values, "name": attr, "person": personFlag};

                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };
                var promise = orgActions.setPersonAttribute(data, cb, null, !!async);
                return (!!async) ? promise : v;

                // var cb = function(json){
                //     if (success) return success(json);
                // }.ag().catch(function(xhr, text, error){
                //     if (failure) return failure(xhr, text, error);
                // });
                //
                // orgActions.setPersonAttribute(data, cb, null, !!async);
            },
            //获取人员属性值
            getPersonAttribute: function (person, attr, async) {
                getOrgActions();
                var personFlag = (typeOf(person) === "object") ? (person.distinguishedName || person.id || person.unique || person.name) : person;
                var data = {"name": attr, "person": personFlag};
                var v = null;
                var cb = function (json) {
                    v = json.data.attributeList;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.getPersonAttribute(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //列出人员所有属性的名称
            listPersonAttributeName: function (name, async) {
                getOrgActions();
                var data = {"personList": getNameFlag(name)};
                var v = null;
                var cb = function (json) {
                    v = json.data.nameList;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listPersonAttributeName(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //列出人员的所有属性
            listPersonAllAttribute: function (name, async) {
                getOrgActions();
                var data = {"personList": getNameFlag(name)};
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listPersonAllAttribute(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },

            //身份**********
            //获取身份
            getIdentity: function (name, async) {
                getOrgActions();
                var data = {"identityList": getNameFlag(name)};
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    v = (v && v.length === 1) ? v[0] : v;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listIdentity(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //列出人员的身份
            listIdentityWithPerson: function (name, async, findCN) {
                getOrgActions();
                var data = {"personList": getNameFlag(name)};
                if( o2.typeOf(findCN) === "boolean"){
                    data.useNameFind = findCN;
                }
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listIdentityWithPerson(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //查询组织成员身份--返回身份的对象数组
            //nested  布尔  true嵌套的所有成员；false直接成员；默认false；
            listIdentityWithUnit: function (name, nested, async) {
                getOrgActions();
                var data = {"unitList": getNameFlag(name)};
                var v = null;

                // var cb = function(json){
                //     v = json.data;
                //     if (async && o2.typeOf(async)=="function") return async(v);
                //     return v;
                // }.ag().catch(function(json){ return json; });

                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var method = (nested) ? "listIdentityWithUnitNested" : "listIdentityWithUnitDirect";
                var promise = orgActions[method](data, cb, null, !!async);
                promise.name = "org";

                //
                // if (nested){
                //     orgActions.listIdentityWithUnitNested(data, cb, null, !!async);
                // }else{
                //     orgActions.listIdentityWithUnitDirect(data, cb, null, !!async);
                // }
                return (!!async) ? promise : v;
            },

            //组织**********
            //获取组织
            getUnit: function (name, async, findCN) {
                getOrgActions();
                var data = {"unitList": getNameFlag(name)};
                if( o2.typeOf(findCN) === "boolean"){
                    data.useNameFind = findCN;
                }
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    v = (v && v.length === 1) ? v[0] : v;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listUnit(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //查询组织的下级--返回组织的对象数组
            //nested  布尔  true嵌套下级；false直接下级；默认false；
            listSubUnit: function (name, nested, async) {
                getOrgActions();
                var data = {"unitList": getNameFlag(name)};
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise;
                if (nested) {
                    promise = orgActions.listUnitSubNested(data, cb, null, !!async);
                } else {
                    promise = orgActions.listUnitSubDirect(data, cb, null, !!async);
                }
                return (!!async) ? promise : v;
            },
            //查询组织的上级--返回组织的对象数组
            //nested  布尔  true嵌套上级；false直接上级；默认false；
            //async 布尔 true异步请求
            listSupUnit: function (name, nested, async) {
                getOrgActions();
                var data = {"unitList": getNameFlag(name)};

                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise;
                if (nested) {
                    promise = orgActions.listUnitSupNested(data, cb, null, !!async);
                } else {
                    promise = orgActions.listUnitSupDirect(data, cb, null, !!async);
                }
                return (!!async) ? promise : v;

                // if (callback){
                //     if (nested){
                //         orgActions.listUnitSupNested(data, function(json){v = json.data; o2.runCallback(callback, "success", [v], this);});
                //     }else{
                //         orgActions.listUnitSupDirect(data, function(json){v = json.data; o2.runCallback(callback, "success", [v], this);});
                //     }
                // }else{
                //     var v = null;
                //     if (nested){
                //         orgActions.listUnitSupNested(data, function(json){v = json.data;}, null, false);
                //     }else{
                //         orgActions.listUnitSupDirect(data, function(json){v = json.data;}, null, false);
                //     }
                //     return v;
                // }
            },
            //根据个人身份获取组织
            //flag 数字    表示获取第几层的组织
            //     字符串  表示获取指定类型的组织
            //     空     表示获取直接所在的组织
            getUnitByIdentity: function (name, flag, async) {
                getOrgActions();
                var getUnitMethod = "current";
                var v;
                if (flag) {
                    if (typeOf(flag) === "string") getUnitMethod = "type";
                    if (typeOf(flag) === "number") getUnitMethod = "level";
                }

                var cb;
                var promise;
                switch (getUnitMethod) {
                    case "current":
                        var data = {"identityList": getNameFlag(name)};

                        // var cb = ((async && o2.typeOf(async)=="function") ? (async.isAG ? async : async.ag()) : null) || function(json){
                        //     v = json.data;  v=(v&&v.length===1) ? v[0] : v; return v;
                        // }.ag().catch(function(json){ return json; });


                        cb = function (json) {
                            v = json.data;
                            v = (v && v.length === 1) ? v[0] : v;
                            if (async && o2.typeOf(async) == "function") return async(v);
                            return v;
                        };


                        promise = orgActions.listUnitWithIdentity(data, cb, null, !!async);
                        break;
                    case "type":
                        var data = {
                            "identity": (typeOf(name) === "object") ? (name.distinguishedName || name.id || name.unique || name.name) : name,
                            "type": flag
                        };

                        cb = function (json) {
                            v = json.data;
                            if (async && o2.typeOf(async) == "function") return async(v);
                            return v;
                        };

                        // var cb = ((async && o2.typeOf(async)=="function") ? (async.isAG ? async : async.ag()) : null) || function(json){
                        //     v = json.data;  return v;
                        // }.ag().catch(function(json){ return json; });

                        promise = orgActions.getUnitWithIdentityAndType(data, cb, null, !!async);
                        break;
                    case "level":
                        var data = {
                            "identity": (typeOf(name) === "object") ? (name.distinguishedName || name.id || name.unique || name.name) : name,
                            "level": flag
                        };

                        cb = function (json) {
                            v = json.data;
                            v = (v && v.length === 1) ? v[0] : v;
                            if (async && o2.typeOf(async) == "function") return async(v);
                            return v;
                        };

                        // var cb = ((async && o2.typeOf(async)=="function") ? (async.isAG ? async : async.ag()) : null) || function(json){
                        //     v = json.data;  return v;
                        // }.ag().catch(function(json){ return json; });

                        promise = orgActions.getUnitWithIdentityAndLevel(data, cb, null, !!async);
                        break;
                }
                return (!!async) ? promise : v;
            },
            //列出身份所在组织的所有上级组织
            listAllSupUnitWithIdentity: function (name, async) {
                getOrgActions();
                var data = {"identityList": getNameFlag(name)};
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listUnitSupNestedWithIdentity(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //获取人员所在的所有组织
            listUnitWithPerson: function (name, async) {
                getOrgActions();
                var data = {"personList": getNameFlag(name)};
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listUnitWithPerson(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //列出人员所在组织的所有上级组织
            listAllSupUnitWithPerson: function (name, async) {
                getOrgActions();
                var data = {"personList": getNameFlag(name)};
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listUnitSupNestedWithPerson(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //根据组织属性，获取所有符合的组织
            listUnitWithAttribute: function (name, attribute, async) {
                getOrgActions();
                var data = {"name": name, "attribute": attribute};
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                promise = orgActions.listUnitWithAttribute(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //根据组织职务，获取所有符合的组织
            listUnitWithDuty: function (name, id, async) {
                getOrgActions();
                var data = {
                    "name": name,
                    "identity": (typeOf(id) === "object") ? (id.distinguishedName || id.id || id.unique || id.name) : id
                };
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listUnitWithDuty(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },

            //组织职务***********
            //获取指定的组织职务的身份
            getDuty: function (duty, id, async) {
                getOrgActions();
                var data = {
                    "name": duty,
                    "unit": (typeOf(id) === "object") ? (id.distinguishedName || id.id || id.unique || id.name) : id
                };
                var v = null;

                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.getDuty(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //获取身份的所有职务名称
            listDutyNameWithIdentity: function (name, async) {
                getOrgActions();
                var data = {"identityList": getNameFlag(name)};
                var v = null;
                var cb = function (json) {
                    v = json.data.nameList;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listDutyNameWithIdentity(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //获取组织的所有职务名称
            listDutyNameWithUnit: function (name, async) {
                getOrgActions();
                var data = {"unitList": getNameFlag(name)};
                var v = null;
                var cb = function (json) {
                    v = json.data.nameList;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listDutyNameWithUnit(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //获取组织的所有职务
            listUnitAllDuty: function (name, async) {
                getOrgActions();
                var data = {"unitList": getNameFlag(name)};
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listUnitAllDuty(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //列出顶层组织
            listTopUnit: function (async) {
                var action = MWF.Actions.get("x_organization_assemble_control");
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = action.listTopUnit(cb, null, !!async);
                return (!!async) ? promise : v;
            },

            //组织属性**************
            //添加组织属性值(在属性中添加values值，如果没有此属性，则创建一个)
            appendUnitAttribute: function (unit, attr, values, success, failure, async) {
                getOrgActions();
                var unitFlag = (typeOf(unit) === "object") ? (unit.distinguishedName || unit.id || unit.unique || unit.name) : unit;
                var data = {"attributeList": values, "name": attr, "unit": unitFlag};

                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };
                var promise = orgActions.appendUnitAttribute(data, cb, null, !!async);
                return (!!async) ? promise : v;

                // var cb = function(json){
                //     if (success) return success(json);
                // }.ag().catch(function(xhr, text, error){
                //     if (failure) return failure(xhr, text, error);
                // });
                //
                // orgActions.appendPersonAttribute(data, cb, null, !!async);

                // orgActions.appendUnitAttribute(data, function(json){
                //     if (json.data.value){
                //         if (success) success();
                //     }else{
                //         if (failure) failure(null, "", "append values failed");
                //     }
                // }, function(xhr, text, error){
                //     if (failure) failure(xhr, text, error);
                // }, false);
            },
            //设置组织属性值(将属性值修改为values，如果没有此属性，则创建一个)
            setUnitAttribute: function (unit, attr, values, success, failure, async) {
                getOrgActions();
                var unitFlag = (typeOf(unit) === "object") ? (unit.distinguishedName || unit.id || unit.unique || unit.name) : unit;
                var data = {"attributeList": values, "name": attr, "unit": unitFlag};

                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };
                var promise = orgActions.setUnitAttribute(data, cb, null, !!async);
                return (!!async) ? promise : v;

                // var cb = function(json){
                //     if (success) return success(json);
                // }.ag().catch(function(xhr, text, error){
                //     if (failure) return failure(xhr, text, error);
                // });
                // orgActions.setUnitAttribute(data, cb, null, !!async);

                // orgActions.setUnitAttribute(data, function(json){
                //     if (json.data.value){
                //         if (success) success();
                //     }else{
                //         if (failure) failure(null, "", "append values failed");
                //     }
                // }, function(xhr, text, error){
                //     if (failure) failure(xhr, text, error);
                // }, false);
            },
            //获取组织属性值
            getUnitAttribute: function (unit, attr, async) {
                getOrgActions();
                var unitFlag = (typeOf(unit) === "object") ? (unit.distinguishedName || unit.id || unit.unique || unit.name) : unit;
                var data = {"name": attr, "unit": unitFlag};
                var v = null;
                var cb = function (json) {
                    v = json.data.attributeList;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.getUnitAttribute(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //列出组织所有属性的名称
            listUnitAttributeName: function (name, async) {
                getOrgActions();
                var data = {"unitList": getNameFlag(name)};
                var v = null;
                var cb = function (json) {
                    v = json.data.nameList;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listUnitAttributeName(data, cb, null, !!async);
                return (!!async) ? promise : v;
            },
            //列出组织的所有属性
            listUnitAllAttribute: function (name, async) {
                getOrgActions();
                var data = {"unitList": getNameFlag(name)};
                var v = null;
                var cb = function (json) {
                    v = json.data;
                    if (async && o2.typeOf(async) == "function") return async(v);
                    return v;
                };

                var promise = orgActions.listUnitAllAttribute(data, cb, null, !!async);
                return (!!async) ? promise : v;
            }
        };

        this.Action = (function () {
            var actions = [];
            return function (root, json) {
                var action = actions[root] || (actions[root] = new MWF.xDesktop.Actions.RestActions("", root, ""));
                action.getActions = function (callback) {
                    if (!this.actions) this.actions = {};
                    Object.merge(this.actions, json);
                    if (callback) callback();
                };
                this.invoke = function (option) {
                    action.invoke(option)
                }
            }
        })();
        // this.service = {
        //     "jaxwsClient": {},
        //     "jaxrsClient": {}
        // };

        var lookupAction = null;
        var getLookupAction = function (callback) {
            if (!lookupAction) {
                MWF.require("MWF.xDesktop.Actions.RestActions", function () {
                    lookupAction = new MWF.xDesktop.Actions.RestActions("", "x_processplatform_assemble_surface", "");
                    lookupAction.getActions = function (actionCallback) {
                        this.actions = {
                            //"lookup": {"uri": "/jaxrs/view/flag/{view}/application/flag/{application}"},
                            //"getView": {"uri": "/jaxrs/view/{id}/design"}
                            "lookup": {
                                "uri": "/jaxrs/queryview/flag/{view}/application/flag/{application}/execute",
                                "method": "PUT"
                            },
                            "getView": {"uri": "/jaxrs/queryview/flag/{view}/application/flag/{application}"}
                        };
                        if (actionCallback) actionCallback();
                    }
                    if (callback) callback();
                });
            } else {
                if (callback) callback();
            }
        };

        this.view = {
            "lookup": function (view, callback, async) {
                var filterList = {"filterList": (view.filter || null)};
                return MWF.Actions.load("x_query_assemble_surface").ViewAction.executeWithQuery(view.view, view.application, filterList, function (json) {
                    var data = {
                        "grid": json.data.grid || json.data.groupGrid,
                        "groupGrid": json.data.groupGrid
                    };
                    if (callback) callback(data);
                    return data;
                }, null, async);
            },

            "lookupV1": function (view, callback) {
                getLookupAction(function () {
                    lookupAction.invoke({
                        "name": "lookup",
                        "async": true,
                        "parameter": {"view": view.view, "application": view.application},
                        "success": function (json) {
                            var data = {
                                "grid": json.data.grid,
                                "groupGrid": json.data.groupGrid
                            };
                            if (callback) callback(data);
                        }.bind(this)
                    });
                }.bind(this));
            },
            "select": function (view, callback, options) {
                if (view.view) {
                    var viewJson = {
                        "application": view.application || _form.json.application,
                        "viewName": view.view || "",
                        "isTitle": (view.isTitle === false) ? "no" : "yes",
                        "select": (view.isMulti === false) ? "single" : "multi",
                        "filter": view.filter
                    };
                    if (!options) options = {};
                    options.width = view.width;
                    options.height = view.height;
                    options.title = view.caption;

                    var width = options.width || "700";
                    var height = options.height || "400";

                    if (layout.mobile) {
                        var size = document.body.getSize();
                        width = size.x;
                        height = size.y;
                        options.style = "viewmobile";
                    }
                    width = width.toInt();
                    height = height.toInt();

                    var size = _form.app.content.getSize();
                    var x = (size.x - width) / 2;
                    var y = (size.y - height) / 2;
                    if (x < 0) x = 0;
                    if (y < 0) y = 0;
                    if (layout.mobile) {
                        x = 20;
                        y = 0;
                    }

                    var _self = this;
                    MWF.require("MWF.xDesktop.Dialog", function () {
                        var dlg = new MWF.xDesktop.Dialog({
                            "title": options.title || "select view",
                            "style": options.style || "view",
                            "top": y,
                            "left": x - 20,
                            "fromTop": y,
                            "fromLeft": x - 20,
                            "width": width,
                            "height": height,
                            "html": "<div style='height: 100%;'></div>",
                            "maskNode": _form.app.content,
                            "container": _form.app.content,
                            "buttonList": [
                                {
                                    "text": MWF.LP.process.button.ok,
                                    "action": function () {
                                        //if (callback) callback(_self.view.selectedItems);
                                        if (callback) callback(_self.view.getData());
                                        this.close();
                                    }
                                },
                                {
                                    "text": MWF.LP.process.button.cancel,
                                    "action": function () {
                                        this.close();
                                    }
                                }
                            ]
                        });
                        dlg.show();

                        if (layout.mobile) {
                            var backAction = dlg.node.getElement(".MWF_dialod_Action_back");
                            var okAction = dlg.node.getElement(".MWF_dialod_Action_ok");
                            if (backAction) backAction.addEvent("click", function (e) {
                                dlg.close();
                            }.bind(this));
                            if (okAction) okAction.addEvent("click", function (e) {
                                //if (callback) callback(this.view.selectedItems);
                                if (callback) callback(this.view.getData());
                                dlg.close();
                            }.bind(this));
                        }

                        MWF.xDesktop.requireApp("query.Query", "Viewer", function () {
                            this.view = new MWF.xApplication.query.Query.Viewer(dlg.content.getFirst(), viewJson, {"style": "select"}, _form.app, _form.Macro);
                        }.bind(this));
                    }.bind(this));
                }
            }
        };

        this.statement = {
        execute: function (obj, callback, async) {
            if( obj.format ){
                return this._execute(obj, callback, async, obj.format);
            }else{
                if( this.needCheckFormat(obj) ){
                    var result;
                    var p = MWF.Actions.load("x_query_assemble_surface").StatementAction.getFormat(obj.name, function(json){
                        result = this._execute(obj, callback, async, json.data.format);
                        return result;
                    }.bind(this), null, async);
                    return result || p;
                }else{
                    return this._execute(obj, callback, async, "");
                }

            }
        },
            needCheckFormat: function(s){
                if( s.format )return false;
                if( typeOf(s.parameter) === "object" ){
                    for( var p in s.parameter ){
                        if( typeOf( s.parameter[p] ) === "date" )return true;
                    }
                }
                if( typeOf(s.filter) === "array" ){
                    for( var i=0; i< s.filter.length; i++){
                        var fType = s.filter[i].formatType;
                        if( ["dateTimeValue", "datetimeValue", "dateValue", "timeValue"].contains( fType ) )return true;
                    }
                }
                return false;
            },
            _execute: function(statement, callback, async, format){
                var parameter = this.parseParameter(statement.parameter, format);
                var filterList = this.parseFilter(statement.filter, parameter, format);
                var obj = {
                    "filterList": filterList,
                    "parameter" : parameter
                };
                return MWF.Actions.load("x_query_assemble_surface").StatementAction.executeV2(
                    statement.name, statement.mode || "data", statement.page || 1, statement.pageSize || 20, obj,
                    function (json) {
                        if (callback) callback(json);
                        return json;
                    }, null, async);
            },
            parseFilter: function (filter, parameter, format) {
                if (typeOf(filter) !== "array") return [];
                if( !parameter )parameter = {};
                var filterList = [];
                (filter || []).each(function (d) {
                    if( !d.logic )d.logic = "and";

                    //var parameterName = d.path.replace(/\./g, "_");
                    var pName = d.path.replace(/\./g, "_");

                    var parameterName = pName;
                    var suffix = 1;
                    while( parameter[parameterName] ){
                        parameterName = pName + "_" + suffix;
                        suffix++;
                    }
                    var value = d.value;
                    if (d.comparison === "like" || d.comparison === "notLike") {
                        if (value.substr(0, 1) !== "%") value = "%" + value;
                        if (value.substr(value.length - 1, 1) !== "%") value = value + "%";
                        parameter[parameterName] = value; //"%"+value+"%";
                    } else {
                         if( ["sql", "sqlScript"].contains(format) ) {
                            if (d.formatType === "numberValue") {
                                value = parseFloat(value);
                            }
                        }else{
                            if (d.formatType === "dateTimeValue" || d.formatType === "datetimeValue") {
                                value = "{ts '" + value + "'}"
                            } else if (d.formatType === "dateValue") {
                                value = "{d '" + value + "'}"
                            } else if (d.formatType === "timeValue") {
                                value = "{t '" + value + "'}"
                            } else if (d.formatType === "numberValue") {
                                value = parseFloat(value);
                            }
                        }
                        parameter[parameterName] = value;
                    }
                    d.value = parameterName;

                    filterList.push(d);
                }.bind(this));
                return filterList;
            },
            parseParameter : function( obj, format ){
                if( typeOf(obj) !== "object" )return {};
                var parameter = {};
                //传入的参数
                for( var p in obj ){
                    var value = obj[p];
                    if( typeOf( value ) === "date" ){
                        if( ["sql", "sqlScript"].contains(format) ){
                            value = value.format("db");
                        }else{
                            value = "{ts '"+value.format("db")+"'}"
                        }
                    }
                    parameter[ p ] = value;
                }
                return parameter;
            },
            "select": function (statement, callback, options) {
                if (statement.name) {
                    // var parameter = this.parseParameter(statement.parameter);
                    // var filterList = this.parseFilter(statement.filter, parameter);
                    var statementJson = {
                        "statementId": statement.name || "",
                        "isTitle": (statement.isTitle === false) ? "no" : "yes",
                        "select": (statement.isMulti === false) ? "single" : "multi",
                        "filter": statement.filter,
                        "parameter": statement.parameter
                    };
                    if (!options) options = {};
                    options.width = statement.width;
                    options.height = statement.height;
                    options.title = statement.caption;

                    var width = options.width || "700";
                    var height = options.height || "400";

                    if (layout.mobile) {
                        var size = document.body.getSize();
                        width = size.x;
                        height = size.y;
                        options.style = "viewmobile";
                    }
                    width = width.toInt();
                    height = height.toInt();

                    var size = _form.app.content.getSize();
                    var x = (size.x - width) / 2;
                    var y = (size.y - height) / 2;
                    if (x < 0) x = 0;
                    if (y < 0) y = 0;
                    if (layout.mobile) {
                        x = 20;
                        y = 0;
                    }

                    var _self = this;
                    MWF.require("MWF.xDesktop.Dialog", function () {
                        var dlg = new MWF.xDesktop.Dialog({
                            "title": options.title || "select statement view",
                            "style": options.style || "view",
                            "top": y,
                            "left": x - 20,
                            "fromTop": y,
                            "fromLeft": x - 20,
                            "width": width,
                            "height": height,
                            "html": "<div style='height: 100%;'></div>",
                            "maskNode": _form.app.content,
                            "container": _form.app.content,
                            "buttonList": [
                                {
                                    "text": MWF.LP.process.button.ok,
                                    "action": function () {
                                        //if (callback) callback(_self.view.selectedItems);
                                        if (callback) callback(_self.statement.getData());
                                        this.close();
                                    }
                                },
                                {
                                    "text": MWF.LP.process.button.cancel,
                                    "action": function () {
                                        this.close();
                                    }
                                }
                            ]
                        });
                        dlg.show();

                        if (layout.mobile) {
                            var backAction = dlg.node.getElement(".MWF_dialod_Action_back");
                            var okAction = dlg.node.getElement(".MWF_dialod_Action_ok");
                            if (backAction) backAction.addEvent("click", function (e) {
                                dlg.close();
                            }.bind(this));
                            if (okAction) okAction.addEvent("click", function (e) {
                                //if (callback) callback(this.view.selectedItems);
                                if (callback) callback(this.statement.getData());
                                dlg.close();
                            }.bind(this));
                        }

                        MWF.xDesktop.requireApp("query.Query", "Statement", function () {
                            this.statement = new MWF.xApplication.query.Query.Statement(dlg.content.getFirst(), statementJson, {"style": "select"}, _form.app, _form.Macro);
                        }.bind(this));
                    }.bind(this));
                }
            }
        };


        this.importer = {
            "upload": function (options, callback, async) {
                MWF.xDesktop.requireApp("query.Query", "Importer", function () {
                    var importer = new MWF.xApplication.query.Query.Importer(_form.app.content, options, {}, _form.app, _form.Macro);
                    importer.addEvent("afterImport", function (data) {
                        if(callback)callback(data);
                    });
                    importer.load();
                }.bind(this));
            },
            "downloadTemplate": function (options, fileName, callback) {
                MWF.xDesktop.requireApp("query.Query", "Importer", function () {
                    var importer = new MWF.xApplication.query.Query.Importer(_form.app.content, options, {}, _form.app, _form.Macro);
                    importer.downloadTemplate(fileName, callback);
                }.bind(this));
            }
        };

        //include 引用脚本
        //optionsOrName : {
        //  type : "", 默认为portal, 可以为 portal  process  cms
        //  application : "", 门户/流程/CMS的名称/别名/id, 默认为当前应用
        //  name : "" // 脚本名称/别名/id
        //}
        //或者name: "" // 脚本名称/别名/id
        // if( !window.includedScripts ){
        //     var includedScripts = window.includedScripts = [];
        // }else{
        //     var includedScripts = window.includedScripts;
        // }
        var includedScripts = [];
        var _includeSingle = function (optionsOrName, callback, async) {
            var options = optionsOrName;
            if (typeOf(options) == "string") {
                options = {name: options};
            }
            var name = options.name;
            var type;
            if( options.type === "service" ){
                type = options.type;
            }else{
                type = (options.type && options.application) ? options.type : "portal";
            }
            var application = options.application || _form.json.application;
            var key = type + "-" + application + "-" + name;
            if( type === "service" ){
                key = type + "-" + name;
            }
            if (includedScripts.indexOf(key) > -1) {
                if (callback) callback.apply(this);
                return;
            }
            //if (includedScripts.indexOf( name )> -1){
            //    if (callback) callback.apply(this);
            //    return;
            //}
            if (( options.enableAnonymous || options.anonymous ) && type === "cms") {
                o2.Actions.load("x_cms_assemble_control").ScriptAnonymousAction.getWithAppWithName(application, name, function (json) {
                    if (json.data) {
                        includedScripts.push(key);
                        //名称、别名、id
                        (json.data.importedList || []).each(function (flag) {
                            includedScripts.push(type + "-" + json.data.appId + "-" + flag);
                            if (json.data.appName) includedScripts.push(type + "-" + json.data.appName + "-" + flag);
                            if (json.data.appAlias) includedScripts.push(type + "-" + json.data.appAlias + "-" + flag);
                        });
                        includedScripts = includedScripts.concat(json.data.importedList || []);
                        MWF.CMSMacro.exec(json.data.text, this);
                        if (callback) callback.apply(this);
                    } else {
                        if (callback) callback.apply(this);
                    }
                }.bind(this), null, false);
            } else {
                var scriptAction;
                switch (type) {
                    case "portal" :
                        if (this.scriptActionPortal) {
                            scriptAction = this.scriptActionPortal;
                        } else {
                            MWF.require("MWF.xScript.Actions.PortalScriptActions", null, false);
                            scriptAction = this.scriptActionPortal = new MWF.xScript.Actions.PortalScriptActions();
                        }
                        break;
                    case "process" :
                        if (this.scriptActionProcess) {
                            scriptAction = this.scriptActionProcess;
                        } else {
                            MWF.require("MWF.xScript.Actions.ScriptActions", null, false);
                            scriptAction = this.scriptActionProcess = new MWF.xScript.Actions.ScriptActions();
                        }
                        break;
                    case "cms" :
                        if (this.scriptActionCMS) {
                            scriptAction = this.scriptActionCMS;
                        } else {
                            MWF.require("MWF.xScript.Actions.CMSScriptActions", null, false);
                            scriptAction = this.scriptActionCMS = new MWF.xScript.Actions.CMSScriptActions();
                        }
                        break;
                    case "service" :
                        if (this.scriptActionService) {
                            scriptAction = this.scriptActionService;
                        } else {
                            MWF.require("MWF.xScript.Actions.ServiceScriptActions", null, false);
                            scriptAction = this.scriptActionService = new MWF.xScript.Actions.ServiceScriptActions();
                        }
                        break;
                }

                var successCallback = function (json) {
                    if (json.data) {
                        includedScripts.push(key);

                        //名称、别名、id
                        json.data.importedList.each(function (flag) {
                            if (type === "portal") {
                                includedScripts.push(type + "-" + json.data.portal + "-" + flag);
                                if (json.data.portalName) includedScripts.push(type + "-" + json.data.portalName + "-" + flag);
                                if (json.data.portalAlias) includedScripts.push(type + "-" + json.data.portalAlias + "-" + flag);
                            } else if (type === "cms") {
                                includedScripts.push(type + "-" + json.data.appId + "-" + flag);
                                if (json.data.appName) includedScripts.push(type + "-" + json.data.appName + "-" + flag);
                                if (json.data.appAlias) includedScripts.push(type + "-" + json.data.appAlias + "-" + flag);
                            } else if (type === "process") {
                                includedScripts.push(type + "-" + json.data.application + "-" + flag);
                                if (json.data.appName) includedScripts.push(type + "-" + json.data.appName + "-" + flag);
                                if (json.data.appAlias) includedScripts.push(type + "-" + json.data.appAlias + "-" + flag);
                            }else if (type === "service") {
                                includedScripts.push(type + "-" + flag);
                            }
                        });

                        includedScripts = includedScripts.concat(json.data.importedList);
                        MWF.Macro.exec(json.data.text, this);
                        if (callback) callback.apply(this);
                    } else {
                        if (callback) callback.apply(this);
                    }
                }.bind(this);

            if( type === "service" ){
                scriptAction.getScriptByName(name, includedScripts, successCallback, null, !!async);
            }else{
                scriptAction.getScriptByName(application, name, includedScripts, successCallback, null, !!async);
            }
            }
        };
        this.include = function (optionsOrName, callback, async) {
            if (o2.typeOf(optionsOrName) == "array") {
                if (!!async) {
                    var count = optionsOrName.length;
                    var loaded = 0;
                    optionsOrName.each(function (option) {
                        _includeSingle.apply(this, [option, function () {
                            loaded++;
                            if (loaded >= count) if (callback) callback.apply(this);
                        }.bind(this), true]);
                    }.bind(this));

                } else {
                    optionsOrName.each(function (option) {
                        _includeSingle.apply(this, [option]);
                    }.bind(this));
                    if (callback) callback.apply(this);
                }
            } else {
                _includeSingle.apply(this, [optionsOrName, callback, async])
            }
        };

        this.define = function (name, fun, overwrite) {
            var over = true;
            if (overwrite === false) over = false;
            var o = {};
            o[name] = {"value": fun, "configurable": over};
            MWF.defineProperties(this, o);
        }.bind(this);

        //如果前端事件有异步调用，想要在异步调用结束后继续运行页面加载，
        //可在调用前执行 var resolve = this.wait();
        //在异步调用结束后 执行 resolve.cb()；
        //目前只有表单的queryload事件支持此方法。
        this.wait = function () {
            resolve = {};
            var setResolve = function (callback) {
                resolve.cb = callback;
            }.bind(this);
            this.target.event_resolve = setResolve;
            return resolve;
        };
        //和this.wait配合使用，
        //如果没有异步，则resolve.cb方法不存在，
        //所以在回调中中使用this.goon();使表单继续加载
        this.goon = function () {
            this.target.event_resolve = null;
        };

        //仅前台对象-----------------------------------------
        //form
        /**
         * page对象可在门户页面中可用。它的很多方法与form类似。<b>（仅前端脚本可用）</b><br/>
         * @module page
         * @o2cn 门户页面
         * @o2category web
         * @o2range {Portal}
         * @o2ordernumber 50
         * @o2syntax
         * //您可以在门户表单中，通过this来获取page对象，如下：
         * var page = this.page;
         */
        this.page = this.form = {
            /** 跳转到当前门户的指定页面。<b>（仅门户页面脚本可用）</b>
             * @method toPage
             * @static
             * @param {String} name - 要跳转的页面名称
             * @param {Object} [par] - 要传入被打开页面的数据。在被打开的页面可以用this.page.parameters获取
             * @param {Boolean} [nohis] - 页面跳转的时候，不往History里增加历史状态，默认为false
             * @o2syntax
             * //跳转到当前门户的指定页面。
             * this.page.toPage( name, par, nohis );
             * @example
             * this.page.toPage("列表页面", {"key": "发文列表"});//打开“列表页面”，并传入一个json数据。
             *
             * //在列表页面中，通过this.page.parameters获取传入的数据。
             * var key = this.page.parameters.key; //key="发文列表"
             */
            "toPage": function (name, par, nohis) {
                _form.app.toPage(name, par, nohis);
            },

            /** 跳转到指定门户页面。<b>（仅门户页面脚本可用）</b>
             * @method toPortal
             * @static
             * @param {String} portal - 要跳转的门户名称。
             * @param {String} [page] - 要打开的门户的页面名称。为空则打开指定门户的默认首页。
             * @param {String} [par] - 在被打开的页面可以用this.page.parameters获取。
             * @o2syntax
             * this.page.toPortal( portal, page, par );
             * @example
             * this.page.toPortal("公文门户", "列表页面", {"key": "发文列表"});//打开“公文门户”的“列表页面”，并传入一个json数据。
             *
             * //在列表页面中，通过this.page.parameters获取传入的数据。
             * var key = this.page.parameters.key; //key="发文列表"
             */
            "toPortal": function (portal, page, par) {
                _form.app.toPortal(portal, page, par);
            },
            /**获取当前页面的基本信息
             * @method getInfor
             * @static
             * @see module:form.getInfor
             */
            "getInfor": function () {
                return ev.pageInfor;
            },
            "infor": ev.pageInfor,
            /**获取打开当前页面的component对象。
             * @method getApp
             * @static
             * @see module:form.getApp
             */
            "getApp": function () {
                return _form.app;
            },
            "app": _form.app,
            /**获取page对应的DOM对象。
             * @method node
             * @static
             * @see module:form.node
             */
            "node": function () {
                return _form.node;
            },
            //"readonly": _form.options.readonly,
            /**获取页面元素对象。
             * @method get
             * @static
             * @see module:form.get
             */
            "get": function(name,subformName ){
                if( !_form.all )return null;
                if( subformName ){
                    if( _form.all[subformName +"_"+ name] )return _form.all[subformName +"_"+ name];
                    return _form.all[name];
                }else{
                    return _form.all[name];
                }
                // return (_form.all) ? _form.all[name] : null;
            },

            /**获取指定部件元素对象。<br/>
             * @method getWidgetModule
             * @static
             * @param {String} widgetId  - 在主页面嵌入部件时用的标识。
             * @param {String} fieldId  - 部件内组件标识。
             * @return {FormComponent} 请查看本文档的Classes导航下的FormComponents。
             * @see module:form.get
             * @o2syntax
             * this.page.getWidgetModule( widgetId, fieldId );
             * @example
             * <caption>
             * 1、设计了一个部件，包含一个设计元素subject。<br/>
             * 2、在主页面里两次嵌入1步骤创建的部件，一个标识是widget_1, widget_2。
             * </caption>
             * var module = this.page.getWidgetModule( "widget_1", "subject"); //部件widget_1的subject组件
             * var data2 = this.page.getWidgetModule( "widget_2", "subject").getData(); //部件widget_2的subject组件的值
             */
            "getWidgetModule": function (widget, moduleName) {
                if (!_form.widgetModules || !_form.widgetModules[widget]) return null;
                var module = _form.widgetModules[widget][moduleName];
                return module || null;
            },
            /**获取页面中可输入的字段元素对象
             * @method getField
             * @static
             * @see module:form.getField
             */
            "getField": function (name) {
                return _forms[name];
            },
            "getAction": function () {
                return _form.workAction
            },
            "getDesktop": function () {
                return _form.app.desktop
            },

            "getData": function () {
                return new MWF.xScript.JSONData(_form.getData());
            },
            //"save": function(callback){_form.saveWork(callback);},

            /**关闭当前页面
             * @method close
             * @static
             * @see module:form.close
             */
            "close": function () {
                _form.closeWork();
            },

            "print": function (application, form) {
                _form.printWork(application, form);
            },

            /**弹出一个确认框
             * @method confirm
             * @static
             * @see module:form.confirm
             */
            "confirm": function (type, title, text, width, height, ok, cancel, callback, mask, style) {
                // var p = MWF.getCenter({"x": width, "y": height});
                // e = {"event": {"clientX": p.x,"x": p.x,"clientY": p.y,"y": p.y}};
                // _form.confirm(type, e, title, text, width, height, ok, cancel, callback, mask, style);
                if ((arguments.length <= 1) || o2.typeOf(arguments[1]) === "string") {
                    var p = MWF.getCenter({"x": width, "y": height});
                    e = {"event": {"clientX": p.x, "x": p.x, "clientY": p.y, "y": p.y}};
                    _form.confirm(type, e, title, text, width, height, ok, cancel, callback, mask, style);
                } else {
                    e = (arguments.length > 1) ? arguments[1] : null;
                    title = (arguments.length > 2) ? arguments[2] : null;
                    text = (arguments.length > 3) ? arguments[3] : null;
                    width = (arguments.length > 4) ? arguments[4] : null;
                    height = (arguments.length > 5) ? arguments[5] : null;
                    ok = (arguments.length > 6) ? arguments[6] : null;
                    cancel = (arguments.length > 7) ? arguments[7] : null;
                    callback = (arguments.length > 8) ? arguments[8] : null;
                    mask = (arguments.length > 9) ? arguments[9] : null;
                    style = (arguments.length > 10) ? arguments[10] : null;
                    _form.confirm(type, e, title, text, width, height, ok, cancel, callback, mask, style);
                }
            },
            /**显示一个带关闭按钮的信息框
             * @method alert
             * @static
             * @see module:form.alert
             */
            "alert": function (type, title, text, width, height) {
                _form.alert(type, title, text, width, height);
            },

            /**显示一个信息框
             * @method notice
             * @static
             * @see module:form.notice
             */
            "notice": function (content, type, target, where, offset, option) {
                _form.notice(content, type, target, where, offset, option);
            },

            /**打开一个对话框
             * @method dialog
             * @static
             * @see module:form.dialog
             */
            "dialog": function ( options ) {
                return _form.dialog( options );
            },

            /**打开人员组织选择界面
             * @method selectOrg
             * @static
             * @see module:form.selectOrg
             */
            "selectOrg": function ( container, options,  delayLoad) {
                if( !container )container = _form.app.content;
                return new MWF.O2Selector(container, options, delayLoad);
            },

            /**给页面添加事件。
             * @method addEvent
             * @static
             * @see module:form.addEvent
             */
            "addEvent": function (e, f) {
                _form.addEvent(e, f);
            },

            "openWindow": function (form, app) {
                _form.openWindow(form, app);
            },

            /**打开一个在流转或已完成的流程实例
             * @method openWork
             * @static
             * @see module:form.openWork
             */
            "openWork": function (id, completedId, title, options) {
                var op = options || {};
                op.workId = id;
                op.workCompletedId = completedId;
                op.docTitle = title;
                op.appId = "process.Work" + (op.workId || op.workCompletedId);
                return layout.desktop.openApplication(this.event, "process.Work", op);
            },
            /**使用流程的jobId打开工作
             * @method openJob
             * @static
             * @see module:form.openJob
             */
            "openJob": function (id, choice, options, callback) {
                var workData = null, handel;
                o2.Actions.get("x_processplatform_assemble_surface").listWorkByJob(id, function(json){
                    if (json.data) workData = json.data;
                }.bind(this), null, false);

                if( !layout.inBrowser && o2.typeOf(callback) === "function" ){
                    if( !options )options = {};
                    var queryLoad = options.onQueryLoad;
                    options.onQueryLoad = function () {
                        if( o2.typeOf(queryLoad) === "function" )queryLoad.call(this);
                        callback(this);
                    }
                }

                runCallback = function ( handel ) {
                    if( o2.typeOf(callback) === "function" ) {
                        if (layout.inBrowser) {
                            callback(handel);
                        } else if (options && options.appId) {
                            if (layout.desktop && layout.desktop.apps && layout.desktop.apps[options.appId]) {
                                callback(layout.desktop.apps[options.appId], true);
                            }else{
                                callback(handel, false);
                            }
                        }else{
                            callback(handel, false);
                        }
                    }
                };

                if (workData){
                    var len = workData.workList.length + workData.workCompletedList.length;
                    if (len){
                        if (len>1 && choice){
                            var node = new Element("div", {"styles": {"padding": "20px", "width": "500px"}}).inject(_form.node);
                            workData.workList.each(function(work){
                                var workNode = new Element("div", {
                                    "styles": {
                                        "background": "#ffffff",
                                        "border-radius": "10px",
                                        "clear": "both",
                                        "margin-bottom": "10px",
                                        "height": "40px",
                                        "padding": "10px 10px"
                                    }
                                }).inject(node);
                                var html = "<div style='height: 40px; width: 40px; float: left; background: url(../x_component_process_Xform/$Form/default/icon/work.png) no-repeat center center'></div>" +
                                    "<div style='height: 40px; width: 40px; float: right'><div class='MWFAction' style='height: 20px; width: 40px; margin-top: 10px; border: 1px solid #999999; border-radius: 5px;text-align: center; cursor: pointer'>"+o2.LP.widget.open+"</div></div>"+
                                    "<div style='height: 20px; line-height: 20px; margin: 0px 40px'>"+work.title+"</div>" +
                                    "<div style='margin: 0px 40px'><div style='color:#999999; float: left; margin-right: 10px'>"+work.activityName+"</div>" +
                                    "<div style='color:#999999; float: left; margin-right: 10px'>"+work.activityArrivedTime+"</div>" +
                                    "<div style='color:#999999; float: left; margin-right: 10px'>"+(work.manualTaskIdentityText || "")+"</div></div>";
                                workNode.set("html", html);
                                var action = workNode.getElement(".MWFAction");
                                action.store("work", work);
                                action.addEvent("click", function(e){
                                    var work = e.target.retrieve("work");
                                    if (work){
                                        handel =  this.openWork(work.id, null, work.title, options);
                                        runCallback( handel );
                                    }
                                    dlg.close();
                                }.bind(this));

                            }.bind(this));
                            workData.workCompletedList.each(function(work){
                                var workNode = new Element("div", {
                                    "styles": {
                                        "background": "#ffffff",
                                        "border-radius": "10px",
                                        "clear": "both",
                                        "margin-bottom": "10px",
                                        "height": "40px",
                                        "padding": "10px 10px"
                                    }
                                }).inject(node);
                                var html = "<div style='height: 40px; width: 40px; float: left; background: url(../x_component_process_Xform/$Form/default/icon/work.png) no-repeat center center'></div>" +
                                    "<div style='height: 40px; width: 40px; float: right'><div class='MWFAction' style='height: 20px; width: 40px; margin-top: 10px; border: 1px solid #999999; border-radius: 5px;text-align: center; cursor: pointer'>"+o2.LP.widget.open+"</div></div>"+
                                    "<div style='height: 20px; line-height: 20px; margin: 0px 40px'>"+work.title+"</div>" +
                                    "<div style='margin: 0px 40px'><div style='color:#999999; float: left; margin-right: 10px'>"+o2.LP.widget.workcompleted+"</div>" +
                                    "<div style='color:#999999; float: left; margin-right: 10px'>"+work.completedTime+"</div>";
                                workNode.set("html", html);
                                var action = workNode.getElement(".MWFAction");
                                action.store("work", work);
                                action.addEvent("click", function(e){
                                    var work = e.target.retrieve("work");
                                    if (work){
                                        handel =  this.openWork(null, work.id, work.title, options);
                                        runCallback( handel );
                                    }
                                    dlg.close();
                                }.bind(this));

                            }.bind(this));
                            var height = node.getSize().y+20;
                            if (height>600) height = 600;

                            var dlg = o2.DL.open({
                                "title": o2.LP.widget.choiceWork,
                                "style" : "user",
                                "isResize": false,
                                "content": node,
                                "buttonList": [
                                    {
                                        "type" : "cancel",
                                        "text": o2.LP.widget.close,
                                        "action": function(){dlg.close();}
                                    }
                                ]
                            });
                        }else{
                            if (workData.workList.length){
                                var work =  workData.workList[0];
                                handel = this.openWork(work.id, null, work.title, options);
                                runCallback( handel );
                                return handel;
                            }else{
                                var work =  workData.workCompletedList[0];
                                handel = this.openWork(null, work.id, work.title, options);
                                runCallback( handel );
                                return handel;
                            }
                        }
                    }else{
                        runCallback(new Error("Can't open this Job", {
                            cause: workData
                        }));
                    }
                }else{
                    runCallback(new Error("Can't open this Job", {
                        cause: workData
                    }));
                }
            },
            /**打开一个内容管理文档
             * @method openDocument
             * @static
             * @see module:form.openDocument
             */
            "openDocument": function (id, title, options) {
                var op = options || {};
                op.documentId = id;
                op.docTitle = title || "";
                op.appId = (op.appId) || ("cms.Document"+id);
                if( op.onPostPublish ){
                    op.postPublish = op.onPostPublish;
                    delete op.onPostPublish;
                }
                if( op.onAfterPublish ){
                    op.afterPublish = op.onAfterPublish;
                    delete op.onAfterPublish;
                }
                if( op.onAfterSave ){
                    op.afterSave = op.onAfterSave;
                    delete op.onAfterSave;
                }
                if( op.onBeforeClose ){
                    op.beforeClose = op.onBeforeClose;
                    delete op.onBeforeClose;
                }
                if( op.onPostDelete ){
                    op.postDelete = op.onPostDelete;
                    delete op.onPostDelete;
                }
                return layout.desktop.openApplication(this.event, "cms.Document", op);
            },
            /**打开一个门户页面
             * @method openPortal
             * @static
             * @see module:form.openPortal
             */
            "openPortal": function (name, page, par) {
                var action = MWF.Actions.get("x_portal_assemble_surface");
                action.getApplication(name, function (json) {
                    if (json.data) {
                        if (page) {
                            action.getPageByName(page, json.data.id, function (pageJson) {
                                var pageId = (pageJson.data) ? pageJson.data.id : "";
                                layout.desktop.openApplication(null, "portal.Portal", {
                                    "portalId": json.data.id,
                                    "pageId": pageId,
                                    "parameters": par,
                                    "appId": (par && par.appId) || ("portal.Portal" + json.data.id + pageId)
                                })
                            });
                        } else {
                            layout.desktop.openApplication(null, "portal.Portal", {
                                "portalId": json.data.id,
                                "parameters": par,
                                "appId": (par && par.appId) || ("portal.Portal" + json.data.id)
                            })
                        }
                    }

                });
            },
            /**打开一个内容管理栏目（应用）
             * @method openCMS
             * @static
             * @see module:form.openCMS
             */
            "openCMS": function (name) {
                var action = MWF.Actions.get("x_cms_assemble_control");
                action.getColumn(name, function (json) {
                    if (json.data) {
                        layout.desktop.openApplication(null, "cms.Module", {
                            "columnId": json.data.id,
                            "appId": "cms.Module" + json.data.id
                        });
                    }
                });
            },
            /**打开一个流程应用
             * @method openProcess
             * @static
             * @see module:form.openProcess
             */
            "openProcess": function (name) {
                var action = MWF.Actions.get("x_processplatform_assemble_surface");
                action.getApplication(name, function (json) {
                    if (json.data) {
                        layout.desktop.openApplication(null, "process.Application", {
                            "id": json.data.id,
                            "appId": "process.Application" + json.data.id
                        });
                    }
                });
            },
            /**打开一个任意一个component应用
             * @method openApplication
             * @static
             * @see module:form.openApplication
             */
            "openApplication": function (name, options, status) {
                return layout.desktop.openApplication(null, name, options, status);
            },
            /**创建一个内容管理文档
             * @method createDocument
             * @static
             * @see module:form.createDocument
             */
            "createDocument": function (columnOrOptions, category, data, identity, callback, target, latest, selectColumnEnable, ignoreTitle, restrictToColumn) {
                var column = columnOrOptions;
                var onAfterPublish, onPostPublish;
                if (typeOf(columnOrOptions) == "object") {
                    column = columnOrOptions.column;
                    category = columnOrOptions.category;
                    data = columnOrOptions.data;
                    identity = columnOrOptions.identity;
                    callback = columnOrOptions.callback;
                    target = columnOrOptions.target;
                    latest = columnOrOptions.latest;
                    selectColumnEnable = columnOrOptions.selectColumnEnable;
                    ignoreTitle = columnOrOptions.ignoreTitle;
                    restrictToColumn = columnOrOptions.restrictToColumn;
                    onAfterPublish = columnOrOptions.onAfterPublish;
                    onPostPublish = columnOrOptions.onPostPublish;
                }
                // 移动端 app相关的实现
                if (layout.mobile) {
                    var options = {};
                    if (column) {
                        options["column"] = column
                    }
                    if (category) {
                        options["category"] = category
                    }
                    if (data) {
                        options["data"] = data
                    }
                    if (identity) {
                        options["identity"] = identity
                    }
                    if (typeof(latest) == 'undefined' || latest === null) {
                        options["latest"] = true
                    } else {
                        options["latest"] = latest
                    }
                    if (typeof(ignoreTitle) == 'undefined' || ignoreTitle === null) {
                        options["ignoreTitle"] = false
                    } else {
                        options["ignoreTitle"] = ignoreTitle
                    }
                    if (window.o2android && window.o2android.postMessage) {
                        var body = {
                            type: "createO2CmsDocument",
                            data: options
                        };
                        window.o2android.postMessage(JSON.stringify(body));
                        return;
                    } else if (window.o2android && window.o2android.createO2CmsDocument){
                        window.o2android.createO2CmsDocument(JSON.stringify(options));
                        return;
                    } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.createO2CmsDocument) {
                        window.webkit.messageHandlers.createO2CmsDocument.postMessage(options);
                        return;
                    }
                }
                // 下面是pc端

                if (target) {
                    if (layout.app && layout.app.inBrowser) {
                        layout.app.content.empty();
                        layout.app = null;
                    }
                }

                MWF.xDesktop.requireApp("cms.Index", "Newer", function () {
                    var starter = new MWF.xApplication.cms.Index.Newer(null, null, _form.app, null, {
                        "documentData": data,
                        "identity": identity,

                        "ignoreTitle": ignoreTitle === true,
                        "ignoreDrafted": latest === false,
                        "selectColumnEnable": !category || selectColumnEnable === true,
                        "restrictToColumn": restrictToColumn === true || (!!category && selectColumnEnable !== true),

                        "categoryFlag": category, //category id or name
                        "columnFlag": column, //column id or name,
                        "onStarted": function (documentId, data, windowHandle) {
                            if (callback) callback(documentId, data, windowHandle);
                        },
                        "onPostPublish": function () {
                            if (onPostPublish) onPostPublish();
                        },
                        "onAfterPublish": function () {
                            if (onAfterPublish) onAfterPublish();
                        }
                    });
                    starter.load();
                })
            },
            /**启动一个流程实例
             * @method startProcess
             * @static
             * @see module:form.startProcess
             */
            "startProcess": function (app, process, data, identity, callback, target, latest, afterCreated, skipDraftCheck) {
                if (arguments.length > 2) {
                    for (var i = 2; i < arguments.length; i++) {
                        if (typeOf(arguments[i]) == "boolean") {
                            target = arguments[i];
                            break;
                        }
                    }
                }

                if (target) {
                    if (layout.app && layout.app.inBrowser) {
                        //layout.app.content.empty();
                        layout.app.$openWithSelf = true;
                    }
                }
                if (!app || !process){
                    var cmpt = this.getApp();
                    o2.requireApp([["process.TaskCenter", "lp."+o2.language], ["process.TaskCenter", ""]],"", function(){
                        var obj = {
                            "lp": o2.xApplication.process.TaskCenter.LP,
                            "content": cmpt.content,
                            "addEvent": function(type, fun){
                                cmpt.addEvent(type, fun);
                            },
                            "getAction": function (callback) {
                                if (!this.action) {
                                    this.action = o2.Actions.get("x_processplatform_assemble_surface");
                                    if (callback) callback();
                                } else {
                                    if (callback) callback();
                                }
                            },
                            "desktop": layout.desktop,
                            "refreshAll": function(){},
                            "notice": cmpt.notice,
                        }
                        o2.JSON.get("../x_component_process_TaskCenter/$Main/default/css.wcss", function(data){
                            obj.css = data;
                        }, false);

                        if (!cmpt.processStarter) cmpt.processStarter = new o2.xApplication.process.TaskCenter.Starter(obj);
                        cmpt.processStarter.load();
                    }, true, true);
                    return "";
                }
                var action = MWF.Actions.get("x_processplatform_assemble_surface").getProcessByName(process, app, function (json) {
                    if (json.data) {
                        MWF.xDesktop.requireApp("process.TaskCenter", "ProcessStarter", function () {
                            var starter = new MWF.xApplication.process.TaskCenter.ProcessStarter(json.data, _form.app, {
                                "workData": data,
                                "identity": identity,
                                "latest": latest,
                                "skipDraftCheck": skipDraftCheck,
                                "onStarted": function (data, title, processName) {
                                    var application;
                                    if (data.work) {
                                        var work = data.work;
                                        var options = {
                                            "draft": work,
                                            "draftData":data.data||{},
                                            "appId": "process.Work" + (new o2.widget.UUID).toString(),
                                            "desktopReload": false
                                        };
                                        if( !layout.inBrowser && afterCreated )options.onPostLoadForm = afterCreated;
                                        application = layout.desktop.openApplication(null, "process.Work", options);
                                    } else {
                                        var currentTask = [];
                                        data.each(function (work) {
                                            if (work.currentTaskIndex != -1) currentTask.push(work.taskList[work.currentTaskIndex].work);
                                        }.bind(this));

                                        if (currentTask.length == 1) {
                                            var options = {"workId": currentTask[0], "appId": currentTask[0]};
                                            if( !layout.inBrowser && afterCreated )options.onPostLoadForm = afterCreated;
                                            application = layout.desktop.openApplication(null, "process.Work", options);
                                        } else {
                                        }
                                    }

                                    // var currentTask = [];
                                    // data.each(function (work) {
                                    //     if (work.currentTaskIndex != -1) currentTask.push(work.taskList[work.currentTaskIndex].work);
                                    // }.bind(this));
                                    //
                                    // if (currentTask.length == 1) {
                                    //     var options = { "workId": currentTask[0], "appId": currentTask[0] };
                                    //     layout.desktop.openApplication(null, "process.Work", options);
                                    // } else { }

                                    if (callback) callback(data);

                                    if(layout.inBrowser && afterCreated){
                                        afterCreated(application)
                                    }
                                }.bind(this)
                            });
                            starter.load();
                        }.bind(this));
                    }
                });
            },

            /**
             * 在打开的页面的任意脚本中，获取传入的参数。
             * @member parameters
             * @static
             * @return {Boolean} 任意数据类型，根据传入的参数决定。
             * @o2syntax
             * var par = this.page.parameters
             * @example
             * //打开页面时传入参数：
             * this.form.openPortal(id, "", {"type": "my type"});
             *
             * //在打开的页面的任意脚本中，可以获取parameters：
             * var par = this.page.parameters;
             * //par的内容：{"type": "my type"}
             */
            "parameters": _form.options.parameters,

            /**
             * 在嵌入部件的时候，可以在主页面上传入参数。通过本方法，可以在对应部件或者部件元素的脚本中获取传入的参数。
             * @method getWidgetPrameters
             * @static
             * @return {Object} 任意数据类型，根据传入的参数决定。
             * @o2syntax
             * var par = this.page.getWidgetPrameters();
             * @example
             * //在主页面嵌入部件的地方传入参数：
             * return {"type": "my type"};
             *
             * //在对应部件脚本中，可以获取parameters：
             * var par = this.page.getWidgetPrameters();
             * //par的内容：{"type": "my type"}
             */
            "getWidgetPrameters": function () {
                if (!this.target) return null;
                if (!this.target.widget) return null;
                if (!this.widgetParameters) return null;
                var pageId = this.target.widget.json.id;
                return this.widgetParameters[pageId];
            }.bind(this)
            //"app": _form.app
        };
        this.form.currentRouteName = _form.json.currentRouteName;
        this.form.opinion = _form.json.opinion;

        this.target = ev.target;
        this.event = ev.event;
        this.status = ev.status;
        this.session = layout.desktop.session;
        this.Actions = o2.Actions;

        this.query = function (option) {
            // options = {
            //      "name": "statementName",
            //      "data": "json data",
            //      "firstResult": 1,
            //      "maxResults": 100,
            //      "success": function(){},
            //      "error": function(){},
            //      "async": true or false, default is true
            // }
            if (option) {
                var json = (option.data) || {};
                if (option.firstResult) json.firstResult = option.firstResult.toInt();
                if (option.maxResults) json.maxResults = option.maxResults.toInt();
                o2.Actions.get("x_query_assemble_surface").executeStatement(option.name, json, success, error, options.async);
            }
        };
        this.Table = MWF.xScript.createTable();
    };
}

if (!MWF.xScript.createTable) MWF.xScript.createTable = function(){
    return function(name){
        this.name = name;
        this.action = o2.Actions.load("x_query_assemble_surface").TableAction;

        this.listRowNext = function(id, count, success, error, async){
            return this.action.listRowNext(this.name, id, count, success, error, async);
        };
        this.listRowPrev = function(id, count, success, error, async){
            return this.action.listRowPrev(this.name, id, count, success, error, async);
        };
        this.listRowSelect = function(where, orderBy, size, success, error, async){
            return this.action.listRowSelect(this.name, {"where": where, "orderBy": orderBy, "size": size || ""}, success, error, async);
        };
        this.listRowSelectWhere = function(where, success, error, async){
            return this.action.listRowSelectWhere(this.name, where, success, error, async);
        };
        this.rowCountWhere = function(where, success, error, async){
            return this.action.rowCountWhere(this.name, where, success, error, async);
        };
        this.deleteRow = function(id, success, error, async){
            return this.action.rowDelete(this.name, id, success, error, async);
        };
        this.deleteAllRow = function(success, error, async){
            return this.action.rowDeleteAll(this.name, success, error, async);
        };
        this.getRow = function(id, success, error, async){
            return this.action.rowGet(this.name, id, success, error, async);
        };
        this.insertRow = function(data, success, error, async){
            return this.action.rowInsert(this.name, data, success, error, async);
        };
        this.addRow = function(data, success, error, async){
            return this.action.rowInsertOne(this.name, data, success, error, async);
        };
        this.updateRow = function(id, data, success, error, async){
            return this.action.rowUpdate(this.name, id, data, success, error, async);
        };
    }
};
if (!MWF.xScript.JSONData) {
    var getArrayJSONData = function (jData, p, _form) {
        return new MWF.xScript.JSONData(jData, function (data, key, _self) {
            var p = {
                "getKey": function () {
                    return key;
                }, "getParent": function () {
                    return _self;
                }
            };
            while (p && !_form.forms[p.getKey()]) p = p.getParent();
            //if (p) if (p.getKey()) if (_forms[p.getKey()]) _forms[p.getKey()].resetData();
            var k = (p) ? p.getKey() : "";
            if (k) if (_form.forms[k]) if (_form.forms[k].resetData) _form.forms[k].resetData();
            //if(p) if(p.getKey()) if(_forms[p.getKey()]) if(_forms[p.getKey()].render) _forms[p.getKey()].render();
        }, "", p, _form);
    };
    MWF.xScript.JSONData = function (data, callback, key, parent, _form) {
        var getter = function (data, callback, k, _self) {
            return function () {
                var t = typeOf(data[k]);
                if (["array", "object"].indexOf(t) === -1) {
                    return data[k]
                } else {
                    if (t === "array") {
                        if (window.Proxy){
                            var arr = new Proxy(data[k], {
                                get: function(o, k){
                                    return (o2.typeOf(o[k])==="object") ? getArrayJSONData(o[k], _self, _form) : o[k];
                                },
                                set: function(o, k, v){
                                    o[k] = v;
                                    if (callback) callback(o, k, _self);
                                    return true;
                                }
                            });
                            return arr;
                        }else{
                            var arr =[];
                            data[k].forEach(function(d, i){
                                arr.push((o2.typeOf(d)==="object") ? getArrayJSONData(d, _self, _form) : d);
                            });
                            return arr;
                        }
                    } else {
                        return new MWF.xScript.JSONData(data[k], callback, k, _self, _form);
                    }
                    // var obj =
                    // if (t==="array") obj.constructor = Array;
                    // return obj;
                }
                //return (["array","object"].indexOf(typeOf(data[k]))===-1) ? data[k] : new MWF.xScript.JSONData(data[k], callback, k, _self, _form);
            };
        };
        var setter = function (data, callback, k, _self) {
            return function (v) {
                data[k] = v;
                //debugger;
                //this.add(k, v, true);
                if (callback) callback(data, k, _self);
            }
        };
        var define = function () {
            var o = {};
            for (var k in data) o[k] = {
                "configurable": true,
                "enumerable": true,
                "get": getter.apply(this, [data, callback, k, this]),
                "set": setter.apply(this, [data, callback, k, this])
            };
            o["length"] = {
                "get": function () {
                    return Object.keys(data).length;
                }
            };
            o["some"] = {
                "get": function () {
                    return data.some;
                }
            };
            MWF.defineProperties(this, o);

            var methods = {
                "getKey": {
                    "value": function () {
                        return key;
                    }
                },
                "getParent": {
                    "value": function () {
                        return parent;
                    }
                },
                "toString": {
                    "value": function () {
                        return data.toString();
                    }
                },
                "setSection": {
                    "value": function (newKey, newValue) {
                        this.add(newKey, newValue, true);
                        try {
                            var path = [this.getKey()];
                            p = this.getParent();
                            while (p && p.getKey()) {
                                path.unshift(p.getKey());
                                p = p.getParent();
                            }
                            if (path.length) _form.sectionListObj[path.join(".")] = newKey;
                        } catch (e) {

                        }
                    }
                },

                "add": {
                    "value": function (newKey, newValue, overwrite, noreset) {
                        if( newKey.test(/^\d+$/) ){
                            throw new Error("Field name '"+newKey+"' cannot contain only numbers" );
                        }
                        if (arguments.length < 2 || newKey.indexOf("..") === -1) {
                            var flag = true;
                            var type = typeOf(data);
                            if (type === "array") {
                                if (arguments.length < 2) {
                                    data.push(newKey);
                                    newValue = newKey;
                                    newKey = data.length - 1;
                                } else {
                                    if (!newKey && newKey !== 0) {
                                        data.push(newValue);
                                        newKey = data.length - 1;
                                    } else {
                                        if (newKey >= data.length) {
                                            data.push(newValue);
                                            newKey = data.length - 1;
                                        } else {
                                            if (overwrite) data[newKey] = newValue;
                                            newValue = data[newKey];
                                            flag = false;
                                        }
                                    }
                                }
                                if (flag) {
                                    var o = {};
                                    o[newKey] = {
                                        "configurable": true,
                                        "enumerable": true,
                                        "get": getter.apply(this, [data, callback, newKey, this]),
                                        "set": setter.apply(this, [data, callback, newKey, this])
                                    };
                                    MWF.defineProperties(this, o);
                                }
                                if (!noreset) this[newKey] = newValue;
                            } else if (type === "object") {
                                if (!this.hasOwnProperty(newKey)) {
                                    if (!data[newKey] || overwrite) {
                                        data[newKey] = newValue;
                                    }
                                    newValue = data[newKey];

                                    if (flag) {
                                        var o = {};
                                        o[newKey] = {
                                            "configurable": true,
                                            "enumerable": true,
                                            "get": getter.apply(this, [data, callback, newKey, this]),
                                            "set": setter.apply(this, [data, callback, newKey, this])
                                        };
                                        MWF.defineProperties(this, o);
                                    }
                                    if (!noreset) this[newKey] = newValue;
                                } else {
                                    if (!Object.getOwnPropertyDescriptor(this, newKey).get){
                                        var o = {};
                                        o[newKey] = {"configurable": true, "enumerable": true, "get": getter.apply(this, [data, callback, newKey, this]),"set": setter.apply(this, [data, callback, newKey, this])};
                                        MWF.defineProperties(this, o);
                                    }
                                    if (overwrite) {
                                        data[newKey] = newValue;
                                        if (!noreset) this[newKey] = newValue;
                                    }
                                }
                            }
                            return this[newKey];
                        } else {
                            var keys = newKey.split("..");
                            var kk = keys.shift();
                            var d = this.add(kk, {}, false, true);
                            if (keys.length) return d.add(keys.join(".."), newValue, overwrite, noreset);
                            return d;
                        }
                    }
                },
                "check": {
                    "value": function (kk, v) {
                        var value = typeOf( v ) === "null" ? "" : v;
                        this.add(kk, value, false, true);
                    }
                },
                "del": {
                    "value": function (delKey) {
                        if (!this.hasOwnProperty(delKey)) return null;
                        // delete data[delKey];
                        // delete this[delKey];
                        data[delKey] = "";
                        this[delKey] = "";
                        return this;
                    }
                }
            };
            MWF.defineProperties(this, methods);

            //this.getKey = function(){ return key; };
            //this.getParent = function(){ return parent; };
            //this.toString = function() { return data.toString();};
            //this.add = function(newKey, newValue, overwrite){
            //    var flag = true;
            //    var type = typeOf(data);
            //    if (!this.hasOwnProperty(newKey)){
            //        if (type=="array"){
            //            if (arguments.length<2){
            //                data.push(newKey);
            //                newValue = newKey;
            //                newKey = data.length-1;
            //            }else{
            //                debugger;
            //                if (!newKey && newKey!=0){
            //                    data.push(newValue);
            //                    newKey = data.length-1;
            //                }else{
            //                    flag == false;
            //                }
            //            }
            //        }else{
            //            data[newKey] = newValue;
            //        }
            //        //var valueType = typeOf(newValue);
            //        //var newValueData = newValue;
            //        //if (valueType=="object" || valueType=="array") newValueData = new MWF.xScript.JSONData(newValue, callback, newKey, this);
            //        //if (valueType=="null") newValueData = new MWF.xScript.JSONData({}, callback, newKey, this);
            //        if (flag){
            //            var o = {};
            //            o[newKey] = {"configurable": true, "enumerable": true, "get": getter.apply(this, [data, callback, newKey, this]),"set": setter.apply(this, [data, callback, newKey, this])};
            //            MWF.defineProperties(this, o);
            //        }
            //        this[newKey] = newValue;
            //    }else{
            //        if (overwrite) this[newKey] = newValue;
            //    }
            //
            //    //var valueType = typeOf(newValue);
            //    //var newValueData = newValue;
            //    //if (valueType=="object" || valueType=="array") newValueData = new MWF.xScript.JSONData(newValue, callback, newKey, this);
            //    //if (valueType=="null") newValueData = new MWF.xScript.JSONData({}, callback, newKey, this);
            //    //
            //    //this[newKey] = newValueData;
            //
            //    return this[newKey];
            //};
            //this.del = function(delKey){
            //    if (!this.hasOwnProperty(delKey)) return null;
            //    delete data[newKey];
            //    delete this[newKey];
            //    return this;
            //};
        };

        var type = typeOf(data);
        if (type === "object" || type === "array") define.apply(this);
    };
}
if( !MWF.xScript.dictLoaded )MWF.xScript.dictLoaded = {};

if (!MWF.xScript.createDict) {
    MWF.xScript.addDictToCache = function (options, path, json) {
        if (!path) path = "root";
        if (path.indexOf("root") !== 0) path = "root." + path;

        var type = options.appType || "process";
        var enableAnonymous = ( options.enableAnonymous || options.anonymous ) || false;

        var appFlagList = [];
        if (options.application) appFlagList.push(options.application);
        if (options.appId) appFlagList.push(options.appId);
        if (options.appName) appFlagList.push(options.appName);
        if (options.appAlias) appFlagList.push(options.appAlias);

        var dictFlagList = [];
        if (options.id) dictFlagList.push(options.id);
        if (options.name) dictFlagList.push(options.name);
        if (options.alias) dictFlagList.push(options.alias);

        var cache = {};
        cache[path] = json;

        for (var i = 0; i < appFlagList.length; i++) {
            for (var j = 0; j < dictFlagList.length; j++) {
                var k = dictFlagList[j] + type + appFlagList[i] + enableAnonymous;
                if (!MWF.xScript.dictLoaded[k]) {
                    MWF.xScript.dictLoaded[k] = cache; //指向同一个对象
                    // MWF.xScript.dictLoaded[k][path] = json; //指向不同的对象
                } else if (i === 0 && j === 0) {
                    MWF.xScript.setDictToCache(k, path, json);
                    var arr = path.split(/\./g);
                    var p;
                    var cache = MWF.xScript.dictLoaded[k];
                    for (var l = 0; l < arr.length; l++) {
                        p = l === 0 ? arr[0] : (p + "." + arr[l]);
                        if (cache[p]) break;
                    }
                    if (p) {
                        var mathP = p + ".";
                        Object.keys(cache).each(function (path, idx) {
                            if (path.indexOf(mathP) === 0) delete cache[path];
                        })
                    }
                }
            }
        }
    };

    MWF.xScript.getMatchedDict = function (key, path) {
        if (!path) path = "root";
        if (path.indexOf("root") !== 0) path = "root." + path;

        var arr = path.split(/\./g);
        if (MWF.xScript.dictLoaded[key]) {
            var dicts = MWF.xScript.dictLoaded[key];
            var list = Array.clone(arr);
            var p;
            var dict;
            for (var i = 0; i < arr.length; i++) {
                p = i === 0 ? arr[0] : (p + "." + arr[i]);
                list.shift();
                if (dicts[p]) {
                    dict = dicts[p];
                    break;
                }
            }
            return {
                dict: dict,
                unmatchedPathList: list
            }
        }
        return {
            dict: null,
            unmatchedPathList: list
        }
    };

    MWF.xScript.insertDictToCache = function (key, path, json) {
        var p = path;
        if( !p )p = "root";
        if( p.indexOf("root") !== 0 )p = "root." + p ;

        if (MWF.xScript.dictLoaded[key]) {
            var matchedDict = MWF.xScript.getMatchedDict(key, path);
            var dict = matchedDict.dict;
            var list = matchedDict.unmatchedPathList;
            if (!dict) {
                MWF.xScript.dictLoaded[key][p] = json;
            }else if( !list || list.length === 0 ){
                MWF.xScript.dictLoaded[key][p] = json;
            } else {
                for (var j = 0; j < list.length - 1; j++) {
                    if (!dict[list[j]]) {
                        dict[list[j]] = {};
                    }
                    dict = dict[list[j]];
                }
                var lastPath = list[list.length - 1];
                if (!dict[lastPath]) {
                    dict[lastPath] = json;
                } else if (typeOf(dict[lastPath]) === "array") {
                    dict[lastPath].push(json);
                }
            }
        } else {
            MWF.xScript.dictLoaded[key] = {};
            MWF.xScript.dictLoaded[key][p] = json;
        }
    };

    MWF.xScript.setDictToCache = function (key, path, json) {
        var p = path;
        if( !p )p = "root";
        if( p.indexOf("root") !== 0 )p = "root." + p ;

        if (MWF.xScript.dictLoaded[key]) {
            var matchedDict = MWF.xScript.getMatchedDict(key, path);
            var dict = matchedDict.dict;
            var list = matchedDict.unmatchedPathList;
            if (!dict) {
                MWF.xScript.dictLoaded[key][p] = json;
            }else if( !list || list.length === 0 ){
                MWF.xScript.dictLoaded[key][p] = json;
            } else {
                for (var j = 0; j < list.length - 1; j++) {
                    if (!dict[list[j]]) {
                        dict[list[j]] = {};
                    }
                    dict = dict[list[j]];
                }
                dict[list[list.length - 1]] = json;
            }
        } else {
            MWF.xScript.dictLoaded[key] = {};
            MWF.xScript.dictLoaded[key][p] = json;
        }
    };

    MWF.xScript.getDictFromCache = function (key, path) {
        var matchedDict = MWF.xScript.getMatchedDict(key, path);
        var dict = matchedDict.dict;
        var list = matchedDict.unmatchedPathList;
        if (dict) {
            for (var j = 0; j < list.length; j++) {
                dict = dict[list[j]];
                if (!dict) return null;
            }
            return dict;
        }
        return null;
    };

    MWF.xScript.deleteDictToCache = function (key, path) {
        var matchedDict = MWF.xScript.getMatchedDict(key, path);
        var dict = matchedDict.dict;
        var list = matchedDict.unmatchedPathList;

        if (dict) {
            for (var j = 0; j < list.length - 1; j++) {
                dict = dict[list[j]];
                if (!dict) return;
            }
            if( list.length ){
                delete dict[list[list.length - 1]];
            }
        }
    };

    MWF.xScript.createDict = function (application, appType) {
        //optionsOrName : {
        //  type : "", //默认为process, 可以为  process  cms
        //  application : "", //流程/CMS的名称/别名/id, 默认为当前应用
        //  name : "", // 数据字典名称/别名/id
        //  anonymous : false //允许在未登录的情况下读取CMS的数据字典， 该参数名也可以是 enableAnonymous
        //}
        //或者name: "" // 数据字典名称/别名/id
        return function (optionsOrName) {
            var options = optionsOrName;
            if (typeOf(options) == "string") {
                options = {
                    name: options,
                    type: appType,
                    application: application
                };
            }
            var name = this.name = options.name;
            var type;
            if( options.type === "service"){
                type = options.type;
            }else{
                type = ( options.type && options.application ) ?  options.type : "process";
            }
            var applicationId = options.application || application;
            var enableAnonymous = ( options.enableAnonymous || options.anonymous ) || false;

            var opt = {
                "appType": type,
                "name": name,
                "appId": applicationId,
                "enableAnonymous": enableAnonymous
            };

            var key = name + type + applicationId + enableAnonymous;
            // if (!dictLoaded[key]) dictLoaded[key] = {};
            // this.dictData = dictLoaded[key];

            //MWF.require("MWF.xScript.Actions.DictActions", null, false);
            var action;
            if (type === "cms") {
                action = MWF.Actions.get("x_cms_assemble_control");
            } else if( type === "portal" ){
                action = MWF.Actions.get("x_portal_assemble_surface");
            }else if( type === "service" ){
                key = name+type+enableAnonymous;
                action = MWF.Actions.get("x_program_center");
            } else {
                action = MWF.Actions.get("x_processplatform_assemble_surface");
            }

            var encodePath = function (path) {
                var arr = path.split(/\./g);
                var ar = arr.map(function (v) {
                    return encodeURIComponent(v);
                });
                return ( type === "portal" || type === "service" ) ? ar.join(".") : ar.join("/");
            };

            this.get = function (path, success, failure, async, refresh) {
                var value = null;

                if (success === true) async = true;
                if (failure === true) async = true;

                if (!refresh) {
                    var data = MWF.xScript.getDictFromCache(key, path);
                    if (data) {
                        if (success && o2.typeOf(success) == "function") success(data);
                        if (!!async) {
                            return Promise.resolve(data);
                        } else {
                            return data;
                        }
                    }
                }

                // var cb = function(json){
                //     value = json.data;
                //     MWF.xScript.addDictToCache(opt, path, value);
                //     if (success && o2.typeOf(success)=="function") value = success(json.data);
                //     return value;
                // }.ag().catch(function(xhr, text, error){ if (failure && o2.typeOf(failure)=="function") return failure(xhr, text, error); });

                var cb = function (json) {
                    value = json.data;
                    MWF.xScript.addDictToCache(opt, path, value);
                    if (success && o2.typeOf(success) == "function") value = success(json.data);
                    return value;
                };

                var promise;
                if( type === "service" ){
                    if (path){
                        var p = encodePath( path );
                        promise = action.getDictData(encodeURIComponent(this.name), p, cb, null, !!async, false);
                    }else{
                        promise = action.getDictRoot(this.name, cb, null, !!async, false);
                    }
                }else{
                    if (path) {
                        var p = encodePath(path);
                        promise = action[((enableAnonymous && type == "cms") ? "getDictDataAnonymous" : "getDictData")](encodeURIComponent(this.name), applicationId, p, cb, null, !!async, false);
                    } else {
                        promise = action[((enableAnonymous && type == "cms") ? "getDictRootAnonymous" : "getDictRoot")](this.name, applicationId, cb, null, !!async, false);
                    }
                }
                return (!!async) ? promise : value;

                // if (path){
                //     var p = encodePath( path );
                //     //var p = path.replace(/\./g, "/");
                //     action[ ( (enableAnonymous && type == "cms") ? "getDictDataAnonymous" : "getDictData" ) ](encodeURIComponent(this.name), applicationId, p, function(json){
                //         value = json.data;
                //         // this.dictData[path] = value;
                //         MWF.xScript.addDictToCache(opt, path, value);
                //         if (success) success(json.data);
                //     }.bind(this), function(xhr, text, error){
                //         if (failure) failure(xhr, text, error);
                //     }, !!async);
                // }else{
                //     action[ ( (enableAnonymous && type == "cms") ? "getDictRootAnonymous" : "getDictRoot" ) ](this.name, applicationId, function(json){
                //         value = json.data;
                //         // this.dictData["root"] = value;
                //         MWF.xScript.addDictToCache(opt, path, value);
                //         if (success) success(json.data);
                //     }.bind(this), function(xhr, text, error){
                //         if (failure) failure(xhr, text, error);
                //     }, !!async);
                // }

                //return value;
            };

            this.set = function (path, value, success, failure) {
                var p = encodePath(path);
                //var p = path.replace(/\./g, "/");
                var successCallback = function(json){
                    MWF.xScript.setDictToCache(key, path, value);
                    if (success) return success(json.data);
                };
                var failureCallback = function(xhr, text, error){
                    if (failure) return failure(xhr, text, error);
                };
                if( type === "service" ){
                    return action.setDictData(encodeURIComponent(this.name), p, value, successCallback, failureCallback, false, false);
                }else{
                    return action.setDictData(encodeURIComponent(this.name), applicationId, p, value, successCallback, failureCallback, false, false);
                }
            };
            this.add = function (path, value, success, failure) {
                var p = encodePath(path);
                //var p = path.replace(/\./g, "/");
                var successCallback = function(json){
                    MWF.xScript.insertDictToCache(key, path, value);
                    if (success) return success(json.data);
                };
                var failureCallback = function(xhr, text, error){
                    if (failure) return failure(xhr, text, error);
                };
                if( type === "service" ) {
                    return action.addDictData(encodeURIComponent(this.name), p, value, successCallback, failureCallback, false, false);
                }else{
                    return action.addDictData(encodeURIComponent(this.name), applicationId, p, value, successCallback, failureCallback, false, false);
                }
            };
            this["delete"] = function (path, success, failure) {
                var p = encodePath(path);
                //var p = path.replace(/\./g, "/");
                var successCallback = function(json){
                    MWF.xScript.deleteDictToCache(key, path);
                    if (success) return success(json.data);
                };
                var failureCallback = function(xhr, text, error){
                    if (failure) return failure(xhr, text, error);
                };
                if( type === "service" ) {
                    return action.deleteDictData(encodeURIComponent(this.name), p, successCallback, failureCallback, false, false);
                }else{
                    return action.deleteDictData(encodeURIComponent(this.name), applicationId, p, successCallback, failureCallback, false, false);
                }
            };
            this.destory = this["delete"];
        }
    };
}

MWF.xAction.RestActions.Action["x_organization_assemble_authentication"] = new Class({
    Extends: MWF.xAction.RestActions.Action,
    login: function(data, success, failure, async){
        this.action.invoke({"name": "login", data : data,
            "success": function(json, responseText){
                if (json.data.tokenType!="anonymous"){
                    if (success) success(json);
                }else{
                    if (failure) failure(null, responseText, json.message);
                }
            },"failure": failure, "async": async});
    },

    loginByCaptcha: function(data, success, failure, async){
        if (layout.config.publicKey){
            o2.load("../o2_lib/jsencrypt/jsencrypt.js", function(){
                var encrypt = new JSEncrypt();
                encrypt.setPublicKey("-----BEGIN PUBLIC KEY-----"+layout.config.publicKey+"-----END PUBLIC KEY-----");
                data.password = encrypt.encrypt(data.password);
                data.isEncrypted = "y";
                this.action.invoke({"name": "loginByCaptcha", data : data,
                    "success": function(json, responseText){
                        if (json.data.tokenType!="anonymous"){
                            if (success) success(json);
                        }else{
                            if (failure) failure(null, responseText, json.message);
                        }
                    },"failure": failure, "async": async});
            }.bind(this));
        }else{
            this.action.invoke({"name": "loginByCaptcha", data : data,
                "success": function(json, responseText){
                    if (json.data.tokenType!="anonymous"){
                        if (success) success(json);
                    }else{
                        if (failure) failure(null, responseText, json.message);
                    }
                },"failure": failure, "async": async});
        }
    },

    getAuthentication: function(success, failure, async){
        this.action.invoke({"name": "getAuthentication",
            "success": function(json, responseText){
                if (json.data.tokenType!=="anonymous" || layout.anonymous){
                    if (json.data && !json.data.roleList) json.data.roleList = [];
                    if (success) success(json);
                }else{
                    if (failure) failure(null, responseText, json.message);
                }
            }, "failure": failure, "async": async});
    }
});

MWF.xAction.RestActions.Action["x_processplatform_assemble_surface"] = new Class({
    Extends: MWF.xAction.RestActions.Action,

    exportView: function(app, view, filter){
        this.action.invoke({"name": "exportView","async": true, "data": filter, "parameter": {"flag": view, "applicationFlag": app},	"success": function(json){
            var url = this.action.actions["exportViewResult"].uri;
            //url = url.replace("{applicationFlag}", app);
            url = url.replace("{flag}", json.data.id);
            window.open(o2.filterUrl(this.action.address+url, "_blank"));
        }.bind(this)});
    },
    saveDictionary: function(data, success, failure){
        if (data.id){
            this.updateDictionary(data, success, failure);
        }else{
            this.addDictionary(data, success, failure);
        }
    },
    updateDictionary: function(data, success, failure){
        this.action.invoke({"name": "updataDictionary","data": data,"parameter": {"applicationDictFlag": data.id, "applicationFlag": data.application},"success": success,"failure": failure});
    },
    addDictionary: function(data, success, failure){
        if (!data.id){
            this.getUUID(function(id){
                data.id = id;
                this.action.invoke({"name": "addDictionary","data": data,"success": success,"failure": failure});
            }.bind(this));
        }
    },
    removeWork: function(id, application, all, success, failure, async){
        if (all){
            this.action.invoke({"name": "removeAllWork","async": async, "parameter": {"id": id, "applicationId": application},	"success": success,	"failure": failure});
        }else{
            this.action.invoke({"name": "removeWork","async": async, "parameter": {"id": id, "applicationId": application},	"success": success,	"failure": failure});
        }
    },

    getAttachmentData: function(id, workid){
        this.action.getActions(function(){
            var url = this.action.actions.getAttachmentData.uri;
            url = url.replace("{id}", encodeURIComponent(id));
            url = url.replace("{workid}", encodeURIComponent(workid));
            window.open(o2.filterUrl(this.action.address+url));
        }.bind(this));
    },
    getWorkcompletedAttachmentData: function(id, workid){
        this.action.getActions(function(){
            var url = this.action.actions.getWorkcompletedAttachmentData.uri;
            url = url.replace("{id}", encodeURIComponent(id));
            url = url.replace("{workCompletedId}", encodeURIComponent(workid));
            window.open(o2.filterUrl(this.action.address+url));
        }.bind(this));
    },
    getAttachmentStream: function(id, workid){
        this.action.getActions(function(){
            var url = this.action.actions.getAttachmentStream.uri;
            url = url.replace("{id}", encodeURIComponent(id));
            url = url.replace("{workid}", encodeURIComponent(workid));
            window.open(o2.filterUrl(this.action.address+url));
        }.bind(this));
    },
    getWorkcompletedAttachmentStream: function(id, workid){
        this.action.getActions(function(){
            var url = this.action.actions.getWorkcompletedAttachmentStream.uri;
            url = url.replace("{id}", encodeURIComponent(id));
            url = url.replace("{workCompletedId}", encodeURIComponent(workid));
            window.open(o2.filterUrl(this.action.address+url));
        }.bind(this));
    },

    getAttachmentUrl: function(id, workid, callback){
        this.action.getActions(function(){
            var url = this.action.actions.getAttachmentData.uri;
            url = url.replace("{id}", encodeURIComponent(id));
            url = url.replace("{workid}", encodeURIComponent(workid));
            if (callback) callback(o2.filterUrl(this.action.address+url));
        }.bind(this));
    },
    getAttachmentWorkcompletedUrl: function(id, workid, callback){
        this.action.getActions(function(){
            var url = this.action.actions.getWorkcompletedAttachmentData.uri;
            url = url.replace("{id}", encodeURIComponent(id));
            url = url.replace("{workCompletedId}", encodeURIComponent(workid));
            if (callback) callback(o2.filterUrl(this.action.address+url));
        }.bind(this));
    },
    getWorkDataByPath: function(id, path, success, failure, async){
        var p = path.replace(/\./g, "/");
        if (id.workCompleted){
            this.action.invoke({"name": "getWorkcompletedDataByPath","async": async, "parameter": {"id": id.workCompleted, "path": p},	"success": success,	"failure": failure, "urlEncode":false});
        }else{
            this.action.invoke({"name": "getWorkDataByPath","async": async, "parameter": {"id": id.work, "path": p},	"success": success,	"failure": failure, "urlEncode":false});
        }

    },
    getJobDataByPath: function(id, path, success, failure, async){
        var p = path.replace(/\./g, "/");
        this.action.invoke({"name": "getJobDataByPath","async": async, "parameter": {"id": id, "path": p},	"success": success,	"failure": failure, "urlEncode":false});
    },

    startWork: function(par1, par2, par3, par4, async){
        var process = par3, data = par4, success = par1, failure = par2;
        if (o2.typeOf(par1)==="string"){
            process = par1;
            data = par2;
            success = par3;
            failure = par4;
        }
        this.getProcess(process, function(json){
            if (json.data.defaultStartMode=="draft"){
                this.draw(process, data, success, failure, async)
            }else{
                this.createtWork(process, data, success, failure, async)
            }
        }.bind(this), failure, async);
    }
});
MWF.xAction.RestActions.Action["x_cms_assemble_control"] = new Class({
    Extends: MWF.xAction.RestActions.Action,
    getUUID: function(success){
        var id = "";
        this.action.invoke({"name": "getId","async": false, "parameter": {"count": "1"}, "success": function(ids){
            id = ids.data[0];
            if (success) success(id);
        },	"failure": null});
        return id;
    },
    saveColumn: function(columnData, success, failure){
        if (!columnData.isNewColumn){
            this.updateColumn(columnData, success, failure);
        }else{
            this.addColumn(columnData, success, failure);
        }
    },
    addColumn: function(columnData, success, failure){
        this.action.invoke({"name": "addColumn","data": columnData,"success": success,"failure": failure});
    },
    updateColumn: function(columnData, success, failure){
        this.action.invoke({"name": "updateColumn","data": columnData,"parameter": {"id": columnData.id},"success": success,"failure": failure});
    },
    updataColumnIcon: function(columnId, success, failure, formData, file){
        this.action.invoke({"name": "updataColumnIcon", "parameter": {"id": columnId},"data": formData,"file": file,"success": success,"failure": failure});
    },
    listCategory: function( columnId, success, failure, async){
        var _self = this;
        this.action.invoke({"name": "listCategory","parameter": {"appId": columnId },"async": async, "success": function(json){
            _self.transCategoryData(json);
            success.call(this,json);
        },"failure": failure});
    },
    listCategoryByPublisher: function( columnId, success, failure, async){
        var _self = this;
        this.action.invoke({"name": "listCategoryByPublisher","parameter": {"appId": columnId },"async": async, "success": function(json){
            _self.transCategoryData(json);
            success.call(this,json);
        },"failure": failure});
    },
    getCategory: function(categoryId, success, failure, async){
        var _self = this;
        this.action.invoke({"name": "getCategory", "parameter": {"id": categoryId },"success": function(json){
            _self.transCategoryData(json);
            success.call(this,json);
        },"failure": failure, "async": async});
    },
    saveCategory: function(categoryData, success, failure){
        if (!categoryData.isNew){
            this.updateCategory(categoryData, success, failure);
        }else{
            this.addCategory(categoryData, success, failure);
        }
    },
    addCategory: function(categoryData, success, failure){
        this.action.invoke({"name": "addCategory","data": categoryData,"success": success,"failure": failure});
    },
    updateCategory: function(categoryData, success, failure){
        this.action.invoke({"name": "updateCategory","data": categoryData,"parameter": {"id": categoryData.id},"success": success,"failure": failure});
    },
    transCategoryData : function( json ){
        var trans = function(category){
            if(!category.name)category.name = category.categoryName;
            if(!category.alias)category.alias = category.categoryAlias;
            if(!category.categoryName)category.categoryName = category.name;
            if(!category.categoryAlias)category.categoryAlias = category.alias;
        };
        if( json.data ){
            if( typeOf(json.data) == "array" ){
                json.data.each( function(category){
                    trans(category)
                })
            }else{
                trans(json.data)
            }
        }else{
            json.data = [];
        }
    },

    saveFile: function(data, success, failure, async){
        if (data.id){
            this.updataFile(data.id, data, success, failure, async);
        }else{
            this.getUUID(function(id){
                data.id = id;
                this.addFile(data, success, failure, async);
            }.bind(this), false);

        }
    },

    saveForm: function(formData, mobileData, fieldList, success, failure){
        if (!formData.isNewForm){
            this.updateForm(formData, mobileData, fieldList, success, failure);
        }else{
            this.addForm(formData, mobileData, fieldList, success, failure);
        }
    },
    updateForm: function(formData, mobileData, fieldList, success, failure){
        var data, mobileDataStr;
        if (formData) data = MWF.encodeJsonString(JSON.encode(formData));
        if (mobileData) mobileDataStr = MWF.encodeJsonString(JSON.encode(mobileData));

        var relatedScriptMap = null;
        if (formData && formData.json.includeScripts && formData.json.includeScripts.length){
            relatedScriptMap = {};
            formData.json.includeScripts.each(function(s){
                relatedScriptMap[s.id] = ((s.appType==="process") ? "processPlatform" : s.appType);
            });
        }

        var mobileRelatedScriptMap = null;
        if (mobileData && mobileData.json.includeScripts && mobileData.json.includeScripts.length){
            mobileRelatedScriptMap = {};
            mobileData.json.includeScripts.each(function(s){
                mobileRelatedScriptMap[s.id] = ((s.appType==="process") ? "processPlatform" : s.appType);
            });
        }

        var json = {
            "id": formData.json.id,
            "name": formData.json.name,
            "alias": formData.json.name,
            "description": formData.json.description,
            "appId": formData.json.application,
            "formFieldList": fieldList,
            "relatedScriptMap": relatedScriptMap,
            "relatedFormList": (formData && formData.json.subformList) ? formData.json.subformList : [],
            "mobileRelatedScriptMap": mobileRelatedScriptMap,
            "mobileRelatedFormList": (mobileData && mobileData.json.subformList) ? mobileData.json.subformList : []
        };
        if (formData) json.data = data;
        if (mobileData) json.mobileData = mobileDataStr;

        this.action.invoke({"name": "updataForm","data": json,"parameter": {"id": formData.json.id},"success": success,"failure": failure});
    },
    addForm: function(formData, mobileData, fieldList, success, failure){
        var data, mobileDataStr;
        if (!formData.json.id){
            this.getUUID(function(id){
                formData.json.id = id;

                if (formData) data = MWF.encodeJsonString(JSON.encode(formData));

                if ( mobileData && !mobileData.json.id ){
                    mobileData.json.id = id;
                }
                if (mobileData) mobileDataStr = MWF.encodeJsonString(JSON.encode(mobileData));

                var relatedScriptMap = null;
                if (formData && formData.json.includeScripts && formData.json.includeScripts.length){
                    relatedScriptMap = {};
                    formData.json.includeScripts.each(function(s){
                        relatedScriptMap[s.id] = ((s.appType==="process") ? "processPlatform" : s.appType);
                    });
                };

                var mobileRelatedScriptMap = null;
                if (mobileData && mobileData.json.includeScripts && mobileData.json.includeScripts.length){
                    mobileRelatedScriptMap = {};
                    mobileData.json.includeScripts.each(function(s){
                        mobileRelatedScriptMap[s.id] = ((s.appType==="process") ? "processPlatform" : s.appType);
                    });
                }

                var json = {
                    "id": formData.json.id,
                    "name": formData.json.name,
                    "alias": formData.json.name,
                    "description": formData.json.description,
                    "appId": formData.json.application,
                    "formFieldList": fieldList,
                    "relatedScriptMap": relatedScriptMap,
                    "relatedFormList": (formData && formData.json.subformList) ? formData.json.subformList : [],
                    "mobileRelatedScriptMap": mobileRelatedScriptMap,
                    "mobileRelatedFormList": (mobileData && mobileData.json.subformList) ? mobileData.json.subformList : []
                };
                if (formData) json.data = data;
                if (mobileData) json.mobileData = mobileDataStr;
                this.action.invoke({"name": "addForm","data": json, "parameter": {"id": formData.json.id }, "success": success,"failure": failure});
            }.bind(this));
        }else{
            if (formData) data = MWF.encodeJsonString(JSON.encode(formData));

            if ( mobileData && !mobileData.json.id ){
                mobileData.json.id = formData.json.id;
            }
            if (mobileData) mobileDataStr = MWF.encodeJsonString(JSON.encode(mobileData));

            var json = {
                "id": formData.json.id,
                "name": formData.json.name,
                "alias": formData.json.name,
                "description": formData.json.description,
                "appId": formData.json.application,
                "formFieldList": fieldList
            };
            if (formData) json.data = data;
            if (mobileData) json.mobileData = mobileDataStr;
            this.action.invoke({"name": "addForm","data": json, "parameter": {"id": formData.json.categoryId}, "success": success,"failure": failure});
        }
    },
    addFormTemplate: function(formData, mobileData, templateData, success, failure){
        var data, mobileDataStr;
        this.getUUID(function(id){
            //formData.json.id = id;
            templateData.id = id;
            if (formData){
                var tFormData = Object.clone(formData);
                tFormData.json.id = id;
                tFormData.json.name = templateData.name;
                data = MWF.encodeJsonString(JSON.encode(tFormData));
            }
            if (mobileData){
                var tMobileData = Object.clone(mobileData);
                tMobileData.json.id = id;
                tMobileData.json.name = templateData.name;
                mobileDataStr = MWF.encodeJsonString(JSON.encode(tMobileData));
            }

            //templateData.name
            //templateData.category
            //templateData.description

            if (formData) templateData.data = data;
            if (mobileData) templateData.mobileData = mobileDataStr;
            this.action.invoke({"name": "addFormTemplate","data": templateData, "success": success,"failure": failure});
        }.bind(this));
    },
    saveDictionary: function(data, success, failure){
        if (data.id || data.appDictId ){
            this.updateDictionary(data, success, failure);
        }else{
            this.addDictionary(data, success, failure);
        }
    },
    updateDictionary: function(data, success, failure){
        if(!data.alias || data.alias=="")data.alias=data.name;
        this.action.invoke({"name": "updataDictionary","data": data,"parameter": {"appDictId": data.id },"success": success,"failure": failure});
    },
    addDictionary: function(data, success, failure){
        if (!data.id){
            this.getUUID(function(id){
                data.id = id;
                data.appDictId = id;
                if(!data.alias || data.alias=="")data.alias=data.name;
                this.action.invoke({"name": "addDictionary","data": data, "parameter": {"appDictId": data.id },"success": success,"failure": failure});
            }.bind(this));
        }
    },
    getScript: function(id, success, failure, async){
        var _self = this;
        this.action.invoke({"name": "getScript","async": async, "parameter": {"id": id},	"success": function(json){
            _self.transScriptData(json);
            success.call(this,json);
        },	"failure": failure});
    },
    getScriptByName: function(name, appId, success, failure, async){
        var _self = this;
        this.action.invoke({"name": "getScriptByName","async": async, "parameter": {"name": name, "appId": appId},	"success": function(json){
            _self.transScriptData(json);
            success.call(this,json);
        },	"failure": failure});
    },
    saveScript: function(data, success, failure){
        if (!data.isNewScript){
            this.updateScript(data, success, failure);
        }else{
            this.addScript(data, success, failure);
        }
    },
    updateScript: function(data, success, failure){
        this.transScriptData(data,"send");
        this.action.invoke({"name": "updataScript","data": data,"parameter": {"id": data.id},"success": success,"failure": failure});
    },
    addScript: function(data, success, failure){
        this.transScriptData(data,"send");
        var _self = this;
        if (!data.id){
            this.getUUID(function(id){
                data.id = id;
                this.action.invoke({"name": "addScript","data": data,"success": success,"failure": failure});
            }.bind(this));
        }else{
            this.action.invoke({"name": "addScript","data": data,"success": success,"failure": failure});
        }
    },
    transScriptData : function( json, type ){
        var trans = function(json){
            if( type && type == "send" ){
                if(!json.appId )json.appId = json.application;
                if(!json.appName )json.appName = json.applicationName;
                if( json.application )delete json.application;
                if( json.applicationName )delete json.applicationName;
            }else{
                if(!json.appId )json.appId = json.application;
                if(!json.appName )json.appName = json.applicationName;
                if(!json.application )json.application = json.appId;
                if(!json.applicationName )json.application = json.appName;
            }
        };
        if( typeOf(json) == "array" ){
            json.each( function(json){
                trans(json)
            })
        }else{
            trans(json)
        }
    },
    saveView: function(viewData, success, failure){
        if (!viewData.isNew){
            this.updateView(viewData, success, failure);
        }else{
            this.addView(viewData, success, failure);
        }
    },
    addView: function(viewData, success, failure){
        this.action.invoke({"name": "addView","data": viewData,"success": success,"failure": failure});
    },
    updateView: function(viewData, success, failure){
        this.action.invoke({"name": "updateView","data": viewData,"parameter": {"id": viewData.id},"success": success,"failure": failure});
    },

    saveViewColumn: function(data, success, failure,async){
        if (!data.isNew){
            this.updateViewColumn(data, success, failure,async);
        }else{
            this.addViewColumn(data, success, failure,async);
        }
    },

    saveCategoryView: function(data, success, failure,async){
        if (!data.isNew){
            this.updateViewColumn(data, success, failure,async);
        }else{
            this.addViewColumn(data, success, failure,async);
        }
    },
    saveQueryView: function(data, success, failure,async){
        if ( data.isNewView ){
            data.isNewView = false;
            this.addQueryView(data, success, failure,async);
        }else{
            this.updateQueryView(data, success, failure,async);
        }
    },
    addQueryView: function(viewData, success, failure, async){
        var data =viewData.data;
        var dataStr = JSON.encode(viewData.data);
        viewData.data = dataStr;
        if (!data.id){
            this.getUUID(function(id){
                viewData.id = id;
                this.action.invoke({"name": "addQueryView","data": viewData, "success": success,"failure": failure,"async": async});
                viewData.data = data;
            }.bind(this));
        }else{
            this.action.invoke({"name": "addQueryView","data": viewData, "success": success,"failure": failure,"async": async});
            viewData.data = data;
        }
    },
    updateQueryView: function(viewData, success, failure, async){
        var data =viewData.data;
        var dataStr = JSON.encode(viewData.data);
        viewData.data = dataStr;
        this.action.invoke({"name": "updateQueryView","data": viewData,"async": async,"parameter": {"id": viewData.id},"success": success,"failure": failure});
        viewData.data = data;
    },

    //----document---
    saveDocument: function(documentData, success, failure, async){
        if (!documentData.isNewDocument){
            this.updateDocument(documentData, success, failure, async);
        }else{
            this.addDocument(documentData, success, failure, async);
        }
    },
    addDocument: function(documentData, success, failure, async){
        delete documentData.attachmentList;
        this.action.invoke({"name": "addDocument","data": documentData,"success": success,"failure": failure,"async": async});
    },
    updateDocument: function(documentData, success, failure, async){
        delete documentData.attachmentList;
        this.action.invoke({"name": "updateDocument","data": documentData,"parameter": {"id": documentData.id},"success": success,"failure": failure,"async": async});
    },
    saveData: function(success, failure, id, data, async){
        if( !data.isNew ) {
            this.updateData(success, failure, id, data, async);
        }else{
            this.addData(success, failure, id, data, async);
        }
    },
    addData: function(success, failure, id, data, async){
        this.action.invoke({"name": "addData","data": data, "parameter": {"id": id}, "success": success,"failure": failure,"async": async});
    },
    updateData: function(success, failure, id, data, async){
        this.action.invoke({"name": "updateData","data": data,"parameter": {"id": id},"success": success,"failure": failure, "async": async});
    },
    uploadAttachment: function(id, success, failure, formData, file){
        this.action.invoke({"name": "uploadAttachment", "parameter": {"id": id},"data": formData,"file": file,"success": success,"failure": failure});
    },
    replaceAttachment: function(id, documentid, success, failure, formData, file){
        this.action.invoke({"name": "replaceAttachment", "parameter": {"documentid": documentid, "id": id},"data": formData,"file": file,"success": success,"failure": failure});
    },
    getAttachmentData: function(id, documentid){
        this.action.getActions(function(){
            var url = layout.user.tokenType === "anonymous"?this.action.actions.getAttachmentDataByAnonymous.uri:this.action.actions.getAttachmentData.uri;
            url = url.replace("{id}", encodeURIComponent(id));
            url = url.replace("{documentid}", encodeURIComponent(documentid));
            window.open(o2.filterUrl(this.action.address+url));
        }.bind(this));
    },
    getAttachmentStream: function(id, documentid){
        this.action.getActions(function(){
            var url = layout.user.tokenType === "anonymous" ? this.action.actions.getAttachmentStreamByAnonymous.uri : this.action.actions.getAttachmentStream.uri;
            url = url.replace("{id}", encodeURIComponent(id));
            url = url.replace("{documentid}", encodeURIComponent(documentid));
            window.open(o2.filterUrl(this.action.address+url));
        }.bind(this));
    },
    getAttachmentUrl: function(id, documentid, callback){
        this.action.getActions(function(){
            var url = layout.user.tokenType === "anonymous" ? this.action.actions.getAttachmentDataByAnonymous.uri : this.action.actions.getAttachmentData.uri;
            url = url.replace("{id}", encodeURIComponent(id));
            url = url.replace("{documentid}", encodeURIComponent(documentid));
            if (callback) callback(o2.filterUrl(this.action.address+url));
        }.bind(this));
    },
    getAttachment: function(id, documentid, success, failure){
        if( layout.user.tokenType === "anonymous" ){
            this.action.invoke({"name": "getAttachmentByAnonymous", "parameter": {"id": id, "documentid": documentid},"success": success,"failure": failure});
        }else{
            this.action.invoke({"name": "getAttachment", "parameter": {"id": id, "documentid": documentid}, "success": success,"failure": failure});
        }
    },
    convertLocalImageToBase64: function(size, success, failure, formData, file){
        this.action.invoke({"name": "convertLocalImageToBase64", "parameter": {"size": size},"data": formData,"file": file,"success": success,"failure": failure});
    },
    getImageUrl: function(id, documentid, callback){
        this.action.getActions(function(){
            var url = this.action.actions.getImage.uri;
            url = url.replace("{id}", encodeURIComponent(id));
            url = url.replace("{documentid}", encodeURIComponent(documentid));
            if (callback) callback(o2.filterUrl(this.action.address+url));
        }.bind(this));
    },
    //--index--
    listDocumentFilterNext: function(id, count, data, success, failure, async){
        if( data && !data.documentType )data.documentType = "全部";
        this.action.invoke({"name": "listDocumentFilterNext","async": async, "data": data, "parameter": {"id": id, "count": count}, "success": success,	"failure": failure});
    },
    listDocumentFilterPrev: function(id, count, data, success, failure, async){
        if( data && !data.documentType )data.documentType = "全部";
        this.action.invoke({"name": "listDocumentFilterPrev","async": async, "data": data, "parameter": {"id": id, "count": count}, "success": success,	"failure": failure});
    },
    listDraftNext: function(id, count, data, success, failure, async){
        if( data && !data.documentType )data.documentType = "全部";
        this.action.invoke({"name": "listDraftNext","async": async, "data": data, "parameter": {"id": id, "count": count}, "success": success,	"failure": failure});
    },
    listDraftPrev: function(id, count, data, success, failure, async){
        if( data && !data.documentType )data.documentType = "全部";
        this.action.invoke({"name": "listDraftPrev","async": async, "data": data, "parameter": {"id": id, "count": count}, "success": success,	"failure": failure});
    },
    //--module--
    importDocumentFormExcel: function(categoryId, success, failure, formData, file){
        this.action.invoke({"name": "importDocumentFormExcel", "parameter": {"categoryId": categoryId},"data": formData,"file": file,"success": success,"failure": failure});
    },
    getCategoryByAlias: function(alias, success, failure){
        var _self = this;
        this.action.invoke({"name": "getCategoryByAlias","parameter": {"alias": alias },"success": function(json){
            _self.transCategoryData(json);
            success.call(this,json);
        },"failure": failure});
    },
    batchModifyData: function(docIds, dataChanges, success, failure){
        this.action.invoke({"name": "batchModifyData","data": { docIds : docIds, dataChanges : dataChanges },"success": success,"failure": failure});
    }
});

MWF.xAction.RestActions.Action["x_organization_assemble_control"] = new Class({
    Extends: MWF.xAction.RestActions.Action,

    //个人接口服务--
    savePerson: function(data, success, failure){
        if (data.id){
            this.updatePerson(data.id, data, success, failure);
        }else{
            this.addPerson(data, success, failure);
        }
    },
    listPersonByPinyin: function(success, failure, key, async){
        var data = {};
        if (typeOf(key)==="string"){ data.key = key; }else{data = key;}
        this.action.invoke({"name": "listPersonByPinyin","async": async, "data": data,	"success": success,	"failure": failure});
    },
    listPersonByPinyininitial: function(success, failure, key, async){
        var data = {};
        if (typeOf(key)==="string"){ data.key = key; }else{data = key;}
        this.action.invoke({"name": "listPersonByPinyininitial","async": async, "data": data,	"success": success,	"failure": failure});
    },
    listPersonByKey: function(success, failure, key, async){
        var data = {};
        if (typeOf(key)==="string"){ data.key = key; }else{data = key;}
        this.action.invoke({"name": "listPersonByKey","async": async, "data": data,	"success": success,	"failure": failure});
    },
    getPersonIcon: function(id){
        var uri = "/jaxrs/person/{flag}/icon";
        uri = uri.replace("{flag}", id);
        this.action.getAddress();
        return o2.filterUrl(this.action.address+uri+"?"+(new Date()).getTime());
    },


    //个人属性接口服务---
    savePersonAttribute: function(data, success, failure){
        if (data.id){
            this.updatePersonAttribute(data.id, data, success, failure);
        }else{
            this.addPersonAttribute(data, success, failure);
        }
    },

    //身份接口服务---
    saveIdentity: function(data, success, failure){
        if (data.id){
            this.updateIdentity(data.id, data, success, failure);
        }else{
            this.addIdentity(data, success, failure);
        }
    },
    listIdentityByKey: function(success, failure, key, async){
        var data = {};
        if (typeOf(key)==="string"){ data.key = key; }else{data = key;}
        this.action.invoke({"name": "listIdentityByKey","async": async, "data": data,	"success": success,	"failure": failure});
    },
    listIdentityByPinyin: function(success, failure, key, async){
        var data = {};
        if (typeOf(key)==="string"){ data.key = key; }else{data = key;}
        this.action.invoke({"name": "listIdentityByPinyin","async": async, "data": data,	"success": success,	"failure": failure});
    },
    listIdentityByPinyininitial: function(success, failure, key, async){
        var data = {};
        if (typeOf(key)==="string"){ data.key = key; }else{data = key;}
        this.action.invoke({"name": "listIdentityByPinyininitial","async": async, "data": data,	"success": success,	"failure": failure});
    },

    //角色接口服务---
    saveRole: function(data, success, failure){
        if (data.id){
            this.updateRole(data.id, data, success, failure);
        }else{
            this.addRole(data, success, failure);
        }
    },
    listRoleByPinyin: function(success, failure, key, async){
        var data = {};
        if (typeOf(key)==="string"){ data.key = key; }else{data = key;}
        this.action.invoke({"name": "listRoleByKey","async": async, "data": data,	"success": success,	"failure": failure});
    },
    listRoleByPinyininitial: function(success, failure, key, async){
        var data = {};
        if (typeOf(key)==="string"){ data.key = key; }else{data = key;}
        this.action.invoke({"name": "listRoleByPinyininitial","async": async, "data": data,	"success": success,	"failure": failure});
    },
    listRoleByKey: function(success, failure, key, async){
        var data = {};
        if (typeOf(key)==="string"){ data.key = key; }else{data = key;}
        this.action.invoke({"name": "listRoleByKey","async": async, "data": data,	"success": success,	"failure": failure});
    },

    //群组接口服务---
    saveGroup: function(data, success, failure){
        if (data.id){
            this.updateGroup(data.id, data, success, failure);
        }else{
            this.addGroup(data, success, failure);
        }
    },
    listGroupByKey: function(success, failure, key, async){
        var data = {};
        if (typeOf(key)==="string"){ data.key = key; }else{data = key;}
        this.action.invoke({"name": "listGroupByKey","async": async, "data": data,	"success": success,	"failure": failure});
    },
    listGroupByPinyin: function(success, failure, key, async){
        var data = {};
        if (typeOf(key)==="string"){ data.key = key; }else{data = key;}
        this.action.invoke({"name": "listGroupByPinyin","async": async, "data": data,	"success": success,	"failure": failure});
    },
    listGroupByPinyininitial: function(success, failure, key, async){
        var data = {};
        if (typeOf(key)==="string"){ data.key = key; }else{data = key;}
        this.action.invoke({"name": "listGroupByPinyininitial","async": async, "data": data,	"success": success,	"failure": failure});
    },

    //组织接口服务---
    saveUnit: function(data, success, failure){
        if (data.id){
            this.updateUnit(data.id, data, success, failure);
        }else{
            this.addUnit(data, success, failure);
        }
    },
    listUnitByKey: function(success, failure, key, async){
        var data = {};
        if (typeOf(key)==="string"){ data.key = key; }else{data = key;}
        this.action.invoke({"name": "listUnitByKey","async": async, "data": data,	"success": success,	"failure": failure});
    },
    listUnitByPinyin: function(success, failure, key, async){
        var data = {};
        if (typeOf(key)==="string"){ data.key = key; }else{data = key;}
        this.action.invoke({"name": "listUnitByPinyin","async": async, "data": data,	"success": success,	"failure": failure});
    },
    listUnitByPinyininitial: function(success, failure, key, async){
        var data = {};
        if (typeOf(key)==="string"){ data.key = key; }else{data = key;}
        this.action.invoke({"name": "listUnitByPinyininitial","async": async, "data": data,	"success": success,	"failure": failure});
    },

    //组织属性接口服务---
    saveUnitattribute: function(data, success, failure){
        if (data.id){
            this.updateUnitattribute(data.id, data, success, failure);
        }else{
            this.addUnitattribute(data, success, failure);
        }
    },

    //职务接口服务---
    saveUnitduty: function(data, success, failure){
        if (data.id){
            this.updateUnitduty(data.id, data, success, failure);
        }else{
            this.addUnitduty(data, success, failure);
        }
    }
});
MWF.xAction.RestActions.Action["x_query_assemble_surface"] = new Class({
    Extends: MWF.xAction.RestActions.Action,
    saveRow: function(tableFlag, data, success, failure, async){
        if ( data.id ){
            this.action.invoke({"name": "updateRow", "async": async, "parameter": {"tableFlag": tableFlag, "id" : data.id  }, "data" : data, "success": success, "failure": failure});
        }else{
            this.action.invoke({"name": "insertRow", "async": async, "parameter": {"tableFlag": tableFlag  }, "data" : data, "success": success, "failure": failure});
        }
    }
});
MWF.xAction.RestActions.Action["x_organization_assemble_personal"] = new Class({
    Extends: MWF.xAction.RestActions.Action,
    changePassword: function(oldPassword, password, morePassword, success, failure, async){
        if (layout.config.publicKey){
            o2.load("../o2_lib/jsencrypt/jsencrypt.js", function(){
                var encrypt = new JSEncrypt();
                encrypt.setPublicKey("-----BEGIN PUBLIC KEY-----"+layout.config.publicKey+"-----END PUBLIC KEY-----");
                var data = {
                    "oldPassword": encrypt.encrypt(oldPassword),
                    "newPassword": encrypt.encrypt(password),
                    "confirmPassword": encrypt.encrypt(morePassword),
                    "isEncrypted": "y"
                };
                this.action.invoke({"name": "changePassword", "async": async, "data": data, "success": success, "failure": failure});
            }.bind(this));
        }else{
            var data = {
                "oldPassword": oldPassword,
                "newPassword": password,
                "confirmPassword": morePassword
            };
            this.action.invoke({"name": "changePassword", "async": async, "data": data, "success": success, "failure": failure});
        }
    },
    resetPassword: function( data, success, failure, async ){
        if (layout.config.publicKey){
            o2.load("../o2_lib/jsencrypt/jsencrypt.js", function(){
                var encrypt = new JSEncrypt();
                encrypt.setPublicKey("-----BEGIN PUBLIC KEY-----"+layout.config.publicKey+"-----END PUBLIC KEY-----");
                var d = {
                    "codeAnswer": data.codeAnswer,
                    "credential": encrypt.encrypt(data.credential),
                    "password": encrypt.encrypt(data.password)
                };
                this.action.invoke({"name": "resetPassword", "async": async, "data": d, "success": success, "failure": failure});
            }.bind(this));
        }else{
            this.action.invoke({"name": "resetPassword", "async": async, "data": data, "success": success, "failure": failure});
        }
    },
    createCodeOnResetPassword: function ( credential, success, failure, async ){
        if (layout.config.publicKey){
            o2.load("../o2_lib/jsencrypt/jsencrypt.js", function(){
                var encrypt = new JSEncrypt();
                encrypt.setPublicKey("-----BEGIN PUBLIC KEY-----"+layout.config.publicKey+"-----END PUBLIC KEY-----");
                var c = encrypt.encrypt(credential);
                this.action.invoke({"name": "createCodeOnResetPassword", "async": async, "parameter":{ "credential": encodeURIComponent(c) }, "success": success, "failure": failure});
            }.bind(this));
        }else{
            this.action.invoke({"name": "createCodeOnResetPassword", "async": async, "parameter":{ "credential": credential }, "success": success, "failure": failure});
        }
    },
    getPersonIcon: function(id){
        var uri = "/jaxrs/person/icon";
        this.action.getAddress();
        return o2.filterUrl(this.action.address+uri+"?"+(new Date()).getTime());
    },
    getIcon: function(person){
        var uri = "/jaxrs/icon/"+person;
        this.action.getAddress();
        return this.action.address+uri+"?"+(new Date()).getTime();
    },
    createEmPower: function(data, success, failure, async){
        this.action.invoke({"name": "createEmPower", "async": async, "data": data, "success": success, "failure": failure});
    },
    editEmPower: function(id,data, success, failure, async){
        this.action.getAddress();

        this.action.invoke({"name": "editEmPower","parameter":{"id":id}, "async": async, "data": data, "success": success, "failure": failure});
    },
    deleteEmPower: function(id, success, failure, async){
        this.action.invoke({"name": "deleteEmPower","parameter":{"id":id}, "async": async, "success": success, "failure": failure});
    },

    listToCurrentPersonPaging: function( page, size, key,success, failure, async){
        this.action.invoke({"name": "listToCurrentPersonPaging", "parameter":{ "page":page, "size":size }, "data": { "key": key}, "async": async, "success": success, "failure": failure});
    },
    listWithCurrentPersonPaging: function( page, size, key,success, failure, async){
        this.action.invoke({"name": "listWithCurrentPersonPaging", "parameter":{ "page":page, "size":size }, "data": { "key": key}, "async": async, "success": success, "failure": failure});
    }
});
var actionJson = {
  "authentication": {
    "uri": "/jaxrs/authentication",
    "method": "GET"
  },
  "login": {
    "uri": "/jaxrs/authentication",
    "method": "POST"
  },
  "loginAdmin": {
    "uri": "/jaxrs/authentication/administrator",
    "method": "POST"
  },
  "logout": {
    "uri": "/jaxrs/authentication",
    "method": "DELETE"
  },
  "safeLogout": {
    "uri": "/jaxrs/authentication/safe/logout",
    "method": "GET"
  },
  "getLoginMode": {
    "uri": "/jaxrs/authentication/mode"
  }, //图片验证码默认可用，mode获取扫描二维码和手机验证码是否可用
  "getAuthentication": {
    "uri": "/jaxrs/authentication"
  }, //获取当前登录用户
  "loginByPassword": {
    "uri": "/jaxrs/authentication",
    "method": "POST"
  }, //用户登录.credential=xxxx,password=xxxx
  "getLoginCaptcha": {
    "uri": "/jaxrs/authentication/captcha/width/{width}/height/{height}"
  }, //验证码
  "loginByCaptcha": {
    "uri": "/jaxrs/authentication/captcha",
    "method": "POST"
  },
  "createCredentialCode": {
    "uri": "/jaxrs/authentication/code/credential/{credential}"
  }, //发送短信验证码
  "checkCredential": {
    "uri": "/jaxrs/authentication/check/credential/{credential}"
  }, //检查用户名是否存在
  "loginByCode": {
    "uri": "/jaxrs/authentication/code",
    "method": "POST"
  }, //使用短信验证码登录
  "getLoginBind": {
    "uri": "/jaxrs/authentication/bind"
  }, //扫描的二维码
  "checkBindStatus": {
    "uri": "/jaxrs/authentication/bind/meta/{meta}"
  }, //通过二维码进行登录，轮询判断是否登录
  "getOauthServer": {
    "uri": "/jaxrs/authentication/oauth/name/{name}",
    "method": "GET"
  },
  "listOauthServer": {
    "uri": "/jaxrs/authentication/oauth/list",
    "method": "GET"
  },
  "qywxOauthServer": {
    "uri": "/jaxrs/authentication/oauth/qywx/config",
    "method": "GET"
  },
  "dingdingOauthServer": {
    "uri": "/jaxrs/authentication/oauth/dingding/config",
    "method": "GET"
  },
  "loginOauthServer": {
    "uri": "/jaxrs/authentication/oauth/login/name/{name}/code/{code}/redirecturi/{redirectUri}",
    "method": "GET"
  },
  "loginOauthQywxServer": {
    "uri": "/jaxrs/authentication/oauth/login/qywx/code/{code}",
    "method": "GET"
  },
  "loginOauthDingdingServer": {
    "uri": "/jaxrs/authentication/oauth/login/dingding/code/{code}",
    "method": "GET"
  },
  "oauthBind": {
    "uri": "/jaxrs/authentication/oauth/bind/name/{name}/code/{code}/redirecturi/{redirectUri}",
    "method": "GET"
  },
  "clazz": "x_organization_assemble_authentication"
}

if (!o2.xAction.RestActions.Action["x_organization_assemble_authentication"]) o2.xAction.RestActions.Action["x_organization_assemble_authentication"] = new Class({Extends: o2.xAction.RestActions.Action});
o2.Actions.actions["x_organization_assemble_authentication"] = new o2.xAction.RestActions.Action["x_organization_assemble_authentication"]("x_organization_assemble_authentication", actionJson);
var actionJson = {
  "listApplication": {"uri": "/jaxrs/portal/list"},
  "getApplication": {"uri": "/jaxrs/portal/{id}"},


  "listPage": {"uri": "/jaxrs/page/list/portal/{id}"},
  "listSource": {"uri": "/jaxrs/source/list/portal/{id}"},
  "listScript": {"uri": "/jaxrs/script/list/portal/{id}"},
  "listMenu": {"uri": "/jaxrs/menu/list/portal/{id}"},
  "listWidget": {"uri": "/jaxrs/widget/list/portal/{id}"},

  "getPage": {"uri": "/jaxrs/page/{id}"},
  "getPageMobile": {"uri": "/jaxrs/page/{id}/mobile"},
  "getPageV2": {"uri": "/jaxrs/page/v2/{id}"},
  "getPageMobileV2": {"uri": "/jaxrs/page/v2/{id}/mobile"},

  "getPageByName": {"uri": "/jaxrs/page/{name}/portal/{id}"},
  "getPageByNameMobile": {"uri": "/jaxrs/page/{name}/portal/{id}/mobile"},

  "getPageByNameV2": {"uri": "/jaxrs/page/v2/{name}/portal/{id}"},
  "getPageByNameMobileV2": {"uri": "/jaxrs/page/v2/{name}/portal/{id}/mobile"},

  "getSource": {"uri": "/jaxrs/source/{id}"},
  "getScript": {"uri": "/jaxrs/script/{id}"},
  //"getScriptByName": {"uri": "/jaxrs/script/portal/{applicationId}/name/{name}"},
  "getScriptByName": {"uri": "/jaxrs/script/portal/{portal}/name/{name}","method": "POST"},
  "getMenu": {"uri": "/jaxrs/menu/{id}"},
  "getScriptByNameV2": {"uri": "/jaxrs/script/portal/{portal}/name/{name}/imported"},

  "getWidget": {"uri": "/jaxrs/widget/{id}"},
  "getWidgetMobile": {"uri": "/jaxrs/widget/{id}/mobile"},
  "getWidgetByName": {"uri": "/jaxrs/widget/{name}/portal/{id}"},
  "getWidgetByNameMobile": {"uri": "/jaxrs/widget/{name}/portal/{id}/mobile"},

  "readFile": {"uri": "/jaxrs/file/{flag}/portal/{applicationFlag}/content"},
  "listFile": {"uri": "/jaxrs/file/list/portal/{applicationFlag}"},


  "listDictionary": {"uri": "/jaxrs/dict/list/portal/{portalFlag}"},
  "getDictionary": {"uri": "/jaxrs/dict/{dictFlag}/portal/{portalFlag}"},

//  "updataDictionary": {"uri": "/jaxrs/applicationdict/{applicationDictFlag}/application/{applicationFlag}","method": "PUT"},

  "getDictRoot": {"uri": "/jaxrs/dict/{dictFlag}/portal/{portalFlag}/data"},
  "getDictData": {"uri": "/jaxrs/dict/{dictFlag}/portal/{portalFlag}/{path}/data"}, //path:路径(多层路径以.分割，如person.name)
  "setDictData": {"uri": "/jaxrs/dict/{dictFlag}/portal/{portalFlag}/{path}/data", "method": "PUT"},
  "addDictData": {"uri": "/jaxrs/dict/{dictFlag}/portal/{portalFlag}/{path}/data", "method": "POST"},
  "deleteDictData": {"uri": "/jaxrs/dict/{dictFlag}/portal/{portalFlag}/{path}/data", "method": "DELETE"},

  "clazz": "x_portal_assemble_surface"
}

if (!o2.xAction.RestActions.Action["x_portal_assemble_surface"]) o2.xAction.RestActions.Action["x_portal_assemble_surface"] = new Class({Extends: o2.xAction.RestActions.Action});
o2.Actions.actions["x_portal_assemble_surface"] = new o2.xAction.RestActions.Action["x_portal_assemble_surface"]("x_portal_assemble_surface", actionJson);
var actionJson = {
  "getApplication": {"uri": "/jaxrs/application/{id}"},
  "listApplication": {"uri": "/jaxrs/application/list"},
  "listApplications": {"uri": "/jaxrs/application/list"},
  "getApplicationIcon": {"uri": "/jaxrs/application/{id}/icon"},

  "listWorkNext": {"uri": "/jaxrs/work/list/{id}/next/{count}/application/{applicationId}"},
  "listWorkPrev": {"uri": "/jaxrs/work/list/{id}/prev/{count}/application/{applicationId}"},
  "listProcessCount": {"uri": "/jaxrs/work/list/count/application/{applicationId}/process"},
  "listWorkNextManage": {"uri": "/jaxrs/work/list/{id}/next/{count}/application/{applicationId}/manage"},
  "listWorkPrevManage": {"uri": "/jaxrs/work/list/{id}/prev/{count}/application/{applicationId}/manage"},
  "listProcessCountManage": {"uri": "/jaxrs/work/list/count/application/{applicationId}/process/manage"},
  "listProcessManage": {"uri": "/jaxrs/work/list/count/application/{applicationId}/process/manage"},

  "listWorkCreator": {"uri": "/jaxrs/work/list/{id}/next/{count}/creator/current"},
  "listWorkCreatorFilter": {"uri": "/jaxrs/work/list/{id}/next/{count}/creator/current/filter", "method": "POST"},

  "listAssignments": {"uri": "/jaxrs/work/{id}/assignment/manage"},
  "listRelatives": {"uri": "/jaxrs/work/{id}/relative/manage"},
  "listWorkByJob": {"uri": "/jaxrs/job/{job}/find/work/workcompleted"},
  "listAssignmentByWork": {"uri": "/jaxrs/work/{id}/assignment/manage"},

  "listWorkFilter": {"uri": "/jaxrs/work/list/{id}/next/{count}/application/{applicationId}/filter", "method": "POST"},
  "listFilterAttribute": {"uri": "/jaxrs/work/filter/attribute/application/{applicationId}"},
  "listWorkFilterManage": {"uri": "/jaxrs/work/list/{id}/next/{count}/application/{applicationId}/filter/manage", "method": "POST"},
  "listFilterAttributeManage": {"uri": "/jaxrs/work/filter/attribute/application/{applicationId}/manage"},

  "listWorkCompletedNext": {"uri": "/jaxrs/workcompleted/list/{id}/next/{count}/application/{applicationId}"},
  "listWorkCompletedPrev": {"uri": "/jaxrs/workcompleted/list/{id}/prev/{count}/application/{applicationId}"},
  "listWorkCompletedProcess": {"uri": "/jaxrs/workcompleted/list/count/application/{applicationId}/process"},

  "listWorkCompletedNextManage": {"uri": "/jaxrs/workcompleted/list/{id}/next/{count}/application/{applicationId}/manage"},
  "listWorkCompletedPrevManage": {"uri": "/jaxrs/workcompleted/list/{id}/prev/{count}/application/{applicationId}/manage"},
  "listWorkCompletedProcessManage": {"uri": "/jaxrs/workcompleted/list/count/application/{applicationId}/process/manage"},

  "listWorkCompletedFilter": {"uri": "/jaxrs/workcompleted/list/{id}/next/{count}/application/{applicationId}/filter", "method": "POST"},
  "listWorkCompletedFilterAttribute": {"uri": "/jaxrs/workcompleted/filter/attribute/application/{applicationId}"},
  "listWorkCompletedFilterManage": {"uri": "/jaxrs/workcompleted/list/{id}/next/{count}/application/{applicationId}/filter/manage", "method": "POST"},
  "listWorkCompletedFilterAttributeManage": {"uri": "/jaxrs/workcompleted/filter/attribute/application/{applicationId}/manage"},

  "listWorkCompletedAssignments": {"uri": "/jaxrs/workcompleted/{id}/assignment/manage"},

  "removeAllWork": {"uri": "/jaxrs/work/{id}/relative/manage", "method": "DELETE"},
  "removeWork": {"uri": "/jaxrs/work/{id}/single/manage", "method": "DELETE"},
  "removeWorkCompleted": {"uri": "/jaxrs/workcompleted/{id}/delete/manage", "method": "DELETE"},

  "resetTask": {"uri": "/jaxrs/task/{id}/reset/manage", "method": "PUT"},
  "flowTask": {"uri": "/jaxrs/task/{id}/processing/manage", "method": "PUT"},

  "resetRead": {"uri": "/jaxrs/read/{id}/reset/manage", "method": "PUT"},
  "flagRead": {"uri": "/jaxrs/read/{id}/processing/manage", "method": "PUT"},

  "flowWork": {"uri": "/jaxrs/work/{id}/processing", "method": "PUT"},

  "getWork": {"uri": "/jaxrs/work/{id}/manage"},
  "getWorkCompleted": {"uri": "/jaxrs/workcompleted/{id}/manage"},
  "getWorkContent": {"uri": "/jaxrs/work/{id}"},
  "getWorkInfor": {"uri": "/jaxrs/work/{id}"},


  "checkDraft": {"uri": "/jaxrs/work/{id}/close/check", "method": "GET"},

  "removeTask": {"uri": "/jaxrs/task/{id}/manage", "method": "DELETE"},
  "removeDone": {"uri": "/jaxrs/taskcompleted/{id}/manage", "method": "DELETE"},
  "removeRead": {"uri": "/jaxrs/read/{id}/manage", "method": "DELETE"},
  "removeReaded": {"uri": "/jaxrs/readcompleted/{id}/manage", "method": "DELETE"},

  "listDictionary": {"uri": "/jaxrs/applicationdict/list/application/{application}"},
  "getDictionary": {"uri": "/jaxrs/applicationdict/{applicationDict}/application/{applicationFlag}"},

  "updataDictionary": {"uri": "/jaxrs/applicationdict/{applicationDictFlag}/application/{applicationFlag}","method": "PUT"},

  "getDictRoot": {"uri": "/jaxrs/applicationdict/{applicationDict}/application/{application}/data"},
  "getDictData": {"uri": "/jaxrs/applicationdict/{applicationDict}/application/{application}/{path}/data"},
  "setDictData": {"uri": "/jaxrs/applicationdict/{applicationDict}/application/{application}/{path}/data", "method": "PUT"},
  "addDictData": {"uri": "/jaxrs/applicationdict/{applicationDict}/application/{application}/{path}/data", "method": "POST"},
  "deleteDictData": {"uri": "/jaxrs/applicationdict/{applicationDict}/application/{application}/{path}/data", "method": "DELETE"},

  "listSerialNumber": {"uri": "/jaxrs/serialnumber/list/application/{application}"},
  "getSerialNumber": {"uri": "/jaxrs/serialnumber/{id}"},
  "deleteSerialNumber": {"uri": "/jaxrs/serialnumber/{id}","method": "DELETE"},
  "updateSerialNumber": {"uri": "/jaxrs/serialnumber/{id}","method": "PUT"},

  "getRerouteTo": {"uri": "/jaxrs/process/{flag}/allowrerouteto"},
  "rerouteWork": {"uri": "/jaxrs/work/{id}/reroute/activity/{activityId}/activitytype/{type}", "method": "PUT"},

  "listView": {"uri": "/jaxrs/queryview/list/application/flag/{application}"},
  "loadView": {"uri": "/jaxrs/queryview/flag/{flag}/application/flag/{application}/execute", "method": "PUT"},
  "exportView": {"uri": "/jaxrs/queryview/flag/{flag}/application/flag/{applicationFlag}/excel", "method": "PUT"},
  "exportViewResult": {"uri": "/jaxrs/queryview/excel/result/{flag}"},


  "listStat": {"uri": "/jaxrs/querystat/list/application/flag/{application}"},
  "loadStat": {"uri": "/jaxrs/querystat/flag/{flag}/application/flag/{application}/execute", "method": "PUT"},

  "press": {"uri": "/jaxrs/taskcompleted/press/work/{work}"},

  "pauseTask": {"uri": "/jaxrs/task/v2/{id}/pause"},
  "resumeTask": {"uri": "/jaxrs/task/v2/{id}/resume"},

  "getCount": {"uri": "/jaxrs/work/count/{credential}"},

  "listApplicationStartable": {"uri": "/jaxrs/application/list/complex"},

  "listWorkByCreator": {"uri": "/jaxrs/work/list/creator"},

  "startWork": {"uri": "/jaxrs/work/process/{processId}", "method": "POST"},
  "processWork": {"uri": "/jaxrs/work/{id}/processing", "method": "PUT"},

  "createtWork": {"uri": "/jaxrs/work/process/{processId}", "method": "POST"},

  "draw": {"uri": "/jaxrs/draft/process/{processFlag}", "method": "POST"},
  "saveDraft": {"uri": "/jaxrs/draft", "method": "PUT"},
  "getDraft": {"uri": "/jaxrs/draft/{id}"},
  "listDraftNext": {"uri": "/jaxrs/draft/list/{id}/next/{count}"},
  "listDraftPrev": {"uri": "/jaxrs/draft/list/{id}/prev/{count}"},
  "listDraftPage": {"uri": "/jaxrs/draft/list/my/paging/{page}/size/{size}", "method": "POST"},
  "listDraftApplication": {"uri": "/jaxrs/draft/list/count/application"},
  "startDraft": {"uri": "/jaxrs/draft/{id}/start"},
  "deleteDraftWork": {"uri":  "/jaxrs/draft/{id}", "method": "DELETE"},

  "getTask": {"uri": "/jaxrs/task/{id}"},
  "saveTask": {"uri": "/jaxrs/task/{id}", "method": "POST"},
  "deleteTask": {"uri": "/jaxrs/task/{id}", "method": "DELETE"},
  "listTask": {"uri": "/jaxrs/task/list"},
  "listTaskNext": {"uri": "/jaxrs/task/list/{id}/next/{count}"},
  "listTaskNextByApp": {"uri": "/jaxrs/task/list/{id}/next/{count}/application/{application}"},
  "listTaskFilterCount": {"uri": "/jaxrs/task/filter/attribute"},
  "listTaskFilterCountFilter": {"uri": "/jaxrs/task/filter/attribute/filter", "method": "POST"},

  "listTaskMyFilterPaging": {"uri": "/jaxrs/task/list/my/filter/{page}/size/{size}", "method": "POST"},
  "listTaskMyPaging": {"uri": "/jaxrs/task/list/my/paging/{page}/size/{size}"},




  "getTaskCountFilter": {"uri": "/jaxrs/task/count/filter", "method": "POST"},
  "getTaskCount": {"uri": "/jaxrs/task/count/{name}"},
  "listTaskFilter": {"uri": "/jaxrs/task/list/{id}/next/{count}/filter", "method": "POST"},


  "listTaskPrev": {"uri": "/jaxrs/task/list/{id}/prev/{count}"},
  "processTask": {"uri": "/jaxrs/task/{id}/processing", "method": "POST"},

  "listTaskCompletedNext": {"uri": "/jaxrs/taskcompleted/list/{id}/next/{count}"},
  "listTaskCompletedNextByApp": {"uri": "/jaxrs/taskcompleted/list/{id}/next/{count}/application/{application}"},

  "listTaskCompletedPrev": {"uri": "/jaxrs/taskcompleted/list/{id}/prev/{count}"},

  "getSimpleJobByTask": {"uri": "/jaxrs/task/{id}/reference"},

  "listTaskApplication": {"uri": "/jaxrs/task/list/count/application"},
  "listTaskCompletedApplication": {"uri": "/jaxrs/taskcompleted/list/count/application"},

  "listTaskCompletedFilterCount": {"uri": "/jaxrs/taskcompleted/filter/attribute"},
  "listTaskCompletedFilterCountFilter": {"uri": "/jaxrs/taskcompleted/filter/attribute/filter", "method": "POST"},
  "listTaskCompletedMyFilterPaging": {"uri": "/jaxrs/taskcompleted/list/my/filter/{page}/size/{size}", "method": "POST"},
  "listTaskCompletedMyPaging": {"uri": "/jaxrs/taskcompleted/list/my/paging/{page}/size/{size}"},

  "listTaskCompletedFilter": {"uri": "/jaxrs/taskcompleted/list/{id}/next/{count}/filter", "method": "POST"},

  "getSimpleJobByTaskCompleted": {"uri": "/jaxrs/taskcompleted/{id}/reference"},
  "getTaskCompleted": {"uri": "/jaxrs/taskcompleted/{id}"},

  "listReadApplication": {"uri": "/jaxrs/read/list/count/application"},
  "listReadFilter": {"uri": "/jaxrs/read/list/{id}/next/{count}/filter", "method": "POST"},
  "listReadNext": {"uri": "/jaxrs/read/list/{id}/next/{count}"},
  "getSimpleJobByRead": {"uri": "/jaxrs/read/{id}/reference"},
  "listReadFilterCount": {"uri": "/jaxrs/read/filter/attribute"},
  "listReadFilterCountFilter": {"uri": "/jaxrs/read/filter/attribute/filter", "method": "POST"},
  "listReadMyFilterPaging": {"uri": "/jaxrs/read/list/my/filter/{page}/size/{size}", "method": "POST"},
  "listReadMyPaging": {"uri": "/jaxrs/read/list/my/paging/{page}/size/{size}"},

  "getReadCount": {"uri": "/jaxrs/read/count/{name}"},
  "setReaded": {"uri": "/jaxrs/read/{id}/processing", "method": "POST"},
  "getRead": {"uri": "/jaxrs/read/{id}"},

  "listReadedApplication": {"uri": "/jaxrs/readcompleted/list/count/application"},
  "listReadedFilter": {"uri": "/jaxrs/readcompleted/list/{id}/next/{count}/filter", "method": "POST"},
  "listReadedNext": {"uri": "/jaxrs/readcompleted/list/{id}/next/{count}"},
  "getSimpleJobByReaded": {"uri": "/jaxrs/readcompleted/{id}/reference"},
  "getReaded": {"uri": "/jaxrs/readcompleted/{id}"},
  "listReadedFilterCount": {"uri": "/jaxrs/readcompleted/filter/attribute"},
  "listReadedFilterCountFilter": {"uri": "/jaxrs/readcompleted/filter/attribute/filter", "method": "POST"},
  "listReadedMyFilterPaging": {"uri": "/jaxrs/readcompleted/list/my/filter/{page}/size/{size}", "method": "POST"},
  "listReadedMyPaging": {"uri": "/jaxrs/readcompleted/list/my/paging/{page}/size/{size}"},


  "listReviewApplication": {"uri": "/jaxrs/review/list/count/application"},
  "listReviewFilter": {"uri": "/jaxrs/review/list/{id}/next/{count}/filter", "method": "POST"},
  "listReviewNext": {"uri": "/jaxrs/review/list/{id}/next/{count}"},
  "getSimpleJobByReview": {"uri": "/jaxrs/review/{id}/reference"},
  "getReview": {"uri": "/jaxrs/review/{id}"},
  "listReviewFilterCount": {"uri": "/jaxrs/review/filter/attribute"},
  "listReviewFilterCountFilter": {"uri": "/jaxrs/review/filter/attribute/filter", "method": "POST"},
  "listReviewMyFilterPaging": {"uri": "/jaxrs/review/list/my/filter/{page}/size/{size}", "method": "POST"},
  "listReviewMyPaging": {"uri": "/jaxrs/review/list/my/paging/{page}/size/{size}"},
  "listReviewByJob": {"uri": "/jaxrs/review/list/job/{job}"},

  "manageDeleteReview": {"uri": "/jaxrs/review/{id}/application/{applicationFlag}/manage", "method": "DELETE"},
  "addWorkCompletedReview": {"uri": "/jaxrs/review/create/workcompleted", "method": "POST"},
  "addWorkReview": {"uri": "/jaxrs/review/create/work", "method": "POST"},

  "getJobByTask": {"uri": "/jaxrs/work/task/{id}/complex"},
  "getJobByWork": {"uri": "/jaxrs/work/{id}/complex"},
  "getJobByWorkMobile": {"uri": "/jaxrs/work/{id}/complex/mobile"},

  "getLogWithWork":  {"uri": "/jaxrs/worklog/list/work/{workId}"},


  "getWorkData": {"uri": "/jaxrs/data/work/{id}", "method": "GET"},
  "getWorkDataByPath": {"uri": "/jaxrs/data/work/{id}/{path}", "method": "GET"},
  "getWorkcompletedDataByPath": {"uri": "/jaxrs/data/workcompleted/{id}/{path}", "method": "GET"},
  "getJobDataByPath": {"uri": "/jaxrs/data/job/{id}/{path}", "method": "GET"},

  "getWorkcompletedData": {"uri": "/jaxrs/data/workcompleted/{id}", "method": "GET"},

  "saveData": {"uri": "/jaxrs/data/work/{id}", "method": "PUT"},
  "saveSectionData": {"uri": "/jaxrs/data/section/work/{id}", "method": "PUT"},
  "saveWorkCompletedData": {"uri": "/jaxrs/data/workcompleted/{id}", "method": "PUT"},

  "getJobByWorkCompleted": {"uri": "/jaxrs/workcompleted/{id}/complex"},
  "getJobByWorkCompletedMobile": {"uri": "/jaxrs/workcompleted/{id}/complex/mobile"},

  "uploadAttachment": {"uri": "/jaxrs/attachment/upload/work/{id}", "method": "POST", "enctype": "formData"},
  "uploadAttachmentByWorkCompleted": {"uri": "/jaxrs/attachment/upload/workcompleted/{id}", "method": "POST", "enctype": "formData"},
  "V2UploadWorkOrWorkCompleted": {"uri": "/jaxrs/attachment/v2/upload/workorworkcompleted/{workOrWorkCompleted}", "method": "POST", "enctype": "formData"},


  "replaceAttachment": {"uri": "/jaxrs/attachment/update/{id}/work/{workid}", "method": "POST", "enctype": "formData"},

  "getAttachmentData": {"uri": "/jaxrs/attachment/download/{id}/work/{workid}", "method": "GET"},
  "getWorkcompletedAttachmentData": {"uri": "/jaxrs/attachment/download/{id}/workcompleted/{workCompletedId}", "method": "GET"},

  "getAttachmentStream": {"uri": "/jaxrs/attachment/download/{id}/work/{workid}/stream", "method": "GET"},
  "getWorkcompletedAttachmentStream": {"uri": "/jaxrs/attachment/download/{id}/workcompleted/{workCompletedId}/stream", "method": "GET"},

  "getAttachment": {"uri": "/jaxrs/attachment/{id}/work/{workid}"},
  "getAttachmentWorkcompleted": {"uri": "/jaxrs/attachment/{id}/workcompleted/{workCompletedId}"},
  "deleteAttachment": {"uri": "/jaxrs/attachment/{id}/work/{workid}", "method": "DELETE"},
  "deleteWorkCompletedAttachment": {"uri": "/jaxrs/attachment/{id}/workcompleted/{workCompletedId}", "method": "DELETE"},

  "configAttachment": {"uri": "/jaxrs/attachment/edit/{id}/work/{workId}", "method": "PUT"},
  "getAttachmentOCR": {"uri": "/jaxrs/attachment/{id}/work/{workId}/text"},
  "setAttachmentOCR": {"uri": "/jaxrs/attachment/edit/{id}/work/{workId}/text", "method": "PUT"},

  "listWorkAttachments": {"uri": "/jaxrs/attachment/list/work/{workId}"},
  "listWorkCompletedAttachments": {"uri": "/jaxrs/attachment/list/workcompleted/{workCompletedId}"},

  "retractWork": {"uri": "/jaxrs/work/{id}/retract", "method": "PUT"},
  "resetWork": {"uri": "/jaxrs/task/{id}/reset", "method": "PUT"},

  "deleteWork": {"uri": "/jaxrs/work/{id}", "method": "DELETE"},
  "abandoned": {"uri": "/jaxrs/snap/work/{workId}/type/abandoned"},


  "getJobByWorkAssignForm": {"uri": "/jaxrs/work/{id}/complex/appoint/form/{formTag}"},
  "getJobByWorkAssignFormMobile": {"uri": "/jaxrs/work/{id}/complex/appoint/form/{formTag}/mobile"},
  "getJobByWorkCompletedAssignForm": {"uri": "/jaxrs/workcompleted/{id}/complex/appoint/form/{formTag}"},
  "getJobByWorkCompletedAssignFormMobile": {"uri": "/jaxrs/workcompleted/{id}/complex/appoint//form/{formTag}/mobile"},

  "lookupView": {"uri": "/jaxrs/view/{id}"},
  "getView": {"uri": "/jaxrs/view/{id}"},

  "getForm": {"uri": "/jaxrs/form/{id}/application/{applicationFlag}"},
  "getFormMobile": {"uri": "/jaxrs/form/{id}/application/{applicationFlag}/mobile"},
  "getScript": {"uri": "/jaxrs/script/{flag}/application/{applicationFlag}"},
  "getScriptByName": {"uri": "/jaxrs/script/{name}/application/{applicationId}","method": "POST"},
  "getFormV2": {"uri": "/jaxrs/form/v2/{id}?t={tag}"},
  "getFormV2Mobile": {"uri": "/jaxrs/form/v2/{id}/mobile?t={tag}"},
  "getScriptByNameV2": {"uri": "/jaxrs/script/{flag}/application/{applicationFlag}/imported"},

  "sendReaderByWork" : {"uri":"/jaxrs/read/work/{workId}", "method": "POST"},
  "sendReaderByWorkCompleted" : {"uri":"/jaxrs/read/workcompleted/{workCompletedId}", "method": "POST"},
  "copyAttachmentToWork" : {"uri":"/jaxrs/attachment/copy/work/{workId}", "method":"POST"},

  "listProcess": {"uri": "/jaxrs/process/list/application/{applicationFlag}"},
  "getProcess": {"uri": "/jaxrs/process/{id}/complex"},
  "getProcessByName": {"uri": "/jaxrs/process/{flag}/application/{applicationFlag}"},

  "readFile": {"uri": "/jaxrs/file/{flag}/application/{applicationFlag}/content"},
  "listFile": {"uri": "/jaxrs/file/list/application/{applicationFlag}"},

  "changeSite": {"uri": "/jaxrs/attachment/{id}/work/{workId}/change/site/{site}"},

  "addSplit": {"uri": "/jaxrs/work/{id}/add/split", "method": "PUT"},

  "loadWork": {"uri": "/jaxrs/work/workorworkcompleted/{workOrWorkCompleted}"},
  "getWorkLog": {"uri": "/jaxrs/worklog/list/workorworkcompleted/{workOrWorkCompleted}"},
  "getRecordLog": {"uri": "/jaxrs/record/list/workorworkcompleted/{workOrWorkCompleted}"},
  "listAttachments": {"uri": "/jaxrs/attachment/list/workorworkcompleted/{workOrWorkCompleted}"},
  "listTaskcompleted": {"uri": "/jaxrs/taskcompleted/list/workorworkcompleted/{workOrWorkCompleted}"},
  "listReadcompleted": {"uri": "/jaxrs/readcompleted/list/workorworkcompleted/{workOrWorkCompleted}"},
  "listRead": {"uri": "/jaxrs/read/list/workorworkcompleted/{workOrWorkCompleted}"},
  "getWorkControl": {"uri": "/jaxrs/control/workorworkcompleted/{workOrWorkCompleted}"},
  "getWorkForm": {"uri": "/jaxrs/form/workorworkcompleted/{workOrWorkCompleted}"},
  "getWorkFormMobile": {"uri": "/jaxrs/form/workorworkcompleted/{workOrWorkCompleted}/mobile"},

  "loadWorkV2": {"uri": "/jaxrs/work/v2/workorworkcompleted/{workOrWorkCompleted}"},
  "lookupFormWithWork": {"uri": "/jaxrs/form/v2/lookup/workorworkcompleted/{workOrWorkCompleted}"},
  "lookupFormWithWorkMobile": {"uri": "/jaxrs/form/v2/lookup/workorworkcompleted/{workOrWorkCompleted}/mobile"},

  "listTaskByJob": {"uri": "/jaxrs/task/list/job/{job}"},
  "listTaskCompletedByJob": {"uri": "/jaxrs/taskcompleted/list/job/{job}"},
  "listReadByJob": {"uri": "/jaxrs/read/list/job/{job}"},
  "listReadCompletedByJob": {"uri": "/jaxrs/readcompleted/list/job/{job}"},

  "listTaskByWork": {"uri": "/jaxrs/task/list/work/{work}"},
  "listTaskCompletedByWork": {"uri": "/jaxrs/taskcompleted/list/work/{work}"},
  "listReadByWork": {"uri": "/jaxrs/read/list/work/{work}"},
  "listReadCompletedByWork": {"uri": "/jaxrs/readcompleted/list/work/{work}"},

  "listTaskCompletedByWorkOrWorkCompleted": {"uri": "/jaxrs/taskcompleted/list/workorworkcompleted/{workOrWorkCompleted}"},
  "listReadByWorkOrWorkCompleted": {"uri": "/jaxrs/read/list/workorworkcompleted/{workOrWorkCompleted}"},
  "listReadCompletedByWorkOrWorkCompleted": {"uri": "/jaxrs/readcompleted/list/workorworkcompleted/{workOrWorkCompleted}"},

  "rollback": {"uri": "/jaxrs/work/{id}/rollback", "method": "PUT"},
  "rollbackWorkcompleted": {"uri": "/jaxrs/workcompleted/{flag}/rollback", "method": "PUT"},

  "setTaskOpinion": {"uri": "/jaxrs/task/{id}/opinion/manage", "method": "PUT"},
  "setTaskCompletedOpinion": {"uri": "/jaxrs/taskcompleted/{id}/opinion/manage", "method": "PUT"},
  "setReadOpinion": {"uri": "/jaxrs/read/{id}/opinion/manage", "method": "PUT"},
  "setReadCompletedOpinion": {"uri": "/jaxrs/readcompleted/{id}/opinion/manage", "method": "PUT"},

  "manageListTaskFilterByPage": {"uri": "/jaxrs/task/list/filter/{page}/size/{pageSize}/manage", "method": "POST"},
  "manageListTaskDoneFilterByPage": {"uri": "/jaxrs/taskcompleted/list/filter/{page}/size/{pageSize}/manage", "method": "POST"},
  "manageListReadFilterByPage": {"uri": "/jaxrs/read/list/filter/{page}/size/{pageSize}/manage", "method": "POST"},
  "manageListReadDoneFilterByPage": {"uri": "/jaxrs/readcompleted/list/filter/{page}/size/{pageSize}/manage", "method": "POST"},

  "manageListWorkFilterByPage": {"uri": "/jaxrs/work/list/filter/{page}/size/{pageSize}/manage", "method": "POST"},
  "manageListWorkCompletedFilterByPage": {"uri": "/jaxrs/workcompleted/list/filter/{page}/size/{pageSize}/manage", "method": "POST"},

  "docToWord": {"uri": "/jaxrs/attachment/doc/to/word/workorworkcompleted/{workId}", "method": "POST"},

  "getRouteSelectConfig" : {"uri":"/jaxrs/route/{id}/selectconfig"},
  "listRoute" : {"uri":"/jaxrs/route/list", "method":"PUT"},
  "getRoute" : {"uri":"/jaxrs/route/{id}"},

  "getReadRecord" : {"uri":"/jaxrs/readrecord/list/workorworkcompleted/{workOrWorkCompleted}"},



  "clazz": "x_processplatform_assemble_surface"

}

if (!o2.xAction.RestActions.Action["x_processplatform_assemble_surface"]) o2.xAction.RestActions.Action["x_processplatform_assemble_surface"] = new Class({Extends: o2.xAction.RestActions.Action});
o2.Actions.actions["x_processplatform_assemble_surface"] = new o2.xAction.RestActions.Action["x_processplatform_assemble_surface"]("x_processplatform_assemble_surface", actionJson);
var actionJson = {
  //返回人员的所有服务---------------------------------------------
  //人员增删改查
  "addPerson": {"uri": "/jaxrs/person", "method": "POST"},
  "getPerson": {"uri": "/jaxrs/person/{id}"},
  "updatePerson": {"uri": "/jaxrs/person/{id}", "method": "PUT"},
  "removePerson": {"uri": "/jaxrs/person/{id}", "method": "DELETE"},
  "deletePerson": {"uri": "/jaxrs/person/{id}", "method": "DELETE"},

  //列出指定群组所包含的人员（直接包含 嵌套包含）
  "listPersonDirect": {"uri": "/jaxrs/person/list/group/{id}/sub/direct"},
  "listPersonNested": {"uri": "/jaxrs/person/list/group/{id}/sub/nested"},
  //列出指定角色包含的人员
  //"listPersonByRole": {"uri": "/jaxrs/person/list/role/{id}"},

  //按拼音搜索（全拼 首字母）
  "listPersonByPinyin": {"uri": "/jaxrs/person/list/like/pinyin", "method": "PUT"},
  "listPersonByPinyininitial": {"uri": "/jaxrs/person/list/pinyininitial", "method": "PUT"},
  //按关键字搜索
  "listPersonByKey": {"uri": "/jaxrs/person/list/like", "method": "PUT"},

  //更换头像
  "changePersonIcon": {"uri": "/jaxrs/person/{id}/icon", "method": "PUT", "enctype": "formData"},
  //获取头像
  "getPersonIcon": {"uri": "/jaxrs/person/{flag}/icon"},

  //列出所有人员
  "listPersonNext": {"uri": "/jaxrs/person/list/{id}/next/{count}"},
  "listPersonPrev": {"uri": "/jaxrs/person/list/{id}/prev/{count}"},

  //修改密码
  "changePassword": {"uri": "/jaxrs/person/{name}/set/password", "method": "PUT"},
  //重置密码
  "resetPassword": {"uri": "/jaxrs/person/{flag}/reset/password"},

  //-------------------------------------------------------------

  //返回人员属性的所有服务------------------------------------------
  //人员属性增删改查
  "addPersonAttribute": {"uri": "/jaxrs/personattribute", "method": "POST"},
  "getPersonAttribute": {"uri": "/jaxrs/personattribute/{id}"},
  "updatePersonAttribute": {"uri": "/jaxrs/personattribute/{id}", "method": "PUT"},
  "removePersonAttribute": {"uri": "/jaxrs/personattribute/{id}", "method": "DELETE"},
  "deletePersonAttribute": {"uri": "/jaxrs/personattribute/{id}", "method": "DELETE"},

  //列出指定人员的所有属性
  "listPersonAttribute": {"uri": "/jaxrs/personattribute/list/person/{id}"},
  //-------------------------------------------------------------

  //返回身份的所有服务---------------------------------------------
  //身份增删改查
  "addIdentity": {"uri": "/jaxrs/identity", "method": "POST"},
  "getIdentity": {"uri": "/jaxrs/identity/{id}"},
  "updateIdentity": {"uri": "/jaxrs/identity/{id}", "method": "PUT"},
  "removeIdentity": {"uri": "/jaxrs/identity/{id}", "method": "DELETE"},
  "deleteIdentity": {"uri": "/jaxrs/identity/{id}", "method": "DELETE"},

  //身份排序
  "orderIdentity": {"uri": "/jaxrs/identity/{flag}/order/before/{followFlag}"},

  //列出指定组织的所有身份
  //"listIdentity": {"uri": "/jaxrs/identity/list/department/{id}"},

  //按拼音搜索（全拼 首字母）
  "listIdentityByPinyin": {"uri": "/jaxrs/identity/list/like/pinyin", "method": "PUT"},
  "listIdentityByPinyininitial": {"uri": "/jaxrs/identity/list/pinyininitial", "method": "PUT"},
  //按关键字搜索
  "listIdentityByKey": {"uri": "/jaxrs/identity/list/like", "method": "PUT"},

  //列出指定人的所有身份
  "listIdentityByPerson": {"uri": "/jaxrs/identity/list/person/{id}"},
  //列出指定人的所有身份、及身份所在组织和职务等信息。。。
  //"listIdentityComplexByPerson": {"uri": "/jaxrs/identity/complex/list/person/{id}"},
  //列出指定组织的身份
  "listIdentityWithUnit": {"uri": "/jaxrs/identity/list/unit/{unit}"},
  //列出指定职务的所有身份
  "listIdentityWithDuty": {"uri": "/jaxrs/identity/list/unitduty/name/{flag}"},

  //列出所有身份
  "listIdentityNext": {"uri": "/jaxrs/identity/list/{id}/next/{count}"},
  "listIdentityPrev": {"uri": "/jaxrs/identity/list/{id}/prev/{count}"},

  "listIdentityWidthUnitWithDutyName": {"uri": "/jaxrs/identity/list/{unit}/unitduty/name/{duty}"},

  //-------------------------------------------------------------

  //返回角色的所有服务---------------------------------------------
  "addRole": {"uri": "/jaxrs/role", "method": "POST"},
  "getRole": {"uri": "/jaxrs/role/{id}"},
  "updateRole": {"uri": "/jaxrs/role/{id}", "method": "PUT"},
  "removeRole": {"uri": "/jaxrs/role/{id}", "method": "DELETE" },
  "deleteRole": {"uri": "/jaxrs/role/{id}", "method": "DELETE" },

  //按拼音搜索（全拼 首字母）
  "listRoleByPinyin": {"uri": "/jaxrs/role/list/like/pinyin", "method": "PUT"},
  "listRoleByPinyininitial": {"uri": "/jaxrs/role/list/pinyininitial", "method": "PUT"},
  //按关键字搜索
  "listRoleByKey": {"uri": "/jaxrs/role/list/like", "method": "PUT"},

  //列出指定群组拥有的角色
  "listRoleByGroup": {"uri": "/jaxrs/role/list/group/{id}"},
  //列出指定人员拥有的角色
  "listRoleByPerson": {"uri": "/jaxrs/role/list/person/{id}"},

  //列出所有角色
  "listRoleNext": {"uri": "/jaxrs/role/list/{id}/next/{count}"},
  "listRolePrev": {"uri": "/jaxrs/role/list/{id}/prev/{count}"},
  //-------------------------------------------------------------

  //返回群组的所有服务---------------------------------------------
  //群组增删改查
  "addGroup": {"uri": "/jaxrs/group", "method": "POST"},
  "getGroup": {"uri": "/jaxrs/group/{id}"},
  "updateGroup": {"uri": "/jaxrs/group/{id}", "method": "PUT"},
  "removeGroup": {"uri": "/jaxrs/group/{id}", "method": "DELETE"},
  "deleteGroup": {"uri": "/jaxrs/group/{id}", "method": "DELETE"},

  //根据拼音搜索（全拼 首字母）
  "listGroupByPinyin": {"uri": "/jaxrs/group/list/like/pinyin", "method": "PUT"},
  "listGroupByPinyininitial": {"uri": "/jaxrs/group/list/pinyininitial", "method": "PUT"},
  //根据关键字搜索
  "listGroupByKey": {"uri": "/jaxrs/group/list/like", "method": "PUT"},

  //列出人员所在群组（直接包含群组  嵌套群组）
  "listGroupDirectByPerson": {"uri": "/jaxrs/group/list/person/{id}/sup/direct"},
  "listGroupNestedByPerson": {"uri": "/jaxrs/group/list/person/{id}/sup/nested"},

  //列出指定群组的上级和下级群组（直接 和 所有）
  "listSubGroupDirect": {"uri": "/jaxrs/group/list/{id}/sub/direct"},
  "listSubGroupNested": {"uri": "/jaxrs/group/list/{id}/sub/nested"},
  "listSupGroupDirect": {"uri": "/jaxrs/group/list/{id}/sup/direct"},
  "listSupGroupNested": {"uri": "/jaxrs/group/list/{id}/sup/nested"},
  //列出指定角色包含的群组
  //"listGroupByRole": {"uri": "/jaxrs/group/list/role/{id}"},

  //列出所有群组
  "listGroupNext": {"uri": "/jaxrs/group/list/{id}/next/{count}"},
  "listGroupPrev": {"uri": "/jaxrs/group/list/{id}/prev/{count}"},
  //-------------------------------------------------------------

  //返回组织的所有接口
  "addUnit": {"uri": "/jaxrs/unit", "method": "POST"},
  "getUnit": {"uri": "/jaxrs/unit/{id}"},
  "updateUnit": {"uri": "/jaxrs/unit/{id}", "method": "PUT"},
  "removeUnit": {"uri": "/jaxrs/unit/{id}", "method": "DELETE"},
  "deleteUnit": {"uri": "/jaxrs/unit/{id}", "method": "DELETE"},

  //根据拼音搜索（全拼 首字母）
  "listUnitByPinyin": {"uri": "/jaxrs/unit/list/like/pinyin", "method": "PUT"},
  "listUnitByPinyininitial": {"uri": "/jaxrs/unit/list/pinyininitial", "method": "PUT"},
  //根据关键字搜索
  "listUnitByKey": {"uri": "/jaxrs/unit/list/like", "method": "PUT"},

  //列出顶层组织
  "listTopUnit": {"uri": "/jaxrs/unit/list/top"},
  //根据指定的类型，列出组织
  "listUnitByType": {"uri": "/jaxrs/unit/list/unit/type", "method": "PUT"},
  //列出组织类型
  "listUnitType": {"uri": "/jaxrs/unit/list/type"},
  //列出所有组织
  "listUnitNext": {"uri": "/jaxrs/unit/list/{id}/next/{count}"},
  "listUnitPrev": {"uri": "/jaxrs/unit/list/{id}/prev/{count}"},

  //列出指定组织的上级和下级组织（直接 和 所有）
  "listSubUnitDirect": {"uri": "/jaxrs/unit/list/{id}/sub/direct"},
  "listSubUnitNested": {"uri": "/jaxrs/unit/list/{id}/sub/nested"},
  "listSubUnitNestedByType": {"uri": "/jaxrs/unit/list/{flag}/sub/direct/type/{type}"},

  "getSupUnitDirect": {"uri": "/jaxrs/unit/{id}/sup/direct"},
  "listSupUnitNested": {"uri": "/jaxrs/unit/list/{id}/sup/nested"},
  "listSupUnitNestedByType": {"uri": "/jaxrs/unit/list/{flag}/sup/nested/type/{type}"},

  "getUnitWithIdentityWithLevel": {"uri": "/jaxrs/unit/identity/{id}/level/{level}"},
  "getUnitWithIdentityWithType": {"uri": "/jaxrs/unit/identity/{id}/type/{type}"},
  //-------------------------------------------------------------

  //返回组织属性的所有接口
  "addUnitattribute": {"uri": "/jaxrs/unitattribute", "method": "POST"},
  "getUnitattribute": {"uri": "/jaxrs/unitattribute/{id}"},
  "updateUnitattribute": {"uri": "/jaxrs/unitattribute/{id}", "method": "PUT"},
  "removeUnitattribute": {"uri": "/jaxrs/unitattribute/{id}", "method": "DELETE"},
  "deleteUnitattribute": {"uri": "/jaxrs/unitattribute/{id}", "method": "DELETE"},

  //列出组织属性
  "listUnitattribute": {"uri": "/jaxrs/unitattribute/list/unit/{id}"},

  //列出所有组织属性
  "listUnitattributeNext": {"uri": "/jaxrs/unitattribute/list/{id}/next/{count}"},
  "listUnitattributePrev": {"uri": "/jaxrs/unitattribute/list/{id}/prev/{count}"},
  //-------------------------------------------------------------

  //返回组织职务的所有接口
  "addUnitduty": {"uri": "/jaxrs/unitduty", "method": "POST"},
  "getUnitduty": {"uri": "/jaxrs/unitduty/{id}"},
  "updateUnitduty": {"uri": "/jaxrs/unitduty/{id}", "method": "PUT"},
  "removeUnitduty": {"uri": "/jaxrs/unitduty/{id}", "method": "DELETE"},
  "deleteUnitduty": {"uri": "/jaxrs/unitduty/{id}", "method": "DELETE"},

  //获取去重的职务名称
  "listUnitdutyName": {"uri": "/jaxrs/unitduty/distinct/name"},
  //搜索职务名称
  "listUnitdutyNameByKey": {"uri": "/jaxrs/unitduty/distinct/name/like/{key}"},

  //根据关键字搜索
  "listUnitdutyByKey": {"uri": "/jaxrs/unitduty/distinct/name/like/{key}"},
  //列出指定身份的所有职务
  "listUnitdutyByIdentity": {"uri": "/jaxrs/unitduty/list/identity/{flag}"},

  //列出指定组织的所有职务
  "listUnitdutyByUnit": {"uri": "/jaxrs/unitduty/list/unit/{flag}"},
  "listUnitdutyByName": {"uri": "/jaxrs/unitduty/list/name/{name}"},

  //列出所有组织职务
  "listUnitdutyNext": {"uri": "/jaxrs/unitduty/list/{id}/next/{count}"},
  "listUnitdutyPrev": {"uri": "/jaxrs/unitduty/list/{id}/prev/{count}"},
  //-------------------------------------------------------------

  "getImportPersonTemplate": {"uri": "/jaxrs/inputperson/template"},
  "getImportPersonResault": {"uri": "/jaxrs/inputperson/result/flag/{flag}"},
  "importPerson": {"uri": "/jaxrs/inputperson", "method": "POST", "enctype": "formData"},
  "wipeAll": {"uri": "/jaxrs/inputperson/wipe"},

  "clazz": "x_organization_assemble_control"
}
if (!o2.xAction.RestActions.Action["x_organization_assemble_control"]) o2.xAction.RestActions.Action["x_organization_assemble_control"] = new Class({Extends: o2.xAction.RestActions.Action});
o2.Actions.actions["x_organization_assemble_control"] = new o2.xAction.RestActions.Action["x_organization_assemble_control"]("x_organization_assemble_control", actionJson);
var actionJson = {
  "getQuery": {"uri": "/jaxrs/query/{flag}"},
  "listQuery": {"uri": "/jaxrs/query/list"},
  "listQueryByKey": {"uri": "/jaxrs/query/list/key/{key}"},

  "getStatById": {"uri": "/jaxrs/stat/{id}"},
  "getStat": {"uri": "/jaxrs/stat/flag/{flag}/query/{queryFlag}"},
  "listStat": {"uri": "/jaxrs/stat/list/query/{queryFlag}"},
  "loadStatById": {"uri": "/jaxrs/stat/{id}/execute", "method": "PUT"},
  "loadStat": {"uri": "/jaxrs/stat/flag/{flag}/query/{queryFlag}/execute", "method": "PUT"},

  "getViewById": {"uri": "/jaxrs/view/{id}"},
  "getView": {"uri": "/jaxrs/view/flag/{flag}/query/{queryFlag}"},
  "listView": {"uri": "/jaxrs/view/list/query/{queryFlag}"},
  "loadViewById": {"uri": "/jaxrs/view/{id}/execute", "method": "PUT"},
  "loadView": {"uri": "/jaxrs/view/flag/{flag}/query/{queryFlag}/execute", "method": "PUT"},
  "bundleView": {"uri": "/jaxrs/view/{id}/bundle", "method": "PUT"},

  "getTableById" : { "uri": "/jaxrs/table/{id}" },

  "exportViewWithQuery": {"uri": "/jaxrs/view/flag/{flag}/query/{queryFlag}/excel", "method": "PUT"},
  "exportView": {"uri": "/jaxrs/view/{id}/excel", "method": "PUT"},
  "getViewExcel": {"uri": "/jaxrs/view/excel/result/{flag}"},

  "search": {"uri": "/jaxrs/segment/key/{key}"},
  "listSearchEntry": {"uri": "/jaxrs/segment/list/entry", "method": "POST"},

  "executeStatement" : { "uri": "/jaxrs/statement/{flag}/execute/page/{page}/size/{size}", "method": "POST" },

  "listRowNext" : { "uri" : "/jaxrs/table/list/{tableFlag}/row/{id}/next/{count}" },
  "listRowPrev" : { "uri" : "/jaxrs/table/list/{tableFlag}/row/{id}/prev/{count}" },
  "listRowSelectWhere" : { "uri" : "/jaxrs/table/list/{tableFlag}/row/select/where/{where}" }, //通过where 获取表中的数据,格式为jpql语法,o.name='zhangsan'
  "listRowCountWhere" : { "uri" : "/jaxrs/table/{tableFlag}/row/count/where/{where}" },
  "getRow" : { "uri": "/jaxrs/table/{tableFlag}/row/{id}" }, //获取表中某一行数据
  "updateRow":{ "uri": "/jaxrs/table/{tableFlag}/row/{id}", "method": "PUT" }, //更新指定表中指定行数据.
  "insertRow":{ "uri": "/jaxrs/table/{tableFlag}/row", "method": "POST" },//插入一行
  "countRowWhere" : { "uri": "/jaxrs/table/{tableFlag}/row/count/where/{where}"},//通过where 统计数量
  "deleteRow" : { "uri": "/jaxrs/table/{tableFlag}/row/{id}", "method": "DELETE" }, //更新指定表中指定行数据.
  "deleteAllRow" : { "uri": "/jaxrs/table/{tableFlag}/row/delete/all", "method": "DELETE"}, //通过where 统计数量

  "calculateNeural": {"uri": "/jaxrs/neural/list/calculate/model/{modelFlag}/work/{workId}"},

  "executImportModel": { "uri" : "/jaxrs/importmodel/{id}/execute", "method": "POST"},
  "listImportModel": { "uri" : "/jaxrs/importmodel/list/query/{queryFlag}"},
  "getImportModelById": { "uri" : "/jaxrs/importmodel/{id}"},
  "getImportModel": { "uri" : "/jaxrs/importmodel/flag/{flag}/query/{queryFlag}"},

  "getUUID": { "uri" : "/jaxrs/importmodel/uuid"},

  "getImportModelRecord": { "uri" : "/jaxrs/importmodel/record/{recordId}"},
  "getImportModelRecordStatus": { "uri" : "/jaxrs/importmodel/record/{recordId}/status"},
  "listImportModelRecord": {"uri": "/jaxrs/importmodel/list/record/paging/{page}/size/{size}", "method": "POST"},
  "listImportModelRecordItem": { "uri" : "/jaxrs/importmodel/list/record/item/paging/{page}/size/{size}", "method": "POST"},

  "clazz": "x_query_assemble_surface"
}

if (!o2.xAction.RestActions.Action["x_query_assemble_surface"]) o2.xAction.RestActions.Action["x_query_assemble_surface"] = new Class({Extends: o2.xAction.RestActions.Action});
o2.Actions.actions["x_query_assemble_surface"] = new o2.xAction.RestActions.Action["x_query_assemble_surface"]("x_query_assemble_surface", actionJson);
var actionJson = {
  "listApplication": {"uri": "/jaxrs/appinfo/list/user/view/all" },
  "listCMSApplication": {"uri": "/jaxrs/appinfo/list/user/view/all" },
  "getApplication": {"uri": "/jaxrs/appinfo/{id}"},
  "getCMSApplication": {"uri": "/jaxrs/appinfo/{id}"},

  "listAllAppType" : {"uri":"/jaxrs/appinfo/list/appType"},
  "listAllAppTypeByManager" : {"uri":"/jaxrs/appinfo/list/appType/manager"},
  "listWhatICanManageWithAppType" : {"uri":"/jaxrs/appinfo/list/manage/type/{appType}"},
  "listWhatICanViewWithAppType" : {"uri":"/jaxrs/appinfo/list/user/view/all/type/{appType}"},

  "listCMSCategory" : {"uri": "/jaxrs/categoryinfo/list/view/app/{appId}/all" },
  "getCMSForm" : {"uri": "/jaxrs/form/{id}" },

  "listApplicationView": {"uri": "/jaxrs/queryview/list/all"},
  "listCMSApplicationView": {"uri": "/jaxrs/queryview/list/all"},

  "getId" : {"uri":"/jaxrs/uuid/random"},

  "listColumn": {"uri": "/jaxrs/appinfo/list/user/view/all" }, //"/jaxrs/appinfo/list/all"},
  "listColumnByPublish": {"uri": "/jaxrs/appinfo/list/user/publish" },
  "listColumnByAdmin": {"uri": "/jaxrs/appinfo/list/admin" },
  "getColumn": {"uri": "/jaxrs/appinfo/{id}"},
  "getColumnByName": {"uri": "/jaxrs/appinfo/{id}"},
  "addColumn": {"uri": "/jaxrs/appinfo","method": "POST"},
  "removeColumn": {"uri": "/jaxrs/appinfo/{id}","method": "DELETE"},
  "updateColumn": {"uri": "/jaxrs/appinfo","method": "POST"},
  "getColumnIcon":{"uri":"/jaxrs/appinfo/{id}/icon"},
  "updataColumnIcon": {
    "uri": "/jaxrs/appinfo/{id}/icon/size/72",
    "method": "POST",
    "enctype": "formData"
  },

  "listAllCategory" : {"uri":"/jaxrs/categoryinfo/list/all"},
  "listCategory": {"uri": "/jaxrs/categoryinfo/list/view/app/{appId}/all" },
  "listCategoryByPublisher": {"uri": "/jaxrs/categoryinfo/list/publish/app/{appId}" },
  "addCategory" : {"uri":"/jaxrs/categoryinfo","method":"POST"},
  "getCategory" : {"uri":"/jaxrs/categoryinfo/{id}"},
  "updateCategory": {"uri": "/jaxrs/categoryinfo","method": "POST"},
  "removeCategory": {"uri": "/jaxrs/categoryinfo/{id}","method": "DELETE"},
  "saveCategoryExtContent" : {"uri": "/jaxrs/categoryinfo/extContent","method": "POST"},
  "saveCategoryImportView" : {"uri": "/jaxrs/categoryinfo/bind/{categoryId}/view","method": "PUT"},

  "listAllForm" : {"uri":"/jaxrs/form/list/all"},
  "listForm": {"uri": "/jaxrs/form/list/app/{appId}"},
  "getForm": {"uri": "/jaxrs/form/{id}"},
  "getFormWithColumn": {"uri": "/jaxrs/form/{formFlag}/appinfo/{appFlag}"},
  "addForm": {"uri": "/jaxrs/form","method": "POST"},
  "removeForm": {"uri": "/jaxrs/form/{id}","method": "DELETE"},
  "updataForm": {"uri": "/jaxrs/form/{id}","method": "PUT"},
  "getFormByAnonymous": {"uri": "/jaxrs/anonymous/form/{id}"},
  "listFormFieldWithForm" : {"uri": "/jaxrs/form/list/{id}/formfield"},
  "listFormFieldWithColumn" : {"uri": "/jaxrs/form/list/formfield/appInfo/{appId}"},


  "getFormV2": {"uri": "/jaxrs/form/v2/{id}?t={tag}"},
  "getFormMobileV2": {"uri": "/jaxrs/form/v2/{id}/mobile?t={tag}"},
  "getFormAnonymousV2": {"uri": "/jaxrs/anonymous/form/v2/{id}?t={tag}"},
  "getFormMobileAnonymousV2": {"uri": "/jaxrs/anonymous/form/v2/{id}/mobile?t={tag}"},

  "lookupFormWithDocV2":  {"uri": "/jaxrs/form/v2/lookup/document/{docId}"},
  "lookupFormWithDocMobileV2":  {"uri": "/jaxrs/form/v2/lookup/document/{docId}/mobile"},
  "lookupFormWithDocAnonymousV2":  {"uri": "/jaxrs/anonymous/form/v2/lookup/document/{docId}"},
  "lookupFormWithDocMobileAnonymousV2":  {"uri": "/jaxrs/anonymous/form/v2/lookup/document/{docId}/mobile"},


  "getFormTemplate": {"uri": "/jaxrs/templateform/{id}"},
  "deleteFormTemplate": {"uri": "/jaxrs/templateform/{id}","method": "DELETE"},
  "addFormTemplate": {"uri": "/jaxrs/templateform","method": "POST"},
  "listFormTemplate": {"uri": "/jaxrs/templateform/list"},
  "listFormTemplateCategory": {"uri": "/jaxrs/templateform/list/category"},
  "listFormTemplatByCategory": {"uri": "/jaxrs/templateform/list/category","method": "PUT"},

  "listDictionary": {"uri": "/jaxrs/design/appdict/list/appInfo/{appId}"},
  "getDictionary": {"uri": "/jaxrs/design/appdict/{appDictId}"},
  "addDictionary": {"uri": "/jaxrs/design/appdict", "method": "POST"},
  "removeDictionary": {"uri": "/jaxrs/design/appdict/{appDictId}","method": "DELETE"},
  "updataDictionary": {"uri": "/jaxrs/design/appdict/{appDictId}","method": "PUT"},

  "getDictRoot": {"uri": "/jaxrs/surface/appdict/{appDictId}/appInfo/{appId}/data"},
  "getDictData": {"uri": "/jaxrs/surface/appdict/{appDictId}/appInfo/{appId}/{path}/data"},
  "setDictData": {"uri": "/jaxrs/surface/appdict/{appDictId}/appInfo/{appId}/{path}/data", "method": "PUT"},
  "addDictData": {"uri": "/jaxrs/surface/appdict/{appDictId}/appInfo/{appId}/{path}/data", "method": "POST"},
  "deleteDictData": {"uri": "/jaxrs/surface/appdict/{appDictId}/appInfo/{appId}/{path}/data", "method": "DELETE"},

  "getDictRootAnonymous" : {"uri": "/jaxrs/anonymous/surface/appdict/{appDictId}/appInfo/{appId}/data"},
  "getDictDataAnonymous" : {"uri": "/jaxrs/anonymous/surface/appdict/{appDictId}/appInfo/{appId}/{path}/data"},

  "listScript": {"uri": "/jaxrs/script/list/app/{appId}"},
  "getScript": {"uri": "/jaxrs/script/{id}"},
  "addScript": {"uri": "/jaxrs/script", "method": "POST"},
  "removeScript": {"uri": "/jaxrs/script/{id}", "method": "DELETE"},
  "deleteScript": {"uri": "/jaxrs/script/{id}", "method": "DELETE"},
  "updataScript": {"uri": "/jaxrs/script/{id}", "method": "PUT"},
  "getScriptByName": {"uri": "/jaxrs/script/list/app/{appId}/name/{name}"},
  "getScriptByNameV2": {"uri": "/jaxrs/script/{uniqueName}/app/{flag}/imported"},


"listAppByManager" : {"uri":"/jaxrs/appinfo/list/manage"},
  "isAppInfoManager" : {"uri":"/jaxrs/permission/appInfo/{id}/manageable"},

  "isCategoryInfoManagers" : {"uri":"/jaxrs/permission/categoryInfo/{id}/manageable"},

  "listAppInfoManagers" : {"uri":"/jaxrs/permission/appInfo/{id}/managers"},
  "listAppInfoPublishers" : {"uri":"/jaxrs/permission/appInfo/{id}/publishers"},
  "listAppInfoViewers" : {"uri":"/jaxrs/permission/appInfo/{id}/viewers"},

  "listCategoryInfoManagers" : {"uri":"/jaxrs/permission/category/{id}/managers"},
  "listCategoryInfoPublishers" : {"uri":"/jaxrs/permission/category/{id}/publishers"},
  "listCategoryInfoViewers" : {"uri":"/jaxrs/permission/category/{id}/viewers"},

  "saveAppInfoManager" : {"uri":"/jaxrs/permission/manager/appInfo/{id}", "method":"POST" },
  "saveAppInfoPublisher" : {"uri":"/jaxrs/permission/publisher/appInfo/{id}", "method":"POST" },
  "saveAppInfoViewer" : {"uri":"/jaxrs/permission/viewer/appInfo/{id}", "method":"POST" },

  "saveCategoryInfoManager" : {"uri":"/jaxrs/permission/manager/categoryInfo/{id}", "method":"POST" },
  "saveCategoryInfoPublisher" : {"uri":"/jaxrs/permission/publisher/categoryInfo/{id}", "method":"POST" },
  "saveCategoryInfoViewer" : {"uri":"/jaxrs/permission/viewer/categoryInfo/{id}", "method":"POST" },

  "listView": {"uri" : "/jaxrs/view/list/app/{appId}"},
  "listViewByCategory": {"uri" : "/jaxrs/view/list/category/{categoryId}"},
  "listViewByForm": {"uri" : "/jaxrs/view/list/form/{formId}"},
  "getView" : {"uri" : "/jaxrs/view/{id}"},
  "addView": {"uri" : "/jaxrs/view", "method": "POST"},
  "updateView" : {"uri":"/jaxrs/view/{id}","method":"PUT"},
  "deleteView" : {"uri":"/jaxrs/view/{id}","method": "DELETE"},

  "listViewColumn": {"uri" : "/jaxrs/viewfieldconfig/list/view/{viewId}"},
  "getViewColumn" : {"uri" : "/jaxrs/viewfieldconfig/{id}"},
  "addViewColumn" : {"uri":"/jaxrs/viewfieldconfig", "method": "POST"},
  "updateViewColumn" : {"uri":"/jaxrs/viewfieldconfig/{id}","method":"PUT"},
  "deleteViewColumn" : {"uri":"/jaxrs/viewfieldconfig/{id}","method": "DELETE"},

  "listCategoryViewByView": {"uri" : "/jaxrs/viewcategory/list/view/{viewId}"},
  "listCategoryViewByCategory": {"uri" : "/jaxrs/viewcategory/list/category/{categoryId}"},
  "getCategoryView" : {"uri" : "/jaxrs/viewfieldconfig/{id}"},
  "addCategoryView" : {"uri":"/jaxrs/viewcategory", "method": "POST"},
  "updateCategoryView" : {"uri":"/jaxrs/viewcategory/{id}","method":"PUT"},
  "deleteCategoryView" : {"uri":"/jaxrs/viewcategory/{id}","method": "DELETE"},

  "listQueryView": {"uri": "/jaxrs/queryview/design/list/application/{applicationId}"},
  "listQueryViewNextPage": {"uri": "/jaxrs/queryview/design/list/{id}/next/{count}"},
  "listQueryViewPrevPage": {"uri": "/jaxrs/queryview/design/list/{id}/prev/{count}"},
  "getQueryView": {"uri": "/jaxrs/queryview/design/{id}"},
  "addQueryView": {"uri": "/jaxrs/queryview/design", "method": "POST"},
  "updateQueryView": {"uri": "/jaxrs/queryview/design/{id}","method": "PUT"},
  "deleteQueryView": {"uri": "/jaxrs/queryview/design/{id}","method": "DELETE"},
  "getQueryViewContent": {"uri": "/jaxrs/queryview/design/flag/{flag}"}, //获取QueryView内容.
  "loadQueryView": {"uri": "/jaxrs/queryview/design/flag/{flag}/simulate","method": "PUT"},



  //---document--
  "getDocument" : {"uri" : "/jaxrs/document/{id}"},
  "getDocumentControl" : {"uri" : "/jaxrs/document/{id}/control"},
  "viewDocument" : {"uri" : "/jaxrs/document/{id}/view"},
  "getDocumentByAnonymous" : {"uri" : "/jaxrs/anonymous/document/{id}/view"},
  "addDocument": {"uri" : "/jaxrs/document", "method": "POST"},
  "updateDocument" : {"uri":"/jaxrs/document","method":"POST"},
  "removeDocument" : {"uri":"/jaxrs/document/{id}","method": "DELETE"},
  "publishDocument" : {"uri":"/jaxrs/document/publish/{id}","method":"PUT"},  //发布文档信息
  "cancelPublishDocument" : {"uri":"/jaxrs/document/publish/{id}/cancel","method":"PUT"}, //取消发布文档信息
  "archiveDocument" : {"uri":"/jaxrs/document/achive/{id}","method":"PUT"}, //归档文档信息
  "redraftDocument" : {"uri":"/jaxrs/document/draft/{id}","method":"PUT"}, //恢复为草稿
  "publishDocumentComplex" : {  "uri":"/jaxrs/document/publish/content","method":"PUT" },  //直接一次性发布
  "moveDocumentToCategory" : { "uri" : "/jaxrs/document/category/change" , "method":"PUT" },

  //"getCategory" : {"uri":"/jaxrs/categoryinfo/{id}"},

  //"getForm": {"uri": "/jaxrs/form/{id}"},

  "getData": {"uri": "/jaxrs/data/document/{id}"},
  "addData": {"uri": "/jaxrs/data/document/{id}", "method": "POST"},
  "updateData": {"uri": "/jaxrs/data/document/{id}", "method": "PUT"},

  //attachment为文档中的附件
  "listAttachment" : {"uri":"/jaxrs/fileinfo/list/document/{documentid}"},
  "listAttachmentByAnonymous" : {"uri":"/jaxrs/anonymous/fileinfo/list/document/{documentId}"},
  "getAttachment": {"uri": "/jaxrs/fileinfo/{id}/document/{documentid}"},
  "getAttachmentByAnonymous": {"uri": "/jaxrs/anonymous/fileinfo/{id}/document/{documentid}"},
  "deleteAttachment": {"uri": "/jaxrs/fileinfo/{id}", "method": "DELETE"},

  "configAttachment": {"uri": "/jaxrs/fileinfo/edit/{id}/doc/{docId}", "method": "PUT"},

  "uploadAttachment": {"uri": "/jaxrs/fileinfo/upload/document/{id}", "method": "POST", "enctype": "formData"},
  "replaceAttachment": {"uri": "/jaxrs/fileinfo/update/document/{documentid}/attachment/{id}", "method": "POST", "enctype": "formData"},
  //"getAttachmentData": {"uri": "/servlet/download/{id}/document/{documentid}", "method": "GET"},
  "getAttachmentData": {"uri": "/jaxrs/fileinfo/download/document/{id}", "method": "GET"}, //document/{documentid}/
  "getAttachmentDataByAnonymous": {"uri": "/jaxrs/anonymous/fileinfo/download/document/{id}", "method": "GET"}, //document/{documentid}/
  "getAttachmentStream": {"uri": "/jaxrs/fileinfo/download/document/{id}/stream", "method": "GET"},
  "getAttachmentStreamByAnonymous": {"uri": "/jaxrs/anonymous/fileinfo/download/document/{id}/stream", "method": "GET"},

  //获取互联网URL指向的图片的base64编码[Jaxrs],必填, 需要获取的图片URL地址
  //  url- 必填, 需要获取的图片URL地址
  //  size - 转换图片压缩, size为最大宽高限制, 如 size=64 为 64*64
  //  注意,如果附件本身不是图片格式,则系统不会进行编码,并且给出异常, 扩展名限制:BMP、JPG、JPEG、PNG、GIF、TIFF
  //  访问文件无权限限制
  "getInternetImageBaseBase64" : {"uri":"/jaxrs/image/encode/base64", "method": "POST"},
  //上传一个图片,直接转换为一个base64编码[Servlet]
  "convertLocalImageToBase64": {"uri": "/servlet/image/encode/base64/size/{size}", "method": "POST", "enctype": "formData"},
  //将用户已经上传的图片附件直接转换为一个base64编码[Jaxrs]
  "getSubjectAttachmentBase64" : {"uri":"/jaxrs/fileinfo/{id}/binary/base64/{size}"},

  //file为CMS平台的附件
  "listFile" : {"uri":"/jaxrs/file/list/appInfo/{applicationFlag}"},
  "getFile": {"uri": "/jaxrs/file/{id}"},
  "addFile": {"uri": "/jaxrs/file", "method": "POST"},
  "removeFile": {"uri": "/jaxrs/file/{id}", "method": "DELETE"},
  "deleteFile": {"uri": "/jaxrs/file/{id}", "method": "DELETE"},
  "updataFile": {"uri": "/jaxrs/file/{id}", "method": "PUT"},
  "getFileByName": {"uri": "/jaxrs/file/appInfo/{applicationId}/name/{name}"},
  "downloadFile": {"uri": "/jaxrs/file/{id}/download"},
  "downloadWithApp": {"uri": "/jaxrs/file/{flag}/appInfo/{applicationFlag}/download"},
  "readFileById": {"uri": "/jaxrs/file/{id}/content"},
  "uploadFile": {"uri": "/jaxrs/file/{id}/upload", "method": "POST", "enctype": "formData"},
  "copyFile": {"uri": "/jaxrs/file/{flag}/appInfo/{appInfoFlag}"},

  "readFile": {"uri": "/jaxrs/file/{flag}/appInfo/{applicationFlag}/content"},
//  "listFile": {"uri": "/jaxrs/file/list/application/{applicationFlag}"},


  //id                   -- ID
  //  documentId           --文档ID
  //  description          --信息说明（size:255）
  //  base64               --图片Base64编码后的文本（size:1MB）
  "saveImage" : {"uri" : "/jaxrs/document/pic", "method": "POST" },
  "getImage" : {"uri":"/jaxrs/document/pic/{id}"},
  "listImage" :{"uri":"/jaxrs/document/pic/doc/{documentid}"},
  "removeImage" : {"uri":"/jaxrs/document/pic/{id}","method": "DELETE"},
  //4、获取指定文档的ID获取文档大图的base64编码，如果有多个则获取第一个，如果没有则返回“0”
  "getImageByDocument" : {"uri":"/servlet/document/{documentid}/mainpic", "method": "PUT"},

  "getReadedCount" : {"uri":"/jaxrs/document/{id}/view/count"},
  "listReadedLog" : {"uri":"/jaxrs/viewrecord/document/{docId}/filter/list/{id}/next/{count}","method":"GET"},

  //--index----
  "listDocumentAll": {"uri" : "/jaxrs/document/list/category/{categoryId}"},
  "listDocumentFilterNext": {"uri" : "/jaxrs/document/filter/list/{id}/next/{count}", "method": "PUT"},
  "listDocumentFilterPrev": {"uri" : "/jaxrs/document/filter/list/{id}/prev/{count}", "method": "PUT"},

  "listViewDataNext": {"uri" : "/jaxrs/view/viewdata/list/{id}/next/{count}", "method": "POST"},

  "listDraftNext": {"uri" : "/jaxrs/document/draft/list/{id}/next/{count}", "method": "PUT"},
  "listDraftPrev": {"uri" : "/jaxrs/document/draft/list/{id}/prev/{count}", "method": "PUT"},

  "listDraftFilterAttribute": {"uri" : "/jaxrs/searchfilter/list/draft/filter"},
  "listPublishFilterAttribute": {"uri" : "/jaxrs/searchfilter/list/publish/filter"},
  "listArchiveFilterAttribute": {"uri" : "/jaxrs/searchfilter/list/archive/filter"},

  "listCategoryDraftFilterAttribute": {"uri" : "/jaxrs/searchfilter/list/draft/filter/category/{categoryId}"},
  "listCategoryPublishFilterAttribute": {"uri" : "/jaxrs/searchfilter/list/publish/filter/category/{categoryId}"},
  "listCategoryArchiveFilterAttribute": {"uri" : "/jaxrs/searchfilter/list/archive/filter/category/{categoryId}"},

  //---module---
  "achiveDocument" : {"uri":"/jaxrs/document/achive/{id}","method":"PUT"}, //归档文档信息

  "importDocumentFormExcel": {"uri" : "/jaxrs/document/import/category/{categoryId}", "method": "POST", "enctype": "formData"},
  "deleteDocumentWithBatchName" :  {"uri":"/jaxrs/document/batch/{batchId}","method":"DELETE"},
  "checkImportStatus" : {"uri" : "/jaxrs/document/batch/{batchName}/status"},
  "checkAllImportStatus" : {"uri" : "/jaxrs/document/batch/status"},

  "getColumnByAlias": {"uri": "/jaxrs/appinfo/alias/{alias}"},
  "getCategoryByAlias" : {"uri":"/jaxrs/categoryinfo/alias/{alias}"},

  //{  docIds : docIds, dataChanges : dataChanges }
  "batchModifyData" :  {"uri":"/jaxrs/document/batch/data/modify","method":"PUT"}, //批量修改数据

  //评论
  "listCommentNextWithFilter" : {"uri":"/jaxrs/comment/list/{id}/next/{count}","method":"PUT"},
  "listCommentPageWithFilter" : {"uri":"/jaxrs/comment/list/{page}/size/{size}","method":"PUT"},
  "listCommentPrevWithFilter" : {"uri":"/jaxrs/comment/list/{id}/prev/{count}","method":"PUT"},
  "deleteComment" :  {"uri":"/jaxrs/comment/{id}","method":"DELETE"},
  "saveComment" :  {"uri":"/jaxrs/comment","method":"POST"},

  "clazz": "x_cms_assemble_control"
}

if (!o2.xAction.RestActions.Action["x_cms_assemble_control"]) o2.xAction.RestActions.Action["x_cms_assemble_control"] = new Class({Extends: o2.xAction.RestActions.Action});
o2.Actions.actions["x_cms_assemble_control"] = new o2.xAction.RestActions.Action["x_cms_assemble_control"]("x_cms_assemble_control", actionJson);
var actionJson = {
  "collectConnected": {"uri": "/jaxrs/collect/connect"},
  "getCollectConfig": {"uri": "/jaxrs/collect"},
  "disconnect": {"uri": "/jaxrs/collect/disconnect"},
  "collectValidate": {"uri": "/jaxrs/collect/validate"},

  "updateCollect": {"uri": "/jaxrs/collect", "method": "PUT"},
  "updateUnitCollect": {"uri": "/jaxrs/collect/updateUnit", "method": "PUT"},

  "deleteCollect": {"uri": "/jaxrs/collect/name/{name}/mobile/{mobile}/code/{code}", "method": "DELETE"},
  "createCollect": {"uri": "/jaxrs/collect", "method": "POST"},
  "collectValidateInput": {"uri": "/jaxrs/collect/validate/direct", "method": "PUT"},

  "getCode": {"uri": "/jaxrs/collect/code/mobile/{mobile}"},
  "codeValidate": {"uri": "/jaxrs/collect/validate/codeanswer", "method": "PUT"},
  "resetPassword": {"uri": "/jaxrs/collect/resetpassword", "method": "PUT"},

  "nameExist": {"uri": "/jaxrs/collect/name/{name}/exist"},
  "passwordValidate": {"uri": "/jaxrs/collect/validate/password", "method": "PUT"},

  "listModuleCategory": {"uri": "/jaxrs/module/list/category"},
  "listModule": {"uri": "/jaxrs/module/list", "method": "PUT"},
  "compareModule": {"uri": "/jaxrs/module/{id}/compare"},
  "importModule": {"uri": "/jaxrs/module/write/{flag}", "method": "PUT"},
  "compareUpload": {"uri": "/jaxrs/module/compare/upload", "method": "PUT", "enctype": "formData"},

  "outputStructure": {"uri": "/jaxrs/module/output/structure"},
  "removeStructure": {"uri": "/jaxrs/module/remove/structure/{id}", "method": "DELETE"},
  "outputCreate": {"uri": "/jaxrs/module/output", "method": "PUT"},
  "output": {"uri": "/jaxrs/module/output", "method": "PUT"},
  "download": {"uri": "/jaxrs/module/output/{flag}/file"},
  "listStructure": {"uri": "/jaxrs/module/output/list/structure"},

  "getCollect": {"uri": "/jaxrs/config/collect"},
  "getPerson": {"uri": "/jaxrs/config/person"},
  "getToken": {"uri": "/jaxrs/config/token"},
  "getPortal": {"uri": "/jaxrs/config/portal"},
  "setCollect": {"uri": "/jaxrs/config/collect", "method": "PUT"},
  "setPerson": {"uri": "/jaxrs/config/person", "method": "PUT"},
  "setToken": {"uri": "/jaxrs/config/token", "method": "PUT"},
  "setPortal": {"uri": "/jaxrs/config/portal", "method": "PUT"},

  "getCenterServer": {"uri": "/jaxrs/config/centerserver"},
  "setCenterServer": {"uri": "/jaxrs/config/centerserver", "method": "PUT"},
  "getProxy": {"uri": "/jaxrs/config/proxy"},
  "setProxy": {"uri": "/jaxrs/config/proxy", "method": "PUT"},

  "mobile_defaultStyle": {"uri": "/jaxrs/appstyle/default/style"},
  "mobile_currentStyle": {"uri": "/jaxrs/appstyle/current/style"},


  "imageLaunchLogo": {"uri": "/jaxrs/appstyle/image/launch/logo", "method": "PUT", "enctype": "formData"},
  "imageLaunchLogoErase": {"uri": "/jaxrs/appstyle/image/launch/logo/erase"},

  "imageLoginAvatar": {"uri": "/jaxrs/appstyle/image/login/avatar", "method": "PUT", "enctype": "formData"},
  "imageLoginAvatarErase": {"uri": "/jaxrs/appstyle/image/login/avatar/erase"},

  "imageMenuLogoBlur": {"uri": "/jaxrs/appstyle/image/menu/logo/blur", "method": "PUT", "enctype": "formData"},
  "imageMenuLogoBlurErase": {"uri": "/jaxrs/appstyle/image/menu/logo/blur/erase"},

  "imageMenuLogoFocus": {"uri": "/jaxrs/appstyle/image/menu/logo/focus", "method": "PUT", "enctype": "formData"},
  "imageMenuLogoFocusErase": {"uri": "/jaxrs/appstyle/image/menu/logo/focus/erase"},

  "imagePeopleAvatarDefault": {"uri": "/jaxrs/appstyle/image/people/avatar/default", "method": "PUT", "enctype": "formData"},
  "imagePeopleAvatarDefaultErase": {"uri": "/jaxrs/appstyle/image/people/avatar/default/erase"},

  "imageProcessDefault": {"uri": "/jaxrs/appstyle/image/process/default", "method": "PUT", "enctype": "formData"},
  "imageProcessDefaultErase": {"uri": "/jaxrs/appstyle/image/process/default/erase"},

  "imageSetupAboutLogo": {"uri": "/jaxrs/appstyle/image/setup/about/logo", "method": "PUT", "enctype": "formData"},
  "imageSetupAboutLogoErase": {"uri": "/jaxrs/appstyle/image/setup/about/logo/erase"},

  "imageApplicationTop": {"uri": "/jaxrs/appstyle/image/application/top", "method": "PUT", "enctype": "formData"},
  "imageApplicationTopErase": {"uri": "/jaxrs/appstyle/image/application/top/erase"},

  "setAppStyle": {"uri": "/jaxrs/appstyle", "method": "PUT"},

  "listAgent": {"uri": "/jaxrs/agent"},
  "createAgent" : {"uri": "/jaxrs/agent", "method": "POST"},
  "updateAgent" : {"uri": "/jaxrs/agent/{flag}", "method": "PUT"},
  "updateAgentByUploadFile" : {"uri": "/jaxrs/agent/{flag}/file", "method": "PUT", "enctype": "formData"},
  "deleteAgent" : {"uri": "/jaxrs/agent/{flag}", "method": "DELETE"},
  "getAgent" : {"uri": "/jaxrs/agent/{flag}"},
  "disableAgent" : {"uri": "/jaxrs/agent/{flag}/disable"},
  "enableAgent" : {"uri": "/jaxrs/agent/{flag}/enable"},
  "executeAgent" : {"uri": "/jaxrs/agent/{flag}/execute"},

  "listInvoke": {"uri": "/jaxrs/invoke"},
  "createInvoke" : {"uri": "/jaxrs/invoke", "method": "POST"},
  "updateInvoke" : {"uri": "/jaxrs/invoke/{flag}", "method": "PUT"},
  "updateInvokeByUploadFile" : {"uri": "/jaxrs/invoke/{flag}/file", "method": "PUT", "enctype": "formData"},
  "deleteInvoke" : {"uri": "/jaxrs/invoke/{flag}", "method": "DELETE"},
  "getInvoke" : {"uri": "/jaxrs/invoke/{flag}"},
  "executeInvoke" : {"uri": "/jaxrs/invoke/{flag}/execute", "method": "POST"},
  "executeToken" : {"uri": "/jaxrs/invoke/{flag}/client/{client}/token/{token}/execute", "method": "POST"},

  "listPromptErrorLog" : {"uri": "/jaxrs/prompterrorlog/list/{id}/next/{count}"},
  "listPromptErrorLogWithDate" : {"uri": "/jaxrs/prompterrorlog/list/{id}/next/{count}/date/{date}"},
  "listUnexpectedErrorLog" : {"uri": "/jaxrs/unexpectederrorlog/list/{id}/next/{count}"},
  "listUnexpectedErrorLogWithDate" : {"uri": "/jaxrs/unexpectederrorlog/list/{id}/next/{count}/date/{date}"},
  "listWarnLog" : {"uri": "/jaxrs/warnlog/list/{id}/next/{count}"},
  "listWarnLogWithDate" : {"uri": "/jaxrs/warnlog/list/{id}/next/{count}/date/{date}"},
  "listSystemLog" : {"uri": "/jaxrs/warnlog/view/system/log/tag/{tag}"},
  "echo" : {"uri": "/jaxrs/echo"},


  "listDictionaryPaging": {"uri": "/jaxrs/dict/list/paging/{page}/size/{size}"},
  "listDictionary": {"uri": "/jaxrs/dict/list"},
  "getDictionary": {"uri": "/jaxrs/dict/{id}"},
  "addDictionary": {"uri": "/jaxrs/dict", "method": "POST"},
  "updateDictionary": {"uri": "/jaxrs/dict/{id}","method": "PUT"},
  "removeDictionary": {"uri": "/jaxrs/dict/{id}","method": "DELETE"},

  "getDictRoot": {"uri": "/jaxrs/dict/{dictFlag}/data"},
  "getDictData": {"uri": "/jaxrs/dict/{dictFlag}/{path}/data"}, //path:路径(多层路径以.分割，如person.name)
  "setDictData": {"uri": "/jaxrs/dict/{dictFlag}/{path}/data", "method": "PUT"},
  "addDictData": {"uri": "/jaxrs/dict/{dictFlag}/{path}/data", "method": "POST"},
  "deleteDictData": {"uri": "/jaxrs/dict/{dictFlag}/{path}/data", "method": "DELETE"},

  "listScriptPaging": {"uri": "/jaxrs/script/list/paging/{page}/size/{size}", "method": "POST"},
  "listScript": {"uri": "/jaxrs/script/list"},
  "getScript": {"uri": "/jaxrs/script/{id}"},
  "addScript": {"uri": "/jaxrs/script", "method": "POST"},
  "removeScript": {"uri": "/jaxrs/script/{id}", "method": "DELETE"},
  "updateScript": {"uri": "/jaxrs/script/{id}", "method": "PUT"},
  "getScriptByName": {"uri": "/jaxrs/script/name/{name}/imported"}
}

if (!o2.xAction.RestActions.Action["x_program_center"]) o2.xAction.RestActions.Action["x_program_center"] = new Class({Extends: o2.xAction.RestActions.Action});
o2.Actions.actions["x_program_center"] = new o2.xAction.RestActions.Action["x_program_center"]("x_program_center", actionJson);
var actionJson = {
  "changePassword": {"uri": "/jaxrs/person/password", "method": "PUT"},
  "getPerson": {"uri": "/jaxrs/person"},
  "updatePerson": {"uri": "/jaxrs/person", "method": "PUT"},
  "changeIcon": {"uri": "/jaxrs/person/icon", "method": "PUT", "enctype": "formData"},
  "checkPassword" : {"uri":"/jaxrs/reset/check/password/{password}"},
  "getPersonIcon": {"uri": "/jaxrs/person/icon"},

  "getIcon": {"uri": "/jaxrs/icon/{person}"},

  //disable 不允许注册，captcha 图片验证码, code 手机验证码 x_organization_assemble_personal
  "getRegisterMode" : { "uri" : "/jaxrs/regist/mode" },
  "getRegisterCaptcha" : {"uri":"/jaxrs/regist/captcha/width/{width}/height/{height}"},
  "createRegisterCode" : {"uri":"/jaxrs/regist/code/mobile/{mobile}"},
  "checkRegisterName" : {"uri":"/jaxrs/regist/check/name/{name}"},
  "checkRegisterPassword" : {"uri":"/jaxrs/regist/check/password/{password}"},
  "checkRegisterMobile" : {"uri":"/jaxrs/regist/check/mobile/{mobile}"},
  "register" : {"uri":"/jaxrs/regist", "method": "POST"},

  "resetPassword" : {"uri":"/jaxrs/reset", "method": "PUT"},
  "checkCredentialOnResetPassword" : {"uri":"/jaxrs/reset/check/credential/{credential}"},
  "checkPasswordOnResetPassword" : {"uri":"/jaxrs/reset/check/password/{password}"},
  "createCodeOnResetPassword" :  {"uri":"/jaxrs/reset/code/credential/{credential}"},


  "getUserData": {"uri": "/jaxrs/custom/{name}"},
  "putUserData": {"uri": "/jaxrs/custom/{name}", "method": "PUT"},
  "deleteUserData": {"uri": "/jaxrs/custom/{name}", "method": "DELETE"},

  "getPublicUserData": {"uri": "/jaxrs/definition/{name}"},
  "putPublicUserData": {"uri": "/jaxrs/definition/{name}", "method": "PUT"},
  "deletePublicUserData": {"uri": "/jaxrs/definition/{name}", "method": "DELETE"},
  //外出授权
  "getMyEmPower": {"uri": "/jaxrs/empower/list/currentperson", "method": "GET"},
  "getReceiveEmPower": {"uri": "/jaxrs/empower/list/to", "method": "GET"},
  "createEmPower": {"uri": "/jaxrs/empower", "method": "POST"},
  "editEmPower": {"uri": "/jaxrs/empower/{id}", "method": "PUT"},
  "deleteEmPower": {"uri": "/jaxrs/empower/{id}", "method": "DELETE"},

  //2020年1月8日新版无这2个方法
  "getMyEmPowerLog": {"uri": "/jaxrs/empowerlog/list/currentperson", "method": "GET"},
  "getReceiveEmPowerLog": {"uri": "/jaxrs/empowerlog/list/to", "method": "GET"},
  "listToCurrentPersonPaging": {"uri": "/jaxrs/empowerlog/list/to/currentperson/paging/{page}/size/{size}", "method": "POST"},
  "listWithCurrentPersonPaging": {"uri": "/jaxrs/empowerlog/list/currentperson/paging/{page}/size/{size}", "method": "POST"},

  "clazz": "x_organization_assemble_personal"
}
if (!o2.xAction.RestActions.Action["x_organization_assemble_personal"]) o2.xAction.RestActions.Action["x_organization_assemble_personal"] = new Class({Extends: o2.xAction.RestActions.Action});
o2.Actions.actions["x_organization_assemble_personal"] = new o2.xAction.RestActions.Action["x_organization_assemble_personal"]("x_organization_assemble_personal", actionJson);
if (!window.layout || !layout.desktop || !layout.addReady) {
    layout = window.layout || {};
    layout.desktop = layout;
    layout.desktop.type = "app";
    layout.apps = [];
    var locate = window.location;
    layout.protocol = locate.protocol;
    layout.port = locate.port;
    layout.inBrowser = true;
    layout.session = layout.session || {};
    layout.debugger = (locate.href.toString().indexOf("debugger") !== -1);
    layout.anonymous = (locate.href.toString().indexOf("anonymous") !== -1);
    o2.xApplication = o2.xApplication || {};

    o2.xDesktop = o2.xDesktop || {};
    o2.xDesktop.requireApp = function (module, clazz, callback, async) {
        o2.requireApp(module, clazz, callback, async);
    };

    (function (layout) {
        layout.readys = [];
        layout.addReady = function () {
            for (var i = 0; i < arguments.length; i++) {
                if (o2.typeOf(arguments[i]) === "function") {
                    if (layout.isReady) {
                        arguments[i].apply(window);
                    } else {
                        layout.readys.push(arguments[i]);
                    }
                }
            }
        };
        var _requireApp = function (appNames, callback, clazzName) {
            var appPath = appNames.split(".");
            var baseObject = o2.xApplication;
            appPath.each(function (path, i) {
                if (i < (appPath.length - 1)) {
                    baseObject[path] = baseObject[path] || {};
                } else {
                    baseObject[path] = baseObject[path] || {"options": Object.clone(o2.xApplication.Common.options)};
                }
                baseObject = baseObject[path];
            }.bind(this));
            if (!baseObject.options) baseObject.options = Object.clone(o2.xApplication.Common.options);

            var _lpLoaded = false;

            o2.xDesktop.requireApp(appNames, "lp." + o2.language, {
                "onFailure": function () {
                    o2.xDesktop.requireApp(appNames, "lp.zh-cn", null, false);
                }.bind(this)
            }, false);

            o2.xDesktop.requireApp(appNames, clazzName, function () {
                if (callback) callback(baseObject);
            });
        };
        var _createNewApplication = function (e, appNamespace, appName, options, statusObj, inBrowser, taskitem, notCurrent, node) {
            if (options) {
                options.event = e;
            } else {
                options = {"event": e};
            }
            var app = new appNamespace["Main"](layout.desktop, options);
            app.desktop = layout.desktop;
            app.status = statusObj;
            app.inBrowser = !!(inBrowser || layout.inBrowser);
            app.windowNode = node;

            if (layout.desktop.type === "layout") {
                app.appId = (options.appId) ? options.appId : ((appNamespace.options.multitask) ? appName + "-" + (new o2.widget.UUID()) : appName);
                app.options.appId = app.appId;

                if (layout.desktop.createTaskItem) {
                    if (!taskitem) taskitem = layout.desktop.createTaskItem(app);
                    app.taskitem = taskitem;
                    app.taskitem.app = app;
                }

                app.isLoadApplication = true;
                app.load(!notCurrent);

                if (!layout.desktop.apps) layout.desktop.apps = {};
                if (layout.desktop.apps[app.appId]) {
                    var tmpApp = layout.desktop.apps[app.appId];

                } else {
                    layout.desktop.apps[app.appId] = app;
                }

                layout.desktop.appArr.push(app);
                layout.desktop.appCurrentList.push(app);
                if (!notCurrent) layout.desktop.currentApp = app;
            } else {
                app.load(true);
                layout.app = app;
            }

            var mask = document.getElementById("appContentMask");
            if (mask) mask.destroy();
        };

        var _openWorkAndroid = function (options) {
            if (window.o2android && window.o2android.postMessage) {
                var body = {
                    type: "openO2Work",
                    data: {
                        title : options.title || ""
                    }
                };
                if (options.workId) {
                    body.data.workId = options.workId;
                } else if (options.workCompletedId) {
                    body.data.workCompletedId = options.workCompletedId;
                } else if (options.draftId) {
                    body.data.draftId = options.draftId;
                }
                window.o2android.postMessage(JSON.stringify(body));
                return true;
            }
            if (window.o2android && window.o2android.openO2Work) {
                if (options.workId) {
                    window.o2android.openO2Work(options.workId, "", options.title || options.docTitle || "");
                } else if (options.workCompletedId) {
                    window.o2android.openO2Work("", options.workCompletedId, options.title || options.docTitle || "");
                }
                return true;
            }
            return false;
        };
        var _openWorkIOS = function (options) {
            if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openO2Work) {
                if (options.workId) {
                    window.webkit.messageHandlers.openO2Work.postMessage({
                        "work": options.workId,
                        "workCompleted": "",
                        "draftId": options.draftId,
                        "title": options.title || options.docTitle || ""
                    });
                } else if (options.workCompletedId) {
                    window.webkit.messageHandlers.openO2Work.postMessage({
                        "work": "",
                        "workCompleted": options.workCompletedId,
                        "draftId": options.draftId,
                        "title": options.title || options.docTitle || ""
                    });
                }
                return true;
            }
            return false;
        };
        var _openWorkHTML = function (options) {
            var uri = new URI(window.location.href);
            var redirectlink = uri.getData("redirectlink");
            if (!redirectlink) {
                redirectlink = encodeURIComponent(locate.pathname + locate.search);
            } else {
                redirectlink = encodeURIComponent(redirectlink);
            }
            var docurl = "../x_desktop/workmobilewithaction.html".toURI();
            if (options.draft) {
                var par = "draft=" + encodeURIComponent(JSON.stringify(options.draft));
                docurl = "../x_desktop/workmobilewithaction.html?" + par;
            } else {
                docurl = docurl.setData(options).toString();
            }
            var job = (options.jobid || options.jobId || options.job);
            if (job) docurl += ((docurl.indexOf("?") != -1) ? "&" : "?") + "jobid=" + job;
            docurl += ((redirectlink) ? "&redirectlink=" + redirectlink : "");
            docurl += ((layout.debugger) ? "&debugger" : "");
            //使用相对路径不需要filterUrl
            //window.location = o2.filterUrl(docurl);
            window.location = docurl;
        };
        var _openWork = function (options) {
            if (!_openWorkAndroid(options)) if (!_openWorkIOS(options)) _openWorkHTML(options);
        };
        var _openDocument = function (appNames, options, statusObj) {
            var title = typeOf(options) === "object" ? (options.docTitle || options.title) : "";
            title = title || "";
            var par = "app=" + encodeURIComponent(appNames) + "&status=" + encodeURIComponent((statusObj) ? JSON.encode(statusObj) : "") + "&option=" + encodeURIComponent((options) ? JSON.encode(options) : "");
            if (window.o2android && window.o2android.postMessage) {
                var body = {
                    type: "openO2CmsDocument",
                    data: {
                        docId : options.documentId,
                        title: title,
                        options: options
                    }
                };
                window.o2android.postMessage(JSON.stringify(body));
            } else if (window.o2android && window.o2android.openO2CmsDocumentV2) {
                window.o2android.openO2CmsDocumentV2(options.documentId, title, JSON.stringify(options));
            } else if (window.o2android && window.o2android.openO2CmsDocument) {
                window.o2android.openO2CmsDocument(options.documentId, title);
            } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openO2CmsDocument) {
                window.webkit.messageHandlers.openO2CmsDocument.postMessage({
                    "docId": options.documentId,
                    "docTitle": title, "options": JSON.stringify(options)
                });
            } else {
                window.location = o2.filterUrl("../x_desktop/appMobile.html?" + par + ((layout.debugger) ? "&debugger" : ""));
            }
        };
        var _openCms = function (appNames, options, statusObj) {
            var par = "app=" + encodeURIComponent(appNames) + "&status=" + encodeURIComponent((statusObj) ? JSON.encode(statusObj) : "") + "&option=" + encodeURIComponent((options) ? JSON.encode(options) : "");
            if (window.o2android && window.o2android.postMessage) {
                var body = {
                    type: "openO2CmsApplication",
                    data: {
                        appId : options.columnId,
                        title: options.title || "",
                        categoryId: options.categoryId || ""
                    }
                };
                window.o2android.postMessage(JSON.stringify(body));
            } else if (window.o2android && window.o2android.openO2CmsApplication) {
                window.o2android.openO2CmsApplication(options.columnId, options.title || "");
            } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openO2CmsApplication) {
                window.webkit.messageHandlers.openO2CmsApplication.postMessage(options.columnId);
            } else {
                window.location = o2.filterUrl("../x_desktop/appMobile.html?" + par + ((layout.debugger) ? "&debugger" : ""));
            }
        };
        var _openMeeting = function (appNames, options, statusObj) {
            var par = "app=" + encodeURIComponent(appNames) + "&status=" + encodeURIComponent((statusObj) ? JSON.encode(statusObj) : "") + "&option=" + encodeURIComponent((options) ? JSON.encode(options) : "");
            if (window.o2android && window.o2android.postMessage) {
                var body = {
                    type: "openO2Meeting",
                    data: {}
                };
                window.o2android.postMessage(JSON.stringify(body));
            } else if (window.o2android && window.o2android.openO2Meeting) {
                window.o2android.openO2Meeting("");
            } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openO2Meeting) {
                window.webkit.messageHandlers.openO2Meeting.postMessage("");
            } else {
                window.location = o2.filterUrl("../x_desktop/appMobile.html?" + par + ((layout.debugger) ? "&debugger" : ""));
            }
        };

        var _openCalendar = function (appNames, options, statusObj) {
            var par = "app=" + encodeURIComponent(appNames) + "&status=" + encodeURIComponent((statusObj) ? JSON.encode(statusObj) : "") + "&option=" + encodeURIComponent((options) ? JSON.encode(options) : "");
            if (window.o2android && window.o2android.postMessage) {
                var body = {
                    type: "openO2Calendar",
                    data: {}
                };
                window.o2android.postMessage(JSON.stringify(body));
            } else if (window.o2android && window.o2android.openO2Calendar) {
                window.o2android.openO2Calendar("");
            } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openO2Calendar) {
                window.webkit.messageHandlers.openO2Calendar.postMessage("");
            } else {
                window.location = o2.filterUrl("../x_desktop/appMobile.html?" + par + ((layout.debugger) ? "&debugger" : ""));
            }
        };
        var _openTaskCenter = function (appNames, options, statusObj) {
            var par = "app=" + encodeURIComponent(appNames) + "&status=" + encodeURIComponent((statusObj) ? JSON.encode(statusObj) : "") + "&option=" + encodeURIComponent((options) ? JSON.encode(options) : "");
            var tab = ((options && options.navi) ? options.navi : "task").toLowerCase();
            if (tab === "done") tab = "taskCompleted";
            if (tab === "readed") tab = "readCompleted";

            if (window.o2android && window.o2android.postMessage) {
                var body = {
                    type: "openO2WorkSpace",
                    data: { type: tab }
                };
                window.o2android.postMessage(JSON.stringify(body));
            } else if (window.o2android && window.o2android.openO2WorkSpace) {
                window.o2android.openO2WorkSpace(tab);
            } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openO2WorkSpace) {
                window.webkit.messageHandlers.openO2WorkSpace.postMessage(tab);
            } else {
                window.location = o2.filterUrl("../x_desktop/appMobile.html?" + par + ((layout.debugger) ? "&debugger" : ""));
            }
        };

        var _openApplicationMobile = function (appNames, options, statusObj) {
            switch (appNames) {
                case "process.Work":
                    _openWork(options);
                    break;
                case "cms.Document":
                    _openDocument(appNames, options, statusObj);
                    break;
                case "cms.Module":
                    _openCms(appNames, options, statusObj);
                    break;
                case "Meeting":
                    _openMeeting(appNames, options, statusObj);
                    break;
                case "Calendar":
                    _openCalendar(appNames, options, statusObj);
                    break;
                case "process.TaskCenter":
                    _openTaskCenter(appNames, options, statusObj);
                    break;
                default:
                    var optionsStr, statusStr;
                    if( options || statusObj){
                        optionsStr = encodeURIComponent((options) ? JSON.encode(options) : "")
                        statusStr = encodeURIComponent((statusObj) ? JSON.encode(statusObj) : "")
                    }else{
                        var uri = new URI(window.location.href);
                        optionsStr = uri.getData("option");
                        statusStr = uri.getData("status");
                    }
                    window.location = o2.filterUrl("../x_desktop/appMobile.html?app=" + appNames + "&option=" + (optionsStr || "") + "&status=" + (statusStr || "") + ((layout.debugger) ? "&debugger" : ""));
            }
        };

        var _openWindow = function (url, par) {
            var a = new Element("a", {
                "href": url,
                "target": par
            });
            a.click();
            a.destroy();
        };
        var _openApplicationPC = function (appNames, options, statusObj) {
            if (options) delete options.docTitle;
            var par = "app=" + encodeURIComponent(appNames) + "&status=" + encodeURIComponent((statusObj) ? JSON.encode(statusObj) : "") + "&option=" + encodeURIComponent((options) ? JSON.encode(options) : "");
            switch (appNames) {
                case "process.Work":
                    var url = "../x_desktop/work.html";
                    if (options.draft) {
                        url = "../x_desktop/app.html?" + par;
                    } else {
                        Object.keys(options).forEach(function (k) {
                            if (options[k]) url += ((url.indexOf("?") != -1) ? "&" : "?") + k + "=" + options[k];
                        });
                        //url = url.setData(options).toString();
                    }
                    var job = (options.jobid || options.jobId || options.job);
                    if (job) url += ((url.indexOf("?") != -1) ? "&" : "?") + "jobid=" + job;
                    url += ((layout.debugger) ? "&debugger" : "");

                    if (layout.app.$openWithSelf) {
                        return window.location = o2.filterUrl(url);
                    } else {
                        return window.open(o2.filterUrl(url), par);
                    }
                    break;
                case "cms.Document":
                    // _openDocument(appNames, options, statusObj);
                    var url = "../x_desktop/cmsdoc.html".toURI();
                    url = url.setData(options).toString();
                    url += ((layout.debugger) ? "&debugger" : "");
                    if (layout.app.$openWithSelf) {
                        return window.location = o2.filterUrl(url);
                    } else {
                        return window.open(o2.filterUrl(url), par);
                    }
                    break;
                // case "cms.Module":
                //     _openCms(appNames, options, statusObj);
                //     break;
                // case "Meeting":
                //     _openMeeting(appNames, options, statusObj);
                //     break;
                // case "Calendar":
                //     _openCalendar(appNames, options, statusObj);
                //     break;
                // case "process.TaskCenter":
                //     _openTaskCenter(appNames, options, statusObj);
                //     break;
                default:
                    if (layout.app.$openWithSelf) {
                        return window.location = o2.filterUrl("../x_desktop/app.html?" + par + ((layout.debugger) ? "&debugger" : ""));
                    } else {
                        return window.open(o2.filterUrl("../x_desktop/app.html?" + par + ((layout.debugger) ? "&debugger" : "")), par);
                    }
            }
        };

        layout.openApplication = function (e, appNames, options, statusObj, inBrowser, taskitem, notCurrent, node) {
            if (appNames.substring(0, 4) === "@url") {
                var url = appNames.replace(/\@url\:/i, "");
                var a = new Element("a", {"href": url, "target": "_blank"});
                a.click();
                a.destroy();
                a = null;
                return true;
            }

            if (layout.app) {
                if (layout.mobile) {
                    _openApplicationMobile(appNames, options, statusObj);
                } else {
                    return _openApplicationPC(appNames, options, statusObj);
                }
            } else {
                var appPath = appNames.split(".");
                var appName = appPath[appPath.length - 1];
                _requireApp(appNames, function (appNamespace) {
                    var appId = (options && options.appId) ? options.appId : ((appNamespace.options.multitask) ? "" : appName);

                    if (appId && layout.desktop.apps && layout.desktop.apps[appId]) {
                        layout.desktop.apps[appId].setCurrent();
                    } else {
                        if (options) options.appId = appId;
                        if (appNamespace.loading && appNamespace.loading.then){

                            if (!layout.desktop.loadingAppIdArr) layout.desktop.loadingAppIdArr = [];
                            if( !layout.desktop.loadingAppIdArr.contains( appId ) ){

                                if( appId )layout.desktop.loadingAppIdArr.push(appId);

                                appNamespace.loading.then(function(){
                                    _createNewApplication(e, appNamespace, appName, (options || {"appId": appId}), statusObj, inBrowser, taskitem, notCurrent, node);

                                    if( appId )layout.desktop.loadingAppIdArr.erase(appId);
                                });
                            }
                        }else{
                            _createNewApplication(e, appNamespace, appName, (options || {"appId": appId}), statusObj, inBrowser, taskitem, notCurrent, node);
                        }
                    }
                }.bind(this));
            }
        };

        layout.refreshApp = function (app) {
            var status = app.recordStatus();

            var _uri = new URI(window.location.href);
            var appNames = _uri.getData("app");
            var optionsStr = _uri.getData("option");
            var statusStr = _uri.getData("status");
            if (status) statusStr = JSON.encode(status);

            var port = _uri.get("port");
            var u = _uri.get("scheme") + "://" + _uri.get("host") + ((port && port != "80") ? ":" + port : "") + _uri.get("directory") + _uri.get("file") + "?app=" + encodeURIComponent(appNames) + "&status=" + encodeURIComponent(statusStr) + "&option=" + encodeURIComponent((optionsStr) ? JSON.encode(optionsStr) : "") + ((layout.debugger) ? "&debugger" : "");
            u = o2.filterUrl(u);
            window.location = u;
        };

        layout.load = function (appNames, options, statusObj) {
            layout.apps = [];
            layout.node = $("layout") || $("appContent") || document.body;
            var appName = appNames, m_status = statusObj, option = options;

            var topWindow = window.opener;
            if (topWindow) {
                try {
                    if (!appName) appName = topWindow.layout.desktop.openBrowserApp;
                    if (!m_status) m_status = topWindow.layout.desktop.openBrowserStatus;
                    if (!option) option = topWindow.layout.desktop.openBrowserOption;
                } catch (e) {
                }
            }
            layout.openApplication(null, appName, option || {}, m_status);
        };

        layout.getFormDesignerStyle = function (callback) {
            if (!this.formDesignerStyle) {
                this.formDesignerStyle = "default";
                MWF.UD.getData("formDesignerStyle", function (json) {
                    if (json.data) {
                        var styles = JSON.decode(json.data);
                        this.formDesignerStyle = styles.style;
                    }
                    if (callback) callback();
                }.bind(this));
            } else {
                if (callback) callback();
            }
        }

    })(layout);

}

if (!layout.isReady) {
    o2.addReady(function () {
        //兼容方法
        if (window.Element) {
            Element.implement({
                "makeLnk": function (options) {
                }
            });
        }
        layout.desktop.addEvent = function (type, e, d) {
            window.addEvent(type, e, d);
        };
        layout.desktop.addEvents = function (e) {
            window.addEvents(e);
        };

        var loadingNode = (window.$) ? $("loaddingArea") : null;
        var loadeds = 0;
        var loadCount = 4;
        var size = (window.document && document.body) ? document.body.getSize() : null;
        var _closeLoadingNode = function () {
            if (loadingNode) {
                loadingNode.destroy();
                loadingNode = null;
            }
        };
        var _loadProgressBar = function (complete) {
            if (loadingNode) {
                if (complete) {
                    loadingNode.setStyles({"width": "" + size.x + "px"});
                    //loadingNode.set('morph', {duration: 100}).morph({"width": ""+size.x+"px"});
                    window.setTimeout(_closeLoadingNode, 500);
                } else {
                    loadeds++;
                    var p = (loadeds / loadCount) * size.x;
                    loadingNode.setStyles({"width": "" + p + "px"});
                    //loadingNode.set('morph', {duration: 100}).morph({"width": ""+p+"px"});
                    if (loadeds >= loadCount) window.setTimeout(_closeLoadingNode, 500);
                }
            }
        };

        var _setLayoutService = function (service, center) {
            layout.serviceAddressList = service;
            layout.centerServer = center;
            layout.desktop.serviceAddressList = service;
            layout.desktop.centerServer = center;
        };
        var _getDistribute = function (callback) {

            if (layout.config.app_protocol === "auto") {
                layout.config.app_protocol = window.location.protocol;
            }

            if (layout.config.configMapping && (layout.config.configMapping[window.location.host] || layout.config.configMapping[window.location.hostname])) {
                var mapping = layout.config.configMapping[window.location.host] || layout.config.configMapping[window.location.hostname];
                if (mapping.servers) {
                    layout.serviceAddressList = mapping.servers;
                    layout.desktop.serviceAddressList = mapping.servers;
                    if (mapping.center) center = (o2.typeOf(mapping.center) === "array") ? mapping.center[0] : mapping.center;
                    layout.centerServer = center;
                    layout.desktop.centerServer = center;
                    if (callback) callback();
                } else {
                    if (mapping.center) layout.config.center = (o2.typeOf(mapping.center) === "array") ? mapping.center : [mapping.center];
                    o2.xDesktop.getServiceAddress(layout.config, function (service, center) {
                        _setLayoutService(service, center);
                        _loadProgressBar();
                        if (callback) callback();
                    }.bind(this));
                }
            } else {
                o2.xDesktop.getServiceAddress(layout.config, function (service, center) {
                    _setLayoutService(service, center);
                    _loadProgressBar();
                    if (callback) callback();
                }.bind(this));
            }

        };

        var _load = function () {
            var _loadApp = function (json) {
                //用户已经登录
                if (json) {
                    layout.user = json.data;
                    layout.session = layout.session || {};
                    layout.session.user = json.data;
                    layout.session.token = json.data.token;
                    layout.desktop.session = layout.session;
                }

                _loadProgressBar(true);
                layout.isReady = true;
                while (layout.readys && layout.readys.length) {
                    layout.readys.shift().apply(window);
                }
            };

            // 是否ip
            var _isIp = function (ip) {
                var reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
                return reg.test(ip);
            };


            //修改支持x-token
            var uri = new URI(window.location.href);
            var options = uri.get("data");
            if (options[o2.tokenName]) {
                // 删除
                // Cookie.dispose(o2.tokenName);
                // // 写入
                // var host = window.location.hostname; // 域名
                // var domain = null;
                // if (_isIp(host)) {
                //     domain = host;
                // } else {
                //     if (host.indexOf(".") > 0) {
                //         domain = host.substring(host.indexOf(".")); // 上级域名 如 .o2oa.net
                //     }
                // }
                // if (domain) {
                //     Cookie.write(o2.tokenName, options[o2.tokenName], {domain: domain, path: "/"});
                // } else {
                //     Cookie.write(o2.tokenName, options[o2.tokenName]);
                // }
                if (window.layout) {
                    if (!layout.session) layout.session = {};
                    layout.session.token = options[o2.tokenName];
                }
                if (layout.config && layout.config.sessionStorageEnable && window.sessionStorage) window.sessionStorage.setItem("o2LayoutSessionToken", options[o2.tokenName]);
            }

            layout.sessionPromise = new Promise(function (resolve, reject) {
                o2.Actions.get("x_organization_assemble_authentication").getAuthentication(function (json) {
                    if (json.data.language && (json.data.language !== o2.languageName)) {
                        o2.language = json.data.language.toLowerCase();
                        o2.languageName = json.data.language;
                        var lp = "../x_desktop/js/base_lp_" + o2.language + ((o2.session.isDebugger) ? "" : ".min") + ".js?v="+o2.version.v;;
                        o2.load(lp, {"reload": true}, function () {
                            if (resolve) resolve(json.data);
                        });
                    } else {
                        if (resolve) resolve(json.data);
                    }
                }.bind(this), function (xhr, text, error) {
                    if (reject) reject({"xhr": xhr, "text": text, "error": error});
                }.bind(this));
            });

            layout.sessionPromise.then(function (data) {
                //已经登录
                layout.user = data;
                layout.session = layout.session || {};
                layout.session.user = data;
                layout.session.token = data.token;
                layout.desktop.session = layout.session;
                //_loadApp();
            }, function () {
                //允许匿名访问
                if (layout.anonymous) {
                    var data = {name: "anonymous", roleList: []};
                    layout.user = data;
                    layout.session = layout.session || {};
                    layout.session.user = data;
                    layout.session.token = data.token;
                    layout.desktop.session = layout.session;
                    //_loadApp();
                } else {
                    _loadProgressBar(true);
                    if (layout.yqwx) {
                        layout.openLoginQywx();
                    } else {
                        layout.openLogin();
                    }
                }
            });
            _loadApp();

            layout.openLogin = function () {
                layout.desktop.type = "app";
                layout.app = null;
                var content = $("appContent") || $("layout");
                if (content) content.empty();
                layout.authentication = new o2.xDesktop.Authentication({
                    "style": "flat",
                    "onLogin": _load.bind(layout)
                });
                layout.authentication.loadLogin(document.body);
                var loadingNode = $("browser_loading");
                if (loadingNode) loadingNode.fade("out");
            };

            layout.openLoginQywx = function () {
                //console.log("开始login。。。。。。。。。。。。。");
                var uri = locate.href.toURI();

                //console.log("执行单点。。。。。。。。。。");
                var action = new MWF.xDesktop.Actions.RestActions("", "x_organization_assemble_authentication", "");
                action.getActions = function (actionCallback) {
                    this.actions = {"sso": {"uri": "/jaxrs/qiyeweixin/code/{code}", "method": "GET"}};
                    if (actionCallback) actionCallback();
                };
                action.invoke({
                    "name": "sso",
                    "async": true,
                    "parameter": {"code": uri.getData("code")},
                    "success": function (json) {
                        //console.log("单点成功。");
                        //console.log(json);
                        //基础数据。。。。
                        layout.session.user = json.data;
                        //
                        _load();

                    }.bind(this),
                    "failure": function (xhr, text, error) {
                        var n = document.getElementById("loaddingArea");
                        if (n) {
                            n.destroy();
                        }
                        document.id("layout").set("html", "<div>企业微信单点异常！</div>");
                    }.bind(this)
                });
            };
        };

        //异步载入必要模块
        layout.config = null;
        var configLoaded = false;
        var lpLoaded = false;
        var commonLoaded = false;
        //var lp = o2.session.path + "/lp/" + o2.language + ".js";
        // var lp = "../x_desktop/js/base_lp_" + o2.language + ((o2.session.isDebugger) ? "" : ".min") + ".js?v="+o2.version.v;;

        if (o2.session.isDebugger && (o2.session.isMobile || layout.mobile)) o2.load("../o2_lib/eruda/eruda.js");
        var loadAllModules = function(error){
            _loadProgressBar();
            lpLoaded = true;

            var modules = ["o2.xDesktop.$all"];
            o2.require(modules, {
                "onSuccess": function () {
                    if (o2.xDesktop.getServiceAddress){
                        commonLoaded = true;
                        if (configLoaded && commonLoaded && lpLoaded) _getDistribute(function () {
                            _load();
                        });
                    }else{
                        if (error) error();
                    }
                },
                "onFailure": function(){ if (error) error();},
                "onEvery": function () {
                    _loadProgressBar();
                }
            });
        }
        var loadO2Modules = function(){
            _loadProgressBar();
            lpLoaded = true;

            var o2modules = ['o2.widget.Common',
                'o2.widget.Dialog',
                'o2.widget.UUID',
                'o2.xDesktop.Common',
                'o2.xDesktop.Actions.RestActions',
                'o2.xAction.RestActions',
                'o2.xDesktop.Access',
                'o2.xDesktop.Dialog',
                'o2.xDesktop.Menu',
                'o2.xDesktop.UserData',
                'o2.xDesktop.Authentication',
                'o2.xDesktop.Dialog',
                'o2.xDesktop.Window'];
            o2.require(o2modules, {
                "onSuccess": function () {
                    var appmodules = [['Template', 'MPopupForm'], ['Common', 'Main']];
                    o2.requireApp(appmodules, "", {
                        "onSuccess": function(){
                            if (o2.xDesktop.getServiceAddress){
                                commonLoaded = true;
                                if (configLoaded && commonLoaded && lpLoaded) _getDistribute(function () {
                                    _load();
                                });
                            }
                        },
                        "onEvery": function () {
                            _loadProgressBar();
                        }
                    });
                },
                "onEvery": function () {
                    _loadProgressBar();
                }
            });
        }


        var loadModuls = function () {
            loadAllModules(loadO2Modules);
        };


        o2.getJSON("../x_desktop/res/config/config.json", function (config) {
            var supportedLanguages = Object.keys(config.supportedLanguages);

            if (supportedLanguages.indexOf(o2.language) === -1){
                o2.language = o2.language.substring(0, o2.language.indexOf('-'));
            }
            if (supportedLanguages.indexOf(o2.language) === -1) o2.language = "zh-cn";

            if (!o2.LP) {
                var lp = "../x_desktop/js/base_lp_" + o2.language + ((o2.session.isDebugger) ? "" : ".min") + ".js?v="+o2.version.v;
                o2.load(lp, function(m){
                    if (!m.length){
                        var lp = "../o2_core/o2/lp/" + o2.language + ((o2.session.isDebugger) ? "" : ".min") + ".js?v="+o2.version.v;
                        o2.load(lp,loadModuls);
                    }else{
                        loadModuls();
                    }
                });
            } else {
                loadModuls();
            }

            _loadProgressBar();
            if (config.proxyCenterEnable){
                if (o2.typeOf(config.center)==="array"){
                    config.center.forEach(function(c){
                        c.port = window.location.port || 80;
                    });
                }else{
                    config.port = window.location.port || 80;
                }
            }
            layout.config = config;
            o2.tokenName = config.tokenName || "x-token";

            if( !layout.mobile )document.title = layout.config.systemTitle || layout.config.title;

            configLoaded = true;
            if (configLoaded && commonLoaded && lpLoaded) _getDistribute(function () {
                _load();
            });
        });
    });
}
